/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any }
}

export type Access = {
  __typename?: 'Access'
  articles?: Maybe<ArticlesAccess>
  authors?: Maybe<AuthorsAccess>
  callouts?: Maybe<CalloutsAccess>
  canAccessAdmin: Scalars['Boolean']['output']
  categories?: Maybe<CategoriesAccess>
  comments?: Maybe<CommentsAccess>
  footer?: Maybe<FooterAccess>
  form_submissions?: Maybe<Form_SubmissionsAccess>
  forms?: Maybe<FormsAccess>
  guides?: Maybe<GuidesAccess>
  header?: Maybe<HeaderAccess>
  legal?: Maybe<LegalAccess>
  links?: Maybe<LinksAccess>
  lite_embedded?: Maybe<Lite_EmbeddedAccess>
  marketplace?: Maybe<MarketplaceAccess>
  media?: Maybe<MediaAccess>
  newsroom?: Maybe<NewsroomAccess>
  pages?: Maybe<PagesAccess>
  payload_locked_documents?: Maybe<Payload_Locked_DocumentsAccess>
  payload_preferences?: Maybe<Payload_PreferencesAccess>
  pricing?: Maybe<PricingAccess>
  ratings?: Maybe<RatingsAccess>
  redirects?: Maybe<RedirectsAccess>
  search_results?: Maybe<Search_ResultsAccess>
  settings?: Maybe<SettingsAccess>
  stacker?: Maybe<StackerAccess>
  tc_program_tags?: Maybe<Tc_Program_TagsAccess>
  tc_programs?: Maybe<Tc_ProgramsAccess>
  tc_vendors?: Maybe<Tc_VendorsAccess>
  trade_credit_vendors?: Maybe<Trade_Credit_VendorsAccess>
  users?: Maybe<UsersAccess>
  videos?: Maybe<VideosAccess>
}

export type ArticlesCreateAccess = {
  __typename?: 'ArticlesCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesCreateDocAccess = {
  __typename?: 'ArticlesCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesDeleteAccess = {
  __typename?: 'ArticlesDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesDeleteDocAccess = {
  __typename?: 'ArticlesDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesDocAccessFields = {
  __typename?: 'ArticlesDocAccessFields'
  _status?: Maybe<ArticlesDocAccessFields__Status>
  authors?: Maybe<ArticlesDocAccessFields_Authors>
  categories?: Maybe<ArticlesDocAccessFields_Categories>
  createdAt?: Maybe<ArticlesDocAccessFields_CreatedAt>
  createdBy?: Maybe<ArticlesDocAccessFields_CreatedBy>
  customFooter?: Maybe<ArticlesDocAccessFields_CustomFooter>
  customHeader?: Maybe<ArticlesDocAccessFields_CustomHeader>
  excerpt?: Maybe<ArticlesDocAccessFields_Excerpt>
  image?: Maybe<ArticlesDocAccessFields_Image>
  layout?: Maybe<ArticlesDocAccessFields_Layout>
  meta?: Maybe<ArticlesDocAccessFields_Meta>
  publishedAt?: Maybe<ArticlesDocAccessFields_PublishedAt>
  ratings?: Maybe<ArticlesDocAccessFields_Ratings>
  readTimeEstimate?: Maybe<ArticlesDocAccessFields_ReadTimeEstimate>
  relatedArticles?: Maybe<ArticlesDocAccessFields_RelatedArticles>
  resourceCategory?: Maybe<ArticlesDocAccessFields_ResourceCategory>
  richText?: Maybe<ArticlesDocAccessFields_RichText>
  slug?: Maybe<ArticlesDocAccessFields_Slug>
  summary?: Maybe<ArticlesDocAccessFields_Summary>
  tableOfContents?: Maybe<ArticlesDocAccessFields_TableOfContents>
  title?: Maybe<ArticlesDocAccessFields_Title>
  updatedAt?: Maybe<ArticlesDocAccessFields_UpdatedAt>
  wordCount?: Maybe<ArticlesDocAccessFields_WordCount>
  wordpressPostId?: Maybe<ArticlesDocAccessFields_WordpressPostId>
}

export type ArticlesDocAccessFields__Status = {
  __typename?: 'ArticlesDocAccessFields__status'
  create?: Maybe<ArticlesDocAccessFields__Status_Create>
  delete?: Maybe<ArticlesDocAccessFields__Status_Delete>
  read?: Maybe<ArticlesDocAccessFields__Status_Read>
  update?: Maybe<ArticlesDocAccessFields__Status_Update>
}

export type ArticlesDocAccessFields__Status_Create = {
  __typename?: 'ArticlesDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields__Status_Delete = {
  __typename?: 'ArticlesDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields__Status_Read = {
  __typename?: 'ArticlesDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields__Status_Update = {
  __typename?: 'ArticlesDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Authors = {
  __typename?: 'ArticlesDocAccessFields_authors'
  create?: Maybe<ArticlesDocAccessFields_Authors_Create>
  delete?: Maybe<ArticlesDocAccessFields_Authors_Delete>
  read?: Maybe<ArticlesDocAccessFields_Authors_Read>
  update?: Maybe<ArticlesDocAccessFields_Authors_Update>
}

export type ArticlesDocAccessFields_Authors_Create = {
  __typename?: 'ArticlesDocAccessFields_authors_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Authors_Delete = {
  __typename?: 'ArticlesDocAccessFields_authors_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Authors_Read = {
  __typename?: 'ArticlesDocAccessFields_authors_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Authors_Update = {
  __typename?: 'ArticlesDocAccessFields_authors_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Categories = {
  __typename?: 'ArticlesDocAccessFields_categories'
  create?: Maybe<ArticlesDocAccessFields_Categories_Create>
  delete?: Maybe<ArticlesDocAccessFields_Categories_Delete>
  read?: Maybe<ArticlesDocAccessFields_Categories_Read>
  update?: Maybe<ArticlesDocAccessFields_Categories_Update>
}

export type ArticlesDocAccessFields_Categories_Create = {
  __typename?: 'ArticlesDocAccessFields_categories_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Categories_Delete = {
  __typename?: 'ArticlesDocAccessFields_categories_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Categories_Read = {
  __typename?: 'ArticlesDocAccessFields_categories_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Categories_Update = {
  __typename?: 'ArticlesDocAccessFields_categories_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedAt = {
  __typename?: 'ArticlesDocAccessFields_createdAt'
  create?: Maybe<ArticlesDocAccessFields_CreatedAt_Create>
  delete?: Maybe<ArticlesDocAccessFields_CreatedAt_Delete>
  read?: Maybe<ArticlesDocAccessFields_CreatedAt_Read>
  update?: Maybe<ArticlesDocAccessFields_CreatedAt_Update>
}

export type ArticlesDocAccessFields_CreatedAt_Create = {
  __typename?: 'ArticlesDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'ArticlesDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedAt_Read = {
  __typename?: 'ArticlesDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedAt_Update = {
  __typename?: 'ArticlesDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedBy = {
  __typename?: 'ArticlesDocAccessFields_createdBy'
  create?: Maybe<ArticlesDocAccessFields_CreatedBy_Create>
  delete?: Maybe<ArticlesDocAccessFields_CreatedBy_Delete>
  read?: Maybe<ArticlesDocAccessFields_CreatedBy_Read>
  update?: Maybe<ArticlesDocAccessFields_CreatedBy_Update>
}

export type ArticlesDocAccessFields_CreatedBy_Create = {
  __typename?: 'ArticlesDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedBy_Delete = {
  __typename?: 'ArticlesDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedBy_Read = {
  __typename?: 'ArticlesDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CreatedBy_Update = {
  __typename?: 'ArticlesDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter = {
  __typename?: 'ArticlesDocAccessFields_customFooter'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomFooter_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_Update>
}

export type ArticlesDocAccessFields_CustomFooter_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Fields = {
  __typename?: 'ArticlesDocAccessFields_customFooter_Fields'
  disclaimers?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<ArticlesDocAccessFields_CustomFooter_IsHidden>
}

export type ArticlesDocAccessFields_CustomFooter_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Update>
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_Fields'
  align?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Text>
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_align'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Update>
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_id'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Update>
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_number'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Update>
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_text'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Update>
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_IsHidden = {
  __typename?: 'ArticlesDocAccessFields_customFooter_isHidden'
  create?: Maybe<ArticlesDocAccessFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomFooter_IsHidden_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomFooter_IsHidden_Update>
}

export type ArticlesDocAccessFields_CustomFooter_IsHidden_Create = {
  __typename?: 'ArticlesDocAccessFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'ArticlesDocAccessFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_IsHidden_Read = {
  __typename?: 'ArticlesDocAccessFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomFooter_IsHidden_Update = {
  __typename?: 'ArticlesDocAccessFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader = {
  __typename?: 'ArticlesDocAccessFields_customHeader'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomHeader_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_Update>
}

export type ArticlesDocAccessFields_CustomHeader_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_Fields = {
  __typename?: 'ArticlesDocAccessFields_customHeader_Fields'
  headerDisplay?: Maybe<ArticlesDocAccessFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<ArticlesDocAccessFields_CustomHeader_IsHidden>
  loginLink?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink>
  signupLink?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink>
  supportLink?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink>
}

export type ArticlesDocAccessFields_CustomHeader_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_HeaderDisplay = {
  __typename?: 'ArticlesDocAccessFields_customHeader_headerDisplay'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Update>
}

export type ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_IsHidden = {
  __typename?: 'ArticlesDocAccessFields_customHeader_isHidden'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_IsHidden_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_IsHidden_Update>
}

export type ArticlesDocAccessFields_CustomHeader_IsHidden_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_IsHidden_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_IsHidden_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_Fields'
  newTab?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Type>
  url?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Url>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_newTab'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_Fields'
  id?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_id'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_key'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_value'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reference'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reusable'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_targetId'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Type = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_type'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Url = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_url'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Update>
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_Fields'
  newTab?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Type>
  url?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Url>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_newTab'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_Fields'
  id?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_id'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_key'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_value'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reference'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reusable'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_targetId'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Type = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_type'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Url = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_url'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_Fields'
  newTab?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Type>
  url?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Url>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_newTab'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_Fields'
  id?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_id'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_key'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_value'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reference'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reusable'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_targetId'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Type = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_type'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Url = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_url'
  create?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Update>
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'ArticlesDocAccessFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Excerpt = {
  __typename?: 'ArticlesDocAccessFields_excerpt'
  create?: Maybe<ArticlesDocAccessFields_Excerpt_Create>
  delete?: Maybe<ArticlesDocAccessFields_Excerpt_Delete>
  read?: Maybe<ArticlesDocAccessFields_Excerpt_Read>
  update?: Maybe<ArticlesDocAccessFields_Excerpt_Update>
}

export type ArticlesDocAccessFields_Excerpt_Create = {
  __typename?: 'ArticlesDocAccessFields_excerpt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Excerpt_Delete = {
  __typename?: 'ArticlesDocAccessFields_excerpt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Excerpt_Read = {
  __typename?: 'ArticlesDocAccessFields_excerpt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Excerpt_Update = {
  __typename?: 'ArticlesDocAccessFields_excerpt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Image = {
  __typename?: 'ArticlesDocAccessFields_image'
  create?: Maybe<ArticlesDocAccessFields_Image_Create>
  delete?: Maybe<ArticlesDocAccessFields_Image_Delete>
  read?: Maybe<ArticlesDocAccessFields_Image_Read>
  update?: Maybe<ArticlesDocAccessFields_Image_Update>
}

export type ArticlesDocAccessFields_Image_Create = {
  __typename?: 'ArticlesDocAccessFields_image_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Image_Delete = {
  __typename?: 'ArticlesDocAccessFields_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Image_Read = {
  __typename?: 'ArticlesDocAccessFields_image_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Image_Update = {
  __typename?: 'ArticlesDocAccessFields_image_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Layout = {
  __typename?: 'ArticlesDocAccessFields_layout'
  create?: Maybe<ArticlesDocAccessFields_Layout_Create>
  delete?: Maybe<ArticlesDocAccessFields_Layout_Delete>
  read?: Maybe<ArticlesDocAccessFields_Layout_Read>
  update?: Maybe<ArticlesDocAccessFields_Layout_Update>
}

export type ArticlesDocAccessFields_Layout_Create = {
  __typename?: 'ArticlesDocAccessFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Layout_Delete = {
  __typename?: 'ArticlesDocAccessFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Layout_Read = {
  __typename?: 'ArticlesDocAccessFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Layout_Update = {
  __typename?: 'ArticlesDocAccessFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta = {
  __typename?: 'ArticlesDocAccessFields_meta'
  create?: Maybe<ArticlesDocAccessFields_Meta_Create>
  delete?: Maybe<ArticlesDocAccessFields_Meta_Delete>
  fields?: Maybe<ArticlesDocAccessFields_Meta_Fields>
  read?: Maybe<ArticlesDocAccessFields_Meta_Read>
  update?: Maybe<ArticlesDocAccessFields_Meta_Update>
}

export type ArticlesDocAccessFields_Meta_Create = {
  __typename?: 'ArticlesDocAccessFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Delete = {
  __typename?: 'ArticlesDocAccessFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Fields = {
  __typename?: 'ArticlesDocAccessFields_meta_Fields'
  description?: Maybe<ArticlesDocAccessFields_Meta_Description>
  image?: Maybe<ArticlesDocAccessFields_Meta_Image>
  jsonLD?: Maybe<ArticlesDocAccessFields_Meta_JsonLd>
  noIndex?: Maybe<ArticlesDocAccessFields_Meta_NoIndex>
  title?: Maybe<ArticlesDocAccessFields_Meta_Title>
}

export type ArticlesDocAccessFields_Meta_Read = {
  __typename?: 'ArticlesDocAccessFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Update = {
  __typename?: 'ArticlesDocAccessFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Description = {
  __typename?: 'ArticlesDocAccessFields_meta_description'
  create?: Maybe<ArticlesDocAccessFields_Meta_Description_Create>
  delete?: Maybe<ArticlesDocAccessFields_Meta_Description_Delete>
  read?: Maybe<ArticlesDocAccessFields_Meta_Description_Read>
  update?: Maybe<ArticlesDocAccessFields_Meta_Description_Update>
}

export type ArticlesDocAccessFields_Meta_Description_Create = {
  __typename?: 'ArticlesDocAccessFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Description_Delete = {
  __typename?: 'ArticlesDocAccessFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Description_Read = {
  __typename?: 'ArticlesDocAccessFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Description_Update = {
  __typename?: 'ArticlesDocAccessFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Image = {
  __typename?: 'ArticlesDocAccessFields_meta_image'
  create?: Maybe<ArticlesDocAccessFields_Meta_Image_Create>
  delete?: Maybe<ArticlesDocAccessFields_Meta_Image_Delete>
  read?: Maybe<ArticlesDocAccessFields_Meta_Image_Read>
  update?: Maybe<ArticlesDocAccessFields_Meta_Image_Update>
}

export type ArticlesDocAccessFields_Meta_Image_Create = {
  __typename?: 'ArticlesDocAccessFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Image_Delete = {
  __typename?: 'ArticlesDocAccessFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Image_Read = {
  __typename?: 'ArticlesDocAccessFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Image_Update = {
  __typename?: 'ArticlesDocAccessFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_JsonLd = {
  __typename?: 'ArticlesDocAccessFields_meta_jsonLD'
  create?: Maybe<ArticlesDocAccessFields_Meta_JsonLd_Create>
  delete?: Maybe<ArticlesDocAccessFields_Meta_JsonLd_Delete>
  read?: Maybe<ArticlesDocAccessFields_Meta_JsonLd_Read>
  update?: Maybe<ArticlesDocAccessFields_Meta_JsonLd_Update>
}

export type ArticlesDocAccessFields_Meta_JsonLd_Create = {
  __typename?: 'ArticlesDocAccessFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_JsonLd_Delete = {
  __typename?: 'ArticlesDocAccessFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_JsonLd_Read = {
  __typename?: 'ArticlesDocAccessFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_JsonLd_Update = {
  __typename?: 'ArticlesDocAccessFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_NoIndex = {
  __typename?: 'ArticlesDocAccessFields_meta_noIndex'
  create?: Maybe<ArticlesDocAccessFields_Meta_NoIndex_Create>
  delete?: Maybe<ArticlesDocAccessFields_Meta_NoIndex_Delete>
  read?: Maybe<ArticlesDocAccessFields_Meta_NoIndex_Read>
  update?: Maybe<ArticlesDocAccessFields_Meta_NoIndex_Update>
}

export type ArticlesDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'ArticlesDocAccessFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'ArticlesDocAccessFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'ArticlesDocAccessFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'ArticlesDocAccessFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Title = {
  __typename?: 'ArticlesDocAccessFields_meta_title'
  create?: Maybe<ArticlesDocAccessFields_Meta_Title_Create>
  delete?: Maybe<ArticlesDocAccessFields_Meta_Title_Delete>
  read?: Maybe<ArticlesDocAccessFields_Meta_Title_Read>
  update?: Maybe<ArticlesDocAccessFields_Meta_Title_Update>
}

export type ArticlesDocAccessFields_Meta_Title_Create = {
  __typename?: 'ArticlesDocAccessFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Title_Delete = {
  __typename?: 'ArticlesDocAccessFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Title_Read = {
  __typename?: 'ArticlesDocAccessFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Meta_Title_Update = {
  __typename?: 'ArticlesDocAccessFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_PublishedAt = {
  __typename?: 'ArticlesDocAccessFields_publishedAt'
  create?: Maybe<ArticlesDocAccessFields_PublishedAt_Create>
  delete?: Maybe<ArticlesDocAccessFields_PublishedAt_Delete>
  read?: Maybe<ArticlesDocAccessFields_PublishedAt_Read>
  update?: Maybe<ArticlesDocAccessFields_PublishedAt_Update>
}

export type ArticlesDocAccessFields_PublishedAt_Create = {
  __typename?: 'ArticlesDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_PublishedAt_Delete = {
  __typename?: 'ArticlesDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_PublishedAt_Read = {
  __typename?: 'ArticlesDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_PublishedAt_Update = {
  __typename?: 'ArticlesDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Ratings = {
  __typename?: 'ArticlesDocAccessFields_ratings'
  create?: Maybe<ArticlesDocAccessFields_Ratings_Create>
  delete?: Maybe<ArticlesDocAccessFields_Ratings_Delete>
  read?: Maybe<ArticlesDocAccessFields_Ratings_Read>
  update?: Maybe<ArticlesDocAccessFields_Ratings_Update>
}

export type ArticlesDocAccessFields_Ratings_Create = {
  __typename?: 'ArticlesDocAccessFields_ratings_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Ratings_Delete = {
  __typename?: 'ArticlesDocAccessFields_ratings_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Ratings_Read = {
  __typename?: 'ArticlesDocAccessFields_ratings_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Ratings_Update = {
  __typename?: 'ArticlesDocAccessFields_ratings_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ReadTimeEstimate = {
  __typename?: 'ArticlesDocAccessFields_readTimeEstimate'
  create?: Maybe<ArticlesDocAccessFields_ReadTimeEstimate_Create>
  delete?: Maybe<ArticlesDocAccessFields_ReadTimeEstimate_Delete>
  read?: Maybe<ArticlesDocAccessFields_ReadTimeEstimate_Read>
  update?: Maybe<ArticlesDocAccessFields_ReadTimeEstimate_Update>
}

export type ArticlesDocAccessFields_ReadTimeEstimate_Create = {
  __typename?: 'ArticlesDocAccessFields_readTimeEstimate_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ReadTimeEstimate_Delete = {
  __typename?: 'ArticlesDocAccessFields_readTimeEstimate_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ReadTimeEstimate_Read = {
  __typename?: 'ArticlesDocAccessFields_readTimeEstimate_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ReadTimeEstimate_Update = {
  __typename?: 'ArticlesDocAccessFields_readTimeEstimate_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RelatedArticles = {
  __typename?: 'ArticlesDocAccessFields_relatedArticles'
  create?: Maybe<ArticlesDocAccessFields_RelatedArticles_Create>
  delete?: Maybe<ArticlesDocAccessFields_RelatedArticles_Delete>
  read?: Maybe<ArticlesDocAccessFields_RelatedArticles_Read>
  update?: Maybe<ArticlesDocAccessFields_RelatedArticles_Update>
}

export type ArticlesDocAccessFields_RelatedArticles_Create = {
  __typename?: 'ArticlesDocAccessFields_relatedArticles_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RelatedArticles_Delete = {
  __typename?: 'ArticlesDocAccessFields_relatedArticles_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RelatedArticles_Read = {
  __typename?: 'ArticlesDocAccessFields_relatedArticles_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RelatedArticles_Update = {
  __typename?: 'ArticlesDocAccessFields_relatedArticles_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ResourceCategory = {
  __typename?: 'ArticlesDocAccessFields_resourceCategory'
  create?: Maybe<ArticlesDocAccessFields_ResourceCategory_Create>
  delete?: Maybe<ArticlesDocAccessFields_ResourceCategory_Delete>
  read?: Maybe<ArticlesDocAccessFields_ResourceCategory_Read>
  update?: Maybe<ArticlesDocAccessFields_ResourceCategory_Update>
}

export type ArticlesDocAccessFields_ResourceCategory_Create = {
  __typename?: 'ArticlesDocAccessFields_resourceCategory_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ResourceCategory_Delete = {
  __typename?: 'ArticlesDocAccessFields_resourceCategory_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ResourceCategory_Read = {
  __typename?: 'ArticlesDocAccessFields_resourceCategory_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_ResourceCategory_Update = {
  __typename?: 'ArticlesDocAccessFields_resourceCategory_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RichText = {
  __typename?: 'ArticlesDocAccessFields_richText'
  create?: Maybe<ArticlesDocAccessFields_RichText_Create>
  delete?: Maybe<ArticlesDocAccessFields_RichText_Delete>
  read?: Maybe<ArticlesDocAccessFields_RichText_Read>
  update?: Maybe<ArticlesDocAccessFields_RichText_Update>
}

export type ArticlesDocAccessFields_RichText_Create = {
  __typename?: 'ArticlesDocAccessFields_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RichText_Delete = {
  __typename?: 'ArticlesDocAccessFields_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RichText_Read = {
  __typename?: 'ArticlesDocAccessFields_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_RichText_Update = {
  __typename?: 'ArticlesDocAccessFields_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Slug = {
  __typename?: 'ArticlesDocAccessFields_slug'
  create?: Maybe<ArticlesDocAccessFields_Slug_Create>
  delete?: Maybe<ArticlesDocAccessFields_Slug_Delete>
  read?: Maybe<ArticlesDocAccessFields_Slug_Read>
  update?: Maybe<ArticlesDocAccessFields_Slug_Update>
}

export type ArticlesDocAccessFields_Slug_Create = {
  __typename?: 'ArticlesDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Slug_Delete = {
  __typename?: 'ArticlesDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Slug_Read = {
  __typename?: 'ArticlesDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Slug_Update = {
  __typename?: 'ArticlesDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary = {
  __typename?: 'ArticlesDocAccessFields_summary'
  create?: Maybe<ArticlesDocAccessFields_Summary_Create>
  delete?: Maybe<ArticlesDocAccessFields_Summary_Delete>
  fields?: Maybe<ArticlesDocAccessFields_Summary_Fields>
  read?: Maybe<ArticlesDocAccessFields_Summary_Read>
  update?: Maybe<ArticlesDocAccessFields_Summary_Update>
}

export type ArticlesDocAccessFields_Summary_Create = {
  __typename?: 'ArticlesDocAccessFields_summary_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Delete = {
  __typename?: 'ArticlesDocAccessFields_summary_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Fields = {
  __typename?: 'ArticlesDocAccessFields_summary_Fields'
  id?: Maybe<ArticlesDocAccessFields_Summary_Id>
  text?: Maybe<ArticlesDocAccessFields_Summary_Text>
}

export type ArticlesDocAccessFields_Summary_Read = {
  __typename?: 'ArticlesDocAccessFields_summary_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Update = {
  __typename?: 'ArticlesDocAccessFields_summary_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Id = {
  __typename?: 'ArticlesDocAccessFields_summary_id'
  create?: Maybe<ArticlesDocAccessFields_Summary_Id_Create>
  delete?: Maybe<ArticlesDocAccessFields_Summary_Id_Delete>
  read?: Maybe<ArticlesDocAccessFields_Summary_Id_Read>
  update?: Maybe<ArticlesDocAccessFields_Summary_Id_Update>
}

export type ArticlesDocAccessFields_Summary_Id_Create = {
  __typename?: 'ArticlesDocAccessFields_summary_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Id_Delete = {
  __typename?: 'ArticlesDocAccessFields_summary_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Id_Read = {
  __typename?: 'ArticlesDocAccessFields_summary_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Id_Update = {
  __typename?: 'ArticlesDocAccessFields_summary_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Text = {
  __typename?: 'ArticlesDocAccessFields_summary_text'
  create?: Maybe<ArticlesDocAccessFields_Summary_Text_Create>
  delete?: Maybe<ArticlesDocAccessFields_Summary_Text_Delete>
  read?: Maybe<ArticlesDocAccessFields_Summary_Text_Read>
  update?: Maybe<ArticlesDocAccessFields_Summary_Text_Update>
}

export type ArticlesDocAccessFields_Summary_Text_Create = {
  __typename?: 'ArticlesDocAccessFields_summary_text_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Text_Delete = {
  __typename?: 'ArticlesDocAccessFields_summary_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Text_Read = {
  __typename?: 'ArticlesDocAccessFields_summary_text_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Summary_Text_Update = {
  __typename?: 'ArticlesDocAccessFields_summary_text_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents'
  create?: Maybe<ArticlesDocAccessFields_TableOfContents_Create>
  delete?: Maybe<ArticlesDocAccessFields_TableOfContents_Delete>
  fields?: Maybe<ArticlesDocAccessFields_TableOfContents_Fields>
  read?: Maybe<ArticlesDocAccessFields_TableOfContents_Read>
  update?: Maybe<ArticlesDocAccessFields_TableOfContents_Update>
}

export type ArticlesDocAccessFields_TableOfContents_Create = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Delete = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Fields = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_Fields'
  id?: Maybe<ArticlesDocAccessFields_TableOfContents_Id>
  idAttribute?: Maybe<ArticlesDocAccessFields_TableOfContents_IdAttribute>
  text?: Maybe<ArticlesDocAccessFields_TableOfContents_Text>
}

export type ArticlesDocAccessFields_TableOfContents_Read = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Update = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Id = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_id'
  create?: Maybe<ArticlesDocAccessFields_TableOfContents_Id_Create>
  delete?: Maybe<ArticlesDocAccessFields_TableOfContents_Id_Delete>
  read?: Maybe<ArticlesDocAccessFields_TableOfContents_Id_Read>
  update?: Maybe<ArticlesDocAccessFields_TableOfContents_Id_Update>
}

export type ArticlesDocAccessFields_TableOfContents_IdAttribute = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_idAttribute'
  create?: Maybe<ArticlesDocAccessFields_TableOfContents_IdAttribute_Create>
  delete?: Maybe<ArticlesDocAccessFields_TableOfContents_IdAttribute_Delete>
  read?: Maybe<ArticlesDocAccessFields_TableOfContents_IdAttribute_Read>
  update?: Maybe<ArticlesDocAccessFields_TableOfContents_IdAttribute_Update>
}

export type ArticlesDocAccessFields_TableOfContents_IdAttribute_Create = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_idAttribute_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_IdAttribute_Delete = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_idAttribute_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_IdAttribute_Read = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_idAttribute_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_IdAttribute_Update = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_idAttribute_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Id_Create = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Id_Delete = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Id_Read = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Id_Update = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Text = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_text'
  create?: Maybe<ArticlesDocAccessFields_TableOfContents_Text_Create>
  delete?: Maybe<ArticlesDocAccessFields_TableOfContents_Text_Delete>
  read?: Maybe<ArticlesDocAccessFields_TableOfContents_Text_Read>
  update?: Maybe<ArticlesDocAccessFields_TableOfContents_Text_Update>
}

export type ArticlesDocAccessFields_TableOfContents_Text_Create = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_text_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Text_Delete = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Text_Read = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_text_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_TableOfContents_Text_Update = {
  __typename?: 'ArticlesDocAccessFields_tableOfContents_text_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Title = {
  __typename?: 'ArticlesDocAccessFields_title'
  create?: Maybe<ArticlesDocAccessFields_Title_Create>
  delete?: Maybe<ArticlesDocAccessFields_Title_Delete>
  read?: Maybe<ArticlesDocAccessFields_Title_Read>
  update?: Maybe<ArticlesDocAccessFields_Title_Update>
}

export type ArticlesDocAccessFields_Title_Create = {
  __typename?: 'ArticlesDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Title_Delete = {
  __typename?: 'ArticlesDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Title_Read = {
  __typename?: 'ArticlesDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_Title_Update = {
  __typename?: 'ArticlesDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_UpdatedAt = {
  __typename?: 'ArticlesDocAccessFields_updatedAt'
  create?: Maybe<ArticlesDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<ArticlesDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<ArticlesDocAccessFields_UpdatedAt_Read>
  update?: Maybe<ArticlesDocAccessFields_UpdatedAt_Update>
}

export type ArticlesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'ArticlesDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'ArticlesDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'ArticlesDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'ArticlesDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordCount = {
  __typename?: 'ArticlesDocAccessFields_wordCount'
  create?: Maybe<ArticlesDocAccessFields_WordCount_Create>
  delete?: Maybe<ArticlesDocAccessFields_WordCount_Delete>
  read?: Maybe<ArticlesDocAccessFields_WordCount_Read>
  update?: Maybe<ArticlesDocAccessFields_WordCount_Update>
}

export type ArticlesDocAccessFields_WordCount_Create = {
  __typename?: 'ArticlesDocAccessFields_wordCount_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordCount_Delete = {
  __typename?: 'ArticlesDocAccessFields_wordCount_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordCount_Read = {
  __typename?: 'ArticlesDocAccessFields_wordCount_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordCount_Update = {
  __typename?: 'ArticlesDocAccessFields_wordCount_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordpressPostId = {
  __typename?: 'ArticlesDocAccessFields_wordpressPostId'
  create?: Maybe<ArticlesDocAccessFields_WordpressPostId_Create>
  delete?: Maybe<ArticlesDocAccessFields_WordpressPostId_Delete>
  read?: Maybe<ArticlesDocAccessFields_WordpressPostId_Read>
  update?: Maybe<ArticlesDocAccessFields_WordpressPostId_Update>
}

export type ArticlesDocAccessFields_WordpressPostId_Create = {
  __typename?: 'ArticlesDocAccessFields_wordpressPostId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordpressPostId_Delete = {
  __typename?: 'ArticlesDocAccessFields_wordpressPostId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordpressPostId_Read = {
  __typename?: 'ArticlesDocAccessFields_wordpressPostId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesDocAccessFields_WordpressPostId_Update = {
  __typename?: 'ArticlesDocAccessFields_wordpressPostId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields = {
  __typename?: 'ArticlesFields'
  _status?: Maybe<ArticlesFields__Status>
  authors?: Maybe<ArticlesFields_Authors>
  categories?: Maybe<ArticlesFields_Categories>
  createdAt?: Maybe<ArticlesFields_CreatedAt>
  createdBy?: Maybe<ArticlesFields_CreatedBy>
  customFooter?: Maybe<ArticlesFields_CustomFooter>
  customHeader?: Maybe<ArticlesFields_CustomHeader>
  excerpt?: Maybe<ArticlesFields_Excerpt>
  image?: Maybe<ArticlesFields_Image>
  layout?: Maybe<ArticlesFields_Layout>
  meta?: Maybe<ArticlesFields_Meta>
  publishedAt?: Maybe<ArticlesFields_PublishedAt>
  ratings?: Maybe<ArticlesFields_Ratings>
  readTimeEstimate?: Maybe<ArticlesFields_ReadTimeEstimate>
  relatedArticles?: Maybe<ArticlesFields_RelatedArticles>
  resourceCategory?: Maybe<ArticlesFields_ResourceCategory>
  richText?: Maybe<ArticlesFields_RichText>
  slug?: Maybe<ArticlesFields_Slug>
  summary?: Maybe<ArticlesFields_Summary>
  tableOfContents?: Maybe<ArticlesFields_TableOfContents>
  title?: Maybe<ArticlesFields_Title>
  updatedAt?: Maybe<ArticlesFields_UpdatedAt>
  wordCount?: Maybe<ArticlesFields_WordCount>
  wordpressPostId?: Maybe<ArticlesFields_WordpressPostId>
}

export type ArticlesFields__Status = {
  __typename?: 'ArticlesFields__status'
  create?: Maybe<ArticlesFields__Status_Create>
  delete?: Maybe<ArticlesFields__Status_Delete>
  read?: Maybe<ArticlesFields__Status_Read>
  update?: Maybe<ArticlesFields__Status_Update>
}

export type ArticlesFields__Status_Create = {
  __typename?: 'ArticlesFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields__Status_Delete = {
  __typename?: 'ArticlesFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields__Status_Read = {
  __typename?: 'ArticlesFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields__Status_Update = {
  __typename?: 'ArticlesFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Authors = {
  __typename?: 'ArticlesFields_authors'
  create?: Maybe<ArticlesFields_Authors_Create>
  delete?: Maybe<ArticlesFields_Authors_Delete>
  read?: Maybe<ArticlesFields_Authors_Read>
  update?: Maybe<ArticlesFields_Authors_Update>
}

export type ArticlesFields_Authors_Create = {
  __typename?: 'ArticlesFields_authors_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Authors_Delete = {
  __typename?: 'ArticlesFields_authors_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Authors_Read = {
  __typename?: 'ArticlesFields_authors_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Authors_Update = {
  __typename?: 'ArticlesFields_authors_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Categories = {
  __typename?: 'ArticlesFields_categories'
  create?: Maybe<ArticlesFields_Categories_Create>
  delete?: Maybe<ArticlesFields_Categories_Delete>
  read?: Maybe<ArticlesFields_Categories_Read>
  update?: Maybe<ArticlesFields_Categories_Update>
}

export type ArticlesFields_Categories_Create = {
  __typename?: 'ArticlesFields_categories_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Categories_Delete = {
  __typename?: 'ArticlesFields_categories_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Categories_Read = {
  __typename?: 'ArticlesFields_categories_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Categories_Update = {
  __typename?: 'ArticlesFields_categories_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedAt = {
  __typename?: 'ArticlesFields_createdAt'
  create?: Maybe<ArticlesFields_CreatedAt_Create>
  delete?: Maybe<ArticlesFields_CreatedAt_Delete>
  read?: Maybe<ArticlesFields_CreatedAt_Read>
  update?: Maybe<ArticlesFields_CreatedAt_Update>
}

export type ArticlesFields_CreatedAt_Create = {
  __typename?: 'ArticlesFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedAt_Delete = {
  __typename?: 'ArticlesFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedAt_Read = {
  __typename?: 'ArticlesFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedAt_Update = {
  __typename?: 'ArticlesFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedBy = {
  __typename?: 'ArticlesFields_createdBy'
  create?: Maybe<ArticlesFields_CreatedBy_Create>
  delete?: Maybe<ArticlesFields_CreatedBy_Delete>
  read?: Maybe<ArticlesFields_CreatedBy_Read>
  update?: Maybe<ArticlesFields_CreatedBy_Update>
}

export type ArticlesFields_CreatedBy_Create = {
  __typename?: 'ArticlesFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedBy_Delete = {
  __typename?: 'ArticlesFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedBy_Read = {
  __typename?: 'ArticlesFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CreatedBy_Update = {
  __typename?: 'ArticlesFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter = {
  __typename?: 'ArticlesFields_customFooter'
  create?: Maybe<ArticlesFields_CustomFooter_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_Delete>
  fields?: Maybe<ArticlesFields_CustomFooter_Fields>
  read?: Maybe<ArticlesFields_CustomFooter_Read>
  update?: Maybe<ArticlesFields_CustomFooter_Update>
}

export type ArticlesFields_CustomFooter_Create = {
  __typename?: 'ArticlesFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Delete = {
  __typename?: 'ArticlesFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Fields = {
  __typename?: 'ArticlesFields_customFooter_Fields'
  disclaimers?: Maybe<ArticlesFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<ArticlesFields_CustomFooter_IsHidden>
}

export type ArticlesFields_CustomFooter_Read = {
  __typename?: 'ArticlesFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Update = {
  __typename?: 'ArticlesFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers = {
  __typename?: 'ArticlesFields_customFooter_disclaimers'
  create?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Update>
}

export type ArticlesFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_Fields'
  align?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Text>
}

export type ArticlesFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_align'
  create?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Align_Update>
}

export type ArticlesFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_id'
  create?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Id_Update>
}

export type ArticlesFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_number'
  create?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Number_Update>
}

export type ArticlesFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_text'
  create?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<ArticlesFields_CustomFooter_Disclaimers_Text_Update>
}

export type ArticlesFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'ArticlesFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_IsHidden = {
  __typename?: 'ArticlesFields_customFooter_isHidden'
  create?: Maybe<ArticlesFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<ArticlesFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<ArticlesFields_CustomFooter_IsHidden_Read>
  update?: Maybe<ArticlesFields_CustomFooter_IsHidden_Update>
}

export type ArticlesFields_CustomFooter_IsHidden_Create = {
  __typename?: 'ArticlesFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'ArticlesFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_IsHidden_Read = {
  __typename?: 'ArticlesFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomFooter_IsHidden_Update = {
  __typename?: 'ArticlesFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader = {
  __typename?: 'ArticlesFields_customHeader'
  create?: Maybe<ArticlesFields_CustomHeader_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_Delete>
  fields?: Maybe<ArticlesFields_CustomHeader_Fields>
  read?: Maybe<ArticlesFields_CustomHeader_Read>
  update?: Maybe<ArticlesFields_CustomHeader_Update>
}

export type ArticlesFields_CustomHeader_Create = {
  __typename?: 'ArticlesFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_Delete = {
  __typename?: 'ArticlesFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_Fields = {
  __typename?: 'ArticlesFields_customHeader_Fields'
  headerDisplay?: Maybe<ArticlesFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<ArticlesFields_CustomHeader_IsHidden>
  loginLink?: Maybe<ArticlesFields_CustomHeader_LoginLink>
  signupLink?: Maybe<ArticlesFields_CustomHeader_SignupLink>
  supportLink?: Maybe<ArticlesFields_CustomHeader_SupportLink>
}

export type ArticlesFields_CustomHeader_Read = {
  __typename?: 'ArticlesFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_Update = {
  __typename?: 'ArticlesFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_HeaderDisplay = {
  __typename?: 'ArticlesFields_customHeader_headerDisplay'
  create?: Maybe<ArticlesFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<ArticlesFields_CustomHeader_HeaderDisplay_Update>
}

export type ArticlesFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'ArticlesFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'ArticlesFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'ArticlesFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'ArticlesFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_IsHidden = {
  __typename?: 'ArticlesFields_customHeader_isHidden'
  create?: Maybe<ArticlesFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_IsHidden_Read>
  update?: Maybe<ArticlesFields_CustomHeader_IsHidden_Update>
}

export type ArticlesFields_CustomHeader_IsHidden_Create = {
  __typename?: 'ArticlesFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'ArticlesFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_IsHidden_Read = {
  __typename?: 'ArticlesFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_IsHidden_Update = {
  __typename?: 'ArticlesFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink = {
  __typename?: 'ArticlesFields_customHeader_loginLink'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<ArticlesFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'ArticlesFields_customHeader_loginLink_Fields'
  newTab?: Maybe<ArticlesFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<ArticlesFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<ArticlesFields_CustomHeader_LoginLink_Type>
  url?: Maybe<ArticlesFields_CustomHeader_LoginLink_Url>
}

export type ArticlesFields_CustomHeader_LoginLink_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'ArticlesFields_customHeader_loginLink_newTab'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_NewTab_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_Fields'
  id?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Value>
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_id'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_key'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_value'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reference'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reference_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reusable'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Reusable_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'ArticlesFields_customHeader_loginLink_targetId'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_TargetId_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Type = {
  __typename?: 'ArticlesFields_customHeader_loginLink_type'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Type_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Url = {
  __typename?: 'ArticlesFields_customHeader_loginLink_url'
  create?: Maybe<ArticlesFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<ArticlesFields_CustomHeader_LoginLink_Url_Update>
}

export type ArticlesFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'ArticlesFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'ArticlesFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'ArticlesFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'ArticlesFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink = {
  __typename?: 'ArticlesFields_customHeader_signupLink'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<ArticlesFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'ArticlesFields_customHeader_signupLink_Fields'
  newTab?: Maybe<ArticlesFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<ArticlesFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<ArticlesFields_CustomHeader_SignupLink_Type>
  url?: Maybe<ArticlesFields_CustomHeader_SignupLink_Url>
}

export type ArticlesFields_CustomHeader_SignupLink_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'ArticlesFields_customHeader_signupLink_newTab'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_NewTab_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_Fields'
  id?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Value>
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_id'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_key'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_value'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reference'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reference_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reusable'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Reusable_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'ArticlesFields_customHeader_signupLink_targetId'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_TargetId_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Type = {
  __typename?: 'ArticlesFields_customHeader_signupLink_type'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Type_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Url = {
  __typename?: 'ArticlesFields_customHeader_signupLink_url'
  create?: Maybe<ArticlesFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SignupLink_Url_Update>
}

export type ArticlesFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'ArticlesFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'ArticlesFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'ArticlesFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'ArticlesFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink = {
  __typename?: 'ArticlesFields_customHeader_supportLink'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<ArticlesFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'ArticlesFields_customHeader_supportLink_Fields'
  newTab?: Maybe<ArticlesFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<ArticlesFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<ArticlesFields_CustomHeader_SupportLink_Type>
  url?: Maybe<ArticlesFields_CustomHeader_SupportLink_Url>
}

export type ArticlesFields_CustomHeader_SupportLink_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'ArticlesFields_customHeader_supportLink_newTab'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_NewTab_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_Fields'
  id?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Value>
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_id'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_key'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_value'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reference'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reference_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reusable'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Reusable_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'ArticlesFields_customHeader_supportLink_targetId'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_TargetId_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Type = {
  __typename?: 'ArticlesFields_customHeader_supportLink_type'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Type_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Url = {
  __typename?: 'ArticlesFields_customHeader_supportLink_url'
  create?: Maybe<ArticlesFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<ArticlesFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<ArticlesFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<ArticlesFields_CustomHeader_SupportLink_Url_Update>
}

export type ArticlesFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'ArticlesFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'ArticlesFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'ArticlesFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'ArticlesFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Excerpt = {
  __typename?: 'ArticlesFields_excerpt'
  create?: Maybe<ArticlesFields_Excerpt_Create>
  delete?: Maybe<ArticlesFields_Excerpt_Delete>
  read?: Maybe<ArticlesFields_Excerpt_Read>
  update?: Maybe<ArticlesFields_Excerpt_Update>
}

export type ArticlesFields_Excerpt_Create = {
  __typename?: 'ArticlesFields_excerpt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Excerpt_Delete = {
  __typename?: 'ArticlesFields_excerpt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Excerpt_Read = {
  __typename?: 'ArticlesFields_excerpt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Excerpt_Update = {
  __typename?: 'ArticlesFields_excerpt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Image = {
  __typename?: 'ArticlesFields_image'
  create?: Maybe<ArticlesFields_Image_Create>
  delete?: Maybe<ArticlesFields_Image_Delete>
  read?: Maybe<ArticlesFields_Image_Read>
  update?: Maybe<ArticlesFields_Image_Update>
}

export type ArticlesFields_Image_Create = {
  __typename?: 'ArticlesFields_image_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Image_Delete = {
  __typename?: 'ArticlesFields_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Image_Read = {
  __typename?: 'ArticlesFields_image_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Image_Update = {
  __typename?: 'ArticlesFields_image_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Layout = {
  __typename?: 'ArticlesFields_layout'
  create?: Maybe<ArticlesFields_Layout_Create>
  delete?: Maybe<ArticlesFields_Layout_Delete>
  read?: Maybe<ArticlesFields_Layout_Read>
  update?: Maybe<ArticlesFields_Layout_Update>
}

export type ArticlesFields_Layout_Create = {
  __typename?: 'ArticlesFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Layout_Delete = {
  __typename?: 'ArticlesFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Layout_Read = {
  __typename?: 'ArticlesFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Layout_Update = {
  __typename?: 'ArticlesFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta = {
  __typename?: 'ArticlesFields_meta'
  create?: Maybe<ArticlesFields_Meta_Create>
  delete?: Maybe<ArticlesFields_Meta_Delete>
  fields?: Maybe<ArticlesFields_Meta_Fields>
  read?: Maybe<ArticlesFields_Meta_Read>
  update?: Maybe<ArticlesFields_Meta_Update>
}

export type ArticlesFields_Meta_Create = {
  __typename?: 'ArticlesFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Delete = {
  __typename?: 'ArticlesFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Fields = {
  __typename?: 'ArticlesFields_meta_Fields'
  description?: Maybe<ArticlesFields_Meta_Description>
  image?: Maybe<ArticlesFields_Meta_Image>
  jsonLD?: Maybe<ArticlesFields_Meta_JsonLd>
  noIndex?: Maybe<ArticlesFields_Meta_NoIndex>
  title?: Maybe<ArticlesFields_Meta_Title>
}

export type ArticlesFields_Meta_Read = {
  __typename?: 'ArticlesFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Update = {
  __typename?: 'ArticlesFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Description = {
  __typename?: 'ArticlesFields_meta_description'
  create?: Maybe<ArticlesFields_Meta_Description_Create>
  delete?: Maybe<ArticlesFields_Meta_Description_Delete>
  read?: Maybe<ArticlesFields_Meta_Description_Read>
  update?: Maybe<ArticlesFields_Meta_Description_Update>
}

export type ArticlesFields_Meta_Description_Create = {
  __typename?: 'ArticlesFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Description_Delete = {
  __typename?: 'ArticlesFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Description_Read = {
  __typename?: 'ArticlesFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Description_Update = {
  __typename?: 'ArticlesFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Image = {
  __typename?: 'ArticlesFields_meta_image'
  create?: Maybe<ArticlesFields_Meta_Image_Create>
  delete?: Maybe<ArticlesFields_Meta_Image_Delete>
  read?: Maybe<ArticlesFields_Meta_Image_Read>
  update?: Maybe<ArticlesFields_Meta_Image_Update>
}

export type ArticlesFields_Meta_Image_Create = {
  __typename?: 'ArticlesFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Image_Delete = {
  __typename?: 'ArticlesFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Image_Read = {
  __typename?: 'ArticlesFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Image_Update = {
  __typename?: 'ArticlesFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_JsonLd = {
  __typename?: 'ArticlesFields_meta_jsonLD'
  create?: Maybe<ArticlesFields_Meta_JsonLd_Create>
  delete?: Maybe<ArticlesFields_Meta_JsonLd_Delete>
  read?: Maybe<ArticlesFields_Meta_JsonLd_Read>
  update?: Maybe<ArticlesFields_Meta_JsonLd_Update>
}

export type ArticlesFields_Meta_JsonLd_Create = {
  __typename?: 'ArticlesFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_JsonLd_Delete = {
  __typename?: 'ArticlesFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_JsonLd_Read = {
  __typename?: 'ArticlesFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_JsonLd_Update = {
  __typename?: 'ArticlesFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_NoIndex = {
  __typename?: 'ArticlesFields_meta_noIndex'
  create?: Maybe<ArticlesFields_Meta_NoIndex_Create>
  delete?: Maybe<ArticlesFields_Meta_NoIndex_Delete>
  read?: Maybe<ArticlesFields_Meta_NoIndex_Read>
  update?: Maybe<ArticlesFields_Meta_NoIndex_Update>
}

export type ArticlesFields_Meta_NoIndex_Create = {
  __typename?: 'ArticlesFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_NoIndex_Delete = {
  __typename?: 'ArticlesFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_NoIndex_Read = {
  __typename?: 'ArticlesFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_NoIndex_Update = {
  __typename?: 'ArticlesFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Title = {
  __typename?: 'ArticlesFields_meta_title'
  create?: Maybe<ArticlesFields_Meta_Title_Create>
  delete?: Maybe<ArticlesFields_Meta_Title_Delete>
  read?: Maybe<ArticlesFields_Meta_Title_Read>
  update?: Maybe<ArticlesFields_Meta_Title_Update>
}

export type ArticlesFields_Meta_Title_Create = {
  __typename?: 'ArticlesFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Title_Delete = {
  __typename?: 'ArticlesFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Title_Read = {
  __typename?: 'ArticlesFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Meta_Title_Update = {
  __typename?: 'ArticlesFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_PublishedAt = {
  __typename?: 'ArticlesFields_publishedAt'
  create?: Maybe<ArticlesFields_PublishedAt_Create>
  delete?: Maybe<ArticlesFields_PublishedAt_Delete>
  read?: Maybe<ArticlesFields_PublishedAt_Read>
  update?: Maybe<ArticlesFields_PublishedAt_Update>
}

export type ArticlesFields_PublishedAt_Create = {
  __typename?: 'ArticlesFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_PublishedAt_Delete = {
  __typename?: 'ArticlesFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_PublishedAt_Read = {
  __typename?: 'ArticlesFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_PublishedAt_Update = {
  __typename?: 'ArticlesFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Ratings = {
  __typename?: 'ArticlesFields_ratings'
  create?: Maybe<ArticlesFields_Ratings_Create>
  delete?: Maybe<ArticlesFields_Ratings_Delete>
  read?: Maybe<ArticlesFields_Ratings_Read>
  update?: Maybe<ArticlesFields_Ratings_Update>
}

export type ArticlesFields_Ratings_Create = {
  __typename?: 'ArticlesFields_ratings_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Ratings_Delete = {
  __typename?: 'ArticlesFields_ratings_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Ratings_Read = {
  __typename?: 'ArticlesFields_ratings_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Ratings_Update = {
  __typename?: 'ArticlesFields_ratings_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ReadTimeEstimate = {
  __typename?: 'ArticlesFields_readTimeEstimate'
  create?: Maybe<ArticlesFields_ReadTimeEstimate_Create>
  delete?: Maybe<ArticlesFields_ReadTimeEstimate_Delete>
  read?: Maybe<ArticlesFields_ReadTimeEstimate_Read>
  update?: Maybe<ArticlesFields_ReadTimeEstimate_Update>
}

export type ArticlesFields_ReadTimeEstimate_Create = {
  __typename?: 'ArticlesFields_readTimeEstimate_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ReadTimeEstimate_Delete = {
  __typename?: 'ArticlesFields_readTimeEstimate_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ReadTimeEstimate_Read = {
  __typename?: 'ArticlesFields_readTimeEstimate_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ReadTimeEstimate_Update = {
  __typename?: 'ArticlesFields_readTimeEstimate_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RelatedArticles = {
  __typename?: 'ArticlesFields_relatedArticles'
  create?: Maybe<ArticlesFields_RelatedArticles_Create>
  delete?: Maybe<ArticlesFields_RelatedArticles_Delete>
  read?: Maybe<ArticlesFields_RelatedArticles_Read>
  update?: Maybe<ArticlesFields_RelatedArticles_Update>
}

export type ArticlesFields_RelatedArticles_Create = {
  __typename?: 'ArticlesFields_relatedArticles_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RelatedArticles_Delete = {
  __typename?: 'ArticlesFields_relatedArticles_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RelatedArticles_Read = {
  __typename?: 'ArticlesFields_relatedArticles_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RelatedArticles_Update = {
  __typename?: 'ArticlesFields_relatedArticles_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ResourceCategory = {
  __typename?: 'ArticlesFields_resourceCategory'
  create?: Maybe<ArticlesFields_ResourceCategory_Create>
  delete?: Maybe<ArticlesFields_ResourceCategory_Delete>
  read?: Maybe<ArticlesFields_ResourceCategory_Read>
  update?: Maybe<ArticlesFields_ResourceCategory_Update>
}

export type ArticlesFields_ResourceCategory_Create = {
  __typename?: 'ArticlesFields_resourceCategory_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ResourceCategory_Delete = {
  __typename?: 'ArticlesFields_resourceCategory_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ResourceCategory_Read = {
  __typename?: 'ArticlesFields_resourceCategory_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_ResourceCategory_Update = {
  __typename?: 'ArticlesFields_resourceCategory_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RichText = {
  __typename?: 'ArticlesFields_richText'
  create?: Maybe<ArticlesFields_RichText_Create>
  delete?: Maybe<ArticlesFields_RichText_Delete>
  read?: Maybe<ArticlesFields_RichText_Read>
  update?: Maybe<ArticlesFields_RichText_Update>
}

export type ArticlesFields_RichText_Create = {
  __typename?: 'ArticlesFields_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RichText_Delete = {
  __typename?: 'ArticlesFields_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RichText_Read = {
  __typename?: 'ArticlesFields_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_RichText_Update = {
  __typename?: 'ArticlesFields_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Slug = {
  __typename?: 'ArticlesFields_slug'
  create?: Maybe<ArticlesFields_Slug_Create>
  delete?: Maybe<ArticlesFields_Slug_Delete>
  read?: Maybe<ArticlesFields_Slug_Read>
  update?: Maybe<ArticlesFields_Slug_Update>
}

export type ArticlesFields_Slug_Create = {
  __typename?: 'ArticlesFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Slug_Delete = {
  __typename?: 'ArticlesFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Slug_Read = {
  __typename?: 'ArticlesFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Slug_Update = {
  __typename?: 'ArticlesFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary = {
  __typename?: 'ArticlesFields_summary'
  create?: Maybe<ArticlesFields_Summary_Create>
  delete?: Maybe<ArticlesFields_Summary_Delete>
  fields?: Maybe<ArticlesFields_Summary_Fields>
  read?: Maybe<ArticlesFields_Summary_Read>
  update?: Maybe<ArticlesFields_Summary_Update>
}

export type ArticlesFields_Summary_Create = {
  __typename?: 'ArticlesFields_summary_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Delete = {
  __typename?: 'ArticlesFields_summary_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Fields = {
  __typename?: 'ArticlesFields_summary_Fields'
  id?: Maybe<ArticlesFields_Summary_Id>
  text?: Maybe<ArticlesFields_Summary_Text>
}

export type ArticlesFields_Summary_Read = {
  __typename?: 'ArticlesFields_summary_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Update = {
  __typename?: 'ArticlesFields_summary_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Id = {
  __typename?: 'ArticlesFields_summary_id'
  create?: Maybe<ArticlesFields_Summary_Id_Create>
  delete?: Maybe<ArticlesFields_Summary_Id_Delete>
  read?: Maybe<ArticlesFields_Summary_Id_Read>
  update?: Maybe<ArticlesFields_Summary_Id_Update>
}

export type ArticlesFields_Summary_Id_Create = {
  __typename?: 'ArticlesFields_summary_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Id_Delete = {
  __typename?: 'ArticlesFields_summary_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Id_Read = {
  __typename?: 'ArticlesFields_summary_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Id_Update = {
  __typename?: 'ArticlesFields_summary_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Text = {
  __typename?: 'ArticlesFields_summary_text'
  create?: Maybe<ArticlesFields_Summary_Text_Create>
  delete?: Maybe<ArticlesFields_Summary_Text_Delete>
  read?: Maybe<ArticlesFields_Summary_Text_Read>
  update?: Maybe<ArticlesFields_Summary_Text_Update>
}

export type ArticlesFields_Summary_Text_Create = {
  __typename?: 'ArticlesFields_summary_text_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Text_Delete = {
  __typename?: 'ArticlesFields_summary_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Text_Read = {
  __typename?: 'ArticlesFields_summary_text_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Summary_Text_Update = {
  __typename?: 'ArticlesFields_summary_text_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents = {
  __typename?: 'ArticlesFields_tableOfContents'
  create?: Maybe<ArticlesFields_TableOfContents_Create>
  delete?: Maybe<ArticlesFields_TableOfContents_Delete>
  fields?: Maybe<ArticlesFields_TableOfContents_Fields>
  read?: Maybe<ArticlesFields_TableOfContents_Read>
  update?: Maybe<ArticlesFields_TableOfContents_Update>
}

export type ArticlesFields_TableOfContents_Create = {
  __typename?: 'ArticlesFields_tableOfContents_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Delete = {
  __typename?: 'ArticlesFields_tableOfContents_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Fields = {
  __typename?: 'ArticlesFields_tableOfContents_Fields'
  id?: Maybe<ArticlesFields_TableOfContents_Id>
  idAttribute?: Maybe<ArticlesFields_TableOfContents_IdAttribute>
  text?: Maybe<ArticlesFields_TableOfContents_Text>
}

export type ArticlesFields_TableOfContents_Read = {
  __typename?: 'ArticlesFields_tableOfContents_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Update = {
  __typename?: 'ArticlesFields_tableOfContents_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Id = {
  __typename?: 'ArticlesFields_tableOfContents_id'
  create?: Maybe<ArticlesFields_TableOfContents_Id_Create>
  delete?: Maybe<ArticlesFields_TableOfContents_Id_Delete>
  read?: Maybe<ArticlesFields_TableOfContents_Id_Read>
  update?: Maybe<ArticlesFields_TableOfContents_Id_Update>
}

export type ArticlesFields_TableOfContents_IdAttribute = {
  __typename?: 'ArticlesFields_tableOfContents_idAttribute'
  create?: Maybe<ArticlesFields_TableOfContents_IdAttribute_Create>
  delete?: Maybe<ArticlesFields_TableOfContents_IdAttribute_Delete>
  read?: Maybe<ArticlesFields_TableOfContents_IdAttribute_Read>
  update?: Maybe<ArticlesFields_TableOfContents_IdAttribute_Update>
}

export type ArticlesFields_TableOfContents_IdAttribute_Create = {
  __typename?: 'ArticlesFields_tableOfContents_idAttribute_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_IdAttribute_Delete = {
  __typename?: 'ArticlesFields_tableOfContents_idAttribute_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_IdAttribute_Read = {
  __typename?: 'ArticlesFields_tableOfContents_idAttribute_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_IdAttribute_Update = {
  __typename?: 'ArticlesFields_tableOfContents_idAttribute_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Id_Create = {
  __typename?: 'ArticlesFields_tableOfContents_id_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Id_Delete = {
  __typename?: 'ArticlesFields_tableOfContents_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Id_Read = {
  __typename?: 'ArticlesFields_tableOfContents_id_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Id_Update = {
  __typename?: 'ArticlesFields_tableOfContents_id_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Text = {
  __typename?: 'ArticlesFields_tableOfContents_text'
  create?: Maybe<ArticlesFields_TableOfContents_Text_Create>
  delete?: Maybe<ArticlesFields_TableOfContents_Text_Delete>
  read?: Maybe<ArticlesFields_TableOfContents_Text_Read>
  update?: Maybe<ArticlesFields_TableOfContents_Text_Update>
}

export type ArticlesFields_TableOfContents_Text_Create = {
  __typename?: 'ArticlesFields_tableOfContents_text_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Text_Delete = {
  __typename?: 'ArticlesFields_tableOfContents_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Text_Read = {
  __typename?: 'ArticlesFields_tableOfContents_text_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_TableOfContents_Text_Update = {
  __typename?: 'ArticlesFields_tableOfContents_text_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Title = {
  __typename?: 'ArticlesFields_title'
  create?: Maybe<ArticlesFields_Title_Create>
  delete?: Maybe<ArticlesFields_Title_Delete>
  read?: Maybe<ArticlesFields_Title_Read>
  update?: Maybe<ArticlesFields_Title_Update>
}

export type ArticlesFields_Title_Create = {
  __typename?: 'ArticlesFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Title_Delete = {
  __typename?: 'ArticlesFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Title_Read = {
  __typename?: 'ArticlesFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_Title_Update = {
  __typename?: 'ArticlesFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_UpdatedAt = {
  __typename?: 'ArticlesFields_updatedAt'
  create?: Maybe<ArticlesFields_UpdatedAt_Create>
  delete?: Maybe<ArticlesFields_UpdatedAt_Delete>
  read?: Maybe<ArticlesFields_UpdatedAt_Read>
  update?: Maybe<ArticlesFields_UpdatedAt_Update>
}

export type ArticlesFields_UpdatedAt_Create = {
  __typename?: 'ArticlesFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_UpdatedAt_Delete = {
  __typename?: 'ArticlesFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_UpdatedAt_Read = {
  __typename?: 'ArticlesFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_UpdatedAt_Update = {
  __typename?: 'ArticlesFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordCount = {
  __typename?: 'ArticlesFields_wordCount'
  create?: Maybe<ArticlesFields_WordCount_Create>
  delete?: Maybe<ArticlesFields_WordCount_Delete>
  read?: Maybe<ArticlesFields_WordCount_Read>
  update?: Maybe<ArticlesFields_WordCount_Update>
}

export type ArticlesFields_WordCount_Create = {
  __typename?: 'ArticlesFields_wordCount_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordCount_Delete = {
  __typename?: 'ArticlesFields_wordCount_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordCount_Read = {
  __typename?: 'ArticlesFields_wordCount_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordCount_Update = {
  __typename?: 'ArticlesFields_wordCount_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordpressPostId = {
  __typename?: 'ArticlesFields_wordpressPostId'
  create?: Maybe<ArticlesFields_WordpressPostId_Create>
  delete?: Maybe<ArticlesFields_WordpressPostId_Delete>
  read?: Maybe<ArticlesFields_WordpressPostId_Read>
  update?: Maybe<ArticlesFields_WordpressPostId_Update>
}

export type ArticlesFields_WordpressPostId_Create = {
  __typename?: 'ArticlesFields_wordpressPostId_Create'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordpressPostId_Delete = {
  __typename?: 'ArticlesFields_wordpressPostId_Delete'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordpressPostId_Read = {
  __typename?: 'ArticlesFields_wordpressPostId_Read'
  permission: Scalars['Boolean']['output']
}

export type ArticlesFields_WordpressPostId_Update = {
  __typename?: 'ArticlesFields_wordpressPostId_Update'
  permission: Scalars['Boolean']['output']
}

export type ArticlesReadAccess = {
  __typename?: 'ArticlesReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesReadDocAccess = {
  __typename?: 'ArticlesReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesReadVersionsAccess = {
  __typename?: 'ArticlesReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesReadVersionsDocAccess = {
  __typename?: 'ArticlesReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesUpdateAccess = {
  __typename?: 'ArticlesUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type ArticlesUpdateDocAccess = {
  __typename?: 'ArticlesUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsCreateAccess = {
  __typename?: 'AuthorsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsCreateDocAccess = {
  __typename?: 'AuthorsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsDeleteAccess = {
  __typename?: 'AuthorsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsDeleteDocAccess = {
  __typename?: 'AuthorsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsDocAccessFields = {
  __typename?: 'AuthorsDocAccessFields'
  bio?: Maybe<AuthorsDocAccessFields_Bio>
  createdAt?: Maybe<AuthorsDocAccessFields_CreatedAt>
  createdBy?: Maybe<AuthorsDocAccessFields_CreatedBy>
  description?: Maybe<AuthorsDocAccessFields_Description>
  media?: Maybe<AuthorsDocAccessFields_Media>
  name?: Maybe<AuthorsDocAccessFields_Name>
  shortBio?: Maybe<AuthorsDocAccessFields_ShortBio>
  slug?: Maybe<AuthorsDocAccessFields_Slug>
  socials?: Maybe<AuthorsDocAccessFields_Socials>
  updatedAt?: Maybe<AuthorsDocAccessFields_UpdatedAt>
}

export type AuthorsDocAccessFields_Bio = {
  __typename?: 'AuthorsDocAccessFields_bio'
  create?: Maybe<AuthorsDocAccessFields_Bio_Create>
  delete?: Maybe<AuthorsDocAccessFields_Bio_Delete>
  read?: Maybe<AuthorsDocAccessFields_Bio_Read>
  update?: Maybe<AuthorsDocAccessFields_Bio_Update>
}

export type AuthorsDocAccessFields_Bio_Create = {
  __typename?: 'AuthorsDocAccessFields_bio_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Bio_Delete = {
  __typename?: 'AuthorsDocAccessFields_bio_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Bio_Read = {
  __typename?: 'AuthorsDocAccessFields_bio_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Bio_Update = {
  __typename?: 'AuthorsDocAccessFields_bio_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedAt = {
  __typename?: 'AuthorsDocAccessFields_createdAt'
  create?: Maybe<AuthorsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<AuthorsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<AuthorsDocAccessFields_CreatedAt_Read>
  update?: Maybe<AuthorsDocAccessFields_CreatedAt_Update>
}

export type AuthorsDocAccessFields_CreatedAt_Create = {
  __typename?: 'AuthorsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'AuthorsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedAt_Read = {
  __typename?: 'AuthorsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedAt_Update = {
  __typename?: 'AuthorsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedBy = {
  __typename?: 'AuthorsDocAccessFields_createdBy'
  create?: Maybe<AuthorsDocAccessFields_CreatedBy_Create>
  delete?: Maybe<AuthorsDocAccessFields_CreatedBy_Delete>
  read?: Maybe<AuthorsDocAccessFields_CreatedBy_Read>
  update?: Maybe<AuthorsDocAccessFields_CreatedBy_Update>
}

export type AuthorsDocAccessFields_CreatedBy_Create = {
  __typename?: 'AuthorsDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedBy_Delete = {
  __typename?: 'AuthorsDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedBy_Read = {
  __typename?: 'AuthorsDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_CreatedBy_Update = {
  __typename?: 'AuthorsDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Description = {
  __typename?: 'AuthorsDocAccessFields_description'
  create?: Maybe<AuthorsDocAccessFields_Description_Create>
  delete?: Maybe<AuthorsDocAccessFields_Description_Delete>
  read?: Maybe<AuthorsDocAccessFields_Description_Read>
  update?: Maybe<AuthorsDocAccessFields_Description_Update>
}

export type AuthorsDocAccessFields_Description_Create = {
  __typename?: 'AuthorsDocAccessFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Description_Delete = {
  __typename?: 'AuthorsDocAccessFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Description_Read = {
  __typename?: 'AuthorsDocAccessFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Description_Update = {
  __typename?: 'AuthorsDocAccessFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Media = {
  __typename?: 'AuthorsDocAccessFields_media'
  create?: Maybe<AuthorsDocAccessFields_Media_Create>
  delete?: Maybe<AuthorsDocAccessFields_Media_Delete>
  read?: Maybe<AuthorsDocAccessFields_Media_Read>
  update?: Maybe<AuthorsDocAccessFields_Media_Update>
}

export type AuthorsDocAccessFields_Media_Create = {
  __typename?: 'AuthorsDocAccessFields_media_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Media_Delete = {
  __typename?: 'AuthorsDocAccessFields_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Media_Read = {
  __typename?: 'AuthorsDocAccessFields_media_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Media_Update = {
  __typename?: 'AuthorsDocAccessFields_media_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Name = {
  __typename?: 'AuthorsDocAccessFields_name'
  create?: Maybe<AuthorsDocAccessFields_Name_Create>
  delete?: Maybe<AuthorsDocAccessFields_Name_Delete>
  read?: Maybe<AuthorsDocAccessFields_Name_Read>
  update?: Maybe<AuthorsDocAccessFields_Name_Update>
}

export type AuthorsDocAccessFields_Name_Create = {
  __typename?: 'AuthorsDocAccessFields_name_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Name_Delete = {
  __typename?: 'AuthorsDocAccessFields_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Name_Read = {
  __typename?: 'AuthorsDocAccessFields_name_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Name_Update = {
  __typename?: 'AuthorsDocAccessFields_name_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_ShortBio = {
  __typename?: 'AuthorsDocAccessFields_shortBio'
  create?: Maybe<AuthorsDocAccessFields_ShortBio_Create>
  delete?: Maybe<AuthorsDocAccessFields_ShortBio_Delete>
  read?: Maybe<AuthorsDocAccessFields_ShortBio_Read>
  update?: Maybe<AuthorsDocAccessFields_ShortBio_Update>
}

export type AuthorsDocAccessFields_ShortBio_Create = {
  __typename?: 'AuthorsDocAccessFields_shortBio_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_ShortBio_Delete = {
  __typename?: 'AuthorsDocAccessFields_shortBio_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_ShortBio_Read = {
  __typename?: 'AuthorsDocAccessFields_shortBio_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_ShortBio_Update = {
  __typename?: 'AuthorsDocAccessFields_shortBio_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Slug = {
  __typename?: 'AuthorsDocAccessFields_slug'
  create?: Maybe<AuthorsDocAccessFields_Slug_Create>
  delete?: Maybe<AuthorsDocAccessFields_Slug_Delete>
  read?: Maybe<AuthorsDocAccessFields_Slug_Read>
  update?: Maybe<AuthorsDocAccessFields_Slug_Update>
}

export type AuthorsDocAccessFields_Slug_Create = {
  __typename?: 'AuthorsDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Slug_Delete = {
  __typename?: 'AuthorsDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Slug_Read = {
  __typename?: 'AuthorsDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Slug_Update = {
  __typename?: 'AuthorsDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials = {
  __typename?: 'AuthorsDocAccessFields_socials'
  create?: Maybe<AuthorsDocAccessFields_Socials_Create>
  delete?: Maybe<AuthorsDocAccessFields_Socials_Delete>
  fields?: Maybe<AuthorsDocAccessFields_Socials_Fields>
  read?: Maybe<AuthorsDocAccessFields_Socials_Read>
  update?: Maybe<AuthorsDocAccessFields_Socials_Update>
}

export type AuthorsDocAccessFields_Socials_Create = {
  __typename?: 'AuthorsDocAccessFields_socials_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Delete = {
  __typename?: 'AuthorsDocAccessFields_socials_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Fields = {
  __typename?: 'AuthorsDocAccessFields_socials_Fields'
  facebook?: Maybe<AuthorsDocAccessFields_Socials_Facebook>
  instagram?: Maybe<AuthorsDocAccessFields_Socials_Instagram>
  linkedin?: Maybe<AuthorsDocAccessFields_Socials_Linkedin>
  x?: Maybe<AuthorsDocAccessFields_Socials_X>
}

export type AuthorsDocAccessFields_Socials_Read = {
  __typename?: 'AuthorsDocAccessFields_socials_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Update = {
  __typename?: 'AuthorsDocAccessFields_socials_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Facebook = {
  __typename?: 'AuthorsDocAccessFields_socials_facebook'
  create?: Maybe<AuthorsDocAccessFields_Socials_Facebook_Create>
  delete?: Maybe<AuthorsDocAccessFields_Socials_Facebook_Delete>
  read?: Maybe<AuthorsDocAccessFields_Socials_Facebook_Read>
  update?: Maybe<AuthorsDocAccessFields_Socials_Facebook_Update>
}

export type AuthorsDocAccessFields_Socials_Facebook_Create = {
  __typename?: 'AuthorsDocAccessFields_socials_facebook_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Facebook_Delete = {
  __typename?: 'AuthorsDocAccessFields_socials_facebook_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Facebook_Read = {
  __typename?: 'AuthorsDocAccessFields_socials_facebook_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Facebook_Update = {
  __typename?: 'AuthorsDocAccessFields_socials_facebook_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Instagram = {
  __typename?: 'AuthorsDocAccessFields_socials_instagram'
  create?: Maybe<AuthorsDocAccessFields_Socials_Instagram_Create>
  delete?: Maybe<AuthorsDocAccessFields_Socials_Instagram_Delete>
  read?: Maybe<AuthorsDocAccessFields_Socials_Instagram_Read>
  update?: Maybe<AuthorsDocAccessFields_Socials_Instagram_Update>
}

export type AuthorsDocAccessFields_Socials_Instagram_Create = {
  __typename?: 'AuthorsDocAccessFields_socials_instagram_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Instagram_Delete = {
  __typename?: 'AuthorsDocAccessFields_socials_instagram_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Instagram_Read = {
  __typename?: 'AuthorsDocAccessFields_socials_instagram_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Instagram_Update = {
  __typename?: 'AuthorsDocAccessFields_socials_instagram_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Linkedin = {
  __typename?: 'AuthorsDocAccessFields_socials_linkedin'
  create?: Maybe<AuthorsDocAccessFields_Socials_Linkedin_Create>
  delete?: Maybe<AuthorsDocAccessFields_Socials_Linkedin_Delete>
  read?: Maybe<AuthorsDocAccessFields_Socials_Linkedin_Read>
  update?: Maybe<AuthorsDocAccessFields_Socials_Linkedin_Update>
}

export type AuthorsDocAccessFields_Socials_Linkedin_Create = {
  __typename?: 'AuthorsDocAccessFields_socials_linkedin_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Linkedin_Delete = {
  __typename?: 'AuthorsDocAccessFields_socials_linkedin_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Linkedin_Read = {
  __typename?: 'AuthorsDocAccessFields_socials_linkedin_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_Linkedin_Update = {
  __typename?: 'AuthorsDocAccessFields_socials_linkedin_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_X = {
  __typename?: 'AuthorsDocAccessFields_socials_x'
  create?: Maybe<AuthorsDocAccessFields_Socials_X_Create>
  delete?: Maybe<AuthorsDocAccessFields_Socials_X_Delete>
  read?: Maybe<AuthorsDocAccessFields_Socials_X_Read>
  update?: Maybe<AuthorsDocAccessFields_Socials_X_Update>
}

export type AuthorsDocAccessFields_Socials_X_Create = {
  __typename?: 'AuthorsDocAccessFields_socials_x_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_X_Delete = {
  __typename?: 'AuthorsDocAccessFields_socials_x_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_X_Read = {
  __typename?: 'AuthorsDocAccessFields_socials_x_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_Socials_X_Update = {
  __typename?: 'AuthorsDocAccessFields_socials_x_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_UpdatedAt = {
  __typename?: 'AuthorsDocAccessFields_updatedAt'
  create?: Maybe<AuthorsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<AuthorsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<AuthorsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<AuthorsDocAccessFields_UpdatedAt_Update>
}

export type AuthorsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'AuthorsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'AuthorsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'AuthorsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'AuthorsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields = {
  __typename?: 'AuthorsFields'
  bio?: Maybe<AuthorsFields_Bio>
  createdAt?: Maybe<AuthorsFields_CreatedAt>
  createdBy?: Maybe<AuthorsFields_CreatedBy>
  description?: Maybe<AuthorsFields_Description>
  media?: Maybe<AuthorsFields_Media>
  name?: Maybe<AuthorsFields_Name>
  shortBio?: Maybe<AuthorsFields_ShortBio>
  slug?: Maybe<AuthorsFields_Slug>
  socials?: Maybe<AuthorsFields_Socials>
  updatedAt?: Maybe<AuthorsFields_UpdatedAt>
}

export type AuthorsFields_Bio = {
  __typename?: 'AuthorsFields_bio'
  create?: Maybe<AuthorsFields_Bio_Create>
  delete?: Maybe<AuthorsFields_Bio_Delete>
  read?: Maybe<AuthorsFields_Bio_Read>
  update?: Maybe<AuthorsFields_Bio_Update>
}

export type AuthorsFields_Bio_Create = {
  __typename?: 'AuthorsFields_bio_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Bio_Delete = {
  __typename?: 'AuthorsFields_bio_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Bio_Read = {
  __typename?: 'AuthorsFields_bio_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Bio_Update = {
  __typename?: 'AuthorsFields_bio_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedAt = {
  __typename?: 'AuthorsFields_createdAt'
  create?: Maybe<AuthorsFields_CreatedAt_Create>
  delete?: Maybe<AuthorsFields_CreatedAt_Delete>
  read?: Maybe<AuthorsFields_CreatedAt_Read>
  update?: Maybe<AuthorsFields_CreatedAt_Update>
}

export type AuthorsFields_CreatedAt_Create = {
  __typename?: 'AuthorsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedAt_Delete = {
  __typename?: 'AuthorsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedAt_Read = {
  __typename?: 'AuthorsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedAt_Update = {
  __typename?: 'AuthorsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedBy = {
  __typename?: 'AuthorsFields_createdBy'
  create?: Maybe<AuthorsFields_CreatedBy_Create>
  delete?: Maybe<AuthorsFields_CreatedBy_Delete>
  read?: Maybe<AuthorsFields_CreatedBy_Read>
  update?: Maybe<AuthorsFields_CreatedBy_Update>
}

export type AuthorsFields_CreatedBy_Create = {
  __typename?: 'AuthorsFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedBy_Delete = {
  __typename?: 'AuthorsFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedBy_Read = {
  __typename?: 'AuthorsFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_CreatedBy_Update = {
  __typename?: 'AuthorsFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Description = {
  __typename?: 'AuthorsFields_description'
  create?: Maybe<AuthorsFields_Description_Create>
  delete?: Maybe<AuthorsFields_Description_Delete>
  read?: Maybe<AuthorsFields_Description_Read>
  update?: Maybe<AuthorsFields_Description_Update>
}

export type AuthorsFields_Description_Create = {
  __typename?: 'AuthorsFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Description_Delete = {
  __typename?: 'AuthorsFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Description_Read = {
  __typename?: 'AuthorsFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Description_Update = {
  __typename?: 'AuthorsFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Media = {
  __typename?: 'AuthorsFields_media'
  create?: Maybe<AuthorsFields_Media_Create>
  delete?: Maybe<AuthorsFields_Media_Delete>
  read?: Maybe<AuthorsFields_Media_Read>
  update?: Maybe<AuthorsFields_Media_Update>
}

export type AuthorsFields_Media_Create = {
  __typename?: 'AuthorsFields_media_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Media_Delete = {
  __typename?: 'AuthorsFields_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Media_Read = {
  __typename?: 'AuthorsFields_media_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Media_Update = {
  __typename?: 'AuthorsFields_media_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Name = {
  __typename?: 'AuthorsFields_name'
  create?: Maybe<AuthorsFields_Name_Create>
  delete?: Maybe<AuthorsFields_Name_Delete>
  read?: Maybe<AuthorsFields_Name_Read>
  update?: Maybe<AuthorsFields_Name_Update>
}

export type AuthorsFields_Name_Create = {
  __typename?: 'AuthorsFields_name_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Name_Delete = {
  __typename?: 'AuthorsFields_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Name_Read = {
  __typename?: 'AuthorsFields_name_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Name_Update = {
  __typename?: 'AuthorsFields_name_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_ShortBio = {
  __typename?: 'AuthorsFields_shortBio'
  create?: Maybe<AuthorsFields_ShortBio_Create>
  delete?: Maybe<AuthorsFields_ShortBio_Delete>
  read?: Maybe<AuthorsFields_ShortBio_Read>
  update?: Maybe<AuthorsFields_ShortBio_Update>
}

export type AuthorsFields_ShortBio_Create = {
  __typename?: 'AuthorsFields_shortBio_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_ShortBio_Delete = {
  __typename?: 'AuthorsFields_shortBio_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_ShortBio_Read = {
  __typename?: 'AuthorsFields_shortBio_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_ShortBio_Update = {
  __typename?: 'AuthorsFields_shortBio_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Slug = {
  __typename?: 'AuthorsFields_slug'
  create?: Maybe<AuthorsFields_Slug_Create>
  delete?: Maybe<AuthorsFields_Slug_Delete>
  read?: Maybe<AuthorsFields_Slug_Read>
  update?: Maybe<AuthorsFields_Slug_Update>
}

export type AuthorsFields_Slug_Create = {
  __typename?: 'AuthorsFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Slug_Delete = {
  __typename?: 'AuthorsFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Slug_Read = {
  __typename?: 'AuthorsFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Slug_Update = {
  __typename?: 'AuthorsFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials = {
  __typename?: 'AuthorsFields_socials'
  create?: Maybe<AuthorsFields_Socials_Create>
  delete?: Maybe<AuthorsFields_Socials_Delete>
  fields?: Maybe<AuthorsFields_Socials_Fields>
  read?: Maybe<AuthorsFields_Socials_Read>
  update?: Maybe<AuthorsFields_Socials_Update>
}

export type AuthorsFields_Socials_Create = {
  __typename?: 'AuthorsFields_socials_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Delete = {
  __typename?: 'AuthorsFields_socials_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Fields = {
  __typename?: 'AuthorsFields_socials_Fields'
  facebook?: Maybe<AuthorsFields_Socials_Facebook>
  instagram?: Maybe<AuthorsFields_Socials_Instagram>
  linkedin?: Maybe<AuthorsFields_Socials_Linkedin>
  x?: Maybe<AuthorsFields_Socials_X>
}

export type AuthorsFields_Socials_Read = {
  __typename?: 'AuthorsFields_socials_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Update = {
  __typename?: 'AuthorsFields_socials_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Facebook = {
  __typename?: 'AuthorsFields_socials_facebook'
  create?: Maybe<AuthorsFields_Socials_Facebook_Create>
  delete?: Maybe<AuthorsFields_Socials_Facebook_Delete>
  read?: Maybe<AuthorsFields_Socials_Facebook_Read>
  update?: Maybe<AuthorsFields_Socials_Facebook_Update>
}

export type AuthorsFields_Socials_Facebook_Create = {
  __typename?: 'AuthorsFields_socials_facebook_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Facebook_Delete = {
  __typename?: 'AuthorsFields_socials_facebook_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Facebook_Read = {
  __typename?: 'AuthorsFields_socials_facebook_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Facebook_Update = {
  __typename?: 'AuthorsFields_socials_facebook_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Instagram = {
  __typename?: 'AuthorsFields_socials_instagram'
  create?: Maybe<AuthorsFields_Socials_Instagram_Create>
  delete?: Maybe<AuthorsFields_Socials_Instagram_Delete>
  read?: Maybe<AuthorsFields_Socials_Instagram_Read>
  update?: Maybe<AuthorsFields_Socials_Instagram_Update>
}

export type AuthorsFields_Socials_Instagram_Create = {
  __typename?: 'AuthorsFields_socials_instagram_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Instagram_Delete = {
  __typename?: 'AuthorsFields_socials_instagram_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Instagram_Read = {
  __typename?: 'AuthorsFields_socials_instagram_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Instagram_Update = {
  __typename?: 'AuthorsFields_socials_instagram_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Linkedin = {
  __typename?: 'AuthorsFields_socials_linkedin'
  create?: Maybe<AuthorsFields_Socials_Linkedin_Create>
  delete?: Maybe<AuthorsFields_Socials_Linkedin_Delete>
  read?: Maybe<AuthorsFields_Socials_Linkedin_Read>
  update?: Maybe<AuthorsFields_Socials_Linkedin_Update>
}

export type AuthorsFields_Socials_Linkedin_Create = {
  __typename?: 'AuthorsFields_socials_linkedin_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Linkedin_Delete = {
  __typename?: 'AuthorsFields_socials_linkedin_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Linkedin_Read = {
  __typename?: 'AuthorsFields_socials_linkedin_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_Linkedin_Update = {
  __typename?: 'AuthorsFields_socials_linkedin_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_X = {
  __typename?: 'AuthorsFields_socials_x'
  create?: Maybe<AuthorsFields_Socials_X_Create>
  delete?: Maybe<AuthorsFields_Socials_X_Delete>
  read?: Maybe<AuthorsFields_Socials_X_Read>
  update?: Maybe<AuthorsFields_Socials_X_Update>
}

export type AuthorsFields_Socials_X_Create = {
  __typename?: 'AuthorsFields_socials_x_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_X_Delete = {
  __typename?: 'AuthorsFields_socials_x_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_X_Read = {
  __typename?: 'AuthorsFields_socials_x_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_Socials_X_Update = {
  __typename?: 'AuthorsFields_socials_x_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_UpdatedAt = {
  __typename?: 'AuthorsFields_updatedAt'
  create?: Maybe<AuthorsFields_UpdatedAt_Create>
  delete?: Maybe<AuthorsFields_UpdatedAt_Delete>
  read?: Maybe<AuthorsFields_UpdatedAt_Read>
  update?: Maybe<AuthorsFields_UpdatedAt_Update>
}

export type AuthorsFields_UpdatedAt_Create = {
  __typename?: 'AuthorsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_UpdatedAt_Delete = {
  __typename?: 'AuthorsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_UpdatedAt_Read = {
  __typename?: 'AuthorsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type AuthorsFields_UpdatedAt_Update = {
  __typename?: 'AuthorsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type AuthorsReadAccess = {
  __typename?: 'AuthorsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsReadDocAccess = {
  __typename?: 'AuthorsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsUpdateAccess = {
  __typename?: 'AuthorsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AuthorsUpdateDocAccess = {
  __typename?: 'AuthorsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsCreateAccess = {
  __typename?: 'CalloutsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsCreateDocAccess = {
  __typename?: 'CalloutsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsDeleteAccess = {
  __typename?: 'CalloutsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsDeleteDocAccess = {
  __typename?: 'CalloutsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsDocAccessFields = {
  __typename?: 'CalloutsDocAccessFields'
  callout?: Maybe<CalloutsDocAccessFields_Callout>
  createdAt?: Maybe<CalloutsDocAccessFields_CreatedAt>
  createdBy?: Maybe<CalloutsDocAccessFields_CreatedBy>
  slug?: Maybe<CalloutsDocAccessFields_Slug>
  title?: Maybe<CalloutsDocAccessFields_Title>
  updatedAt?: Maybe<CalloutsDocAccessFields_UpdatedAt>
}

export type CalloutsDocAccessFields_Callout = {
  __typename?: 'CalloutsDocAccessFields_callout'
  create?: Maybe<CalloutsDocAccessFields_Callout_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Delete>
  fields?: Maybe<CalloutsDocAccessFields_Callout_Fields>
  read?: Maybe<CalloutsDocAccessFields_Callout_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Update>
}

export type CalloutsDocAccessFields_Callout_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Fields = {
  __typename?: 'CalloutsDocAccessFields_callout_Fields'
  emphasis?: Maybe<CalloutsDocAccessFields_Callout_Emphasis>
  heading?: Maybe<CalloutsDocAccessFields_Callout_Heading>
  iconName?: Maybe<CalloutsDocAccessFields_Callout_IconName>
  intent?: Maybe<CalloutsDocAccessFields_Callout_Intent>
  links?: Maybe<CalloutsDocAccessFields_Callout_Links>
  richText?: Maybe<CalloutsDocAccessFields_Callout_RichText>
}

export type CalloutsDocAccessFields_Callout_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Emphasis = {
  __typename?: 'CalloutsDocAccessFields_callout_emphasis'
  create?: Maybe<CalloutsDocAccessFields_Callout_Emphasis_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Emphasis_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Emphasis_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Emphasis_Update>
}

export type CalloutsDocAccessFields_Callout_Emphasis_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_emphasis_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Emphasis_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_emphasis_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Emphasis_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_emphasis_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Emphasis_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_emphasis_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Heading = {
  __typename?: 'CalloutsDocAccessFields_callout_heading'
  create?: Maybe<CalloutsDocAccessFields_Callout_Heading_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Heading_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Heading_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Heading_Update>
}

export type CalloutsDocAccessFields_Callout_Heading_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_heading_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Heading_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_heading_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Heading_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_heading_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Heading_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_heading_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_IconName = {
  __typename?: 'CalloutsDocAccessFields_callout_iconName'
  create?: Maybe<CalloutsDocAccessFields_Callout_IconName_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_IconName_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_IconName_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_IconName_Update>
}

export type CalloutsDocAccessFields_Callout_IconName_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_iconName_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_IconName_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_iconName_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_IconName_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_iconName_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_IconName_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_iconName_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Intent = {
  __typename?: 'CalloutsDocAccessFields_callout_intent'
  create?: Maybe<CalloutsDocAccessFields_Callout_Intent_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Intent_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Intent_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Intent_Update>
}

export type CalloutsDocAccessFields_Callout_Intent_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_intent_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Intent_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_intent_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Intent_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_intent_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Intent_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_intent_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links = {
  __typename?: 'CalloutsDocAccessFields_callout_links'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Delete>
  fields?: Maybe<CalloutsDocAccessFields_Callout_Links_Fields>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Fields = {
  __typename?: 'CalloutsDocAccessFields_callout_links_Fields'
  id?: Maybe<CalloutsDocAccessFields_Callout_Links_Id>
  link?: Maybe<CalloutsDocAccessFields_Callout_Links_Link>
}

export type CalloutsDocAccessFields_Callout_Links_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Id = {
  __typename?: 'CalloutsDocAccessFields_callout_links_id'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Id_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Id_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Id_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Id_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Id_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Id_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Id_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Id_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Delete>
  fields?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Fields>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Fields = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_Fields'
  iconAfter?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconAfter>
  iconBefore?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconBefore>
  label?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Label>
  newTab?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_NewTab>
  query?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query>
  reference?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reference>
  reusable?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reusable>
  targetId?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_TargetId>
  type?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Type>
  url?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Url>
  variant?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Variant>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconAfter = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconAfter'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconAfter_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconBefore = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconBefore'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_IconBefore_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Label = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_label'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Label_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Label_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Label_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Label_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Label_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Label_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Label_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Label_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_NewTab = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_newTab'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_NewTab_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_NewTab_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_NewTab_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_NewTab_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_NewTab_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_NewTab_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_NewTab_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_NewTab_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Delete>
  fields?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Fields>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Fields = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_Fields'
  id?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Id>
  key?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Key>
  value?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Value>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Id = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_id'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Id_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Key = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_key'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Key_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Value = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_value'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Query_Value_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reference = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reference'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reference_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reference_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reference_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reference_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reference_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reference_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reference_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reference_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reusable = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reusable'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reusable_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reusable_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reusable_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Reusable_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reusable_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reusable_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reusable_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Reusable_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_TargetId = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_targetId'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_TargetId_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_TargetId_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_TargetId_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_TargetId_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_TargetId_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_TargetId_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_TargetId_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_TargetId_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Type = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_type'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Type_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Type_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Type_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Type_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Type_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Type_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Type_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Type_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Url = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_url'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Url_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Url_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Url_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Url_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Url_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Url_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Url_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Url_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Variant = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_variant'
  create?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Variant_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Variant_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Variant_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_Links_Link_Variant_Update>
}

export type CalloutsDocAccessFields_Callout_Links_Link_Variant_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Variant_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Variant_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_Links_Link_Variant_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_RichText = {
  __typename?: 'CalloutsDocAccessFields_callout_richText'
  create?: Maybe<CalloutsDocAccessFields_Callout_RichText_Create>
  delete?: Maybe<CalloutsDocAccessFields_Callout_RichText_Delete>
  read?: Maybe<CalloutsDocAccessFields_Callout_RichText_Read>
  update?: Maybe<CalloutsDocAccessFields_Callout_RichText_Update>
}

export type CalloutsDocAccessFields_Callout_RichText_Create = {
  __typename?: 'CalloutsDocAccessFields_callout_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_RichText_Delete = {
  __typename?: 'CalloutsDocAccessFields_callout_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_RichText_Read = {
  __typename?: 'CalloutsDocAccessFields_callout_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Callout_RichText_Update = {
  __typename?: 'CalloutsDocAccessFields_callout_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedAt = {
  __typename?: 'CalloutsDocAccessFields_createdAt'
  create?: Maybe<CalloutsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<CalloutsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<CalloutsDocAccessFields_CreatedAt_Read>
  update?: Maybe<CalloutsDocAccessFields_CreatedAt_Update>
}

export type CalloutsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CalloutsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CalloutsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CalloutsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CalloutsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedBy = {
  __typename?: 'CalloutsDocAccessFields_createdBy'
  create?: Maybe<CalloutsDocAccessFields_CreatedBy_Create>
  delete?: Maybe<CalloutsDocAccessFields_CreatedBy_Delete>
  read?: Maybe<CalloutsDocAccessFields_CreatedBy_Read>
  update?: Maybe<CalloutsDocAccessFields_CreatedBy_Update>
}

export type CalloutsDocAccessFields_CreatedBy_Create = {
  __typename?: 'CalloutsDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedBy_Delete = {
  __typename?: 'CalloutsDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedBy_Read = {
  __typename?: 'CalloutsDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_CreatedBy_Update = {
  __typename?: 'CalloutsDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Slug = {
  __typename?: 'CalloutsDocAccessFields_slug'
  create?: Maybe<CalloutsDocAccessFields_Slug_Create>
  delete?: Maybe<CalloutsDocAccessFields_Slug_Delete>
  read?: Maybe<CalloutsDocAccessFields_Slug_Read>
  update?: Maybe<CalloutsDocAccessFields_Slug_Update>
}

export type CalloutsDocAccessFields_Slug_Create = {
  __typename?: 'CalloutsDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Slug_Delete = {
  __typename?: 'CalloutsDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Slug_Read = {
  __typename?: 'CalloutsDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Slug_Update = {
  __typename?: 'CalloutsDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Title = {
  __typename?: 'CalloutsDocAccessFields_title'
  create?: Maybe<CalloutsDocAccessFields_Title_Create>
  delete?: Maybe<CalloutsDocAccessFields_Title_Delete>
  read?: Maybe<CalloutsDocAccessFields_Title_Read>
  update?: Maybe<CalloutsDocAccessFields_Title_Update>
}

export type CalloutsDocAccessFields_Title_Create = {
  __typename?: 'CalloutsDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Title_Delete = {
  __typename?: 'CalloutsDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Title_Read = {
  __typename?: 'CalloutsDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_Title_Update = {
  __typename?: 'CalloutsDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_UpdatedAt = {
  __typename?: 'CalloutsDocAccessFields_updatedAt'
  create?: Maybe<CalloutsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<CalloutsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<CalloutsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<CalloutsDocAccessFields_UpdatedAt_Update>
}

export type CalloutsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CalloutsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CalloutsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CalloutsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CalloutsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields = {
  __typename?: 'CalloutsFields'
  callout?: Maybe<CalloutsFields_Callout>
  createdAt?: Maybe<CalloutsFields_CreatedAt>
  createdBy?: Maybe<CalloutsFields_CreatedBy>
  slug?: Maybe<CalloutsFields_Slug>
  title?: Maybe<CalloutsFields_Title>
  updatedAt?: Maybe<CalloutsFields_UpdatedAt>
}

export type CalloutsFields_Callout = {
  __typename?: 'CalloutsFields_callout'
  create?: Maybe<CalloutsFields_Callout_Create>
  delete?: Maybe<CalloutsFields_Callout_Delete>
  fields?: Maybe<CalloutsFields_Callout_Fields>
  read?: Maybe<CalloutsFields_Callout_Read>
  update?: Maybe<CalloutsFields_Callout_Update>
}

export type CalloutsFields_Callout_Create = {
  __typename?: 'CalloutsFields_callout_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Delete = {
  __typename?: 'CalloutsFields_callout_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Fields = {
  __typename?: 'CalloutsFields_callout_Fields'
  emphasis?: Maybe<CalloutsFields_Callout_Emphasis>
  heading?: Maybe<CalloutsFields_Callout_Heading>
  iconName?: Maybe<CalloutsFields_Callout_IconName>
  intent?: Maybe<CalloutsFields_Callout_Intent>
  links?: Maybe<CalloutsFields_Callout_Links>
  richText?: Maybe<CalloutsFields_Callout_RichText>
}

export type CalloutsFields_Callout_Read = {
  __typename?: 'CalloutsFields_callout_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Update = {
  __typename?: 'CalloutsFields_callout_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Emphasis = {
  __typename?: 'CalloutsFields_callout_emphasis'
  create?: Maybe<CalloutsFields_Callout_Emphasis_Create>
  delete?: Maybe<CalloutsFields_Callout_Emphasis_Delete>
  read?: Maybe<CalloutsFields_Callout_Emphasis_Read>
  update?: Maybe<CalloutsFields_Callout_Emphasis_Update>
}

export type CalloutsFields_Callout_Emphasis_Create = {
  __typename?: 'CalloutsFields_callout_emphasis_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Emphasis_Delete = {
  __typename?: 'CalloutsFields_callout_emphasis_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Emphasis_Read = {
  __typename?: 'CalloutsFields_callout_emphasis_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Emphasis_Update = {
  __typename?: 'CalloutsFields_callout_emphasis_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Heading = {
  __typename?: 'CalloutsFields_callout_heading'
  create?: Maybe<CalloutsFields_Callout_Heading_Create>
  delete?: Maybe<CalloutsFields_Callout_Heading_Delete>
  read?: Maybe<CalloutsFields_Callout_Heading_Read>
  update?: Maybe<CalloutsFields_Callout_Heading_Update>
}

export type CalloutsFields_Callout_Heading_Create = {
  __typename?: 'CalloutsFields_callout_heading_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Heading_Delete = {
  __typename?: 'CalloutsFields_callout_heading_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Heading_Read = {
  __typename?: 'CalloutsFields_callout_heading_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Heading_Update = {
  __typename?: 'CalloutsFields_callout_heading_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_IconName = {
  __typename?: 'CalloutsFields_callout_iconName'
  create?: Maybe<CalloutsFields_Callout_IconName_Create>
  delete?: Maybe<CalloutsFields_Callout_IconName_Delete>
  read?: Maybe<CalloutsFields_Callout_IconName_Read>
  update?: Maybe<CalloutsFields_Callout_IconName_Update>
}

export type CalloutsFields_Callout_IconName_Create = {
  __typename?: 'CalloutsFields_callout_iconName_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_IconName_Delete = {
  __typename?: 'CalloutsFields_callout_iconName_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_IconName_Read = {
  __typename?: 'CalloutsFields_callout_iconName_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_IconName_Update = {
  __typename?: 'CalloutsFields_callout_iconName_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Intent = {
  __typename?: 'CalloutsFields_callout_intent'
  create?: Maybe<CalloutsFields_Callout_Intent_Create>
  delete?: Maybe<CalloutsFields_Callout_Intent_Delete>
  read?: Maybe<CalloutsFields_Callout_Intent_Read>
  update?: Maybe<CalloutsFields_Callout_Intent_Update>
}

export type CalloutsFields_Callout_Intent_Create = {
  __typename?: 'CalloutsFields_callout_intent_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Intent_Delete = {
  __typename?: 'CalloutsFields_callout_intent_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Intent_Read = {
  __typename?: 'CalloutsFields_callout_intent_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Intent_Update = {
  __typename?: 'CalloutsFields_callout_intent_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links = {
  __typename?: 'CalloutsFields_callout_links'
  create?: Maybe<CalloutsFields_Callout_Links_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Delete>
  fields?: Maybe<CalloutsFields_Callout_Links_Fields>
  read?: Maybe<CalloutsFields_Callout_Links_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Update>
}

export type CalloutsFields_Callout_Links_Create = {
  __typename?: 'CalloutsFields_callout_links_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Delete = {
  __typename?: 'CalloutsFields_callout_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Fields = {
  __typename?: 'CalloutsFields_callout_links_Fields'
  id?: Maybe<CalloutsFields_Callout_Links_Id>
  link?: Maybe<CalloutsFields_Callout_Links_Link>
}

export type CalloutsFields_Callout_Links_Read = {
  __typename?: 'CalloutsFields_callout_links_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Update = {
  __typename?: 'CalloutsFields_callout_links_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Id = {
  __typename?: 'CalloutsFields_callout_links_id'
  create?: Maybe<CalloutsFields_Callout_Links_Id_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Id_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Id_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Id_Update>
}

export type CalloutsFields_Callout_Links_Id_Create = {
  __typename?: 'CalloutsFields_callout_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Id_Delete = {
  __typename?: 'CalloutsFields_callout_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Id_Read = {
  __typename?: 'CalloutsFields_callout_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Id_Update = {
  __typename?: 'CalloutsFields_callout_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link = {
  __typename?: 'CalloutsFields_callout_links_link'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Delete>
  fields?: Maybe<CalloutsFields_Callout_Links_Link_Fields>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Update>
}

export type CalloutsFields_Callout_Links_Link_Create = {
  __typename?: 'CalloutsFields_callout_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Fields = {
  __typename?: 'CalloutsFields_callout_links_link_Fields'
  iconAfter?: Maybe<CalloutsFields_Callout_Links_Link_IconAfter>
  iconBefore?: Maybe<CalloutsFields_Callout_Links_Link_IconBefore>
  label?: Maybe<CalloutsFields_Callout_Links_Link_Label>
  newTab?: Maybe<CalloutsFields_Callout_Links_Link_NewTab>
  query?: Maybe<CalloutsFields_Callout_Links_Link_Query>
  reference?: Maybe<CalloutsFields_Callout_Links_Link_Reference>
  reusable?: Maybe<CalloutsFields_Callout_Links_Link_Reusable>
  targetId?: Maybe<CalloutsFields_Callout_Links_Link_TargetId>
  type?: Maybe<CalloutsFields_Callout_Links_Link_Type>
  url?: Maybe<CalloutsFields_Callout_Links_Link_Url>
  variant?: Maybe<CalloutsFields_Callout_Links_Link_Variant>
}

export type CalloutsFields_Callout_Links_Link_Read = {
  __typename?: 'CalloutsFields_callout_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Update = {
  __typename?: 'CalloutsFields_callout_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconAfter = {
  __typename?: 'CalloutsFields_callout_links_link_iconAfter'
  create?: Maybe<CalloutsFields_Callout_Links_Link_IconAfter_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_IconAfter_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_IconAfter_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_IconAfter_Update>
}

export type CalloutsFields_Callout_Links_Link_IconAfter_Create = {
  __typename?: 'CalloutsFields_callout_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconAfter_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconAfter_Read = {
  __typename?: 'CalloutsFields_callout_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconAfter_Update = {
  __typename?: 'CalloutsFields_callout_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconBefore = {
  __typename?: 'CalloutsFields_callout_links_link_iconBefore'
  create?: Maybe<CalloutsFields_Callout_Links_Link_IconBefore_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_IconBefore_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_IconBefore_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_IconBefore_Update>
}

export type CalloutsFields_Callout_Links_Link_IconBefore_Create = {
  __typename?: 'CalloutsFields_callout_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconBefore_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconBefore_Read = {
  __typename?: 'CalloutsFields_callout_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_IconBefore_Update = {
  __typename?: 'CalloutsFields_callout_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Label = {
  __typename?: 'CalloutsFields_callout_links_link_label'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Label_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Label_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Label_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Label_Update>
}

export type CalloutsFields_Callout_Links_Link_Label_Create = {
  __typename?: 'CalloutsFields_callout_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Label_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Label_Read = {
  __typename?: 'CalloutsFields_callout_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Label_Update = {
  __typename?: 'CalloutsFields_callout_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_NewTab = {
  __typename?: 'CalloutsFields_callout_links_link_newTab'
  create?: Maybe<CalloutsFields_Callout_Links_Link_NewTab_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_NewTab_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_NewTab_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_NewTab_Update>
}

export type CalloutsFields_Callout_Links_Link_NewTab_Create = {
  __typename?: 'CalloutsFields_callout_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_NewTab_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_NewTab_Read = {
  __typename?: 'CalloutsFields_callout_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_NewTab_Update = {
  __typename?: 'CalloutsFields_callout_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query = {
  __typename?: 'CalloutsFields_callout_links_link_query'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Query_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Query_Delete>
  fields?: Maybe<CalloutsFields_Callout_Links_Link_Query_Fields>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Query_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Query_Update>
}

export type CalloutsFields_Callout_Links_Link_Query_Create = {
  __typename?: 'CalloutsFields_callout_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Fields = {
  __typename?: 'CalloutsFields_callout_links_link_query_Fields'
  id?: Maybe<CalloutsFields_Callout_Links_Link_Query_Id>
  key?: Maybe<CalloutsFields_Callout_Links_Link_Query_Key>
  value?: Maybe<CalloutsFields_Callout_Links_Link_Query_Value>
}

export type CalloutsFields_Callout_Links_Link_Query_Read = {
  __typename?: 'CalloutsFields_callout_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Update = {
  __typename?: 'CalloutsFields_callout_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Id = {
  __typename?: 'CalloutsFields_callout_links_link_query_id'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Query_Id_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Query_Id_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Query_Id_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Query_Id_Update>
}

export type CalloutsFields_Callout_Links_Link_Query_Id_Create = {
  __typename?: 'CalloutsFields_callout_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Id_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Id_Read = {
  __typename?: 'CalloutsFields_callout_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Id_Update = {
  __typename?: 'CalloutsFields_callout_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Key = {
  __typename?: 'CalloutsFields_callout_links_link_query_key'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Query_Key_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Query_Key_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Query_Key_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Query_Key_Update>
}

export type CalloutsFields_Callout_Links_Link_Query_Key_Create = {
  __typename?: 'CalloutsFields_callout_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Key_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Key_Read = {
  __typename?: 'CalloutsFields_callout_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Key_Update = {
  __typename?: 'CalloutsFields_callout_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Value = {
  __typename?: 'CalloutsFields_callout_links_link_query_value'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Query_Value_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Query_Value_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Query_Value_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Query_Value_Update>
}

export type CalloutsFields_Callout_Links_Link_Query_Value_Create = {
  __typename?: 'CalloutsFields_callout_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Value_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Value_Read = {
  __typename?: 'CalloutsFields_callout_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Query_Value_Update = {
  __typename?: 'CalloutsFields_callout_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reference = {
  __typename?: 'CalloutsFields_callout_links_link_reference'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Reference_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Reference_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Reference_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Reference_Update>
}

export type CalloutsFields_Callout_Links_Link_Reference_Create = {
  __typename?: 'CalloutsFields_callout_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reference_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reference_Read = {
  __typename?: 'CalloutsFields_callout_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reference_Update = {
  __typename?: 'CalloutsFields_callout_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reusable = {
  __typename?: 'CalloutsFields_callout_links_link_reusable'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Reusable_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Reusable_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Reusable_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Reusable_Update>
}

export type CalloutsFields_Callout_Links_Link_Reusable_Create = {
  __typename?: 'CalloutsFields_callout_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reusable_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reusable_Read = {
  __typename?: 'CalloutsFields_callout_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Reusable_Update = {
  __typename?: 'CalloutsFields_callout_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_TargetId = {
  __typename?: 'CalloutsFields_callout_links_link_targetId'
  create?: Maybe<CalloutsFields_Callout_Links_Link_TargetId_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_TargetId_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_TargetId_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_TargetId_Update>
}

export type CalloutsFields_Callout_Links_Link_TargetId_Create = {
  __typename?: 'CalloutsFields_callout_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_TargetId_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_TargetId_Read = {
  __typename?: 'CalloutsFields_callout_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_TargetId_Update = {
  __typename?: 'CalloutsFields_callout_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Type = {
  __typename?: 'CalloutsFields_callout_links_link_type'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Type_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Type_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Type_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Type_Update>
}

export type CalloutsFields_Callout_Links_Link_Type_Create = {
  __typename?: 'CalloutsFields_callout_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Type_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Type_Read = {
  __typename?: 'CalloutsFields_callout_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Type_Update = {
  __typename?: 'CalloutsFields_callout_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Url = {
  __typename?: 'CalloutsFields_callout_links_link_url'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Url_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Url_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Url_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Url_Update>
}

export type CalloutsFields_Callout_Links_Link_Url_Create = {
  __typename?: 'CalloutsFields_callout_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Url_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Url_Read = {
  __typename?: 'CalloutsFields_callout_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Url_Update = {
  __typename?: 'CalloutsFields_callout_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Variant = {
  __typename?: 'CalloutsFields_callout_links_link_variant'
  create?: Maybe<CalloutsFields_Callout_Links_Link_Variant_Create>
  delete?: Maybe<CalloutsFields_Callout_Links_Link_Variant_Delete>
  read?: Maybe<CalloutsFields_Callout_Links_Link_Variant_Read>
  update?: Maybe<CalloutsFields_Callout_Links_Link_Variant_Update>
}

export type CalloutsFields_Callout_Links_Link_Variant_Create = {
  __typename?: 'CalloutsFields_callout_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Variant_Delete = {
  __typename?: 'CalloutsFields_callout_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Variant_Read = {
  __typename?: 'CalloutsFields_callout_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_Links_Link_Variant_Update = {
  __typename?: 'CalloutsFields_callout_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_RichText = {
  __typename?: 'CalloutsFields_callout_richText'
  create?: Maybe<CalloutsFields_Callout_RichText_Create>
  delete?: Maybe<CalloutsFields_Callout_RichText_Delete>
  read?: Maybe<CalloutsFields_Callout_RichText_Read>
  update?: Maybe<CalloutsFields_Callout_RichText_Update>
}

export type CalloutsFields_Callout_RichText_Create = {
  __typename?: 'CalloutsFields_callout_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_RichText_Delete = {
  __typename?: 'CalloutsFields_callout_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_RichText_Read = {
  __typename?: 'CalloutsFields_callout_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Callout_RichText_Update = {
  __typename?: 'CalloutsFields_callout_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedAt = {
  __typename?: 'CalloutsFields_createdAt'
  create?: Maybe<CalloutsFields_CreatedAt_Create>
  delete?: Maybe<CalloutsFields_CreatedAt_Delete>
  read?: Maybe<CalloutsFields_CreatedAt_Read>
  update?: Maybe<CalloutsFields_CreatedAt_Update>
}

export type CalloutsFields_CreatedAt_Create = {
  __typename?: 'CalloutsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedAt_Delete = {
  __typename?: 'CalloutsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedAt_Read = {
  __typename?: 'CalloutsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedAt_Update = {
  __typename?: 'CalloutsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedBy = {
  __typename?: 'CalloutsFields_createdBy'
  create?: Maybe<CalloutsFields_CreatedBy_Create>
  delete?: Maybe<CalloutsFields_CreatedBy_Delete>
  read?: Maybe<CalloutsFields_CreatedBy_Read>
  update?: Maybe<CalloutsFields_CreatedBy_Update>
}

export type CalloutsFields_CreatedBy_Create = {
  __typename?: 'CalloutsFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedBy_Delete = {
  __typename?: 'CalloutsFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedBy_Read = {
  __typename?: 'CalloutsFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_CreatedBy_Update = {
  __typename?: 'CalloutsFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Slug = {
  __typename?: 'CalloutsFields_slug'
  create?: Maybe<CalloutsFields_Slug_Create>
  delete?: Maybe<CalloutsFields_Slug_Delete>
  read?: Maybe<CalloutsFields_Slug_Read>
  update?: Maybe<CalloutsFields_Slug_Update>
}

export type CalloutsFields_Slug_Create = {
  __typename?: 'CalloutsFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Slug_Delete = {
  __typename?: 'CalloutsFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Slug_Read = {
  __typename?: 'CalloutsFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Slug_Update = {
  __typename?: 'CalloutsFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Title = {
  __typename?: 'CalloutsFields_title'
  create?: Maybe<CalloutsFields_Title_Create>
  delete?: Maybe<CalloutsFields_Title_Delete>
  read?: Maybe<CalloutsFields_Title_Read>
  update?: Maybe<CalloutsFields_Title_Update>
}

export type CalloutsFields_Title_Create = {
  __typename?: 'CalloutsFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Title_Delete = {
  __typename?: 'CalloutsFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Title_Read = {
  __typename?: 'CalloutsFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_Title_Update = {
  __typename?: 'CalloutsFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_UpdatedAt = {
  __typename?: 'CalloutsFields_updatedAt'
  create?: Maybe<CalloutsFields_UpdatedAt_Create>
  delete?: Maybe<CalloutsFields_UpdatedAt_Delete>
  read?: Maybe<CalloutsFields_UpdatedAt_Read>
  update?: Maybe<CalloutsFields_UpdatedAt_Update>
}

export type CalloutsFields_UpdatedAt_Create = {
  __typename?: 'CalloutsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_UpdatedAt_Delete = {
  __typename?: 'CalloutsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_UpdatedAt_Read = {
  __typename?: 'CalloutsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CalloutsFields_UpdatedAt_Update = {
  __typename?: 'CalloutsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CalloutsReadAccess = {
  __typename?: 'CalloutsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsReadDocAccess = {
  __typename?: 'CalloutsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsUpdateAccess = {
  __typename?: 'CalloutsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CalloutsUpdateDocAccess = {
  __typename?: 'CalloutsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesCreateAccess = {
  __typename?: 'CategoriesCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesCreateDocAccess = {
  __typename?: 'CategoriesCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesDeleteAccess = {
  __typename?: 'CategoriesDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesDeleteDocAccess = {
  __typename?: 'CategoriesDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesDocAccessFields = {
  __typename?: 'CategoriesDocAccessFields'
  breadcrumbs?: Maybe<CategoriesDocAccessFields_Breadcrumbs>
  createdAt?: Maybe<CategoriesDocAccessFields_CreatedAt>
  createdBy?: Maybe<CategoriesDocAccessFields_CreatedBy>
  isPublic?: Maybe<CategoriesDocAccessFields_IsPublic>
  parent?: Maybe<CategoriesDocAccessFields_Parent>
  slug?: Maybe<CategoriesDocAccessFields_Slug>
  title?: Maybe<CategoriesDocAccessFields_Title>
  updatedAt?: Maybe<CategoriesDocAccessFields_UpdatedAt>
}

export type CategoriesDocAccessFields_Breadcrumbs = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs'
  create?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Create>
  delete?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Delete>
  fields?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Fields>
  read?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Read>
  update?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Update>
}

export type CategoriesDocAccessFields_Breadcrumbs_Create = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Delete = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Fields = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_Fields'
  doc?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Doc>
  id?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Id>
  label?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Label>
  url?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Url>
}

export type CategoriesDocAccessFields_Breadcrumbs_Read = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Update = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Doc = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_doc'
  create?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Doc_Create>
  delete?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Doc_Delete>
  read?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Doc_Read>
  update?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Doc_Update>
}

export type CategoriesDocAccessFields_Breadcrumbs_Doc_Create = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_doc_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_doc_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Doc_Read = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_doc_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Doc_Update = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_doc_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Id = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_id'
  create?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Id_Create>
  delete?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Id_Delete>
  read?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Id_Read>
  update?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Id_Update>
}

export type CategoriesDocAccessFields_Breadcrumbs_Id_Create = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Id_Delete = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Id_Read = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Id_Update = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Label = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_label'
  create?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Label_Create>
  delete?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Label_Delete>
  read?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Label_Read>
  update?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Label_Update>
}

export type CategoriesDocAccessFields_Breadcrumbs_Label_Create = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Label_Delete = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Label_Read = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Label_Update = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Url = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_url'
  create?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Url_Create>
  delete?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Url_Delete>
  read?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Url_Read>
  update?: Maybe<CategoriesDocAccessFields_Breadcrumbs_Url_Update>
}

export type CategoriesDocAccessFields_Breadcrumbs_Url_Create = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Url_Delete = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Url_Read = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Breadcrumbs_Url_Update = {
  __typename?: 'CategoriesDocAccessFields_breadcrumbs_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedAt = {
  __typename?: 'CategoriesDocAccessFields_createdAt'
  create?: Maybe<CategoriesDocAccessFields_CreatedAt_Create>
  delete?: Maybe<CategoriesDocAccessFields_CreatedAt_Delete>
  read?: Maybe<CategoriesDocAccessFields_CreatedAt_Read>
  update?: Maybe<CategoriesDocAccessFields_CreatedAt_Update>
}

export type CategoriesDocAccessFields_CreatedAt_Create = {
  __typename?: 'CategoriesDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CategoriesDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedAt_Read = {
  __typename?: 'CategoriesDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedAt_Update = {
  __typename?: 'CategoriesDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedBy = {
  __typename?: 'CategoriesDocAccessFields_createdBy'
  create?: Maybe<CategoriesDocAccessFields_CreatedBy_Create>
  delete?: Maybe<CategoriesDocAccessFields_CreatedBy_Delete>
  read?: Maybe<CategoriesDocAccessFields_CreatedBy_Read>
  update?: Maybe<CategoriesDocAccessFields_CreatedBy_Update>
}

export type CategoriesDocAccessFields_CreatedBy_Create = {
  __typename?: 'CategoriesDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedBy_Delete = {
  __typename?: 'CategoriesDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedBy_Read = {
  __typename?: 'CategoriesDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_CreatedBy_Update = {
  __typename?: 'CategoriesDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_IsPublic = {
  __typename?: 'CategoriesDocAccessFields_isPublic'
  create?: Maybe<CategoriesDocAccessFields_IsPublic_Create>
  delete?: Maybe<CategoriesDocAccessFields_IsPublic_Delete>
  read?: Maybe<CategoriesDocAccessFields_IsPublic_Read>
  update?: Maybe<CategoriesDocAccessFields_IsPublic_Update>
}

export type CategoriesDocAccessFields_IsPublic_Create = {
  __typename?: 'CategoriesDocAccessFields_isPublic_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_IsPublic_Delete = {
  __typename?: 'CategoriesDocAccessFields_isPublic_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_IsPublic_Read = {
  __typename?: 'CategoriesDocAccessFields_isPublic_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_IsPublic_Update = {
  __typename?: 'CategoriesDocAccessFields_isPublic_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Parent = {
  __typename?: 'CategoriesDocAccessFields_parent'
  create?: Maybe<CategoriesDocAccessFields_Parent_Create>
  delete?: Maybe<CategoriesDocAccessFields_Parent_Delete>
  read?: Maybe<CategoriesDocAccessFields_Parent_Read>
  update?: Maybe<CategoriesDocAccessFields_Parent_Update>
}

export type CategoriesDocAccessFields_Parent_Create = {
  __typename?: 'CategoriesDocAccessFields_parent_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Parent_Delete = {
  __typename?: 'CategoriesDocAccessFields_parent_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Parent_Read = {
  __typename?: 'CategoriesDocAccessFields_parent_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Parent_Update = {
  __typename?: 'CategoriesDocAccessFields_parent_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Slug = {
  __typename?: 'CategoriesDocAccessFields_slug'
  create?: Maybe<CategoriesDocAccessFields_Slug_Create>
  delete?: Maybe<CategoriesDocAccessFields_Slug_Delete>
  read?: Maybe<CategoriesDocAccessFields_Slug_Read>
  update?: Maybe<CategoriesDocAccessFields_Slug_Update>
}

export type CategoriesDocAccessFields_Slug_Create = {
  __typename?: 'CategoriesDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Slug_Delete = {
  __typename?: 'CategoriesDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Slug_Read = {
  __typename?: 'CategoriesDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Slug_Update = {
  __typename?: 'CategoriesDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Title = {
  __typename?: 'CategoriesDocAccessFields_title'
  create?: Maybe<CategoriesDocAccessFields_Title_Create>
  delete?: Maybe<CategoriesDocAccessFields_Title_Delete>
  read?: Maybe<CategoriesDocAccessFields_Title_Read>
  update?: Maybe<CategoriesDocAccessFields_Title_Update>
}

export type CategoriesDocAccessFields_Title_Create = {
  __typename?: 'CategoriesDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Title_Delete = {
  __typename?: 'CategoriesDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Title_Read = {
  __typename?: 'CategoriesDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_Title_Update = {
  __typename?: 'CategoriesDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_UpdatedAt = {
  __typename?: 'CategoriesDocAccessFields_updatedAt'
  create?: Maybe<CategoriesDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<CategoriesDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<CategoriesDocAccessFields_UpdatedAt_Read>
  update?: Maybe<CategoriesDocAccessFields_UpdatedAt_Update>
}

export type CategoriesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CategoriesDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CategoriesDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CategoriesDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CategoriesDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields = {
  __typename?: 'CategoriesFields'
  breadcrumbs?: Maybe<CategoriesFields_Breadcrumbs>
  createdAt?: Maybe<CategoriesFields_CreatedAt>
  createdBy?: Maybe<CategoriesFields_CreatedBy>
  isPublic?: Maybe<CategoriesFields_IsPublic>
  parent?: Maybe<CategoriesFields_Parent>
  slug?: Maybe<CategoriesFields_Slug>
  title?: Maybe<CategoriesFields_Title>
  updatedAt?: Maybe<CategoriesFields_UpdatedAt>
}

export type CategoriesFields_Breadcrumbs = {
  __typename?: 'CategoriesFields_breadcrumbs'
  create?: Maybe<CategoriesFields_Breadcrumbs_Create>
  delete?: Maybe<CategoriesFields_Breadcrumbs_Delete>
  fields?: Maybe<CategoriesFields_Breadcrumbs_Fields>
  read?: Maybe<CategoriesFields_Breadcrumbs_Read>
  update?: Maybe<CategoriesFields_Breadcrumbs_Update>
}

export type CategoriesFields_Breadcrumbs_Create = {
  __typename?: 'CategoriesFields_breadcrumbs_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Delete = {
  __typename?: 'CategoriesFields_breadcrumbs_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Fields = {
  __typename?: 'CategoriesFields_breadcrumbs_Fields'
  doc?: Maybe<CategoriesFields_Breadcrumbs_Doc>
  id?: Maybe<CategoriesFields_Breadcrumbs_Id>
  label?: Maybe<CategoriesFields_Breadcrumbs_Label>
  url?: Maybe<CategoriesFields_Breadcrumbs_Url>
}

export type CategoriesFields_Breadcrumbs_Read = {
  __typename?: 'CategoriesFields_breadcrumbs_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Update = {
  __typename?: 'CategoriesFields_breadcrumbs_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Doc = {
  __typename?: 'CategoriesFields_breadcrumbs_doc'
  create?: Maybe<CategoriesFields_Breadcrumbs_Doc_Create>
  delete?: Maybe<CategoriesFields_Breadcrumbs_Doc_Delete>
  read?: Maybe<CategoriesFields_Breadcrumbs_Doc_Read>
  update?: Maybe<CategoriesFields_Breadcrumbs_Doc_Update>
}

export type CategoriesFields_Breadcrumbs_Doc_Create = {
  __typename?: 'CategoriesFields_breadcrumbs_doc_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'CategoriesFields_breadcrumbs_doc_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Doc_Read = {
  __typename?: 'CategoriesFields_breadcrumbs_doc_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Doc_Update = {
  __typename?: 'CategoriesFields_breadcrumbs_doc_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Id = {
  __typename?: 'CategoriesFields_breadcrumbs_id'
  create?: Maybe<CategoriesFields_Breadcrumbs_Id_Create>
  delete?: Maybe<CategoriesFields_Breadcrumbs_Id_Delete>
  read?: Maybe<CategoriesFields_Breadcrumbs_Id_Read>
  update?: Maybe<CategoriesFields_Breadcrumbs_Id_Update>
}

export type CategoriesFields_Breadcrumbs_Id_Create = {
  __typename?: 'CategoriesFields_breadcrumbs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Id_Delete = {
  __typename?: 'CategoriesFields_breadcrumbs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Id_Read = {
  __typename?: 'CategoriesFields_breadcrumbs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Id_Update = {
  __typename?: 'CategoriesFields_breadcrumbs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Label = {
  __typename?: 'CategoriesFields_breadcrumbs_label'
  create?: Maybe<CategoriesFields_Breadcrumbs_Label_Create>
  delete?: Maybe<CategoriesFields_Breadcrumbs_Label_Delete>
  read?: Maybe<CategoriesFields_Breadcrumbs_Label_Read>
  update?: Maybe<CategoriesFields_Breadcrumbs_Label_Update>
}

export type CategoriesFields_Breadcrumbs_Label_Create = {
  __typename?: 'CategoriesFields_breadcrumbs_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Label_Delete = {
  __typename?: 'CategoriesFields_breadcrumbs_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Label_Read = {
  __typename?: 'CategoriesFields_breadcrumbs_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Label_Update = {
  __typename?: 'CategoriesFields_breadcrumbs_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Url = {
  __typename?: 'CategoriesFields_breadcrumbs_url'
  create?: Maybe<CategoriesFields_Breadcrumbs_Url_Create>
  delete?: Maybe<CategoriesFields_Breadcrumbs_Url_Delete>
  read?: Maybe<CategoriesFields_Breadcrumbs_Url_Read>
  update?: Maybe<CategoriesFields_Breadcrumbs_Url_Update>
}

export type CategoriesFields_Breadcrumbs_Url_Create = {
  __typename?: 'CategoriesFields_breadcrumbs_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Url_Delete = {
  __typename?: 'CategoriesFields_breadcrumbs_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Url_Read = {
  __typename?: 'CategoriesFields_breadcrumbs_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Breadcrumbs_Url_Update = {
  __typename?: 'CategoriesFields_breadcrumbs_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedAt = {
  __typename?: 'CategoriesFields_createdAt'
  create?: Maybe<CategoriesFields_CreatedAt_Create>
  delete?: Maybe<CategoriesFields_CreatedAt_Delete>
  read?: Maybe<CategoriesFields_CreatedAt_Read>
  update?: Maybe<CategoriesFields_CreatedAt_Update>
}

export type CategoriesFields_CreatedAt_Create = {
  __typename?: 'CategoriesFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedAt_Delete = {
  __typename?: 'CategoriesFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedAt_Read = {
  __typename?: 'CategoriesFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedAt_Update = {
  __typename?: 'CategoriesFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedBy = {
  __typename?: 'CategoriesFields_createdBy'
  create?: Maybe<CategoriesFields_CreatedBy_Create>
  delete?: Maybe<CategoriesFields_CreatedBy_Delete>
  read?: Maybe<CategoriesFields_CreatedBy_Read>
  update?: Maybe<CategoriesFields_CreatedBy_Update>
}

export type CategoriesFields_CreatedBy_Create = {
  __typename?: 'CategoriesFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedBy_Delete = {
  __typename?: 'CategoriesFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedBy_Read = {
  __typename?: 'CategoriesFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_CreatedBy_Update = {
  __typename?: 'CategoriesFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_IsPublic = {
  __typename?: 'CategoriesFields_isPublic'
  create?: Maybe<CategoriesFields_IsPublic_Create>
  delete?: Maybe<CategoriesFields_IsPublic_Delete>
  read?: Maybe<CategoriesFields_IsPublic_Read>
  update?: Maybe<CategoriesFields_IsPublic_Update>
}

export type CategoriesFields_IsPublic_Create = {
  __typename?: 'CategoriesFields_isPublic_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_IsPublic_Delete = {
  __typename?: 'CategoriesFields_isPublic_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_IsPublic_Read = {
  __typename?: 'CategoriesFields_isPublic_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_IsPublic_Update = {
  __typename?: 'CategoriesFields_isPublic_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Parent = {
  __typename?: 'CategoriesFields_parent'
  create?: Maybe<CategoriesFields_Parent_Create>
  delete?: Maybe<CategoriesFields_Parent_Delete>
  read?: Maybe<CategoriesFields_Parent_Read>
  update?: Maybe<CategoriesFields_Parent_Update>
}

export type CategoriesFields_Parent_Create = {
  __typename?: 'CategoriesFields_parent_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Parent_Delete = {
  __typename?: 'CategoriesFields_parent_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Parent_Read = {
  __typename?: 'CategoriesFields_parent_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Parent_Update = {
  __typename?: 'CategoriesFields_parent_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Slug = {
  __typename?: 'CategoriesFields_slug'
  create?: Maybe<CategoriesFields_Slug_Create>
  delete?: Maybe<CategoriesFields_Slug_Delete>
  read?: Maybe<CategoriesFields_Slug_Read>
  update?: Maybe<CategoriesFields_Slug_Update>
}

export type CategoriesFields_Slug_Create = {
  __typename?: 'CategoriesFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Slug_Delete = {
  __typename?: 'CategoriesFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Slug_Read = {
  __typename?: 'CategoriesFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Slug_Update = {
  __typename?: 'CategoriesFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Title = {
  __typename?: 'CategoriesFields_title'
  create?: Maybe<CategoriesFields_Title_Create>
  delete?: Maybe<CategoriesFields_Title_Delete>
  read?: Maybe<CategoriesFields_Title_Read>
  update?: Maybe<CategoriesFields_Title_Update>
}

export type CategoriesFields_Title_Create = {
  __typename?: 'CategoriesFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Title_Delete = {
  __typename?: 'CategoriesFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Title_Read = {
  __typename?: 'CategoriesFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_Title_Update = {
  __typename?: 'CategoriesFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_UpdatedAt = {
  __typename?: 'CategoriesFields_updatedAt'
  create?: Maybe<CategoriesFields_UpdatedAt_Create>
  delete?: Maybe<CategoriesFields_UpdatedAt_Delete>
  read?: Maybe<CategoriesFields_UpdatedAt_Read>
  update?: Maybe<CategoriesFields_UpdatedAt_Update>
}

export type CategoriesFields_UpdatedAt_Create = {
  __typename?: 'CategoriesFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_UpdatedAt_Delete = {
  __typename?: 'CategoriesFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_UpdatedAt_Read = {
  __typename?: 'CategoriesFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CategoriesFields_UpdatedAt_Update = {
  __typename?: 'CategoriesFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CategoriesReadAccess = {
  __typename?: 'CategoriesReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesReadDocAccess = {
  __typename?: 'CategoriesReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesUpdateAccess = {
  __typename?: 'CategoriesUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CategoriesUpdateDocAccess = {
  __typename?: 'CategoriesUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsAccordion = {
  __typename?: 'CmsAccordion'
  accordionItems?: Maybe<Array<CmsAccordion_AccordionItems>>
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsAccordion_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
}

export type CmsAccordion_AccordionItems = {
  __typename?: 'CmsAccordion_AccordionItems'
  id?: Maybe<Scalars['String']['output']>
  mainContent?: Maybe<Scalars['JSON']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type CmsAccordion_AccordionItemsMainContentArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsAccordion_Ctas = {
  __typename?: 'CmsAccordion_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsAlertBannerBlock = {
  __typename?: 'CmsAlertBannerBlock'
  alert?: Maybe<CmsAlertBannerBlock_Alert>
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsAlertBannerBlock_Alert = {
  __typename?: 'CmsAlertBannerBlock_Alert'
  intent?: Maybe<CmsAlertBannerBlock_Alert_Intent>
  richText?: Maybe<Scalars['JSON']['output']>
}

export type CmsAlertBannerBlock_AlertRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export const CmsAlertBannerBlock_Alert_Intent = {
  Info: 'info',
  Note: 'note',
  Tip: 'tip',
  Warning: 'warning',
} as const

export type CmsAlertBannerBlock_Alert_Intent =
  (typeof CmsAlertBannerBlock_Alert_Intent)[keyof typeof CmsAlertBannerBlock_Alert_Intent]
export type CmsArchive = {
  __typename?: 'CmsArchive'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  categories?: Maybe<Array<CmsCategories>>
  ctas?: Maybe<Array<CmsArchive_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Float']['output']>
  populateBy?: Maybe<CmsArchive_PopulateBy>
  populatedDocs?: Maybe<Array<CmsArchive_PopulatedDocs_Relationship>>
  populatedDocsTotal?: Maybe<Scalars['Float']['output']>
  relationTo?: Maybe<CmsArchive_RelationTo>
  resourceCategory?: Maybe<CmsArchive_ResourceCategory>
  section?: Maybe<CmsSection>
  selectedDocs?: Maybe<Array<CmsArchive_SelectedDocs_Relationship>>
}

export type CmsArchivePopulatedDocsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArchiveSelectedDocsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArchive_Ctas = {
  __typename?: 'CmsArchive_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsArchive_PopulatedDocs = CmsArticle

export const CmsArchive_PopulatedDocs_RelationTo = {
  Articles: 'articles',
} as const

export type CmsArchive_PopulatedDocs_RelationTo =
  (typeof CmsArchive_PopulatedDocs_RelationTo)[keyof typeof CmsArchive_PopulatedDocs_RelationTo]
export type CmsArchive_PopulatedDocs_Relationship = {
  __typename?: 'CmsArchive_PopulatedDocs_Relationship'
  relationTo?: Maybe<CmsArchive_PopulatedDocs_RelationTo>
  value?: Maybe<CmsArchive_PopulatedDocs>
}

export type CmsArchive_SelectedDocs = CmsArticle

export const CmsArchive_SelectedDocs_RelationTo = {
  Articles: 'articles',
} as const

export type CmsArchive_SelectedDocs_RelationTo =
  (typeof CmsArchive_SelectedDocs_RelationTo)[keyof typeof CmsArchive_SelectedDocs_RelationTo]
export type CmsArchive_SelectedDocs_Relationship = {
  __typename?: 'CmsArchive_SelectedDocs_Relationship'
  relationTo?: Maybe<CmsArchive_SelectedDocs_RelationTo>
  value?: Maybe<CmsArchive_SelectedDocs>
}

export const CmsArchive_PopulateBy = {
  Collection: 'collection',
  Selection: 'selection',
} as const

export type CmsArchive_PopulateBy = (typeof CmsArchive_PopulateBy)[keyof typeof CmsArchive_PopulateBy]
export const CmsArchive_RelationTo = {
  Articles: 'articles',
} as const

export type CmsArchive_RelationTo = (typeof CmsArchive_RelationTo)[keyof typeof CmsArchive_RelationTo]
export const CmsArchive_ResourceCategory = {
  AccountingSoftware: 'accounting_software',
  BusinessChecking: 'business_checking',
  BusinessCreditCard: 'business_credit_card',
  BusinessCreditScores: 'business_credit_scores',
  BusinessFormation: 'business_formation',
  BusinessTaxes: 'business_taxes',
  CreditBuilding: 'credit_building',
  InsuranceResource: 'insurance_resource',
  MerchantServices: 'merchant_services',
  PayrollServices: 'payroll_services',
  Resource: 'resource',
  SmallBusinessLoans: 'small_business_loans',
} as const

export type CmsArchive_ResourceCategory = (typeof CmsArchive_ResourceCategory)[keyof typeof CmsArchive_ResourceCategory]
export type CmsArticle = {
  __typename?: 'CmsArticle'
  _status?: Maybe<CmsArticle__Status>
  authors?: Maybe<Array<CmsAuthor>>
  categories?: Maybe<Array<CmsCategories>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  excerpt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  image?: Maybe<CmsMedia>
  meta?: Maybe<CmsMeta>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  ratings?: Maybe<CmsRating>
  readTimeEstimate?: Maybe<Scalars['Float']['output']>
  relatedArticles?: Maybe<Array<CmsArticle>>
  resourceCategory?: Maybe<CmsArticle_ResourceCategory>
  richText?: Maybe<Scalars['JSON']['output']>
  slug?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Array<CmsArticle_Summary>>
  tableOfContents?: Maybe<Array<CmsArticle_TableOfContents>>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  wordCount?: Maybe<Scalars['Float']['output']>
  wordpressPostId?: Maybe<Scalars['String']['output']>
}

export type CmsArticleRelatedArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticleRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export const CmsArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsArticleUpdate_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsArticleUpdate_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsArticleUpdate_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsArticleUpdate_CustomHeader_HeaderDisplay_MutationInput]
export const CmsArticleUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsArticleUpdate__Status_MutationInput =
  (typeof CmsArticleUpdate__Status_MutationInput)[keyof typeof CmsArticleUpdate__Status_MutationInput]
export const CmsArticleUpdate_ResourceCategory_MutationInput = {
  AccountingSoftware: 'accounting_software',
  BusinessChecking: 'business_checking',
  BusinessCreditCard: 'business_credit_card',
  BusinessCreditScores: 'business_credit_scores',
  BusinessFormation: 'business_formation',
  BusinessTaxes: 'business_taxes',
  CreditBuilding: 'credit_building',
  InsuranceResource: 'insurance_resource',
  MerchantServices: 'merchant_services',
  PayrollServices: 'payroll_services',
  Resource: 'resource',
  SmallBusinessLoans: 'small_business_loans',
} as const

export type CmsArticleUpdate_ResourceCategory_MutationInput =
  (typeof CmsArticleUpdate_ResourceCategory_MutationInput)[keyof typeof CmsArticleUpdate_ResourceCategory_MutationInput]
export type CmsArticleVersion = {
  __typename?: 'CmsArticleVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsArticle>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsArticleVersion_Version>
}

export type CmsArticleVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticleVersion_Version = {
  __typename?: 'CmsArticleVersion_Version'
  _status?: Maybe<CmsArticleVersion_Version__Status>
  authors?: Maybe<Array<CmsAuthor>>
  categories?: Maybe<Array<CmsCategories>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  excerpt?: Maybe<Scalars['String']['output']>
  image?: Maybe<CmsMedia>
  meta?: Maybe<CmsMeta>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  ratings?: Maybe<CmsRating>
  readTimeEstimate?: Maybe<Scalars['Float']['output']>
  relatedArticles?: Maybe<Array<CmsArticle>>
  resourceCategory?: Maybe<CmsArticleVersion_Version_ResourceCategory>
  richText?: Maybe<Scalars['JSON']['output']>
  slug?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Array<CmsArticleVersion_Version_Summary>>
  tableOfContents?: Maybe<Array<CmsArticleVersion_Version_TableOfContents>>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  wordCount?: Maybe<Scalars['Float']['output']>
  wordpressPostId?: Maybe<Scalars['String']['output']>
}

export type CmsArticleVersion_VersionRelatedArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticleVersion_VersionRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsArticleVersion_Version_Summary = {
  __typename?: 'CmsArticleVersion_Version_Summary'
  id?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type CmsArticleVersion_Version_TableOfContents = {
  __typename?: 'CmsArticleVersion_Version_TableOfContents'
  id?: Maybe<Scalars['String']['output']>
  idAttribute?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export const CmsArticleVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsArticleVersion_Version__Status =
  (typeof CmsArticleVersion_Version__Status)[keyof typeof CmsArticleVersion_Version__Status]
export const CmsArticleVersion_Version_ResourceCategory = {
  AccountingSoftware: 'accounting_software',
  BusinessChecking: 'business_checking',
  BusinessCreditCard: 'business_credit_card',
  BusinessCreditScores: 'business_credit_scores',
  BusinessFormation: 'business_formation',
  BusinessTaxes: 'business_taxes',
  CreditBuilding: 'credit_building',
  InsuranceResource: 'insurance_resource',
  MerchantServices: 'merchant_services',
  PayrollServices: 'payroll_services',
  Resource: 'resource',
  SmallBusinessLoans: 'small_business_loans',
} as const

export type CmsArticleVersion_Version_ResourceCategory =
  (typeof CmsArticleVersion_Version_ResourceCategory)[keyof typeof CmsArticleVersion_Version_ResourceCategory]
export const CmsArticle_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsArticle_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsArticle_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsArticle_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsArticle_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsArticle_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsArticle_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsArticle_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsArticle_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsArticle_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsArticle_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsArticle_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsArticle_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsArticle_CustomHeader_HeaderDisplay_MutationInput]
export type CmsArticle_Summary = {
  __typename?: 'CmsArticle_Summary'
  id?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type CmsArticle_TableOfContents = {
  __typename?: 'CmsArticle_TableOfContents'
  id?: Maybe<Scalars['String']['output']>
  idAttribute?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export const CmsArticle__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsArticle__Status = (typeof CmsArticle__Status)[keyof typeof CmsArticle__Status]
export const CmsArticle__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsArticle__Status_Input = (typeof CmsArticle__Status_Input)[keyof typeof CmsArticle__Status_Input]
export const CmsArticle__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsArticle__Status_MutationInput =
  (typeof CmsArticle__Status_MutationInput)[keyof typeof CmsArticle__Status_MutationInput]
export type CmsArticle__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsArticle__Status_Input>>>
  equals?: InputMaybe<CmsArticle__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsArticle__Status_Input>>>
  not_equals?: InputMaybe<CmsArticle__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsArticle__Status_Input>>>
}

export type CmsArticle_Authors_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsArticle_Categories_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsArticle_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsArticle_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const CmsArticle_CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsArticle_CustomFooter__Disclaimers__Align_Input =
  (typeof CmsArticle_CustomFooter__Disclaimers__Align_Input)[keyof typeof CmsArticle_CustomFooter__Disclaimers__Align_Input]
export type CmsArticle_CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Input>>>
}

export type CmsArticle_CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticle_CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsArticle_CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsArticle_CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsArticle_CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsArticle_CustomHeader__HeaderDisplay_Input =
  (typeof CmsArticle_CustomHeader__HeaderDisplay_Input)[keyof typeof CmsArticle_CustomHeader__HeaderDisplay_Input]
export type CmsArticle_CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Input>>>
}

export type CmsArticle_CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticle_CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticle_CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof CmsArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof CmsArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type CmsArticle_CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof CmsArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof CmsArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type CmsArticle_CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsArticle_CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsArticle_CustomHeader__LoginLink__Type_Input =
  (typeof CmsArticle_CustomHeader__LoginLink__Type_Input)[keyof typeof CmsArticle_CustomHeader__LoginLink__Type_Input]
export type CmsArticle_CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Type_Input>
}

export type CmsArticle_CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticle_CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof CmsArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof CmsArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type CmsArticle_CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof CmsArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof CmsArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type CmsArticle_CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsArticle_CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsArticle_CustomHeader__SignupLink__Type_Input =
  (typeof CmsArticle_CustomHeader__SignupLink__Type_Input)[keyof typeof CmsArticle_CustomHeader__SignupLink__Type_Input]
export type CmsArticle_CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Type_Input>
}

export type CmsArticle_CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticle_CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof CmsArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof CmsArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type CmsArticle_CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof CmsArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof CmsArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type CmsArticle_CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsArticle_CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsArticle_CustomHeader__SupportLink__Type_Input =
  (typeof CmsArticle_CustomHeader__SupportLink__Type_Input)[keyof typeof CmsArticle_CustomHeader__SupportLink__Type_Input]
export type CmsArticle_CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Type_Input>
}

export type CmsArticle_CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsArticle_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsArticle_Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsArticle_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsArticle_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsArticle_Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsArticle_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsArticle_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsArticle_Ratings_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsArticle_ReadTimeEstimate_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsArticle_RelatedArticles_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const CmsArticle_ResourceCategory = {
  AccountingSoftware: 'accounting_software',
  BusinessChecking: 'business_checking',
  BusinessCreditCard: 'business_credit_card',
  BusinessCreditScores: 'business_credit_scores',
  BusinessFormation: 'business_formation',
  BusinessTaxes: 'business_taxes',
  CreditBuilding: 'credit_building',
  InsuranceResource: 'insurance_resource',
  MerchantServices: 'merchant_services',
  PayrollServices: 'payroll_services',
  Resource: 'resource',
  SmallBusinessLoans: 'small_business_loans',
} as const

export type CmsArticle_ResourceCategory = (typeof CmsArticle_ResourceCategory)[keyof typeof CmsArticle_ResourceCategory]
export const CmsArticle_ResourceCategory_Input = {
  AccountingSoftware: 'accounting_software',
  BusinessChecking: 'business_checking',
  BusinessCreditCard: 'business_credit_card',
  BusinessCreditScores: 'business_credit_scores',
  BusinessFormation: 'business_formation',
  BusinessTaxes: 'business_taxes',
  CreditBuilding: 'credit_building',
  InsuranceResource: 'insurance_resource',
  MerchantServices: 'merchant_services',
  PayrollServices: 'payroll_services',
  Resource: 'resource',
  SmallBusinessLoans: 'small_business_loans',
} as const

export type CmsArticle_ResourceCategory_Input =
  (typeof CmsArticle_ResourceCategory_Input)[keyof typeof CmsArticle_ResourceCategory_Input]
export const CmsArticle_ResourceCategory_MutationInput = {
  AccountingSoftware: 'accounting_software',
  BusinessChecking: 'business_checking',
  BusinessCreditCard: 'business_credit_card',
  BusinessCreditScores: 'business_credit_scores',
  BusinessFormation: 'business_formation',
  BusinessTaxes: 'business_taxes',
  CreditBuilding: 'credit_building',
  InsuranceResource: 'insurance_resource',
  MerchantServices: 'merchant_services',
  PayrollServices: 'payroll_services',
  Resource: 'resource',
  SmallBusinessLoans: 'small_business_loans',
} as const

export type CmsArticle_ResourceCategory_MutationInput =
  (typeof CmsArticle_ResourceCategory_MutationInput)[keyof typeof CmsArticle_ResourceCategory_MutationInput]
export type CmsArticle_ResourceCategory_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsArticle_ResourceCategory_Input>>>
  equals?: InputMaybe<CmsArticle_ResourceCategory_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsArticle_ResourceCategory_Input>>>
  not_equals?: InputMaybe<CmsArticle_ResourceCategory_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsArticle_ResourceCategory_Input>>>
}

export type CmsArticle_RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsArticle_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_Summary__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_Summary__Text_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsArticle_TableOfContents__IdAttribute_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_TableOfContents__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_TableOfContents__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticle_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsArticle_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsArticle_Where_Or>>>
  _status?: InputMaybe<CmsArticle__Status_Operator>
  authors?: InputMaybe<CmsArticle_Authors_Operator>
  categories?: InputMaybe<CmsArticle_Categories_Operator>
  createdAt?: InputMaybe<CmsArticle_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsArticle_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsArticle_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsArticle_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsArticle_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsArticle_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsArticle_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsArticle_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsArticle_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsArticle_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Url_Operator>
  excerpt?: InputMaybe<CmsArticle_Excerpt_Operator>
  id?: InputMaybe<CmsArticle_Id_Operator>
  image?: InputMaybe<CmsArticle_Image_Operator>
  meta__description?: InputMaybe<CmsArticle_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsArticle_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsArticle_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsArticle_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsArticle_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsArticle_PublishedAt_Operator>
  ratings?: InputMaybe<CmsArticle_Ratings_Operator>
  readTimeEstimate?: InputMaybe<CmsArticle_ReadTimeEstimate_Operator>
  relatedArticles?: InputMaybe<CmsArticle_RelatedArticles_Operator>
  resourceCategory?: InputMaybe<CmsArticle_ResourceCategory_Operator>
  richText?: InputMaybe<CmsArticle_RichText_Operator>
  slug?: InputMaybe<CmsArticle_Slug_Operator>
  summary__id?: InputMaybe<CmsArticle_Summary__Id_Operator>
  summary__text?: InputMaybe<CmsArticle_Summary__Text_Operator>
  tableOfContents__id?: InputMaybe<CmsArticle_TableOfContents__Id_Operator>
  tableOfContents__idAttribute?: InputMaybe<CmsArticle_TableOfContents__IdAttribute_Operator>
  tableOfContents__text?: InputMaybe<CmsArticle_TableOfContents__Text_Operator>
  title?: InputMaybe<CmsArticle_Title_Operator>
  updatedAt?: InputMaybe<CmsArticle_UpdatedAt_Operator>
  wordCount?: InputMaybe<CmsArticle_WordCount_Operator>
  wordpressPostId?: InputMaybe<CmsArticle_WordpressPostId_Operator>
}

export type CmsArticle_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsArticle_Where_Or>>>
  _status?: InputMaybe<CmsArticle__Status_Operator>
  authors?: InputMaybe<CmsArticle_Authors_Operator>
  categories?: InputMaybe<CmsArticle_Categories_Operator>
  createdAt?: InputMaybe<CmsArticle_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsArticle_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsArticle_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsArticle_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsArticle_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsArticle_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsArticle_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsArticle_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsArticle_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsArticle_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Url_Operator>
  excerpt?: InputMaybe<CmsArticle_Excerpt_Operator>
  id?: InputMaybe<CmsArticle_Id_Operator>
  image?: InputMaybe<CmsArticle_Image_Operator>
  meta__description?: InputMaybe<CmsArticle_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsArticle_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsArticle_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsArticle_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsArticle_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsArticle_PublishedAt_Operator>
  ratings?: InputMaybe<CmsArticle_Ratings_Operator>
  readTimeEstimate?: InputMaybe<CmsArticle_ReadTimeEstimate_Operator>
  relatedArticles?: InputMaybe<CmsArticle_RelatedArticles_Operator>
  resourceCategory?: InputMaybe<CmsArticle_ResourceCategory_Operator>
  richText?: InputMaybe<CmsArticle_RichText_Operator>
  slug?: InputMaybe<CmsArticle_Slug_Operator>
  summary__id?: InputMaybe<CmsArticle_Summary__Id_Operator>
  summary__text?: InputMaybe<CmsArticle_Summary__Text_Operator>
  tableOfContents__id?: InputMaybe<CmsArticle_TableOfContents__Id_Operator>
  tableOfContents__idAttribute?: InputMaybe<CmsArticle_TableOfContents__IdAttribute_Operator>
  tableOfContents__text?: InputMaybe<CmsArticle_TableOfContents__Text_Operator>
  title?: InputMaybe<CmsArticle_Title_Operator>
  updatedAt?: InputMaybe<CmsArticle_UpdatedAt_Operator>
  wordCount?: InputMaybe<CmsArticle_WordCount_Operator>
  wordpressPostId?: InputMaybe<CmsArticle_WordpressPostId_Operator>
}

export type CmsArticle_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsArticle_Where_Or>>>
  _status?: InputMaybe<CmsArticle__Status_Operator>
  authors?: InputMaybe<CmsArticle_Authors_Operator>
  categories?: InputMaybe<CmsArticle_Categories_Operator>
  createdAt?: InputMaybe<CmsArticle_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsArticle_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsArticle_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsArticle_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsArticle_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsArticle_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsArticle_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsArticle_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsArticle_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsArticle_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsArticle_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsArticle_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsArticle_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsArticle_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsArticle_CustomHeader__SupportLink__Url_Operator>
  excerpt?: InputMaybe<CmsArticle_Excerpt_Operator>
  id?: InputMaybe<CmsArticle_Id_Operator>
  image?: InputMaybe<CmsArticle_Image_Operator>
  meta__description?: InputMaybe<CmsArticle_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsArticle_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsArticle_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsArticle_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsArticle_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsArticle_PublishedAt_Operator>
  ratings?: InputMaybe<CmsArticle_Ratings_Operator>
  readTimeEstimate?: InputMaybe<CmsArticle_ReadTimeEstimate_Operator>
  relatedArticles?: InputMaybe<CmsArticle_RelatedArticles_Operator>
  resourceCategory?: InputMaybe<CmsArticle_ResourceCategory_Operator>
  richText?: InputMaybe<CmsArticle_RichText_Operator>
  slug?: InputMaybe<CmsArticle_Slug_Operator>
  summary__id?: InputMaybe<CmsArticle_Summary__Id_Operator>
  summary__text?: InputMaybe<CmsArticle_Summary__Text_Operator>
  tableOfContents__id?: InputMaybe<CmsArticle_TableOfContents__Id_Operator>
  tableOfContents__idAttribute?: InputMaybe<CmsArticle_TableOfContents__IdAttribute_Operator>
  tableOfContents__text?: InputMaybe<CmsArticle_TableOfContents__Text_Operator>
  title?: InputMaybe<CmsArticle_Title_Operator>
  updatedAt?: InputMaybe<CmsArticle_UpdatedAt_Operator>
  wordCount?: InputMaybe<CmsArticle_WordCount_Operator>
  wordpressPostId?: InputMaybe<CmsArticle_WordpressPostId_Operator>
}

export type CmsArticle_WordCount_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsArticle_WordpressPostId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsArticles = {
  __typename?: 'CmsArticles'
  docs?: Maybe<Array<Maybe<CmsArticle>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsAuthor = {
  __typename?: 'CmsAuthor'
  bio?: Maybe<Scalars['JSON']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  media?: Maybe<CmsMedia>
  name: Scalars['String']['output']
  shortBio: Scalars['String']['output']
  slug?: Maybe<Scalars['String']['output']>
  socials?: Maybe<CmsAuthor_Socials>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsAuthorBioArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsAuthor_Socials = {
  __typename?: 'CmsAuthor_Socials'
  facebook?: Maybe<Scalars['String']['output']>
  instagram?: Maybe<Scalars['String']['output']>
  linkedin?: Maybe<Scalars['String']['output']>
  x?: Maybe<Scalars['String']['output']>
}

export type CmsAuthor_Bio_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsAuthor_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsAuthor_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsAuthor_Description_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsAuthor_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsAuthor_Media_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsAuthor_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsAuthor_ShortBio_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsAuthor_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsAuthor_Socials__Facebook_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsAuthor_Socials__Instagram_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsAuthor_Socials__Linkedin_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsAuthor_Socials__X_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsAuthor_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsAuthor_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsAuthor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsAuthor_Where_Or>>>
  bio?: InputMaybe<CmsAuthor_Bio_Operator>
  createdAt?: InputMaybe<CmsAuthor_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsAuthor_CreatedBy_Operator>
  description?: InputMaybe<CmsAuthor_Description_Operator>
  id?: InputMaybe<CmsAuthor_Id_Operator>
  media?: InputMaybe<CmsAuthor_Media_Operator>
  name?: InputMaybe<CmsAuthor_Name_Operator>
  shortBio?: InputMaybe<CmsAuthor_ShortBio_Operator>
  slug?: InputMaybe<CmsAuthor_Slug_Operator>
  socials__facebook?: InputMaybe<CmsAuthor_Socials__Facebook_Operator>
  socials__instagram?: InputMaybe<CmsAuthor_Socials__Instagram_Operator>
  socials__linkedin?: InputMaybe<CmsAuthor_Socials__Linkedin_Operator>
  socials__x?: InputMaybe<CmsAuthor_Socials__X_Operator>
  updatedAt?: InputMaybe<CmsAuthor_UpdatedAt_Operator>
}

export type CmsAuthor_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsAuthor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsAuthor_Where_Or>>>
  bio?: InputMaybe<CmsAuthor_Bio_Operator>
  createdAt?: InputMaybe<CmsAuthor_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsAuthor_CreatedBy_Operator>
  description?: InputMaybe<CmsAuthor_Description_Operator>
  id?: InputMaybe<CmsAuthor_Id_Operator>
  media?: InputMaybe<CmsAuthor_Media_Operator>
  name?: InputMaybe<CmsAuthor_Name_Operator>
  shortBio?: InputMaybe<CmsAuthor_ShortBio_Operator>
  slug?: InputMaybe<CmsAuthor_Slug_Operator>
  socials__facebook?: InputMaybe<CmsAuthor_Socials__Facebook_Operator>
  socials__instagram?: InputMaybe<CmsAuthor_Socials__Instagram_Operator>
  socials__linkedin?: InputMaybe<CmsAuthor_Socials__Linkedin_Operator>
  socials__x?: InputMaybe<CmsAuthor_Socials__X_Operator>
  updatedAt?: InputMaybe<CmsAuthor_UpdatedAt_Operator>
}

export type CmsAuthor_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsAuthor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsAuthor_Where_Or>>>
  bio?: InputMaybe<CmsAuthor_Bio_Operator>
  createdAt?: InputMaybe<CmsAuthor_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsAuthor_CreatedBy_Operator>
  description?: InputMaybe<CmsAuthor_Description_Operator>
  id?: InputMaybe<CmsAuthor_Id_Operator>
  media?: InputMaybe<CmsAuthor_Media_Operator>
  name?: InputMaybe<CmsAuthor_Name_Operator>
  shortBio?: InputMaybe<CmsAuthor_ShortBio_Operator>
  slug?: InputMaybe<CmsAuthor_Slug_Operator>
  socials__facebook?: InputMaybe<CmsAuthor_Socials__Facebook_Operator>
  socials__instagram?: InputMaybe<CmsAuthor_Socials__Instagram_Operator>
  socials__linkedin?: InputMaybe<CmsAuthor_Socials__Linkedin_Operator>
  socials__x?: InputMaybe<CmsAuthor_Socials__X_Operator>
  updatedAt?: InputMaybe<CmsAuthor_UpdatedAt_Operator>
}

export type CmsAuthors = {
  __typename?: 'CmsAuthors'
  docs?: Maybe<Array<Maybe<CmsAuthor>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsBento = {
  __typename?: 'CmsBento'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsBento_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  rows?: Maybe<Array<CmsBento_Rows>>
  section?: Maybe<CmsSection>
}

export type CmsBento_Ctas = {
  __typename?: 'CmsBento_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsBento_Rows = {
  __typename?: 'CmsBento_Rows'
  cols?: Maybe<Array<CmsBento_Rows_Cols>>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsBento_Rows_Cols = {
  __typename?: 'CmsBento_Rows_Cols'
  bgMedia?: Maybe<CmsMedia>
  id?: Maybe<Scalars['String']['output']>
  overlay?: Maybe<Array<CmsBento_Rows_Cols_Overlay>>
  richText?: Maybe<Scalars['JSON']['output']>
  size?: Maybe<CmsBento_Rows_Cols_Size>
}

export type CmsBento_Rows_ColsRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsBento_Rows_Cols_Overlay = {
  __typename?: 'CmsBento_Rows_Cols_Overlay'
  id?: Maybe<Scalars['String']['output']>
  media?: Maybe<CmsMedia>
  size?: Maybe<CmsBento_Rows_Cols_Overlay_Size>
}

export const CmsBento_Rows_Cols_Overlay_Size = {
  Large: 'large',
  Medium: 'medium',
  Small: 'small',
} as const

export type CmsBento_Rows_Cols_Overlay_Size =
  (typeof CmsBento_Rows_Cols_Overlay_Size)[keyof typeof CmsBento_Rows_Cols_Overlay_Size]
export const CmsBento_Rows_Cols_Size = {
  Full: 'full',
  Half: 'half',
  OneThird: 'oneThird',
  TwoThirds: 'twoThirds',
} as const

export type CmsBento_Rows_Cols_Size = (typeof CmsBento_Rows_Cols_Size)[keyof typeof CmsBento_Rows_Cols_Size]
export type CmsCta = {
  __typename?: 'CmsCTA'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctaBannerType?: Maybe<CmsCta_CtaBannerType>
  headline?: Maybe<Scalars['JSON']['output']>
  id?: Maybe<Scalars['String']['output']>
  links?: Maybe<Array<CmsCta_Links>>
  media?: Maybe<CmsMedia>
  productImage?: Maybe<CmsMedia>
  reviewRating?: Maybe<Scalars['Float']['output']>
  reviewText?: Maybe<Scalars['String']['output']>
  showReviews?: Maybe<Scalars['Boolean']['output']>
}

export type CmsCtaHeadlineArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsCta_Links = {
  __typename?: 'CmsCTA_Links'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export const CmsCta_CtaBannerType = {
  Default: 'default',
  Product: 'product',
} as const

export type CmsCta_CtaBannerType = (typeof CmsCta_CtaBannerType)[keyof typeof CmsCta_CtaBannerType]
export type CmsCallout = {
  __typename?: 'CmsCallout'
  callout?: Maybe<CmsCallout_Callout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  id: Scalars['Int']['output']
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsCalloutBlock = {
  __typename?: 'CmsCalloutBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  calloutReference?: Maybe<CmsCallout>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsCalloutUpdate_Callout_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsCalloutUpdate_Callout_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsCalloutUpdate_Callout_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsCalloutUpdate_Callout_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsCalloutUpdate_Callout_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsCalloutUpdate_Callout_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsCalloutUpdate_Callout_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsCalloutUpdate_Callout_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsCalloutUpdate_Callout_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsCalloutUpdate_Callout_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsCalloutUpdate_Callout_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsCalloutUpdate_Callout_Links_Link_ReusableRelationshipInputRelationTo]
export const CmsCalloutUpdate_Callout_Links_Link_Variant_MutationInput = {
  Default: 'default',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsCalloutUpdate_Callout_Links_Link_Variant_MutationInput =
  (typeof CmsCalloutUpdate_Callout_Links_Link_Variant_MutationInput)[keyof typeof CmsCalloutUpdate_Callout_Links_Link_Variant_MutationInput]
export const CmsCalloutUpdate_Callout_Emphasis_MutationInput = {
  Important: 'important',
  Primary: 'primary',
  Prime: 'prime',
  Standard: 'standard',
} as const

export type CmsCalloutUpdate_Callout_Emphasis_MutationInput =
  (typeof CmsCalloutUpdate_Callout_Emphasis_MutationInput)[keyof typeof CmsCalloutUpdate_Callout_Emphasis_MutationInput]
export const CmsCalloutUpdate_Callout_Intent_MutationInput = {
  CallToAction: 'callToAction',
  Custom: 'custom',
  Disclaimer: 'disclaimer',
  Link: 'link',
  Tip: 'tip',
} as const

export type CmsCalloutUpdate_Callout_Intent_MutationInput =
  (typeof CmsCalloutUpdate_Callout_Intent_MutationInput)[keyof typeof CmsCalloutUpdate_Callout_Intent_MutationInput]
export type CmsCallout_Callout = {
  __typename?: 'CmsCallout_Callout'
  emphasis?: Maybe<CmsCallout_Callout_Emphasis>
  heading?: Maybe<Scalars['String']['output']>
  iconName?: Maybe<Scalars['String']['output']>
  intent?: Maybe<CmsCallout_Callout_Intent>
  links?: Maybe<Array<CmsCallout_Callout_Links>>
  richText?: Maybe<Scalars['JSON']['output']>
}

export type CmsCallout_CalloutRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsCallout_Callout_Links = {
  __typename?: 'CmsCallout_Callout_Links'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsCallout_Callout_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsCallout_Callout_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsCallout_Callout_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsCallout_Callout_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsCallout_Callout_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsCallout_Callout_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsCallout_Callout_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsCallout_Callout_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsCallout_Callout_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsCallout_Callout_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsCallout_Callout_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsCallout_Callout_Links_Link_ReusableRelationshipInputRelationTo]
export const CmsCallout_Callout_Links_Link_Variant_MutationInput = {
  Default: 'default',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsCallout_Callout_Links_Link_Variant_MutationInput =
  (typeof CmsCallout_Callout_Links_Link_Variant_MutationInput)[keyof typeof CmsCallout_Callout_Links_Link_Variant_MutationInput]
export const CmsCallout_Callout_Emphasis = {
  Important: 'important',
  Primary: 'primary',
  Prime: 'prime',
  Standard: 'standard',
} as const

export type CmsCallout_Callout_Emphasis = (typeof CmsCallout_Callout_Emphasis)[keyof typeof CmsCallout_Callout_Emphasis]
export const CmsCallout_Callout_Emphasis_MutationInput = {
  Important: 'important',
  Primary: 'primary',
  Prime: 'prime',
  Standard: 'standard',
} as const

export type CmsCallout_Callout_Emphasis_MutationInput =
  (typeof CmsCallout_Callout_Emphasis_MutationInput)[keyof typeof CmsCallout_Callout_Emphasis_MutationInput]
export const CmsCallout_Callout_Intent = {
  CallToAction: 'callToAction',
  Custom: 'custom',
  Disclaimer: 'disclaimer',
  Link: 'link',
  Tip: 'tip',
} as const

export type CmsCallout_Callout_Intent = (typeof CmsCallout_Callout_Intent)[keyof typeof CmsCallout_Callout_Intent]
export const CmsCallout_Callout_Intent_MutationInput = {
  CallToAction: 'callToAction',
  Custom: 'custom',
  Disclaimer: 'disclaimer',
  Link: 'link',
  Tip: 'tip',
} as const

export type CmsCallout_Callout_Intent_MutationInput =
  (typeof CmsCallout_Callout_Intent_MutationInput)[keyof typeof CmsCallout_Callout_Intent_MutationInput]
export const CmsCallout_Callout__Emphasis_Input = {
  Important: 'important',
  Primary: 'primary',
  Prime: 'prime',
  Standard: 'standard',
} as const

export type CmsCallout_Callout__Emphasis_Input =
  (typeof CmsCallout_Callout__Emphasis_Input)[keyof typeof CmsCallout_Callout__Emphasis_Input]
export type CmsCallout_Callout__Emphasis_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Emphasis_Input>>>
  equals?: InputMaybe<CmsCallout_Callout__Emphasis_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Emphasis_Input>>>
  not_equals?: InputMaybe<CmsCallout_Callout__Emphasis_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Emphasis_Input>>>
}

export type CmsCallout_Callout__Heading_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__IconName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsCallout_Callout__Intent_Input = {
  CallToAction: 'callToAction',
  Custom: 'custom',
  Disclaimer: 'disclaimer',
  Link: 'link',
  Tip: 'tip',
} as const

export type CmsCallout_Callout__Intent_Input =
  (typeof CmsCallout_Callout__Intent_Input)[keyof typeof CmsCallout_Callout__Intent_Input]
export type CmsCallout_Callout__Intent_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Intent_Input>>>
  equals?: InputMaybe<CmsCallout_Callout__Intent_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Intent_Input>>>
  not_equals?: InputMaybe<CmsCallout_Callout__Intent_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Intent_Input>>>
}

export type CmsCallout_Callout__Links__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__Links__Link__IconAfter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__Links__Link__IconBefore_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__Links__Link__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__Links__Link__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsCallout_Callout__Links__Link__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__Links__Link__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__Links__Link__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Callout__Links__Link__Reference_Relation = {
  relationTo?: InputMaybe<CmsCallout_Callout__Links__Link__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsCallout_Callout__Links__Link__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsCallout_Callout__Links__Link__Reference_Relation_RelationTo =
  (typeof CmsCallout_Callout__Links__Link__Reference_Relation_RelationTo)[keyof typeof CmsCallout_Callout__Links__Link__Reference_Relation_RelationTo]
export type CmsCallout_Callout__Links__Link__Reusable_Relation = {
  relationTo?: InputMaybe<CmsCallout_Callout__Links__Link__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsCallout_Callout__Links__Link__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsCallout_Callout__Links__Link__Reusable_Relation_RelationTo =
  (typeof CmsCallout_Callout__Links__Link__Reusable_Relation_RelationTo)[keyof typeof CmsCallout_Callout__Links__Link__Reusable_Relation_RelationTo]
export type CmsCallout_Callout__Links__Link__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsCallout_Callout__Links__Link__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsCallout_Callout__Links__Link__Type_Input =
  (typeof CmsCallout_Callout__Links__Link__Type_Input)[keyof typeof CmsCallout_Callout__Links__Link__Type_Input]
export type CmsCallout_Callout__Links__Link__Type_Operator = {
  contains?: InputMaybe<CmsCallout_Callout__Links__Link__Type_Input>
  equals?: InputMaybe<CmsCallout_Callout__Links__Link__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsCallout_Callout__Links__Link__Type_Input>
  not_equals?: InputMaybe<CmsCallout_Callout__Links__Link__Type_Input>
}

export type CmsCallout_Callout__Links__Link__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsCallout_Callout__Links__Link__Variant_Input = {
  Default: 'default',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsCallout_Callout__Links__Link__Variant_Input =
  (typeof CmsCallout_Callout__Links__Link__Variant_Input)[keyof typeof CmsCallout_Callout__Links__Link__Variant_Input]
export type CmsCallout_Callout__Links__Link__Variant_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Links__Link__Variant_Input>>>
  equals?: InputMaybe<CmsCallout_Callout__Links__Link__Variant_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Links__Link__Variant_Input>>>
  not_equals?: InputMaybe<CmsCallout_Callout__Links__Link__Variant_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsCallout_Callout__Links__Link__Variant_Input>>>
}

export type CmsCallout_Callout__RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsCallout_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsCallout_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsCallout_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsCallout_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCallout_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsCallout_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsCallout_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsCallout_Where_Or>>>
  callout__emphasis?: InputMaybe<CmsCallout_Callout__Emphasis_Operator>
  callout__heading?: InputMaybe<CmsCallout_Callout__Heading_Operator>
  callout__iconName?: InputMaybe<CmsCallout_Callout__IconName_Operator>
  callout__intent?: InputMaybe<CmsCallout_Callout__Intent_Operator>
  callout__links__id?: InputMaybe<CmsCallout_Callout__Links__Id_Operator>
  callout__links__link__iconAfter?: InputMaybe<CmsCallout_Callout__Links__Link__IconAfter_Operator>
  callout__links__link__iconBefore?: InputMaybe<CmsCallout_Callout__Links__Link__IconBefore_Operator>
  callout__links__link__label?: InputMaybe<CmsCallout_Callout__Links__Link__Label_Operator>
  callout__links__link__newTab?: InputMaybe<CmsCallout_Callout__Links__Link__NewTab_Operator>
  callout__links__link__query__id?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Id_Operator>
  callout__links__link__query__key?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Key_Operator>
  callout__links__link__query__value?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Value_Operator>
  callout__links__link__reference?: InputMaybe<CmsCallout_Callout__Links__Link__Reference_Relation>
  callout__links__link__reusable?: InputMaybe<CmsCallout_Callout__Links__Link__Reusable_Relation>
  callout__links__link__targetId?: InputMaybe<CmsCallout_Callout__Links__Link__TargetId_Operator>
  callout__links__link__type?: InputMaybe<CmsCallout_Callout__Links__Link__Type_Operator>
  callout__links__link__url?: InputMaybe<CmsCallout_Callout__Links__Link__Url_Operator>
  callout__links__link__variant?: InputMaybe<CmsCallout_Callout__Links__Link__Variant_Operator>
  callout__richText?: InputMaybe<CmsCallout_Callout__RichText_Operator>
  createdAt?: InputMaybe<CmsCallout_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsCallout_CreatedBy_Operator>
  id?: InputMaybe<CmsCallout_Id_Operator>
  slug?: InputMaybe<CmsCallout_Slug_Operator>
  title?: InputMaybe<CmsCallout_Title_Operator>
  updatedAt?: InputMaybe<CmsCallout_UpdatedAt_Operator>
}

export type CmsCallout_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsCallout_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsCallout_Where_Or>>>
  callout__emphasis?: InputMaybe<CmsCallout_Callout__Emphasis_Operator>
  callout__heading?: InputMaybe<CmsCallout_Callout__Heading_Operator>
  callout__iconName?: InputMaybe<CmsCallout_Callout__IconName_Operator>
  callout__intent?: InputMaybe<CmsCallout_Callout__Intent_Operator>
  callout__links__id?: InputMaybe<CmsCallout_Callout__Links__Id_Operator>
  callout__links__link__iconAfter?: InputMaybe<CmsCallout_Callout__Links__Link__IconAfter_Operator>
  callout__links__link__iconBefore?: InputMaybe<CmsCallout_Callout__Links__Link__IconBefore_Operator>
  callout__links__link__label?: InputMaybe<CmsCallout_Callout__Links__Link__Label_Operator>
  callout__links__link__newTab?: InputMaybe<CmsCallout_Callout__Links__Link__NewTab_Operator>
  callout__links__link__query__id?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Id_Operator>
  callout__links__link__query__key?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Key_Operator>
  callout__links__link__query__value?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Value_Operator>
  callout__links__link__reference?: InputMaybe<CmsCallout_Callout__Links__Link__Reference_Relation>
  callout__links__link__reusable?: InputMaybe<CmsCallout_Callout__Links__Link__Reusable_Relation>
  callout__links__link__targetId?: InputMaybe<CmsCallout_Callout__Links__Link__TargetId_Operator>
  callout__links__link__type?: InputMaybe<CmsCallout_Callout__Links__Link__Type_Operator>
  callout__links__link__url?: InputMaybe<CmsCallout_Callout__Links__Link__Url_Operator>
  callout__links__link__variant?: InputMaybe<CmsCallout_Callout__Links__Link__Variant_Operator>
  callout__richText?: InputMaybe<CmsCallout_Callout__RichText_Operator>
  createdAt?: InputMaybe<CmsCallout_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsCallout_CreatedBy_Operator>
  id?: InputMaybe<CmsCallout_Id_Operator>
  slug?: InputMaybe<CmsCallout_Slug_Operator>
  title?: InputMaybe<CmsCallout_Title_Operator>
  updatedAt?: InputMaybe<CmsCallout_UpdatedAt_Operator>
}

export type CmsCallout_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsCallout_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsCallout_Where_Or>>>
  callout__emphasis?: InputMaybe<CmsCallout_Callout__Emphasis_Operator>
  callout__heading?: InputMaybe<CmsCallout_Callout__Heading_Operator>
  callout__iconName?: InputMaybe<CmsCallout_Callout__IconName_Operator>
  callout__intent?: InputMaybe<CmsCallout_Callout__Intent_Operator>
  callout__links__id?: InputMaybe<CmsCallout_Callout__Links__Id_Operator>
  callout__links__link__iconAfter?: InputMaybe<CmsCallout_Callout__Links__Link__IconAfter_Operator>
  callout__links__link__iconBefore?: InputMaybe<CmsCallout_Callout__Links__Link__IconBefore_Operator>
  callout__links__link__label?: InputMaybe<CmsCallout_Callout__Links__Link__Label_Operator>
  callout__links__link__newTab?: InputMaybe<CmsCallout_Callout__Links__Link__NewTab_Operator>
  callout__links__link__query__id?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Id_Operator>
  callout__links__link__query__key?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Key_Operator>
  callout__links__link__query__value?: InputMaybe<CmsCallout_Callout__Links__Link__Query__Value_Operator>
  callout__links__link__reference?: InputMaybe<CmsCallout_Callout__Links__Link__Reference_Relation>
  callout__links__link__reusable?: InputMaybe<CmsCallout_Callout__Links__Link__Reusable_Relation>
  callout__links__link__targetId?: InputMaybe<CmsCallout_Callout__Links__Link__TargetId_Operator>
  callout__links__link__type?: InputMaybe<CmsCallout_Callout__Links__Link__Type_Operator>
  callout__links__link__url?: InputMaybe<CmsCallout_Callout__Links__Link__Url_Operator>
  callout__links__link__variant?: InputMaybe<CmsCallout_Callout__Links__Link__Variant_Operator>
  callout__richText?: InputMaybe<CmsCallout_Callout__RichText_Operator>
  createdAt?: InputMaybe<CmsCallout_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsCallout_CreatedBy_Operator>
  id?: InputMaybe<CmsCallout_Id_Operator>
  slug?: InputMaybe<CmsCallout_Slug_Operator>
  title?: InputMaybe<CmsCallout_Title_Operator>
  updatedAt?: InputMaybe<CmsCallout_UpdatedAt_Operator>
}

export type CmsCallouts = {
  __typename?: 'CmsCallouts'
  docs?: Maybe<Array<Maybe<CmsCallout>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsCarousel = {
  __typename?: 'CmsCarousel'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsCarousel_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
  slides?: Maybe<Array<CmsCarousel_Slides>>
}

export type CmsCarousel_Ctas = {
  __typename?: 'CmsCarousel_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsCarousel_Slides = {
  __typename?: 'CmsCarousel_Slides'
  id?: Maybe<Scalars['String']['output']>
  media?: Maybe<CmsMedia>
}

export type CmsCategories = {
  __typename?: 'CmsCategories'
  breadcrumbs?: Maybe<Array<CmsCategories_Breadcrumbs>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  id: Scalars['Int']['output']
  isPublic?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsCategories>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsCategories_Breadcrumbs = {
  __typename?: 'CmsCategories_Breadcrumbs'
  doc?: Maybe<CmsCategories>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsCategories_Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsCategories_Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCategories_Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCategories_Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCategories_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsCategories_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsCategories_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsCategories_IsPublic_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsCategories_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsCategories_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCategories_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsCategories_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsCategories_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsCategories_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsCategories_Where_Or>>>
  breadcrumbs__doc?: InputMaybe<CmsCategories_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsCategories_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsCategories_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsCategories_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsCategories_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsCategories_CreatedBy_Operator>
  id?: InputMaybe<CmsCategories_Id_Operator>
  isPublic?: InputMaybe<CmsCategories_IsPublic_Operator>
  parent?: InputMaybe<CmsCategories_Parent_Operator>
  slug?: InputMaybe<CmsCategories_Slug_Operator>
  title?: InputMaybe<CmsCategories_Title_Operator>
  updatedAt?: InputMaybe<CmsCategories_UpdatedAt_Operator>
}

export type CmsCategories_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsCategories_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsCategories_Where_Or>>>
  breadcrumbs__doc?: InputMaybe<CmsCategories_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsCategories_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsCategories_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsCategories_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsCategories_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsCategories_CreatedBy_Operator>
  id?: InputMaybe<CmsCategories_Id_Operator>
  isPublic?: InputMaybe<CmsCategories_IsPublic_Operator>
  parent?: InputMaybe<CmsCategories_Parent_Operator>
  slug?: InputMaybe<CmsCategories_Slug_Operator>
  title?: InputMaybe<CmsCategories_Title_Operator>
  updatedAt?: InputMaybe<CmsCategories_UpdatedAt_Operator>
}

export type CmsCategories_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsCategories_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsCategories_Where_Or>>>
  breadcrumbs__doc?: InputMaybe<CmsCategories_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsCategories_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsCategories_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsCategories_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsCategories_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsCategories_CreatedBy_Operator>
  id?: InputMaybe<CmsCategories_Id_Operator>
  isPublic?: InputMaybe<CmsCategories_IsPublic_Operator>
  parent?: InputMaybe<CmsCategories_Parent_Operator>
  slug?: InputMaybe<CmsCategories_Slug_Operator>
  title?: InputMaybe<CmsCategories_Title_Operator>
  updatedAt?: InputMaybe<CmsCategories_UpdatedAt_Operator>
}

export type CmsCheckboxFormField = {
  __typename?: 'CmsCheckboxFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  defaultValue?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsComment = {
  __typename?: 'CmsComment'
  author?: Maybe<CmsAuthor>
  authorIp?: Maybe<Scalars['String']['output']>
  authorName?: Maybe<Scalars['String']['output']>
  authorUserAgent?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['EmailAddress']['output']>
  id: Scalars['Int']['output']
  isApproved?: Maybe<Scalars['Boolean']['output']>
  rejectReason?: Maybe<Scalars['String']['output']>
  replyComment?: Maybe<CmsComment>
  replyPost?: Maybe<CmsComment_ReplyPost_Relationship>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsCommentReplyPostArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsCommentUpdate_ReplyPostRelationshipInput = {
  relationTo?: InputMaybe<CmsCommentUpdate_ReplyPostRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsCommentUpdate_ReplyPostRelationshipInputRelationTo = {
  Articles: 'articles',
  Newsroom: 'newsroom',
} as const

export type CmsCommentUpdate_ReplyPostRelationshipInputRelationTo =
  (typeof CmsCommentUpdate_ReplyPostRelationshipInputRelationTo)[keyof typeof CmsCommentUpdate_ReplyPostRelationshipInputRelationTo]
export type CmsComment_ReplyPost = CmsArticle | CmsNewsroomArticle

export type CmsComment_ReplyPostRelationshipInput = {
  relationTo?: InputMaybe<CmsComment_ReplyPostRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsComment_ReplyPostRelationshipInputRelationTo = {
  Articles: 'articles',
  Newsroom: 'newsroom',
} as const

export type CmsComment_ReplyPostRelationshipInputRelationTo =
  (typeof CmsComment_ReplyPostRelationshipInputRelationTo)[keyof typeof CmsComment_ReplyPostRelationshipInputRelationTo]
export const CmsComment_ReplyPost_RelationTo = {
  Articles: 'articles',
  Newsroom: 'newsroom',
} as const

export type CmsComment_ReplyPost_RelationTo =
  (typeof CmsComment_ReplyPost_RelationTo)[keyof typeof CmsComment_ReplyPost_RelationTo]
export type CmsComment_ReplyPost_Relationship = {
  __typename?: 'CmsComment_ReplyPost_Relationship'
  relationTo?: Maybe<CmsComment_ReplyPost_RelationTo>
  value?: Maybe<CmsComment_ReplyPost>
}

export type CmsComment_AuthorIp_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsComment_AuthorName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsComment_AuthorUserAgent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsComment_Author_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsComment_Content_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsComment_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsComment_Email_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>
  contains?: InputMaybe<Scalars['EmailAddress']['input']>
  equals?: InputMaybe<Scalars['EmailAddress']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>
  like?: InputMaybe<Scalars['EmailAddress']['input']>
  not_equals?: InputMaybe<Scalars['EmailAddress']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']['input']>>>
}

export type CmsComment_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsComment_IsApproved_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsComment_RejectReason_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsComment_ReplyComment_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsComment_ReplyPost_Relation = {
  relationTo?: InputMaybe<CmsComment_ReplyPost_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsComment_ReplyPost_Relation_RelationTo = {
  Articles: 'articles',
  Newsroom: 'newsroom',
} as const

export type CmsComment_ReplyPost_Relation_RelationTo =
  (typeof CmsComment_ReplyPost_Relation_RelationTo)[keyof typeof CmsComment_ReplyPost_Relation_RelationTo]
export type CmsComment_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsComment_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsComment_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsComment_Where_Or>>>
  author?: InputMaybe<CmsComment_Author_Operator>
  authorIp?: InputMaybe<CmsComment_AuthorIp_Operator>
  authorName?: InputMaybe<CmsComment_AuthorName_Operator>
  authorUserAgent?: InputMaybe<CmsComment_AuthorUserAgent_Operator>
  content?: InputMaybe<CmsComment_Content_Operator>
  createdAt?: InputMaybe<CmsComment_CreatedAt_Operator>
  email?: InputMaybe<CmsComment_Email_Operator>
  id?: InputMaybe<CmsComment_Id_Operator>
  isApproved?: InputMaybe<CmsComment_IsApproved_Operator>
  rejectReason?: InputMaybe<CmsComment_RejectReason_Operator>
  replyComment?: InputMaybe<CmsComment_ReplyComment_Operator>
  replyPost?: InputMaybe<CmsComment_ReplyPost_Relation>
  updatedAt?: InputMaybe<CmsComment_UpdatedAt_Operator>
}

export type CmsComment_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsComment_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsComment_Where_Or>>>
  author?: InputMaybe<CmsComment_Author_Operator>
  authorIp?: InputMaybe<CmsComment_AuthorIp_Operator>
  authorName?: InputMaybe<CmsComment_AuthorName_Operator>
  authorUserAgent?: InputMaybe<CmsComment_AuthorUserAgent_Operator>
  content?: InputMaybe<CmsComment_Content_Operator>
  createdAt?: InputMaybe<CmsComment_CreatedAt_Operator>
  email?: InputMaybe<CmsComment_Email_Operator>
  id?: InputMaybe<CmsComment_Id_Operator>
  isApproved?: InputMaybe<CmsComment_IsApproved_Operator>
  rejectReason?: InputMaybe<CmsComment_RejectReason_Operator>
  replyComment?: InputMaybe<CmsComment_ReplyComment_Operator>
  replyPost?: InputMaybe<CmsComment_ReplyPost_Relation>
  updatedAt?: InputMaybe<CmsComment_UpdatedAt_Operator>
}

export type CmsComment_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsComment_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsComment_Where_Or>>>
  author?: InputMaybe<CmsComment_Author_Operator>
  authorIp?: InputMaybe<CmsComment_AuthorIp_Operator>
  authorName?: InputMaybe<CmsComment_AuthorName_Operator>
  authorUserAgent?: InputMaybe<CmsComment_AuthorUserAgent_Operator>
  content?: InputMaybe<CmsComment_Content_Operator>
  createdAt?: InputMaybe<CmsComment_CreatedAt_Operator>
  email?: InputMaybe<CmsComment_Email_Operator>
  id?: InputMaybe<CmsComment_Id_Operator>
  isApproved?: InputMaybe<CmsComment_IsApproved_Operator>
  rejectReason?: InputMaybe<CmsComment_RejectReason_Operator>
  replyComment?: InputMaybe<CmsComment_ReplyComment_Operator>
  replyPost?: InputMaybe<CmsComment_ReplyPost_Relation>
  updatedAt?: InputMaybe<CmsComment_UpdatedAt_Operator>
}

export type CmsComments = {
  __typename?: 'CmsComments'
  docs?: Maybe<Array<Maybe<CmsComment>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsContent = {
  __typename?: 'CmsContent'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  columns?: Maybe<Array<CmsContent_Columns>>
  columnsAlign?: Maybe<CmsContent_ColumnsAlign>
  columnsMaxWidth?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
}

export type CmsContentLayout = {
  __typename?: 'CmsContentLayout'
  layout?: Maybe<Array<CmsContentLayout_Layout>>
}

export type CmsContentLayout_Layout =
  | CmsAccordion
  | CmsAlertBannerBlock
  | CmsArchive
  | CmsBento
  | CmsCta
  | CmsCalloutBlock
  | CmsCarousel
  | CmsContent
  | CmsCrossLinks
  | CmsDevicePreview
  | CmsDisclaimers
  | CmsDownloadBanner
  | CmsExperiment
  | CmsFeatureGrid
  | CmsFeatureSection
  | CmsFormBlock
  | CmsImageBlock
  | CmsLegalBlock
  | CmsOfferBlock
  | CmsPriceTier
  | CmsProsConsBlock
  | CmsQuote
  | CmsResources
  | CmsRichTextBlock
  | CmsRichTextSection
  | CmsTableBlock
  | CmsVideoBlock
  | CmsVideoEmbedBlock

export type CmsContent_Columns = {
  __typename?: 'CmsContent_Columns'
  colSpanLg?: Maybe<Scalars['Float']['output']>
  colSpanMd?: Maybe<Scalars['Float']['output']>
  colSpanSm?: Maybe<Scalars['Float']['output']>
  ctaAlign?: Maybe<CmsContent_Columns_CtaAlign>
  ctas?: Maybe<Array<CmsContent_Columns_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  richText?: Maybe<Scalars['JSON']['output']>
}

export type CmsContent_ColumnsRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsContent_Columns_Ctas = {
  __typename?: 'CmsContent_Columns_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export const CmsContent_Columns_CtaAlign = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsContent_Columns_CtaAlign = (typeof CmsContent_Columns_CtaAlign)[keyof typeof CmsContent_Columns_CtaAlign]
export const CmsContent_ColumnsAlign = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsContent_ColumnsAlign = (typeof CmsContent_ColumnsAlign)[keyof typeof CmsContent_ColumnsAlign]
export type CmsCreditQualityFormField = {
  __typename?: 'CmsCreditQualityFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsCrossLinks = {
  __typename?: 'CmsCrossLinks'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  crossLinksCards?: Maybe<Array<CmsCrossLinks_CrossLinksCards>>
  ctas?: Maybe<Array<CmsCrossLinks_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
}

export type CmsCrossLinks_CrossLinksCards = {
  __typename?: 'CmsCrossLinks_CrossLinksCards'
  id?: Maybe<Scalars['String']['output']>
  media?: Maybe<CmsMedia>
  selectedDoc?: Maybe<CmsCrossLinks_CrossLinksCards_SelectedDoc_Relationship>
  title?: Maybe<Scalars['String']['output']>
  topic?: Maybe<Scalars['String']['output']>
}

export type CmsCrossLinks_CrossLinksCardsSelectedDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsCrossLinks_CrossLinksCards_SelectedDoc =
  | CmsArticle
  | CmsGuide
  | CmsMarketplacePage
  | CmsNewsroomArticle
  | CmsPage

export const CmsCrossLinks_CrossLinksCards_SelectedDoc_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsCrossLinks_CrossLinksCards_SelectedDoc_RelationTo =
  (typeof CmsCrossLinks_CrossLinksCards_SelectedDoc_RelationTo)[keyof typeof CmsCrossLinks_CrossLinksCards_SelectedDoc_RelationTo]
export type CmsCrossLinks_CrossLinksCards_SelectedDoc_Relationship = {
  __typename?: 'CmsCrossLinks_CrossLinksCards_SelectedDoc_Relationship'
  relationTo?: Maybe<CmsCrossLinks_CrossLinksCards_SelectedDoc_RelationTo>
  value?: Maybe<CmsCrossLinks_CrossLinksCards_SelectedDoc>
}

export type CmsCrossLinks_Ctas = {
  __typename?: 'CmsCrossLinks_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsCustomFooter = {
  __typename?: 'CmsCustomFooter'
  disclaimers?: Maybe<Array<CmsDisclaimersArray>>
  isHidden?: Maybe<Scalars['Boolean']['output']>
}

export type CmsCustomHeader = {
  __typename?: 'CmsCustomHeader'
  headerDisplay?: Maybe<CmsCustomHeader_HeaderDisplay>
  isHidden?: Maybe<Scalars['Boolean']['output']>
  loginLink?: Maybe<CmsLink>
  signupLink?: Maybe<CmsLink>
  supportLink?: Maybe<CmsLink>
}

export const CmsCustomHeader_HeaderDisplay = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsCustomHeader_HeaderDisplay =
  (typeof CmsCustomHeader_HeaderDisplay)[keyof typeof CmsCustomHeader_HeaderDisplay]
export type CmsDevicePreview = {
  __typename?: 'CmsDevicePreview'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsDevicePreview_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  laptopMedia?: Maybe<CmsMedia>
  phoneMedia?: Maybe<CmsMedia>
  section?: Maybe<CmsSection>
}

export type CmsDevicePreview_Ctas = {
  __typename?: 'CmsDevicePreview_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsDisclaimers = {
  __typename?: 'CmsDisclaimers'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsDisclaimers_Ctas>>
  disclaimers?: Maybe<Array<CmsDisclaimersArray>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
}

export type CmsDisclaimersArray = {
  __typename?: 'CmsDisclaimersArray'
  align?: Maybe<CmsDisclaimersArray_Align>
  id?: Maybe<Scalars['String']['output']>
  includeAsterick?: Maybe<Scalars['Boolean']['output']>
  number?: Maybe<Scalars['Float']['output']>
  text?: Maybe<CmsLegal>
}

export const CmsDisclaimersArray_Align = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsDisclaimersArray_Align = (typeof CmsDisclaimersArray_Align)[keyof typeof CmsDisclaimersArray_Align]
export type CmsDisclaimers_Ctas = {
  __typename?: 'CmsDisclaimers_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsDownloadBanner = {
  __typename?: 'CmsDownloadBanner'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  media?: Maybe<CmsMedia>
  richText?: Maybe<Scalars['JSON']['output']>
}

export type CmsDownloadBannerRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsEmailFormField = {
  __typename?: 'CmsEmailFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsExperiment = {
  __typename?: 'CmsExperiment'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  featureFlag?: Maybe<CmsFeatureFlag>
  id?: Maybe<Scalars['String']['output']>
  layout?: Maybe<Array<CmsExperiment_Layout>>
}

export type CmsExperiment_Layout =
  | CmsAccordion
  | CmsAlertBannerBlock
  | CmsArchive
  | CmsBento
  | CmsCta
  | CmsCalloutBlock
  | CmsCarousel
  | CmsContent
  | CmsCrossLinks
  | CmsDevicePreview
  | CmsDisclaimers
  | CmsDownloadBanner
  | CmsFeatureGrid
  | CmsFeatureSection
  | CmsFormBlock
  | CmsImageBlock
  | CmsLegalBlock
  | CmsOfferBlock
  | CmsPriceTier
  | CmsQuote
  | CmsResources
  | CmsRichTextBlock
  | CmsRichTextSection
  | CmsTableBlock
  | CmsVideoBlock
  | CmsVideoEmbedBlock

export type CmsFeatureFlag = {
  __typename?: 'CmsFeatureFlag'
  key?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type CmsFeatureGrid = {
  __typename?: 'CmsFeatureGrid'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsFeatureGrid_Ctas>>
  features?: Maybe<Array<CmsFeatureGrid_Features>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
}

export type CmsFeatureGrid_Ctas = {
  __typename?: 'CmsFeatureGrid_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsFeatureGrid_Features = {
  __typename?: 'CmsFeatureGrid_Features'
  description?: Maybe<Scalars['String']['output']>
  fillIcon?: Maybe<Scalars['Boolean']['output']>
  iconName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type CmsFeatureSection = {
  __typename?: 'CmsFeatureSection'
  align?: Maybe<CmsFeatureSection_Align>
  bgMedia?: Maybe<CmsMedia>
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsFeatureSection_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
  template?: Maybe<CmsFeatureSection_Template>
  tmplStats?: Maybe<Array<CmsFeatureSection_TmplStats>>
}

export type CmsFeatureSection_Ctas = {
  __typename?: 'CmsFeatureSection_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsFeatureSection_TmplStats = {
  __typename?: 'CmsFeatureSection_TmplStats'
  data?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['JSON']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsFeatureSection_TmplStatsDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export const CmsFeatureSection_Align = {
  ImageAlignLeft: 'imageAlignLeft',
  ImageAlignRight: 'imageAlignRight',
} as const

export type CmsFeatureSection_Align = (typeof CmsFeatureSection_Align)[keyof typeof CmsFeatureSection_Align]
export const CmsFeatureSection_Template = {
  None: 'none',
  Stats: 'stats',
} as const

export type CmsFeatureSection_Template = (typeof CmsFeatureSection_Template)[keyof typeof CmsFeatureSection_Template]
export type CmsFooter = {
  __typename?: 'CmsFooter'
  copyrightText: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  disclaimers?: Maybe<Array<CmsDisclaimersArray>>
  footerColumns?: Maybe<Array<CmsFooter_FooterColumns>>
  termsLinks?: Maybe<Array<CmsFooter_TermsLinks>>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsFooterDocAccessFields = {
  __typename?: 'CmsFooterDocAccessFields'
  copyrightText?: Maybe<CmsFooterDocAccessFields_CopyrightText>
  createdAt?: Maybe<CmsFooterDocAccessFields_CreatedAt>
  disclaimers?: Maybe<CmsFooterDocAccessFields_Disclaimers>
  footerColumns?: Maybe<CmsFooterDocAccessFields_FooterColumns>
  termsLinks?: Maybe<CmsFooterDocAccessFields_TermsLinks>
  updatedAt?: Maybe<CmsFooterDocAccessFields_UpdatedAt>
}

export type CmsFooterDocAccessFields_CopyrightText = {
  __typename?: 'CmsFooterDocAccessFields_copyrightText'
  create?: Maybe<CmsFooterDocAccessFields_CopyrightText_Create>
  delete?: Maybe<CmsFooterDocAccessFields_CopyrightText_Delete>
  read?: Maybe<CmsFooterDocAccessFields_CopyrightText_Read>
  update?: Maybe<CmsFooterDocAccessFields_CopyrightText_Update>
}

export type CmsFooterDocAccessFields_CopyrightText_Create = {
  __typename?: 'CmsFooterDocAccessFields_copyrightText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_CopyrightText_Delete = {
  __typename?: 'CmsFooterDocAccessFields_copyrightText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_CopyrightText_Read = {
  __typename?: 'CmsFooterDocAccessFields_copyrightText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_CopyrightText_Update = {
  __typename?: 'CmsFooterDocAccessFields_copyrightText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_CreatedAt = {
  __typename?: 'CmsFooterDocAccessFields_createdAt'
  create?: Maybe<CmsFooterDocAccessFields_CreatedAt_Create>
  delete?: Maybe<CmsFooterDocAccessFields_CreatedAt_Delete>
  read?: Maybe<CmsFooterDocAccessFields_CreatedAt_Read>
  update?: Maybe<CmsFooterDocAccessFields_CreatedAt_Update>
}

export type CmsFooterDocAccessFields_CreatedAt_Create = {
  __typename?: 'CmsFooterDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CmsFooterDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_CreatedAt_Read = {
  __typename?: 'CmsFooterDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_CreatedAt_Update = {
  __typename?: 'CmsFooterDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers'
  create?: Maybe<CmsFooterDocAccessFields_Disclaimers_Create>
  delete?: Maybe<CmsFooterDocAccessFields_Disclaimers_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_Disclaimers_Fields>
  read?: Maybe<CmsFooterDocAccessFields_Disclaimers_Read>
  update?: Maybe<CmsFooterDocAccessFields_Disclaimers_Update>
}

export type CmsFooterDocAccessFields_Disclaimers_Create = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Delete = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Fields = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_Fields'
  align?: Maybe<CmsFooterDocAccessFields_Disclaimers_Align>
  id?: Maybe<CmsFooterDocAccessFields_Disclaimers_Id>
  includeAsterick?: Maybe<CmsFooterDocAccessFields_Disclaimers_IncludeAsterick>
  number?: Maybe<CmsFooterDocAccessFields_Disclaimers_Number>
  text?: Maybe<CmsFooterDocAccessFields_Disclaimers_Text>
}

export type CmsFooterDocAccessFields_Disclaimers_Read = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Update = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Align = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_align'
  create?: Maybe<CmsFooterDocAccessFields_Disclaimers_Align_Create>
  delete?: Maybe<CmsFooterDocAccessFields_Disclaimers_Align_Delete>
  read?: Maybe<CmsFooterDocAccessFields_Disclaimers_Align_Read>
  update?: Maybe<CmsFooterDocAccessFields_Disclaimers_Align_Update>
}

export type CmsFooterDocAccessFields_Disclaimers_Align_Create = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Align_Delete = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Align_Read = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Align_Update = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Id = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_id'
  create?: Maybe<CmsFooterDocAccessFields_Disclaimers_Id_Create>
  delete?: Maybe<CmsFooterDocAccessFields_Disclaimers_Id_Delete>
  read?: Maybe<CmsFooterDocAccessFields_Disclaimers_Id_Read>
  update?: Maybe<CmsFooterDocAccessFields_Disclaimers_Id_Update>
}

export type CmsFooterDocAccessFields_Disclaimers_Id_Create = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Id_Delete = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Id_Read = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Id_Update = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_IncludeAsterick = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_includeAsterick'
  create?: Maybe<CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Update>
}

export type CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Number = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_number'
  create?: Maybe<CmsFooterDocAccessFields_Disclaimers_Number_Create>
  delete?: Maybe<CmsFooterDocAccessFields_Disclaimers_Number_Delete>
  read?: Maybe<CmsFooterDocAccessFields_Disclaimers_Number_Read>
  update?: Maybe<CmsFooterDocAccessFields_Disclaimers_Number_Update>
}

export type CmsFooterDocAccessFields_Disclaimers_Number_Create = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Number_Delete = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Number_Read = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Number_Update = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Text = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_text'
  create?: Maybe<CmsFooterDocAccessFields_Disclaimers_Text_Create>
  delete?: Maybe<CmsFooterDocAccessFields_Disclaimers_Text_Delete>
  read?: Maybe<CmsFooterDocAccessFields_Disclaimers_Text_Read>
  update?: Maybe<CmsFooterDocAccessFields_Disclaimers_Text_Update>
}

export type CmsFooterDocAccessFields_Disclaimers_Text_Create = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Text_Delete = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Text_Read = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_Disclaimers_Text_Update = {
  __typename?: 'CmsFooterDocAccessFields_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_FooterColumns_Fields>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_Fields = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_Fields'
  id?: Maybe<CmsFooterDocAccessFields_FooterColumns_Id>
  linkColumns?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns>
}

export type CmsFooterDocAccessFields_FooterColumns_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_Id = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_id'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_Id_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_Id_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_Id_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_Id_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_Id_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_Id_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_Id_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_Id_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Fields>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Fields = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_Fields'
  columnTitle?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle>
  links?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_columnTitle'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_columnTitle_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_columnTitle_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_columnTitle_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_ColumnTitle_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_columnTitle_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Fields>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Fields = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_Fields'
  id?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id>
  link?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_id'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Id_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Fields>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Fields = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_Fields'
  iconAfter?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter>
  iconBefore?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore>
  label?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label>
  newTab?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab>
  query?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query>
  reference?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference>
  reusable?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable>
  targetId?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId>
  type?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type>
  url?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconAfter'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconBefore'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_label'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Label_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_newTab'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_NewTab_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Fields>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Fields = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_Fields'
  id?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id>
  key?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key>
  value?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_id'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_key'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_value'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reference'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reference_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reusable'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Reusable_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_targetId'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_TargetId_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_type'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Type_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_url'
  create?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Create>
  delete?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Delete>
  read?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Read>
  update?: Maybe<CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Update>
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Create = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Delete = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Read = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_FooterColumns_LinkColumns_Links_Link_Url_Update = {
  __typename?: 'CmsFooterDocAccessFields_footerColumns_linkColumns_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_TermsLinks_Fields>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Fields = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_Fields'
  id?: Maybe<CmsFooterDocAccessFields_TermsLinks_Id>
  link?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link>
}

export type CmsFooterDocAccessFields_TermsLinks_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Id = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_id'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Id_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Id_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Id_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Id_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Id_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Id_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Id_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Id_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Fields>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Fields = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_Fields'
  iconAfter?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconAfter>
  iconBefore?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconBefore>
  label?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Label>
  newTab?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_NewTab>
  query?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query>
  reference?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reference>
  reusable?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reusable>
  targetId?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_TargetId>
  type?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Type>
  url?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Url>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconAfter = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconAfter'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconAfter_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconBefore = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconBefore'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_IconBefore_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Label = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_label'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Label_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Label_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Label_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Label_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Label_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Label_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Label_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Label_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_NewTab = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_newTab'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_NewTab_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Delete>
  fields?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Fields>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Fields = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_Fields'
  id?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Id>
  key?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Key>
  value?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Value>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Id = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_id'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Id_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Key = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_key'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Key_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Value = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_value'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Query_Value_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reference = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reference'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reference_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reference_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reference_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reference_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reference_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reference_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reference_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reference_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reusable = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reusable'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Reusable_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_TargetId = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_targetId'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_TargetId_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Type = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_type'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Type_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Type_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Type_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Type_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Type_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Type_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Type_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Type_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Url = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_url'
  create?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Url_Create>
  delete?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Url_Delete>
  read?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Url_Read>
  update?: Maybe<CmsFooterDocAccessFields_TermsLinks_Link_Url_Update>
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Url_Create = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Url_Delete = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Url_Read = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_TermsLinks_Link_Url_Update = {
  __typename?: 'CmsFooterDocAccessFields_termsLinks_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_UpdatedAt = {
  __typename?: 'CmsFooterDocAccessFields_updatedAt'
  create?: Maybe<CmsFooterDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<CmsFooterDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<CmsFooterDocAccessFields_UpdatedAt_Read>
  update?: Maybe<CmsFooterDocAccessFields_UpdatedAt_Update>
}

export type CmsFooterDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CmsFooterDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CmsFooterDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CmsFooterDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CmsFooterDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields = {
  __typename?: 'CmsFooterFields'
  copyrightText?: Maybe<CmsFooterFields_CopyrightText>
  createdAt?: Maybe<CmsFooterFields_CreatedAt>
  disclaimers?: Maybe<CmsFooterFields_Disclaimers>
  footerColumns?: Maybe<CmsFooterFields_FooterColumns>
  termsLinks?: Maybe<CmsFooterFields_TermsLinks>
  updatedAt?: Maybe<CmsFooterFields_UpdatedAt>
}

export type CmsFooterFields_CopyrightText = {
  __typename?: 'CmsFooterFields_copyrightText'
  create?: Maybe<CmsFooterFields_CopyrightText_Create>
  delete?: Maybe<CmsFooterFields_CopyrightText_Delete>
  read?: Maybe<CmsFooterFields_CopyrightText_Read>
  update?: Maybe<CmsFooterFields_CopyrightText_Update>
}

export type CmsFooterFields_CopyrightText_Create = {
  __typename?: 'CmsFooterFields_copyrightText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_CopyrightText_Delete = {
  __typename?: 'CmsFooterFields_copyrightText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_CopyrightText_Read = {
  __typename?: 'CmsFooterFields_copyrightText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_CopyrightText_Update = {
  __typename?: 'CmsFooterFields_copyrightText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_CreatedAt = {
  __typename?: 'CmsFooterFields_createdAt'
  create?: Maybe<CmsFooterFields_CreatedAt_Create>
  delete?: Maybe<CmsFooterFields_CreatedAt_Delete>
  read?: Maybe<CmsFooterFields_CreatedAt_Read>
  update?: Maybe<CmsFooterFields_CreatedAt_Update>
}

export type CmsFooterFields_CreatedAt_Create = {
  __typename?: 'CmsFooterFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_CreatedAt_Delete = {
  __typename?: 'CmsFooterFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_CreatedAt_Read = {
  __typename?: 'CmsFooterFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_CreatedAt_Update = {
  __typename?: 'CmsFooterFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers = {
  __typename?: 'CmsFooterFields_disclaimers'
  create?: Maybe<CmsFooterFields_Disclaimers_Create>
  delete?: Maybe<CmsFooterFields_Disclaimers_Delete>
  fields?: Maybe<CmsFooterFields_Disclaimers_Fields>
  read?: Maybe<CmsFooterFields_Disclaimers_Read>
  update?: Maybe<CmsFooterFields_Disclaimers_Update>
}

export type CmsFooterFields_Disclaimers_Create = {
  __typename?: 'CmsFooterFields_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Delete = {
  __typename?: 'CmsFooterFields_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Fields = {
  __typename?: 'CmsFooterFields_disclaimers_Fields'
  align?: Maybe<CmsFooterFields_Disclaimers_Align>
  id?: Maybe<CmsFooterFields_Disclaimers_Id>
  includeAsterick?: Maybe<CmsFooterFields_Disclaimers_IncludeAsterick>
  number?: Maybe<CmsFooterFields_Disclaimers_Number>
  text?: Maybe<CmsFooterFields_Disclaimers_Text>
}

export type CmsFooterFields_Disclaimers_Read = {
  __typename?: 'CmsFooterFields_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Update = {
  __typename?: 'CmsFooterFields_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Align = {
  __typename?: 'CmsFooterFields_disclaimers_align'
  create?: Maybe<CmsFooterFields_Disclaimers_Align_Create>
  delete?: Maybe<CmsFooterFields_Disclaimers_Align_Delete>
  read?: Maybe<CmsFooterFields_Disclaimers_Align_Read>
  update?: Maybe<CmsFooterFields_Disclaimers_Align_Update>
}

export type CmsFooterFields_Disclaimers_Align_Create = {
  __typename?: 'CmsFooterFields_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Align_Delete = {
  __typename?: 'CmsFooterFields_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Align_Read = {
  __typename?: 'CmsFooterFields_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Align_Update = {
  __typename?: 'CmsFooterFields_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Id = {
  __typename?: 'CmsFooterFields_disclaimers_id'
  create?: Maybe<CmsFooterFields_Disclaimers_Id_Create>
  delete?: Maybe<CmsFooterFields_Disclaimers_Id_Delete>
  read?: Maybe<CmsFooterFields_Disclaimers_Id_Read>
  update?: Maybe<CmsFooterFields_Disclaimers_Id_Update>
}

export type CmsFooterFields_Disclaimers_Id_Create = {
  __typename?: 'CmsFooterFields_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Id_Delete = {
  __typename?: 'CmsFooterFields_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Id_Read = {
  __typename?: 'CmsFooterFields_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Id_Update = {
  __typename?: 'CmsFooterFields_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_IncludeAsterick = {
  __typename?: 'CmsFooterFields_disclaimers_includeAsterick'
  create?: Maybe<CmsFooterFields_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<CmsFooterFields_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<CmsFooterFields_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<CmsFooterFields_Disclaimers_IncludeAsterick_Update>
}

export type CmsFooterFields_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'CmsFooterFields_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'CmsFooterFields_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'CmsFooterFields_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'CmsFooterFields_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Number = {
  __typename?: 'CmsFooterFields_disclaimers_number'
  create?: Maybe<CmsFooterFields_Disclaimers_Number_Create>
  delete?: Maybe<CmsFooterFields_Disclaimers_Number_Delete>
  read?: Maybe<CmsFooterFields_Disclaimers_Number_Read>
  update?: Maybe<CmsFooterFields_Disclaimers_Number_Update>
}

export type CmsFooterFields_Disclaimers_Number_Create = {
  __typename?: 'CmsFooterFields_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Number_Delete = {
  __typename?: 'CmsFooterFields_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Number_Read = {
  __typename?: 'CmsFooterFields_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Number_Update = {
  __typename?: 'CmsFooterFields_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Text = {
  __typename?: 'CmsFooterFields_disclaimers_text'
  create?: Maybe<CmsFooterFields_Disclaimers_Text_Create>
  delete?: Maybe<CmsFooterFields_Disclaimers_Text_Delete>
  read?: Maybe<CmsFooterFields_Disclaimers_Text_Read>
  update?: Maybe<CmsFooterFields_Disclaimers_Text_Update>
}

export type CmsFooterFields_Disclaimers_Text_Create = {
  __typename?: 'CmsFooterFields_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Text_Delete = {
  __typename?: 'CmsFooterFields_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Text_Read = {
  __typename?: 'CmsFooterFields_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_Disclaimers_Text_Update = {
  __typename?: 'CmsFooterFields_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns = {
  __typename?: 'CmsFooterFields_footerColumns'
  create?: Maybe<CmsFooterFields_FooterColumns_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_Delete>
  fields?: Maybe<CmsFooterFields_FooterColumns_Fields>
  read?: Maybe<CmsFooterFields_FooterColumns_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_Update>
}

export type CmsFooterFields_FooterColumns_Create = {
  __typename?: 'CmsFooterFields_footerColumns_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_Fields = {
  __typename?: 'CmsFooterFields_footerColumns_Fields'
  id?: Maybe<CmsFooterFields_FooterColumns_Id>
  linkColumns?: Maybe<CmsFooterFields_FooterColumns_LinkColumns>
}

export type CmsFooterFields_FooterColumns_Read = {
  __typename?: 'CmsFooterFields_footerColumns_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_Update = {
  __typename?: 'CmsFooterFields_footerColumns_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_Id = {
  __typename?: 'CmsFooterFields_footerColumns_id'
  create?: Maybe<CmsFooterFields_FooterColumns_Id_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_Id_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_Id_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_Id_Update>
}

export type CmsFooterFields_FooterColumns_Id_Create = {
  __typename?: 'CmsFooterFields_footerColumns_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_Id_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_Id_Read = {
  __typename?: 'CmsFooterFields_footerColumns_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_Id_Update = {
  __typename?: 'CmsFooterFields_footerColumns_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Delete>
  fields?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Fields>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Fields = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_Fields'
  columnTitle?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle>
  links?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_columnTitle'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_columnTitle_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_columnTitle_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_columnTitle_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_ColumnTitle_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_columnTitle_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Delete>
  fields?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Fields>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Fields = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_Fields'
  id?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Id>
  link?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Id = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_id'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Id_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Delete>
  fields?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Fields>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Fields = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_Fields'
  iconAfter?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter>
  iconBefore?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore>
  label?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label>
  newTab?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab>
  query?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query>
  reference?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference>
  reusable?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable>
  targetId?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId>
  type?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type>
  url?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconAfter'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconAfter_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconBefore'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_IconBefore_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_label'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Label_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_newTab'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_NewTab_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Delete>
  fields?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Fields>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Fields = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_Fields'
  id?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id>
  key?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key>
  value?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_id'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Id_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_key'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Key_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_value'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Query_Value_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reference'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reference_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reusable'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Reusable_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_targetId'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_TargetId_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_type'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Type_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_url'
  create?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Create>
  delete?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Delete>
  read?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Read>
  update?: Maybe<CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Update>
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Create = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Delete = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Read = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_FooterColumns_LinkColumns_Links_Link_Url_Update = {
  __typename?: 'CmsFooterFields_footerColumns_linkColumns_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks = {
  __typename?: 'CmsFooterFields_termsLinks'
  create?: Maybe<CmsFooterFields_TermsLinks_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Delete>
  fields?: Maybe<CmsFooterFields_TermsLinks_Fields>
  read?: Maybe<CmsFooterFields_TermsLinks_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Update>
}

export type CmsFooterFields_TermsLinks_Create = {
  __typename?: 'CmsFooterFields_termsLinks_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Fields = {
  __typename?: 'CmsFooterFields_termsLinks_Fields'
  id?: Maybe<CmsFooterFields_TermsLinks_Id>
  link?: Maybe<CmsFooterFields_TermsLinks_Link>
}

export type CmsFooterFields_TermsLinks_Read = {
  __typename?: 'CmsFooterFields_termsLinks_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Update = {
  __typename?: 'CmsFooterFields_termsLinks_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Id = {
  __typename?: 'CmsFooterFields_termsLinks_id'
  create?: Maybe<CmsFooterFields_TermsLinks_Id_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Id_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Id_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Id_Update>
}

export type CmsFooterFields_TermsLinks_Id_Create = {
  __typename?: 'CmsFooterFields_termsLinks_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Id_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Id_Read = {
  __typename?: 'CmsFooterFields_termsLinks_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Id_Update = {
  __typename?: 'CmsFooterFields_termsLinks_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link = {
  __typename?: 'CmsFooterFields_termsLinks_link'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Delete>
  fields?: Maybe<CmsFooterFields_TermsLinks_Link_Fields>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Update>
}

export type CmsFooterFields_TermsLinks_Link_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Fields = {
  __typename?: 'CmsFooterFields_termsLinks_link_Fields'
  iconAfter?: Maybe<CmsFooterFields_TermsLinks_Link_IconAfter>
  iconBefore?: Maybe<CmsFooterFields_TermsLinks_Link_IconBefore>
  label?: Maybe<CmsFooterFields_TermsLinks_Link_Label>
  newTab?: Maybe<CmsFooterFields_TermsLinks_Link_NewTab>
  query?: Maybe<CmsFooterFields_TermsLinks_Link_Query>
  reference?: Maybe<CmsFooterFields_TermsLinks_Link_Reference>
  reusable?: Maybe<CmsFooterFields_TermsLinks_Link_Reusable>
  targetId?: Maybe<CmsFooterFields_TermsLinks_Link_TargetId>
  type?: Maybe<CmsFooterFields_TermsLinks_Link_Type>
  url?: Maybe<CmsFooterFields_TermsLinks_Link_Url>
}

export type CmsFooterFields_TermsLinks_Link_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconAfter = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconAfter'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_IconAfter_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_IconAfter_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_IconAfter_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_IconAfter_Update>
}

export type CmsFooterFields_TermsLinks_Link_IconAfter_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconAfter_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconAfter_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconAfter_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconBefore = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconBefore'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_IconBefore_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_IconBefore_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_IconBefore_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_IconBefore_Update>
}

export type CmsFooterFields_TermsLinks_Link_IconBefore_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconBefore_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconBefore_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_IconBefore_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Label = {
  __typename?: 'CmsFooterFields_termsLinks_link_label'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Label_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Label_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Label_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Label_Update>
}

export type CmsFooterFields_TermsLinks_Link_Label_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Label_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Label_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Label_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_NewTab = {
  __typename?: 'CmsFooterFields_termsLinks_link_newTab'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_NewTab_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_NewTab_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_NewTab_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_NewTab_Update>
}

export type CmsFooterFields_TermsLinks_Link_NewTab_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_NewTab_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_NewTab_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_NewTab_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query = {
  __typename?: 'CmsFooterFields_termsLinks_link_query'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Delete>
  fields?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Fields>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Update>
}

export type CmsFooterFields_TermsLinks_Link_Query_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Fields = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_Fields'
  id?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Id>
  key?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Key>
  value?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Value>
}

export type CmsFooterFields_TermsLinks_Link_Query_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Id = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_id'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Id_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Id_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Id_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Id_Update>
}

export type CmsFooterFields_TermsLinks_Link_Query_Id_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Id_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Id_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Id_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Key = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_key'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Key_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Key_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Key_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Key_Update>
}

export type CmsFooterFields_TermsLinks_Link_Query_Key_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Key_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Key_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Key_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Value = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_value'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Value_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Value_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Value_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Query_Value_Update>
}

export type CmsFooterFields_TermsLinks_Link_Query_Value_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Value_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Value_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Query_Value_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reference = {
  __typename?: 'CmsFooterFields_termsLinks_link_reference'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Reference_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Reference_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Reference_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Reference_Update>
}

export type CmsFooterFields_TermsLinks_Link_Reference_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reference_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reference_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reference_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reusable = {
  __typename?: 'CmsFooterFields_termsLinks_link_reusable'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Reusable_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Reusable_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Reusable_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Reusable_Update>
}

export type CmsFooterFields_TermsLinks_Link_Reusable_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reusable_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reusable_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Reusable_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_TargetId = {
  __typename?: 'CmsFooterFields_termsLinks_link_targetId'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_TargetId_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_TargetId_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_TargetId_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_TargetId_Update>
}

export type CmsFooterFields_TermsLinks_Link_TargetId_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_TargetId_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_TargetId_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_TargetId_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Type = {
  __typename?: 'CmsFooterFields_termsLinks_link_type'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Type_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Type_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Type_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Type_Update>
}

export type CmsFooterFields_TermsLinks_Link_Type_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Type_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Type_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Type_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Url = {
  __typename?: 'CmsFooterFields_termsLinks_link_url'
  create?: Maybe<CmsFooterFields_TermsLinks_Link_Url_Create>
  delete?: Maybe<CmsFooterFields_TermsLinks_Link_Url_Delete>
  read?: Maybe<CmsFooterFields_TermsLinks_Link_Url_Read>
  update?: Maybe<CmsFooterFields_TermsLinks_Link_Url_Update>
}

export type CmsFooterFields_TermsLinks_Link_Url_Create = {
  __typename?: 'CmsFooterFields_termsLinks_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Url_Delete = {
  __typename?: 'CmsFooterFields_termsLinks_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Url_Read = {
  __typename?: 'CmsFooterFields_termsLinks_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_TermsLinks_Link_Url_Update = {
  __typename?: 'CmsFooterFields_termsLinks_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_UpdatedAt = {
  __typename?: 'CmsFooterFields_updatedAt'
  create?: Maybe<CmsFooterFields_UpdatedAt_Create>
  delete?: Maybe<CmsFooterFields_UpdatedAt_Delete>
  read?: Maybe<CmsFooterFields_UpdatedAt_Read>
  update?: Maybe<CmsFooterFields_UpdatedAt_Update>
}

export type CmsFooterFields_UpdatedAt_Create = {
  __typename?: 'CmsFooterFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_UpdatedAt_Delete = {
  __typename?: 'CmsFooterFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_UpdatedAt_Read = {
  __typename?: 'CmsFooterFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterFields_UpdatedAt_Update = {
  __typename?: 'CmsFooterFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsFooterReadAccess = {
  __typename?: 'CmsFooterReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsFooterReadDocAccess = {
  __typename?: 'CmsFooterReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsFooterUpdateAccess = {
  __typename?: 'CmsFooterUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsFooterUpdateDocAccess = {
  __typename?: 'CmsFooterUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export const CmsFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsFooter_Disclaimers_Align_MutationInput =
  (typeof CmsFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsFooter_Disclaimers_Align_MutationInput]
export type CmsFooter_FooterColumns = {
  __typename?: 'CmsFooter_FooterColumns'
  id?: Maybe<Scalars['String']['output']>
  linkColumns?: Maybe<CmsFooter_FooterColumns_LinkColumns>
}

export type CmsFooter_FooterColumns_LinkColumns = {
  __typename?: 'CmsFooter_FooterColumns_LinkColumns'
  columnTitle?: Maybe<Scalars['String']['output']>
  links?: Maybe<Array<CmsFooter_FooterColumns_LinkColumns_Links>>
}

export type CmsFooter_FooterColumns_LinkColumns_Links = {
  __typename?: 'CmsFooter_FooterColumns_LinkColumns_Links'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsFooter_FooterColumns_LinkColumns_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsFooter_FooterColumns_LinkColumns_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsFooter_FooterColumns_LinkColumns_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsFooter_FooterColumns_LinkColumns_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsFooter_FooterColumns_LinkColumns_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsFooter_FooterColumns_LinkColumns_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsFooter_FooterColumns_LinkColumns_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsFooter_FooterColumns_LinkColumns_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsFooter_FooterColumns_LinkColumns_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsFooter_FooterColumns_LinkColumns_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsFooter_FooterColumns_LinkColumns_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsFooter_FooterColumns_LinkColumns_Links_Link_ReusableRelationshipInputRelationTo]
export type CmsFooter_TermsLinks = {
  __typename?: 'CmsFooter_TermsLinks'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsFooter_TermsLinks_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsFooter_TermsLinks_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsFooter_TermsLinks_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsFooter_TermsLinks_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsFooter_TermsLinks_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsFooter_TermsLinks_Link_ReferenceRelationshipInputRelationTo]
export type CmsFooter_TermsLinks_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsFooter_TermsLinks_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsFooter_TermsLinks_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsFooter_TermsLinks_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsFooter_TermsLinks_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsFooter_TermsLinks_Link_ReusableRelationshipInputRelationTo]
export type CmsForm = {
  __typename?: 'CmsForm'
  _status?: Maybe<CmsForm__Status>
  confirmationMessage?: Maybe<Scalars['JSON']['output']>
  confirmationType?: Maybe<CmsForm_ConfirmationType>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['JSON']['output']>
  emails?: Maybe<Array<CmsForm_Emails>>
  fields?: Maybe<Array<CmsForm_Fields>>
  id: Scalars['Int']['output']
  redirect?: Maybe<CmsForm_Redirect>
  slug?: Maybe<Scalars['String']['output']>
  submitButtonLabel?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsFormConfirmationMessageArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsFormDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsFormBlock = {
  __typename?: 'CmsFormBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  form?: Maybe<CmsForm>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsFormBlockFormArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsFormSubmission = {
  __typename?: 'CmsFormSubmission'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  form: CmsForm
  id: Scalars['Int']['output']
  submissionData?: Maybe<Array<CmsFormSubmission_SubmissionData>>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsFormSubmissionFormArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsFormSubmission_SubmissionData = {
  __typename?: 'CmsFormSubmission_SubmissionData'
  field?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type CmsFormSubmission_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsFormSubmission_Form_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsFormSubmission_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsFormSubmission_SubmissionData__Field_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsFormSubmission_SubmissionData__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsFormSubmission_SubmissionData__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsFormSubmission_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsFormSubmission_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsFormSubmission_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsFormSubmission_Where_Or>>>
  createdAt?: InputMaybe<CmsFormSubmission_CreatedAt_Operator>
  form?: InputMaybe<CmsFormSubmission_Form_Operator>
  id?: InputMaybe<CmsFormSubmission_Id_Operator>
  submissionData__field?: InputMaybe<CmsFormSubmission_SubmissionData__Field_Operator>
  submissionData__id?: InputMaybe<CmsFormSubmission_SubmissionData__Id_Operator>
  submissionData__value?: InputMaybe<CmsFormSubmission_SubmissionData__Value_Operator>
  updatedAt?: InputMaybe<CmsFormSubmission_UpdatedAt_Operator>
}

export type CmsFormSubmission_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsFormSubmission_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsFormSubmission_Where_Or>>>
  createdAt?: InputMaybe<CmsFormSubmission_CreatedAt_Operator>
  form?: InputMaybe<CmsFormSubmission_Form_Operator>
  id?: InputMaybe<CmsFormSubmission_Id_Operator>
  submissionData__field?: InputMaybe<CmsFormSubmission_SubmissionData__Field_Operator>
  submissionData__id?: InputMaybe<CmsFormSubmission_SubmissionData__Id_Operator>
  submissionData__value?: InputMaybe<CmsFormSubmission_SubmissionData__Value_Operator>
  updatedAt?: InputMaybe<CmsFormSubmission_UpdatedAt_Operator>
}

export type CmsFormSubmission_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsFormSubmission_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsFormSubmission_Where_Or>>>
  createdAt?: InputMaybe<CmsFormSubmission_CreatedAt_Operator>
  form?: InputMaybe<CmsFormSubmission_Form_Operator>
  id?: InputMaybe<CmsFormSubmission_Id_Operator>
  submissionData__field?: InputMaybe<CmsFormSubmission_SubmissionData__Field_Operator>
  submissionData__id?: InputMaybe<CmsFormSubmission_SubmissionData__Id_Operator>
  submissionData__value?: InputMaybe<CmsFormSubmission_SubmissionData__Value_Operator>
  updatedAt?: InputMaybe<CmsFormSubmission_UpdatedAt_Operator>
}

export type CmsFormSubmissions = {
  __typename?: 'CmsFormSubmissions'
  docs?: Maybe<Array<Maybe<CmsFormSubmission>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsFormUpdate_Redirect_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsFormUpdate_Redirect_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsFormUpdate_Redirect_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsFormUpdate_Redirect_ReferenceRelationshipInputRelationTo =
  (typeof CmsFormUpdate_Redirect_ReferenceRelationshipInputRelationTo)[keyof typeof CmsFormUpdate_Redirect_ReferenceRelationshipInputRelationTo]
export const CmsFormUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsFormUpdate__Status_MutationInput =
  (typeof CmsFormUpdate__Status_MutationInput)[keyof typeof CmsFormUpdate__Status_MutationInput]
export type CmsFormVersion = {
  __typename?: 'CmsFormVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsForm>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsFormVersion_Version>
}

export type CmsFormVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsFormVersion_Version = {
  __typename?: 'CmsFormVersion_Version'
  _status?: Maybe<CmsFormVersion_Version__Status>
  confirmationMessage?: Maybe<Scalars['JSON']['output']>
  confirmationType?: Maybe<CmsFormVersion_Version_ConfirmationType>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['JSON']['output']>
  emails?: Maybe<Array<CmsFormVersion_Version_Emails>>
  fields?: Maybe<Array<CmsFormVersion_Version_Fields>>
  redirect?: Maybe<CmsFormVersion_Version_Redirect>
  slug?: Maybe<Scalars['String']['output']>
  submitButtonLabel?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsFormVersion_VersionConfirmationMessageArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsFormVersion_VersionDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsFormVersion_Version_Emails = {
  __typename?: 'CmsFormVersion_Version_Emails'
  bcc?: Maybe<Scalars['String']['output']>
  cc?: Maybe<Scalars['String']['output']>
  emailFrom?: Maybe<Scalars['String']['output']>
  emailTo?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['JSON']['output']>
  replyTo?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
}

export type CmsFormVersion_Version_EmailsMessageArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsFormVersion_Version_Fields =
  | CmsCheckboxFormField
  | CmsCreditQualityFormField
  | CmsEmailFormField
  | CmsMessageFormField
  | CmsNumberFormField
  | CmsSelectFormField
  | CmsStateFormField
  | CmsTextAreaFormField
  | CmsTextFormField
  | CmsTimeInBusinessFormField

export type CmsFormVersion_Version_Redirect = {
  __typename?: 'CmsFormVersion_Version_Redirect'
  reference?: Maybe<CmsFormVersion_Version_Redirect_Reference_Relationship>
  type?: Maybe<CmsFormVersion_Version_Redirect_Type>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsFormVersion_Version_RedirectReferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsFormVersion_Version_Redirect_Reference =
  | CmsArticle
  | CmsGuide
  | CmsMarketplacePage
  | CmsNewsroomArticle
  | CmsPage
  | CmsStackerPage

export const CmsFormVersion_Version_Redirect_Reference_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsFormVersion_Version_Redirect_Reference_RelationTo =
  (typeof CmsFormVersion_Version_Redirect_Reference_RelationTo)[keyof typeof CmsFormVersion_Version_Redirect_Reference_RelationTo]
export type CmsFormVersion_Version_Redirect_Reference_Relationship = {
  __typename?: 'CmsFormVersion_Version_Redirect_Reference_Relationship'
  relationTo?: Maybe<CmsFormVersion_Version_Redirect_Reference_RelationTo>
  value?: Maybe<CmsFormVersion_Version_Redirect_Reference>
}

export const CmsFormVersion_Version_Redirect_Type = {
  Custom: 'custom',
  Reference: 'reference',
} as const

export type CmsFormVersion_Version_Redirect_Type =
  (typeof CmsFormVersion_Version_Redirect_Type)[keyof typeof CmsFormVersion_Version_Redirect_Type]
export const CmsFormVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsFormVersion_Version__Status =
  (typeof CmsFormVersion_Version__Status)[keyof typeof CmsFormVersion_Version__Status]
export const CmsFormVersion_Version_ConfirmationType = {
  Message: 'message',
  Redirect: 'redirect',
} as const

export type CmsFormVersion_Version_ConfirmationType =
  (typeof CmsFormVersion_Version_ConfirmationType)[keyof typeof CmsFormVersion_Version_ConfirmationType]
export type CmsForm_Emails = {
  __typename?: 'CmsForm_Emails'
  bcc?: Maybe<Scalars['String']['output']>
  cc?: Maybe<Scalars['String']['output']>
  emailFrom?: Maybe<Scalars['String']['output']>
  emailTo?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['JSON']['output']>
  replyTo?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
}

export type CmsForm_EmailsMessageArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsForm_Fields =
  | CmsCheckboxFormField
  | CmsCreditQualityFormField
  | CmsEmailFormField
  | CmsMessageFormField
  | CmsNumberFormField
  | CmsSelectFormField
  | CmsStateFormField
  | CmsTextAreaFormField
  | CmsTextFormField
  | CmsTimeInBusinessFormField

export type CmsForm_Redirect = {
  __typename?: 'CmsForm_Redirect'
  reference?: Maybe<CmsForm_Redirect_Reference_Relationship>
  type?: Maybe<CmsForm_Redirect_Type>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsForm_RedirectReferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsForm_Redirect_Reference =
  | CmsArticle
  | CmsGuide
  | CmsMarketplacePage
  | CmsNewsroomArticle
  | CmsPage
  | CmsStackerPage

export type CmsForm_Redirect_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsForm_Redirect_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsForm_Redirect_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsForm_Redirect_ReferenceRelationshipInputRelationTo =
  (typeof CmsForm_Redirect_ReferenceRelationshipInputRelationTo)[keyof typeof CmsForm_Redirect_ReferenceRelationshipInputRelationTo]
export const CmsForm_Redirect_Reference_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsForm_Redirect_Reference_RelationTo =
  (typeof CmsForm_Redirect_Reference_RelationTo)[keyof typeof CmsForm_Redirect_Reference_RelationTo]
export type CmsForm_Redirect_Reference_Relationship = {
  __typename?: 'CmsForm_Redirect_Reference_Relationship'
  relationTo?: Maybe<CmsForm_Redirect_Reference_RelationTo>
  value?: Maybe<CmsForm_Redirect_Reference>
}

export const CmsForm_Redirect_Type = {
  Custom: 'custom',
  Reference: 'reference',
} as const

export type CmsForm_Redirect_Type = (typeof CmsForm_Redirect_Type)[keyof typeof CmsForm_Redirect_Type]
export const CmsForm__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsForm__Status = (typeof CmsForm__Status)[keyof typeof CmsForm__Status]
export const CmsForm__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsForm__Status_Input = (typeof CmsForm__Status_Input)[keyof typeof CmsForm__Status_Input]
export const CmsForm__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsForm__Status_MutationInput =
  (typeof CmsForm__Status_MutationInput)[keyof typeof CmsForm__Status_MutationInput]
export type CmsForm__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsForm__Status_Input>>>
  equals?: InputMaybe<CmsForm__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsForm__Status_Input>>>
  not_equals?: InputMaybe<CmsForm__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsForm__Status_Input>>>
}

export type CmsForm_ConfirmationMessage_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsForm_ConfirmationType = {
  Message: 'message',
  Redirect: 'redirect',
} as const

export type CmsForm_ConfirmationType = (typeof CmsForm_ConfirmationType)[keyof typeof CmsForm_ConfirmationType]
export const CmsForm_ConfirmationType_Input = {
  Message: 'message',
  Redirect: 'redirect',
} as const

export type CmsForm_ConfirmationType_Input =
  (typeof CmsForm_ConfirmationType_Input)[keyof typeof CmsForm_ConfirmationType_Input]
export type CmsForm_ConfirmationType_Operator = {
  contains?: InputMaybe<CmsForm_ConfirmationType_Input>
  equals?: InputMaybe<CmsForm_ConfirmationType_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsForm_ConfirmationType_Input>
  not_equals?: InputMaybe<CmsForm_ConfirmationType_Input>
}

export type CmsForm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsForm_Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsForm_Emails__Bcc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Emails__Cc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Emails__EmailFrom_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Emails__EmailTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Emails__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Emails__Message_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsForm_Emails__ReplyTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Emails__Subject_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsForm_Redirect__Reference_Relation = {
  relationTo?: InputMaybe<CmsForm_Redirect__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsForm_Redirect__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsForm_Redirect__Reference_Relation_RelationTo =
  (typeof CmsForm_Redirect__Reference_Relation_RelationTo)[keyof typeof CmsForm_Redirect__Reference_Relation_RelationTo]
export const CmsForm_Redirect__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
} as const

export type CmsForm_Redirect__Type_Input =
  (typeof CmsForm_Redirect__Type_Input)[keyof typeof CmsForm_Redirect__Type_Input]
export type CmsForm_Redirect__Type_Operator = {
  contains?: InputMaybe<CmsForm_Redirect__Type_Input>
  equals?: InputMaybe<CmsForm_Redirect__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsForm_Redirect__Type_Input>
  not_equals?: InputMaybe<CmsForm_Redirect__Type_Input>
}

export type CmsForm_Redirect__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_SubmitButtonLabel_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsForm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsForm_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsForm_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsForm_Where_Or>>>
  _status?: InputMaybe<CmsForm__Status_Operator>
  confirmationMessage?: InputMaybe<CmsForm_ConfirmationMessage_Operator>
  confirmationType?: InputMaybe<CmsForm_ConfirmationType_Operator>
  createdAt?: InputMaybe<CmsForm_CreatedAt_Operator>
  description?: InputMaybe<CmsForm_Description_Operator>
  emails__bcc?: InputMaybe<CmsForm_Emails__Bcc_Operator>
  emails__cc?: InputMaybe<CmsForm_Emails__Cc_Operator>
  emails__emailFrom?: InputMaybe<CmsForm_Emails__EmailFrom_Operator>
  emails__emailTo?: InputMaybe<CmsForm_Emails__EmailTo_Operator>
  emails__id?: InputMaybe<CmsForm_Emails__Id_Operator>
  emails__message?: InputMaybe<CmsForm_Emails__Message_Operator>
  emails__replyTo?: InputMaybe<CmsForm_Emails__ReplyTo_Operator>
  emails__subject?: InputMaybe<CmsForm_Emails__Subject_Operator>
  id?: InputMaybe<CmsForm_Id_Operator>
  redirect__reference?: InputMaybe<CmsForm_Redirect__Reference_Relation>
  redirect__type?: InputMaybe<CmsForm_Redirect__Type_Operator>
  redirect__url?: InputMaybe<CmsForm_Redirect__Url_Operator>
  slug?: InputMaybe<CmsForm_Slug_Operator>
  submitButtonLabel?: InputMaybe<CmsForm_SubmitButtonLabel_Operator>
  title?: InputMaybe<CmsForm_Title_Operator>
  updatedAt?: InputMaybe<CmsForm_UpdatedAt_Operator>
}

export type CmsForm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsForm_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsForm_Where_Or>>>
  _status?: InputMaybe<CmsForm__Status_Operator>
  confirmationMessage?: InputMaybe<CmsForm_ConfirmationMessage_Operator>
  confirmationType?: InputMaybe<CmsForm_ConfirmationType_Operator>
  createdAt?: InputMaybe<CmsForm_CreatedAt_Operator>
  description?: InputMaybe<CmsForm_Description_Operator>
  emails__bcc?: InputMaybe<CmsForm_Emails__Bcc_Operator>
  emails__cc?: InputMaybe<CmsForm_Emails__Cc_Operator>
  emails__emailFrom?: InputMaybe<CmsForm_Emails__EmailFrom_Operator>
  emails__emailTo?: InputMaybe<CmsForm_Emails__EmailTo_Operator>
  emails__id?: InputMaybe<CmsForm_Emails__Id_Operator>
  emails__message?: InputMaybe<CmsForm_Emails__Message_Operator>
  emails__replyTo?: InputMaybe<CmsForm_Emails__ReplyTo_Operator>
  emails__subject?: InputMaybe<CmsForm_Emails__Subject_Operator>
  id?: InputMaybe<CmsForm_Id_Operator>
  redirect__reference?: InputMaybe<CmsForm_Redirect__Reference_Relation>
  redirect__type?: InputMaybe<CmsForm_Redirect__Type_Operator>
  redirect__url?: InputMaybe<CmsForm_Redirect__Url_Operator>
  slug?: InputMaybe<CmsForm_Slug_Operator>
  submitButtonLabel?: InputMaybe<CmsForm_SubmitButtonLabel_Operator>
  title?: InputMaybe<CmsForm_Title_Operator>
  updatedAt?: InputMaybe<CmsForm_UpdatedAt_Operator>
}

export type CmsForm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsForm_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsForm_Where_Or>>>
  _status?: InputMaybe<CmsForm__Status_Operator>
  confirmationMessage?: InputMaybe<CmsForm_ConfirmationMessage_Operator>
  confirmationType?: InputMaybe<CmsForm_ConfirmationType_Operator>
  createdAt?: InputMaybe<CmsForm_CreatedAt_Operator>
  description?: InputMaybe<CmsForm_Description_Operator>
  emails__bcc?: InputMaybe<CmsForm_Emails__Bcc_Operator>
  emails__cc?: InputMaybe<CmsForm_Emails__Cc_Operator>
  emails__emailFrom?: InputMaybe<CmsForm_Emails__EmailFrom_Operator>
  emails__emailTo?: InputMaybe<CmsForm_Emails__EmailTo_Operator>
  emails__id?: InputMaybe<CmsForm_Emails__Id_Operator>
  emails__message?: InputMaybe<CmsForm_Emails__Message_Operator>
  emails__replyTo?: InputMaybe<CmsForm_Emails__ReplyTo_Operator>
  emails__subject?: InputMaybe<CmsForm_Emails__Subject_Operator>
  id?: InputMaybe<CmsForm_Id_Operator>
  redirect__reference?: InputMaybe<CmsForm_Redirect__Reference_Relation>
  redirect__type?: InputMaybe<CmsForm_Redirect__Type_Operator>
  redirect__url?: InputMaybe<CmsForm_Redirect__Url_Operator>
  slug?: InputMaybe<CmsForm_Slug_Operator>
  submitButtonLabel?: InputMaybe<CmsForm_SubmitButtonLabel_Operator>
  title?: InputMaybe<CmsForm_Title_Operator>
  updatedAt?: InputMaybe<CmsForm_UpdatedAt_Operator>
}

export type CmsForms = {
  __typename?: 'CmsForms'
  docs?: Maybe<Array<Maybe<CmsForm>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsGuide = {
  __typename?: 'CmsGuide'
  _status?: Maybe<CmsGuide__Status>
  authors?: Maybe<Array<CmsAuthor>>
  chapters?: Maybe<Array<CmsGuide_Chapters>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  header?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  intro?: Maybe<Scalars['JSON']['output']>
  media?: Maybe<CmsMedia>
  meta?: Maybe<CmsMeta>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  timeEstimate?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsGuideHeaderArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsGuideIntroArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsGuideUpdate_Chapters_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsGuideUpdate_Chapters_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsGuideUpdate_Chapters_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsGuideUpdate_Chapters_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsGuideUpdate_Chapters_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsGuideUpdate_Chapters_Link_ReferenceRelationshipInputRelationTo]
export type CmsGuideUpdate_Chapters_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsGuideUpdate_Chapters_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsGuideUpdate_Chapters_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsGuideUpdate_Chapters_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsGuideUpdate_Chapters_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsGuideUpdate_Chapters_Link_ReusableRelationshipInputRelationTo]
export const CmsGuideUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsGuideUpdate__Status_MutationInput =
  (typeof CmsGuideUpdate__Status_MutationInput)[keyof typeof CmsGuideUpdate__Status_MutationInput]
export type CmsGuideVersion = {
  __typename?: 'CmsGuideVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsGuide>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsGuideVersion_Version>
}

export type CmsGuideVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsGuideVersion_Version = {
  __typename?: 'CmsGuideVersion_Version'
  _status?: Maybe<CmsGuideVersion_Version__Status>
  authors?: Maybe<Array<CmsAuthor>>
  chapters?: Maybe<Array<CmsGuideVersion_Version_Chapters>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  header?: Maybe<Scalars['JSON']['output']>
  intro?: Maybe<Scalars['JSON']['output']>
  media?: Maybe<CmsMedia>
  meta?: Maybe<CmsMeta>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  timeEstimate?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsGuideVersion_VersionHeaderArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsGuideVersion_VersionIntroArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsGuideVersion_Version_Chapters = {
  __typename?: 'CmsGuideVersion_Version_Chapters'
  id?: Maybe<Scalars['String']['output']>
  image?: Maybe<CmsMedia>
  link?: Maybe<CmsLink>
  title?: Maybe<Scalars['JSON']['output']>
}

export type CmsGuideVersion_Version_ChaptersTitleArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export const CmsGuideVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsGuideVersion_Version__Status =
  (typeof CmsGuideVersion_Version__Status)[keyof typeof CmsGuideVersion_Version__Status]
export type CmsGuide_Chapters = {
  __typename?: 'CmsGuide_Chapters'
  id?: Maybe<Scalars['String']['output']>
  image?: Maybe<CmsMedia>
  link?: Maybe<CmsLink>
  title?: Maybe<Scalars['JSON']['output']>
}

export type CmsGuide_ChaptersTitleArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsGuide_Chapters_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsGuide_Chapters_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsGuide_Chapters_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsGuide_Chapters_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsGuide_Chapters_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsGuide_Chapters_Link_ReferenceRelationshipInputRelationTo]
export type CmsGuide_Chapters_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsGuide_Chapters_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsGuide_Chapters_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsGuide_Chapters_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsGuide_Chapters_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsGuide_Chapters_Link_ReusableRelationshipInputRelationTo]
export const CmsGuide__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsGuide__Status = (typeof CmsGuide__Status)[keyof typeof CmsGuide__Status]
export const CmsGuide__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsGuide__Status_Input = (typeof CmsGuide__Status_Input)[keyof typeof CmsGuide__Status_Input]
export const CmsGuide__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsGuide__Status_MutationInput =
  (typeof CmsGuide__Status_MutationInput)[keyof typeof CmsGuide__Status_MutationInput]
export type CmsGuide__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsGuide__Status_Input>>>
  equals?: InputMaybe<CmsGuide__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsGuide__Status_Input>>>
  not_equals?: InputMaybe<CmsGuide__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsGuide__Status_Input>>>
}

export type CmsGuide_Authors_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsGuide_Chapters__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsGuide_Chapters__Link__IconAfter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Link__IconBefore_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Link__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Link__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsGuide_Chapters__Link__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Link__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Link__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Link__Reference_Relation = {
  relationTo?: InputMaybe<CmsGuide_Chapters__Link__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsGuide_Chapters__Link__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsGuide_Chapters__Link__Reference_Relation_RelationTo =
  (typeof CmsGuide_Chapters__Link__Reference_Relation_RelationTo)[keyof typeof CmsGuide_Chapters__Link__Reference_Relation_RelationTo]
export type CmsGuide_Chapters__Link__Reusable_Relation = {
  relationTo?: InputMaybe<CmsGuide_Chapters__Link__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsGuide_Chapters__Link__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsGuide_Chapters__Link__Reusable_Relation_RelationTo =
  (typeof CmsGuide_Chapters__Link__Reusable_Relation_RelationTo)[keyof typeof CmsGuide_Chapters__Link__Reusable_Relation_RelationTo]
export type CmsGuide_Chapters__Link__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsGuide_Chapters__Link__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsGuide_Chapters__Link__Type_Input =
  (typeof CmsGuide_Chapters__Link__Type_Input)[keyof typeof CmsGuide_Chapters__Link__Type_Input]
export type CmsGuide_Chapters__Link__Type_Operator = {
  contains?: InputMaybe<CmsGuide_Chapters__Link__Type_Input>
  equals?: InputMaybe<CmsGuide_Chapters__Link__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsGuide_Chapters__Link__Type_Input>
  not_equals?: InputMaybe<CmsGuide_Chapters__Link__Type_Input>
}

export type CmsGuide_Chapters__Link__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Chapters__Title_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsGuide_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsGuide_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsGuide_Header_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsGuide_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsGuide_Intro_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsGuide_Media_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsGuide_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsGuide_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsGuide_Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsGuide_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsGuide_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsGuide_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_TimeEstimate_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsGuide_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsGuide_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsGuide_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsGuide_Where_Or>>>
  _status?: InputMaybe<CmsGuide__Status_Operator>
  authors?: InputMaybe<CmsGuide_Authors_Operator>
  chapters__id?: InputMaybe<CmsGuide_Chapters__Id_Operator>
  chapters__image?: InputMaybe<CmsGuide_Chapters__Image_Operator>
  chapters__link__iconAfter?: InputMaybe<CmsGuide_Chapters__Link__IconAfter_Operator>
  chapters__link__iconBefore?: InputMaybe<CmsGuide_Chapters__Link__IconBefore_Operator>
  chapters__link__label?: InputMaybe<CmsGuide_Chapters__Link__Label_Operator>
  chapters__link__newTab?: InputMaybe<CmsGuide_Chapters__Link__NewTab_Operator>
  chapters__link__query__id?: InputMaybe<CmsGuide_Chapters__Link__Query__Id_Operator>
  chapters__link__query__key?: InputMaybe<CmsGuide_Chapters__Link__Query__Key_Operator>
  chapters__link__query__value?: InputMaybe<CmsGuide_Chapters__Link__Query__Value_Operator>
  chapters__link__reference?: InputMaybe<CmsGuide_Chapters__Link__Reference_Relation>
  chapters__link__reusable?: InputMaybe<CmsGuide_Chapters__Link__Reusable_Relation>
  chapters__link__targetId?: InputMaybe<CmsGuide_Chapters__Link__TargetId_Operator>
  chapters__link__type?: InputMaybe<CmsGuide_Chapters__Link__Type_Operator>
  chapters__link__url?: InputMaybe<CmsGuide_Chapters__Link__Url_Operator>
  chapters__title?: InputMaybe<CmsGuide_Chapters__Title_Operator>
  createdAt?: InputMaybe<CmsGuide_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsGuide_CreatedBy_Operator>
  header?: InputMaybe<CmsGuide_Header_Operator>
  id?: InputMaybe<CmsGuide_Id_Operator>
  intro?: InputMaybe<CmsGuide_Intro_Operator>
  media?: InputMaybe<CmsGuide_Media_Operator>
  meta__description?: InputMaybe<CmsGuide_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsGuide_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsGuide_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsGuide_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsGuide_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsGuide_PublishedAt_Operator>
  slug?: InputMaybe<CmsGuide_Slug_Operator>
  timeEstimate?: InputMaybe<CmsGuide_TimeEstimate_Operator>
  title?: InputMaybe<CmsGuide_Title_Operator>
  updatedAt?: InputMaybe<CmsGuide_UpdatedAt_Operator>
}

export type CmsGuide_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsGuide_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsGuide_Where_Or>>>
  _status?: InputMaybe<CmsGuide__Status_Operator>
  authors?: InputMaybe<CmsGuide_Authors_Operator>
  chapters__id?: InputMaybe<CmsGuide_Chapters__Id_Operator>
  chapters__image?: InputMaybe<CmsGuide_Chapters__Image_Operator>
  chapters__link__iconAfter?: InputMaybe<CmsGuide_Chapters__Link__IconAfter_Operator>
  chapters__link__iconBefore?: InputMaybe<CmsGuide_Chapters__Link__IconBefore_Operator>
  chapters__link__label?: InputMaybe<CmsGuide_Chapters__Link__Label_Operator>
  chapters__link__newTab?: InputMaybe<CmsGuide_Chapters__Link__NewTab_Operator>
  chapters__link__query__id?: InputMaybe<CmsGuide_Chapters__Link__Query__Id_Operator>
  chapters__link__query__key?: InputMaybe<CmsGuide_Chapters__Link__Query__Key_Operator>
  chapters__link__query__value?: InputMaybe<CmsGuide_Chapters__Link__Query__Value_Operator>
  chapters__link__reference?: InputMaybe<CmsGuide_Chapters__Link__Reference_Relation>
  chapters__link__reusable?: InputMaybe<CmsGuide_Chapters__Link__Reusable_Relation>
  chapters__link__targetId?: InputMaybe<CmsGuide_Chapters__Link__TargetId_Operator>
  chapters__link__type?: InputMaybe<CmsGuide_Chapters__Link__Type_Operator>
  chapters__link__url?: InputMaybe<CmsGuide_Chapters__Link__Url_Operator>
  chapters__title?: InputMaybe<CmsGuide_Chapters__Title_Operator>
  createdAt?: InputMaybe<CmsGuide_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsGuide_CreatedBy_Operator>
  header?: InputMaybe<CmsGuide_Header_Operator>
  id?: InputMaybe<CmsGuide_Id_Operator>
  intro?: InputMaybe<CmsGuide_Intro_Operator>
  media?: InputMaybe<CmsGuide_Media_Operator>
  meta__description?: InputMaybe<CmsGuide_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsGuide_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsGuide_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsGuide_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsGuide_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsGuide_PublishedAt_Operator>
  slug?: InputMaybe<CmsGuide_Slug_Operator>
  timeEstimate?: InputMaybe<CmsGuide_TimeEstimate_Operator>
  title?: InputMaybe<CmsGuide_Title_Operator>
  updatedAt?: InputMaybe<CmsGuide_UpdatedAt_Operator>
}

export type CmsGuide_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsGuide_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsGuide_Where_Or>>>
  _status?: InputMaybe<CmsGuide__Status_Operator>
  authors?: InputMaybe<CmsGuide_Authors_Operator>
  chapters__id?: InputMaybe<CmsGuide_Chapters__Id_Operator>
  chapters__image?: InputMaybe<CmsGuide_Chapters__Image_Operator>
  chapters__link__iconAfter?: InputMaybe<CmsGuide_Chapters__Link__IconAfter_Operator>
  chapters__link__iconBefore?: InputMaybe<CmsGuide_Chapters__Link__IconBefore_Operator>
  chapters__link__label?: InputMaybe<CmsGuide_Chapters__Link__Label_Operator>
  chapters__link__newTab?: InputMaybe<CmsGuide_Chapters__Link__NewTab_Operator>
  chapters__link__query__id?: InputMaybe<CmsGuide_Chapters__Link__Query__Id_Operator>
  chapters__link__query__key?: InputMaybe<CmsGuide_Chapters__Link__Query__Key_Operator>
  chapters__link__query__value?: InputMaybe<CmsGuide_Chapters__Link__Query__Value_Operator>
  chapters__link__reference?: InputMaybe<CmsGuide_Chapters__Link__Reference_Relation>
  chapters__link__reusable?: InputMaybe<CmsGuide_Chapters__Link__Reusable_Relation>
  chapters__link__targetId?: InputMaybe<CmsGuide_Chapters__Link__TargetId_Operator>
  chapters__link__type?: InputMaybe<CmsGuide_Chapters__Link__Type_Operator>
  chapters__link__url?: InputMaybe<CmsGuide_Chapters__Link__Url_Operator>
  chapters__title?: InputMaybe<CmsGuide_Chapters__Title_Operator>
  createdAt?: InputMaybe<CmsGuide_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsGuide_CreatedBy_Operator>
  header?: InputMaybe<CmsGuide_Header_Operator>
  id?: InputMaybe<CmsGuide_Id_Operator>
  intro?: InputMaybe<CmsGuide_Intro_Operator>
  media?: InputMaybe<CmsGuide_Media_Operator>
  meta__description?: InputMaybe<CmsGuide_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsGuide_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsGuide_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsGuide_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsGuide_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsGuide_PublishedAt_Operator>
  slug?: InputMaybe<CmsGuide_Slug_Operator>
  timeEstimate?: InputMaybe<CmsGuide_TimeEstimate_Operator>
  title?: InputMaybe<CmsGuide_Title_Operator>
  updatedAt?: InputMaybe<CmsGuide_UpdatedAt_Operator>
}

export type CmsGuides = {
  __typename?: 'CmsGuides'
  docs?: Maybe<Array<Maybe<CmsGuide>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsHeader = {
  __typename?: 'CmsHeader'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  loginLink?: Maybe<CmsLink>
  nav?: Maybe<Array<CmsHeader_Nav>>
  signupLink?: Maybe<CmsLink>
  supportLink?: Maybe<CmsLink>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsHeaderDocAccessFields = {
  __typename?: 'CmsHeaderDocAccessFields'
  createdAt?: Maybe<CmsHeaderDocAccessFields_CreatedAt>
  loginLink?: Maybe<CmsHeaderDocAccessFields_LoginLink>
  nav?: Maybe<CmsHeaderDocAccessFields_Nav>
  signupLink?: Maybe<CmsHeaderDocAccessFields_SignupLink>
  supportLink?: Maybe<CmsHeaderDocAccessFields_SupportLink>
  updatedAt?: Maybe<CmsHeaderDocAccessFields_UpdatedAt>
}

export type CmsHeaderDocAccessFields_CreatedAt = {
  __typename?: 'CmsHeaderDocAccessFields_createdAt'
  create?: Maybe<CmsHeaderDocAccessFields_CreatedAt_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_CreatedAt_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_CreatedAt_Read>
  update?: Maybe<CmsHeaderDocAccessFields_CreatedAt_Update>
}

export type CmsHeaderDocAccessFields_CreatedAt_Create = {
  __typename?: 'CmsHeaderDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_CreatedAt_Read = {
  __typename?: 'CmsHeaderDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_CreatedAt_Update = {
  __typename?: 'CmsHeaderDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_LoginLink_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_Fields'
  newTab?: Maybe<CmsHeaderDocAccessFields_LoginLink_NewTab>
  query?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query>
  reference?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reference>
  reusable?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reusable>
  targetId?: Maybe<CmsHeaderDocAccessFields_LoginLink_TargetId>
  type?: Maybe<CmsHeaderDocAccessFields_LoginLink_Type>
  url?: Maybe<CmsHeaderDocAccessFields_LoginLink_Url>
}

export type CmsHeaderDocAccessFields_LoginLink_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_NewTab = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_newTab'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_NewTab_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_NewTab_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_NewTab_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_NewTab_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_NewTab_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_NewTab_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_NewTab_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_NewTab_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_Fields'
  id?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Id>
  key?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Key>
  value?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Value>
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Id = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_id'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Id_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Key = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_key'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Key_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Key_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Key_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Key_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Key_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Key_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Key_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Key_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Value = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_value'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Value_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Value_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Value_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Query_Value_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Value_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Value_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Value_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Query_Value_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reference = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reference'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reference_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reference_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reference_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reference_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Reference_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reference_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reference_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reference_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reusable = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reusable'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reusable_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reusable_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reusable_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Reusable_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Reusable_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reusable_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reusable_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Reusable_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_TargetId = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_targetId'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_TargetId_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_TargetId_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_TargetId_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_TargetId_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_TargetId_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_TargetId_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_TargetId_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_TargetId_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Type = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_type'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Type_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Type_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Type_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Type_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Type_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Type_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Type_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Type_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Url = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_url'
  create?: Maybe<CmsHeaderDocAccessFields_LoginLink_Url_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_LoginLink_Url_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_LoginLink_Url_Read>
  update?: Maybe<CmsHeaderDocAccessFields_LoginLink_Url_Update>
}

export type CmsHeaderDocAccessFields_LoginLink_Url_Create = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Url_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Url_Read = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_LoginLink_Url_Update = {
  __typename?: 'CmsHeaderDocAccessFields_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav = {
  __typename?: 'CmsHeaderDocAccessFields_nav'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Update>
}

export type CmsHeaderDocAccessFields_Nav_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_Fields'
  id?: Maybe<CmsHeaderDocAccessFields_Nav_Id>
  link?: Maybe<CmsHeaderDocAccessFields_Nav_Link>
  submenu?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu>
  title?: Maybe<CmsHeaderDocAccessFields_Nav_Title>
  type?: Maybe<CmsHeaderDocAccessFields_Nav_Type>
}

export type CmsHeaderDocAccessFields_Nav_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Id = {
  __typename?: 'CmsHeaderDocAccessFields_nav_id'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Id_Update>
}

export type CmsHeaderDocAccessFields_Nav_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_Fields'
  label?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Label>
  newTab?: Maybe<CmsHeaderDocAccessFields_Nav_Link_NewTab>
  query?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query>
  reference?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reference>
  reusable?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reusable>
  targetId?: Maybe<CmsHeaderDocAccessFields_Nav_Link_TargetId>
  type?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Type>
  url?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Url>
}

export type CmsHeaderDocAccessFields_Nav_Link_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Label = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_label'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Label_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Label_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Label_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Label_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Label_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Label_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Label_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Label_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_NewTab = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_newTab'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_NewTab_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_NewTab_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_NewTab_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_NewTab_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_NewTab_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_NewTab_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_NewTab_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_NewTab_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_Fields'
  id?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Id>
  key?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Key>
  value?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Value>
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Id = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_id'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Id_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Key = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_key'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Key_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Key_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Key_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Key_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Key_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Key_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Key_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Key_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Value = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_value'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Value_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Value_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Value_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Query_Value_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Value_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Value_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Value_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Query_Value_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reference = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reference'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reference_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reference_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reference_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reference_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Reference_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reference_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reference_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reference_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reusable = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reusable'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reusable_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reusable_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reusable_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Reusable_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Reusable_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reusable_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reusable_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Reusable_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_TargetId = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_targetId'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_TargetId_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_TargetId_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_TargetId_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_TargetId_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_TargetId_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_TargetId_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_TargetId_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_TargetId_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Type = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_type'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Type_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Type_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Type_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Type_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Type_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Type_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Type_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Type_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Url = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_url'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Url_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Url_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Url_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Link_Url_Update>
}

export type CmsHeaderDocAccessFields_Nav_Link_Url_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Url_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Url_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Link_Url_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_Fields'
  categories?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_Fields'
  id?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id>
  items?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items>
  name?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_id'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_Fields'
  description?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description>
  id?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id>
  link?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link>
  title?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_description'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_description_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_description_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Description_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_description_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_id'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_Fields'
  iconAfter?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter>
  iconBefore?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore>
  newTab?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab>
  query?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query>
  reference?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference>
  reusable?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable>
  targetId?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId>
  type?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type>
  url?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url>
  variant?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconAfter'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconAfter_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconBefore'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_IconBefore_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_newTab'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_NewTab_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_Fields'
  id?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id>
  key?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key>
  value?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_id'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_key'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Key_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_value'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Query_Value_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reference'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reference_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reusable'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Reusable_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_targetId'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_TargetId_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_type'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Type_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_url'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Url_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_variant'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Link_Variant_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_title'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Items_Title_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_items_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_name'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Update>
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_name_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_name_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Submenu_Categories_Name_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_submenu_categories_name_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Title = {
  __typename?: 'CmsHeaderDocAccessFields_nav_title'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Title_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Title_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Title_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Title_Update>
}

export type CmsHeaderDocAccessFields_Nav_Title_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Title_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Title_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Title_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Type = {
  __typename?: 'CmsHeaderDocAccessFields_nav_type'
  create?: Maybe<CmsHeaderDocAccessFields_Nav_Type_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_Nav_Type_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_Nav_Type_Read>
  update?: Maybe<CmsHeaderDocAccessFields_Nav_Type_Update>
}

export type CmsHeaderDocAccessFields_Nav_Type_Create = {
  __typename?: 'CmsHeaderDocAccessFields_nav_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Type_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_nav_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Type_Read = {
  __typename?: 'CmsHeaderDocAccessFields_nav_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_Nav_Type_Update = {
  __typename?: 'CmsHeaderDocAccessFields_nav_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_SignupLink_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_Fields'
  newTab?: Maybe<CmsHeaderDocAccessFields_SignupLink_NewTab>
  query?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query>
  reference?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reference>
  reusable?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reusable>
  targetId?: Maybe<CmsHeaderDocAccessFields_SignupLink_TargetId>
  type?: Maybe<CmsHeaderDocAccessFields_SignupLink_Type>
  url?: Maybe<CmsHeaderDocAccessFields_SignupLink_Url>
}

export type CmsHeaderDocAccessFields_SignupLink_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_NewTab = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_newTab'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_NewTab_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_NewTab_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_NewTab_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_NewTab_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_NewTab_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_NewTab_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_NewTab_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_NewTab_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_Fields'
  id?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Id>
  key?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Key>
  value?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Value>
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Id = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_id'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Id_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Key = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_key'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Key_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Key_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Key_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Key_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Key_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Key_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Key_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Key_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Value = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_value'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Value_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Value_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Value_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Query_Value_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Value_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Value_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Value_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Query_Value_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reference = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reference'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reference_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reference_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reference_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reference_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Reference_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reference_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reference_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reference_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reusable = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reusable'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reusable_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reusable_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reusable_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Reusable_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Reusable_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reusable_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reusable_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Reusable_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_TargetId = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_targetId'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_TargetId_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_TargetId_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_TargetId_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_TargetId_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_TargetId_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_TargetId_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_TargetId_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_TargetId_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Type = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_type'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Type_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Type_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Type_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Type_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Type_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Type_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Type_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Type_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Url = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_url'
  create?: Maybe<CmsHeaderDocAccessFields_SignupLink_Url_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SignupLink_Url_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SignupLink_Url_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SignupLink_Url_Update>
}

export type CmsHeaderDocAccessFields_SignupLink_Url_Create = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Url_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Url_Read = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SignupLink_Url_Update = {
  __typename?: 'CmsHeaderDocAccessFields_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_SupportLink_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_Fields'
  newTab?: Maybe<CmsHeaderDocAccessFields_SupportLink_NewTab>
  query?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query>
  reference?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reference>
  reusable?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reusable>
  targetId?: Maybe<CmsHeaderDocAccessFields_SupportLink_TargetId>
  type?: Maybe<CmsHeaderDocAccessFields_SupportLink_Type>
  url?: Maybe<CmsHeaderDocAccessFields_SupportLink_Url>
}

export type CmsHeaderDocAccessFields_SupportLink_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_NewTab = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_newTab'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_NewTab_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_NewTab_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_NewTab_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_NewTab_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_NewTab_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_NewTab_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_NewTab_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_NewTab_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Delete>
  fields?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Fields>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Fields = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_Fields'
  id?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Id>
  key?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Key>
  value?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Value>
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Id = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_id'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Id_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Id_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Id_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Id_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Id_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Id_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Id_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Id_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Key = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_key'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Key_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Key_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Key_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Key_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Key_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Key_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Key_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Key_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Value = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_value'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Value_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Value_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Value_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Query_Value_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Value_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Value_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Value_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Query_Value_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reference = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reference'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reference_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reference_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reference_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reference_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Reference_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reference_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reference_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reference_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reusable = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reusable'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reusable_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reusable_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reusable_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Reusable_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Reusable_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reusable_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reusable_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Reusable_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_TargetId = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_targetId'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_TargetId_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_TargetId_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_TargetId_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_TargetId_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_TargetId_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_TargetId_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_TargetId_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_TargetId_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Type = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_type'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Type_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Type_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Type_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Type_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Type_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Type_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Type_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Type_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Url = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_url'
  create?: Maybe<CmsHeaderDocAccessFields_SupportLink_Url_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_SupportLink_Url_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_SupportLink_Url_Read>
  update?: Maybe<CmsHeaderDocAccessFields_SupportLink_Url_Update>
}

export type CmsHeaderDocAccessFields_SupportLink_Url_Create = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Url_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Url_Read = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_SupportLink_Url_Update = {
  __typename?: 'CmsHeaderDocAccessFields_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_UpdatedAt = {
  __typename?: 'CmsHeaderDocAccessFields_updatedAt'
  create?: Maybe<CmsHeaderDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<CmsHeaderDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<CmsHeaderDocAccessFields_UpdatedAt_Read>
  update?: Maybe<CmsHeaderDocAccessFields_UpdatedAt_Update>
}

export type CmsHeaderDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CmsHeaderDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CmsHeaderDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CmsHeaderDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CmsHeaderDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields = {
  __typename?: 'CmsHeaderFields'
  createdAt?: Maybe<CmsHeaderFields_CreatedAt>
  loginLink?: Maybe<CmsHeaderFields_LoginLink>
  nav?: Maybe<CmsHeaderFields_Nav>
  signupLink?: Maybe<CmsHeaderFields_SignupLink>
  supportLink?: Maybe<CmsHeaderFields_SupportLink>
  updatedAt?: Maybe<CmsHeaderFields_UpdatedAt>
}

export type CmsHeaderFields_CreatedAt = {
  __typename?: 'CmsHeaderFields_createdAt'
  create?: Maybe<CmsHeaderFields_CreatedAt_Create>
  delete?: Maybe<CmsHeaderFields_CreatedAt_Delete>
  read?: Maybe<CmsHeaderFields_CreatedAt_Read>
  update?: Maybe<CmsHeaderFields_CreatedAt_Update>
}

export type CmsHeaderFields_CreatedAt_Create = {
  __typename?: 'CmsHeaderFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_CreatedAt_Delete = {
  __typename?: 'CmsHeaderFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_CreatedAt_Read = {
  __typename?: 'CmsHeaderFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_CreatedAt_Update = {
  __typename?: 'CmsHeaderFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink = {
  __typename?: 'CmsHeaderFields_loginLink'
  create?: Maybe<CmsHeaderFields_LoginLink_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Delete>
  fields?: Maybe<CmsHeaderFields_LoginLink_Fields>
  read?: Maybe<CmsHeaderFields_LoginLink_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Update>
}

export type CmsHeaderFields_LoginLink_Create = {
  __typename?: 'CmsHeaderFields_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Fields = {
  __typename?: 'CmsHeaderFields_loginLink_Fields'
  newTab?: Maybe<CmsHeaderFields_LoginLink_NewTab>
  query?: Maybe<CmsHeaderFields_LoginLink_Query>
  reference?: Maybe<CmsHeaderFields_LoginLink_Reference>
  reusable?: Maybe<CmsHeaderFields_LoginLink_Reusable>
  targetId?: Maybe<CmsHeaderFields_LoginLink_TargetId>
  type?: Maybe<CmsHeaderFields_LoginLink_Type>
  url?: Maybe<CmsHeaderFields_LoginLink_Url>
}

export type CmsHeaderFields_LoginLink_Read = {
  __typename?: 'CmsHeaderFields_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Update = {
  __typename?: 'CmsHeaderFields_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_NewTab = {
  __typename?: 'CmsHeaderFields_loginLink_newTab'
  create?: Maybe<CmsHeaderFields_LoginLink_NewTab_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_NewTab_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_NewTab_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_NewTab_Update>
}

export type CmsHeaderFields_LoginLink_NewTab_Create = {
  __typename?: 'CmsHeaderFields_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_NewTab_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_NewTab_Read = {
  __typename?: 'CmsHeaderFields_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_NewTab_Update = {
  __typename?: 'CmsHeaderFields_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query = {
  __typename?: 'CmsHeaderFields_loginLink_query'
  create?: Maybe<CmsHeaderFields_LoginLink_Query_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Query_Delete>
  fields?: Maybe<CmsHeaderFields_LoginLink_Query_Fields>
  read?: Maybe<CmsHeaderFields_LoginLink_Query_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Query_Update>
}

export type CmsHeaderFields_LoginLink_Query_Create = {
  __typename?: 'CmsHeaderFields_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Fields = {
  __typename?: 'CmsHeaderFields_loginLink_query_Fields'
  id?: Maybe<CmsHeaderFields_LoginLink_Query_Id>
  key?: Maybe<CmsHeaderFields_LoginLink_Query_Key>
  value?: Maybe<CmsHeaderFields_LoginLink_Query_Value>
}

export type CmsHeaderFields_LoginLink_Query_Read = {
  __typename?: 'CmsHeaderFields_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Update = {
  __typename?: 'CmsHeaderFields_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Id = {
  __typename?: 'CmsHeaderFields_loginLink_query_id'
  create?: Maybe<CmsHeaderFields_LoginLink_Query_Id_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Query_Id_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_Query_Id_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Query_Id_Update>
}

export type CmsHeaderFields_LoginLink_Query_Id_Create = {
  __typename?: 'CmsHeaderFields_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Id_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Id_Read = {
  __typename?: 'CmsHeaderFields_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Id_Update = {
  __typename?: 'CmsHeaderFields_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Key = {
  __typename?: 'CmsHeaderFields_loginLink_query_key'
  create?: Maybe<CmsHeaderFields_LoginLink_Query_Key_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Query_Key_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_Query_Key_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Query_Key_Update>
}

export type CmsHeaderFields_LoginLink_Query_Key_Create = {
  __typename?: 'CmsHeaderFields_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Key_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Key_Read = {
  __typename?: 'CmsHeaderFields_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Key_Update = {
  __typename?: 'CmsHeaderFields_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Value = {
  __typename?: 'CmsHeaderFields_loginLink_query_value'
  create?: Maybe<CmsHeaderFields_LoginLink_Query_Value_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Query_Value_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_Query_Value_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Query_Value_Update>
}

export type CmsHeaderFields_LoginLink_Query_Value_Create = {
  __typename?: 'CmsHeaderFields_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Value_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Value_Read = {
  __typename?: 'CmsHeaderFields_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Query_Value_Update = {
  __typename?: 'CmsHeaderFields_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reference = {
  __typename?: 'CmsHeaderFields_loginLink_reference'
  create?: Maybe<CmsHeaderFields_LoginLink_Reference_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Reference_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_Reference_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Reference_Update>
}

export type CmsHeaderFields_LoginLink_Reference_Create = {
  __typename?: 'CmsHeaderFields_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reference_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reference_Read = {
  __typename?: 'CmsHeaderFields_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reference_Update = {
  __typename?: 'CmsHeaderFields_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reusable = {
  __typename?: 'CmsHeaderFields_loginLink_reusable'
  create?: Maybe<CmsHeaderFields_LoginLink_Reusable_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Reusable_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_Reusable_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Reusable_Update>
}

export type CmsHeaderFields_LoginLink_Reusable_Create = {
  __typename?: 'CmsHeaderFields_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reusable_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reusable_Read = {
  __typename?: 'CmsHeaderFields_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Reusable_Update = {
  __typename?: 'CmsHeaderFields_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_TargetId = {
  __typename?: 'CmsHeaderFields_loginLink_targetId'
  create?: Maybe<CmsHeaderFields_LoginLink_TargetId_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_TargetId_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_TargetId_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_TargetId_Update>
}

export type CmsHeaderFields_LoginLink_TargetId_Create = {
  __typename?: 'CmsHeaderFields_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_TargetId_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_TargetId_Read = {
  __typename?: 'CmsHeaderFields_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_TargetId_Update = {
  __typename?: 'CmsHeaderFields_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Type = {
  __typename?: 'CmsHeaderFields_loginLink_type'
  create?: Maybe<CmsHeaderFields_LoginLink_Type_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Type_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_Type_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Type_Update>
}

export type CmsHeaderFields_LoginLink_Type_Create = {
  __typename?: 'CmsHeaderFields_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Type_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Type_Read = {
  __typename?: 'CmsHeaderFields_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Type_Update = {
  __typename?: 'CmsHeaderFields_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Url = {
  __typename?: 'CmsHeaderFields_loginLink_url'
  create?: Maybe<CmsHeaderFields_LoginLink_Url_Create>
  delete?: Maybe<CmsHeaderFields_LoginLink_Url_Delete>
  read?: Maybe<CmsHeaderFields_LoginLink_Url_Read>
  update?: Maybe<CmsHeaderFields_LoginLink_Url_Update>
}

export type CmsHeaderFields_LoginLink_Url_Create = {
  __typename?: 'CmsHeaderFields_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Url_Delete = {
  __typename?: 'CmsHeaderFields_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Url_Read = {
  __typename?: 'CmsHeaderFields_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_LoginLink_Url_Update = {
  __typename?: 'CmsHeaderFields_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav = {
  __typename?: 'CmsHeaderFields_nav'
  create?: Maybe<CmsHeaderFields_Nav_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Read>
  update?: Maybe<CmsHeaderFields_Nav_Update>
}

export type CmsHeaderFields_Nav_Create = {
  __typename?: 'CmsHeaderFields_nav_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Delete = {
  __typename?: 'CmsHeaderFields_nav_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Fields = {
  __typename?: 'CmsHeaderFields_nav_Fields'
  id?: Maybe<CmsHeaderFields_Nav_Id>
  link?: Maybe<CmsHeaderFields_Nav_Link>
  submenu?: Maybe<CmsHeaderFields_Nav_Submenu>
  title?: Maybe<CmsHeaderFields_Nav_Title>
  type?: Maybe<CmsHeaderFields_Nav_Type>
}

export type CmsHeaderFields_Nav_Read = {
  __typename?: 'CmsHeaderFields_nav_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Update = {
  __typename?: 'CmsHeaderFields_nav_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Id = {
  __typename?: 'CmsHeaderFields_nav_id'
  create?: Maybe<CmsHeaderFields_Nav_Id_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Id_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Id_Read>
  update?: Maybe<CmsHeaderFields_Nav_Id_Update>
}

export type CmsHeaderFields_Nav_Id_Create = {
  __typename?: 'CmsHeaderFields_nav_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Id_Delete = {
  __typename?: 'CmsHeaderFields_nav_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Id_Read = {
  __typename?: 'CmsHeaderFields_nav_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Id_Update = {
  __typename?: 'CmsHeaderFields_nav_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link = {
  __typename?: 'CmsHeaderFields_nav_link'
  create?: Maybe<CmsHeaderFields_Nav_Link_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Link_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Link_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Update>
}

export type CmsHeaderFields_Nav_Link_Create = {
  __typename?: 'CmsHeaderFields_nav_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Fields = {
  __typename?: 'CmsHeaderFields_nav_link_Fields'
  label?: Maybe<CmsHeaderFields_Nav_Link_Label>
  newTab?: Maybe<CmsHeaderFields_Nav_Link_NewTab>
  query?: Maybe<CmsHeaderFields_Nav_Link_Query>
  reference?: Maybe<CmsHeaderFields_Nav_Link_Reference>
  reusable?: Maybe<CmsHeaderFields_Nav_Link_Reusable>
  targetId?: Maybe<CmsHeaderFields_Nav_Link_TargetId>
  type?: Maybe<CmsHeaderFields_Nav_Link_Type>
  url?: Maybe<CmsHeaderFields_Nav_Link_Url>
}

export type CmsHeaderFields_Nav_Link_Read = {
  __typename?: 'CmsHeaderFields_nav_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Update = {
  __typename?: 'CmsHeaderFields_nav_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Label = {
  __typename?: 'CmsHeaderFields_nav_link_label'
  create?: Maybe<CmsHeaderFields_Nav_Link_Label_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Label_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Label_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Label_Update>
}

export type CmsHeaderFields_Nav_Link_Label_Create = {
  __typename?: 'CmsHeaderFields_nav_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Label_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Label_Read = {
  __typename?: 'CmsHeaderFields_nav_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Label_Update = {
  __typename?: 'CmsHeaderFields_nav_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_NewTab = {
  __typename?: 'CmsHeaderFields_nav_link_newTab'
  create?: Maybe<CmsHeaderFields_Nav_Link_NewTab_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_NewTab_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_NewTab_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_NewTab_Update>
}

export type CmsHeaderFields_Nav_Link_NewTab_Create = {
  __typename?: 'CmsHeaderFields_nav_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_NewTab_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_NewTab_Read = {
  __typename?: 'CmsHeaderFields_nav_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_NewTab_Update = {
  __typename?: 'CmsHeaderFields_nav_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query = {
  __typename?: 'CmsHeaderFields_nav_link_query'
  create?: Maybe<CmsHeaderFields_Nav_Link_Query_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Query_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Link_Query_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Link_Query_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Query_Update>
}

export type CmsHeaderFields_Nav_Link_Query_Create = {
  __typename?: 'CmsHeaderFields_nav_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Fields = {
  __typename?: 'CmsHeaderFields_nav_link_query_Fields'
  id?: Maybe<CmsHeaderFields_Nav_Link_Query_Id>
  key?: Maybe<CmsHeaderFields_Nav_Link_Query_Key>
  value?: Maybe<CmsHeaderFields_Nav_Link_Query_Value>
}

export type CmsHeaderFields_Nav_Link_Query_Read = {
  __typename?: 'CmsHeaderFields_nav_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Update = {
  __typename?: 'CmsHeaderFields_nav_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Id = {
  __typename?: 'CmsHeaderFields_nav_link_query_id'
  create?: Maybe<CmsHeaderFields_Nav_Link_Query_Id_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Query_Id_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Query_Id_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Query_Id_Update>
}

export type CmsHeaderFields_Nav_Link_Query_Id_Create = {
  __typename?: 'CmsHeaderFields_nav_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Id_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Id_Read = {
  __typename?: 'CmsHeaderFields_nav_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Id_Update = {
  __typename?: 'CmsHeaderFields_nav_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Key = {
  __typename?: 'CmsHeaderFields_nav_link_query_key'
  create?: Maybe<CmsHeaderFields_Nav_Link_Query_Key_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Query_Key_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Query_Key_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Query_Key_Update>
}

export type CmsHeaderFields_Nav_Link_Query_Key_Create = {
  __typename?: 'CmsHeaderFields_nav_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Key_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Key_Read = {
  __typename?: 'CmsHeaderFields_nav_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Key_Update = {
  __typename?: 'CmsHeaderFields_nav_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Value = {
  __typename?: 'CmsHeaderFields_nav_link_query_value'
  create?: Maybe<CmsHeaderFields_Nav_Link_Query_Value_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Query_Value_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Query_Value_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Query_Value_Update>
}

export type CmsHeaderFields_Nav_Link_Query_Value_Create = {
  __typename?: 'CmsHeaderFields_nav_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Value_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Value_Read = {
  __typename?: 'CmsHeaderFields_nav_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Query_Value_Update = {
  __typename?: 'CmsHeaderFields_nav_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reference = {
  __typename?: 'CmsHeaderFields_nav_link_reference'
  create?: Maybe<CmsHeaderFields_Nav_Link_Reference_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Reference_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Reference_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Reference_Update>
}

export type CmsHeaderFields_Nav_Link_Reference_Create = {
  __typename?: 'CmsHeaderFields_nav_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reference_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reference_Read = {
  __typename?: 'CmsHeaderFields_nav_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reference_Update = {
  __typename?: 'CmsHeaderFields_nav_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reusable = {
  __typename?: 'CmsHeaderFields_nav_link_reusable'
  create?: Maybe<CmsHeaderFields_Nav_Link_Reusable_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Reusable_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Reusable_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Reusable_Update>
}

export type CmsHeaderFields_Nav_Link_Reusable_Create = {
  __typename?: 'CmsHeaderFields_nav_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reusable_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reusable_Read = {
  __typename?: 'CmsHeaderFields_nav_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Reusable_Update = {
  __typename?: 'CmsHeaderFields_nav_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_TargetId = {
  __typename?: 'CmsHeaderFields_nav_link_targetId'
  create?: Maybe<CmsHeaderFields_Nav_Link_TargetId_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_TargetId_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_TargetId_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_TargetId_Update>
}

export type CmsHeaderFields_Nav_Link_TargetId_Create = {
  __typename?: 'CmsHeaderFields_nav_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_TargetId_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_TargetId_Read = {
  __typename?: 'CmsHeaderFields_nav_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_TargetId_Update = {
  __typename?: 'CmsHeaderFields_nav_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Type = {
  __typename?: 'CmsHeaderFields_nav_link_type'
  create?: Maybe<CmsHeaderFields_Nav_Link_Type_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Type_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Type_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Type_Update>
}

export type CmsHeaderFields_Nav_Link_Type_Create = {
  __typename?: 'CmsHeaderFields_nav_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Type_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Type_Read = {
  __typename?: 'CmsHeaderFields_nav_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Type_Update = {
  __typename?: 'CmsHeaderFields_nav_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Url = {
  __typename?: 'CmsHeaderFields_nav_link_url'
  create?: Maybe<CmsHeaderFields_Nav_Link_Url_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Link_Url_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Link_Url_Read>
  update?: Maybe<CmsHeaderFields_Nav_Link_Url_Update>
}

export type CmsHeaderFields_Nav_Link_Url_Create = {
  __typename?: 'CmsHeaderFields_nav_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Url_Delete = {
  __typename?: 'CmsHeaderFields_nav_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Url_Read = {
  __typename?: 'CmsHeaderFields_nav_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Link_Url_Update = {
  __typename?: 'CmsHeaderFields_nav_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu = {
  __typename?: 'CmsHeaderFields_nav_submenu'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Submenu_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Update>
}

export type CmsHeaderFields_Nav_Submenu_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Fields = {
  __typename?: 'CmsHeaderFields_nav_submenu_Fields'
  categories?: Maybe<CmsHeaderFields_Nav_Submenu_Categories>
}

export type CmsHeaderFields_Nav_Submenu_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Fields = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_Fields'
  id?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Id>
  items?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items>
  name?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Name>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Id = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_id'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Id_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Id_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Id_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Id_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Id_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Id_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Id_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Id_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Fields = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_Fields'
  description?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Description>
  id?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Id>
  link?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link>
  title?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Title>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Description = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_description'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_description_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_description_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Description_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_description_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Id = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_id'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Id_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Fields = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_Fields'
  iconAfter?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter>
  iconBefore?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore>
  newTab?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab>
  query?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query>
  reference?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference>
  reusable?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable>
  targetId?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId>
  type?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type>
  url?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url>
  variant?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconAfter'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconAfter_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconBefore'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_IconBefore_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_newTab'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_NewTab_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Delete>
  fields?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Fields>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Fields = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_Fields'
  id?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id>
  key?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key>
  value?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_id'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Id_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_key'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Key_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_value'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Query_Value_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reference'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reference_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reusable'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Reusable_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_targetId'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_TargetId_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_type'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Type_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_url'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Url_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_variant'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Link_Variant_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Title = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_title'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Items_Title_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_items_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Name = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_name'
  create?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Name_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Name_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Name_Read>
  update?: Maybe<CmsHeaderFields_Nav_Submenu_Categories_Name_Update>
}

export type CmsHeaderFields_Nav_Submenu_Categories_Name_Create = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_name_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Name_Delete = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Name_Read = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_name_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Submenu_Categories_Name_Update = {
  __typename?: 'CmsHeaderFields_nav_submenu_categories_name_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Title = {
  __typename?: 'CmsHeaderFields_nav_title'
  create?: Maybe<CmsHeaderFields_Nav_Title_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Title_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Title_Read>
  update?: Maybe<CmsHeaderFields_Nav_Title_Update>
}

export type CmsHeaderFields_Nav_Title_Create = {
  __typename?: 'CmsHeaderFields_nav_title_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Title_Delete = {
  __typename?: 'CmsHeaderFields_nav_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Title_Read = {
  __typename?: 'CmsHeaderFields_nav_title_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Title_Update = {
  __typename?: 'CmsHeaderFields_nav_title_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Type = {
  __typename?: 'CmsHeaderFields_nav_type'
  create?: Maybe<CmsHeaderFields_Nav_Type_Create>
  delete?: Maybe<CmsHeaderFields_Nav_Type_Delete>
  read?: Maybe<CmsHeaderFields_Nav_Type_Read>
  update?: Maybe<CmsHeaderFields_Nav_Type_Update>
}

export type CmsHeaderFields_Nav_Type_Create = {
  __typename?: 'CmsHeaderFields_nav_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Type_Delete = {
  __typename?: 'CmsHeaderFields_nav_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Type_Read = {
  __typename?: 'CmsHeaderFields_nav_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_Nav_Type_Update = {
  __typename?: 'CmsHeaderFields_nav_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink = {
  __typename?: 'CmsHeaderFields_signupLink'
  create?: Maybe<CmsHeaderFields_SignupLink_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Delete>
  fields?: Maybe<CmsHeaderFields_SignupLink_Fields>
  read?: Maybe<CmsHeaderFields_SignupLink_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Update>
}

export type CmsHeaderFields_SignupLink_Create = {
  __typename?: 'CmsHeaderFields_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Fields = {
  __typename?: 'CmsHeaderFields_signupLink_Fields'
  newTab?: Maybe<CmsHeaderFields_SignupLink_NewTab>
  query?: Maybe<CmsHeaderFields_SignupLink_Query>
  reference?: Maybe<CmsHeaderFields_SignupLink_Reference>
  reusable?: Maybe<CmsHeaderFields_SignupLink_Reusable>
  targetId?: Maybe<CmsHeaderFields_SignupLink_TargetId>
  type?: Maybe<CmsHeaderFields_SignupLink_Type>
  url?: Maybe<CmsHeaderFields_SignupLink_Url>
}

export type CmsHeaderFields_SignupLink_Read = {
  __typename?: 'CmsHeaderFields_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Update = {
  __typename?: 'CmsHeaderFields_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_NewTab = {
  __typename?: 'CmsHeaderFields_signupLink_newTab'
  create?: Maybe<CmsHeaderFields_SignupLink_NewTab_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_NewTab_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_NewTab_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_NewTab_Update>
}

export type CmsHeaderFields_SignupLink_NewTab_Create = {
  __typename?: 'CmsHeaderFields_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_NewTab_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_NewTab_Read = {
  __typename?: 'CmsHeaderFields_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_NewTab_Update = {
  __typename?: 'CmsHeaderFields_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query = {
  __typename?: 'CmsHeaderFields_signupLink_query'
  create?: Maybe<CmsHeaderFields_SignupLink_Query_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Query_Delete>
  fields?: Maybe<CmsHeaderFields_SignupLink_Query_Fields>
  read?: Maybe<CmsHeaderFields_SignupLink_Query_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Query_Update>
}

export type CmsHeaderFields_SignupLink_Query_Create = {
  __typename?: 'CmsHeaderFields_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Fields = {
  __typename?: 'CmsHeaderFields_signupLink_query_Fields'
  id?: Maybe<CmsHeaderFields_SignupLink_Query_Id>
  key?: Maybe<CmsHeaderFields_SignupLink_Query_Key>
  value?: Maybe<CmsHeaderFields_SignupLink_Query_Value>
}

export type CmsHeaderFields_SignupLink_Query_Read = {
  __typename?: 'CmsHeaderFields_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Update = {
  __typename?: 'CmsHeaderFields_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Id = {
  __typename?: 'CmsHeaderFields_signupLink_query_id'
  create?: Maybe<CmsHeaderFields_SignupLink_Query_Id_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Query_Id_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_Query_Id_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Query_Id_Update>
}

export type CmsHeaderFields_SignupLink_Query_Id_Create = {
  __typename?: 'CmsHeaderFields_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Id_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Id_Read = {
  __typename?: 'CmsHeaderFields_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Id_Update = {
  __typename?: 'CmsHeaderFields_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Key = {
  __typename?: 'CmsHeaderFields_signupLink_query_key'
  create?: Maybe<CmsHeaderFields_SignupLink_Query_Key_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Query_Key_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_Query_Key_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Query_Key_Update>
}

export type CmsHeaderFields_SignupLink_Query_Key_Create = {
  __typename?: 'CmsHeaderFields_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Key_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Key_Read = {
  __typename?: 'CmsHeaderFields_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Key_Update = {
  __typename?: 'CmsHeaderFields_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Value = {
  __typename?: 'CmsHeaderFields_signupLink_query_value'
  create?: Maybe<CmsHeaderFields_SignupLink_Query_Value_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Query_Value_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_Query_Value_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Query_Value_Update>
}

export type CmsHeaderFields_SignupLink_Query_Value_Create = {
  __typename?: 'CmsHeaderFields_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Value_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Value_Read = {
  __typename?: 'CmsHeaderFields_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Query_Value_Update = {
  __typename?: 'CmsHeaderFields_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reference = {
  __typename?: 'CmsHeaderFields_signupLink_reference'
  create?: Maybe<CmsHeaderFields_SignupLink_Reference_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Reference_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_Reference_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Reference_Update>
}

export type CmsHeaderFields_SignupLink_Reference_Create = {
  __typename?: 'CmsHeaderFields_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reference_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reference_Read = {
  __typename?: 'CmsHeaderFields_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reference_Update = {
  __typename?: 'CmsHeaderFields_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reusable = {
  __typename?: 'CmsHeaderFields_signupLink_reusable'
  create?: Maybe<CmsHeaderFields_SignupLink_Reusable_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Reusable_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_Reusable_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Reusable_Update>
}

export type CmsHeaderFields_SignupLink_Reusable_Create = {
  __typename?: 'CmsHeaderFields_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reusable_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reusable_Read = {
  __typename?: 'CmsHeaderFields_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Reusable_Update = {
  __typename?: 'CmsHeaderFields_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_TargetId = {
  __typename?: 'CmsHeaderFields_signupLink_targetId'
  create?: Maybe<CmsHeaderFields_SignupLink_TargetId_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_TargetId_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_TargetId_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_TargetId_Update>
}

export type CmsHeaderFields_SignupLink_TargetId_Create = {
  __typename?: 'CmsHeaderFields_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_TargetId_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_TargetId_Read = {
  __typename?: 'CmsHeaderFields_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_TargetId_Update = {
  __typename?: 'CmsHeaderFields_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Type = {
  __typename?: 'CmsHeaderFields_signupLink_type'
  create?: Maybe<CmsHeaderFields_SignupLink_Type_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Type_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_Type_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Type_Update>
}

export type CmsHeaderFields_SignupLink_Type_Create = {
  __typename?: 'CmsHeaderFields_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Type_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Type_Read = {
  __typename?: 'CmsHeaderFields_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Type_Update = {
  __typename?: 'CmsHeaderFields_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Url = {
  __typename?: 'CmsHeaderFields_signupLink_url'
  create?: Maybe<CmsHeaderFields_SignupLink_Url_Create>
  delete?: Maybe<CmsHeaderFields_SignupLink_Url_Delete>
  read?: Maybe<CmsHeaderFields_SignupLink_Url_Read>
  update?: Maybe<CmsHeaderFields_SignupLink_Url_Update>
}

export type CmsHeaderFields_SignupLink_Url_Create = {
  __typename?: 'CmsHeaderFields_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Url_Delete = {
  __typename?: 'CmsHeaderFields_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Url_Read = {
  __typename?: 'CmsHeaderFields_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SignupLink_Url_Update = {
  __typename?: 'CmsHeaderFields_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink = {
  __typename?: 'CmsHeaderFields_supportLink'
  create?: Maybe<CmsHeaderFields_SupportLink_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Delete>
  fields?: Maybe<CmsHeaderFields_SupportLink_Fields>
  read?: Maybe<CmsHeaderFields_SupportLink_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Update>
}

export type CmsHeaderFields_SupportLink_Create = {
  __typename?: 'CmsHeaderFields_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Fields = {
  __typename?: 'CmsHeaderFields_supportLink_Fields'
  newTab?: Maybe<CmsHeaderFields_SupportLink_NewTab>
  query?: Maybe<CmsHeaderFields_SupportLink_Query>
  reference?: Maybe<CmsHeaderFields_SupportLink_Reference>
  reusable?: Maybe<CmsHeaderFields_SupportLink_Reusable>
  targetId?: Maybe<CmsHeaderFields_SupportLink_TargetId>
  type?: Maybe<CmsHeaderFields_SupportLink_Type>
  url?: Maybe<CmsHeaderFields_SupportLink_Url>
}

export type CmsHeaderFields_SupportLink_Read = {
  __typename?: 'CmsHeaderFields_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Update = {
  __typename?: 'CmsHeaderFields_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_NewTab = {
  __typename?: 'CmsHeaderFields_supportLink_newTab'
  create?: Maybe<CmsHeaderFields_SupportLink_NewTab_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_NewTab_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_NewTab_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_NewTab_Update>
}

export type CmsHeaderFields_SupportLink_NewTab_Create = {
  __typename?: 'CmsHeaderFields_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_NewTab_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_NewTab_Read = {
  __typename?: 'CmsHeaderFields_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_NewTab_Update = {
  __typename?: 'CmsHeaderFields_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query = {
  __typename?: 'CmsHeaderFields_supportLink_query'
  create?: Maybe<CmsHeaderFields_SupportLink_Query_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Query_Delete>
  fields?: Maybe<CmsHeaderFields_SupportLink_Query_Fields>
  read?: Maybe<CmsHeaderFields_SupportLink_Query_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Query_Update>
}

export type CmsHeaderFields_SupportLink_Query_Create = {
  __typename?: 'CmsHeaderFields_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Fields = {
  __typename?: 'CmsHeaderFields_supportLink_query_Fields'
  id?: Maybe<CmsHeaderFields_SupportLink_Query_Id>
  key?: Maybe<CmsHeaderFields_SupportLink_Query_Key>
  value?: Maybe<CmsHeaderFields_SupportLink_Query_Value>
}

export type CmsHeaderFields_SupportLink_Query_Read = {
  __typename?: 'CmsHeaderFields_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Update = {
  __typename?: 'CmsHeaderFields_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Id = {
  __typename?: 'CmsHeaderFields_supportLink_query_id'
  create?: Maybe<CmsHeaderFields_SupportLink_Query_Id_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Query_Id_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_Query_Id_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Query_Id_Update>
}

export type CmsHeaderFields_SupportLink_Query_Id_Create = {
  __typename?: 'CmsHeaderFields_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Id_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Id_Read = {
  __typename?: 'CmsHeaderFields_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Id_Update = {
  __typename?: 'CmsHeaderFields_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Key = {
  __typename?: 'CmsHeaderFields_supportLink_query_key'
  create?: Maybe<CmsHeaderFields_SupportLink_Query_Key_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Query_Key_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_Query_Key_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Query_Key_Update>
}

export type CmsHeaderFields_SupportLink_Query_Key_Create = {
  __typename?: 'CmsHeaderFields_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Key_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Key_Read = {
  __typename?: 'CmsHeaderFields_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Key_Update = {
  __typename?: 'CmsHeaderFields_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Value = {
  __typename?: 'CmsHeaderFields_supportLink_query_value'
  create?: Maybe<CmsHeaderFields_SupportLink_Query_Value_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Query_Value_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_Query_Value_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Query_Value_Update>
}

export type CmsHeaderFields_SupportLink_Query_Value_Create = {
  __typename?: 'CmsHeaderFields_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Value_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Value_Read = {
  __typename?: 'CmsHeaderFields_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Query_Value_Update = {
  __typename?: 'CmsHeaderFields_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reference = {
  __typename?: 'CmsHeaderFields_supportLink_reference'
  create?: Maybe<CmsHeaderFields_SupportLink_Reference_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Reference_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_Reference_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Reference_Update>
}

export type CmsHeaderFields_SupportLink_Reference_Create = {
  __typename?: 'CmsHeaderFields_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reference_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reference_Read = {
  __typename?: 'CmsHeaderFields_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reference_Update = {
  __typename?: 'CmsHeaderFields_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reusable = {
  __typename?: 'CmsHeaderFields_supportLink_reusable'
  create?: Maybe<CmsHeaderFields_SupportLink_Reusable_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Reusable_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_Reusable_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Reusable_Update>
}

export type CmsHeaderFields_SupportLink_Reusable_Create = {
  __typename?: 'CmsHeaderFields_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reusable_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reusable_Read = {
  __typename?: 'CmsHeaderFields_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Reusable_Update = {
  __typename?: 'CmsHeaderFields_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_TargetId = {
  __typename?: 'CmsHeaderFields_supportLink_targetId'
  create?: Maybe<CmsHeaderFields_SupportLink_TargetId_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_TargetId_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_TargetId_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_TargetId_Update>
}

export type CmsHeaderFields_SupportLink_TargetId_Create = {
  __typename?: 'CmsHeaderFields_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_TargetId_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_TargetId_Read = {
  __typename?: 'CmsHeaderFields_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_TargetId_Update = {
  __typename?: 'CmsHeaderFields_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Type = {
  __typename?: 'CmsHeaderFields_supportLink_type'
  create?: Maybe<CmsHeaderFields_SupportLink_Type_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Type_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_Type_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Type_Update>
}

export type CmsHeaderFields_SupportLink_Type_Create = {
  __typename?: 'CmsHeaderFields_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Type_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Type_Read = {
  __typename?: 'CmsHeaderFields_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Type_Update = {
  __typename?: 'CmsHeaderFields_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Url = {
  __typename?: 'CmsHeaderFields_supportLink_url'
  create?: Maybe<CmsHeaderFields_SupportLink_Url_Create>
  delete?: Maybe<CmsHeaderFields_SupportLink_Url_Delete>
  read?: Maybe<CmsHeaderFields_SupportLink_Url_Read>
  update?: Maybe<CmsHeaderFields_SupportLink_Url_Update>
}

export type CmsHeaderFields_SupportLink_Url_Create = {
  __typename?: 'CmsHeaderFields_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Url_Delete = {
  __typename?: 'CmsHeaderFields_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Url_Read = {
  __typename?: 'CmsHeaderFields_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_SupportLink_Url_Update = {
  __typename?: 'CmsHeaderFields_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_UpdatedAt = {
  __typename?: 'CmsHeaderFields_updatedAt'
  create?: Maybe<CmsHeaderFields_UpdatedAt_Create>
  delete?: Maybe<CmsHeaderFields_UpdatedAt_Delete>
  read?: Maybe<CmsHeaderFields_UpdatedAt_Read>
  update?: Maybe<CmsHeaderFields_UpdatedAt_Update>
}

export type CmsHeaderFields_UpdatedAt_Create = {
  __typename?: 'CmsHeaderFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_UpdatedAt_Delete = {
  __typename?: 'CmsHeaderFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_UpdatedAt_Read = {
  __typename?: 'CmsHeaderFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderFields_UpdatedAt_Update = {
  __typename?: 'CmsHeaderFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsHeaderReadAccess = {
  __typename?: 'CmsHeaderReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsHeaderReadDocAccess = {
  __typename?: 'CmsHeaderReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsHeaderUpdateAccess = {
  __typename?: 'CmsHeaderUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsHeaderUpdateDocAccess = {
  __typename?: 'CmsHeaderUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsHeader_Nav = {
  __typename?: 'CmsHeader_Nav'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
  submenu?: Maybe<CmsHeader_Nav_Submenu>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<CmsHeader_Nav_Type>
}

export type CmsHeader_Nav_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_Nav_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_Nav_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsHeader_Nav_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsHeader_Nav_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsHeader_Nav_Link_ReferenceRelationshipInputRelationTo]
export type CmsHeader_Nav_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_Nav_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_Nav_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsHeader_Nav_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsHeader_Nav_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsHeader_Nav_Link_ReusableRelationshipInputRelationTo]
export type CmsHeader_Nav_Submenu = {
  __typename?: 'CmsHeader_Nav_Submenu'
  categories?: Maybe<Array<CmsHeader_Nav_Submenu_Categories>>
}

export type CmsHeader_Nav_Submenu_Categories = {
  __typename?: 'CmsHeader_Nav_Submenu_Categories'
  id?: Maybe<Scalars['String']['output']>
  items?: Maybe<Array<CmsHeader_Nav_Submenu_Categories_Items>>
  name?: Maybe<Scalars['String']['output']>
}

export type CmsHeader_Nav_Submenu_Categories_Items = {
  __typename?: 'CmsHeader_Nav_Submenu_Categories_Items'
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
  title?: Maybe<Scalars['String']['output']>
}

export type CmsHeader_Nav_Submenu_Categories_Items_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_Nav_Submenu_Categories_Items_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_Nav_Submenu_Categories_Items_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsHeader_Nav_Submenu_Categories_Items_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsHeader_Nav_Submenu_Categories_Items_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsHeader_Nav_Submenu_Categories_Items_Link_ReferenceRelationshipInputRelationTo]
export type CmsHeader_Nav_Submenu_Categories_Items_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_Nav_Submenu_Categories_Items_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_Nav_Submenu_Categories_Items_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsHeader_Nav_Submenu_Categories_Items_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsHeader_Nav_Submenu_Categories_Items_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsHeader_Nav_Submenu_Categories_Items_Link_ReusableRelationshipInputRelationTo]
export const CmsHeader_Nav_Submenu_Categories_Items_Link_Variant_MutationInput = {
  Plain: 'plain',
  PrimaryPlain: 'primaryPlain',
} as const

export type CmsHeader_Nav_Submenu_Categories_Items_Link_Variant_MutationInput =
  (typeof CmsHeader_Nav_Submenu_Categories_Items_Link_Variant_MutationInput)[keyof typeof CmsHeader_Nav_Submenu_Categories_Items_Link_Variant_MutationInput]
export const CmsHeader_Nav_Type = {
  Link: 'link',
  Submenu: 'submenu',
} as const

export type CmsHeader_Nav_Type = (typeof CmsHeader_Nav_Type)[keyof typeof CmsHeader_Nav_Type]
export type CmsHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsHeader_SupportLink_ReusableRelationshipInputRelationTo]
export type CmsHero = {
  __typename?: 'CmsHero'
  desktopFallback?: Maybe<CmsMedia>
  desktopVideo?: Maybe<CmsVideo>
  disclaimerText?: Maybe<Scalars['String']['output']>
  heroSize?: Maybe<CmsHero_HeroSize>
  hzAlign?: Maybe<CmsHero_HzAlign>
  links?: Maybe<Array<CmsHero_Links>>
  media?: Maybe<CmsMedia>
  mobileFallback?: Maybe<CmsMedia>
  mobileVideo?: Maybe<CmsVideo>
  productImage?: Maybe<CmsMedia>
  reviewRating?: Maybe<Scalars['Float']['output']>
  reviewText?: Maybe<Scalars['String']['output']>
  richText?: Maybe<Scalars['JSON']['output']>
  richTextMax?: Maybe<Scalars['Float']['output']>
  showReviews?: Maybe<Scalars['Boolean']['output']>
  type?: Maybe<CmsHero_Type>
  vertAlign?: Maybe<CmsHero_VertAlign>
}

export type CmsHeroRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsHero_Links = {
  __typename?: 'CmsHero_Links'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export const CmsHero_HeroSize = {
  Full: 'full',
  Partial: 'partial',
} as const

export type CmsHero_HeroSize = (typeof CmsHero_HeroSize)[keyof typeof CmsHero_HeroSize]
export const CmsHero_HzAlign = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsHero_HzAlign = (typeof CmsHero_HzAlign)[keyof typeof CmsHero_HzAlign]
export const CmsHero_Type = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsHero_Type = (typeof CmsHero_Type)[keyof typeof CmsHero_Type]
export const CmsHero_VertAlign = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsHero_VertAlign = (typeof CmsHero_VertAlign)[keyof typeof CmsHero_VertAlign]
export type CmsImageBlock = {
  __typename?: 'CmsImageBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsImageBlock_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  image?: Maybe<CmsMedia>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
}

export type CmsImageBlock_Ctas = {
  __typename?: 'CmsImageBlock_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsLegal = {
  __typename?: 'CmsLegal'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  description: Scalars['String']['output']
  id: Scalars['Int']['output']
  richText?: Maybe<Scalars['JSON']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsLegalRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsLegalBlock = {
  __typename?: 'CmsLegalBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsLegalBlock_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  legal?: Maybe<CmsLegal>
  section?: Maybe<CmsSection>
}

export type CmsLegalBlock_Ctas = {
  __typename?: 'CmsLegalBlock_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsLegal_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsLegal_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsLegal_Description_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLegal_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsLegal_RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsLegal_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLegal_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLegal_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsLegal_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsLegal_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLegal_Where_Or>>>
  createdAt?: InputMaybe<CmsLegal_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsLegal_CreatedBy_Operator>
  description?: InputMaybe<CmsLegal_Description_Operator>
  id?: InputMaybe<CmsLegal_Id_Operator>
  richText?: InputMaybe<CmsLegal_RichText_Operator>
  slug?: InputMaybe<CmsLegal_Slug_Operator>
  title?: InputMaybe<CmsLegal_Title_Operator>
  updatedAt?: InputMaybe<CmsLegal_UpdatedAt_Operator>
}

export type CmsLegal_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsLegal_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLegal_Where_Or>>>
  createdAt?: InputMaybe<CmsLegal_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsLegal_CreatedBy_Operator>
  description?: InputMaybe<CmsLegal_Description_Operator>
  id?: InputMaybe<CmsLegal_Id_Operator>
  richText?: InputMaybe<CmsLegal_RichText_Operator>
  slug?: InputMaybe<CmsLegal_Slug_Operator>
  title?: InputMaybe<CmsLegal_Title_Operator>
  updatedAt?: InputMaybe<CmsLegal_UpdatedAt_Operator>
}

export type CmsLegal_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsLegal_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLegal_Where_Or>>>
  createdAt?: InputMaybe<CmsLegal_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsLegal_CreatedBy_Operator>
  description?: InputMaybe<CmsLegal_Description_Operator>
  id?: InputMaybe<CmsLegal_Id_Operator>
  richText?: InputMaybe<CmsLegal_RichText_Operator>
  slug?: InputMaybe<CmsLegal_Slug_Operator>
  title?: InputMaybe<CmsLegal_Title_Operator>
  updatedAt?: InputMaybe<CmsLegal_UpdatedAt_Operator>
}

export type CmsLegals = {
  __typename?: 'CmsLegals'
  docs?: Maybe<Array<Maybe<CmsLegal>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsLink = {
  __typename?: 'CmsLink'
  iconAfter?: Maybe<Scalars['String']['output']>
  iconBefore?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  newTab?: Maybe<Scalars['Boolean']['output']>
  query?: Maybe<Array<CmsLink_Query>>
  reference?: Maybe<CmsLink_Reference_Relationship>
  reusable?: Maybe<CmsLink_Reusable_Relationship>
  targetId?: Maybe<Scalars['String']['output']>
  type?: Maybe<CmsLink_Type>
  url?: Maybe<Scalars['String']['output']>
  variant?: Maybe<CmsLink_Variant>
}

export type CmsLinkReferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsLink_Query = {
  __typename?: 'CmsLink_Query'
  id?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type CmsLink_Reference = CmsArticle | CmsGuide | CmsMarketplacePage | CmsNewsroomArticle | CmsPage

export const CmsLink_Reference_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsLink_Reference_RelationTo =
  (typeof CmsLink_Reference_RelationTo)[keyof typeof CmsLink_Reference_RelationTo]
export type CmsLink_Reference_Relationship = {
  __typename?: 'CmsLink_Reference_Relationship'
  relationTo?: Maybe<CmsLink_Reference_RelationTo>
  value?: Maybe<CmsLink_Reference>
}

export type CmsLink_Reusable = CmsLinks

export const CmsLink_Reusable_RelationTo = {
  Links: 'links',
} as const

export type CmsLink_Reusable_RelationTo = (typeof CmsLink_Reusable_RelationTo)[keyof typeof CmsLink_Reusable_RelationTo]
export type CmsLink_Reusable_Relationship = {
  __typename?: 'CmsLink_Reusable_Relationship'
  relationTo?: Maybe<CmsLink_Reusable_RelationTo>
  value?: Maybe<CmsLink_Reusable>
}

export const CmsLink_Type = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsLink_Type = (typeof CmsLink_Type)[keyof typeof CmsLink_Type]
export const CmsLink_Variant = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsLink_Variant = (typeof CmsLink_Variant)[keyof typeof CmsLink_Variant]
export type CmsLinks = {
  __typename?: 'CmsLinks'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url: Scalars['String']['output']
}

export type CmsLinks_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsLinks_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsLinks_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLinks_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsLinks_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLinks_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsLinks_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLinks_Where_Or>>>
  createdAt?: InputMaybe<CmsLinks_CreatedAt_Operator>
  id?: InputMaybe<CmsLinks_Id_Operator>
  title?: InputMaybe<CmsLinks_Title_Operator>
  updatedAt?: InputMaybe<CmsLinks_UpdatedAt_Operator>
  url?: InputMaybe<CmsLinks_Url_Operator>
}

export type CmsLinks_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsLinks_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLinks_Where_Or>>>
  createdAt?: InputMaybe<CmsLinks_CreatedAt_Operator>
  id?: InputMaybe<CmsLinks_Id_Operator>
  title?: InputMaybe<CmsLinks_Title_Operator>
  updatedAt?: InputMaybe<CmsLinks_UpdatedAt_Operator>
  url?: InputMaybe<CmsLinks_Url_Operator>
}

export type CmsLinks_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsLinks_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLinks_Where_Or>>>
  createdAt?: InputMaybe<CmsLinks_CreatedAt_Operator>
  id?: InputMaybe<CmsLinks_Id_Operator>
  title?: InputMaybe<CmsLinks_Title_Operator>
  updatedAt?: InputMaybe<CmsLinks_UpdatedAt_Operator>
  url?: InputMaybe<CmsLinks_Url_Operator>
}

export type CmsLiteEmbeddedMarketplace = {
  __typename?: 'CmsLiteEmbeddedMarketplace'
  _status?: Maybe<CmsLiteEmbeddedMarketplace__Status>
  affiliateCode?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  id: Scalars['Int']['output']
  logo?: Maybe<CmsMedia>
  logoHref?: Maybe<Scalars['String']['output']>
  meta?: Maybe<CmsMeta>
  offerCategories?: Maybe<Array<CmsLiteEmbeddedMarketplace_OfferCategories>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export const CmsLiteEmbeddedMarketplaceUpdate_OfferCategories_Category_MutationInput = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsLiteEmbeddedMarketplaceUpdate_OfferCategories_Category_MutationInput =
  (typeof CmsLiteEmbeddedMarketplaceUpdate_OfferCategories_Category_MutationInput)[keyof typeof CmsLiteEmbeddedMarketplaceUpdate_OfferCategories_Category_MutationInput]
export const CmsLiteEmbeddedMarketplaceUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsLiteEmbeddedMarketplaceUpdate__Status_MutationInput =
  (typeof CmsLiteEmbeddedMarketplaceUpdate__Status_MutationInput)[keyof typeof CmsLiteEmbeddedMarketplaceUpdate__Status_MutationInput]
export type CmsLiteEmbeddedMarketplaceVersion = {
  __typename?: 'CmsLiteEmbeddedMarketplaceVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsLiteEmbeddedMarketplace>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsLiteEmbeddedMarketplaceVersion_Version>
}

export type CmsLiteEmbeddedMarketplaceVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsLiteEmbeddedMarketplaceVersion_Version = {
  __typename?: 'CmsLiteEmbeddedMarketplaceVersion_Version'
  _status?: Maybe<CmsLiteEmbeddedMarketplaceVersion_Version__Status>
  affiliateCode?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  logo?: Maybe<CmsMedia>
  logoHref?: Maybe<Scalars['String']['output']>
  meta?: Maybe<CmsMeta>
  offerCategories?: Maybe<Array<CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories = {
  __typename?: 'CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories'
  category?: Maybe<CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories_Category>
  collection?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export const CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories_Category = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories_Category =
  (typeof CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories_Category)[keyof typeof CmsLiteEmbeddedMarketplaceVersion_Version_OfferCategories_Category]
export const CmsLiteEmbeddedMarketplaceVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsLiteEmbeddedMarketplaceVersion_Version__Status =
  (typeof CmsLiteEmbeddedMarketplaceVersion_Version__Status)[keyof typeof CmsLiteEmbeddedMarketplaceVersion_Version__Status]
export type CmsLiteEmbeddedMarketplace_OfferCategories = {
  __typename?: 'CmsLiteEmbeddedMarketplace_OfferCategories'
  category?: Maybe<CmsLiteEmbeddedMarketplace_OfferCategories_Category>
  collection?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export const CmsLiteEmbeddedMarketplace_OfferCategories_Category = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsLiteEmbeddedMarketplace_OfferCategories_Category =
  (typeof CmsLiteEmbeddedMarketplace_OfferCategories_Category)[keyof typeof CmsLiteEmbeddedMarketplace_OfferCategories_Category]
export const CmsLiteEmbeddedMarketplace_OfferCategories_Category_MutationInput = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsLiteEmbeddedMarketplace_OfferCategories_Category_MutationInput =
  (typeof CmsLiteEmbeddedMarketplace_OfferCategories_Category_MutationInput)[keyof typeof CmsLiteEmbeddedMarketplace_OfferCategories_Category_MutationInput]
export const CmsLiteEmbeddedMarketplace__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsLiteEmbeddedMarketplace__Status =
  (typeof CmsLiteEmbeddedMarketplace__Status)[keyof typeof CmsLiteEmbeddedMarketplace__Status]
export const CmsLiteEmbeddedMarketplace__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsLiteEmbeddedMarketplace__Status_Input =
  (typeof CmsLiteEmbeddedMarketplace__Status_Input)[keyof typeof CmsLiteEmbeddedMarketplace__Status_Input]
export const CmsLiteEmbeddedMarketplace__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsLiteEmbeddedMarketplace__Status_MutationInput =
  (typeof CmsLiteEmbeddedMarketplace__Status_MutationInput)[keyof typeof CmsLiteEmbeddedMarketplace__Status_MutationInput]
export type CmsLiteEmbeddedMarketplace__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace__Status_Input>>>
  equals?: InputMaybe<CmsLiteEmbeddedMarketplace__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace__Status_Input>>>
  not_equals?: InputMaybe<CmsLiteEmbeddedMarketplace__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace__Status_Input>>>
}

export type CmsLiteEmbeddedMarketplace_AffiliateCode_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsLiteEmbeddedMarketplace_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsLiteEmbeddedMarketplace_LogoHref_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_Logo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsLiteEmbeddedMarketplace_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsLiteEmbeddedMarketplace_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsLiteEmbeddedMarketplace_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input =
  (typeof CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input)[keyof typeof CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input]
export type CmsLiteEmbeddedMarketplace_OfferCategories__Category_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input>>>
  equals?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input>
  in?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input>>>
  not_equals?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Input>>>
}

export type CmsLiteEmbeddedMarketplace_OfferCategories__Collection_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_OfferCategories__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_OfferCategories__Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_OfferCategories__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsLiteEmbeddedMarketplace_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsLiteEmbeddedMarketplace_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsLiteEmbeddedMarketplace_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_Where_Or>>>
  _status?: InputMaybe<CmsLiteEmbeddedMarketplace__Status_Operator>
  affiliateCode?: InputMaybe<CmsLiteEmbeddedMarketplace_AffiliateCode_Operator>
  createdAt?: InputMaybe<CmsLiteEmbeddedMarketplace_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsLiteEmbeddedMarketplace_CreatedBy_Operator>
  id?: InputMaybe<CmsLiteEmbeddedMarketplace_Id_Operator>
  logo?: InputMaybe<CmsLiteEmbeddedMarketplace_Logo_Operator>
  logoHref?: InputMaybe<CmsLiteEmbeddedMarketplace_LogoHref_Operator>
  meta__description?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Title_Operator>
  offerCategories__category?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Operator>
  offerCategories__collection?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Collection_Operator>
  offerCategories__id?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Id_Operator>
  offerCategories__name?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Name_Operator>
  offerCategories__slug?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Slug_Operator>
  publishedAt?: InputMaybe<CmsLiteEmbeddedMarketplace_PublishedAt_Operator>
  slug?: InputMaybe<CmsLiteEmbeddedMarketplace_Slug_Operator>
  title?: InputMaybe<CmsLiteEmbeddedMarketplace_Title_Operator>
  updatedAt?: InputMaybe<CmsLiteEmbeddedMarketplace_UpdatedAt_Operator>
}

export type CmsLiteEmbeddedMarketplace_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_Where_Or>>>
  _status?: InputMaybe<CmsLiteEmbeddedMarketplace__Status_Operator>
  affiliateCode?: InputMaybe<CmsLiteEmbeddedMarketplace_AffiliateCode_Operator>
  createdAt?: InputMaybe<CmsLiteEmbeddedMarketplace_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsLiteEmbeddedMarketplace_CreatedBy_Operator>
  id?: InputMaybe<CmsLiteEmbeddedMarketplace_Id_Operator>
  logo?: InputMaybe<CmsLiteEmbeddedMarketplace_Logo_Operator>
  logoHref?: InputMaybe<CmsLiteEmbeddedMarketplace_LogoHref_Operator>
  meta__description?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Title_Operator>
  offerCategories__category?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Operator>
  offerCategories__collection?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Collection_Operator>
  offerCategories__id?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Id_Operator>
  offerCategories__name?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Name_Operator>
  offerCategories__slug?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Slug_Operator>
  publishedAt?: InputMaybe<CmsLiteEmbeddedMarketplace_PublishedAt_Operator>
  slug?: InputMaybe<CmsLiteEmbeddedMarketplace_Slug_Operator>
  title?: InputMaybe<CmsLiteEmbeddedMarketplace_Title_Operator>
  updatedAt?: InputMaybe<CmsLiteEmbeddedMarketplace_UpdatedAt_Operator>
}

export type CmsLiteEmbeddedMarketplace_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsLiteEmbeddedMarketplace_Where_Or>>>
  _status?: InputMaybe<CmsLiteEmbeddedMarketplace__Status_Operator>
  affiliateCode?: InputMaybe<CmsLiteEmbeddedMarketplace_AffiliateCode_Operator>
  createdAt?: InputMaybe<CmsLiteEmbeddedMarketplace_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsLiteEmbeddedMarketplace_CreatedBy_Operator>
  id?: InputMaybe<CmsLiteEmbeddedMarketplace_Id_Operator>
  logo?: InputMaybe<CmsLiteEmbeddedMarketplace_Logo_Operator>
  logoHref?: InputMaybe<CmsLiteEmbeddedMarketplace_LogoHref_Operator>
  meta__description?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsLiteEmbeddedMarketplace_Meta__Title_Operator>
  offerCategories__category?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Category_Operator>
  offerCategories__collection?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Collection_Operator>
  offerCategories__id?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Id_Operator>
  offerCategories__name?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Name_Operator>
  offerCategories__slug?: InputMaybe<CmsLiteEmbeddedMarketplace_OfferCategories__Slug_Operator>
  publishedAt?: InputMaybe<CmsLiteEmbeddedMarketplace_PublishedAt_Operator>
  slug?: InputMaybe<CmsLiteEmbeddedMarketplace_Slug_Operator>
  title?: InputMaybe<CmsLiteEmbeddedMarketplace_Title_Operator>
  updatedAt?: InputMaybe<CmsLiteEmbeddedMarketplace_UpdatedAt_Operator>
}

export type CmsLiteEmbeddedMarketplaces = {
  __typename?: 'CmsLiteEmbeddedMarketplaces'
  docs?: Maybe<Array<Maybe<CmsLiteEmbeddedMarketplace>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsMarketplacePage = {
  __typename?: 'CmsMarketplacePage'
  _status?: Maybe<CmsMarketplacePage__Status>
  breadcrumbs?: Maybe<Array<CmsMarketplacePage_Breadcrumbs>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  hero?: Maybe<CmsHero>
  id: Scalars['Int']['output']
  meta?: Maybe<CmsMeta>
  offerCategory?: Maybe<CmsMarketplacePage_OfferCategory>
  parent?: Maybe<CmsMarketplacePage>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsMarketplacePageParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsMarketplacePageUpdate_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsMarketplacePageUpdate_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsMarketplacePageUpdate_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsMarketplacePageUpdate_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsMarketplacePageUpdate_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsMarketplacePageUpdate_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsMarketplacePageUpdate_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsMarketplacePageUpdate_CustomHeader_HeaderDisplay_MutationInput]
export type CmsMarketplacePageUpdate_Hero_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePageUpdate_Hero_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo]
export const CmsMarketplacePageUpdate_Hero_Links_Link_Variant_MutationInput = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsMarketplacePageUpdate_Hero_Links_Link_Variant_MutationInput =
  (typeof CmsMarketplacePageUpdate_Hero_Links_Link_Variant_MutationInput)[keyof typeof CmsMarketplacePageUpdate_Hero_Links_Link_Variant_MutationInput]
export const CmsMarketplacePageUpdate_Hero_HzAlign_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsMarketplacePageUpdate_Hero_HzAlign_MutationInput =
  (typeof CmsMarketplacePageUpdate_Hero_HzAlign_MutationInput)[keyof typeof CmsMarketplacePageUpdate_Hero_HzAlign_MutationInput]
export const CmsMarketplacePageUpdate_Hero_Type_MutationInput = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsMarketplacePageUpdate_Hero_Type_MutationInput =
  (typeof CmsMarketplacePageUpdate_Hero_Type_MutationInput)[keyof typeof CmsMarketplacePageUpdate_Hero_Type_MutationInput]
export const CmsMarketplacePageUpdate_Hero_VertAlign_MutationInput = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsMarketplacePageUpdate_Hero_VertAlign_MutationInput =
  (typeof CmsMarketplacePageUpdate_Hero_VertAlign_MutationInput)[keyof typeof CmsMarketplacePageUpdate_Hero_VertAlign_MutationInput]
export const CmsMarketplacePageUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsMarketplacePageUpdate__Status_MutationInput =
  (typeof CmsMarketplacePageUpdate__Status_MutationInput)[keyof typeof CmsMarketplacePageUpdate__Status_MutationInput]
export const CmsMarketplacePageUpdate_OfferCategory_MutationInput = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsMarketplacePageUpdate_OfferCategory_MutationInput =
  (typeof CmsMarketplacePageUpdate_OfferCategory_MutationInput)[keyof typeof CmsMarketplacePageUpdate_OfferCategory_MutationInput]
export type CmsMarketplacePageVersion = {
  __typename?: 'CmsMarketplacePageVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsMarketplacePage>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsMarketplacePageVersion_Version>
}

export type CmsMarketplacePageVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePageVersion_Version = {
  __typename?: 'CmsMarketplacePageVersion_Version'
  _status?: Maybe<CmsMarketplacePageVersion_Version__Status>
  breadcrumbs?: Maybe<Array<CmsMarketplacePageVersion_Version_Breadcrumbs>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  hero?: Maybe<CmsHero>
  meta?: Maybe<CmsMeta>
  offerCategory?: Maybe<CmsMarketplacePageVersion_Version_OfferCategory>
  parent?: Maybe<CmsMarketplacePage>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsMarketplacePageVersion_VersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePageVersion_Version_Breadcrumbs = {
  __typename?: 'CmsMarketplacePageVersion_Version_Breadcrumbs'
  doc?: Maybe<CmsMarketplacePage>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsMarketplacePageVersion_Version_BreadcrumbsDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsMarketplacePageVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsMarketplacePageVersion_Version__Status =
  (typeof CmsMarketplacePageVersion_Version__Status)[keyof typeof CmsMarketplacePageVersion_Version__Status]
export const CmsMarketplacePageVersion_Version_OfferCategory = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsMarketplacePageVersion_Version_OfferCategory =
  (typeof CmsMarketplacePageVersion_Version_OfferCategory)[keyof typeof CmsMarketplacePageVersion_Version_OfferCategory]
export type CmsMarketplacePage_Breadcrumbs = {
  __typename?: 'CmsMarketplacePage_Breadcrumbs'
  doc?: Maybe<CmsMarketplacePage>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsMarketplacePage_BreadcrumbsDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsMarketplacePage_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsMarketplacePage_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsMarketplacePage_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsMarketplacePage_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsMarketplacePage_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePage_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsMarketplacePage_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePage_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsMarketplacePage_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePage_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsMarketplacePage_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsMarketplacePage_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsMarketplacePage_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsMarketplacePage_CustomHeader_HeaderDisplay_MutationInput]
export type CmsMarketplacePage_Hero_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_Hero_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_Hero_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_Hero_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_Hero_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_Hero_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsMarketplacePage_Hero_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsMarketplacePage_Hero_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_Hero_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_Hero_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsMarketplacePage_Hero_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsMarketplacePage_Hero_Links_Link_ReusableRelationshipInputRelationTo]
export const CmsMarketplacePage_Hero_Links_Link_Variant_MutationInput = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsMarketplacePage_Hero_Links_Link_Variant_MutationInput =
  (typeof CmsMarketplacePage_Hero_Links_Link_Variant_MutationInput)[keyof typeof CmsMarketplacePage_Hero_Links_Link_Variant_MutationInput]
export const CmsMarketplacePage_Hero_HzAlign_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsMarketplacePage_Hero_HzAlign_MutationInput =
  (typeof CmsMarketplacePage_Hero_HzAlign_MutationInput)[keyof typeof CmsMarketplacePage_Hero_HzAlign_MutationInput]
export const CmsMarketplacePage_Hero_Type_MutationInput = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsMarketplacePage_Hero_Type_MutationInput =
  (typeof CmsMarketplacePage_Hero_Type_MutationInput)[keyof typeof CmsMarketplacePage_Hero_Type_MutationInput]
export const CmsMarketplacePage_Hero_VertAlign_MutationInput = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsMarketplacePage_Hero_VertAlign_MutationInput =
  (typeof CmsMarketplacePage_Hero_VertAlign_MutationInput)[keyof typeof CmsMarketplacePage_Hero_VertAlign_MutationInput]
export const CmsMarketplacePage__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsMarketplacePage__Status = (typeof CmsMarketplacePage__Status)[keyof typeof CmsMarketplacePage__Status]
export const CmsMarketplacePage__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsMarketplacePage__Status_Input =
  (typeof CmsMarketplacePage__Status_Input)[keyof typeof CmsMarketplacePage__Status_Input]
export const CmsMarketplacePage__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsMarketplacePage__Status_MutationInput =
  (typeof CmsMarketplacePage__Status_MutationInput)[keyof typeof CmsMarketplacePage__Status_MutationInput]
export type CmsMarketplacePage__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage__Status_Input>>>
  equals?: InputMaybe<CmsMarketplacePage__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage__Status_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage__Status_Input>>>
}

export type CmsMarketplacePage_Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsMarketplacePage_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input =
  (typeof CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input)[keyof typeof CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input]
export type CmsMarketplacePage_CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Input>>>
}

export type CmsMarketplacePage_CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePage_CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMarketplacePage_CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsMarketplacePage_CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsMarketplacePage_CustomHeader__HeaderDisplay_Input =
  (typeof CmsMarketplacePage_CustomHeader__HeaderDisplay_Input)[keyof typeof CmsMarketplacePage_CustomHeader__HeaderDisplay_Input]
export type CmsMarketplacePage_CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Input>>>
}

export type CmsMarketplacePage_CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePage_CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePage_CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type CmsMarketplacePage_CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsMarketplacePage_CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsMarketplacePage_CustomHeader__LoginLink__Type_Input =
  (typeof CmsMarketplacePage_CustomHeader__LoginLink__Type_Input)[keyof typeof CmsMarketplacePage_CustomHeader__LoginLink__Type_Input]
export type CmsMarketplacePage_CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Type_Input>
}

export type CmsMarketplacePage_CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePage_CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type CmsMarketplacePage_CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsMarketplacePage_CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsMarketplacePage_CustomHeader__SignupLink__Type_Input =
  (typeof CmsMarketplacePage_CustomHeader__SignupLink__Type_Input)[keyof typeof CmsMarketplacePage_CustomHeader__SignupLink__Type_Input]
export type CmsMarketplacePage_CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Type_Input>
}

export type CmsMarketplacePage_CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePage_CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type CmsMarketplacePage_CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsMarketplacePage_CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsMarketplacePage_CustomHeader__SupportLink__Type_Input =
  (typeof CmsMarketplacePage_CustomHeader__SupportLink__Type_Input)[keyof typeof CmsMarketplacePage_CustomHeader__SupportLink__Type_Input]
export type CmsMarketplacePage_CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Type_Input>
}

export type CmsMarketplacePage_CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__DesktopFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Hero__DesktopVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Hero__DisclaimerText_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export const CmsMarketplacePage_Hero__HeroSize_Input = {
  Full: 'full',
  Partial: 'partial',
} as const

export type CmsMarketplacePage_Hero__HeroSize_Input =
  (typeof CmsMarketplacePage_Hero__HeroSize_Input)[keyof typeof CmsMarketplacePage_Hero__HeroSize_Input]
export type CmsMarketplacePage_Hero__HeroSize_Operator = {
  contains?: InputMaybe<CmsMarketplacePage_Hero__HeroSize_Input>
  equals?: InputMaybe<CmsMarketplacePage_Hero__HeroSize_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsMarketplacePage_Hero__HeroSize_Input>
  not_equals?: InputMaybe<CmsMarketplacePage_Hero__HeroSize_Input>
}

export const CmsMarketplacePage_Hero__HzAlign_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsMarketplacePage_Hero__HzAlign_Input =
  (typeof CmsMarketplacePage_Hero__HzAlign_Input)[keyof typeof CmsMarketplacePage_Hero__HzAlign_Input]
export type CmsMarketplacePage_Hero__HzAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__HzAlign_Input>>>
  equals?: InputMaybe<CmsMarketplacePage_Hero__HzAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__HzAlign_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage_Hero__HzAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__HzAlign_Input>>>
}

export type CmsMarketplacePage_Hero__Links__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__Links__Link__IconAfter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__Links__Link__IconBefore_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__Links__Link__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__Links__Link__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePage_Hero__Links__Link__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__Links__Link__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__Links__Link__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__Links__Link__Reference_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_Hero__Links__Link__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsMarketplacePage_Hero__Links__Link__Reference_Relation_RelationTo =
  (typeof CmsMarketplacePage_Hero__Links__Link__Reference_Relation_RelationTo)[keyof typeof CmsMarketplacePage_Hero__Links__Link__Reference_Relation_RelationTo]
export type CmsMarketplacePage_Hero__Links__Link__Reusable_Relation = {
  relationTo?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsMarketplacePage_Hero__Links__Link__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsMarketplacePage_Hero__Links__Link__Reusable_Relation_RelationTo =
  (typeof CmsMarketplacePage_Hero__Links__Link__Reusable_Relation_RelationTo)[keyof typeof CmsMarketplacePage_Hero__Links__Link__Reusable_Relation_RelationTo]
export type CmsMarketplacePage_Hero__Links__Link__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsMarketplacePage_Hero__Links__Link__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsMarketplacePage_Hero__Links__Link__Type_Input =
  (typeof CmsMarketplacePage_Hero__Links__Link__Type_Input)[keyof typeof CmsMarketplacePage_Hero__Links__Link__Type_Input]
export type CmsMarketplacePage_Hero__Links__Link__Type_Operator = {
  contains?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Type_Input>
  equals?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Type_Input>
  not_equals?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Type_Input>
}

export type CmsMarketplacePage_Hero__Links__Link__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsMarketplacePage_Hero__Links__Link__Variant_Input = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsMarketplacePage_Hero__Links__Link__Variant_Input =
  (typeof CmsMarketplacePage_Hero__Links__Link__Variant_Input)[keyof typeof CmsMarketplacePage_Hero__Links__Link__Variant_Input]
export type CmsMarketplacePage_Hero__Links__Link__Variant_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Input>>>
  equals?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Input>>>
}

export type CmsMarketplacePage_Hero__Media_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Hero__MobileFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Hero__MobileVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Hero__ProductImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Hero__ReviewRating_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMarketplacePage_Hero__ReviewText_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Hero__RichTextMax_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMarketplacePage_Hero__RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsMarketplacePage_Hero__ShowReviews_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsMarketplacePage_Hero__Type_Input = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsMarketplacePage_Hero__Type_Input =
  (typeof CmsMarketplacePage_Hero__Type_Input)[keyof typeof CmsMarketplacePage_Hero__Type_Input]
export type CmsMarketplacePage_Hero__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__Type_Input>>>
  equals?: InputMaybe<CmsMarketplacePage_Hero__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__Type_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage_Hero__Type_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__Type_Input>>>
}

export const CmsMarketplacePage_Hero__VertAlign_Input = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsMarketplacePage_Hero__VertAlign_Input =
  (typeof CmsMarketplacePage_Hero__VertAlign_Input)[keyof typeof CmsMarketplacePage_Hero__VertAlign_Input]
export type CmsMarketplacePage_Hero__VertAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__VertAlign_Input>>>
  equals?: InputMaybe<CmsMarketplacePage_Hero__VertAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__VertAlign_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage_Hero__VertAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Hero__VertAlign_Input>>>
}

export type CmsMarketplacePage_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsMarketplacePage_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsMarketplacePage_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsMarketplacePage_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsMarketplacePage_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsMarketplacePage_OfferCategory = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsMarketplacePage_OfferCategory =
  (typeof CmsMarketplacePage_OfferCategory)[keyof typeof CmsMarketplacePage_OfferCategory]
export const CmsMarketplacePage_OfferCategory_Input = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsMarketplacePage_OfferCategory_Input =
  (typeof CmsMarketplacePage_OfferCategory_Input)[keyof typeof CmsMarketplacePage_OfferCategory_Input]
export const CmsMarketplacePage_OfferCategory_MutationInput = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsMarketplacePage_OfferCategory_MutationInput =
  (typeof CmsMarketplacePage_OfferCategory_MutationInput)[keyof typeof CmsMarketplacePage_OfferCategory_MutationInput]
export type CmsMarketplacePage_OfferCategory_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_OfferCategory_Input>>>
  equals?: InputMaybe<CmsMarketplacePage_OfferCategory_Input>
  in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_OfferCategory_Input>>>
  not_equals?: InputMaybe<CmsMarketplacePage_OfferCategory_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_OfferCategory_Input>>>
}

export type CmsMarketplacePage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMarketplacePage_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsMarketplacePage_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMarketplacePage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsMarketplacePage_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Where_Or>>>
  _status?: InputMaybe<CmsMarketplacePage__Status_Operator>
  breadcrumbs__doc?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsMarketplacePage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsMarketplacePage_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsMarketplacePage_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsMarketplacePage_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Url_Operator>
  hero__desktopFallback?: InputMaybe<CmsMarketplacePage_Hero__DesktopFallback_Operator>
  hero__desktopVideo?: InputMaybe<CmsMarketplacePage_Hero__DesktopVideo_Operator>
  hero__disclaimerText?: InputMaybe<CmsMarketplacePage_Hero__DisclaimerText_Operator>
  hero__heroSize?: InputMaybe<CmsMarketplacePage_Hero__HeroSize_Operator>
  hero__hzAlign?: InputMaybe<CmsMarketplacePage_Hero__HzAlign_Operator>
  hero__links__id?: InputMaybe<CmsMarketplacePage_Hero__Links__Id_Operator>
  hero__links__link__iconAfter?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__IconAfter_Operator>
  hero__links__link__iconBefore?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__IconBefore_Operator>
  hero__links__link__label?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Label_Operator>
  hero__links__link__newTab?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__NewTab_Operator>
  hero__links__link__query__id?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Id_Operator>
  hero__links__link__query__key?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Key_Operator>
  hero__links__link__query__value?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Value_Operator>
  hero__links__link__reference?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reference_Relation>
  hero__links__link__reusable?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reusable_Relation>
  hero__links__link__targetId?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__TargetId_Operator>
  hero__links__link__type?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Type_Operator>
  hero__links__link__url?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Url_Operator>
  hero__links__link__variant?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Operator>
  hero__media?: InputMaybe<CmsMarketplacePage_Hero__Media_Operator>
  hero__mobileFallback?: InputMaybe<CmsMarketplacePage_Hero__MobileFallback_Operator>
  hero__mobileVideo?: InputMaybe<CmsMarketplacePage_Hero__MobileVideo_Operator>
  hero__productImage?: InputMaybe<CmsMarketplacePage_Hero__ProductImage_Operator>
  hero__reviewRating?: InputMaybe<CmsMarketplacePage_Hero__ReviewRating_Operator>
  hero__reviewText?: InputMaybe<CmsMarketplacePage_Hero__ReviewText_Operator>
  hero__richText?: InputMaybe<CmsMarketplacePage_Hero__RichText_Operator>
  hero__richTextMax?: InputMaybe<CmsMarketplacePage_Hero__RichTextMax_Operator>
  hero__showReviews?: InputMaybe<CmsMarketplacePage_Hero__ShowReviews_Operator>
  hero__type?: InputMaybe<CmsMarketplacePage_Hero__Type_Operator>
  hero__vertAlign?: InputMaybe<CmsMarketplacePage_Hero__VertAlign_Operator>
  id?: InputMaybe<CmsMarketplacePage_Id_Operator>
  meta__description?: InputMaybe<CmsMarketplacePage_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsMarketplacePage_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsMarketplacePage_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsMarketplacePage_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsMarketplacePage_Meta__Title_Operator>
  offerCategory?: InputMaybe<CmsMarketplacePage_OfferCategory_Operator>
  parent?: InputMaybe<CmsMarketplacePage_Parent_Operator>
  publishedAt?: InputMaybe<CmsMarketplacePage_PublishedAt_Operator>
  slug?: InputMaybe<CmsMarketplacePage_Slug_Operator>
  title?: InputMaybe<CmsMarketplacePage_Title_Operator>
  updatedAt?: InputMaybe<CmsMarketplacePage_UpdatedAt_Operator>
}

export type CmsMarketplacePage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Where_Or>>>
  _status?: InputMaybe<CmsMarketplacePage__Status_Operator>
  breadcrumbs__doc?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsMarketplacePage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsMarketplacePage_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsMarketplacePage_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsMarketplacePage_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Url_Operator>
  hero__desktopFallback?: InputMaybe<CmsMarketplacePage_Hero__DesktopFallback_Operator>
  hero__desktopVideo?: InputMaybe<CmsMarketplacePage_Hero__DesktopVideo_Operator>
  hero__disclaimerText?: InputMaybe<CmsMarketplacePage_Hero__DisclaimerText_Operator>
  hero__heroSize?: InputMaybe<CmsMarketplacePage_Hero__HeroSize_Operator>
  hero__hzAlign?: InputMaybe<CmsMarketplacePage_Hero__HzAlign_Operator>
  hero__links__id?: InputMaybe<CmsMarketplacePage_Hero__Links__Id_Operator>
  hero__links__link__iconAfter?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__IconAfter_Operator>
  hero__links__link__iconBefore?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__IconBefore_Operator>
  hero__links__link__label?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Label_Operator>
  hero__links__link__newTab?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__NewTab_Operator>
  hero__links__link__query__id?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Id_Operator>
  hero__links__link__query__key?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Key_Operator>
  hero__links__link__query__value?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Value_Operator>
  hero__links__link__reference?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reference_Relation>
  hero__links__link__reusable?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reusable_Relation>
  hero__links__link__targetId?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__TargetId_Operator>
  hero__links__link__type?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Type_Operator>
  hero__links__link__url?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Url_Operator>
  hero__links__link__variant?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Operator>
  hero__media?: InputMaybe<CmsMarketplacePage_Hero__Media_Operator>
  hero__mobileFallback?: InputMaybe<CmsMarketplacePage_Hero__MobileFallback_Operator>
  hero__mobileVideo?: InputMaybe<CmsMarketplacePage_Hero__MobileVideo_Operator>
  hero__productImage?: InputMaybe<CmsMarketplacePage_Hero__ProductImage_Operator>
  hero__reviewRating?: InputMaybe<CmsMarketplacePage_Hero__ReviewRating_Operator>
  hero__reviewText?: InputMaybe<CmsMarketplacePage_Hero__ReviewText_Operator>
  hero__richText?: InputMaybe<CmsMarketplacePage_Hero__RichText_Operator>
  hero__richTextMax?: InputMaybe<CmsMarketplacePage_Hero__RichTextMax_Operator>
  hero__showReviews?: InputMaybe<CmsMarketplacePage_Hero__ShowReviews_Operator>
  hero__type?: InputMaybe<CmsMarketplacePage_Hero__Type_Operator>
  hero__vertAlign?: InputMaybe<CmsMarketplacePage_Hero__VertAlign_Operator>
  id?: InputMaybe<CmsMarketplacePage_Id_Operator>
  meta__description?: InputMaybe<CmsMarketplacePage_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsMarketplacePage_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsMarketplacePage_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsMarketplacePage_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsMarketplacePage_Meta__Title_Operator>
  offerCategory?: InputMaybe<CmsMarketplacePage_OfferCategory_Operator>
  parent?: InputMaybe<CmsMarketplacePage_Parent_Operator>
  publishedAt?: InputMaybe<CmsMarketplacePage_PublishedAt_Operator>
  slug?: InputMaybe<CmsMarketplacePage_Slug_Operator>
  title?: InputMaybe<CmsMarketplacePage_Title_Operator>
  updatedAt?: InputMaybe<CmsMarketplacePage_UpdatedAt_Operator>
}

export type CmsMarketplacePage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsMarketplacePage_Where_Or>>>
  _status?: InputMaybe<CmsMarketplacePage__Status_Operator>
  breadcrumbs__doc?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsMarketplacePage_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsMarketplacePage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsMarketplacePage_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsMarketplacePage_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsMarketplacePage_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsMarketplacePage_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsMarketplacePage_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsMarketplacePage_CustomHeader__SupportLink__Url_Operator>
  hero__desktopFallback?: InputMaybe<CmsMarketplacePage_Hero__DesktopFallback_Operator>
  hero__desktopVideo?: InputMaybe<CmsMarketplacePage_Hero__DesktopVideo_Operator>
  hero__disclaimerText?: InputMaybe<CmsMarketplacePage_Hero__DisclaimerText_Operator>
  hero__heroSize?: InputMaybe<CmsMarketplacePage_Hero__HeroSize_Operator>
  hero__hzAlign?: InputMaybe<CmsMarketplacePage_Hero__HzAlign_Operator>
  hero__links__id?: InputMaybe<CmsMarketplacePage_Hero__Links__Id_Operator>
  hero__links__link__iconAfter?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__IconAfter_Operator>
  hero__links__link__iconBefore?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__IconBefore_Operator>
  hero__links__link__label?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Label_Operator>
  hero__links__link__newTab?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__NewTab_Operator>
  hero__links__link__query__id?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Id_Operator>
  hero__links__link__query__key?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Key_Operator>
  hero__links__link__query__value?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Query__Value_Operator>
  hero__links__link__reference?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reference_Relation>
  hero__links__link__reusable?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Reusable_Relation>
  hero__links__link__targetId?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__TargetId_Operator>
  hero__links__link__type?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Type_Operator>
  hero__links__link__url?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Url_Operator>
  hero__links__link__variant?: InputMaybe<CmsMarketplacePage_Hero__Links__Link__Variant_Operator>
  hero__media?: InputMaybe<CmsMarketplacePage_Hero__Media_Operator>
  hero__mobileFallback?: InputMaybe<CmsMarketplacePage_Hero__MobileFallback_Operator>
  hero__mobileVideo?: InputMaybe<CmsMarketplacePage_Hero__MobileVideo_Operator>
  hero__productImage?: InputMaybe<CmsMarketplacePage_Hero__ProductImage_Operator>
  hero__reviewRating?: InputMaybe<CmsMarketplacePage_Hero__ReviewRating_Operator>
  hero__reviewText?: InputMaybe<CmsMarketplacePage_Hero__ReviewText_Operator>
  hero__richText?: InputMaybe<CmsMarketplacePage_Hero__RichText_Operator>
  hero__richTextMax?: InputMaybe<CmsMarketplacePage_Hero__RichTextMax_Operator>
  hero__showReviews?: InputMaybe<CmsMarketplacePage_Hero__ShowReviews_Operator>
  hero__type?: InputMaybe<CmsMarketplacePage_Hero__Type_Operator>
  hero__vertAlign?: InputMaybe<CmsMarketplacePage_Hero__VertAlign_Operator>
  id?: InputMaybe<CmsMarketplacePage_Id_Operator>
  meta__description?: InputMaybe<CmsMarketplacePage_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsMarketplacePage_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsMarketplacePage_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsMarketplacePage_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsMarketplacePage_Meta__Title_Operator>
  offerCategory?: InputMaybe<CmsMarketplacePage_OfferCategory_Operator>
  parent?: InputMaybe<CmsMarketplacePage_Parent_Operator>
  publishedAt?: InputMaybe<CmsMarketplacePage_PublishedAt_Operator>
  slug?: InputMaybe<CmsMarketplacePage_Slug_Operator>
  title?: InputMaybe<CmsMarketplacePage_Title_Operator>
  updatedAt?: InputMaybe<CmsMarketplacePage_UpdatedAt_Operator>
}

export type CmsMarketplacePages = {
  __typename?: 'CmsMarketplacePages'
  docs?: Maybe<Array<Maybe<CmsMarketplacePage>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsMedia = {
  __typename?: 'CmsMedia'
  alt: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  focalX?: Maybe<Scalars['Float']['output']>
  focalY?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  id: Scalars['Int']['output']
  mimeType?: Maybe<Scalars['String']['output']>
  prefix?: Maybe<Scalars['String']['output']>
  sizes?: Maybe<CmsMedia_Sizes>
  thumbnailURL?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes = {
  __typename?: 'CmsMedia_Sizes'
  banner?: Maybe<CmsMedia_Sizes_Banner>
  card?: Maybe<CmsMedia_Sizes_Card>
  feature?: Maybe<CmsMedia_Sizes_Feature>
  largeAutoHeight?: Maybe<CmsMedia_Sizes_LargeAutoHeight>
  largeHero?: Maybe<CmsMedia_Sizes_LargeHero>
  portrait?: Maybe<CmsMedia_Sizes_Portrait>
  smallAutoHeight?: Maybe<CmsMedia_Sizes_SmallAutoHeight>
  square?: Maybe<CmsMedia_Sizes_Square>
  squareThumbnail?: Maybe<CmsMedia_Sizes_SquareThumbnail>
}

export type CmsMedia_Sizes_Banner = {
  __typename?: 'CmsMedia_Sizes_Banner'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_Card = {
  __typename?: 'CmsMedia_Sizes_Card'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_Feature = {
  __typename?: 'CmsMedia_Sizes_Feature'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_LargeAutoHeight = {
  __typename?: 'CmsMedia_Sizes_LargeAutoHeight'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_LargeHero = {
  __typename?: 'CmsMedia_Sizes_LargeHero'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_Portrait = {
  __typename?: 'CmsMedia_Sizes_Portrait'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_SmallAutoHeight = {
  __typename?: 'CmsMedia_Sizes_SmallAutoHeight'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_Square = {
  __typename?: 'CmsMedia_Sizes_Square'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Sizes_SquareThumbnail = {
  __typename?: 'CmsMedia_Sizes_SquareThumbnail'
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsMedia_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsMedia_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsMedia_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_FocalX_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_FocalY_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsMedia_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Prefix_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Banner__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Banner__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Banner__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Banner__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Banner__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Banner__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Feature__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Feature__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Feature__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Feature__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Feature__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Feature__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__LargeAutoHeight__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__LargeAutoHeight__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__LargeAutoHeight__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__LargeAutoHeight__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__LargeAutoHeight__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__LargeAutoHeight__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__LargeHero__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__LargeHero__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__LargeHero__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__LargeHero__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__LargeHero__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__LargeHero__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__SmallAutoHeight__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__SmallAutoHeight__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__SmallAutoHeight__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__SmallAutoHeight__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__SmallAutoHeight__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__SmallAutoHeight__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__SquareThumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__SquareThumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__SquareThumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__SquareThumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__SquareThumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__SquareThumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Square__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Square__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Square__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_Sizes__Square__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Square__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Sizes__Square__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedia_ThumbnailUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsMedia_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsMedia_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsMedia_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsMedia_Where_Or>>>
  alt?: InputMaybe<CmsMedia_Alt_Operator>
  createdAt?: InputMaybe<CmsMedia_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsMedia_CreatedBy_Operator>
  filename?: InputMaybe<CmsMedia_Filename_Operator>
  filesize?: InputMaybe<CmsMedia_Filesize_Operator>
  focalX?: InputMaybe<CmsMedia_FocalX_Operator>
  focalY?: InputMaybe<CmsMedia_FocalY_Operator>
  height?: InputMaybe<CmsMedia_Height_Operator>
  id?: InputMaybe<CmsMedia_Id_Operator>
  mimeType?: InputMaybe<CmsMedia_MimeType_Operator>
  prefix?: InputMaybe<CmsMedia_Prefix_Operator>
  sizes__banner__filename?: InputMaybe<CmsMedia_Sizes__Banner__Filename_Operator>
  sizes__banner__filesize?: InputMaybe<CmsMedia_Sizes__Banner__Filesize_Operator>
  sizes__banner__height?: InputMaybe<CmsMedia_Sizes__Banner__Height_Operator>
  sizes__banner__mimeType?: InputMaybe<CmsMedia_Sizes__Banner__MimeType_Operator>
  sizes__banner__url?: InputMaybe<CmsMedia_Sizes__Banner__Url_Operator>
  sizes__banner__width?: InputMaybe<CmsMedia_Sizes__Banner__Width_Operator>
  sizes__card__filename?: InputMaybe<CmsMedia_Sizes__Card__Filename_Operator>
  sizes__card__filesize?: InputMaybe<CmsMedia_Sizes__Card__Filesize_Operator>
  sizes__card__height?: InputMaybe<CmsMedia_Sizes__Card__Height_Operator>
  sizes__card__mimeType?: InputMaybe<CmsMedia_Sizes__Card__MimeType_Operator>
  sizes__card__url?: InputMaybe<CmsMedia_Sizes__Card__Url_Operator>
  sizes__card__width?: InputMaybe<CmsMedia_Sizes__Card__Width_Operator>
  sizes__feature__filename?: InputMaybe<CmsMedia_Sizes__Feature__Filename_Operator>
  sizes__feature__filesize?: InputMaybe<CmsMedia_Sizes__Feature__Filesize_Operator>
  sizes__feature__height?: InputMaybe<CmsMedia_Sizes__Feature__Height_Operator>
  sizes__feature__mimeType?: InputMaybe<CmsMedia_Sizes__Feature__MimeType_Operator>
  sizes__feature__url?: InputMaybe<CmsMedia_Sizes__Feature__Url_Operator>
  sizes__feature__width?: InputMaybe<CmsMedia_Sizes__Feature__Width_Operator>
  sizes__largeAutoHeight__filename?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Filename_Operator>
  sizes__largeAutoHeight__filesize?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Filesize_Operator>
  sizes__largeAutoHeight__height?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Height_Operator>
  sizes__largeAutoHeight__mimeType?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__MimeType_Operator>
  sizes__largeAutoHeight__url?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Url_Operator>
  sizes__largeAutoHeight__width?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Width_Operator>
  sizes__largeHero__filename?: InputMaybe<CmsMedia_Sizes__LargeHero__Filename_Operator>
  sizes__largeHero__filesize?: InputMaybe<CmsMedia_Sizes__LargeHero__Filesize_Operator>
  sizes__largeHero__height?: InputMaybe<CmsMedia_Sizes__LargeHero__Height_Operator>
  sizes__largeHero__mimeType?: InputMaybe<CmsMedia_Sizes__LargeHero__MimeType_Operator>
  sizes__largeHero__url?: InputMaybe<CmsMedia_Sizes__LargeHero__Url_Operator>
  sizes__largeHero__width?: InputMaybe<CmsMedia_Sizes__LargeHero__Width_Operator>
  sizes__portrait__filename?: InputMaybe<CmsMedia_Sizes__Portrait__Filename_Operator>
  sizes__portrait__filesize?: InputMaybe<CmsMedia_Sizes__Portrait__Filesize_Operator>
  sizes__portrait__height?: InputMaybe<CmsMedia_Sizes__Portrait__Height_Operator>
  sizes__portrait__mimeType?: InputMaybe<CmsMedia_Sizes__Portrait__MimeType_Operator>
  sizes__portrait__url?: InputMaybe<CmsMedia_Sizes__Portrait__Url_Operator>
  sizes__portrait__width?: InputMaybe<CmsMedia_Sizes__Portrait__Width_Operator>
  sizes__smallAutoHeight__filename?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Filename_Operator>
  sizes__smallAutoHeight__filesize?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Filesize_Operator>
  sizes__smallAutoHeight__height?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Height_Operator>
  sizes__smallAutoHeight__mimeType?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__MimeType_Operator>
  sizes__smallAutoHeight__url?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Url_Operator>
  sizes__smallAutoHeight__width?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Width_Operator>
  sizes__squareThumbnail__filename?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Filename_Operator>
  sizes__squareThumbnail__filesize?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Filesize_Operator>
  sizes__squareThumbnail__height?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Height_Operator>
  sizes__squareThumbnail__mimeType?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__MimeType_Operator>
  sizes__squareThumbnail__url?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Url_Operator>
  sizes__squareThumbnail__width?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Width_Operator>
  sizes__square__filename?: InputMaybe<CmsMedia_Sizes__Square__Filename_Operator>
  sizes__square__filesize?: InputMaybe<CmsMedia_Sizes__Square__Filesize_Operator>
  sizes__square__height?: InputMaybe<CmsMedia_Sizes__Square__Height_Operator>
  sizes__square__mimeType?: InputMaybe<CmsMedia_Sizes__Square__MimeType_Operator>
  sizes__square__url?: InputMaybe<CmsMedia_Sizes__Square__Url_Operator>
  sizes__square__width?: InputMaybe<CmsMedia_Sizes__Square__Width_Operator>
  thumbnailURL?: InputMaybe<CmsMedia_ThumbnailUrl_Operator>
  updatedAt?: InputMaybe<CmsMedia_UpdatedAt_Operator>
  url?: InputMaybe<CmsMedia_Url_Operator>
  width?: InputMaybe<CmsMedia_Width_Operator>
}

export type CmsMedia_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsMedia_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsMedia_Where_Or>>>
  alt?: InputMaybe<CmsMedia_Alt_Operator>
  createdAt?: InputMaybe<CmsMedia_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsMedia_CreatedBy_Operator>
  filename?: InputMaybe<CmsMedia_Filename_Operator>
  filesize?: InputMaybe<CmsMedia_Filesize_Operator>
  focalX?: InputMaybe<CmsMedia_FocalX_Operator>
  focalY?: InputMaybe<CmsMedia_FocalY_Operator>
  height?: InputMaybe<CmsMedia_Height_Operator>
  id?: InputMaybe<CmsMedia_Id_Operator>
  mimeType?: InputMaybe<CmsMedia_MimeType_Operator>
  prefix?: InputMaybe<CmsMedia_Prefix_Operator>
  sizes__banner__filename?: InputMaybe<CmsMedia_Sizes__Banner__Filename_Operator>
  sizes__banner__filesize?: InputMaybe<CmsMedia_Sizes__Banner__Filesize_Operator>
  sizes__banner__height?: InputMaybe<CmsMedia_Sizes__Banner__Height_Operator>
  sizes__banner__mimeType?: InputMaybe<CmsMedia_Sizes__Banner__MimeType_Operator>
  sizes__banner__url?: InputMaybe<CmsMedia_Sizes__Banner__Url_Operator>
  sizes__banner__width?: InputMaybe<CmsMedia_Sizes__Banner__Width_Operator>
  sizes__card__filename?: InputMaybe<CmsMedia_Sizes__Card__Filename_Operator>
  sizes__card__filesize?: InputMaybe<CmsMedia_Sizes__Card__Filesize_Operator>
  sizes__card__height?: InputMaybe<CmsMedia_Sizes__Card__Height_Operator>
  sizes__card__mimeType?: InputMaybe<CmsMedia_Sizes__Card__MimeType_Operator>
  sizes__card__url?: InputMaybe<CmsMedia_Sizes__Card__Url_Operator>
  sizes__card__width?: InputMaybe<CmsMedia_Sizes__Card__Width_Operator>
  sizes__feature__filename?: InputMaybe<CmsMedia_Sizes__Feature__Filename_Operator>
  sizes__feature__filesize?: InputMaybe<CmsMedia_Sizes__Feature__Filesize_Operator>
  sizes__feature__height?: InputMaybe<CmsMedia_Sizes__Feature__Height_Operator>
  sizes__feature__mimeType?: InputMaybe<CmsMedia_Sizes__Feature__MimeType_Operator>
  sizes__feature__url?: InputMaybe<CmsMedia_Sizes__Feature__Url_Operator>
  sizes__feature__width?: InputMaybe<CmsMedia_Sizes__Feature__Width_Operator>
  sizes__largeAutoHeight__filename?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Filename_Operator>
  sizes__largeAutoHeight__filesize?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Filesize_Operator>
  sizes__largeAutoHeight__height?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Height_Operator>
  sizes__largeAutoHeight__mimeType?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__MimeType_Operator>
  sizes__largeAutoHeight__url?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Url_Operator>
  sizes__largeAutoHeight__width?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Width_Operator>
  sizes__largeHero__filename?: InputMaybe<CmsMedia_Sizes__LargeHero__Filename_Operator>
  sizes__largeHero__filesize?: InputMaybe<CmsMedia_Sizes__LargeHero__Filesize_Operator>
  sizes__largeHero__height?: InputMaybe<CmsMedia_Sizes__LargeHero__Height_Operator>
  sizes__largeHero__mimeType?: InputMaybe<CmsMedia_Sizes__LargeHero__MimeType_Operator>
  sizes__largeHero__url?: InputMaybe<CmsMedia_Sizes__LargeHero__Url_Operator>
  sizes__largeHero__width?: InputMaybe<CmsMedia_Sizes__LargeHero__Width_Operator>
  sizes__portrait__filename?: InputMaybe<CmsMedia_Sizes__Portrait__Filename_Operator>
  sizes__portrait__filesize?: InputMaybe<CmsMedia_Sizes__Portrait__Filesize_Operator>
  sizes__portrait__height?: InputMaybe<CmsMedia_Sizes__Portrait__Height_Operator>
  sizes__portrait__mimeType?: InputMaybe<CmsMedia_Sizes__Portrait__MimeType_Operator>
  sizes__portrait__url?: InputMaybe<CmsMedia_Sizes__Portrait__Url_Operator>
  sizes__portrait__width?: InputMaybe<CmsMedia_Sizes__Portrait__Width_Operator>
  sizes__smallAutoHeight__filename?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Filename_Operator>
  sizes__smallAutoHeight__filesize?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Filesize_Operator>
  sizes__smallAutoHeight__height?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Height_Operator>
  sizes__smallAutoHeight__mimeType?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__MimeType_Operator>
  sizes__smallAutoHeight__url?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Url_Operator>
  sizes__smallAutoHeight__width?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Width_Operator>
  sizes__squareThumbnail__filename?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Filename_Operator>
  sizes__squareThumbnail__filesize?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Filesize_Operator>
  sizes__squareThumbnail__height?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Height_Operator>
  sizes__squareThumbnail__mimeType?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__MimeType_Operator>
  sizes__squareThumbnail__url?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Url_Operator>
  sizes__squareThumbnail__width?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Width_Operator>
  sizes__square__filename?: InputMaybe<CmsMedia_Sizes__Square__Filename_Operator>
  sizes__square__filesize?: InputMaybe<CmsMedia_Sizes__Square__Filesize_Operator>
  sizes__square__height?: InputMaybe<CmsMedia_Sizes__Square__Height_Operator>
  sizes__square__mimeType?: InputMaybe<CmsMedia_Sizes__Square__MimeType_Operator>
  sizes__square__url?: InputMaybe<CmsMedia_Sizes__Square__Url_Operator>
  sizes__square__width?: InputMaybe<CmsMedia_Sizes__Square__Width_Operator>
  thumbnailURL?: InputMaybe<CmsMedia_ThumbnailUrl_Operator>
  updatedAt?: InputMaybe<CmsMedia_UpdatedAt_Operator>
  url?: InputMaybe<CmsMedia_Url_Operator>
  width?: InputMaybe<CmsMedia_Width_Operator>
}

export type CmsMedia_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsMedia_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsMedia_Where_Or>>>
  alt?: InputMaybe<CmsMedia_Alt_Operator>
  createdAt?: InputMaybe<CmsMedia_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsMedia_CreatedBy_Operator>
  filename?: InputMaybe<CmsMedia_Filename_Operator>
  filesize?: InputMaybe<CmsMedia_Filesize_Operator>
  focalX?: InputMaybe<CmsMedia_FocalX_Operator>
  focalY?: InputMaybe<CmsMedia_FocalY_Operator>
  height?: InputMaybe<CmsMedia_Height_Operator>
  id?: InputMaybe<CmsMedia_Id_Operator>
  mimeType?: InputMaybe<CmsMedia_MimeType_Operator>
  prefix?: InputMaybe<CmsMedia_Prefix_Operator>
  sizes__banner__filename?: InputMaybe<CmsMedia_Sizes__Banner__Filename_Operator>
  sizes__banner__filesize?: InputMaybe<CmsMedia_Sizes__Banner__Filesize_Operator>
  sizes__banner__height?: InputMaybe<CmsMedia_Sizes__Banner__Height_Operator>
  sizes__banner__mimeType?: InputMaybe<CmsMedia_Sizes__Banner__MimeType_Operator>
  sizes__banner__url?: InputMaybe<CmsMedia_Sizes__Banner__Url_Operator>
  sizes__banner__width?: InputMaybe<CmsMedia_Sizes__Banner__Width_Operator>
  sizes__card__filename?: InputMaybe<CmsMedia_Sizes__Card__Filename_Operator>
  sizes__card__filesize?: InputMaybe<CmsMedia_Sizes__Card__Filesize_Operator>
  sizes__card__height?: InputMaybe<CmsMedia_Sizes__Card__Height_Operator>
  sizes__card__mimeType?: InputMaybe<CmsMedia_Sizes__Card__MimeType_Operator>
  sizes__card__url?: InputMaybe<CmsMedia_Sizes__Card__Url_Operator>
  sizes__card__width?: InputMaybe<CmsMedia_Sizes__Card__Width_Operator>
  sizes__feature__filename?: InputMaybe<CmsMedia_Sizes__Feature__Filename_Operator>
  sizes__feature__filesize?: InputMaybe<CmsMedia_Sizes__Feature__Filesize_Operator>
  sizes__feature__height?: InputMaybe<CmsMedia_Sizes__Feature__Height_Operator>
  sizes__feature__mimeType?: InputMaybe<CmsMedia_Sizes__Feature__MimeType_Operator>
  sizes__feature__url?: InputMaybe<CmsMedia_Sizes__Feature__Url_Operator>
  sizes__feature__width?: InputMaybe<CmsMedia_Sizes__Feature__Width_Operator>
  sizes__largeAutoHeight__filename?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Filename_Operator>
  sizes__largeAutoHeight__filesize?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Filesize_Operator>
  sizes__largeAutoHeight__height?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Height_Operator>
  sizes__largeAutoHeight__mimeType?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__MimeType_Operator>
  sizes__largeAutoHeight__url?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Url_Operator>
  sizes__largeAutoHeight__width?: InputMaybe<CmsMedia_Sizes__LargeAutoHeight__Width_Operator>
  sizes__largeHero__filename?: InputMaybe<CmsMedia_Sizes__LargeHero__Filename_Operator>
  sizes__largeHero__filesize?: InputMaybe<CmsMedia_Sizes__LargeHero__Filesize_Operator>
  sizes__largeHero__height?: InputMaybe<CmsMedia_Sizes__LargeHero__Height_Operator>
  sizes__largeHero__mimeType?: InputMaybe<CmsMedia_Sizes__LargeHero__MimeType_Operator>
  sizes__largeHero__url?: InputMaybe<CmsMedia_Sizes__LargeHero__Url_Operator>
  sizes__largeHero__width?: InputMaybe<CmsMedia_Sizes__LargeHero__Width_Operator>
  sizes__portrait__filename?: InputMaybe<CmsMedia_Sizes__Portrait__Filename_Operator>
  sizes__portrait__filesize?: InputMaybe<CmsMedia_Sizes__Portrait__Filesize_Operator>
  sizes__portrait__height?: InputMaybe<CmsMedia_Sizes__Portrait__Height_Operator>
  sizes__portrait__mimeType?: InputMaybe<CmsMedia_Sizes__Portrait__MimeType_Operator>
  sizes__portrait__url?: InputMaybe<CmsMedia_Sizes__Portrait__Url_Operator>
  sizes__portrait__width?: InputMaybe<CmsMedia_Sizes__Portrait__Width_Operator>
  sizes__smallAutoHeight__filename?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Filename_Operator>
  sizes__smallAutoHeight__filesize?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Filesize_Operator>
  sizes__smallAutoHeight__height?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Height_Operator>
  sizes__smallAutoHeight__mimeType?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__MimeType_Operator>
  sizes__smallAutoHeight__url?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Url_Operator>
  sizes__smallAutoHeight__width?: InputMaybe<CmsMedia_Sizes__SmallAutoHeight__Width_Operator>
  sizes__squareThumbnail__filename?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Filename_Operator>
  sizes__squareThumbnail__filesize?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Filesize_Operator>
  sizes__squareThumbnail__height?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Height_Operator>
  sizes__squareThumbnail__mimeType?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__MimeType_Operator>
  sizes__squareThumbnail__url?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Url_Operator>
  sizes__squareThumbnail__width?: InputMaybe<CmsMedia_Sizes__SquareThumbnail__Width_Operator>
  sizes__square__filename?: InputMaybe<CmsMedia_Sizes__Square__Filename_Operator>
  sizes__square__filesize?: InputMaybe<CmsMedia_Sizes__Square__Filesize_Operator>
  sizes__square__height?: InputMaybe<CmsMedia_Sizes__Square__Height_Operator>
  sizes__square__mimeType?: InputMaybe<CmsMedia_Sizes__Square__MimeType_Operator>
  sizes__square__url?: InputMaybe<CmsMedia_Sizes__Square__Url_Operator>
  sizes__square__width?: InputMaybe<CmsMedia_Sizes__Square__Width_Operator>
  thumbnailURL?: InputMaybe<CmsMedia_ThumbnailUrl_Operator>
  updatedAt?: InputMaybe<CmsMedia_UpdatedAt_Operator>
  url?: InputMaybe<CmsMedia_Url_Operator>
  width?: InputMaybe<CmsMedia_Width_Operator>
}

export type CmsMedia_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsMedias = {
  __typename?: 'CmsMedias'
  docs?: Maybe<Array<Maybe<CmsMedia>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsMessageFormField = {
  __typename?: 'CmsMessageFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['JSON']['output']>
}

export type CmsMessageFormFieldMessageArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsMeta = {
  __typename?: 'CmsMeta'
  description?: Maybe<Scalars['String']['output']>
  image?: Maybe<CmsMedia>
  jsonLD?: Maybe<Scalars['String']['output']>
  noIndex?: Maybe<Scalars['Boolean']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type CmsNewsroomArticle = {
  __typename?: 'CmsNewsroomArticle'
  _status?: Maybe<CmsNewsroomArticle__Status>
  authors?: Maybe<Array<CmsAuthor>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  excerpt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  image?: Maybe<CmsMedia>
  meta?: Maybe<CmsMeta>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  richText?: Maybe<Scalars['JSON']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  wordpressPostId?: Maybe<Scalars['String']['output']>
}

export type CmsNewsroomArticleRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export const CmsNewsroomArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsNewsroomArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsNewsroomArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsNewsroomArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsNewsroomArticleUpdate_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsNewsroomArticleUpdate_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsNewsroomArticleUpdate_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsNewsroomArticleUpdate_CustomHeader_HeaderDisplay_MutationInput]
export const CmsNewsroomArticleUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsNewsroomArticleUpdate__Status_MutationInput =
  (typeof CmsNewsroomArticleUpdate__Status_MutationInput)[keyof typeof CmsNewsroomArticleUpdate__Status_MutationInput]
export type CmsNewsroomArticleVersion = {
  __typename?: 'CmsNewsroomArticleVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsNewsroomArticle>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsNewsroomArticleVersion_Version>
}

export type CmsNewsroomArticleVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsNewsroomArticleVersion_Version = {
  __typename?: 'CmsNewsroomArticleVersion_Version'
  _status?: Maybe<CmsNewsroomArticleVersion_Version__Status>
  authors?: Maybe<Array<CmsAuthor>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  excerpt?: Maybe<Scalars['String']['output']>
  image?: Maybe<CmsMedia>
  meta?: Maybe<CmsMeta>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  richText?: Maybe<Scalars['JSON']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  wordpressPostId?: Maybe<Scalars['String']['output']>
}

export type CmsNewsroomArticleVersion_VersionRichTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export const CmsNewsroomArticleVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsNewsroomArticleVersion_Version__Status =
  (typeof CmsNewsroomArticleVersion_Version__Status)[keyof typeof CmsNewsroomArticleVersion_Version__Status]
export const CmsNewsroomArticle_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsNewsroomArticle_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsNewsroomArticle_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsNewsroomArticle_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsNewsroomArticle_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsNewsroomArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsNewsroomArticle_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsNewsroomArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsNewsroomArticle_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsNewsroomArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsNewsroomArticle_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsNewsroomArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsNewsroomArticle_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsNewsroomArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsNewsroomArticle_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsNewsroomArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsNewsroomArticle_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsNewsroomArticle_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsNewsroomArticle_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsNewsroomArticle_CustomHeader_HeaderDisplay_MutationInput]
export const CmsNewsroomArticle__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsNewsroomArticle__Status = (typeof CmsNewsroomArticle__Status)[keyof typeof CmsNewsroomArticle__Status]
export const CmsNewsroomArticle__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsNewsroomArticle__Status_Input =
  (typeof CmsNewsroomArticle__Status_Input)[keyof typeof CmsNewsroomArticle__Status_Input]
export const CmsNewsroomArticle__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsNewsroomArticle__Status_MutationInput =
  (typeof CmsNewsroomArticle__Status_MutationInput)[keyof typeof CmsNewsroomArticle__Status_MutationInput]
export type CmsNewsroomArticle__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle__Status_Input>>>
  equals?: InputMaybe<CmsNewsroomArticle__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle__Status_Input>>>
  not_equals?: InputMaybe<CmsNewsroomArticle__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle__Status_Input>>>
}

export type CmsNewsroomArticle_Authors_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsNewsroomArticle_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsNewsroomArticle_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input =
  (typeof CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input)[keyof typeof CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input]
export type CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Input>>>
}

export type CmsNewsroomArticle_CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsNewsroomArticle_CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsNewsroomArticle_CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsNewsroomArticle_CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input =
  (typeof CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input)[keyof typeof CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input]
export type CmsNewsroomArticle_CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Input>>>
}

export type CmsNewsroomArticle_CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsNewsroomArticle_CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsNewsroomArticle_CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type CmsNewsroomArticle_CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input =
  (typeof CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input)[keyof typeof CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input]
export type CmsNewsroomArticle_CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Type_Input>
}

export type CmsNewsroomArticle_CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsNewsroomArticle_CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type CmsNewsroomArticle_CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input =
  (typeof CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input)[keyof typeof CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input]
export type CmsNewsroomArticle_CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Type_Input>
}

export type CmsNewsroomArticle_CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsNewsroomArticle_CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type CmsNewsroomArticle_CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input =
  (typeof CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input)[keyof typeof CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input]
export type CmsNewsroomArticle_CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Type_Input>
}

export type CmsNewsroomArticle_CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsNewsroomArticle_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsNewsroomArticle_Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsNewsroomArticle_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsNewsroomArticle_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsNewsroomArticle_Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsNewsroomArticle_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsNewsroomArticle_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsNewsroomArticle_RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsNewsroomArticle_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticle_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsNewsroomArticle_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_Where_Or>>>
  _status?: InputMaybe<CmsNewsroomArticle__Status_Operator>
  authors?: InputMaybe<CmsNewsroomArticle_Authors_Operator>
  createdAt?: InputMaybe<CmsNewsroomArticle_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsNewsroomArticle_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsNewsroomArticle_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsNewsroomArticle_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Url_Operator>
  excerpt?: InputMaybe<CmsNewsroomArticle_Excerpt_Operator>
  id?: InputMaybe<CmsNewsroomArticle_Id_Operator>
  image?: InputMaybe<CmsNewsroomArticle_Image_Operator>
  meta__description?: InputMaybe<CmsNewsroomArticle_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsNewsroomArticle_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsNewsroomArticle_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsNewsroomArticle_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsNewsroomArticle_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsNewsroomArticle_PublishedAt_Operator>
  richText?: InputMaybe<CmsNewsroomArticle_RichText_Operator>
  slug?: InputMaybe<CmsNewsroomArticle_Slug_Operator>
  title?: InputMaybe<CmsNewsroomArticle_Title_Operator>
  updatedAt?: InputMaybe<CmsNewsroomArticle_UpdatedAt_Operator>
  wordpressPostId?: InputMaybe<CmsNewsroomArticle_WordpressPostId_Operator>
}

export type CmsNewsroomArticle_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_Where_Or>>>
  _status?: InputMaybe<CmsNewsroomArticle__Status_Operator>
  authors?: InputMaybe<CmsNewsroomArticle_Authors_Operator>
  createdAt?: InputMaybe<CmsNewsroomArticle_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsNewsroomArticle_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsNewsroomArticle_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsNewsroomArticle_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Url_Operator>
  excerpt?: InputMaybe<CmsNewsroomArticle_Excerpt_Operator>
  id?: InputMaybe<CmsNewsroomArticle_Id_Operator>
  image?: InputMaybe<CmsNewsroomArticle_Image_Operator>
  meta__description?: InputMaybe<CmsNewsroomArticle_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsNewsroomArticle_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsNewsroomArticle_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsNewsroomArticle_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsNewsroomArticle_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsNewsroomArticle_PublishedAt_Operator>
  richText?: InputMaybe<CmsNewsroomArticle_RichText_Operator>
  slug?: InputMaybe<CmsNewsroomArticle_Slug_Operator>
  title?: InputMaybe<CmsNewsroomArticle_Title_Operator>
  updatedAt?: InputMaybe<CmsNewsroomArticle_UpdatedAt_Operator>
  wordpressPostId?: InputMaybe<CmsNewsroomArticle_WordpressPostId_Operator>
}

export type CmsNewsroomArticle_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsNewsroomArticle_Where_Or>>>
  _status?: InputMaybe<CmsNewsroomArticle__Status_Operator>
  authors?: InputMaybe<CmsNewsroomArticle_Authors_Operator>
  createdAt?: InputMaybe<CmsNewsroomArticle_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsNewsroomArticle_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsNewsroomArticle_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsNewsroomArticle_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsNewsroomArticle_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsNewsroomArticle_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsNewsroomArticle_CustomHeader__SupportLink__Url_Operator>
  excerpt?: InputMaybe<CmsNewsroomArticle_Excerpt_Operator>
  id?: InputMaybe<CmsNewsroomArticle_Id_Operator>
  image?: InputMaybe<CmsNewsroomArticle_Image_Operator>
  meta__description?: InputMaybe<CmsNewsroomArticle_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsNewsroomArticle_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsNewsroomArticle_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsNewsroomArticle_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsNewsroomArticle_Meta__Title_Operator>
  publishedAt?: InputMaybe<CmsNewsroomArticle_PublishedAt_Operator>
  richText?: InputMaybe<CmsNewsroomArticle_RichText_Operator>
  slug?: InputMaybe<CmsNewsroomArticle_Slug_Operator>
  title?: InputMaybe<CmsNewsroomArticle_Title_Operator>
  updatedAt?: InputMaybe<CmsNewsroomArticle_UpdatedAt_Operator>
  wordpressPostId?: InputMaybe<CmsNewsroomArticle_WordpressPostId_Operator>
}

export type CmsNewsroomArticle_WordpressPostId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsNewsroomArticles = {
  __typename?: 'CmsNewsroomArticles'
  docs?: Maybe<Array<Maybe<CmsNewsroomArticle>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsNumberFormField = {
  __typename?: 'CmsNumberFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  defaultValue?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsOfferBlock = {
  __typename?: 'CmsOfferBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsOfferBlock_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  marketplaceOffer?: Maybe<CmsOfferBlock_MarketplaceOffer>
  section?: Maybe<CmsSection>
}

export type CmsOfferBlock_Ctas = {
  __typename?: 'CmsOfferBlock_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsOfferBlock_MarketplaceOffer = {
  __typename?: 'CmsOfferBlock_MarketplaceOffer'
  category?: Maybe<Scalars['String']['output']>
  offerId?: Maybe<Scalars['String']['output']>
}

export type CmsPage = {
  __typename?: 'CmsPage'
  _status?: Maybe<CmsPage__Status>
  breadcrumbs?: Maybe<Array<CmsPage_Breadcrumbs>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  hero?: Maybe<CmsHero>
  id: Scalars['Int']['output']
  meta?: Maybe<CmsMeta>
  parent?: Maybe<CmsPage>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsPageParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsPageUpdate_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsPageUpdate_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsPageUpdate_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsPageUpdate_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsPageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsPageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsPageUpdate_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsPageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsPageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsPageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsPageUpdate_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsPageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsPageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsPageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsPageUpdate_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsPageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsPageUpdate_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsPageUpdate_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsPageUpdate_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsPageUpdate_CustomHeader_HeaderDisplay_MutationInput]
export type CmsPageUpdate_Hero_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsPageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_Hero_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsPageUpdate_Hero_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsPageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsPageUpdate_Hero_Links_Link_ReusableRelationshipInputRelationTo]
export const CmsPageUpdate_Hero_Links_Link_Variant_MutationInput = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsPageUpdate_Hero_Links_Link_Variant_MutationInput =
  (typeof CmsPageUpdate_Hero_Links_Link_Variant_MutationInput)[keyof typeof CmsPageUpdate_Hero_Links_Link_Variant_MutationInput]
export const CmsPageUpdate_Hero_HzAlign_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsPageUpdate_Hero_HzAlign_MutationInput =
  (typeof CmsPageUpdate_Hero_HzAlign_MutationInput)[keyof typeof CmsPageUpdate_Hero_HzAlign_MutationInput]
export const CmsPageUpdate_Hero_Type_MutationInput = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsPageUpdate_Hero_Type_MutationInput =
  (typeof CmsPageUpdate_Hero_Type_MutationInput)[keyof typeof CmsPageUpdate_Hero_Type_MutationInput]
export const CmsPageUpdate_Hero_VertAlign_MutationInput = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsPageUpdate_Hero_VertAlign_MutationInput =
  (typeof CmsPageUpdate_Hero_VertAlign_MutationInput)[keyof typeof CmsPageUpdate_Hero_VertAlign_MutationInput]
export const CmsPageUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsPageUpdate__Status_MutationInput =
  (typeof CmsPageUpdate__Status_MutationInput)[keyof typeof CmsPageUpdate__Status_MutationInput]
export type CmsPageVersion = {
  __typename?: 'CmsPageVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsPage>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsPageVersion_Version>
}

export type CmsPageVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPageVersion_Version = {
  __typename?: 'CmsPageVersion_Version'
  _status?: Maybe<CmsPageVersion_Version__Status>
  breadcrumbs?: Maybe<Array<CmsPageVersion_Version_Breadcrumbs>>
  content?: Maybe<CmsContentLayout>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  customFooter?: Maybe<CmsCustomFooter>
  customHeader?: Maybe<CmsCustomHeader>
  hero?: Maybe<CmsHero>
  meta?: Maybe<CmsMeta>
  parent?: Maybe<CmsPage>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsPageVersion_VersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPageVersion_Version_Breadcrumbs = {
  __typename?: 'CmsPageVersion_Version_Breadcrumbs'
  doc?: Maybe<CmsPage>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsPageVersion_Version_BreadcrumbsDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsPageVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsPageVersion_Version__Status =
  (typeof CmsPageVersion_Version__Status)[keyof typeof CmsPageVersion_Version__Status]
export type CmsPage_Breadcrumbs = {
  __typename?: 'CmsPage_Breadcrumbs'
  doc?: Maybe<CmsPage>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsPage_BreadcrumbsDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsPage_CustomFooter_Disclaimers_Align_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsPage_CustomFooter_Disclaimers_Align_MutationInput =
  (typeof CmsPage_CustomFooter_Disclaimers_Align_MutationInput)[keyof typeof CmsPage_CustomFooter_Disclaimers_Align_MutationInput]
export type CmsPage_CustomHeader_LoginLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsPage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPage_CustomHeader_LoginLink_ReferenceRelationshipInputRelationTo]
export type CmsPage_CustomHeader_LoginLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo =
  (typeof CmsPage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsPage_CustomHeader_LoginLink_ReusableRelationshipInputRelationTo]
export type CmsPage_CustomHeader_SignupLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsPage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPage_CustomHeader_SignupLink_ReferenceRelationshipInputRelationTo]
export type CmsPage_CustomHeader_SignupLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo =
  (typeof CmsPage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsPage_CustomHeader_SignupLink_ReusableRelationshipInputRelationTo]
export type CmsPage_CustomHeader_SupportLink_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo =
  (typeof CmsPage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPage_CustomHeader_SupportLink_ReferenceRelationshipInputRelationTo]
export type CmsPage_CustomHeader_SupportLink_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo =
  (typeof CmsPage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo)[keyof typeof CmsPage_CustomHeader_SupportLink_ReusableRelationshipInputRelationTo]
export const CmsPage_CustomHeader_HeaderDisplay_MutationInput = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsPage_CustomHeader_HeaderDisplay_MutationInput =
  (typeof CmsPage_CustomHeader_HeaderDisplay_MutationInput)[keyof typeof CmsPage_CustomHeader_HeaderDisplay_MutationInput]
export type CmsPage_Hero_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_Hero_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_Hero_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_Hero_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsPage_Hero_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsPage_Hero_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsPage_Hero_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsPage_Hero_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_Hero_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsPage_Hero_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsPage_Hero_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsPage_Hero_Links_Link_ReusableRelationshipInputRelationTo]
export const CmsPage_Hero_Links_Link_Variant_MutationInput = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsPage_Hero_Links_Link_Variant_MutationInput =
  (typeof CmsPage_Hero_Links_Link_Variant_MutationInput)[keyof typeof CmsPage_Hero_Links_Link_Variant_MutationInput]
export const CmsPage_Hero_HzAlign_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsPage_Hero_HzAlign_MutationInput =
  (typeof CmsPage_Hero_HzAlign_MutationInput)[keyof typeof CmsPage_Hero_HzAlign_MutationInput]
export const CmsPage_Hero_Type_MutationInput = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsPage_Hero_Type_MutationInput =
  (typeof CmsPage_Hero_Type_MutationInput)[keyof typeof CmsPage_Hero_Type_MutationInput]
export const CmsPage_Hero_VertAlign_MutationInput = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsPage_Hero_VertAlign_MutationInput =
  (typeof CmsPage_Hero_VertAlign_MutationInput)[keyof typeof CmsPage_Hero_VertAlign_MutationInput]
export const CmsPage__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsPage__Status = (typeof CmsPage__Status)[keyof typeof CmsPage__Status]
export const CmsPage__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsPage__Status_Input = (typeof CmsPage__Status_Input)[keyof typeof CmsPage__Status_Input]
export const CmsPage__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsPage__Status_MutationInput =
  (typeof CmsPage__Status_MutationInput)[keyof typeof CmsPage__Status_MutationInput]
export type CmsPage__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsPage__Status_Input>>>
  equals?: InputMaybe<CmsPage__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsPage__Status_Input>>>
  not_equals?: InputMaybe<CmsPage__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsPage__Status_Input>>>
}

export type CmsPage_Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsPage_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const CmsPage_CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsPage_CustomFooter__Disclaimers__Align_Input =
  (typeof CmsPage_CustomFooter__Disclaimers__Align_Input)[keyof typeof CmsPage_CustomFooter__Disclaimers__Align_Input]
export type CmsPage_CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Input>>>
}

export type CmsPage_CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPage_CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsPage_CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsPage_CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type CmsPage_CustomHeader__HeaderDisplay_Input =
  (typeof CmsPage_CustomHeader__HeaderDisplay_Input)[keyof typeof CmsPage_CustomHeader__HeaderDisplay_Input]
export type CmsPage_CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Input>>>
}

export type CmsPage_CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPage_CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPage_CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof CmsPage_CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof CmsPage_CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type CmsPage_CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsPage_CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof CmsPage_CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof CmsPage_CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type CmsPage_CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsPage_CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsPage_CustomHeader__LoginLink__Type_Input =
  (typeof CmsPage_CustomHeader__LoginLink__Type_Input)[keyof typeof CmsPage_CustomHeader__LoginLink__Type_Input]
export type CmsPage_CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<CmsPage_CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<CmsPage_CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsPage_CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<CmsPage_CustomHeader__LoginLink__Type_Input>
}

export type CmsPage_CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPage_CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof CmsPage_CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof CmsPage_CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type CmsPage_CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsPage_CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof CmsPage_CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof CmsPage_CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type CmsPage_CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsPage_CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsPage_CustomHeader__SignupLink__Type_Input =
  (typeof CmsPage_CustomHeader__SignupLink__Type_Input)[keyof typeof CmsPage_CustomHeader__SignupLink__Type_Input]
export type CmsPage_CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<CmsPage_CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<CmsPage_CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsPage_CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<CmsPage_CustomHeader__SignupLink__Type_Input>
}

export type CmsPage_CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPage_CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof CmsPage_CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof CmsPage_CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type CmsPage_CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsPage_CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof CmsPage_CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof CmsPage_CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type CmsPage_CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsPage_CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsPage_CustomHeader__SupportLink__Type_Input =
  (typeof CmsPage_CustomHeader__SupportLink__Type_Input)[keyof typeof CmsPage_CustomHeader__SupportLink__Type_Input]
export type CmsPage_CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<CmsPage_CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<CmsPage_CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsPage_CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<CmsPage_CustomHeader__SupportLink__Type_Input>
}

export type CmsPage_CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__DesktopFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Hero__DesktopVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Hero__DisclaimerText_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export const CmsPage_Hero__HeroSize_Input = {
  Full: 'full',
  Partial: 'partial',
} as const

export type CmsPage_Hero__HeroSize_Input =
  (typeof CmsPage_Hero__HeroSize_Input)[keyof typeof CmsPage_Hero__HeroSize_Input]
export type CmsPage_Hero__HeroSize_Operator = {
  contains?: InputMaybe<CmsPage_Hero__HeroSize_Input>
  equals?: InputMaybe<CmsPage_Hero__HeroSize_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsPage_Hero__HeroSize_Input>
  not_equals?: InputMaybe<CmsPage_Hero__HeroSize_Input>
}

export const CmsPage_Hero__HzAlign_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsPage_Hero__HzAlign_Input = (typeof CmsPage_Hero__HzAlign_Input)[keyof typeof CmsPage_Hero__HzAlign_Input]
export type CmsPage_Hero__HzAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsPage_Hero__HzAlign_Input>>>
  equals?: InputMaybe<CmsPage_Hero__HzAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__HzAlign_Input>>>
  not_equals?: InputMaybe<CmsPage_Hero__HzAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__HzAlign_Input>>>
}

export type CmsPage_Hero__Links__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__Links__Link__IconAfter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__Links__Link__IconBefore_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__Links__Link__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__Links__Link__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPage_Hero__Links__Link__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__Links__Link__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__Links__Link__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__Links__Link__Reference_Relation = {
  relationTo?: InputMaybe<CmsPage_Hero__Links__Link__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_Hero__Links__Link__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsPage_Hero__Links__Link__Reference_Relation_RelationTo =
  (typeof CmsPage_Hero__Links__Link__Reference_Relation_RelationTo)[keyof typeof CmsPage_Hero__Links__Link__Reference_Relation_RelationTo]
export type CmsPage_Hero__Links__Link__Reusable_Relation = {
  relationTo?: InputMaybe<CmsPage_Hero__Links__Link__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsPage_Hero__Links__Link__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type CmsPage_Hero__Links__Link__Reusable_Relation_RelationTo =
  (typeof CmsPage_Hero__Links__Link__Reusable_Relation_RelationTo)[keyof typeof CmsPage_Hero__Links__Link__Reusable_Relation_RelationTo]
export type CmsPage_Hero__Links__Link__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsPage_Hero__Links__Link__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type CmsPage_Hero__Links__Link__Type_Input =
  (typeof CmsPage_Hero__Links__Link__Type_Input)[keyof typeof CmsPage_Hero__Links__Link__Type_Input]
export type CmsPage_Hero__Links__Link__Type_Operator = {
  contains?: InputMaybe<CmsPage_Hero__Links__Link__Type_Input>
  equals?: InputMaybe<CmsPage_Hero__Links__Link__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsPage_Hero__Links__Link__Type_Input>
  not_equals?: InputMaybe<CmsPage_Hero__Links__Link__Type_Input>
}

export type CmsPage_Hero__Links__Link__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsPage_Hero__Links__Link__Variant_Input = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsPage_Hero__Links__Link__Variant_Input =
  (typeof CmsPage_Hero__Links__Link__Variant_Input)[keyof typeof CmsPage_Hero__Links__Link__Variant_Input]
export type CmsPage_Hero__Links__Link__Variant_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsPage_Hero__Links__Link__Variant_Input>>>
  equals?: InputMaybe<CmsPage_Hero__Links__Link__Variant_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__Links__Link__Variant_Input>>>
  not_equals?: InputMaybe<CmsPage_Hero__Links__Link__Variant_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__Links__Link__Variant_Input>>>
}

export type CmsPage_Hero__Media_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Hero__MobileFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Hero__MobileVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Hero__ProductImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Hero__ReviewRating_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsPage_Hero__ReviewText_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Hero__RichTextMax_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsPage_Hero__RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsPage_Hero__ShowReviews_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const CmsPage_Hero__Type_Input = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsPage_Hero__Type_Input = (typeof CmsPage_Hero__Type_Input)[keyof typeof CmsPage_Hero__Type_Input]
export type CmsPage_Hero__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsPage_Hero__Type_Input>>>
  equals?: InputMaybe<CmsPage_Hero__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__Type_Input>>>
  not_equals?: InputMaybe<CmsPage_Hero__Type_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__Type_Input>>>
}

export const CmsPage_Hero__VertAlign_Input = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsPage_Hero__VertAlign_Input =
  (typeof CmsPage_Hero__VertAlign_Input)[keyof typeof CmsPage_Hero__VertAlign_Input]
export type CmsPage_Hero__VertAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsPage_Hero__VertAlign_Input>>>
  equals?: InputMaybe<CmsPage_Hero__VertAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__VertAlign_Input>>>
  not_equals?: InputMaybe<CmsPage_Hero__VertAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsPage_Hero__VertAlign_Input>>>
}

export type CmsPage_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsPage_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsPage_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsPage_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPage_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPage_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsPage_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsPage_Where_Or>>>
  _status?: InputMaybe<CmsPage__Status_Operator>
  breadcrumbs__doc?: InputMaybe<CmsPage_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsPage_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsPage_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsPage_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsPage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsPage_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsPage_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsPage_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsPage_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsPage_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsPage_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsPage_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsPage_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsPage_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsPage_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsPage_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsPage_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsPage_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsPage_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsPage_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsPage_CustomHeader__SupportLink__Url_Operator>
  hero__desktopFallback?: InputMaybe<CmsPage_Hero__DesktopFallback_Operator>
  hero__desktopVideo?: InputMaybe<CmsPage_Hero__DesktopVideo_Operator>
  hero__disclaimerText?: InputMaybe<CmsPage_Hero__DisclaimerText_Operator>
  hero__heroSize?: InputMaybe<CmsPage_Hero__HeroSize_Operator>
  hero__hzAlign?: InputMaybe<CmsPage_Hero__HzAlign_Operator>
  hero__links__id?: InputMaybe<CmsPage_Hero__Links__Id_Operator>
  hero__links__link__iconAfter?: InputMaybe<CmsPage_Hero__Links__Link__IconAfter_Operator>
  hero__links__link__iconBefore?: InputMaybe<CmsPage_Hero__Links__Link__IconBefore_Operator>
  hero__links__link__label?: InputMaybe<CmsPage_Hero__Links__Link__Label_Operator>
  hero__links__link__newTab?: InputMaybe<CmsPage_Hero__Links__Link__NewTab_Operator>
  hero__links__link__query__id?: InputMaybe<CmsPage_Hero__Links__Link__Query__Id_Operator>
  hero__links__link__query__key?: InputMaybe<CmsPage_Hero__Links__Link__Query__Key_Operator>
  hero__links__link__query__value?: InputMaybe<CmsPage_Hero__Links__Link__Query__Value_Operator>
  hero__links__link__reference?: InputMaybe<CmsPage_Hero__Links__Link__Reference_Relation>
  hero__links__link__reusable?: InputMaybe<CmsPage_Hero__Links__Link__Reusable_Relation>
  hero__links__link__targetId?: InputMaybe<CmsPage_Hero__Links__Link__TargetId_Operator>
  hero__links__link__type?: InputMaybe<CmsPage_Hero__Links__Link__Type_Operator>
  hero__links__link__url?: InputMaybe<CmsPage_Hero__Links__Link__Url_Operator>
  hero__links__link__variant?: InputMaybe<CmsPage_Hero__Links__Link__Variant_Operator>
  hero__media?: InputMaybe<CmsPage_Hero__Media_Operator>
  hero__mobileFallback?: InputMaybe<CmsPage_Hero__MobileFallback_Operator>
  hero__mobileVideo?: InputMaybe<CmsPage_Hero__MobileVideo_Operator>
  hero__productImage?: InputMaybe<CmsPage_Hero__ProductImage_Operator>
  hero__reviewRating?: InputMaybe<CmsPage_Hero__ReviewRating_Operator>
  hero__reviewText?: InputMaybe<CmsPage_Hero__ReviewText_Operator>
  hero__richText?: InputMaybe<CmsPage_Hero__RichText_Operator>
  hero__richTextMax?: InputMaybe<CmsPage_Hero__RichTextMax_Operator>
  hero__showReviews?: InputMaybe<CmsPage_Hero__ShowReviews_Operator>
  hero__type?: InputMaybe<CmsPage_Hero__Type_Operator>
  hero__vertAlign?: InputMaybe<CmsPage_Hero__VertAlign_Operator>
  id?: InputMaybe<CmsPage_Id_Operator>
  meta__description?: InputMaybe<CmsPage_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsPage_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsPage_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsPage_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsPage_Meta__Title_Operator>
  parent?: InputMaybe<CmsPage_Parent_Operator>
  publishedAt?: InputMaybe<CmsPage_PublishedAt_Operator>
  slug?: InputMaybe<CmsPage_Slug_Operator>
  title?: InputMaybe<CmsPage_Title_Operator>
  updatedAt?: InputMaybe<CmsPage_UpdatedAt_Operator>
}

export type CmsPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsPage_Where_Or>>>
  _status?: InputMaybe<CmsPage__Status_Operator>
  breadcrumbs__doc?: InputMaybe<CmsPage_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsPage_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsPage_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsPage_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsPage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsPage_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsPage_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsPage_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsPage_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsPage_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsPage_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsPage_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsPage_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsPage_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsPage_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsPage_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsPage_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsPage_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsPage_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsPage_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsPage_CustomHeader__SupportLink__Url_Operator>
  hero__desktopFallback?: InputMaybe<CmsPage_Hero__DesktopFallback_Operator>
  hero__desktopVideo?: InputMaybe<CmsPage_Hero__DesktopVideo_Operator>
  hero__disclaimerText?: InputMaybe<CmsPage_Hero__DisclaimerText_Operator>
  hero__heroSize?: InputMaybe<CmsPage_Hero__HeroSize_Operator>
  hero__hzAlign?: InputMaybe<CmsPage_Hero__HzAlign_Operator>
  hero__links__id?: InputMaybe<CmsPage_Hero__Links__Id_Operator>
  hero__links__link__iconAfter?: InputMaybe<CmsPage_Hero__Links__Link__IconAfter_Operator>
  hero__links__link__iconBefore?: InputMaybe<CmsPage_Hero__Links__Link__IconBefore_Operator>
  hero__links__link__label?: InputMaybe<CmsPage_Hero__Links__Link__Label_Operator>
  hero__links__link__newTab?: InputMaybe<CmsPage_Hero__Links__Link__NewTab_Operator>
  hero__links__link__query__id?: InputMaybe<CmsPage_Hero__Links__Link__Query__Id_Operator>
  hero__links__link__query__key?: InputMaybe<CmsPage_Hero__Links__Link__Query__Key_Operator>
  hero__links__link__query__value?: InputMaybe<CmsPage_Hero__Links__Link__Query__Value_Operator>
  hero__links__link__reference?: InputMaybe<CmsPage_Hero__Links__Link__Reference_Relation>
  hero__links__link__reusable?: InputMaybe<CmsPage_Hero__Links__Link__Reusable_Relation>
  hero__links__link__targetId?: InputMaybe<CmsPage_Hero__Links__Link__TargetId_Operator>
  hero__links__link__type?: InputMaybe<CmsPage_Hero__Links__Link__Type_Operator>
  hero__links__link__url?: InputMaybe<CmsPage_Hero__Links__Link__Url_Operator>
  hero__links__link__variant?: InputMaybe<CmsPage_Hero__Links__Link__Variant_Operator>
  hero__media?: InputMaybe<CmsPage_Hero__Media_Operator>
  hero__mobileFallback?: InputMaybe<CmsPage_Hero__MobileFallback_Operator>
  hero__mobileVideo?: InputMaybe<CmsPage_Hero__MobileVideo_Operator>
  hero__productImage?: InputMaybe<CmsPage_Hero__ProductImage_Operator>
  hero__reviewRating?: InputMaybe<CmsPage_Hero__ReviewRating_Operator>
  hero__reviewText?: InputMaybe<CmsPage_Hero__ReviewText_Operator>
  hero__richText?: InputMaybe<CmsPage_Hero__RichText_Operator>
  hero__richTextMax?: InputMaybe<CmsPage_Hero__RichTextMax_Operator>
  hero__showReviews?: InputMaybe<CmsPage_Hero__ShowReviews_Operator>
  hero__type?: InputMaybe<CmsPage_Hero__Type_Operator>
  hero__vertAlign?: InputMaybe<CmsPage_Hero__VertAlign_Operator>
  id?: InputMaybe<CmsPage_Id_Operator>
  meta__description?: InputMaybe<CmsPage_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsPage_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsPage_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsPage_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsPage_Meta__Title_Operator>
  parent?: InputMaybe<CmsPage_Parent_Operator>
  publishedAt?: InputMaybe<CmsPage_PublishedAt_Operator>
  slug?: InputMaybe<CmsPage_Slug_Operator>
  title?: InputMaybe<CmsPage_Title_Operator>
  updatedAt?: InputMaybe<CmsPage_UpdatedAt_Operator>
}

export type CmsPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsPage_Where_Or>>>
  _status?: InputMaybe<CmsPage__Status_Operator>
  breadcrumbs__doc?: InputMaybe<CmsPage_Breadcrumbs__Doc_Operator>
  breadcrumbs__id?: InputMaybe<CmsPage_Breadcrumbs__Id_Operator>
  breadcrumbs__label?: InputMaybe<CmsPage_Breadcrumbs__Label_Operator>
  breadcrumbs__url?: InputMaybe<CmsPage_Breadcrumbs__Url_Operator>
  createdAt?: InputMaybe<CmsPage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsPage_CreatedBy_Operator>
  customFooter__disclaimers__align?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Align_Operator>
  customFooter__disclaimers__id?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Id_Operator>
  customFooter__disclaimers__includeAsterick?: InputMaybe<CmsPage_CustomFooter__Disclaimers__IncludeAsterick_Operator>
  customFooter__disclaimers__number?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Number_Operator>
  customFooter__disclaimers__text?: InputMaybe<CmsPage_CustomFooter__Disclaimers__Text_Operator>
  customFooter__isHidden?: InputMaybe<CmsPage_CustomFooter__IsHidden_Operator>
  customHeader__headerDisplay?: InputMaybe<CmsPage_CustomHeader__HeaderDisplay_Operator>
  customHeader__isHidden?: InputMaybe<CmsPage_CustomHeader__IsHidden_Operator>
  customHeader__loginLink__newTab?: InputMaybe<CmsPage_CustomHeader__LoginLink__NewTab_Operator>
  customHeader__loginLink__query__id?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Id_Operator>
  customHeader__loginLink__query__key?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Key_Operator>
  customHeader__loginLink__query__value?: InputMaybe<CmsPage_CustomHeader__LoginLink__Query__Value_Operator>
  customHeader__loginLink__reference?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reference_Relation>
  customHeader__loginLink__reusable?: InputMaybe<CmsPage_CustomHeader__LoginLink__Reusable_Relation>
  customHeader__loginLink__targetId?: InputMaybe<CmsPage_CustomHeader__LoginLink__TargetId_Operator>
  customHeader__loginLink__type?: InputMaybe<CmsPage_CustomHeader__LoginLink__Type_Operator>
  customHeader__loginLink__url?: InputMaybe<CmsPage_CustomHeader__LoginLink__Url_Operator>
  customHeader__signupLink__newTab?: InputMaybe<CmsPage_CustomHeader__SignupLink__NewTab_Operator>
  customHeader__signupLink__query__id?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Id_Operator>
  customHeader__signupLink__query__key?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Key_Operator>
  customHeader__signupLink__query__value?: InputMaybe<CmsPage_CustomHeader__SignupLink__Query__Value_Operator>
  customHeader__signupLink__reference?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reference_Relation>
  customHeader__signupLink__reusable?: InputMaybe<CmsPage_CustomHeader__SignupLink__Reusable_Relation>
  customHeader__signupLink__targetId?: InputMaybe<CmsPage_CustomHeader__SignupLink__TargetId_Operator>
  customHeader__signupLink__type?: InputMaybe<CmsPage_CustomHeader__SignupLink__Type_Operator>
  customHeader__signupLink__url?: InputMaybe<CmsPage_CustomHeader__SignupLink__Url_Operator>
  customHeader__supportLink__newTab?: InputMaybe<CmsPage_CustomHeader__SupportLink__NewTab_Operator>
  customHeader__supportLink__query__id?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Id_Operator>
  customHeader__supportLink__query__key?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Key_Operator>
  customHeader__supportLink__query__value?: InputMaybe<CmsPage_CustomHeader__SupportLink__Query__Value_Operator>
  customHeader__supportLink__reference?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reference_Relation>
  customHeader__supportLink__reusable?: InputMaybe<CmsPage_CustomHeader__SupportLink__Reusable_Relation>
  customHeader__supportLink__targetId?: InputMaybe<CmsPage_CustomHeader__SupportLink__TargetId_Operator>
  customHeader__supportLink__type?: InputMaybe<CmsPage_CustomHeader__SupportLink__Type_Operator>
  customHeader__supportLink__url?: InputMaybe<CmsPage_CustomHeader__SupportLink__Url_Operator>
  hero__desktopFallback?: InputMaybe<CmsPage_Hero__DesktopFallback_Operator>
  hero__desktopVideo?: InputMaybe<CmsPage_Hero__DesktopVideo_Operator>
  hero__disclaimerText?: InputMaybe<CmsPage_Hero__DisclaimerText_Operator>
  hero__heroSize?: InputMaybe<CmsPage_Hero__HeroSize_Operator>
  hero__hzAlign?: InputMaybe<CmsPage_Hero__HzAlign_Operator>
  hero__links__id?: InputMaybe<CmsPage_Hero__Links__Id_Operator>
  hero__links__link__iconAfter?: InputMaybe<CmsPage_Hero__Links__Link__IconAfter_Operator>
  hero__links__link__iconBefore?: InputMaybe<CmsPage_Hero__Links__Link__IconBefore_Operator>
  hero__links__link__label?: InputMaybe<CmsPage_Hero__Links__Link__Label_Operator>
  hero__links__link__newTab?: InputMaybe<CmsPage_Hero__Links__Link__NewTab_Operator>
  hero__links__link__query__id?: InputMaybe<CmsPage_Hero__Links__Link__Query__Id_Operator>
  hero__links__link__query__key?: InputMaybe<CmsPage_Hero__Links__Link__Query__Key_Operator>
  hero__links__link__query__value?: InputMaybe<CmsPage_Hero__Links__Link__Query__Value_Operator>
  hero__links__link__reference?: InputMaybe<CmsPage_Hero__Links__Link__Reference_Relation>
  hero__links__link__reusable?: InputMaybe<CmsPage_Hero__Links__Link__Reusable_Relation>
  hero__links__link__targetId?: InputMaybe<CmsPage_Hero__Links__Link__TargetId_Operator>
  hero__links__link__type?: InputMaybe<CmsPage_Hero__Links__Link__Type_Operator>
  hero__links__link__url?: InputMaybe<CmsPage_Hero__Links__Link__Url_Operator>
  hero__links__link__variant?: InputMaybe<CmsPage_Hero__Links__Link__Variant_Operator>
  hero__media?: InputMaybe<CmsPage_Hero__Media_Operator>
  hero__mobileFallback?: InputMaybe<CmsPage_Hero__MobileFallback_Operator>
  hero__mobileVideo?: InputMaybe<CmsPage_Hero__MobileVideo_Operator>
  hero__productImage?: InputMaybe<CmsPage_Hero__ProductImage_Operator>
  hero__reviewRating?: InputMaybe<CmsPage_Hero__ReviewRating_Operator>
  hero__reviewText?: InputMaybe<CmsPage_Hero__ReviewText_Operator>
  hero__richText?: InputMaybe<CmsPage_Hero__RichText_Operator>
  hero__richTextMax?: InputMaybe<CmsPage_Hero__RichTextMax_Operator>
  hero__showReviews?: InputMaybe<CmsPage_Hero__ShowReviews_Operator>
  hero__type?: InputMaybe<CmsPage_Hero__Type_Operator>
  hero__vertAlign?: InputMaybe<CmsPage_Hero__VertAlign_Operator>
  id?: InputMaybe<CmsPage_Id_Operator>
  meta__description?: InputMaybe<CmsPage_Meta__Description_Operator>
  meta__image?: InputMaybe<CmsPage_Meta__Image_Operator>
  meta__jsonLD?: InputMaybe<CmsPage_Meta__JsonLd_Operator>
  meta__noIndex?: InputMaybe<CmsPage_Meta__NoIndex_Operator>
  meta__title?: InputMaybe<CmsPage_Meta__Title_Operator>
  parent?: InputMaybe<CmsPage_Parent_Operator>
  publishedAt?: InputMaybe<CmsPage_PublishedAt_Operator>
  slug?: InputMaybe<CmsPage_Slug_Operator>
  title?: InputMaybe<CmsPage_Title_Operator>
  updatedAt?: InputMaybe<CmsPage_UpdatedAt_Operator>
}

export type CmsPages = {
  __typename?: 'CmsPages'
  docs?: Maybe<Array<Maybe<CmsPage>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsPriceTier = {
  __typename?: 'CmsPriceTier'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsPriceTier_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
  tiers?: Maybe<Array<CmsPriceTier_Tiers>>
}

export type CmsPriceTier_Ctas = {
  __typename?: 'CmsPriceTier_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsPriceTier_Tiers = {
  __typename?: 'CmsPriceTier_Tiers'
  id?: Maybe<Scalars['String']['output']>
  tier?: Maybe<CmsPricing>
}

export type CmsPricing = {
  __typename?: 'CmsPricing'
  buttonText: Scalars['String']['output']
  buttonUrl: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  features?: Maybe<Array<CmsPricing_Features>>
  id: Scalars['Int']['output']
  includes?: Maybe<Array<CmsPricing>>
  isPopular?: Maybe<Scalars['Boolean']['output']>
  popularText?: Maybe<Scalars['String']['output']>
  priceMonthly: Scalars['Float']['output']
  priceQuarterly: Scalars['Float']['output']
  priceYearly: Scalars['Float']['output']
  tierDescription: Scalars['String']['output']
  tierName: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsPricing_Features = {
  __typename?: 'CmsPricing_Features'
  disclaimer?: Maybe<Scalars['JSON']['output']>
  id?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['JSON']['output']>
}

export type CmsPricing_FeaturesDisclaimerArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsPricing_FeaturesTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsPricing_ButtonText_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPricing_ButtonUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPricing_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsPricing_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPricing_Features__Disclaimer_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsPricing_Features__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPricing_Features__Text_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type CmsPricing_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsPricing_Includes_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsPricing_IsPopular_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsPricing_PopularText_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPricing_PriceMonthly_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsPricing_PriceQuarterly_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsPricing_PriceYearly_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsPricing_TierDescription_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPricing_TierName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsPricing_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsPricing_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsPricing_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsPricing_Where_Or>>>
  buttonText?: InputMaybe<CmsPricing_ButtonText_Operator>
  buttonUrl?: InputMaybe<CmsPricing_ButtonUrl_Operator>
  createdAt?: InputMaybe<CmsPricing_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsPricing_CreatedBy_Operator>
  features__disclaimer?: InputMaybe<CmsPricing_Features__Disclaimer_Operator>
  features__id?: InputMaybe<CmsPricing_Features__Id_Operator>
  features__text?: InputMaybe<CmsPricing_Features__Text_Operator>
  id?: InputMaybe<CmsPricing_Id_Operator>
  includes?: InputMaybe<CmsPricing_Includes_Operator>
  isPopular?: InputMaybe<CmsPricing_IsPopular_Operator>
  popularText?: InputMaybe<CmsPricing_PopularText_Operator>
  priceMonthly?: InputMaybe<CmsPricing_PriceMonthly_Operator>
  priceQuarterly?: InputMaybe<CmsPricing_PriceQuarterly_Operator>
  priceYearly?: InputMaybe<CmsPricing_PriceYearly_Operator>
  tierDescription?: InputMaybe<CmsPricing_TierDescription_Operator>
  tierName?: InputMaybe<CmsPricing_TierName_Operator>
  updatedAt?: InputMaybe<CmsPricing_UpdatedAt_Operator>
}

export type CmsPricing_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsPricing_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsPricing_Where_Or>>>
  buttonText?: InputMaybe<CmsPricing_ButtonText_Operator>
  buttonUrl?: InputMaybe<CmsPricing_ButtonUrl_Operator>
  createdAt?: InputMaybe<CmsPricing_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsPricing_CreatedBy_Operator>
  features__disclaimer?: InputMaybe<CmsPricing_Features__Disclaimer_Operator>
  features__id?: InputMaybe<CmsPricing_Features__Id_Operator>
  features__text?: InputMaybe<CmsPricing_Features__Text_Operator>
  id?: InputMaybe<CmsPricing_Id_Operator>
  includes?: InputMaybe<CmsPricing_Includes_Operator>
  isPopular?: InputMaybe<CmsPricing_IsPopular_Operator>
  popularText?: InputMaybe<CmsPricing_PopularText_Operator>
  priceMonthly?: InputMaybe<CmsPricing_PriceMonthly_Operator>
  priceQuarterly?: InputMaybe<CmsPricing_PriceQuarterly_Operator>
  priceYearly?: InputMaybe<CmsPricing_PriceYearly_Operator>
  tierDescription?: InputMaybe<CmsPricing_TierDescription_Operator>
  tierName?: InputMaybe<CmsPricing_TierName_Operator>
  updatedAt?: InputMaybe<CmsPricing_UpdatedAt_Operator>
}

export type CmsPricing_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsPricing_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsPricing_Where_Or>>>
  buttonText?: InputMaybe<CmsPricing_ButtonText_Operator>
  buttonUrl?: InputMaybe<CmsPricing_ButtonUrl_Operator>
  createdAt?: InputMaybe<CmsPricing_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsPricing_CreatedBy_Operator>
  features__disclaimer?: InputMaybe<CmsPricing_Features__Disclaimer_Operator>
  features__id?: InputMaybe<CmsPricing_Features__Id_Operator>
  features__text?: InputMaybe<CmsPricing_Features__Text_Operator>
  id?: InputMaybe<CmsPricing_Id_Operator>
  includes?: InputMaybe<CmsPricing_Includes_Operator>
  isPopular?: InputMaybe<CmsPricing_IsPopular_Operator>
  popularText?: InputMaybe<CmsPricing_PopularText_Operator>
  priceMonthly?: InputMaybe<CmsPricing_PriceMonthly_Operator>
  priceQuarterly?: InputMaybe<CmsPricing_PriceQuarterly_Operator>
  priceYearly?: InputMaybe<CmsPricing_PriceYearly_Operator>
  tierDescription?: InputMaybe<CmsPricing_TierDescription_Operator>
  tierName?: InputMaybe<CmsPricing_TierName_Operator>
  updatedAt?: InputMaybe<CmsPricing_UpdatedAt_Operator>
}

export type CmsPricings = {
  __typename?: 'CmsPricings'
  docs?: Maybe<Array<Maybe<CmsPricing>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsProsConsBlock = {
  __typename?: 'CmsProsConsBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  cons?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  pros?: Maybe<Scalars['String']['output']>
}

export type CmsQuote = {
  __typename?: 'CmsQuote'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsQuote_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  quoteStyle?: Maybe<CmsQuote_QuoteStyle>
  quotes?: Maybe<Array<CmsQuote_Quotes>>
  section?: Maybe<CmsSection>
}

export type CmsQuote_Ctas = {
  __typename?: 'CmsQuote_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsQuote_Quotes = {
  __typename?: 'CmsQuote_Quotes'
  author?: Maybe<Scalars['String']['output']>
  business?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  quoteText?: Maybe<Scalars['JSON']['output']>
}

export type CmsQuote_QuotesQuoteTextArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export const CmsQuote_QuoteStyle = {
  Blockquote: 'blockquote',
  Card: 'card',
} as const

export type CmsQuote_QuoteStyle = (typeof CmsQuote_QuoteStyle)[keyof typeof CmsQuote_QuoteStyle]
export type CmsRating = {
  __typename?: 'CmsRating'
  average?: Maybe<Scalars['Float']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  fiveStar?: Maybe<Scalars['Float']['output']>
  fourStar?: Maybe<Scalars['Float']['output']>
  id: Scalars['Int']['output']
  oneStar?: Maybe<Scalars['Float']['output']>
  threeStar?: Maybe<Scalars['Float']['output']>
  total?: Maybe<Scalars['Float']['output']>
  twoStar?: Maybe<Scalars['Float']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsRating_Average_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsRating_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsRating_FiveStar_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsRating_FourStar_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsRating_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsRating_OneStar_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsRating_ThreeStar_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsRating_Total_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsRating_TwoStar_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsRating_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsRating_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsRating_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsRating_Where_Or>>>
  average?: InputMaybe<CmsRating_Average_Operator>
  createdAt?: InputMaybe<CmsRating_CreatedAt_Operator>
  fiveStar?: InputMaybe<CmsRating_FiveStar_Operator>
  fourStar?: InputMaybe<CmsRating_FourStar_Operator>
  id?: InputMaybe<CmsRating_Id_Operator>
  oneStar?: InputMaybe<CmsRating_OneStar_Operator>
  threeStar?: InputMaybe<CmsRating_ThreeStar_Operator>
  total?: InputMaybe<CmsRating_Total_Operator>
  twoStar?: InputMaybe<CmsRating_TwoStar_Operator>
  updatedAt?: InputMaybe<CmsRating_UpdatedAt_Operator>
}

export type CmsRating_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsRating_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsRating_Where_Or>>>
  average?: InputMaybe<CmsRating_Average_Operator>
  createdAt?: InputMaybe<CmsRating_CreatedAt_Operator>
  fiveStar?: InputMaybe<CmsRating_FiveStar_Operator>
  fourStar?: InputMaybe<CmsRating_FourStar_Operator>
  id?: InputMaybe<CmsRating_Id_Operator>
  oneStar?: InputMaybe<CmsRating_OneStar_Operator>
  threeStar?: InputMaybe<CmsRating_ThreeStar_Operator>
  total?: InputMaybe<CmsRating_Total_Operator>
  twoStar?: InputMaybe<CmsRating_TwoStar_Operator>
  updatedAt?: InputMaybe<CmsRating_UpdatedAt_Operator>
}

export type CmsRating_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsRating_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsRating_Where_Or>>>
  average?: InputMaybe<CmsRating_Average_Operator>
  createdAt?: InputMaybe<CmsRating_CreatedAt_Operator>
  fiveStar?: InputMaybe<CmsRating_FiveStar_Operator>
  fourStar?: InputMaybe<CmsRating_FourStar_Operator>
  id?: InputMaybe<CmsRating_Id_Operator>
  oneStar?: InputMaybe<CmsRating_OneStar_Operator>
  threeStar?: InputMaybe<CmsRating_ThreeStar_Operator>
  total?: InputMaybe<CmsRating_Total_Operator>
  twoStar?: InputMaybe<CmsRating_TwoStar_Operator>
  updatedAt?: InputMaybe<CmsRating_UpdatedAt_Operator>
}

export type CmsRatings = {
  __typename?: 'CmsRatings'
  docs?: Maybe<Array<Maybe<CmsRating>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsRedirect = {
  __typename?: 'CmsRedirect'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  from: Scalars['String']['output']
  id: Scalars['Int']['output']
  permanent?: Maybe<Scalars['Boolean']['output']>
  to?: Maybe<CmsRedirect_To>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsRedirectUpdate_To_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsRedirectUpdate_To_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsRedirectUpdate_To_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsRedirectUpdate_To_ReferenceRelationshipInputRelationTo =
  (typeof CmsRedirectUpdate_To_ReferenceRelationshipInputRelationTo)[keyof typeof CmsRedirectUpdate_To_ReferenceRelationshipInputRelationTo]
export type CmsRedirect_To = {
  __typename?: 'CmsRedirect_To'
  reference?: Maybe<CmsRedirect_To_Reference_Relationship>
  type?: Maybe<CmsRedirect_To_Type>
  url?: Maybe<Scalars['String']['output']>
}

export type CmsRedirect_ToReferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsRedirect_To_Reference =
  | CmsArticle
  | CmsGuide
  | CmsMarketplacePage
  | CmsNewsroomArticle
  | CmsPage
  | CmsStackerPage

export type CmsRedirect_To_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsRedirect_To_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsRedirect_To_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsRedirect_To_ReferenceRelationshipInputRelationTo =
  (typeof CmsRedirect_To_ReferenceRelationshipInputRelationTo)[keyof typeof CmsRedirect_To_ReferenceRelationshipInputRelationTo]
export const CmsRedirect_To_Reference_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsRedirect_To_Reference_RelationTo =
  (typeof CmsRedirect_To_Reference_RelationTo)[keyof typeof CmsRedirect_To_Reference_RelationTo]
export type CmsRedirect_To_Reference_Relationship = {
  __typename?: 'CmsRedirect_To_Reference_Relationship'
  relationTo?: Maybe<CmsRedirect_To_Reference_RelationTo>
  value?: Maybe<CmsRedirect_To_Reference>
}

export const CmsRedirect_To_Type = {
  Custom: 'custom',
  Reference: 'reference',
} as const

export type CmsRedirect_To_Type = (typeof CmsRedirect_To_Type)[keyof typeof CmsRedirect_To_Type]
export type CmsRedirect_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsRedirect_From_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsRedirect_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsRedirect_Permanent_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsRedirect_To__Reference_Relation = {
  relationTo?: InputMaybe<CmsRedirect_To__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsRedirect_To__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type CmsRedirect_To__Reference_Relation_RelationTo =
  (typeof CmsRedirect_To__Reference_Relation_RelationTo)[keyof typeof CmsRedirect_To__Reference_Relation_RelationTo]
export const CmsRedirect_To__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
} as const

export type CmsRedirect_To__Type_Input = (typeof CmsRedirect_To__Type_Input)[keyof typeof CmsRedirect_To__Type_Input]
export type CmsRedirect_To__Type_Operator = {
  contains?: InputMaybe<CmsRedirect_To__Type_Input>
  equals?: InputMaybe<CmsRedirect_To__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<CmsRedirect_To__Type_Input>
  not_equals?: InputMaybe<CmsRedirect_To__Type_Input>
}

export type CmsRedirect_To__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsRedirect_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsRedirect_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsRedirect_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsRedirect_Where_Or>>>
  createdAt?: InputMaybe<CmsRedirect_CreatedAt_Operator>
  from?: InputMaybe<CmsRedirect_From_Operator>
  id?: InputMaybe<CmsRedirect_Id_Operator>
  permanent?: InputMaybe<CmsRedirect_Permanent_Operator>
  to__reference?: InputMaybe<CmsRedirect_To__Reference_Relation>
  to__type?: InputMaybe<CmsRedirect_To__Type_Operator>
  to__url?: InputMaybe<CmsRedirect_To__Url_Operator>
  updatedAt?: InputMaybe<CmsRedirect_UpdatedAt_Operator>
}

export type CmsRedirect_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsRedirect_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsRedirect_Where_Or>>>
  createdAt?: InputMaybe<CmsRedirect_CreatedAt_Operator>
  from?: InputMaybe<CmsRedirect_From_Operator>
  id?: InputMaybe<CmsRedirect_Id_Operator>
  permanent?: InputMaybe<CmsRedirect_Permanent_Operator>
  to__reference?: InputMaybe<CmsRedirect_To__Reference_Relation>
  to__type?: InputMaybe<CmsRedirect_To__Type_Operator>
  to__url?: InputMaybe<CmsRedirect_To__Url_Operator>
  updatedAt?: InputMaybe<CmsRedirect_UpdatedAt_Operator>
}

export type CmsRedirect_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsRedirect_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsRedirect_Where_Or>>>
  createdAt?: InputMaybe<CmsRedirect_CreatedAt_Operator>
  from?: InputMaybe<CmsRedirect_From_Operator>
  id?: InputMaybe<CmsRedirect_Id_Operator>
  permanent?: InputMaybe<CmsRedirect_Permanent_Operator>
  to__reference?: InputMaybe<CmsRedirect_To__Reference_Relation>
  to__type?: InputMaybe<CmsRedirect_To__Type_Operator>
  to__url?: InputMaybe<CmsRedirect_To__Url_Operator>
  updatedAt?: InputMaybe<CmsRedirect_UpdatedAt_Operator>
}

export type CmsRedirects = {
  __typename?: 'CmsRedirects'
  docs?: Maybe<Array<Maybe<CmsRedirect>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsResources = {
  __typename?: 'CmsResources'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  cards?: Maybe<Array<CmsResources_Cards>>
  cardsGridType?: Maybe<CmsResources_CardsGridType>
  ctas?: Maybe<Array<CmsResources_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
}

export type CmsResources_Cards = {
  __typename?: 'CmsResources_Cards'
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
  linkAppearance?: Maybe<CmsResources_Cards_LinkAppearance>
  media?: Maybe<CmsMedia>
  title?: Maybe<Scalars['String']['output']>
}

export const CmsResources_Cards_LinkAppearance = {
  Cta: 'cta',
  FullCard: 'full_card',
} as const

export type CmsResources_Cards_LinkAppearance =
  (typeof CmsResources_Cards_LinkAppearance)[keyof typeof CmsResources_Cards_LinkAppearance]
export type CmsResources_Ctas = {
  __typename?: 'CmsResources_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export const CmsResources_CardsGridType = {
  Condensed: 'condensed',
  Standard: 'standard',
  Wide: 'wide',
} as const

export type CmsResources_CardsGridType = (typeof CmsResources_CardsGridType)[keyof typeof CmsResources_CardsGridType]
export type CmsRichTextBlock = {
  __typename?: 'CmsRichTextBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  richTextContent?: Maybe<Scalars['JSON']['output']>
  richTextSettings?: Maybe<CmsRichTextBlock_RichTextSettings>
  tableOfContents?: Maybe<Array<CmsRichTextBlock_TableOfContents>>
}

export type CmsRichTextBlockRichTextContentArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsRichTextBlock_RichTextSettings = {
  __typename?: 'CmsRichTextBlock_RichTextSettings'
  enableTOC?: Maybe<Scalars['Boolean']['output']>
}

export type CmsRichTextBlock_TableOfContents = {
  __typename?: 'CmsRichTextBlock_TableOfContents'
  id?: Maybe<Scalars['String']['output']>
  idAttribute?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type CmsRichTextNestedBlocks = {
  __typename?: 'CmsRichTextNestedBlocks'
  layout?: Maybe<Array<CmsRichTextNestedBlocks_Layout>>
}

export type CmsRichTextNestedBlocks_Layout =
  | CmsAccordion
  | CmsCta
  | CmsCalloutBlock
  | CmsContent
  | CmsImageBlock
  | CmsOfferBlock
  | CmsTableBlock
  | CmsVideoBlock

export type CmsRichTextSection = {
  __typename?: 'CmsRichTextSection'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsRichTextSection_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  richTextSections?: Maybe<Array<CmsRichTextSection_RichTextSections>>
  section?: Maybe<CmsSection>
}

export type CmsRichTextSection_Ctas = {
  __typename?: 'CmsRichTextSection_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsRichTextSection_RichTextSections = {
  __typename?: 'CmsRichTextSection_RichTextSections'
  content?: Maybe<CmsRichTextNestedBlocks>
  featuredImage?: Maybe<CmsMedia>
  header?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsSearch = {
  __typename?: 'CmsSearch'
  docs?: Maybe<Array<Maybe<CmsSearchResult>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsSearchResult = {
  __typename?: 'CmsSearchResult'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  doc: CmsSearchResult_Doc_Relationship
  excerpt?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  priority?: Maybe<Scalars['Float']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsSearchResultDocArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsSearchResult_Doc = CmsArticle

export const CmsSearchResult_Doc_RelationTo = {
  Articles: 'articles',
} as const

export type CmsSearchResult_Doc_RelationTo =
  (typeof CmsSearchResult_Doc_RelationTo)[keyof typeof CmsSearchResult_Doc_RelationTo]
export type CmsSearchResult_Doc_Relationship = {
  __typename?: 'CmsSearchResult_Doc_Relationship'
  relationTo?: Maybe<CmsSearchResult_Doc_RelationTo>
  value?: Maybe<CmsSearchResult_Doc>
}

export type CmsSection = {
  __typename?: 'CmsSection'
  ctaAlign?: Maybe<CmsSection_CtaAlign>
  element?: Maybe<CmsSection_Element>
  heading?: Maybe<Scalars['JSON']['output']>
  headingMax?: Maybe<Scalars['Float']['output']>
}

export type CmsSectionHeadingArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>
}

export type CmsSection_Element = {
  __typename?: 'CmsSection_Element'
  className?: Maybe<Scalars['String']['output']>
  elemId?: Maybe<Scalars['String']['output']>
}

export const CmsSection_CtaAlign = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsSection_CtaAlign = (typeof CmsSection_CtaAlign)[keyof typeof CmsSection_CtaAlign]
export type CmsSelectFormField = {
  __typename?: 'CmsSelectFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  defaultValue?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  options?: Maybe<Array<CmsSelectFormField_Options>>
  placeholder?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsSelectFormField_Options = {
  __typename?: 'CmsSelectFormField_Options'
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type CmsSettings = {
  __typename?: 'CmsSettings'
  articlesPage?: Maybe<CmsPage>
  blog?: Maybe<CmsSettings_Blog>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  logo?: Maybe<CmsMedia>
  newsroom?: Maybe<CmsSettings_Newsroom>
  sameAs?: Maybe<Array<CmsSettings_SameAs>>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsSettingsArticlesPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsSettingsDocAccessFields = {
  __typename?: 'CmsSettingsDocAccessFields'
  articlesPage?: Maybe<CmsSettingsDocAccessFields_ArticlesPage>
  blog?: Maybe<CmsSettingsDocAccessFields_Blog>
  createdAt?: Maybe<CmsSettingsDocAccessFields_CreatedAt>
  logo?: Maybe<CmsSettingsDocAccessFields_Logo>
  newsroom?: Maybe<CmsSettingsDocAccessFields_Newsroom>
  sameAs?: Maybe<CmsSettingsDocAccessFields_SameAs>
  updatedAt?: Maybe<CmsSettingsDocAccessFields_UpdatedAt>
}

export type CmsSettingsDocAccessFields_ArticlesPage = {
  __typename?: 'CmsSettingsDocAccessFields_articlesPage'
  create?: Maybe<CmsSettingsDocAccessFields_ArticlesPage_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_ArticlesPage_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_ArticlesPage_Read>
  update?: Maybe<CmsSettingsDocAccessFields_ArticlesPage_Update>
}

export type CmsSettingsDocAccessFields_ArticlesPage_Create = {
  __typename?: 'CmsSettingsDocAccessFields_articlesPage_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_ArticlesPage_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_articlesPage_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_ArticlesPage_Read = {
  __typename?: 'CmsSettingsDocAccessFields_articlesPage_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_ArticlesPage_Update = {
  __typename?: 'CmsSettingsDocAccessFields_articlesPage_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog = {
  __typename?: 'CmsSettingsDocAccessFields_blog'
  create?: Maybe<CmsSettingsDocAccessFields_Blog_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Blog_Delete>
  fields?: Maybe<CmsSettingsDocAccessFields_Blog_Fields>
  read?: Maybe<CmsSettingsDocAccessFields_Blog_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Blog_Update>
}

export type CmsSettingsDocAccessFields_Blog_Create = {
  __typename?: 'CmsSettingsDocAccessFields_blog_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_blog_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_Fields = {
  __typename?: 'CmsSettingsDocAccessFields_blog_Fields'
  featuredArticles?: Maybe<CmsSettingsDocAccessFields_Blog_FeaturedArticles>
  filterCategories?: Maybe<CmsSettingsDocAccessFields_Blog_FilterCategories>
  popularArticles?: Maybe<CmsSettingsDocAccessFields_Blog_PopularArticles>
}

export type CmsSettingsDocAccessFields_Blog_Read = {
  __typename?: 'CmsSettingsDocAccessFields_blog_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_Update = {
  __typename?: 'CmsSettingsDocAccessFields_blog_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FeaturedArticles = {
  __typename?: 'CmsSettingsDocAccessFields_blog_featuredArticles'
  create?: Maybe<CmsSettingsDocAccessFields_Blog_FeaturedArticles_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Blog_FeaturedArticles_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Blog_FeaturedArticles_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Blog_FeaturedArticles_Update>
}

export type CmsSettingsDocAccessFields_Blog_FeaturedArticles_Create = {
  __typename?: 'CmsSettingsDocAccessFields_blog_featuredArticles_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FeaturedArticles_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_blog_featuredArticles_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FeaturedArticles_Read = {
  __typename?: 'CmsSettingsDocAccessFields_blog_featuredArticles_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FeaturedArticles_Update = {
  __typename?: 'CmsSettingsDocAccessFields_blog_featuredArticles_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FilterCategories = {
  __typename?: 'CmsSettingsDocAccessFields_blog_filterCategories'
  create?: Maybe<CmsSettingsDocAccessFields_Blog_FilterCategories_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Blog_FilterCategories_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Blog_FilterCategories_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Blog_FilterCategories_Update>
}

export type CmsSettingsDocAccessFields_Blog_FilterCategories_Create = {
  __typename?: 'CmsSettingsDocAccessFields_blog_filterCategories_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FilterCategories_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_blog_filterCategories_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FilterCategories_Read = {
  __typename?: 'CmsSettingsDocAccessFields_blog_filterCategories_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_FilterCategories_Update = {
  __typename?: 'CmsSettingsDocAccessFields_blog_filterCategories_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_PopularArticles = {
  __typename?: 'CmsSettingsDocAccessFields_blog_popularArticles'
  create?: Maybe<CmsSettingsDocAccessFields_Blog_PopularArticles_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Blog_PopularArticles_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Blog_PopularArticles_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Blog_PopularArticles_Update>
}

export type CmsSettingsDocAccessFields_Blog_PopularArticles_Create = {
  __typename?: 'CmsSettingsDocAccessFields_blog_popularArticles_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_PopularArticles_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_blog_popularArticles_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_PopularArticles_Read = {
  __typename?: 'CmsSettingsDocAccessFields_blog_popularArticles_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Blog_PopularArticles_Update = {
  __typename?: 'CmsSettingsDocAccessFields_blog_popularArticles_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_CreatedAt = {
  __typename?: 'CmsSettingsDocAccessFields_createdAt'
  create?: Maybe<CmsSettingsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_CreatedAt_Read>
  update?: Maybe<CmsSettingsDocAccessFields_CreatedAt_Update>
}

export type CmsSettingsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CmsSettingsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CmsSettingsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CmsSettingsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Logo = {
  __typename?: 'CmsSettingsDocAccessFields_logo'
  create?: Maybe<CmsSettingsDocAccessFields_Logo_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Logo_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Logo_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Logo_Update>
}

export type CmsSettingsDocAccessFields_Logo_Create = {
  __typename?: 'CmsSettingsDocAccessFields_logo_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Logo_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_logo_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Logo_Read = {
  __typename?: 'CmsSettingsDocAccessFields_logo_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Logo_Update = {
  __typename?: 'CmsSettingsDocAccessFields_logo_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Delete>
  fields?: Maybe<CmsSettingsDocAccessFields_Newsroom_Fields>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Fields = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_Fields'
  hero?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero>
}

export type CmsSettingsDocAccessFields_Newsroom_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Delete>
  fields?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Fields>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Fields = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_Fields'
  desktopFallback?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback>
  desktopVideo?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo>
  disclaimerText?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText>
  heroSize?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize>
  hzAlign?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign>
  links?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links>
  media?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Media>
  mobileFallback?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback>
  mobileVideo?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo>
  productImage?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage>
  reviewRating?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating>
  reviewText?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText>
  richText?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichText>
  richTextMax?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax>
  showReviews?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews>
  type?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Type>
  vertAlign?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopFallback'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopFallback_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopVideo'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DesktopVideo_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_desktopVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_disclaimerText'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_disclaimerText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_disclaimerText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_disclaimerText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_DisclaimerText_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_disclaimerText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_heroSize'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_heroSize_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_heroSize_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_heroSize_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HeroSize_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_heroSize_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_hzAlign'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_hzAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_hzAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_hzAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_HzAlign_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_hzAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Delete>
  fields?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Fields>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Fields = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_Fields'
  id?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id>
  link?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_id'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Id_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Delete>
  fields?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Fields>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Fields = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_Fields'
  iconAfter?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter>
  iconBefore?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore>
  label?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label>
  newTab?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab>
  query?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query>
  reference?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference>
  reusable?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable>
  targetId?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId>
  type?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type>
  url?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url>
  variant?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconAfter'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconAfter_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconBefore'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_IconBefore_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_label'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Label_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_newTab'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_NewTab_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Delete>
  fields?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Fields>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Fields = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_Fields'
  id?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id>
  key?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key>
  value?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_id'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Id_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_key'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Key_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_value'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Query_Value_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reference'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reference_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reusable'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Reusable_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_targetId'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_TargetId_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_type'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Type_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_url'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Url_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_variant'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Links_Link_Variant_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Media = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_media'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Media_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Media_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Media_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Media_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Media_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_media_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Media_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Media_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_media_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Media_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_media_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileFallback'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileFallback_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileVideo'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_MobileVideo_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_mobileVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_productImage'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_productImage_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_productImage_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_productImage_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ProductImage_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_productImage_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewRating'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewRating_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewRating_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewRating_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewRating_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewRating_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewText'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ReviewText_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_reviewText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichText = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richText'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richTextMax'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richTextMax_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richTextMax_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richTextMax_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichTextMax_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richTextMax_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_RichText_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_showReviews'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_showReviews_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_showReviews_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_showReviews_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_ShowReviews_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_showReviews_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Type = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_type'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Type_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Type_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Type_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_Type_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Type_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Type_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Type_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_Type_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_vertAlign'
  create?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Read>
  update?: Maybe<CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Update>
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Create = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_vertAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_vertAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Read = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_vertAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_Newsroom_Hero_VertAlign_Update = {
  __typename?: 'CmsSettingsDocAccessFields_newsroom_hero_vertAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs'
  create?: Maybe<CmsSettingsDocAccessFields_SameAs_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_SameAs_Delete>
  fields?: Maybe<CmsSettingsDocAccessFields_SameAs_Fields>
  read?: Maybe<CmsSettingsDocAccessFields_SameAs_Read>
  update?: Maybe<CmsSettingsDocAccessFields_SameAs_Update>
}

export type CmsSettingsDocAccessFields_SameAs_Create = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Fields = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_Fields'
  id?: Maybe<CmsSettingsDocAccessFields_SameAs_Id>
  value?: Maybe<CmsSettingsDocAccessFields_SameAs_Value>
}

export type CmsSettingsDocAccessFields_SameAs_Read = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Update = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Id = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_id'
  create?: Maybe<CmsSettingsDocAccessFields_SameAs_Id_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_SameAs_Id_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_SameAs_Id_Read>
  update?: Maybe<CmsSettingsDocAccessFields_SameAs_Id_Update>
}

export type CmsSettingsDocAccessFields_SameAs_Id_Create = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Id_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Id_Read = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Id_Update = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Value = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_value'
  create?: Maybe<CmsSettingsDocAccessFields_SameAs_Value_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_SameAs_Value_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_SameAs_Value_Read>
  update?: Maybe<CmsSettingsDocAccessFields_SameAs_Value_Update>
}

export type CmsSettingsDocAccessFields_SameAs_Value_Create = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Value_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Value_Read = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_SameAs_Value_Update = {
  __typename?: 'CmsSettingsDocAccessFields_sameAs_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_UpdatedAt = {
  __typename?: 'CmsSettingsDocAccessFields_updatedAt'
  create?: Maybe<CmsSettingsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<CmsSettingsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<CmsSettingsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<CmsSettingsDocAccessFields_UpdatedAt_Update>
}

export type CmsSettingsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CmsSettingsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CmsSettingsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CmsSettingsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CmsSettingsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields = {
  __typename?: 'CmsSettingsFields'
  articlesPage?: Maybe<CmsSettingsFields_ArticlesPage>
  blog?: Maybe<CmsSettingsFields_Blog>
  createdAt?: Maybe<CmsSettingsFields_CreatedAt>
  logo?: Maybe<CmsSettingsFields_Logo>
  newsroom?: Maybe<CmsSettingsFields_Newsroom>
  sameAs?: Maybe<CmsSettingsFields_SameAs>
  updatedAt?: Maybe<CmsSettingsFields_UpdatedAt>
}

export type CmsSettingsFields_ArticlesPage = {
  __typename?: 'CmsSettingsFields_articlesPage'
  create?: Maybe<CmsSettingsFields_ArticlesPage_Create>
  delete?: Maybe<CmsSettingsFields_ArticlesPage_Delete>
  read?: Maybe<CmsSettingsFields_ArticlesPage_Read>
  update?: Maybe<CmsSettingsFields_ArticlesPage_Update>
}

export type CmsSettingsFields_ArticlesPage_Create = {
  __typename?: 'CmsSettingsFields_articlesPage_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_ArticlesPage_Delete = {
  __typename?: 'CmsSettingsFields_articlesPage_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_ArticlesPage_Read = {
  __typename?: 'CmsSettingsFields_articlesPage_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_ArticlesPage_Update = {
  __typename?: 'CmsSettingsFields_articlesPage_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog = {
  __typename?: 'CmsSettingsFields_blog'
  create?: Maybe<CmsSettingsFields_Blog_Create>
  delete?: Maybe<CmsSettingsFields_Blog_Delete>
  fields?: Maybe<CmsSettingsFields_Blog_Fields>
  read?: Maybe<CmsSettingsFields_Blog_Read>
  update?: Maybe<CmsSettingsFields_Blog_Update>
}

export type CmsSettingsFields_Blog_Create = {
  __typename?: 'CmsSettingsFields_blog_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_Delete = {
  __typename?: 'CmsSettingsFields_blog_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_Fields = {
  __typename?: 'CmsSettingsFields_blog_Fields'
  featuredArticles?: Maybe<CmsSettingsFields_Blog_FeaturedArticles>
  filterCategories?: Maybe<CmsSettingsFields_Blog_FilterCategories>
  popularArticles?: Maybe<CmsSettingsFields_Blog_PopularArticles>
}

export type CmsSettingsFields_Blog_Read = {
  __typename?: 'CmsSettingsFields_blog_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_Update = {
  __typename?: 'CmsSettingsFields_blog_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FeaturedArticles = {
  __typename?: 'CmsSettingsFields_blog_featuredArticles'
  create?: Maybe<CmsSettingsFields_Blog_FeaturedArticles_Create>
  delete?: Maybe<CmsSettingsFields_Blog_FeaturedArticles_Delete>
  read?: Maybe<CmsSettingsFields_Blog_FeaturedArticles_Read>
  update?: Maybe<CmsSettingsFields_Blog_FeaturedArticles_Update>
}

export type CmsSettingsFields_Blog_FeaturedArticles_Create = {
  __typename?: 'CmsSettingsFields_blog_featuredArticles_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FeaturedArticles_Delete = {
  __typename?: 'CmsSettingsFields_blog_featuredArticles_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FeaturedArticles_Read = {
  __typename?: 'CmsSettingsFields_blog_featuredArticles_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FeaturedArticles_Update = {
  __typename?: 'CmsSettingsFields_blog_featuredArticles_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FilterCategories = {
  __typename?: 'CmsSettingsFields_blog_filterCategories'
  create?: Maybe<CmsSettingsFields_Blog_FilterCategories_Create>
  delete?: Maybe<CmsSettingsFields_Blog_FilterCategories_Delete>
  read?: Maybe<CmsSettingsFields_Blog_FilterCategories_Read>
  update?: Maybe<CmsSettingsFields_Blog_FilterCategories_Update>
}

export type CmsSettingsFields_Blog_FilterCategories_Create = {
  __typename?: 'CmsSettingsFields_blog_filterCategories_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FilterCategories_Delete = {
  __typename?: 'CmsSettingsFields_blog_filterCategories_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FilterCategories_Read = {
  __typename?: 'CmsSettingsFields_blog_filterCategories_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_FilterCategories_Update = {
  __typename?: 'CmsSettingsFields_blog_filterCategories_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_PopularArticles = {
  __typename?: 'CmsSettingsFields_blog_popularArticles'
  create?: Maybe<CmsSettingsFields_Blog_PopularArticles_Create>
  delete?: Maybe<CmsSettingsFields_Blog_PopularArticles_Delete>
  read?: Maybe<CmsSettingsFields_Blog_PopularArticles_Read>
  update?: Maybe<CmsSettingsFields_Blog_PopularArticles_Update>
}

export type CmsSettingsFields_Blog_PopularArticles_Create = {
  __typename?: 'CmsSettingsFields_blog_popularArticles_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_PopularArticles_Delete = {
  __typename?: 'CmsSettingsFields_blog_popularArticles_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_PopularArticles_Read = {
  __typename?: 'CmsSettingsFields_blog_popularArticles_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Blog_PopularArticles_Update = {
  __typename?: 'CmsSettingsFields_blog_popularArticles_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_CreatedAt = {
  __typename?: 'CmsSettingsFields_createdAt'
  create?: Maybe<CmsSettingsFields_CreatedAt_Create>
  delete?: Maybe<CmsSettingsFields_CreatedAt_Delete>
  read?: Maybe<CmsSettingsFields_CreatedAt_Read>
  update?: Maybe<CmsSettingsFields_CreatedAt_Update>
}

export type CmsSettingsFields_CreatedAt_Create = {
  __typename?: 'CmsSettingsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_CreatedAt_Delete = {
  __typename?: 'CmsSettingsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_CreatedAt_Read = {
  __typename?: 'CmsSettingsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_CreatedAt_Update = {
  __typename?: 'CmsSettingsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Logo = {
  __typename?: 'CmsSettingsFields_logo'
  create?: Maybe<CmsSettingsFields_Logo_Create>
  delete?: Maybe<CmsSettingsFields_Logo_Delete>
  read?: Maybe<CmsSettingsFields_Logo_Read>
  update?: Maybe<CmsSettingsFields_Logo_Update>
}

export type CmsSettingsFields_Logo_Create = {
  __typename?: 'CmsSettingsFields_logo_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Logo_Delete = {
  __typename?: 'CmsSettingsFields_logo_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Logo_Read = {
  __typename?: 'CmsSettingsFields_logo_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Logo_Update = {
  __typename?: 'CmsSettingsFields_logo_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom = {
  __typename?: 'CmsSettingsFields_newsroom'
  create?: Maybe<CmsSettingsFields_Newsroom_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Delete>
  fields?: Maybe<CmsSettingsFields_Newsroom_Fields>
  read?: Maybe<CmsSettingsFields_Newsroom_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Update>
}

export type CmsSettingsFields_Newsroom_Create = {
  __typename?: 'CmsSettingsFields_newsroom_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Fields = {
  __typename?: 'CmsSettingsFields_newsroom_Fields'
  hero?: Maybe<CmsSettingsFields_Newsroom_Hero>
}

export type CmsSettingsFields_Newsroom_Read = {
  __typename?: 'CmsSettingsFields_newsroom_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Update = {
  __typename?: 'CmsSettingsFields_newsroom_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero = {
  __typename?: 'CmsSettingsFields_newsroom_hero'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Delete>
  fields?: Maybe<CmsSettingsFields_Newsroom_Hero_Fields>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Fields = {
  __typename?: 'CmsSettingsFields_newsroom_hero_Fields'
  desktopFallback?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopFallback>
  desktopVideo?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopVideo>
  disclaimerText?: Maybe<CmsSettingsFields_Newsroom_Hero_DisclaimerText>
  heroSize?: Maybe<CmsSettingsFields_Newsroom_Hero_HeroSize>
  hzAlign?: Maybe<CmsSettingsFields_Newsroom_Hero_HzAlign>
  links?: Maybe<CmsSettingsFields_Newsroom_Hero_Links>
  media?: Maybe<CmsSettingsFields_Newsroom_Hero_Media>
  mobileFallback?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileFallback>
  mobileVideo?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileVideo>
  productImage?: Maybe<CmsSettingsFields_Newsroom_Hero_ProductImage>
  reviewRating?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewRating>
  reviewText?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewText>
  richText?: Maybe<CmsSettingsFields_Newsroom_Hero_RichText>
  richTextMax?: Maybe<CmsSettingsFields_Newsroom_Hero_RichTextMax>
  showReviews?: Maybe<CmsSettingsFields_Newsroom_Hero_ShowReviews>
  type?: Maybe<CmsSettingsFields_Newsroom_Hero_Type>
  vertAlign?: Maybe<CmsSettingsFields_Newsroom_Hero_VertAlign>
}

export type CmsSettingsFields_Newsroom_Hero_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopFallback = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopFallback'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopFallback_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopFallback_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopFallback_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopFallback_Update>
}

export type CmsSettingsFields_Newsroom_Hero_DesktopFallback_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopFallback_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopFallback_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopFallback_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopVideo = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopVideo'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopVideo_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopVideo_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopVideo_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_DesktopVideo_Update>
}

export type CmsSettingsFields_Newsroom_Hero_DesktopVideo_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopVideo_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopVideo_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DesktopVideo_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_desktopVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DisclaimerText = {
  __typename?: 'CmsSettingsFields_newsroom_hero_disclaimerText'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_DisclaimerText_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_DisclaimerText_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_DisclaimerText_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_DisclaimerText_Update>
}

export type CmsSettingsFields_Newsroom_Hero_DisclaimerText_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_disclaimerText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DisclaimerText_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_disclaimerText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DisclaimerText_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_disclaimerText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_DisclaimerText_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_disclaimerText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HeroSize = {
  __typename?: 'CmsSettingsFields_newsroom_hero_heroSize'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_HeroSize_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_HeroSize_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_HeroSize_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_HeroSize_Update>
}

export type CmsSettingsFields_Newsroom_Hero_HeroSize_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_heroSize_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HeroSize_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_heroSize_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HeroSize_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_heroSize_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HeroSize_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_heroSize_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HzAlign = {
  __typename?: 'CmsSettingsFields_newsroom_hero_hzAlign'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_HzAlign_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_HzAlign_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_HzAlign_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_HzAlign_Update>
}

export type CmsSettingsFields_Newsroom_Hero_HzAlign_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_hzAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HzAlign_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_hzAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HzAlign_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_hzAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_HzAlign_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_hzAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Delete>
  fields?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Fields>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Fields = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_Fields'
  id?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Id>
  link?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Id = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_id'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Id_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Id_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Id_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Id_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Id_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Id_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Id_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Id_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Delete>
  fields?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Fields>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Fields = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_Fields'
  iconAfter?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter>
  iconBefore?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore>
  label?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Label>
  newTab?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab>
  query?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query>
  reference?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reference>
  reusable?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable>
  targetId?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId>
  type?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Type>
  url?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Url>
  variant?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Variant>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconAfter'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconAfter_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconBefore'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_IconBefore_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Label = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_label'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Label_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_newTab'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_NewTab_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Delete>
  fields?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Fields>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Fields = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_Fields'
  id?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id>
  key?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key>
  value?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_id'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Id_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_key'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Key_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_value'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Query_Value_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reference = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reference'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reference_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reusable'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Reusable_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_targetId'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_TargetId_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Type = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_type'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Type_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Url = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_url'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Url_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Variant = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_variant'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Links_Link_Variant_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Media = {
  __typename?: 'CmsSettingsFields_newsroom_hero_media'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Media_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Media_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Media_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Media_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Media_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_media_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Media_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Media_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_media_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Media_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_media_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileFallback = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileFallback'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileFallback_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileFallback_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileFallback_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileFallback_Update>
}

export type CmsSettingsFields_Newsroom_Hero_MobileFallback_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileFallback_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileFallback_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileFallback_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileVideo = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileVideo'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileVideo_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileVideo_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileVideo_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_MobileVideo_Update>
}

export type CmsSettingsFields_Newsroom_Hero_MobileVideo_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileVideo_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileVideo_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_MobileVideo_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_mobileVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ProductImage = {
  __typename?: 'CmsSettingsFields_newsroom_hero_productImage'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_ProductImage_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_ProductImage_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_ProductImage_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_ProductImage_Update>
}

export type CmsSettingsFields_Newsroom_Hero_ProductImage_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_productImage_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ProductImage_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_productImage_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ProductImage_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_productImage_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ProductImage_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_productImage_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewRating = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewRating'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewRating_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewRating_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewRating_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewRating_Update>
}

export type CmsSettingsFields_Newsroom_Hero_ReviewRating_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewRating_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewRating_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewRating_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewRating_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewRating_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewRating_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewRating_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewText = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewText'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewText_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewText_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewText_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_ReviewText_Update>
}

export type CmsSettingsFields_Newsroom_Hero_ReviewText_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewText_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewText_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ReviewText_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_reviewText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichText = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richText'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_RichText_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_RichText_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_RichText_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_RichText_Update>
}

export type CmsSettingsFields_Newsroom_Hero_RichTextMax = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richTextMax'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_RichTextMax_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_RichTextMax_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_RichTextMax_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_RichTextMax_Update>
}

export type CmsSettingsFields_Newsroom_Hero_RichTextMax_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richTextMax_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichTextMax_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richTextMax_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichTextMax_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richTextMax_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichTextMax_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richTextMax_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichText_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichText_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichText_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_RichText_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ShowReviews = {
  __typename?: 'CmsSettingsFields_newsroom_hero_showReviews'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_ShowReviews_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_ShowReviews_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_ShowReviews_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_ShowReviews_Update>
}

export type CmsSettingsFields_Newsroom_Hero_ShowReviews_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_showReviews_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ShowReviews_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_showReviews_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ShowReviews_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_showReviews_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_ShowReviews_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_showReviews_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Type = {
  __typename?: 'CmsSettingsFields_newsroom_hero_type'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_Type_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_Type_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_Type_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_Type_Update>
}

export type CmsSettingsFields_Newsroom_Hero_Type_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_type_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Type_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Type_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_type_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_Type_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_type_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_VertAlign = {
  __typename?: 'CmsSettingsFields_newsroom_hero_vertAlign'
  create?: Maybe<CmsSettingsFields_Newsroom_Hero_VertAlign_Create>
  delete?: Maybe<CmsSettingsFields_Newsroom_Hero_VertAlign_Delete>
  read?: Maybe<CmsSettingsFields_Newsroom_Hero_VertAlign_Read>
  update?: Maybe<CmsSettingsFields_Newsroom_Hero_VertAlign_Update>
}

export type CmsSettingsFields_Newsroom_Hero_VertAlign_Create = {
  __typename?: 'CmsSettingsFields_newsroom_hero_vertAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_VertAlign_Delete = {
  __typename?: 'CmsSettingsFields_newsroom_hero_vertAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_VertAlign_Read = {
  __typename?: 'CmsSettingsFields_newsroom_hero_vertAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_Newsroom_Hero_VertAlign_Update = {
  __typename?: 'CmsSettingsFields_newsroom_hero_vertAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs = {
  __typename?: 'CmsSettingsFields_sameAs'
  create?: Maybe<CmsSettingsFields_SameAs_Create>
  delete?: Maybe<CmsSettingsFields_SameAs_Delete>
  fields?: Maybe<CmsSettingsFields_SameAs_Fields>
  read?: Maybe<CmsSettingsFields_SameAs_Read>
  update?: Maybe<CmsSettingsFields_SameAs_Update>
}

export type CmsSettingsFields_SameAs_Create = {
  __typename?: 'CmsSettingsFields_sameAs_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Delete = {
  __typename?: 'CmsSettingsFields_sameAs_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Fields = {
  __typename?: 'CmsSettingsFields_sameAs_Fields'
  id?: Maybe<CmsSettingsFields_SameAs_Id>
  value?: Maybe<CmsSettingsFields_SameAs_Value>
}

export type CmsSettingsFields_SameAs_Read = {
  __typename?: 'CmsSettingsFields_sameAs_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Update = {
  __typename?: 'CmsSettingsFields_sameAs_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Id = {
  __typename?: 'CmsSettingsFields_sameAs_id'
  create?: Maybe<CmsSettingsFields_SameAs_Id_Create>
  delete?: Maybe<CmsSettingsFields_SameAs_Id_Delete>
  read?: Maybe<CmsSettingsFields_SameAs_Id_Read>
  update?: Maybe<CmsSettingsFields_SameAs_Id_Update>
}

export type CmsSettingsFields_SameAs_Id_Create = {
  __typename?: 'CmsSettingsFields_sameAs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Id_Delete = {
  __typename?: 'CmsSettingsFields_sameAs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Id_Read = {
  __typename?: 'CmsSettingsFields_sameAs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Id_Update = {
  __typename?: 'CmsSettingsFields_sameAs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Value = {
  __typename?: 'CmsSettingsFields_sameAs_value'
  create?: Maybe<CmsSettingsFields_SameAs_Value_Create>
  delete?: Maybe<CmsSettingsFields_SameAs_Value_Delete>
  read?: Maybe<CmsSettingsFields_SameAs_Value_Read>
  update?: Maybe<CmsSettingsFields_SameAs_Value_Update>
}

export type CmsSettingsFields_SameAs_Value_Create = {
  __typename?: 'CmsSettingsFields_sameAs_value_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Value_Delete = {
  __typename?: 'CmsSettingsFields_sameAs_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Value_Read = {
  __typename?: 'CmsSettingsFields_sameAs_value_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_SameAs_Value_Update = {
  __typename?: 'CmsSettingsFields_sameAs_value_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_UpdatedAt = {
  __typename?: 'CmsSettingsFields_updatedAt'
  create?: Maybe<CmsSettingsFields_UpdatedAt_Create>
  delete?: Maybe<CmsSettingsFields_UpdatedAt_Delete>
  read?: Maybe<CmsSettingsFields_UpdatedAt_Read>
  update?: Maybe<CmsSettingsFields_UpdatedAt_Update>
}

export type CmsSettingsFields_UpdatedAt_Create = {
  __typename?: 'CmsSettingsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_UpdatedAt_Delete = {
  __typename?: 'CmsSettingsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_UpdatedAt_Read = {
  __typename?: 'CmsSettingsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsFields_UpdatedAt_Update = {
  __typename?: 'CmsSettingsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CmsSettingsReadAccess = {
  __typename?: 'CmsSettingsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsSettingsReadDocAccess = {
  __typename?: 'CmsSettingsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsSettingsUpdateAccess = {
  __typename?: 'CmsSettingsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsSettingsUpdateDocAccess = {
  __typename?: 'CmsSettingsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CmsSettings_Blog = {
  __typename?: 'CmsSettings_Blog'
  featuredArticles?: Maybe<Array<CmsArticle>>
  filterCategories?: Maybe<Array<CmsCategories>>
  popularArticles?: Maybe<Array<CmsArticle>>
}

export type CmsSettings_BlogFeaturedArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsSettings_BlogPopularArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsSettings_Newsroom = {
  __typename?: 'CmsSettings_Newsroom'
  hero?: Maybe<CmsHero>
}

export type CmsSettings_Newsroom_Hero_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CmsSettings_Newsroom_Hero_Links_Link_ReferenceRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsSettings_Newsroom_Hero_Links_Link_ReferenceRelationshipInputRelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type CmsSettings_Newsroom_Hero_Links_Link_ReferenceRelationshipInputRelationTo =
  (typeof CmsSettings_Newsroom_Hero_Links_Link_ReferenceRelationshipInputRelationTo)[keyof typeof CmsSettings_Newsroom_Hero_Links_Link_ReferenceRelationshipInputRelationTo]
export type CmsSettings_Newsroom_Hero_Links_Link_ReusableRelationshipInput = {
  relationTo?: InputMaybe<CmsSettings_Newsroom_Hero_Links_Link_ReusableRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const CmsSettings_Newsroom_Hero_Links_Link_ReusableRelationshipInputRelationTo = {
  Links: 'links',
} as const

export type CmsSettings_Newsroom_Hero_Links_Link_ReusableRelationshipInputRelationTo =
  (typeof CmsSettings_Newsroom_Hero_Links_Link_ReusableRelationshipInputRelationTo)[keyof typeof CmsSettings_Newsroom_Hero_Links_Link_ReusableRelationshipInputRelationTo]
export const CmsSettings_Newsroom_Hero_Links_Link_Variant_MutationInput = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type CmsSettings_Newsroom_Hero_Links_Link_Variant_MutationInput =
  (typeof CmsSettings_Newsroom_Hero_Links_Link_Variant_MutationInput)[keyof typeof CmsSettings_Newsroom_Hero_Links_Link_Variant_MutationInput]
export const CmsSettings_Newsroom_Hero_HzAlign_MutationInput = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type CmsSettings_Newsroom_Hero_HzAlign_MutationInput =
  (typeof CmsSettings_Newsroom_Hero_HzAlign_MutationInput)[keyof typeof CmsSettings_Newsroom_Hero_HzAlign_MutationInput]
export const CmsSettings_Newsroom_Hero_Type_MutationInput = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type CmsSettings_Newsroom_Hero_Type_MutationInput =
  (typeof CmsSettings_Newsroom_Hero_Type_MutationInput)[keyof typeof CmsSettings_Newsroom_Hero_Type_MutationInput]
export const CmsSettings_Newsroom_Hero_VertAlign_MutationInput = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type CmsSettings_Newsroom_Hero_VertAlign_MutationInput =
  (typeof CmsSettings_Newsroom_Hero_VertAlign_MutationInput)[keyof typeof CmsSettings_Newsroom_Hero_VertAlign_MutationInput]
export type CmsSettings_SameAs = {
  __typename?: 'CmsSettings_SameAs'
  id?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type CmsStackerPage = {
  __typename?: 'CmsStackerPage'
  _status?: Maybe<CmsStackerPage__Status>
  affiliateCode?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  id: Scalars['Int']['output']
  offerCategories?: Maybe<Array<CmsStackerPage_OfferCategories>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export const CmsStackerPageUpdate_OfferCategories_Category_MutationInput = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsStackerPageUpdate_OfferCategories_Category_MutationInput =
  (typeof CmsStackerPageUpdate_OfferCategories_Category_MutationInput)[keyof typeof CmsStackerPageUpdate_OfferCategories_Category_MutationInput]
export const CmsStackerPageUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsStackerPageUpdate__Status_MutationInput =
  (typeof CmsStackerPageUpdate__Status_MutationInput)[keyof typeof CmsStackerPageUpdate__Status_MutationInput]
export type CmsStackerPageVersion = {
  __typename?: 'CmsStackerPageVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsStackerPage>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsStackerPageVersion_Version>
}

export type CmsStackerPageVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsStackerPageVersion_Version = {
  __typename?: 'CmsStackerPageVersion_Version'
  _status?: Maybe<CmsStackerPageVersion_Version__Status>
  affiliateCode?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  offerCategories?: Maybe<Array<CmsStackerPageVersion_Version_OfferCategories>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsStackerPageVersion_Version_OfferCategories = {
  __typename?: 'CmsStackerPageVersion_Version_OfferCategories'
  category?: Maybe<CmsStackerPageVersion_Version_OfferCategories_Category>
  collection?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export const CmsStackerPageVersion_Version_OfferCategories_Category = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsStackerPageVersion_Version_OfferCategories_Category =
  (typeof CmsStackerPageVersion_Version_OfferCategories_Category)[keyof typeof CmsStackerPageVersion_Version_OfferCategories_Category]
export const CmsStackerPageVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsStackerPageVersion_Version__Status =
  (typeof CmsStackerPageVersion_Version__Status)[keyof typeof CmsStackerPageVersion_Version__Status]
export type CmsStackerPage_OfferCategories = {
  __typename?: 'CmsStackerPage_OfferCategories'
  category?: Maybe<CmsStackerPage_OfferCategories_Category>
  collection?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export const CmsStackerPage_OfferCategories_Category = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsStackerPage_OfferCategories_Category =
  (typeof CmsStackerPage_OfferCategories_Category)[keyof typeof CmsStackerPage_OfferCategories_Category]
export const CmsStackerPage_OfferCategories_Category_MutationInput = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsStackerPage_OfferCategories_Category_MutationInput =
  (typeof CmsStackerPage_OfferCategories_Category_MutationInput)[keyof typeof CmsStackerPage_OfferCategories_Category_MutationInput]
export const CmsStackerPage__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsStackerPage__Status = (typeof CmsStackerPage__Status)[keyof typeof CmsStackerPage__Status]
export const CmsStackerPage__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsStackerPage__Status_Input =
  (typeof CmsStackerPage__Status_Input)[keyof typeof CmsStackerPage__Status_Input]
export const CmsStackerPage__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsStackerPage__Status_MutationInput =
  (typeof CmsStackerPage__Status_MutationInput)[keyof typeof CmsStackerPage__Status_MutationInput]
export type CmsStackerPage__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsStackerPage__Status_Input>>>
  equals?: InputMaybe<CmsStackerPage__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsStackerPage__Status_Input>>>
  not_equals?: InputMaybe<CmsStackerPage__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsStackerPage__Status_Input>>>
}

export type CmsStackerPage_AffiliateCode_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsStackerPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsStackerPage_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsStackerPage_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export const CmsStackerPage_OfferCategories__Category_Input = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type CmsStackerPage_OfferCategories__Category_Input =
  (typeof CmsStackerPage_OfferCategories__Category_Input)[keyof typeof CmsStackerPage_OfferCategories__Category_Input]
export type CmsStackerPage_OfferCategories__Category_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsStackerPage_OfferCategories__Category_Input>>>
  equals?: InputMaybe<CmsStackerPage_OfferCategories__Category_Input>
  in?: InputMaybe<Array<InputMaybe<CmsStackerPage_OfferCategories__Category_Input>>>
  not_equals?: InputMaybe<CmsStackerPage_OfferCategories__Category_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsStackerPage_OfferCategories__Category_Input>>>
}

export type CmsStackerPage_OfferCategories__Collection_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsStackerPage_OfferCategories__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsStackerPage_OfferCategories__Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsStackerPage_OfferCategories__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsStackerPage_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsStackerPage_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsStackerPage_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsStackerPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsStackerPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsStackerPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsStackerPage_Where_Or>>>
  _status?: InputMaybe<CmsStackerPage__Status_Operator>
  affiliateCode?: InputMaybe<CmsStackerPage_AffiliateCode_Operator>
  createdAt?: InputMaybe<CmsStackerPage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsStackerPage_CreatedBy_Operator>
  id?: InputMaybe<CmsStackerPage_Id_Operator>
  offerCategories__category?: InputMaybe<CmsStackerPage_OfferCategories__Category_Operator>
  offerCategories__collection?: InputMaybe<CmsStackerPage_OfferCategories__Collection_Operator>
  offerCategories__id?: InputMaybe<CmsStackerPage_OfferCategories__Id_Operator>
  offerCategories__name?: InputMaybe<CmsStackerPage_OfferCategories__Name_Operator>
  offerCategories__slug?: InputMaybe<CmsStackerPage_OfferCategories__Slug_Operator>
  publishedAt?: InputMaybe<CmsStackerPage_PublishedAt_Operator>
  slug?: InputMaybe<CmsStackerPage_Slug_Operator>
  title?: InputMaybe<CmsStackerPage_Title_Operator>
  updatedAt?: InputMaybe<CmsStackerPage_UpdatedAt_Operator>
}

export type CmsStackerPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsStackerPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsStackerPage_Where_Or>>>
  _status?: InputMaybe<CmsStackerPage__Status_Operator>
  affiliateCode?: InputMaybe<CmsStackerPage_AffiliateCode_Operator>
  createdAt?: InputMaybe<CmsStackerPage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsStackerPage_CreatedBy_Operator>
  id?: InputMaybe<CmsStackerPage_Id_Operator>
  offerCategories__category?: InputMaybe<CmsStackerPage_OfferCategories__Category_Operator>
  offerCategories__collection?: InputMaybe<CmsStackerPage_OfferCategories__Collection_Operator>
  offerCategories__id?: InputMaybe<CmsStackerPage_OfferCategories__Id_Operator>
  offerCategories__name?: InputMaybe<CmsStackerPage_OfferCategories__Name_Operator>
  offerCategories__slug?: InputMaybe<CmsStackerPage_OfferCategories__Slug_Operator>
  publishedAt?: InputMaybe<CmsStackerPage_PublishedAt_Operator>
  slug?: InputMaybe<CmsStackerPage_Slug_Operator>
  title?: InputMaybe<CmsStackerPage_Title_Operator>
  updatedAt?: InputMaybe<CmsStackerPage_UpdatedAt_Operator>
}

export type CmsStackerPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsStackerPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsStackerPage_Where_Or>>>
  _status?: InputMaybe<CmsStackerPage__Status_Operator>
  affiliateCode?: InputMaybe<CmsStackerPage_AffiliateCode_Operator>
  createdAt?: InputMaybe<CmsStackerPage_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsStackerPage_CreatedBy_Operator>
  id?: InputMaybe<CmsStackerPage_Id_Operator>
  offerCategories__category?: InputMaybe<CmsStackerPage_OfferCategories__Category_Operator>
  offerCategories__collection?: InputMaybe<CmsStackerPage_OfferCategories__Collection_Operator>
  offerCategories__id?: InputMaybe<CmsStackerPage_OfferCategories__Id_Operator>
  offerCategories__name?: InputMaybe<CmsStackerPage_OfferCategories__Name_Operator>
  offerCategories__slug?: InputMaybe<CmsStackerPage_OfferCategories__Slug_Operator>
  publishedAt?: InputMaybe<CmsStackerPage_PublishedAt_Operator>
  slug?: InputMaybe<CmsStackerPage_Slug_Operator>
  title?: InputMaybe<CmsStackerPage_Title_Operator>
  updatedAt?: InputMaybe<CmsStackerPage_UpdatedAt_Operator>
}

export type CmsStackerPages = {
  __typename?: 'CmsStackerPages'
  docs?: Maybe<Array<Maybe<CmsStackerPage>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsStateFormField = {
  __typename?: 'CmsStateFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsTableBlock = {
  __typename?: 'CmsTableBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsTableBlock_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
  table?: Maybe<CmsTableBlock_Table>
}

export type CmsTableBlock_Ctas = {
  __typename?: 'CmsTableBlock_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsTableBlock_Table = {
  __typename?: 'CmsTableBlock_Table'
  columns?: Maybe<Array<CmsTableBlock_Table_Columns>>
  rows?: Maybe<Array<CmsTableBlock_Table_Rows>>
}

export type CmsTableBlock_Table_Columns = {
  __typename?: 'CmsTableBlock_Table_Columns'
  header?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsTableBlock_Table_Rows = {
  __typename?: 'CmsTableBlock_Table_Rows'
  cells?: Maybe<Array<CmsTableBlock_Table_Rows_Cells>>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsTableBlock_Table_Rows_Cells = {
  __typename?: 'CmsTableBlock_Table_Rows_Cells'
  cell?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export type CmsTextAreaFormField = {
  __typename?: 'CmsTextAreaFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  defaultValue?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsTextFormField = {
  __typename?: 'CmsTextFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  defaultValue?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsTimeInBusinessFormField = {
  __typename?: 'CmsTimeInBusinessFormField'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsTradeCreditProgram = {
  __typename?: 'CmsTradeCreditProgram'
  _status?: Maybe<CmsTradeCreditProgram__Status>
  applyUrl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  creditLimitHighCents?: Maybe<Scalars['Float']['output']>
  creditLimitLowCents?: Maybe<Scalars['Float']['output']>
  description?: Maybe<Scalars['String']['output']>
  fees?: Maybe<Array<CmsTradeCreditProgram_Fees>>
  id: Scalars['Int']['output']
  minReqs?: Maybe<Array<CmsTradeCreditProgram_MinReqs>>
  notes?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  reportsTo?: Maybe<Array<CmsTradeCreditProgram_ReportsTo>>
  slug?: Maybe<Scalars['String']['output']>
  tags?: Maybe<Array<CmsTradeCreditProgramTag>>
  terms?: Maybe<Array<CmsTradeCreditProgram_Terms>>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  vendor?: Maybe<CmsTradeCreditVendor>
}

export type CmsTradeCreditProgramVendorArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsTradeCreditProgramTag = {
  __typename?: 'CmsTradeCreditProgramTag'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  slug?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsTradeCreditProgramTag_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditProgramTag_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsTradeCreditProgramTag_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditProgramTag_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditProgramTag_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditProgramTag_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgramTag_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgramTag_Where_Or>>>
  createdAt?: InputMaybe<CmsTradeCreditProgramTag_CreatedAt_Operator>
  id?: InputMaybe<CmsTradeCreditProgramTag_Id_Operator>
  slug?: InputMaybe<CmsTradeCreditProgramTag_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditProgramTag_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditProgramTag_UpdatedAt_Operator>
}

export type CmsTradeCreditProgramTag_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgramTag_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgramTag_Where_Or>>>
  createdAt?: InputMaybe<CmsTradeCreditProgramTag_CreatedAt_Operator>
  id?: InputMaybe<CmsTradeCreditProgramTag_Id_Operator>
  slug?: InputMaybe<CmsTradeCreditProgramTag_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditProgramTag_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditProgramTag_UpdatedAt_Operator>
}

export type CmsTradeCreditProgramTag_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgramTag_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgramTag_Where_Or>>>
  createdAt?: InputMaybe<CmsTradeCreditProgramTag_CreatedAt_Operator>
  id?: InputMaybe<CmsTradeCreditProgramTag_Id_Operator>
  slug?: InputMaybe<CmsTradeCreditProgramTag_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditProgramTag_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditProgramTag_UpdatedAt_Operator>
}

export type CmsTradeCreditProgramTags = {
  __typename?: 'CmsTradeCreditProgramTags'
  docs?: Maybe<Array<Maybe<CmsTradeCreditProgramTag>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export const CmsTradeCreditProgramUpdate_Fees_PaymentPeriod_MutationInput = {
  Annual: 'annual',
  Biannual: 'biannual',
  Monthly: 'monthly',
  OneTime: 'one_time',
  Quarterly: 'quarterly',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgramUpdate_Fees_PaymentPeriod_MutationInput =
  (typeof CmsTradeCreditProgramUpdate_Fees_PaymentPeriod_MutationInput)[keyof typeof CmsTradeCreditProgramUpdate_Fees_PaymentPeriod_MutationInput]
export const CmsTradeCreditProgramUpdate_MinReqs_OrderUnit_MutationInput = {
  Month: 'month',
  Order: 'order',
  Quarter: 'quarter',
  Unspecified: 'unspecified',
  Year: 'year',
} as const

export type CmsTradeCreditProgramUpdate_MinReqs_OrderUnit_MutationInput =
  (typeof CmsTradeCreditProgramUpdate_MinReqs_OrderUnit_MutationInput)[keyof typeof CmsTradeCreditProgramUpdate_MinReqs_OrderUnit_MutationInput]
export const CmsTradeCreditProgramUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditProgramUpdate__Status_MutationInput =
  (typeof CmsTradeCreditProgramUpdate__Status_MutationInput)[keyof typeof CmsTradeCreditProgramUpdate__Status_MutationInput]
export const CmsTradeCreditProgramUpdate_ReportsTo_MutationInput = {
  Ansonia: 'ansonia',
  Cortera: 'cortera',
  CreditSafe: 'credit_safe',
  DunAndBradstreet: 'dun_and_bradstreet',
  Equifax: 'equifax',
  Experian: 'experian',
  Moodys: 'moodys',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgramUpdate_ReportsTo_MutationInput =
  (typeof CmsTradeCreditProgramUpdate_ReportsTo_MutationInput)[keyof typeof CmsTradeCreditProgramUpdate_ReportsTo_MutationInput]
export type CmsTradeCreditProgramVersion = {
  __typename?: 'CmsTradeCreditProgramVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsTradeCreditProgram>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsTradeCreditProgramVersion_Version>
}

export type CmsTradeCreditProgramVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsTradeCreditProgramVersion_Version = {
  __typename?: 'CmsTradeCreditProgramVersion_Version'
  _status?: Maybe<CmsTradeCreditProgramVersion_Version__Status>
  applyUrl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  creditLimitHighCents?: Maybe<Scalars['Float']['output']>
  creditLimitLowCents?: Maybe<Scalars['Float']['output']>
  description?: Maybe<Scalars['String']['output']>
  fees?: Maybe<Array<CmsTradeCreditProgramVersion_Version_Fees>>
  minReqs?: Maybe<Array<CmsTradeCreditProgramVersion_Version_MinReqs>>
  notes?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  reportsTo?: Maybe<Array<CmsTradeCreditProgramVersion_Version_ReportsTo>>
  slug?: Maybe<Scalars['String']['output']>
  tags?: Maybe<Array<CmsTradeCreditProgramTag>>
  terms?: Maybe<Array<CmsTradeCreditProgramVersion_Version_Terms>>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  vendor?: Maybe<CmsTradeCreditVendor>
}

export type CmsTradeCreditProgramVersion_VersionVendorArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsTradeCreditProgramVersion_Version_Fees = {
  __typename?: 'CmsTradeCreditProgramVersion_Version_Fees'
  amountHighCents?: Maybe<Scalars['Float']['output']>
  amountLowCents?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  paymentPeriod?: Maybe<CmsTradeCreditProgramVersion_Version_Fees_PaymentPeriod>
}

export const CmsTradeCreditProgramVersion_Version_Fees_PaymentPeriod = {
  Annual: 'annual',
  Biannual: 'biannual',
  Monthly: 'monthly',
  OneTime: 'one_time',
  Quarterly: 'quarterly',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgramVersion_Version_Fees_PaymentPeriod =
  (typeof CmsTradeCreditProgramVersion_Version_Fees_PaymentPeriod)[keyof typeof CmsTradeCreditProgramVersion_Version_Fees_PaymentPeriod]
export type CmsTradeCreditProgramVersion_Version_MinReqs = {
  __typename?: 'CmsTradeCreditProgramVersion_Version_MinReqs'
  amountCents?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  orderUnit?: Maybe<CmsTradeCreditProgramVersion_Version_MinReqs_OrderUnit>
}

export const CmsTradeCreditProgramVersion_Version_MinReqs_OrderUnit = {
  Month: 'month',
  Order: 'order',
  Quarter: 'quarter',
  Unspecified: 'unspecified',
  Year: 'year',
} as const

export type CmsTradeCreditProgramVersion_Version_MinReqs_OrderUnit =
  (typeof CmsTradeCreditProgramVersion_Version_MinReqs_OrderUnit)[keyof typeof CmsTradeCreditProgramVersion_Version_MinReqs_OrderUnit]
export type CmsTradeCreditProgramVersion_Version_Terms = {
  __typename?: 'CmsTradeCreditProgramVersion_Version_Terms'
  discountDurationDays?: Maybe<Scalars['Float']['output']>
  discountPercentage?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  netDueAfterDays?: Maybe<Scalars['Float']['output']>
}

export const CmsTradeCreditProgramVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditProgramVersion_Version__Status =
  (typeof CmsTradeCreditProgramVersion_Version__Status)[keyof typeof CmsTradeCreditProgramVersion_Version__Status]
export const CmsTradeCreditProgramVersion_Version_ReportsTo = {
  Ansonia: 'ansonia',
  Cortera: 'cortera',
  CreditSafe: 'credit_safe',
  DunAndBradstreet: 'dun_and_bradstreet',
  Equifax: 'equifax',
  Experian: 'experian',
  Moodys: 'moodys',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgramVersion_Version_ReportsTo =
  (typeof CmsTradeCreditProgramVersion_Version_ReportsTo)[keyof typeof CmsTradeCreditProgramVersion_Version_ReportsTo]
export type CmsTradeCreditProgram_Fees = {
  __typename?: 'CmsTradeCreditProgram_Fees'
  amountHighCents?: Maybe<Scalars['Float']['output']>
  amountLowCents?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  paymentPeriod?: Maybe<CmsTradeCreditProgram_Fees_PaymentPeriod>
}

export const CmsTradeCreditProgram_Fees_PaymentPeriod = {
  Annual: 'annual',
  Biannual: 'biannual',
  Monthly: 'monthly',
  OneTime: 'one_time',
  Quarterly: 'quarterly',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgram_Fees_PaymentPeriod =
  (typeof CmsTradeCreditProgram_Fees_PaymentPeriod)[keyof typeof CmsTradeCreditProgram_Fees_PaymentPeriod]
export const CmsTradeCreditProgram_Fees_PaymentPeriod_MutationInput = {
  Annual: 'annual',
  Biannual: 'biannual',
  Monthly: 'monthly',
  OneTime: 'one_time',
  Quarterly: 'quarterly',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgram_Fees_PaymentPeriod_MutationInput =
  (typeof CmsTradeCreditProgram_Fees_PaymentPeriod_MutationInput)[keyof typeof CmsTradeCreditProgram_Fees_PaymentPeriod_MutationInput]
export type CmsTradeCreditProgram_MinReqs = {
  __typename?: 'CmsTradeCreditProgram_MinReqs'
  amountCents?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  orderUnit?: Maybe<CmsTradeCreditProgram_MinReqs_OrderUnit>
}

export const CmsTradeCreditProgram_MinReqs_OrderUnit = {
  Month: 'month',
  Order: 'order',
  Quarter: 'quarter',
  Unspecified: 'unspecified',
  Year: 'year',
} as const

export type CmsTradeCreditProgram_MinReqs_OrderUnit =
  (typeof CmsTradeCreditProgram_MinReqs_OrderUnit)[keyof typeof CmsTradeCreditProgram_MinReqs_OrderUnit]
export const CmsTradeCreditProgram_MinReqs_OrderUnit_MutationInput = {
  Month: 'month',
  Order: 'order',
  Quarter: 'quarter',
  Unspecified: 'unspecified',
  Year: 'year',
} as const

export type CmsTradeCreditProgram_MinReqs_OrderUnit_MutationInput =
  (typeof CmsTradeCreditProgram_MinReqs_OrderUnit_MutationInput)[keyof typeof CmsTradeCreditProgram_MinReqs_OrderUnit_MutationInput]
export type CmsTradeCreditProgram_Terms = {
  __typename?: 'CmsTradeCreditProgram_Terms'
  discountDurationDays?: Maybe<Scalars['Float']['output']>
  discountPercentage?: Maybe<Scalars['Float']['output']>
  id?: Maybe<Scalars['String']['output']>
  netDueAfterDays?: Maybe<Scalars['Float']['output']>
}

export const CmsTradeCreditProgram__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditProgram__Status =
  (typeof CmsTradeCreditProgram__Status)[keyof typeof CmsTradeCreditProgram__Status]
export const CmsTradeCreditProgram__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditProgram__Status_Input =
  (typeof CmsTradeCreditProgram__Status_Input)[keyof typeof CmsTradeCreditProgram__Status_Input]
export const CmsTradeCreditProgram__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditProgram__Status_MutationInput =
  (typeof CmsTradeCreditProgram__Status_MutationInput)[keyof typeof CmsTradeCreditProgram__Status_MutationInput]
export type CmsTradeCreditProgram__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram__Status_Input>>>
  equals?: InputMaybe<CmsTradeCreditProgram__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram__Status_Input>>>
  not_equals?: InputMaybe<CmsTradeCreditProgram__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram__Status_Input>>>
}

export type CmsTradeCreditProgram_ApplyUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditProgram_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditProgram_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsTradeCreditProgram_CreditLimitHighCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_CreditLimitLowCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsTradeCreditProgram_Fees__AmountHighCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_Fees__AmountLowCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_Fees__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsTradeCreditProgram_Fees__PaymentPeriod_Input = {
  Annual: 'annual',
  Biannual: 'biannual',
  Monthly: 'monthly',
  OneTime: 'one_time',
  Quarterly: 'quarterly',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgram_Fees__PaymentPeriod_Input =
  (typeof CmsTradeCreditProgram_Fees__PaymentPeriod_Input)[keyof typeof CmsTradeCreditProgram_Fees__PaymentPeriod_Input]
export type CmsTradeCreditProgram_Fees__PaymentPeriod_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Input>>>
  equals?: InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Input>
  in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Input>>>
  not_equals?: InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Input>>>
}

export type CmsTradeCreditProgram_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsTradeCreditProgram_MinReqs__AmountCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_MinReqs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsTradeCreditProgram_MinReqs__OrderUnit_Input = {
  Month: 'month',
  Order: 'order',
  Quarter: 'quarter',
  Unspecified: 'unspecified',
  Year: 'year',
} as const

export type CmsTradeCreditProgram_MinReqs__OrderUnit_Input =
  (typeof CmsTradeCreditProgram_MinReqs__OrderUnit_Input)[keyof typeof CmsTradeCreditProgram_MinReqs__OrderUnit_Input]
export type CmsTradeCreditProgram_MinReqs__OrderUnit_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Input>>>
  equals?: InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Input>
  in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Input>>>
  not_equals?: InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Input>>>
}

export type CmsTradeCreditProgram_Notes_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsTradeCreditProgram_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const CmsTradeCreditProgram_ReportsTo = {
  Ansonia: 'ansonia',
  Cortera: 'cortera',
  CreditSafe: 'credit_safe',
  DunAndBradstreet: 'dun_and_bradstreet',
  Equifax: 'equifax',
  Experian: 'experian',
  Moodys: 'moodys',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgram_ReportsTo =
  (typeof CmsTradeCreditProgram_ReportsTo)[keyof typeof CmsTradeCreditProgram_ReportsTo]
export const CmsTradeCreditProgram_ReportsTo_Input = {
  Ansonia: 'ansonia',
  Cortera: 'cortera',
  CreditSafe: 'credit_safe',
  DunAndBradstreet: 'dun_and_bradstreet',
  Equifax: 'equifax',
  Experian: 'experian',
  Moodys: 'moodys',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgram_ReportsTo_Input =
  (typeof CmsTradeCreditProgram_ReportsTo_Input)[keyof typeof CmsTradeCreditProgram_ReportsTo_Input]
export const CmsTradeCreditProgram_ReportsTo_MutationInput = {
  Ansonia: 'ansonia',
  Cortera: 'cortera',
  CreditSafe: 'credit_safe',
  DunAndBradstreet: 'dun_and_bradstreet',
  Equifax: 'equifax',
  Experian: 'experian',
  Moodys: 'moodys',
  Unspecified: 'unspecified',
} as const

export type CmsTradeCreditProgram_ReportsTo_MutationInput =
  (typeof CmsTradeCreditProgram_ReportsTo_MutationInput)[keyof typeof CmsTradeCreditProgram_ReportsTo_MutationInput]
export type CmsTradeCreditProgram_ReportsTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_ReportsTo_Input>>>
  equals?: InputMaybe<CmsTradeCreditProgram_ReportsTo_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_ReportsTo_Input>>>
  not_equals?: InputMaybe<CmsTradeCreditProgram_ReportsTo_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_ReportsTo_Input>>>
}

export type CmsTradeCreditProgram_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditProgram_Tags_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsTradeCreditProgram_Terms__DiscountDurationDays_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_Terms__DiscountPercentage_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_Terms__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditProgram_Terms__NetDueAfterDays_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsTradeCreditProgram_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditProgram_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditProgram_Vendor_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsTradeCreditProgram_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditProgram__Status_Operator>
  applyUrl?: InputMaybe<CmsTradeCreditProgram_ApplyUrl_Operator>
  createdAt?: InputMaybe<CmsTradeCreditProgram_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditProgram_CreatedBy_Operator>
  creditLimitHighCents?: InputMaybe<CmsTradeCreditProgram_CreditLimitHighCents_Operator>
  creditLimitLowCents?: InputMaybe<CmsTradeCreditProgram_CreditLimitLowCents_Operator>
  description?: InputMaybe<CmsTradeCreditProgram_Description_Operator>
  fees__amountHighCents?: InputMaybe<CmsTradeCreditProgram_Fees__AmountHighCents_Operator>
  fees__amountLowCents?: InputMaybe<CmsTradeCreditProgram_Fees__AmountLowCents_Operator>
  fees__id?: InputMaybe<CmsTradeCreditProgram_Fees__Id_Operator>
  fees__paymentPeriod?: InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Operator>
  id?: InputMaybe<CmsTradeCreditProgram_Id_Operator>
  minReqs__amountCents?: InputMaybe<CmsTradeCreditProgram_MinReqs__AmountCents_Operator>
  minReqs__id?: InputMaybe<CmsTradeCreditProgram_MinReqs__Id_Operator>
  minReqs__orderUnit?: InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Operator>
  notes?: InputMaybe<CmsTradeCreditProgram_Notes_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditProgram_PublishedAt_Operator>
  reportsTo?: InputMaybe<CmsTradeCreditProgram_ReportsTo_Operator>
  slug?: InputMaybe<CmsTradeCreditProgram_Slug_Operator>
  tags?: InputMaybe<CmsTradeCreditProgram_Tags_Operator>
  terms__discountDurationDays?: InputMaybe<CmsTradeCreditProgram_Terms__DiscountDurationDays_Operator>
  terms__discountPercentage?: InputMaybe<CmsTradeCreditProgram_Terms__DiscountPercentage_Operator>
  terms__id?: InputMaybe<CmsTradeCreditProgram_Terms__Id_Operator>
  terms__netDueAfterDays?: InputMaybe<CmsTradeCreditProgram_Terms__NetDueAfterDays_Operator>
  title?: InputMaybe<CmsTradeCreditProgram_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditProgram_UpdatedAt_Operator>
  vendor?: InputMaybe<CmsTradeCreditProgram_Vendor_Operator>
}

export type CmsTradeCreditProgram_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditProgram__Status_Operator>
  applyUrl?: InputMaybe<CmsTradeCreditProgram_ApplyUrl_Operator>
  createdAt?: InputMaybe<CmsTradeCreditProgram_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditProgram_CreatedBy_Operator>
  creditLimitHighCents?: InputMaybe<CmsTradeCreditProgram_CreditLimitHighCents_Operator>
  creditLimitLowCents?: InputMaybe<CmsTradeCreditProgram_CreditLimitLowCents_Operator>
  description?: InputMaybe<CmsTradeCreditProgram_Description_Operator>
  fees__amountHighCents?: InputMaybe<CmsTradeCreditProgram_Fees__AmountHighCents_Operator>
  fees__amountLowCents?: InputMaybe<CmsTradeCreditProgram_Fees__AmountLowCents_Operator>
  fees__id?: InputMaybe<CmsTradeCreditProgram_Fees__Id_Operator>
  fees__paymentPeriod?: InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Operator>
  id?: InputMaybe<CmsTradeCreditProgram_Id_Operator>
  minReqs__amountCents?: InputMaybe<CmsTradeCreditProgram_MinReqs__AmountCents_Operator>
  minReqs__id?: InputMaybe<CmsTradeCreditProgram_MinReqs__Id_Operator>
  minReqs__orderUnit?: InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Operator>
  notes?: InputMaybe<CmsTradeCreditProgram_Notes_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditProgram_PublishedAt_Operator>
  reportsTo?: InputMaybe<CmsTradeCreditProgram_ReportsTo_Operator>
  slug?: InputMaybe<CmsTradeCreditProgram_Slug_Operator>
  tags?: InputMaybe<CmsTradeCreditProgram_Tags_Operator>
  terms__discountDurationDays?: InputMaybe<CmsTradeCreditProgram_Terms__DiscountDurationDays_Operator>
  terms__discountPercentage?: InputMaybe<CmsTradeCreditProgram_Terms__DiscountPercentage_Operator>
  terms__id?: InputMaybe<CmsTradeCreditProgram_Terms__Id_Operator>
  terms__netDueAfterDays?: InputMaybe<CmsTradeCreditProgram_Terms__NetDueAfterDays_Operator>
  title?: InputMaybe<CmsTradeCreditProgram_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditProgram_UpdatedAt_Operator>
  vendor?: InputMaybe<CmsTradeCreditProgram_Vendor_Operator>
}

export type CmsTradeCreditProgram_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditProgram__Status_Operator>
  applyUrl?: InputMaybe<CmsTradeCreditProgram_ApplyUrl_Operator>
  createdAt?: InputMaybe<CmsTradeCreditProgram_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditProgram_CreatedBy_Operator>
  creditLimitHighCents?: InputMaybe<CmsTradeCreditProgram_CreditLimitHighCents_Operator>
  creditLimitLowCents?: InputMaybe<CmsTradeCreditProgram_CreditLimitLowCents_Operator>
  description?: InputMaybe<CmsTradeCreditProgram_Description_Operator>
  fees__amountHighCents?: InputMaybe<CmsTradeCreditProgram_Fees__AmountHighCents_Operator>
  fees__amountLowCents?: InputMaybe<CmsTradeCreditProgram_Fees__AmountLowCents_Operator>
  fees__id?: InputMaybe<CmsTradeCreditProgram_Fees__Id_Operator>
  fees__paymentPeriod?: InputMaybe<CmsTradeCreditProgram_Fees__PaymentPeriod_Operator>
  id?: InputMaybe<CmsTradeCreditProgram_Id_Operator>
  minReqs__amountCents?: InputMaybe<CmsTradeCreditProgram_MinReqs__AmountCents_Operator>
  minReqs__id?: InputMaybe<CmsTradeCreditProgram_MinReqs__Id_Operator>
  minReqs__orderUnit?: InputMaybe<CmsTradeCreditProgram_MinReqs__OrderUnit_Operator>
  notes?: InputMaybe<CmsTradeCreditProgram_Notes_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditProgram_PublishedAt_Operator>
  reportsTo?: InputMaybe<CmsTradeCreditProgram_ReportsTo_Operator>
  slug?: InputMaybe<CmsTradeCreditProgram_Slug_Operator>
  tags?: InputMaybe<CmsTradeCreditProgram_Tags_Operator>
  terms__discountDurationDays?: InputMaybe<CmsTradeCreditProgram_Terms__DiscountDurationDays_Operator>
  terms__discountPercentage?: InputMaybe<CmsTradeCreditProgram_Terms__DiscountPercentage_Operator>
  terms__id?: InputMaybe<CmsTradeCreditProgram_Terms__Id_Operator>
  terms__netDueAfterDays?: InputMaybe<CmsTradeCreditProgram_Terms__NetDueAfterDays_Operator>
  title?: InputMaybe<CmsTradeCreditProgram_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditProgram_UpdatedAt_Operator>
  vendor?: InputMaybe<CmsTradeCreditProgram_Vendor_Operator>
}

export type CmsTradeCreditPrograms = {
  __typename?: 'CmsTradeCreditPrograms'
  docs?: Maybe<Array<Maybe<CmsTradeCreditProgram>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsTradeCreditRecommendation = {
  __typename?: 'CmsTradeCreditRecommendation'
  _status?: Maybe<CmsTradeCreditRecommendation__Status>
  applyUrl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  image?: Maybe<CmsMedia>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export const CmsTradeCreditRecommendationUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditRecommendationUpdate__Status_MutationInput =
  (typeof CmsTradeCreditRecommendationUpdate__Status_MutationInput)[keyof typeof CmsTradeCreditRecommendationUpdate__Status_MutationInput]
export type CmsTradeCreditRecommendationVersion = {
  __typename?: 'CmsTradeCreditRecommendationVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsTradeCreditRecommendation>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsTradeCreditRecommendationVersion_Version>
}

export type CmsTradeCreditRecommendationVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsTradeCreditRecommendationVersion_Version = {
  __typename?: 'CmsTradeCreditRecommendationVersion_Version'
  _status?: Maybe<CmsTradeCreditRecommendationVersion_Version__Status>
  applyUrl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  description?: Maybe<Scalars['String']['output']>
  image?: Maybe<CmsMedia>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export const CmsTradeCreditRecommendationVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditRecommendationVersion_Version__Status =
  (typeof CmsTradeCreditRecommendationVersion_Version__Status)[keyof typeof CmsTradeCreditRecommendationVersion_Version__Status]
export const CmsTradeCreditRecommendation__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditRecommendation__Status =
  (typeof CmsTradeCreditRecommendation__Status)[keyof typeof CmsTradeCreditRecommendation__Status]
export const CmsTradeCreditRecommendation__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditRecommendation__Status_Input =
  (typeof CmsTradeCreditRecommendation__Status_Input)[keyof typeof CmsTradeCreditRecommendation__Status_Input]
export const CmsTradeCreditRecommendation__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditRecommendation__Status_MutationInput =
  (typeof CmsTradeCreditRecommendation__Status_MutationInput)[keyof typeof CmsTradeCreditRecommendation__Status_MutationInput]
export type CmsTradeCreditRecommendation__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation__Status_Input>>>
  equals?: InputMaybe<CmsTradeCreditRecommendation__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation__Status_Input>>>
  not_equals?: InputMaybe<CmsTradeCreditRecommendation__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation__Status_Input>>>
}

export type CmsTradeCreditRecommendation_ApplyUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditRecommendation_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditRecommendation_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsTradeCreditRecommendation_Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type CmsTradeCreditRecommendation_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsTradeCreditRecommendation_Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsTradeCreditRecommendation_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditRecommendation_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditRecommendation_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditRecommendation_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditRecommendation_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditRecommendation__Status_Operator>
  applyUrl?: InputMaybe<CmsTradeCreditRecommendation_ApplyUrl_Operator>
  createdAt?: InputMaybe<CmsTradeCreditRecommendation_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditRecommendation_CreatedBy_Operator>
  description?: InputMaybe<CmsTradeCreditRecommendation_Description_Operator>
  id?: InputMaybe<CmsTradeCreditRecommendation_Id_Operator>
  image?: InputMaybe<CmsTradeCreditRecommendation_Image_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditRecommendation_PublishedAt_Operator>
  slug?: InputMaybe<CmsTradeCreditRecommendation_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditRecommendation_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditRecommendation_UpdatedAt_Operator>
}

export type CmsTradeCreditRecommendation_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditRecommendation__Status_Operator>
  applyUrl?: InputMaybe<CmsTradeCreditRecommendation_ApplyUrl_Operator>
  createdAt?: InputMaybe<CmsTradeCreditRecommendation_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditRecommendation_CreatedBy_Operator>
  description?: InputMaybe<CmsTradeCreditRecommendation_Description_Operator>
  id?: InputMaybe<CmsTradeCreditRecommendation_Id_Operator>
  image?: InputMaybe<CmsTradeCreditRecommendation_Image_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditRecommendation_PublishedAt_Operator>
  slug?: InputMaybe<CmsTradeCreditRecommendation_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditRecommendation_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditRecommendation_UpdatedAt_Operator>
}

export type CmsTradeCreditRecommendation_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditRecommendation_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditRecommendation__Status_Operator>
  applyUrl?: InputMaybe<CmsTradeCreditRecommendation_ApplyUrl_Operator>
  createdAt?: InputMaybe<CmsTradeCreditRecommendation_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditRecommendation_CreatedBy_Operator>
  description?: InputMaybe<CmsTradeCreditRecommendation_Description_Operator>
  id?: InputMaybe<CmsTradeCreditRecommendation_Id_Operator>
  image?: InputMaybe<CmsTradeCreditRecommendation_Image_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditRecommendation_PublishedAt_Operator>
  slug?: InputMaybe<CmsTradeCreditRecommendation_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditRecommendation_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditRecommendation_UpdatedAt_Operator>
}

export type CmsTradeCreditRecommendations = {
  __typename?: 'CmsTradeCreditRecommendations'
  docs?: Maybe<Array<Maybe<CmsTradeCreditRecommendation>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsTradeCreditVendor = {
  __typename?: 'CmsTradeCreditVendor'
  _status?: Maybe<CmsTradeCreditVendor__Status>
  active?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  id: Scalars['Int']['output']
  logo?: Maybe<CmsMedia>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  websiteUrl?: Maybe<Scalars['String']['output']>
}

export const CmsTradeCreditVendorUpdate__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditVendorUpdate__Status_MutationInput =
  (typeof CmsTradeCreditVendorUpdate__Status_MutationInput)[keyof typeof CmsTradeCreditVendorUpdate__Status_MutationInput]
export type CmsTradeCreditVendorVersion = {
  __typename?: 'CmsTradeCreditVendorVersion'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['Int']['output']>
  latest?: Maybe<Scalars['Boolean']['output']>
  parent?: Maybe<CmsTradeCreditVendor>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<CmsTradeCreditVendorVersion_Version>
}

export type CmsTradeCreditVendorVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsTradeCreditVendorVersion_Version = {
  __typename?: 'CmsTradeCreditVendorVersion_Version'
  _status?: Maybe<CmsTradeCreditVendorVersion_Version__Status>
  active?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CmsUser>
  logo?: Maybe<CmsMedia>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  websiteUrl?: Maybe<Scalars['String']['output']>
}

export const CmsTradeCreditVendorVersion_Version__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditVendorVersion_Version__Status =
  (typeof CmsTradeCreditVendorVersion_Version__Status)[keyof typeof CmsTradeCreditVendorVersion_Version__Status]
export const CmsTradeCreditVendor__Status = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditVendor__Status =
  (typeof CmsTradeCreditVendor__Status)[keyof typeof CmsTradeCreditVendor__Status]
export const CmsTradeCreditVendor__Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditVendor__Status_Input =
  (typeof CmsTradeCreditVendor__Status_Input)[keyof typeof CmsTradeCreditVendor__Status_Input]
export const CmsTradeCreditVendor__Status_MutationInput = {
  Draft: 'draft',
  Published: 'published',
} as const

export type CmsTradeCreditVendor__Status_MutationInput =
  (typeof CmsTradeCreditVendor__Status_MutationInput)[keyof typeof CmsTradeCreditVendor__Status_MutationInput]
export type CmsTradeCreditVendor__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor__Status_Input>>>
  equals?: InputMaybe<CmsTradeCreditVendor__Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor__Status_Input>>>
  not_equals?: InputMaybe<CmsTradeCreditVendor__Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor__Status_Input>>>
}

export type CmsTradeCreditVendor_Active_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type CmsTradeCreditVendor_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditVendor_CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsTradeCreditVendor_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsTradeCreditVendor_Logo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type CmsTradeCreditVendor_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditVendor_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditVendor_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditVendor_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsTradeCreditVendor_WebsiteUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsTradeCreditVendor_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditVendor__Status_Operator>
  active?: InputMaybe<CmsTradeCreditVendor_Active_Operator>
  createdAt?: InputMaybe<CmsTradeCreditVendor_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditVendor_CreatedBy_Operator>
  id?: InputMaybe<CmsTradeCreditVendor_Id_Operator>
  logo?: InputMaybe<CmsTradeCreditVendor_Logo_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditVendor_PublishedAt_Operator>
  slug?: InputMaybe<CmsTradeCreditVendor_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditVendor_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditVendor_UpdatedAt_Operator>
  websiteUrl?: InputMaybe<CmsTradeCreditVendor_WebsiteUrl_Operator>
}

export type CmsTradeCreditVendor_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditVendor__Status_Operator>
  active?: InputMaybe<CmsTradeCreditVendor_Active_Operator>
  createdAt?: InputMaybe<CmsTradeCreditVendor_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditVendor_CreatedBy_Operator>
  id?: InputMaybe<CmsTradeCreditVendor_Id_Operator>
  logo?: InputMaybe<CmsTradeCreditVendor_Logo_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditVendor_PublishedAt_Operator>
  slug?: InputMaybe<CmsTradeCreditVendor_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditVendor_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditVendor_UpdatedAt_Operator>
  websiteUrl?: InputMaybe<CmsTradeCreditVendor_WebsiteUrl_Operator>
}

export type CmsTradeCreditVendor_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsTradeCreditVendor_Where_Or>>>
  _status?: InputMaybe<CmsTradeCreditVendor__Status_Operator>
  active?: InputMaybe<CmsTradeCreditVendor_Active_Operator>
  createdAt?: InputMaybe<CmsTradeCreditVendor_CreatedAt_Operator>
  createdBy?: InputMaybe<CmsTradeCreditVendor_CreatedBy_Operator>
  id?: InputMaybe<CmsTradeCreditVendor_Id_Operator>
  logo?: InputMaybe<CmsTradeCreditVendor_Logo_Operator>
  publishedAt?: InputMaybe<CmsTradeCreditVendor_PublishedAt_Operator>
  slug?: InputMaybe<CmsTradeCreditVendor_Slug_Operator>
  title?: InputMaybe<CmsTradeCreditVendor_Title_Operator>
  updatedAt?: InputMaybe<CmsTradeCreditVendor_UpdatedAt_Operator>
  websiteUrl?: InputMaybe<CmsTradeCreditVendor_WebsiteUrl_Operator>
}

export type CmsTradeCreditVendors = {
  __typename?: 'CmsTradeCreditVendors'
  docs?: Maybe<Array<Maybe<CmsTradeCreditVendor>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsUser = {
  __typename?: 'CmsUser'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  email: Scalars['String']['output']
  hash?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lockUntil?: Maybe<Scalars['DateTime']['output']>
  loginAttempts?: Maybe<Scalars['Float']['output']>
  name?: Maybe<Scalars['String']['output']>
  resetPasswordExpiration?: Maybe<Scalars['DateTime']['output']>
  resetPasswordToken?: Maybe<Scalars['String']['output']>
  roles?: Maybe<Array<CmsUser_Roles>>
  salt?: Maybe<Scalars['String']['output']>
  sub?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CmsUserStorage = {
  __typename?: 'CmsUserStorage'
  key?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export const CmsUserUpdate_Roles_MutationInput = {
  Admin: 'admin',
  Editor: 'editor',
  Seo: 'seo',
  User: 'user',
} as const

export type CmsUserUpdate_Roles_MutationInput =
  (typeof CmsUserUpdate_Roles_MutationInput)[keyof typeof CmsUserUpdate_Roles_MutationInput]
export type CmsUser_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsUser_Email_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsUser_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsUser_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const CmsUser_Roles = {
  Admin: 'admin',
  Editor: 'editor',
  Seo: 'seo',
  User: 'user',
} as const

export type CmsUser_Roles = (typeof CmsUser_Roles)[keyof typeof CmsUser_Roles]
export const CmsUser_Roles_Input = {
  Admin: 'admin',
  Editor: 'editor',
  Seo: 'seo',
  User: 'user',
} as const

export type CmsUser_Roles_Input = (typeof CmsUser_Roles_Input)[keyof typeof CmsUser_Roles_Input]
export const CmsUser_Roles_MutationInput = {
  Admin: 'admin',
  Editor: 'editor',
  Seo: 'seo',
  User: 'user',
} as const

export type CmsUser_Roles_MutationInput = (typeof CmsUser_Roles_MutationInput)[keyof typeof CmsUser_Roles_MutationInput]
export type CmsUser_Roles_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsUser_Roles_Input>>>
  equals?: InputMaybe<CmsUser_Roles_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<CmsUser_Roles_Input>>>
  not_equals?: InputMaybe<CmsUser_Roles_Input>
  not_in?: InputMaybe<Array<InputMaybe<CmsUser_Roles_Input>>>
}

export type CmsUser_Sub_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsUser_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsUser_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsUser_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsUser_Where_Or>>>
  createdAt?: InputMaybe<CmsUser_CreatedAt_Operator>
  email?: InputMaybe<CmsUser_Email_Operator>
  id?: InputMaybe<CmsUser_Id_Operator>
  name?: InputMaybe<CmsUser_Name_Operator>
  roles?: InputMaybe<CmsUser_Roles_Operator>
  sub?: InputMaybe<CmsUser_Sub_Operator>
  updatedAt?: InputMaybe<CmsUser_UpdatedAt_Operator>
}

export type CmsUser_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsUser_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsUser_Where_Or>>>
  createdAt?: InputMaybe<CmsUser_CreatedAt_Operator>
  email?: InputMaybe<CmsUser_Email_Operator>
  id?: InputMaybe<CmsUser_Id_Operator>
  name?: InputMaybe<CmsUser_Name_Operator>
  roles?: InputMaybe<CmsUser_Roles_Operator>
  sub?: InputMaybe<CmsUser_Sub_Operator>
  updatedAt?: InputMaybe<CmsUser_UpdatedAt_Operator>
}

export type CmsUser_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsUser_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsUser_Where_Or>>>
  createdAt?: InputMaybe<CmsUser_CreatedAt_Operator>
  email?: InputMaybe<CmsUser_Email_Operator>
  id?: InputMaybe<CmsUser_Id_Operator>
  name?: InputMaybe<CmsUser_Name_Operator>
  roles?: InputMaybe<CmsUser_Roles_Operator>
  sub?: InputMaybe<CmsUser_Sub_Operator>
  updatedAt?: InputMaybe<CmsUser_UpdatedAt_Operator>
}

export type CmsUsers = {
  __typename?: 'CmsUsers'
  docs?: Maybe<Array<Maybe<CmsUser>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CmsVideo = {
  __typename?: 'CmsVideo'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  filename?: Maybe<Scalars['String']['output']>
  filesize?: Maybe<Scalars['Float']['output']>
  focalX?: Maybe<Scalars['Float']['output']>
  focalY?: Maybe<Scalars['Float']['output']>
  height?: Maybe<Scalars['Float']['output']>
  id: Scalars['Int']['output']
  mimeType?: Maybe<Scalars['String']['output']>
  prefix?: Maybe<Scalars['String']['output']>
  thumbnailURL?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

export type CmsVideoBlock = {
  __typename?: 'CmsVideoBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  ctas?: Maybe<Array<CmsVideoBlock_Ctas>>
  id?: Maybe<Scalars['String']['output']>
  invertBackground?: Maybe<Scalars['Boolean']['output']>
  section?: Maybe<CmsSection>
  video?: Maybe<CmsVideo>
}

export type CmsVideoBlock_Ctas = {
  __typename?: 'CmsVideoBlock_Ctas'
  id?: Maybe<Scalars['String']['output']>
  link?: Maybe<CmsLink>
}

export type CmsVideoEmbedBlock = {
  __typename?: 'CmsVideoEmbedBlock'
  blockName?: Maybe<Scalars['String']['output']>
  blockType?: Maybe<Scalars['String']['output']>
  embedType?: Maybe<CmsVideoEmbedBlock_EmbedType>
  embedUrl?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export const CmsVideoEmbedBlock_EmbedType = {
  Vimeo: 'vimeo',
  Wistia: 'wistia',
  Youtube: 'youtube',
} as const

export type CmsVideoEmbedBlock_EmbedType =
  (typeof CmsVideoEmbedBlock_EmbedType)[keyof typeof CmsVideoEmbedBlock_EmbedType]
export type CmsVideo_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsVideo_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsVideo_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsVideo_FocalX_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsVideo_FocalY_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsVideo_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsVideo_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type CmsVideo_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsVideo_Prefix_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsVideo_ThumbnailUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsVideo_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type CmsVideo_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CmsVideo_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsVideo_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsVideo_Where_Or>>>
  createdAt?: InputMaybe<CmsVideo_CreatedAt_Operator>
  filename?: InputMaybe<CmsVideo_Filename_Operator>
  filesize?: InputMaybe<CmsVideo_Filesize_Operator>
  focalX?: InputMaybe<CmsVideo_FocalX_Operator>
  focalY?: InputMaybe<CmsVideo_FocalY_Operator>
  height?: InputMaybe<CmsVideo_Height_Operator>
  id?: InputMaybe<CmsVideo_Id_Operator>
  mimeType?: InputMaybe<CmsVideo_MimeType_Operator>
  prefix?: InputMaybe<CmsVideo_Prefix_Operator>
  thumbnailURL?: InputMaybe<CmsVideo_ThumbnailUrl_Operator>
  updatedAt?: InputMaybe<CmsVideo_UpdatedAt_Operator>
  url?: InputMaybe<CmsVideo_Url_Operator>
  width?: InputMaybe<CmsVideo_Width_Operator>
}

export type CmsVideo_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsVideo_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsVideo_Where_Or>>>
  createdAt?: InputMaybe<CmsVideo_CreatedAt_Operator>
  filename?: InputMaybe<CmsVideo_Filename_Operator>
  filesize?: InputMaybe<CmsVideo_Filesize_Operator>
  focalX?: InputMaybe<CmsVideo_FocalX_Operator>
  focalY?: InputMaybe<CmsVideo_FocalY_Operator>
  height?: InputMaybe<CmsVideo_Height_Operator>
  id?: InputMaybe<CmsVideo_Id_Operator>
  mimeType?: InputMaybe<CmsVideo_MimeType_Operator>
  prefix?: InputMaybe<CmsVideo_Prefix_Operator>
  thumbnailURL?: InputMaybe<CmsVideo_ThumbnailUrl_Operator>
  updatedAt?: InputMaybe<CmsVideo_UpdatedAt_Operator>
  url?: InputMaybe<CmsVideo_Url_Operator>
  width?: InputMaybe<CmsVideo_Width_Operator>
}

export type CmsVideo_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsVideo_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<CmsVideo_Where_Or>>>
  createdAt?: InputMaybe<CmsVideo_CreatedAt_Operator>
  filename?: InputMaybe<CmsVideo_Filename_Operator>
  filesize?: InputMaybe<CmsVideo_Filesize_Operator>
  focalX?: InputMaybe<CmsVideo_FocalX_Operator>
  focalY?: InputMaybe<CmsVideo_FocalY_Operator>
  height?: InputMaybe<CmsVideo_Height_Operator>
  id?: InputMaybe<CmsVideo_Id_Operator>
  mimeType?: InputMaybe<CmsVideo_MimeType_Operator>
  prefix?: InputMaybe<CmsVideo_Prefix_Operator>
  thumbnailURL?: InputMaybe<CmsVideo_ThumbnailUrl_Operator>
  updatedAt?: InputMaybe<CmsVideo_UpdatedAt_Operator>
  url?: InputMaybe<CmsVideo_Url_Operator>
  width?: InputMaybe<CmsVideo_Width_Operator>
}

export type CmsVideo_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type CmsVideos = {
  __typename?: 'CmsVideos'
  docs?: Maybe<Array<Maybe<CmsVideo>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type CommentsCreateAccess = {
  __typename?: 'CommentsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CommentsCreateDocAccess = {
  __typename?: 'CommentsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CommentsDeleteAccess = {
  __typename?: 'CommentsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CommentsDeleteDocAccess = {
  __typename?: 'CommentsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CommentsDocAccessFields = {
  __typename?: 'CommentsDocAccessFields'
  author?: Maybe<CommentsDocAccessFields_Author>
  authorIp?: Maybe<CommentsDocAccessFields_AuthorIp>
  authorName?: Maybe<CommentsDocAccessFields_AuthorName>
  authorUserAgent?: Maybe<CommentsDocAccessFields_AuthorUserAgent>
  content?: Maybe<CommentsDocAccessFields_Content>
  createdAt?: Maybe<CommentsDocAccessFields_CreatedAt>
  email?: Maybe<CommentsDocAccessFields_Email>
  isApproved?: Maybe<CommentsDocAccessFields_IsApproved>
  rejectReason?: Maybe<CommentsDocAccessFields_RejectReason>
  replyComment?: Maybe<CommentsDocAccessFields_ReplyComment>
  replyPost?: Maybe<CommentsDocAccessFields_ReplyPost>
  updatedAt?: Maybe<CommentsDocAccessFields_UpdatedAt>
}

export type CommentsDocAccessFields_Author = {
  __typename?: 'CommentsDocAccessFields_author'
  create?: Maybe<CommentsDocAccessFields_Author_Create>
  delete?: Maybe<CommentsDocAccessFields_Author_Delete>
  read?: Maybe<CommentsDocAccessFields_Author_Read>
  update?: Maybe<CommentsDocAccessFields_Author_Update>
}

export type CommentsDocAccessFields_AuthorIp = {
  __typename?: 'CommentsDocAccessFields_authorIp'
  create?: Maybe<CommentsDocAccessFields_AuthorIp_Create>
  delete?: Maybe<CommentsDocAccessFields_AuthorIp_Delete>
  read?: Maybe<CommentsDocAccessFields_AuthorIp_Read>
  update?: Maybe<CommentsDocAccessFields_AuthorIp_Update>
}

export type CommentsDocAccessFields_AuthorIp_Create = {
  __typename?: 'CommentsDocAccessFields_authorIp_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorIp_Delete = {
  __typename?: 'CommentsDocAccessFields_authorIp_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorIp_Read = {
  __typename?: 'CommentsDocAccessFields_authorIp_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorIp_Update = {
  __typename?: 'CommentsDocAccessFields_authorIp_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorName = {
  __typename?: 'CommentsDocAccessFields_authorName'
  create?: Maybe<CommentsDocAccessFields_AuthorName_Create>
  delete?: Maybe<CommentsDocAccessFields_AuthorName_Delete>
  read?: Maybe<CommentsDocAccessFields_AuthorName_Read>
  update?: Maybe<CommentsDocAccessFields_AuthorName_Update>
}

export type CommentsDocAccessFields_AuthorName_Create = {
  __typename?: 'CommentsDocAccessFields_authorName_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorName_Delete = {
  __typename?: 'CommentsDocAccessFields_authorName_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorName_Read = {
  __typename?: 'CommentsDocAccessFields_authorName_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorName_Update = {
  __typename?: 'CommentsDocAccessFields_authorName_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorUserAgent = {
  __typename?: 'CommentsDocAccessFields_authorUserAgent'
  create?: Maybe<CommentsDocAccessFields_AuthorUserAgent_Create>
  delete?: Maybe<CommentsDocAccessFields_AuthorUserAgent_Delete>
  read?: Maybe<CommentsDocAccessFields_AuthorUserAgent_Read>
  update?: Maybe<CommentsDocAccessFields_AuthorUserAgent_Update>
}

export type CommentsDocAccessFields_AuthorUserAgent_Create = {
  __typename?: 'CommentsDocAccessFields_authorUserAgent_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorUserAgent_Delete = {
  __typename?: 'CommentsDocAccessFields_authorUserAgent_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorUserAgent_Read = {
  __typename?: 'CommentsDocAccessFields_authorUserAgent_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_AuthorUserAgent_Update = {
  __typename?: 'CommentsDocAccessFields_authorUserAgent_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Author_Create = {
  __typename?: 'CommentsDocAccessFields_author_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Author_Delete = {
  __typename?: 'CommentsDocAccessFields_author_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Author_Read = {
  __typename?: 'CommentsDocAccessFields_author_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Author_Update = {
  __typename?: 'CommentsDocAccessFields_author_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Content = {
  __typename?: 'CommentsDocAccessFields_content'
  create?: Maybe<CommentsDocAccessFields_Content_Create>
  delete?: Maybe<CommentsDocAccessFields_Content_Delete>
  read?: Maybe<CommentsDocAccessFields_Content_Read>
  update?: Maybe<CommentsDocAccessFields_Content_Update>
}

export type CommentsDocAccessFields_Content_Create = {
  __typename?: 'CommentsDocAccessFields_content_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Content_Delete = {
  __typename?: 'CommentsDocAccessFields_content_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Content_Read = {
  __typename?: 'CommentsDocAccessFields_content_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Content_Update = {
  __typename?: 'CommentsDocAccessFields_content_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_CreatedAt = {
  __typename?: 'CommentsDocAccessFields_createdAt'
  create?: Maybe<CommentsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<CommentsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<CommentsDocAccessFields_CreatedAt_Read>
  update?: Maybe<CommentsDocAccessFields_CreatedAt_Update>
}

export type CommentsDocAccessFields_CreatedAt_Create = {
  __typename?: 'CommentsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CommentsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_CreatedAt_Read = {
  __typename?: 'CommentsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_CreatedAt_Update = {
  __typename?: 'CommentsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Email = {
  __typename?: 'CommentsDocAccessFields_email'
  create?: Maybe<CommentsDocAccessFields_Email_Create>
  delete?: Maybe<CommentsDocAccessFields_Email_Delete>
  read?: Maybe<CommentsDocAccessFields_Email_Read>
  update?: Maybe<CommentsDocAccessFields_Email_Update>
}

export type CommentsDocAccessFields_Email_Create = {
  __typename?: 'CommentsDocAccessFields_email_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Email_Delete = {
  __typename?: 'CommentsDocAccessFields_email_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Email_Read = {
  __typename?: 'CommentsDocAccessFields_email_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_Email_Update = {
  __typename?: 'CommentsDocAccessFields_email_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_IsApproved = {
  __typename?: 'CommentsDocAccessFields_isApproved'
  create?: Maybe<CommentsDocAccessFields_IsApproved_Create>
  delete?: Maybe<CommentsDocAccessFields_IsApproved_Delete>
  read?: Maybe<CommentsDocAccessFields_IsApproved_Read>
  update?: Maybe<CommentsDocAccessFields_IsApproved_Update>
}

export type CommentsDocAccessFields_IsApproved_Create = {
  __typename?: 'CommentsDocAccessFields_isApproved_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_IsApproved_Delete = {
  __typename?: 'CommentsDocAccessFields_isApproved_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_IsApproved_Read = {
  __typename?: 'CommentsDocAccessFields_isApproved_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_IsApproved_Update = {
  __typename?: 'CommentsDocAccessFields_isApproved_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_RejectReason = {
  __typename?: 'CommentsDocAccessFields_rejectReason'
  create?: Maybe<CommentsDocAccessFields_RejectReason_Create>
  delete?: Maybe<CommentsDocAccessFields_RejectReason_Delete>
  read?: Maybe<CommentsDocAccessFields_RejectReason_Read>
  update?: Maybe<CommentsDocAccessFields_RejectReason_Update>
}

export type CommentsDocAccessFields_RejectReason_Create = {
  __typename?: 'CommentsDocAccessFields_rejectReason_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_RejectReason_Delete = {
  __typename?: 'CommentsDocAccessFields_rejectReason_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_RejectReason_Read = {
  __typename?: 'CommentsDocAccessFields_rejectReason_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_RejectReason_Update = {
  __typename?: 'CommentsDocAccessFields_rejectReason_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyComment = {
  __typename?: 'CommentsDocAccessFields_replyComment'
  create?: Maybe<CommentsDocAccessFields_ReplyComment_Create>
  delete?: Maybe<CommentsDocAccessFields_ReplyComment_Delete>
  read?: Maybe<CommentsDocAccessFields_ReplyComment_Read>
  update?: Maybe<CommentsDocAccessFields_ReplyComment_Update>
}

export type CommentsDocAccessFields_ReplyComment_Create = {
  __typename?: 'CommentsDocAccessFields_replyComment_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyComment_Delete = {
  __typename?: 'CommentsDocAccessFields_replyComment_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyComment_Read = {
  __typename?: 'CommentsDocAccessFields_replyComment_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyComment_Update = {
  __typename?: 'CommentsDocAccessFields_replyComment_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyPost = {
  __typename?: 'CommentsDocAccessFields_replyPost'
  create?: Maybe<CommentsDocAccessFields_ReplyPost_Create>
  delete?: Maybe<CommentsDocAccessFields_ReplyPost_Delete>
  read?: Maybe<CommentsDocAccessFields_ReplyPost_Read>
  update?: Maybe<CommentsDocAccessFields_ReplyPost_Update>
}

export type CommentsDocAccessFields_ReplyPost_Create = {
  __typename?: 'CommentsDocAccessFields_replyPost_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyPost_Delete = {
  __typename?: 'CommentsDocAccessFields_replyPost_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyPost_Read = {
  __typename?: 'CommentsDocAccessFields_replyPost_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_ReplyPost_Update = {
  __typename?: 'CommentsDocAccessFields_replyPost_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_UpdatedAt = {
  __typename?: 'CommentsDocAccessFields_updatedAt'
  create?: Maybe<CommentsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<CommentsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<CommentsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<CommentsDocAccessFields_UpdatedAt_Update>
}

export type CommentsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CommentsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CommentsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CommentsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CommentsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields = {
  __typename?: 'CommentsFields'
  author?: Maybe<CommentsFields_Author>
  authorIp?: Maybe<CommentsFields_AuthorIp>
  authorName?: Maybe<CommentsFields_AuthorName>
  authorUserAgent?: Maybe<CommentsFields_AuthorUserAgent>
  content?: Maybe<CommentsFields_Content>
  createdAt?: Maybe<CommentsFields_CreatedAt>
  email?: Maybe<CommentsFields_Email>
  isApproved?: Maybe<CommentsFields_IsApproved>
  rejectReason?: Maybe<CommentsFields_RejectReason>
  replyComment?: Maybe<CommentsFields_ReplyComment>
  replyPost?: Maybe<CommentsFields_ReplyPost>
  updatedAt?: Maybe<CommentsFields_UpdatedAt>
}

export type CommentsFields_Author = {
  __typename?: 'CommentsFields_author'
  create?: Maybe<CommentsFields_Author_Create>
  delete?: Maybe<CommentsFields_Author_Delete>
  read?: Maybe<CommentsFields_Author_Read>
  update?: Maybe<CommentsFields_Author_Update>
}

export type CommentsFields_AuthorIp = {
  __typename?: 'CommentsFields_authorIp'
  create?: Maybe<CommentsFields_AuthorIp_Create>
  delete?: Maybe<CommentsFields_AuthorIp_Delete>
  read?: Maybe<CommentsFields_AuthorIp_Read>
  update?: Maybe<CommentsFields_AuthorIp_Update>
}

export type CommentsFields_AuthorIp_Create = {
  __typename?: 'CommentsFields_authorIp_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorIp_Delete = {
  __typename?: 'CommentsFields_authorIp_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorIp_Read = {
  __typename?: 'CommentsFields_authorIp_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorIp_Update = {
  __typename?: 'CommentsFields_authorIp_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorName = {
  __typename?: 'CommentsFields_authorName'
  create?: Maybe<CommentsFields_AuthorName_Create>
  delete?: Maybe<CommentsFields_AuthorName_Delete>
  read?: Maybe<CommentsFields_AuthorName_Read>
  update?: Maybe<CommentsFields_AuthorName_Update>
}

export type CommentsFields_AuthorName_Create = {
  __typename?: 'CommentsFields_authorName_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorName_Delete = {
  __typename?: 'CommentsFields_authorName_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorName_Read = {
  __typename?: 'CommentsFields_authorName_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorName_Update = {
  __typename?: 'CommentsFields_authorName_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorUserAgent = {
  __typename?: 'CommentsFields_authorUserAgent'
  create?: Maybe<CommentsFields_AuthorUserAgent_Create>
  delete?: Maybe<CommentsFields_AuthorUserAgent_Delete>
  read?: Maybe<CommentsFields_AuthorUserAgent_Read>
  update?: Maybe<CommentsFields_AuthorUserAgent_Update>
}

export type CommentsFields_AuthorUserAgent_Create = {
  __typename?: 'CommentsFields_authorUserAgent_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorUserAgent_Delete = {
  __typename?: 'CommentsFields_authorUserAgent_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorUserAgent_Read = {
  __typename?: 'CommentsFields_authorUserAgent_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_AuthorUserAgent_Update = {
  __typename?: 'CommentsFields_authorUserAgent_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Author_Create = {
  __typename?: 'CommentsFields_author_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Author_Delete = {
  __typename?: 'CommentsFields_author_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Author_Read = {
  __typename?: 'CommentsFields_author_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Author_Update = {
  __typename?: 'CommentsFields_author_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Content = {
  __typename?: 'CommentsFields_content'
  create?: Maybe<CommentsFields_Content_Create>
  delete?: Maybe<CommentsFields_Content_Delete>
  read?: Maybe<CommentsFields_Content_Read>
  update?: Maybe<CommentsFields_Content_Update>
}

export type CommentsFields_Content_Create = {
  __typename?: 'CommentsFields_content_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Content_Delete = {
  __typename?: 'CommentsFields_content_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Content_Read = {
  __typename?: 'CommentsFields_content_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Content_Update = {
  __typename?: 'CommentsFields_content_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_CreatedAt = {
  __typename?: 'CommentsFields_createdAt'
  create?: Maybe<CommentsFields_CreatedAt_Create>
  delete?: Maybe<CommentsFields_CreatedAt_Delete>
  read?: Maybe<CommentsFields_CreatedAt_Read>
  update?: Maybe<CommentsFields_CreatedAt_Update>
}

export type CommentsFields_CreatedAt_Create = {
  __typename?: 'CommentsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_CreatedAt_Delete = {
  __typename?: 'CommentsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_CreatedAt_Read = {
  __typename?: 'CommentsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_CreatedAt_Update = {
  __typename?: 'CommentsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Email = {
  __typename?: 'CommentsFields_email'
  create?: Maybe<CommentsFields_Email_Create>
  delete?: Maybe<CommentsFields_Email_Delete>
  read?: Maybe<CommentsFields_Email_Read>
  update?: Maybe<CommentsFields_Email_Update>
}

export type CommentsFields_Email_Create = {
  __typename?: 'CommentsFields_email_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Email_Delete = {
  __typename?: 'CommentsFields_email_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Email_Read = {
  __typename?: 'CommentsFields_email_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_Email_Update = {
  __typename?: 'CommentsFields_email_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_IsApproved = {
  __typename?: 'CommentsFields_isApproved'
  create?: Maybe<CommentsFields_IsApproved_Create>
  delete?: Maybe<CommentsFields_IsApproved_Delete>
  read?: Maybe<CommentsFields_IsApproved_Read>
  update?: Maybe<CommentsFields_IsApproved_Update>
}

export type CommentsFields_IsApproved_Create = {
  __typename?: 'CommentsFields_isApproved_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_IsApproved_Delete = {
  __typename?: 'CommentsFields_isApproved_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_IsApproved_Read = {
  __typename?: 'CommentsFields_isApproved_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_IsApproved_Update = {
  __typename?: 'CommentsFields_isApproved_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_RejectReason = {
  __typename?: 'CommentsFields_rejectReason'
  create?: Maybe<CommentsFields_RejectReason_Create>
  delete?: Maybe<CommentsFields_RejectReason_Delete>
  read?: Maybe<CommentsFields_RejectReason_Read>
  update?: Maybe<CommentsFields_RejectReason_Update>
}

export type CommentsFields_RejectReason_Create = {
  __typename?: 'CommentsFields_rejectReason_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_RejectReason_Delete = {
  __typename?: 'CommentsFields_rejectReason_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_RejectReason_Read = {
  __typename?: 'CommentsFields_rejectReason_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_RejectReason_Update = {
  __typename?: 'CommentsFields_rejectReason_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyComment = {
  __typename?: 'CommentsFields_replyComment'
  create?: Maybe<CommentsFields_ReplyComment_Create>
  delete?: Maybe<CommentsFields_ReplyComment_Delete>
  read?: Maybe<CommentsFields_ReplyComment_Read>
  update?: Maybe<CommentsFields_ReplyComment_Update>
}

export type CommentsFields_ReplyComment_Create = {
  __typename?: 'CommentsFields_replyComment_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyComment_Delete = {
  __typename?: 'CommentsFields_replyComment_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyComment_Read = {
  __typename?: 'CommentsFields_replyComment_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyComment_Update = {
  __typename?: 'CommentsFields_replyComment_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyPost = {
  __typename?: 'CommentsFields_replyPost'
  create?: Maybe<CommentsFields_ReplyPost_Create>
  delete?: Maybe<CommentsFields_ReplyPost_Delete>
  read?: Maybe<CommentsFields_ReplyPost_Read>
  update?: Maybe<CommentsFields_ReplyPost_Update>
}

export type CommentsFields_ReplyPost_Create = {
  __typename?: 'CommentsFields_replyPost_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyPost_Delete = {
  __typename?: 'CommentsFields_replyPost_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyPost_Read = {
  __typename?: 'CommentsFields_replyPost_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_ReplyPost_Update = {
  __typename?: 'CommentsFields_replyPost_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_UpdatedAt = {
  __typename?: 'CommentsFields_updatedAt'
  create?: Maybe<CommentsFields_UpdatedAt_Create>
  delete?: Maybe<CommentsFields_UpdatedAt_Delete>
  read?: Maybe<CommentsFields_UpdatedAt_Read>
  update?: Maybe<CommentsFields_UpdatedAt_Update>
}

export type CommentsFields_UpdatedAt_Create = {
  __typename?: 'CommentsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_UpdatedAt_Delete = {
  __typename?: 'CommentsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_UpdatedAt_Read = {
  __typename?: 'CommentsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type CommentsFields_UpdatedAt_Update = {
  __typename?: 'CommentsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type CommentsReadAccess = {
  __typename?: 'CommentsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CommentsReadDocAccess = {
  __typename?: 'CommentsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CommentsUpdateAccess = {
  __typename?: 'CommentsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type CommentsUpdateDocAccess = {
  __typename?: 'CommentsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsCreateAccess = {
  __typename?: 'FormSubmissionsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsCreateDocAccess = {
  __typename?: 'FormSubmissionsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsDeleteAccess = {
  __typename?: 'FormSubmissionsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsDeleteDocAccess = {
  __typename?: 'FormSubmissionsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsDocAccessFields = {
  __typename?: 'FormSubmissionsDocAccessFields'
  createdAt?: Maybe<FormSubmissionsDocAccessFields_CreatedAt>
  form?: Maybe<FormSubmissionsDocAccessFields_Form>
  submissionData?: Maybe<FormSubmissionsDocAccessFields_SubmissionData>
  updatedAt?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt>
}

export type FormSubmissionsDocAccessFields_CreatedAt = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt'
  create?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Read>
  update?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Update>
}

export type FormSubmissionsDocAccessFields_CreatedAt_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_CreatedAt_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_CreatedAt_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_Form = {
  __typename?: 'FormSubmissionsDocAccessFields_form'
  create?: Maybe<FormSubmissionsDocAccessFields_Form_Create>
  delete?: Maybe<FormSubmissionsDocAccessFields_Form_Delete>
  read?: Maybe<FormSubmissionsDocAccessFields_Form_Read>
  update?: Maybe<FormSubmissionsDocAccessFields_Form_Update>
}

export type FormSubmissionsDocAccessFields_Form_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_Form_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_Form_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_Form_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData'
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Create>
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Delete>
  fields?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Fields>
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Read>
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Update>
}

export type FormSubmissionsDocAccessFields_SubmissionData_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Fields = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Fields'
  field?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field>
  id?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id>
  value?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value>
}

export type FormSubmissionsDocAccessFields_SubmissionData_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Field = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field'
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Create>
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Delete>
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Read>
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Update>
}

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Id = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id'
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Create>
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Delete>
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Read>
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Update>
}

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Value = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value'
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Create>
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Delete>
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Read>
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Update>
}

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_UpdatedAt = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt'
  create?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Update>
}

export type FormSubmissionsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields = {
  __typename?: 'FormSubmissionsFields'
  createdAt?: Maybe<FormSubmissionsFields_CreatedAt>
  form?: Maybe<FormSubmissionsFields_Form>
  submissionData?: Maybe<FormSubmissionsFields_SubmissionData>
  updatedAt?: Maybe<FormSubmissionsFields_UpdatedAt>
}

export type FormSubmissionsFields_CreatedAt = {
  __typename?: 'FormSubmissionsFields_createdAt'
  create?: Maybe<FormSubmissionsFields_CreatedAt_Create>
  delete?: Maybe<FormSubmissionsFields_CreatedAt_Delete>
  read?: Maybe<FormSubmissionsFields_CreatedAt_Read>
  update?: Maybe<FormSubmissionsFields_CreatedAt_Update>
}

export type FormSubmissionsFields_CreatedAt_Create = {
  __typename?: 'FormSubmissionsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_CreatedAt_Delete = {
  __typename?: 'FormSubmissionsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_CreatedAt_Read = {
  __typename?: 'FormSubmissionsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_CreatedAt_Update = {
  __typename?: 'FormSubmissionsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_Form = {
  __typename?: 'FormSubmissionsFields_form'
  create?: Maybe<FormSubmissionsFields_Form_Create>
  delete?: Maybe<FormSubmissionsFields_Form_Delete>
  read?: Maybe<FormSubmissionsFields_Form_Read>
  update?: Maybe<FormSubmissionsFields_Form_Update>
}

export type FormSubmissionsFields_Form_Create = {
  __typename?: 'FormSubmissionsFields_form_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_Form_Delete = {
  __typename?: 'FormSubmissionsFields_form_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_Form_Read = {
  __typename?: 'FormSubmissionsFields_form_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_Form_Update = {
  __typename?: 'FormSubmissionsFields_form_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData = {
  __typename?: 'FormSubmissionsFields_submissionData'
  create?: Maybe<FormSubmissionsFields_SubmissionData_Create>
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Delete>
  fields?: Maybe<FormSubmissionsFields_SubmissionData_Fields>
  read?: Maybe<FormSubmissionsFields_SubmissionData_Read>
  update?: Maybe<FormSubmissionsFields_SubmissionData_Update>
}

export type FormSubmissionsFields_SubmissionData_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Fields = {
  __typename?: 'FormSubmissionsFields_submissionData_Fields'
  field?: Maybe<FormSubmissionsFields_SubmissionData_Field>
  id?: Maybe<FormSubmissionsFields_SubmissionData_Id>
  value?: Maybe<FormSubmissionsFields_SubmissionData_Value>
}

export type FormSubmissionsFields_SubmissionData_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Field = {
  __typename?: 'FormSubmissionsFields_submissionData_field'
  create?: Maybe<FormSubmissionsFields_SubmissionData_Field_Create>
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Field_Delete>
  read?: Maybe<FormSubmissionsFields_SubmissionData_Field_Read>
  update?: Maybe<FormSubmissionsFields_SubmissionData_Field_Update>
}

export type FormSubmissionsFields_SubmissionData_Field_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Field_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Field_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Field_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Id = {
  __typename?: 'FormSubmissionsFields_submissionData_id'
  create?: Maybe<FormSubmissionsFields_SubmissionData_Id_Create>
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Id_Delete>
  read?: Maybe<FormSubmissionsFields_SubmissionData_Id_Read>
  update?: Maybe<FormSubmissionsFields_SubmissionData_Id_Update>
}

export type FormSubmissionsFields_SubmissionData_Id_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Id_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Id_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Id_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Value = {
  __typename?: 'FormSubmissionsFields_submissionData_value'
  create?: Maybe<FormSubmissionsFields_SubmissionData_Value_Create>
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Value_Delete>
  read?: Maybe<FormSubmissionsFields_SubmissionData_Value_Read>
  update?: Maybe<FormSubmissionsFields_SubmissionData_Value_Update>
}

export type FormSubmissionsFields_SubmissionData_Value_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Value_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Value_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_SubmissionData_Value_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_UpdatedAt = {
  __typename?: 'FormSubmissionsFields_updatedAt'
  create?: Maybe<FormSubmissionsFields_UpdatedAt_Create>
  delete?: Maybe<FormSubmissionsFields_UpdatedAt_Delete>
  read?: Maybe<FormSubmissionsFields_UpdatedAt_Read>
  update?: Maybe<FormSubmissionsFields_UpdatedAt_Update>
}

export type FormSubmissionsFields_UpdatedAt_Create = {
  __typename?: 'FormSubmissionsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_UpdatedAt_Delete = {
  __typename?: 'FormSubmissionsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_UpdatedAt_Read = {
  __typename?: 'FormSubmissionsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsFields_UpdatedAt_Update = {
  __typename?: 'FormSubmissionsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormSubmissionsReadAccess = {
  __typename?: 'FormSubmissionsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsReadDocAccess = {
  __typename?: 'FormSubmissionsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsUpdateAccess = {
  __typename?: 'FormSubmissionsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormSubmissionsUpdateDocAccess = {
  __typename?: 'FormSubmissionsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsCreateAccess = {
  __typename?: 'FormsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsCreateDocAccess = {
  __typename?: 'FormsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsDeleteAccess = {
  __typename?: 'FormsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsDeleteDocAccess = {
  __typename?: 'FormsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsDocAccessFields = {
  __typename?: 'FormsDocAccessFields'
  _status?: Maybe<FormsDocAccessFields__Status>
  confirmationMessage?: Maybe<FormsDocAccessFields_ConfirmationMessage>
  confirmationType?: Maybe<FormsDocAccessFields_ConfirmationType>
  createdAt?: Maybe<FormsDocAccessFields_CreatedAt>
  description?: Maybe<FormsDocAccessFields_Description>
  emails?: Maybe<FormsDocAccessFields_Emails>
  fields?: Maybe<FormsDocAccessFields_Fields>
  redirect?: Maybe<FormsDocAccessFields_Redirect>
  slug?: Maybe<FormsDocAccessFields_Slug>
  submitButtonLabel?: Maybe<FormsDocAccessFields_SubmitButtonLabel>
  title?: Maybe<FormsDocAccessFields_Title>
  updatedAt?: Maybe<FormsDocAccessFields_UpdatedAt>
}

export type FormsDocAccessFields__Status = {
  __typename?: 'FormsDocAccessFields__status'
  create?: Maybe<FormsDocAccessFields__Status_Create>
  delete?: Maybe<FormsDocAccessFields__Status_Delete>
  read?: Maybe<FormsDocAccessFields__Status_Read>
  update?: Maybe<FormsDocAccessFields__Status_Update>
}

export type FormsDocAccessFields__Status_Create = {
  __typename?: 'FormsDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields__Status_Delete = {
  __typename?: 'FormsDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields__Status_Read = {
  __typename?: 'FormsDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields__Status_Update = {
  __typename?: 'FormsDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationMessage = {
  __typename?: 'FormsDocAccessFields_confirmationMessage'
  create?: Maybe<FormsDocAccessFields_ConfirmationMessage_Create>
  delete?: Maybe<FormsDocAccessFields_ConfirmationMessage_Delete>
  read?: Maybe<FormsDocAccessFields_ConfirmationMessage_Read>
  update?: Maybe<FormsDocAccessFields_ConfirmationMessage_Update>
}

export type FormsDocAccessFields_ConfirmationMessage_Create = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationMessage_Delete = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationMessage_Read = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationMessage_Update = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationType = {
  __typename?: 'FormsDocAccessFields_confirmationType'
  create?: Maybe<FormsDocAccessFields_ConfirmationType_Create>
  delete?: Maybe<FormsDocAccessFields_ConfirmationType_Delete>
  read?: Maybe<FormsDocAccessFields_ConfirmationType_Read>
  update?: Maybe<FormsDocAccessFields_ConfirmationType_Update>
}

export type FormsDocAccessFields_ConfirmationType_Create = {
  __typename?: 'FormsDocAccessFields_confirmationType_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationType_Delete = {
  __typename?: 'FormsDocAccessFields_confirmationType_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationType_Read = {
  __typename?: 'FormsDocAccessFields_confirmationType_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_ConfirmationType_Update = {
  __typename?: 'FormsDocAccessFields_confirmationType_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_CreatedAt = {
  __typename?: 'FormsDocAccessFields_createdAt'
  create?: Maybe<FormsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<FormsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<FormsDocAccessFields_CreatedAt_Read>
  update?: Maybe<FormsDocAccessFields_CreatedAt_Update>
}

export type FormsDocAccessFields_CreatedAt_Create = {
  __typename?: 'FormsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'FormsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_CreatedAt_Read = {
  __typename?: 'FormsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_CreatedAt_Update = {
  __typename?: 'FormsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Description = {
  __typename?: 'FormsDocAccessFields_description'
  create?: Maybe<FormsDocAccessFields_Description_Create>
  delete?: Maybe<FormsDocAccessFields_Description_Delete>
  read?: Maybe<FormsDocAccessFields_Description_Read>
  update?: Maybe<FormsDocAccessFields_Description_Update>
}

export type FormsDocAccessFields_Description_Create = {
  __typename?: 'FormsDocAccessFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Description_Delete = {
  __typename?: 'FormsDocAccessFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Description_Read = {
  __typename?: 'FormsDocAccessFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Description_Update = {
  __typename?: 'FormsDocAccessFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails = {
  __typename?: 'FormsDocAccessFields_emails'
  create?: Maybe<FormsDocAccessFields_Emails_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_Delete>
  fields?: Maybe<FormsDocAccessFields_Emails_Fields>
  read?: Maybe<FormsDocAccessFields_Emails_Read>
  update?: Maybe<FormsDocAccessFields_Emails_Update>
}

export type FormsDocAccessFields_Emails_Create = {
  __typename?: 'FormsDocAccessFields_emails_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Delete = {
  __typename?: 'FormsDocAccessFields_emails_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Fields = {
  __typename?: 'FormsDocAccessFields_emails_Fields'
  bcc?: Maybe<FormsDocAccessFields_Emails_Bcc>
  cc?: Maybe<FormsDocAccessFields_Emails_Cc>
  emailFrom?: Maybe<FormsDocAccessFields_Emails_EmailFrom>
  emailTo?: Maybe<FormsDocAccessFields_Emails_EmailTo>
  id?: Maybe<FormsDocAccessFields_Emails_Id>
  message?: Maybe<FormsDocAccessFields_Emails_Message>
  replyTo?: Maybe<FormsDocAccessFields_Emails_ReplyTo>
  subject?: Maybe<FormsDocAccessFields_Emails_Subject>
}

export type FormsDocAccessFields_Emails_Read = {
  __typename?: 'FormsDocAccessFields_emails_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Update = {
  __typename?: 'FormsDocAccessFields_emails_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Bcc = {
  __typename?: 'FormsDocAccessFields_emails_bcc'
  create?: Maybe<FormsDocAccessFields_Emails_Bcc_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_Bcc_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_Bcc_Read>
  update?: Maybe<FormsDocAccessFields_Emails_Bcc_Update>
}

export type FormsDocAccessFields_Emails_Bcc_Create = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Bcc_Delete = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Bcc_Read = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Bcc_Update = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Cc = {
  __typename?: 'FormsDocAccessFields_emails_cc'
  create?: Maybe<FormsDocAccessFields_Emails_Cc_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_Cc_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_Cc_Read>
  update?: Maybe<FormsDocAccessFields_Emails_Cc_Update>
}

export type FormsDocAccessFields_Emails_Cc_Create = {
  __typename?: 'FormsDocAccessFields_emails_cc_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Cc_Delete = {
  __typename?: 'FormsDocAccessFields_emails_cc_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Cc_Read = {
  __typename?: 'FormsDocAccessFields_emails_cc_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Cc_Update = {
  __typename?: 'FormsDocAccessFields_emails_cc_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailFrom = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom'
  create?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Read>
  update?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Update>
}

export type FormsDocAccessFields_Emails_EmailFrom_Create = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailFrom_Delete = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailFrom_Read = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailFrom_Update = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailTo = {
  __typename?: 'FormsDocAccessFields_emails_emailTo'
  create?: Maybe<FormsDocAccessFields_Emails_EmailTo_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_EmailTo_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_EmailTo_Read>
  update?: Maybe<FormsDocAccessFields_Emails_EmailTo_Update>
}

export type FormsDocAccessFields_Emails_EmailTo_Create = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailTo_Delete = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailTo_Read = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_EmailTo_Update = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Id = {
  __typename?: 'FormsDocAccessFields_emails_id'
  create?: Maybe<FormsDocAccessFields_Emails_Id_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_Id_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_Id_Read>
  update?: Maybe<FormsDocAccessFields_Emails_Id_Update>
}

export type FormsDocAccessFields_Emails_Id_Create = {
  __typename?: 'FormsDocAccessFields_emails_id_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Id_Delete = {
  __typename?: 'FormsDocAccessFields_emails_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Id_Read = {
  __typename?: 'FormsDocAccessFields_emails_id_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Id_Update = {
  __typename?: 'FormsDocAccessFields_emails_id_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Message = {
  __typename?: 'FormsDocAccessFields_emails_message'
  create?: Maybe<FormsDocAccessFields_Emails_Message_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_Message_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_Message_Read>
  update?: Maybe<FormsDocAccessFields_Emails_Message_Update>
}

export type FormsDocAccessFields_Emails_Message_Create = {
  __typename?: 'FormsDocAccessFields_emails_message_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Message_Delete = {
  __typename?: 'FormsDocAccessFields_emails_message_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Message_Read = {
  __typename?: 'FormsDocAccessFields_emails_message_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Message_Update = {
  __typename?: 'FormsDocAccessFields_emails_message_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_ReplyTo = {
  __typename?: 'FormsDocAccessFields_emails_replyTo'
  create?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Read>
  update?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Update>
}

export type FormsDocAccessFields_Emails_ReplyTo_Create = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_ReplyTo_Delete = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_ReplyTo_Read = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_ReplyTo_Update = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Subject = {
  __typename?: 'FormsDocAccessFields_emails_subject'
  create?: Maybe<FormsDocAccessFields_Emails_Subject_Create>
  delete?: Maybe<FormsDocAccessFields_Emails_Subject_Delete>
  read?: Maybe<FormsDocAccessFields_Emails_Subject_Read>
  update?: Maybe<FormsDocAccessFields_Emails_Subject_Update>
}

export type FormsDocAccessFields_Emails_Subject_Create = {
  __typename?: 'FormsDocAccessFields_emails_subject_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Subject_Delete = {
  __typename?: 'FormsDocAccessFields_emails_subject_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Subject_Read = {
  __typename?: 'FormsDocAccessFields_emails_subject_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Emails_Subject_Update = {
  __typename?: 'FormsDocAccessFields_emails_subject_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Fields = {
  __typename?: 'FormsDocAccessFields_fields'
  create?: Maybe<FormsDocAccessFields_Fields_Create>
  delete?: Maybe<FormsDocAccessFields_Fields_Delete>
  read?: Maybe<FormsDocAccessFields_Fields_Read>
  update?: Maybe<FormsDocAccessFields_Fields_Update>
}

export type FormsDocAccessFields_Fields_Create = {
  __typename?: 'FormsDocAccessFields_fields_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Fields_Delete = {
  __typename?: 'FormsDocAccessFields_fields_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Fields_Read = {
  __typename?: 'FormsDocAccessFields_fields_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Fields_Update = {
  __typename?: 'FormsDocAccessFields_fields_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect = {
  __typename?: 'FormsDocAccessFields_redirect'
  create?: Maybe<FormsDocAccessFields_Redirect_Create>
  delete?: Maybe<FormsDocAccessFields_Redirect_Delete>
  fields?: Maybe<FormsDocAccessFields_Redirect_Fields>
  read?: Maybe<FormsDocAccessFields_Redirect_Read>
  update?: Maybe<FormsDocAccessFields_Redirect_Update>
}

export type FormsDocAccessFields_Redirect_Create = {
  __typename?: 'FormsDocAccessFields_redirect_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Delete = {
  __typename?: 'FormsDocAccessFields_redirect_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Fields = {
  __typename?: 'FormsDocAccessFields_redirect_Fields'
  reference?: Maybe<FormsDocAccessFields_Redirect_Reference>
  type?: Maybe<FormsDocAccessFields_Redirect_Type>
  url?: Maybe<FormsDocAccessFields_Redirect_Url>
}

export type FormsDocAccessFields_Redirect_Read = {
  __typename?: 'FormsDocAccessFields_redirect_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Update = {
  __typename?: 'FormsDocAccessFields_redirect_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Reference = {
  __typename?: 'FormsDocAccessFields_redirect_reference'
  create?: Maybe<FormsDocAccessFields_Redirect_Reference_Create>
  delete?: Maybe<FormsDocAccessFields_Redirect_Reference_Delete>
  read?: Maybe<FormsDocAccessFields_Redirect_Reference_Read>
  update?: Maybe<FormsDocAccessFields_Redirect_Reference_Update>
}

export type FormsDocAccessFields_Redirect_Reference_Create = {
  __typename?: 'FormsDocAccessFields_redirect_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Reference_Delete = {
  __typename?: 'FormsDocAccessFields_redirect_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Reference_Read = {
  __typename?: 'FormsDocAccessFields_redirect_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Reference_Update = {
  __typename?: 'FormsDocAccessFields_redirect_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Type = {
  __typename?: 'FormsDocAccessFields_redirect_type'
  create?: Maybe<FormsDocAccessFields_Redirect_Type_Create>
  delete?: Maybe<FormsDocAccessFields_Redirect_Type_Delete>
  read?: Maybe<FormsDocAccessFields_Redirect_Type_Read>
  update?: Maybe<FormsDocAccessFields_Redirect_Type_Update>
}

export type FormsDocAccessFields_Redirect_Type_Create = {
  __typename?: 'FormsDocAccessFields_redirect_type_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Type_Delete = {
  __typename?: 'FormsDocAccessFields_redirect_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Type_Read = {
  __typename?: 'FormsDocAccessFields_redirect_type_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Type_Update = {
  __typename?: 'FormsDocAccessFields_redirect_type_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Url = {
  __typename?: 'FormsDocAccessFields_redirect_url'
  create?: Maybe<FormsDocAccessFields_Redirect_Url_Create>
  delete?: Maybe<FormsDocAccessFields_Redirect_Url_Delete>
  read?: Maybe<FormsDocAccessFields_Redirect_Url_Read>
  update?: Maybe<FormsDocAccessFields_Redirect_Url_Update>
}

export type FormsDocAccessFields_Redirect_Url_Create = {
  __typename?: 'FormsDocAccessFields_redirect_url_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Url_Delete = {
  __typename?: 'FormsDocAccessFields_redirect_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Url_Read = {
  __typename?: 'FormsDocAccessFields_redirect_url_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Redirect_Url_Update = {
  __typename?: 'FormsDocAccessFields_redirect_url_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Slug = {
  __typename?: 'FormsDocAccessFields_slug'
  create?: Maybe<FormsDocAccessFields_Slug_Create>
  delete?: Maybe<FormsDocAccessFields_Slug_Delete>
  read?: Maybe<FormsDocAccessFields_Slug_Read>
  update?: Maybe<FormsDocAccessFields_Slug_Update>
}

export type FormsDocAccessFields_Slug_Create = {
  __typename?: 'FormsDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Slug_Delete = {
  __typename?: 'FormsDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Slug_Read = {
  __typename?: 'FormsDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Slug_Update = {
  __typename?: 'FormsDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_SubmitButtonLabel = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel'
  create?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Create>
  delete?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Delete>
  read?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Read>
  update?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Update>
}

export type FormsDocAccessFields_SubmitButtonLabel_Create = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_SubmitButtonLabel_Delete = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_SubmitButtonLabel_Read = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_SubmitButtonLabel_Update = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Title = {
  __typename?: 'FormsDocAccessFields_title'
  create?: Maybe<FormsDocAccessFields_Title_Create>
  delete?: Maybe<FormsDocAccessFields_Title_Delete>
  read?: Maybe<FormsDocAccessFields_Title_Read>
  update?: Maybe<FormsDocAccessFields_Title_Update>
}

export type FormsDocAccessFields_Title_Create = {
  __typename?: 'FormsDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Title_Delete = {
  __typename?: 'FormsDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Title_Read = {
  __typename?: 'FormsDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_Title_Update = {
  __typename?: 'FormsDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_UpdatedAt = {
  __typename?: 'FormsDocAccessFields_updatedAt'
  create?: Maybe<FormsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<FormsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<FormsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<FormsDocAccessFields_UpdatedAt_Update>
}

export type FormsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'FormsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'FormsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'FormsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'FormsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields = {
  __typename?: 'FormsFields'
  _status?: Maybe<FormsFields__Status>
  confirmationMessage?: Maybe<FormsFields_ConfirmationMessage>
  confirmationType?: Maybe<FormsFields_ConfirmationType>
  createdAt?: Maybe<FormsFields_CreatedAt>
  description?: Maybe<FormsFields_Description>
  emails?: Maybe<FormsFields_Emails>
  fields?: Maybe<FormsFields_Fields>
  redirect?: Maybe<FormsFields_Redirect>
  slug?: Maybe<FormsFields_Slug>
  submitButtonLabel?: Maybe<FormsFields_SubmitButtonLabel>
  title?: Maybe<FormsFields_Title>
  updatedAt?: Maybe<FormsFields_UpdatedAt>
}

export type FormsFields__Status = {
  __typename?: 'FormsFields__status'
  create?: Maybe<FormsFields__Status_Create>
  delete?: Maybe<FormsFields__Status_Delete>
  read?: Maybe<FormsFields__Status_Read>
  update?: Maybe<FormsFields__Status_Update>
}

export type FormsFields__Status_Create = {
  __typename?: 'FormsFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields__Status_Delete = {
  __typename?: 'FormsFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields__Status_Read = {
  __typename?: 'FormsFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields__Status_Update = {
  __typename?: 'FormsFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationMessage = {
  __typename?: 'FormsFields_confirmationMessage'
  create?: Maybe<FormsFields_ConfirmationMessage_Create>
  delete?: Maybe<FormsFields_ConfirmationMessage_Delete>
  read?: Maybe<FormsFields_ConfirmationMessage_Read>
  update?: Maybe<FormsFields_ConfirmationMessage_Update>
}

export type FormsFields_ConfirmationMessage_Create = {
  __typename?: 'FormsFields_confirmationMessage_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationMessage_Delete = {
  __typename?: 'FormsFields_confirmationMessage_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationMessage_Read = {
  __typename?: 'FormsFields_confirmationMessage_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationMessage_Update = {
  __typename?: 'FormsFields_confirmationMessage_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationType = {
  __typename?: 'FormsFields_confirmationType'
  create?: Maybe<FormsFields_ConfirmationType_Create>
  delete?: Maybe<FormsFields_ConfirmationType_Delete>
  read?: Maybe<FormsFields_ConfirmationType_Read>
  update?: Maybe<FormsFields_ConfirmationType_Update>
}

export type FormsFields_ConfirmationType_Create = {
  __typename?: 'FormsFields_confirmationType_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationType_Delete = {
  __typename?: 'FormsFields_confirmationType_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationType_Read = {
  __typename?: 'FormsFields_confirmationType_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_ConfirmationType_Update = {
  __typename?: 'FormsFields_confirmationType_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_CreatedAt = {
  __typename?: 'FormsFields_createdAt'
  create?: Maybe<FormsFields_CreatedAt_Create>
  delete?: Maybe<FormsFields_CreatedAt_Delete>
  read?: Maybe<FormsFields_CreatedAt_Read>
  update?: Maybe<FormsFields_CreatedAt_Update>
}

export type FormsFields_CreatedAt_Create = {
  __typename?: 'FormsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_CreatedAt_Delete = {
  __typename?: 'FormsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_CreatedAt_Read = {
  __typename?: 'FormsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_CreatedAt_Update = {
  __typename?: 'FormsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Description = {
  __typename?: 'FormsFields_description'
  create?: Maybe<FormsFields_Description_Create>
  delete?: Maybe<FormsFields_Description_Delete>
  read?: Maybe<FormsFields_Description_Read>
  update?: Maybe<FormsFields_Description_Update>
}

export type FormsFields_Description_Create = {
  __typename?: 'FormsFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Description_Delete = {
  __typename?: 'FormsFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Description_Read = {
  __typename?: 'FormsFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Description_Update = {
  __typename?: 'FormsFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails = {
  __typename?: 'FormsFields_emails'
  create?: Maybe<FormsFields_Emails_Create>
  delete?: Maybe<FormsFields_Emails_Delete>
  fields?: Maybe<FormsFields_Emails_Fields>
  read?: Maybe<FormsFields_Emails_Read>
  update?: Maybe<FormsFields_Emails_Update>
}

export type FormsFields_Emails_Create = {
  __typename?: 'FormsFields_emails_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Delete = {
  __typename?: 'FormsFields_emails_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Fields = {
  __typename?: 'FormsFields_emails_Fields'
  bcc?: Maybe<FormsFields_Emails_Bcc>
  cc?: Maybe<FormsFields_Emails_Cc>
  emailFrom?: Maybe<FormsFields_Emails_EmailFrom>
  emailTo?: Maybe<FormsFields_Emails_EmailTo>
  id?: Maybe<FormsFields_Emails_Id>
  message?: Maybe<FormsFields_Emails_Message>
  replyTo?: Maybe<FormsFields_Emails_ReplyTo>
  subject?: Maybe<FormsFields_Emails_Subject>
}

export type FormsFields_Emails_Read = {
  __typename?: 'FormsFields_emails_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Update = {
  __typename?: 'FormsFields_emails_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Bcc = {
  __typename?: 'FormsFields_emails_bcc'
  create?: Maybe<FormsFields_Emails_Bcc_Create>
  delete?: Maybe<FormsFields_Emails_Bcc_Delete>
  read?: Maybe<FormsFields_Emails_Bcc_Read>
  update?: Maybe<FormsFields_Emails_Bcc_Update>
}

export type FormsFields_Emails_Bcc_Create = {
  __typename?: 'FormsFields_emails_bcc_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Bcc_Delete = {
  __typename?: 'FormsFields_emails_bcc_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Bcc_Read = {
  __typename?: 'FormsFields_emails_bcc_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Bcc_Update = {
  __typename?: 'FormsFields_emails_bcc_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Cc = {
  __typename?: 'FormsFields_emails_cc'
  create?: Maybe<FormsFields_Emails_Cc_Create>
  delete?: Maybe<FormsFields_Emails_Cc_Delete>
  read?: Maybe<FormsFields_Emails_Cc_Read>
  update?: Maybe<FormsFields_Emails_Cc_Update>
}

export type FormsFields_Emails_Cc_Create = {
  __typename?: 'FormsFields_emails_cc_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Cc_Delete = {
  __typename?: 'FormsFields_emails_cc_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Cc_Read = {
  __typename?: 'FormsFields_emails_cc_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Cc_Update = {
  __typename?: 'FormsFields_emails_cc_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailFrom = {
  __typename?: 'FormsFields_emails_emailFrom'
  create?: Maybe<FormsFields_Emails_EmailFrom_Create>
  delete?: Maybe<FormsFields_Emails_EmailFrom_Delete>
  read?: Maybe<FormsFields_Emails_EmailFrom_Read>
  update?: Maybe<FormsFields_Emails_EmailFrom_Update>
}

export type FormsFields_Emails_EmailFrom_Create = {
  __typename?: 'FormsFields_emails_emailFrom_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailFrom_Delete = {
  __typename?: 'FormsFields_emails_emailFrom_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailFrom_Read = {
  __typename?: 'FormsFields_emails_emailFrom_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailFrom_Update = {
  __typename?: 'FormsFields_emails_emailFrom_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailTo = {
  __typename?: 'FormsFields_emails_emailTo'
  create?: Maybe<FormsFields_Emails_EmailTo_Create>
  delete?: Maybe<FormsFields_Emails_EmailTo_Delete>
  read?: Maybe<FormsFields_Emails_EmailTo_Read>
  update?: Maybe<FormsFields_Emails_EmailTo_Update>
}

export type FormsFields_Emails_EmailTo_Create = {
  __typename?: 'FormsFields_emails_emailTo_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailTo_Delete = {
  __typename?: 'FormsFields_emails_emailTo_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailTo_Read = {
  __typename?: 'FormsFields_emails_emailTo_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_EmailTo_Update = {
  __typename?: 'FormsFields_emails_emailTo_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Id = {
  __typename?: 'FormsFields_emails_id'
  create?: Maybe<FormsFields_Emails_Id_Create>
  delete?: Maybe<FormsFields_Emails_Id_Delete>
  read?: Maybe<FormsFields_Emails_Id_Read>
  update?: Maybe<FormsFields_Emails_Id_Update>
}

export type FormsFields_Emails_Id_Create = {
  __typename?: 'FormsFields_emails_id_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Id_Delete = {
  __typename?: 'FormsFields_emails_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Id_Read = {
  __typename?: 'FormsFields_emails_id_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Id_Update = {
  __typename?: 'FormsFields_emails_id_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Message = {
  __typename?: 'FormsFields_emails_message'
  create?: Maybe<FormsFields_Emails_Message_Create>
  delete?: Maybe<FormsFields_Emails_Message_Delete>
  read?: Maybe<FormsFields_Emails_Message_Read>
  update?: Maybe<FormsFields_Emails_Message_Update>
}

export type FormsFields_Emails_Message_Create = {
  __typename?: 'FormsFields_emails_message_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Message_Delete = {
  __typename?: 'FormsFields_emails_message_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Message_Read = {
  __typename?: 'FormsFields_emails_message_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Message_Update = {
  __typename?: 'FormsFields_emails_message_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_ReplyTo = {
  __typename?: 'FormsFields_emails_replyTo'
  create?: Maybe<FormsFields_Emails_ReplyTo_Create>
  delete?: Maybe<FormsFields_Emails_ReplyTo_Delete>
  read?: Maybe<FormsFields_Emails_ReplyTo_Read>
  update?: Maybe<FormsFields_Emails_ReplyTo_Update>
}

export type FormsFields_Emails_ReplyTo_Create = {
  __typename?: 'FormsFields_emails_replyTo_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_ReplyTo_Delete = {
  __typename?: 'FormsFields_emails_replyTo_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_ReplyTo_Read = {
  __typename?: 'FormsFields_emails_replyTo_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_ReplyTo_Update = {
  __typename?: 'FormsFields_emails_replyTo_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Subject = {
  __typename?: 'FormsFields_emails_subject'
  create?: Maybe<FormsFields_Emails_Subject_Create>
  delete?: Maybe<FormsFields_Emails_Subject_Delete>
  read?: Maybe<FormsFields_Emails_Subject_Read>
  update?: Maybe<FormsFields_Emails_Subject_Update>
}

export type FormsFields_Emails_Subject_Create = {
  __typename?: 'FormsFields_emails_subject_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Subject_Delete = {
  __typename?: 'FormsFields_emails_subject_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Subject_Read = {
  __typename?: 'FormsFields_emails_subject_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Emails_Subject_Update = {
  __typename?: 'FormsFields_emails_subject_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Fields = {
  __typename?: 'FormsFields_fields'
  create?: Maybe<FormsFields_Fields_Create>
  delete?: Maybe<FormsFields_Fields_Delete>
  read?: Maybe<FormsFields_Fields_Read>
  update?: Maybe<FormsFields_Fields_Update>
}

export type FormsFields_Fields_Create = {
  __typename?: 'FormsFields_fields_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Fields_Delete = {
  __typename?: 'FormsFields_fields_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Fields_Read = {
  __typename?: 'FormsFields_fields_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Fields_Update = {
  __typename?: 'FormsFields_fields_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect = {
  __typename?: 'FormsFields_redirect'
  create?: Maybe<FormsFields_Redirect_Create>
  delete?: Maybe<FormsFields_Redirect_Delete>
  fields?: Maybe<FormsFields_Redirect_Fields>
  read?: Maybe<FormsFields_Redirect_Read>
  update?: Maybe<FormsFields_Redirect_Update>
}

export type FormsFields_Redirect_Create = {
  __typename?: 'FormsFields_redirect_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Delete = {
  __typename?: 'FormsFields_redirect_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Fields = {
  __typename?: 'FormsFields_redirect_Fields'
  reference?: Maybe<FormsFields_Redirect_Reference>
  type?: Maybe<FormsFields_Redirect_Type>
  url?: Maybe<FormsFields_Redirect_Url>
}

export type FormsFields_Redirect_Read = {
  __typename?: 'FormsFields_redirect_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Update = {
  __typename?: 'FormsFields_redirect_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Reference = {
  __typename?: 'FormsFields_redirect_reference'
  create?: Maybe<FormsFields_Redirect_Reference_Create>
  delete?: Maybe<FormsFields_Redirect_Reference_Delete>
  read?: Maybe<FormsFields_Redirect_Reference_Read>
  update?: Maybe<FormsFields_Redirect_Reference_Update>
}

export type FormsFields_Redirect_Reference_Create = {
  __typename?: 'FormsFields_redirect_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Reference_Delete = {
  __typename?: 'FormsFields_redirect_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Reference_Read = {
  __typename?: 'FormsFields_redirect_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Reference_Update = {
  __typename?: 'FormsFields_redirect_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Type = {
  __typename?: 'FormsFields_redirect_type'
  create?: Maybe<FormsFields_Redirect_Type_Create>
  delete?: Maybe<FormsFields_Redirect_Type_Delete>
  read?: Maybe<FormsFields_Redirect_Type_Read>
  update?: Maybe<FormsFields_Redirect_Type_Update>
}

export type FormsFields_Redirect_Type_Create = {
  __typename?: 'FormsFields_redirect_type_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Type_Delete = {
  __typename?: 'FormsFields_redirect_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Type_Read = {
  __typename?: 'FormsFields_redirect_type_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Type_Update = {
  __typename?: 'FormsFields_redirect_type_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Url = {
  __typename?: 'FormsFields_redirect_url'
  create?: Maybe<FormsFields_Redirect_Url_Create>
  delete?: Maybe<FormsFields_Redirect_Url_Delete>
  read?: Maybe<FormsFields_Redirect_Url_Read>
  update?: Maybe<FormsFields_Redirect_Url_Update>
}

export type FormsFields_Redirect_Url_Create = {
  __typename?: 'FormsFields_redirect_url_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Url_Delete = {
  __typename?: 'FormsFields_redirect_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Url_Read = {
  __typename?: 'FormsFields_redirect_url_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Redirect_Url_Update = {
  __typename?: 'FormsFields_redirect_url_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Slug = {
  __typename?: 'FormsFields_slug'
  create?: Maybe<FormsFields_Slug_Create>
  delete?: Maybe<FormsFields_Slug_Delete>
  read?: Maybe<FormsFields_Slug_Read>
  update?: Maybe<FormsFields_Slug_Update>
}

export type FormsFields_Slug_Create = {
  __typename?: 'FormsFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Slug_Delete = {
  __typename?: 'FormsFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Slug_Read = {
  __typename?: 'FormsFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Slug_Update = {
  __typename?: 'FormsFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_SubmitButtonLabel = {
  __typename?: 'FormsFields_submitButtonLabel'
  create?: Maybe<FormsFields_SubmitButtonLabel_Create>
  delete?: Maybe<FormsFields_SubmitButtonLabel_Delete>
  read?: Maybe<FormsFields_SubmitButtonLabel_Read>
  update?: Maybe<FormsFields_SubmitButtonLabel_Update>
}

export type FormsFields_SubmitButtonLabel_Create = {
  __typename?: 'FormsFields_submitButtonLabel_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_SubmitButtonLabel_Delete = {
  __typename?: 'FormsFields_submitButtonLabel_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_SubmitButtonLabel_Read = {
  __typename?: 'FormsFields_submitButtonLabel_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_SubmitButtonLabel_Update = {
  __typename?: 'FormsFields_submitButtonLabel_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Title = {
  __typename?: 'FormsFields_title'
  create?: Maybe<FormsFields_Title_Create>
  delete?: Maybe<FormsFields_Title_Delete>
  read?: Maybe<FormsFields_Title_Read>
  update?: Maybe<FormsFields_Title_Update>
}

export type FormsFields_Title_Create = {
  __typename?: 'FormsFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Title_Delete = {
  __typename?: 'FormsFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Title_Read = {
  __typename?: 'FormsFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_Title_Update = {
  __typename?: 'FormsFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_UpdatedAt = {
  __typename?: 'FormsFields_updatedAt'
  create?: Maybe<FormsFields_UpdatedAt_Create>
  delete?: Maybe<FormsFields_UpdatedAt_Delete>
  read?: Maybe<FormsFields_UpdatedAt_Read>
  update?: Maybe<FormsFields_UpdatedAt_Update>
}

export type FormsFields_UpdatedAt_Create = {
  __typename?: 'FormsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_UpdatedAt_Delete = {
  __typename?: 'FormsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_UpdatedAt_Read = {
  __typename?: 'FormsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type FormsFields_UpdatedAt_Update = {
  __typename?: 'FormsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type FormsReadAccess = {
  __typename?: 'FormsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsReadDocAccess = {
  __typename?: 'FormsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsReadVersionsAccess = {
  __typename?: 'FormsReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsReadVersionsDocAccess = {
  __typename?: 'FormsReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsUpdateAccess = {
  __typename?: 'FormsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type FormsUpdateDocAccess = {
  __typename?: 'FormsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesCreateAccess = {
  __typename?: 'GuidesCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesCreateDocAccess = {
  __typename?: 'GuidesCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesDeleteAccess = {
  __typename?: 'GuidesDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesDeleteDocAccess = {
  __typename?: 'GuidesDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesDocAccessFields = {
  __typename?: 'GuidesDocAccessFields'
  _status?: Maybe<GuidesDocAccessFields__Status>
  authors?: Maybe<GuidesDocAccessFields_Authors>
  chapters?: Maybe<GuidesDocAccessFields_Chapters>
  createdAt?: Maybe<GuidesDocAccessFields_CreatedAt>
  createdBy?: Maybe<GuidesDocAccessFields_CreatedBy>
  header?: Maybe<GuidesDocAccessFields_Header>
  intro?: Maybe<GuidesDocAccessFields_Intro>
  media?: Maybe<GuidesDocAccessFields_Media>
  meta?: Maybe<GuidesDocAccessFields_Meta>
  publishedAt?: Maybe<GuidesDocAccessFields_PublishedAt>
  slug?: Maybe<GuidesDocAccessFields_Slug>
  timeEstimate?: Maybe<GuidesDocAccessFields_TimeEstimate>
  title?: Maybe<GuidesDocAccessFields_Title>
  updatedAt?: Maybe<GuidesDocAccessFields_UpdatedAt>
}

export type GuidesDocAccessFields__Status = {
  __typename?: 'GuidesDocAccessFields__status'
  create?: Maybe<GuidesDocAccessFields__Status_Create>
  delete?: Maybe<GuidesDocAccessFields__Status_Delete>
  read?: Maybe<GuidesDocAccessFields__Status_Read>
  update?: Maybe<GuidesDocAccessFields__Status_Update>
}

export type GuidesDocAccessFields__Status_Create = {
  __typename?: 'GuidesDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields__Status_Delete = {
  __typename?: 'GuidesDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields__Status_Read = {
  __typename?: 'GuidesDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields__Status_Update = {
  __typename?: 'GuidesDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Authors = {
  __typename?: 'GuidesDocAccessFields_authors'
  create?: Maybe<GuidesDocAccessFields_Authors_Create>
  delete?: Maybe<GuidesDocAccessFields_Authors_Delete>
  read?: Maybe<GuidesDocAccessFields_Authors_Read>
  update?: Maybe<GuidesDocAccessFields_Authors_Update>
}

export type GuidesDocAccessFields_Authors_Create = {
  __typename?: 'GuidesDocAccessFields_authors_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Authors_Delete = {
  __typename?: 'GuidesDocAccessFields_authors_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Authors_Read = {
  __typename?: 'GuidesDocAccessFields_authors_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Authors_Update = {
  __typename?: 'GuidesDocAccessFields_authors_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters = {
  __typename?: 'GuidesDocAccessFields_chapters'
  create?: Maybe<GuidesDocAccessFields_Chapters_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Delete>
  fields?: Maybe<GuidesDocAccessFields_Chapters_Fields>
  read?: Maybe<GuidesDocAccessFields_Chapters_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Update>
}

export type GuidesDocAccessFields_Chapters_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Fields = {
  __typename?: 'GuidesDocAccessFields_chapters_Fields'
  id?: Maybe<GuidesDocAccessFields_Chapters_Id>
  image?: Maybe<GuidesDocAccessFields_Chapters_Image>
  link?: Maybe<GuidesDocAccessFields_Chapters_Link>
  title?: Maybe<GuidesDocAccessFields_Chapters_Title>
}

export type GuidesDocAccessFields_Chapters_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Id = {
  __typename?: 'GuidesDocAccessFields_chapters_id'
  create?: Maybe<GuidesDocAccessFields_Chapters_Id_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Id_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Id_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Id_Update>
}

export type GuidesDocAccessFields_Chapters_Id_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_id_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Id_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Id_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_id_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Id_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_id_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Image = {
  __typename?: 'GuidesDocAccessFields_chapters_image'
  create?: Maybe<GuidesDocAccessFields_Chapters_Image_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Image_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Image_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Image_Update>
}

export type GuidesDocAccessFields_Chapters_Image_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_image_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Image_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Image_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_image_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Image_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_image_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link = {
  __typename?: 'GuidesDocAccessFields_chapters_link'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Delete>
  fields?: Maybe<GuidesDocAccessFields_Chapters_Link_Fields>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Fields = {
  __typename?: 'GuidesDocAccessFields_chapters_link_Fields'
  iconAfter?: Maybe<GuidesDocAccessFields_Chapters_Link_IconAfter>
  iconBefore?: Maybe<GuidesDocAccessFields_Chapters_Link_IconBefore>
  label?: Maybe<GuidesDocAccessFields_Chapters_Link_Label>
  newTab?: Maybe<GuidesDocAccessFields_Chapters_Link_NewTab>
  query?: Maybe<GuidesDocAccessFields_Chapters_Link_Query>
  reference?: Maybe<GuidesDocAccessFields_Chapters_Link_Reference>
  reusable?: Maybe<GuidesDocAccessFields_Chapters_Link_Reusable>
  targetId?: Maybe<GuidesDocAccessFields_Chapters_Link_TargetId>
  type?: Maybe<GuidesDocAccessFields_Chapters_Link_Type>
  url?: Maybe<GuidesDocAccessFields_Chapters_Link_Url>
}

export type GuidesDocAccessFields_Chapters_Link_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconAfter = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconAfter'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_IconAfter_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_IconAfter_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_IconAfter_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_IconAfter_Update>
}

export type GuidesDocAccessFields_Chapters_Link_IconAfter_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconAfter_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconAfter_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconAfter_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconBefore = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconBefore'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_IconBefore_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_IconBefore_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_IconBefore_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_IconBefore_Update>
}

export type GuidesDocAccessFields_Chapters_Link_IconBefore_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconBefore_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconBefore_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_IconBefore_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Label = {
  __typename?: 'GuidesDocAccessFields_chapters_link_label'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Label_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Label_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Label_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Label_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Label_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Label_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Label_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Label_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_NewTab = {
  __typename?: 'GuidesDocAccessFields_chapters_link_newTab'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_NewTab_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_NewTab_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_NewTab_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_NewTab_Update>
}

export type GuidesDocAccessFields_Chapters_Link_NewTab_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_NewTab_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_NewTab_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_NewTab_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Delete>
  fields?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Fields>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Query_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Fields = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_Fields'
  id?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Id>
  key?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Key>
  value?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Value>
}

export type GuidesDocAccessFields_Chapters_Link_Query_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Id = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_id'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Id_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Id_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Id_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Id_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Query_Id_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Id_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Id_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Id_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Key = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_key'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Key_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Key_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Key_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Key_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Query_Key_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Key_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Key_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Key_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Value = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_value'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Value_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Value_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Value_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Query_Value_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Query_Value_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Value_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Value_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Query_Value_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reference = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reference'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Reference_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Reference_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Reference_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Reference_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Reference_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reference_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reference_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reference_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reusable = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reusable'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Reusable_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Reusable_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Reusable_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Reusable_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Reusable_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reusable_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reusable_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Reusable_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_TargetId = {
  __typename?: 'GuidesDocAccessFields_chapters_link_targetId'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_TargetId_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_TargetId_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_TargetId_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_TargetId_Update>
}

export type GuidesDocAccessFields_Chapters_Link_TargetId_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_TargetId_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_TargetId_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_TargetId_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Type = {
  __typename?: 'GuidesDocAccessFields_chapters_link_type'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Type_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Type_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Type_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Type_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Type_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Type_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Type_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Type_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Url = {
  __typename?: 'GuidesDocAccessFields_chapters_link_url'
  create?: Maybe<GuidesDocAccessFields_Chapters_Link_Url_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Link_Url_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Link_Url_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Link_Url_Update>
}

export type GuidesDocAccessFields_Chapters_Link_Url_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Url_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Url_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Link_Url_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Title = {
  __typename?: 'GuidesDocAccessFields_chapters_title'
  create?: Maybe<GuidesDocAccessFields_Chapters_Title_Create>
  delete?: Maybe<GuidesDocAccessFields_Chapters_Title_Delete>
  read?: Maybe<GuidesDocAccessFields_Chapters_Title_Read>
  update?: Maybe<GuidesDocAccessFields_Chapters_Title_Update>
}

export type GuidesDocAccessFields_Chapters_Title_Create = {
  __typename?: 'GuidesDocAccessFields_chapters_title_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Title_Delete = {
  __typename?: 'GuidesDocAccessFields_chapters_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Title_Read = {
  __typename?: 'GuidesDocAccessFields_chapters_title_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Chapters_Title_Update = {
  __typename?: 'GuidesDocAccessFields_chapters_title_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedAt = {
  __typename?: 'GuidesDocAccessFields_createdAt'
  create?: Maybe<GuidesDocAccessFields_CreatedAt_Create>
  delete?: Maybe<GuidesDocAccessFields_CreatedAt_Delete>
  read?: Maybe<GuidesDocAccessFields_CreatedAt_Read>
  update?: Maybe<GuidesDocAccessFields_CreatedAt_Update>
}

export type GuidesDocAccessFields_CreatedAt_Create = {
  __typename?: 'GuidesDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'GuidesDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedAt_Read = {
  __typename?: 'GuidesDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedAt_Update = {
  __typename?: 'GuidesDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedBy = {
  __typename?: 'GuidesDocAccessFields_createdBy'
  create?: Maybe<GuidesDocAccessFields_CreatedBy_Create>
  delete?: Maybe<GuidesDocAccessFields_CreatedBy_Delete>
  read?: Maybe<GuidesDocAccessFields_CreatedBy_Read>
  update?: Maybe<GuidesDocAccessFields_CreatedBy_Update>
}

export type GuidesDocAccessFields_CreatedBy_Create = {
  __typename?: 'GuidesDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedBy_Delete = {
  __typename?: 'GuidesDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedBy_Read = {
  __typename?: 'GuidesDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_CreatedBy_Update = {
  __typename?: 'GuidesDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Header = {
  __typename?: 'GuidesDocAccessFields_header'
  create?: Maybe<GuidesDocAccessFields_Header_Create>
  delete?: Maybe<GuidesDocAccessFields_Header_Delete>
  read?: Maybe<GuidesDocAccessFields_Header_Read>
  update?: Maybe<GuidesDocAccessFields_Header_Update>
}

export type GuidesDocAccessFields_Header_Create = {
  __typename?: 'GuidesDocAccessFields_header_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Header_Delete = {
  __typename?: 'GuidesDocAccessFields_header_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Header_Read = {
  __typename?: 'GuidesDocAccessFields_header_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Header_Update = {
  __typename?: 'GuidesDocAccessFields_header_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Intro = {
  __typename?: 'GuidesDocAccessFields_intro'
  create?: Maybe<GuidesDocAccessFields_Intro_Create>
  delete?: Maybe<GuidesDocAccessFields_Intro_Delete>
  read?: Maybe<GuidesDocAccessFields_Intro_Read>
  update?: Maybe<GuidesDocAccessFields_Intro_Update>
}

export type GuidesDocAccessFields_Intro_Create = {
  __typename?: 'GuidesDocAccessFields_intro_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Intro_Delete = {
  __typename?: 'GuidesDocAccessFields_intro_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Intro_Read = {
  __typename?: 'GuidesDocAccessFields_intro_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Intro_Update = {
  __typename?: 'GuidesDocAccessFields_intro_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Media = {
  __typename?: 'GuidesDocAccessFields_media'
  create?: Maybe<GuidesDocAccessFields_Media_Create>
  delete?: Maybe<GuidesDocAccessFields_Media_Delete>
  read?: Maybe<GuidesDocAccessFields_Media_Read>
  update?: Maybe<GuidesDocAccessFields_Media_Update>
}

export type GuidesDocAccessFields_Media_Create = {
  __typename?: 'GuidesDocAccessFields_media_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Media_Delete = {
  __typename?: 'GuidesDocAccessFields_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Media_Read = {
  __typename?: 'GuidesDocAccessFields_media_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Media_Update = {
  __typename?: 'GuidesDocAccessFields_media_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta = {
  __typename?: 'GuidesDocAccessFields_meta'
  create?: Maybe<GuidesDocAccessFields_Meta_Create>
  delete?: Maybe<GuidesDocAccessFields_Meta_Delete>
  fields?: Maybe<GuidesDocAccessFields_Meta_Fields>
  read?: Maybe<GuidesDocAccessFields_Meta_Read>
  update?: Maybe<GuidesDocAccessFields_Meta_Update>
}

export type GuidesDocAccessFields_Meta_Create = {
  __typename?: 'GuidesDocAccessFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Delete = {
  __typename?: 'GuidesDocAccessFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Fields = {
  __typename?: 'GuidesDocAccessFields_meta_Fields'
  description?: Maybe<GuidesDocAccessFields_Meta_Description>
  image?: Maybe<GuidesDocAccessFields_Meta_Image>
  jsonLD?: Maybe<GuidesDocAccessFields_Meta_JsonLd>
  noIndex?: Maybe<GuidesDocAccessFields_Meta_NoIndex>
  title?: Maybe<GuidesDocAccessFields_Meta_Title>
}

export type GuidesDocAccessFields_Meta_Read = {
  __typename?: 'GuidesDocAccessFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Update = {
  __typename?: 'GuidesDocAccessFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Description = {
  __typename?: 'GuidesDocAccessFields_meta_description'
  create?: Maybe<GuidesDocAccessFields_Meta_Description_Create>
  delete?: Maybe<GuidesDocAccessFields_Meta_Description_Delete>
  read?: Maybe<GuidesDocAccessFields_Meta_Description_Read>
  update?: Maybe<GuidesDocAccessFields_Meta_Description_Update>
}

export type GuidesDocAccessFields_Meta_Description_Create = {
  __typename?: 'GuidesDocAccessFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Description_Delete = {
  __typename?: 'GuidesDocAccessFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Description_Read = {
  __typename?: 'GuidesDocAccessFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Description_Update = {
  __typename?: 'GuidesDocAccessFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Image = {
  __typename?: 'GuidesDocAccessFields_meta_image'
  create?: Maybe<GuidesDocAccessFields_Meta_Image_Create>
  delete?: Maybe<GuidesDocAccessFields_Meta_Image_Delete>
  read?: Maybe<GuidesDocAccessFields_Meta_Image_Read>
  update?: Maybe<GuidesDocAccessFields_Meta_Image_Update>
}

export type GuidesDocAccessFields_Meta_Image_Create = {
  __typename?: 'GuidesDocAccessFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Image_Delete = {
  __typename?: 'GuidesDocAccessFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Image_Read = {
  __typename?: 'GuidesDocAccessFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Image_Update = {
  __typename?: 'GuidesDocAccessFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_JsonLd = {
  __typename?: 'GuidesDocAccessFields_meta_jsonLD'
  create?: Maybe<GuidesDocAccessFields_Meta_JsonLd_Create>
  delete?: Maybe<GuidesDocAccessFields_Meta_JsonLd_Delete>
  read?: Maybe<GuidesDocAccessFields_Meta_JsonLd_Read>
  update?: Maybe<GuidesDocAccessFields_Meta_JsonLd_Update>
}

export type GuidesDocAccessFields_Meta_JsonLd_Create = {
  __typename?: 'GuidesDocAccessFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_JsonLd_Delete = {
  __typename?: 'GuidesDocAccessFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_JsonLd_Read = {
  __typename?: 'GuidesDocAccessFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_JsonLd_Update = {
  __typename?: 'GuidesDocAccessFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_NoIndex = {
  __typename?: 'GuidesDocAccessFields_meta_noIndex'
  create?: Maybe<GuidesDocAccessFields_Meta_NoIndex_Create>
  delete?: Maybe<GuidesDocAccessFields_Meta_NoIndex_Delete>
  read?: Maybe<GuidesDocAccessFields_Meta_NoIndex_Read>
  update?: Maybe<GuidesDocAccessFields_Meta_NoIndex_Update>
}

export type GuidesDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'GuidesDocAccessFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'GuidesDocAccessFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'GuidesDocAccessFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'GuidesDocAccessFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Title = {
  __typename?: 'GuidesDocAccessFields_meta_title'
  create?: Maybe<GuidesDocAccessFields_Meta_Title_Create>
  delete?: Maybe<GuidesDocAccessFields_Meta_Title_Delete>
  read?: Maybe<GuidesDocAccessFields_Meta_Title_Read>
  update?: Maybe<GuidesDocAccessFields_Meta_Title_Update>
}

export type GuidesDocAccessFields_Meta_Title_Create = {
  __typename?: 'GuidesDocAccessFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Title_Delete = {
  __typename?: 'GuidesDocAccessFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Title_Read = {
  __typename?: 'GuidesDocAccessFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Meta_Title_Update = {
  __typename?: 'GuidesDocAccessFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_PublishedAt = {
  __typename?: 'GuidesDocAccessFields_publishedAt'
  create?: Maybe<GuidesDocAccessFields_PublishedAt_Create>
  delete?: Maybe<GuidesDocAccessFields_PublishedAt_Delete>
  read?: Maybe<GuidesDocAccessFields_PublishedAt_Read>
  update?: Maybe<GuidesDocAccessFields_PublishedAt_Update>
}

export type GuidesDocAccessFields_PublishedAt_Create = {
  __typename?: 'GuidesDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_PublishedAt_Delete = {
  __typename?: 'GuidesDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_PublishedAt_Read = {
  __typename?: 'GuidesDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_PublishedAt_Update = {
  __typename?: 'GuidesDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Slug = {
  __typename?: 'GuidesDocAccessFields_slug'
  create?: Maybe<GuidesDocAccessFields_Slug_Create>
  delete?: Maybe<GuidesDocAccessFields_Slug_Delete>
  read?: Maybe<GuidesDocAccessFields_Slug_Read>
  update?: Maybe<GuidesDocAccessFields_Slug_Update>
}

export type GuidesDocAccessFields_Slug_Create = {
  __typename?: 'GuidesDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Slug_Delete = {
  __typename?: 'GuidesDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Slug_Read = {
  __typename?: 'GuidesDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Slug_Update = {
  __typename?: 'GuidesDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_TimeEstimate = {
  __typename?: 'GuidesDocAccessFields_timeEstimate'
  create?: Maybe<GuidesDocAccessFields_TimeEstimate_Create>
  delete?: Maybe<GuidesDocAccessFields_TimeEstimate_Delete>
  read?: Maybe<GuidesDocAccessFields_TimeEstimate_Read>
  update?: Maybe<GuidesDocAccessFields_TimeEstimate_Update>
}

export type GuidesDocAccessFields_TimeEstimate_Create = {
  __typename?: 'GuidesDocAccessFields_timeEstimate_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_TimeEstimate_Delete = {
  __typename?: 'GuidesDocAccessFields_timeEstimate_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_TimeEstimate_Read = {
  __typename?: 'GuidesDocAccessFields_timeEstimate_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_TimeEstimate_Update = {
  __typename?: 'GuidesDocAccessFields_timeEstimate_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Title = {
  __typename?: 'GuidesDocAccessFields_title'
  create?: Maybe<GuidesDocAccessFields_Title_Create>
  delete?: Maybe<GuidesDocAccessFields_Title_Delete>
  read?: Maybe<GuidesDocAccessFields_Title_Read>
  update?: Maybe<GuidesDocAccessFields_Title_Update>
}

export type GuidesDocAccessFields_Title_Create = {
  __typename?: 'GuidesDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Title_Delete = {
  __typename?: 'GuidesDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Title_Read = {
  __typename?: 'GuidesDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_Title_Update = {
  __typename?: 'GuidesDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_UpdatedAt = {
  __typename?: 'GuidesDocAccessFields_updatedAt'
  create?: Maybe<GuidesDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<GuidesDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<GuidesDocAccessFields_UpdatedAt_Read>
  update?: Maybe<GuidesDocAccessFields_UpdatedAt_Update>
}

export type GuidesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'GuidesDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'GuidesDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'GuidesDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'GuidesDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields = {
  __typename?: 'GuidesFields'
  _status?: Maybe<GuidesFields__Status>
  authors?: Maybe<GuidesFields_Authors>
  chapters?: Maybe<GuidesFields_Chapters>
  createdAt?: Maybe<GuidesFields_CreatedAt>
  createdBy?: Maybe<GuidesFields_CreatedBy>
  header?: Maybe<GuidesFields_Header>
  intro?: Maybe<GuidesFields_Intro>
  media?: Maybe<GuidesFields_Media>
  meta?: Maybe<GuidesFields_Meta>
  publishedAt?: Maybe<GuidesFields_PublishedAt>
  slug?: Maybe<GuidesFields_Slug>
  timeEstimate?: Maybe<GuidesFields_TimeEstimate>
  title?: Maybe<GuidesFields_Title>
  updatedAt?: Maybe<GuidesFields_UpdatedAt>
}

export type GuidesFields__Status = {
  __typename?: 'GuidesFields__status'
  create?: Maybe<GuidesFields__Status_Create>
  delete?: Maybe<GuidesFields__Status_Delete>
  read?: Maybe<GuidesFields__Status_Read>
  update?: Maybe<GuidesFields__Status_Update>
}

export type GuidesFields__Status_Create = {
  __typename?: 'GuidesFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields__Status_Delete = {
  __typename?: 'GuidesFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields__Status_Read = {
  __typename?: 'GuidesFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields__Status_Update = {
  __typename?: 'GuidesFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Authors = {
  __typename?: 'GuidesFields_authors'
  create?: Maybe<GuidesFields_Authors_Create>
  delete?: Maybe<GuidesFields_Authors_Delete>
  read?: Maybe<GuidesFields_Authors_Read>
  update?: Maybe<GuidesFields_Authors_Update>
}

export type GuidesFields_Authors_Create = {
  __typename?: 'GuidesFields_authors_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Authors_Delete = {
  __typename?: 'GuidesFields_authors_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Authors_Read = {
  __typename?: 'GuidesFields_authors_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Authors_Update = {
  __typename?: 'GuidesFields_authors_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters = {
  __typename?: 'GuidesFields_chapters'
  create?: Maybe<GuidesFields_Chapters_Create>
  delete?: Maybe<GuidesFields_Chapters_Delete>
  fields?: Maybe<GuidesFields_Chapters_Fields>
  read?: Maybe<GuidesFields_Chapters_Read>
  update?: Maybe<GuidesFields_Chapters_Update>
}

export type GuidesFields_Chapters_Create = {
  __typename?: 'GuidesFields_chapters_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Delete = {
  __typename?: 'GuidesFields_chapters_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Fields = {
  __typename?: 'GuidesFields_chapters_Fields'
  id?: Maybe<GuidesFields_Chapters_Id>
  image?: Maybe<GuidesFields_Chapters_Image>
  link?: Maybe<GuidesFields_Chapters_Link>
  title?: Maybe<GuidesFields_Chapters_Title>
}

export type GuidesFields_Chapters_Read = {
  __typename?: 'GuidesFields_chapters_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Update = {
  __typename?: 'GuidesFields_chapters_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Id = {
  __typename?: 'GuidesFields_chapters_id'
  create?: Maybe<GuidesFields_Chapters_Id_Create>
  delete?: Maybe<GuidesFields_Chapters_Id_Delete>
  read?: Maybe<GuidesFields_Chapters_Id_Read>
  update?: Maybe<GuidesFields_Chapters_Id_Update>
}

export type GuidesFields_Chapters_Id_Create = {
  __typename?: 'GuidesFields_chapters_id_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Id_Delete = {
  __typename?: 'GuidesFields_chapters_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Id_Read = {
  __typename?: 'GuidesFields_chapters_id_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Id_Update = {
  __typename?: 'GuidesFields_chapters_id_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Image = {
  __typename?: 'GuidesFields_chapters_image'
  create?: Maybe<GuidesFields_Chapters_Image_Create>
  delete?: Maybe<GuidesFields_Chapters_Image_Delete>
  read?: Maybe<GuidesFields_Chapters_Image_Read>
  update?: Maybe<GuidesFields_Chapters_Image_Update>
}

export type GuidesFields_Chapters_Image_Create = {
  __typename?: 'GuidesFields_chapters_image_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Image_Delete = {
  __typename?: 'GuidesFields_chapters_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Image_Read = {
  __typename?: 'GuidesFields_chapters_image_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Image_Update = {
  __typename?: 'GuidesFields_chapters_image_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link = {
  __typename?: 'GuidesFields_chapters_link'
  create?: Maybe<GuidesFields_Chapters_Link_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Delete>
  fields?: Maybe<GuidesFields_Chapters_Link_Fields>
  read?: Maybe<GuidesFields_Chapters_Link_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Update>
}

export type GuidesFields_Chapters_Link_Create = {
  __typename?: 'GuidesFields_chapters_link_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Delete = {
  __typename?: 'GuidesFields_chapters_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Fields = {
  __typename?: 'GuidesFields_chapters_link_Fields'
  iconAfter?: Maybe<GuidesFields_Chapters_Link_IconAfter>
  iconBefore?: Maybe<GuidesFields_Chapters_Link_IconBefore>
  label?: Maybe<GuidesFields_Chapters_Link_Label>
  newTab?: Maybe<GuidesFields_Chapters_Link_NewTab>
  query?: Maybe<GuidesFields_Chapters_Link_Query>
  reference?: Maybe<GuidesFields_Chapters_Link_Reference>
  reusable?: Maybe<GuidesFields_Chapters_Link_Reusable>
  targetId?: Maybe<GuidesFields_Chapters_Link_TargetId>
  type?: Maybe<GuidesFields_Chapters_Link_Type>
  url?: Maybe<GuidesFields_Chapters_Link_Url>
}

export type GuidesFields_Chapters_Link_Read = {
  __typename?: 'GuidesFields_chapters_link_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Update = {
  __typename?: 'GuidesFields_chapters_link_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconAfter = {
  __typename?: 'GuidesFields_chapters_link_iconAfter'
  create?: Maybe<GuidesFields_Chapters_Link_IconAfter_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_IconAfter_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_IconAfter_Read>
  update?: Maybe<GuidesFields_Chapters_Link_IconAfter_Update>
}

export type GuidesFields_Chapters_Link_IconAfter_Create = {
  __typename?: 'GuidesFields_chapters_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconAfter_Delete = {
  __typename?: 'GuidesFields_chapters_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconAfter_Read = {
  __typename?: 'GuidesFields_chapters_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconAfter_Update = {
  __typename?: 'GuidesFields_chapters_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconBefore = {
  __typename?: 'GuidesFields_chapters_link_iconBefore'
  create?: Maybe<GuidesFields_Chapters_Link_IconBefore_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_IconBefore_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_IconBefore_Read>
  update?: Maybe<GuidesFields_Chapters_Link_IconBefore_Update>
}

export type GuidesFields_Chapters_Link_IconBefore_Create = {
  __typename?: 'GuidesFields_chapters_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconBefore_Delete = {
  __typename?: 'GuidesFields_chapters_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconBefore_Read = {
  __typename?: 'GuidesFields_chapters_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_IconBefore_Update = {
  __typename?: 'GuidesFields_chapters_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Label = {
  __typename?: 'GuidesFields_chapters_link_label'
  create?: Maybe<GuidesFields_Chapters_Link_Label_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Label_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Label_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Label_Update>
}

export type GuidesFields_Chapters_Link_Label_Create = {
  __typename?: 'GuidesFields_chapters_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Label_Delete = {
  __typename?: 'GuidesFields_chapters_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Label_Read = {
  __typename?: 'GuidesFields_chapters_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Label_Update = {
  __typename?: 'GuidesFields_chapters_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_NewTab = {
  __typename?: 'GuidesFields_chapters_link_newTab'
  create?: Maybe<GuidesFields_Chapters_Link_NewTab_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_NewTab_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_NewTab_Read>
  update?: Maybe<GuidesFields_Chapters_Link_NewTab_Update>
}

export type GuidesFields_Chapters_Link_NewTab_Create = {
  __typename?: 'GuidesFields_chapters_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_NewTab_Delete = {
  __typename?: 'GuidesFields_chapters_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_NewTab_Read = {
  __typename?: 'GuidesFields_chapters_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_NewTab_Update = {
  __typename?: 'GuidesFields_chapters_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query = {
  __typename?: 'GuidesFields_chapters_link_query'
  create?: Maybe<GuidesFields_Chapters_Link_Query_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Query_Delete>
  fields?: Maybe<GuidesFields_Chapters_Link_Query_Fields>
  read?: Maybe<GuidesFields_Chapters_Link_Query_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Query_Update>
}

export type GuidesFields_Chapters_Link_Query_Create = {
  __typename?: 'GuidesFields_chapters_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Delete = {
  __typename?: 'GuidesFields_chapters_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Fields = {
  __typename?: 'GuidesFields_chapters_link_query_Fields'
  id?: Maybe<GuidesFields_Chapters_Link_Query_Id>
  key?: Maybe<GuidesFields_Chapters_Link_Query_Key>
  value?: Maybe<GuidesFields_Chapters_Link_Query_Value>
}

export type GuidesFields_Chapters_Link_Query_Read = {
  __typename?: 'GuidesFields_chapters_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Update = {
  __typename?: 'GuidesFields_chapters_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Id = {
  __typename?: 'GuidesFields_chapters_link_query_id'
  create?: Maybe<GuidesFields_Chapters_Link_Query_Id_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Query_Id_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Query_Id_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Query_Id_Update>
}

export type GuidesFields_Chapters_Link_Query_Id_Create = {
  __typename?: 'GuidesFields_chapters_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Id_Delete = {
  __typename?: 'GuidesFields_chapters_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Id_Read = {
  __typename?: 'GuidesFields_chapters_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Id_Update = {
  __typename?: 'GuidesFields_chapters_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Key = {
  __typename?: 'GuidesFields_chapters_link_query_key'
  create?: Maybe<GuidesFields_Chapters_Link_Query_Key_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Query_Key_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Query_Key_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Query_Key_Update>
}

export type GuidesFields_Chapters_Link_Query_Key_Create = {
  __typename?: 'GuidesFields_chapters_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Key_Delete = {
  __typename?: 'GuidesFields_chapters_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Key_Read = {
  __typename?: 'GuidesFields_chapters_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Key_Update = {
  __typename?: 'GuidesFields_chapters_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Value = {
  __typename?: 'GuidesFields_chapters_link_query_value'
  create?: Maybe<GuidesFields_Chapters_Link_Query_Value_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Query_Value_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Query_Value_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Query_Value_Update>
}

export type GuidesFields_Chapters_Link_Query_Value_Create = {
  __typename?: 'GuidesFields_chapters_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Value_Delete = {
  __typename?: 'GuidesFields_chapters_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Value_Read = {
  __typename?: 'GuidesFields_chapters_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Query_Value_Update = {
  __typename?: 'GuidesFields_chapters_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reference = {
  __typename?: 'GuidesFields_chapters_link_reference'
  create?: Maybe<GuidesFields_Chapters_Link_Reference_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Reference_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Reference_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Reference_Update>
}

export type GuidesFields_Chapters_Link_Reference_Create = {
  __typename?: 'GuidesFields_chapters_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reference_Delete = {
  __typename?: 'GuidesFields_chapters_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reference_Read = {
  __typename?: 'GuidesFields_chapters_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reference_Update = {
  __typename?: 'GuidesFields_chapters_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reusable = {
  __typename?: 'GuidesFields_chapters_link_reusable'
  create?: Maybe<GuidesFields_Chapters_Link_Reusable_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Reusable_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Reusable_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Reusable_Update>
}

export type GuidesFields_Chapters_Link_Reusable_Create = {
  __typename?: 'GuidesFields_chapters_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reusable_Delete = {
  __typename?: 'GuidesFields_chapters_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reusable_Read = {
  __typename?: 'GuidesFields_chapters_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Reusable_Update = {
  __typename?: 'GuidesFields_chapters_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_TargetId = {
  __typename?: 'GuidesFields_chapters_link_targetId'
  create?: Maybe<GuidesFields_Chapters_Link_TargetId_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_TargetId_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_TargetId_Read>
  update?: Maybe<GuidesFields_Chapters_Link_TargetId_Update>
}

export type GuidesFields_Chapters_Link_TargetId_Create = {
  __typename?: 'GuidesFields_chapters_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_TargetId_Delete = {
  __typename?: 'GuidesFields_chapters_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_TargetId_Read = {
  __typename?: 'GuidesFields_chapters_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_TargetId_Update = {
  __typename?: 'GuidesFields_chapters_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Type = {
  __typename?: 'GuidesFields_chapters_link_type'
  create?: Maybe<GuidesFields_Chapters_Link_Type_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Type_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Type_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Type_Update>
}

export type GuidesFields_Chapters_Link_Type_Create = {
  __typename?: 'GuidesFields_chapters_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Type_Delete = {
  __typename?: 'GuidesFields_chapters_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Type_Read = {
  __typename?: 'GuidesFields_chapters_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Type_Update = {
  __typename?: 'GuidesFields_chapters_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Url = {
  __typename?: 'GuidesFields_chapters_link_url'
  create?: Maybe<GuidesFields_Chapters_Link_Url_Create>
  delete?: Maybe<GuidesFields_Chapters_Link_Url_Delete>
  read?: Maybe<GuidesFields_Chapters_Link_Url_Read>
  update?: Maybe<GuidesFields_Chapters_Link_Url_Update>
}

export type GuidesFields_Chapters_Link_Url_Create = {
  __typename?: 'GuidesFields_chapters_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Url_Delete = {
  __typename?: 'GuidesFields_chapters_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Url_Read = {
  __typename?: 'GuidesFields_chapters_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Link_Url_Update = {
  __typename?: 'GuidesFields_chapters_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Title = {
  __typename?: 'GuidesFields_chapters_title'
  create?: Maybe<GuidesFields_Chapters_Title_Create>
  delete?: Maybe<GuidesFields_Chapters_Title_Delete>
  read?: Maybe<GuidesFields_Chapters_Title_Read>
  update?: Maybe<GuidesFields_Chapters_Title_Update>
}

export type GuidesFields_Chapters_Title_Create = {
  __typename?: 'GuidesFields_chapters_title_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Title_Delete = {
  __typename?: 'GuidesFields_chapters_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Title_Read = {
  __typename?: 'GuidesFields_chapters_title_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Chapters_Title_Update = {
  __typename?: 'GuidesFields_chapters_title_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedAt = {
  __typename?: 'GuidesFields_createdAt'
  create?: Maybe<GuidesFields_CreatedAt_Create>
  delete?: Maybe<GuidesFields_CreatedAt_Delete>
  read?: Maybe<GuidesFields_CreatedAt_Read>
  update?: Maybe<GuidesFields_CreatedAt_Update>
}

export type GuidesFields_CreatedAt_Create = {
  __typename?: 'GuidesFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedAt_Delete = {
  __typename?: 'GuidesFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedAt_Read = {
  __typename?: 'GuidesFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedAt_Update = {
  __typename?: 'GuidesFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedBy = {
  __typename?: 'GuidesFields_createdBy'
  create?: Maybe<GuidesFields_CreatedBy_Create>
  delete?: Maybe<GuidesFields_CreatedBy_Delete>
  read?: Maybe<GuidesFields_CreatedBy_Read>
  update?: Maybe<GuidesFields_CreatedBy_Update>
}

export type GuidesFields_CreatedBy_Create = {
  __typename?: 'GuidesFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedBy_Delete = {
  __typename?: 'GuidesFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedBy_Read = {
  __typename?: 'GuidesFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_CreatedBy_Update = {
  __typename?: 'GuidesFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Header = {
  __typename?: 'GuidesFields_header'
  create?: Maybe<GuidesFields_Header_Create>
  delete?: Maybe<GuidesFields_Header_Delete>
  read?: Maybe<GuidesFields_Header_Read>
  update?: Maybe<GuidesFields_Header_Update>
}

export type GuidesFields_Header_Create = {
  __typename?: 'GuidesFields_header_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Header_Delete = {
  __typename?: 'GuidesFields_header_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Header_Read = {
  __typename?: 'GuidesFields_header_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Header_Update = {
  __typename?: 'GuidesFields_header_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Intro = {
  __typename?: 'GuidesFields_intro'
  create?: Maybe<GuidesFields_Intro_Create>
  delete?: Maybe<GuidesFields_Intro_Delete>
  read?: Maybe<GuidesFields_Intro_Read>
  update?: Maybe<GuidesFields_Intro_Update>
}

export type GuidesFields_Intro_Create = {
  __typename?: 'GuidesFields_intro_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Intro_Delete = {
  __typename?: 'GuidesFields_intro_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Intro_Read = {
  __typename?: 'GuidesFields_intro_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Intro_Update = {
  __typename?: 'GuidesFields_intro_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Media = {
  __typename?: 'GuidesFields_media'
  create?: Maybe<GuidesFields_Media_Create>
  delete?: Maybe<GuidesFields_Media_Delete>
  read?: Maybe<GuidesFields_Media_Read>
  update?: Maybe<GuidesFields_Media_Update>
}

export type GuidesFields_Media_Create = {
  __typename?: 'GuidesFields_media_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Media_Delete = {
  __typename?: 'GuidesFields_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Media_Read = {
  __typename?: 'GuidesFields_media_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Media_Update = {
  __typename?: 'GuidesFields_media_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta = {
  __typename?: 'GuidesFields_meta'
  create?: Maybe<GuidesFields_Meta_Create>
  delete?: Maybe<GuidesFields_Meta_Delete>
  fields?: Maybe<GuidesFields_Meta_Fields>
  read?: Maybe<GuidesFields_Meta_Read>
  update?: Maybe<GuidesFields_Meta_Update>
}

export type GuidesFields_Meta_Create = {
  __typename?: 'GuidesFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Delete = {
  __typename?: 'GuidesFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Fields = {
  __typename?: 'GuidesFields_meta_Fields'
  description?: Maybe<GuidesFields_Meta_Description>
  image?: Maybe<GuidesFields_Meta_Image>
  jsonLD?: Maybe<GuidesFields_Meta_JsonLd>
  noIndex?: Maybe<GuidesFields_Meta_NoIndex>
  title?: Maybe<GuidesFields_Meta_Title>
}

export type GuidesFields_Meta_Read = {
  __typename?: 'GuidesFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Update = {
  __typename?: 'GuidesFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Description = {
  __typename?: 'GuidesFields_meta_description'
  create?: Maybe<GuidesFields_Meta_Description_Create>
  delete?: Maybe<GuidesFields_Meta_Description_Delete>
  read?: Maybe<GuidesFields_Meta_Description_Read>
  update?: Maybe<GuidesFields_Meta_Description_Update>
}

export type GuidesFields_Meta_Description_Create = {
  __typename?: 'GuidesFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Description_Delete = {
  __typename?: 'GuidesFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Description_Read = {
  __typename?: 'GuidesFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Description_Update = {
  __typename?: 'GuidesFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Image = {
  __typename?: 'GuidesFields_meta_image'
  create?: Maybe<GuidesFields_Meta_Image_Create>
  delete?: Maybe<GuidesFields_Meta_Image_Delete>
  read?: Maybe<GuidesFields_Meta_Image_Read>
  update?: Maybe<GuidesFields_Meta_Image_Update>
}

export type GuidesFields_Meta_Image_Create = {
  __typename?: 'GuidesFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Image_Delete = {
  __typename?: 'GuidesFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Image_Read = {
  __typename?: 'GuidesFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Image_Update = {
  __typename?: 'GuidesFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_JsonLd = {
  __typename?: 'GuidesFields_meta_jsonLD'
  create?: Maybe<GuidesFields_Meta_JsonLd_Create>
  delete?: Maybe<GuidesFields_Meta_JsonLd_Delete>
  read?: Maybe<GuidesFields_Meta_JsonLd_Read>
  update?: Maybe<GuidesFields_Meta_JsonLd_Update>
}

export type GuidesFields_Meta_JsonLd_Create = {
  __typename?: 'GuidesFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_JsonLd_Delete = {
  __typename?: 'GuidesFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_JsonLd_Read = {
  __typename?: 'GuidesFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_JsonLd_Update = {
  __typename?: 'GuidesFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_NoIndex = {
  __typename?: 'GuidesFields_meta_noIndex'
  create?: Maybe<GuidesFields_Meta_NoIndex_Create>
  delete?: Maybe<GuidesFields_Meta_NoIndex_Delete>
  read?: Maybe<GuidesFields_Meta_NoIndex_Read>
  update?: Maybe<GuidesFields_Meta_NoIndex_Update>
}

export type GuidesFields_Meta_NoIndex_Create = {
  __typename?: 'GuidesFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_NoIndex_Delete = {
  __typename?: 'GuidesFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_NoIndex_Read = {
  __typename?: 'GuidesFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_NoIndex_Update = {
  __typename?: 'GuidesFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Title = {
  __typename?: 'GuidesFields_meta_title'
  create?: Maybe<GuidesFields_Meta_Title_Create>
  delete?: Maybe<GuidesFields_Meta_Title_Delete>
  read?: Maybe<GuidesFields_Meta_Title_Read>
  update?: Maybe<GuidesFields_Meta_Title_Update>
}

export type GuidesFields_Meta_Title_Create = {
  __typename?: 'GuidesFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Title_Delete = {
  __typename?: 'GuidesFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Title_Read = {
  __typename?: 'GuidesFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Meta_Title_Update = {
  __typename?: 'GuidesFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_PublishedAt = {
  __typename?: 'GuidesFields_publishedAt'
  create?: Maybe<GuidesFields_PublishedAt_Create>
  delete?: Maybe<GuidesFields_PublishedAt_Delete>
  read?: Maybe<GuidesFields_PublishedAt_Read>
  update?: Maybe<GuidesFields_PublishedAt_Update>
}

export type GuidesFields_PublishedAt_Create = {
  __typename?: 'GuidesFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_PublishedAt_Delete = {
  __typename?: 'GuidesFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_PublishedAt_Read = {
  __typename?: 'GuidesFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_PublishedAt_Update = {
  __typename?: 'GuidesFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Slug = {
  __typename?: 'GuidesFields_slug'
  create?: Maybe<GuidesFields_Slug_Create>
  delete?: Maybe<GuidesFields_Slug_Delete>
  read?: Maybe<GuidesFields_Slug_Read>
  update?: Maybe<GuidesFields_Slug_Update>
}

export type GuidesFields_Slug_Create = {
  __typename?: 'GuidesFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Slug_Delete = {
  __typename?: 'GuidesFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Slug_Read = {
  __typename?: 'GuidesFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Slug_Update = {
  __typename?: 'GuidesFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_TimeEstimate = {
  __typename?: 'GuidesFields_timeEstimate'
  create?: Maybe<GuidesFields_TimeEstimate_Create>
  delete?: Maybe<GuidesFields_TimeEstimate_Delete>
  read?: Maybe<GuidesFields_TimeEstimate_Read>
  update?: Maybe<GuidesFields_TimeEstimate_Update>
}

export type GuidesFields_TimeEstimate_Create = {
  __typename?: 'GuidesFields_timeEstimate_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_TimeEstimate_Delete = {
  __typename?: 'GuidesFields_timeEstimate_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_TimeEstimate_Read = {
  __typename?: 'GuidesFields_timeEstimate_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_TimeEstimate_Update = {
  __typename?: 'GuidesFields_timeEstimate_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Title = {
  __typename?: 'GuidesFields_title'
  create?: Maybe<GuidesFields_Title_Create>
  delete?: Maybe<GuidesFields_Title_Delete>
  read?: Maybe<GuidesFields_Title_Read>
  update?: Maybe<GuidesFields_Title_Update>
}

export type GuidesFields_Title_Create = {
  __typename?: 'GuidesFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Title_Delete = {
  __typename?: 'GuidesFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Title_Read = {
  __typename?: 'GuidesFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_Title_Update = {
  __typename?: 'GuidesFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_UpdatedAt = {
  __typename?: 'GuidesFields_updatedAt'
  create?: Maybe<GuidesFields_UpdatedAt_Create>
  delete?: Maybe<GuidesFields_UpdatedAt_Delete>
  read?: Maybe<GuidesFields_UpdatedAt_Read>
  update?: Maybe<GuidesFields_UpdatedAt_Update>
}

export type GuidesFields_UpdatedAt_Create = {
  __typename?: 'GuidesFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_UpdatedAt_Delete = {
  __typename?: 'GuidesFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_UpdatedAt_Read = {
  __typename?: 'GuidesFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type GuidesFields_UpdatedAt_Update = {
  __typename?: 'GuidesFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type GuidesReadAccess = {
  __typename?: 'GuidesReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesReadDocAccess = {
  __typename?: 'GuidesReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesReadVersionsAccess = {
  __typename?: 'GuidesReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesReadVersionsDocAccess = {
  __typename?: 'GuidesReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesUpdateAccess = {
  __typename?: 'GuidesUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type GuidesUpdateDocAccess = {
  __typename?: 'GuidesUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalCreateAccess = {
  __typename?: 'LegalCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalCreateDocAccess = {
  __typename?: 'LegalCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalDeleteAccess = {
  __typename?: 'LegalDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalDeleteDocAccess = {
  __typename?: 'LegalDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalDocAccessFields = {
  __typename?: 'LegalDocAccessFields'
  createdAt?: Maybe<LegalDocAccessFields_CreatedAt>
  createdBy?: Maybe<LegalDocAccessFields_CreatedBy>
  description?: Maybe<LegalDocAccessFields_Description>
  richText?: Maybe<LegalDocAccessFields_RichText>
  slug?: Maybe<LegalDocAccessFields_Slug>
  title?: Maybe<LegalDocAccessFields_Title>
  updatedAt?: Maybe<LegalDocAccessFields_UpdatedAt>
}

export type LegalDocAccessFields_CreatedAt = {
  __typename?: 'LegalDocAccessFields_createdAt'
  create?: Maybe<LegalDocAccessFields_CreatedAt_Create>
  delete?: Maybe<LegalDocAccessFields_CreatedAt_Delete>
  read?: Maybe<LegalDocAccessFields_CreatedAt_Read>
  update?: Maybe<LegalDocAccessFields_CreatedAt_Update>
}

export type LegalDocAccessFields_CreatedAt_Create = {
  __typename?: 'LegalDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_CreatedAt_Delete = {
  __typename?: 'LegalDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_CreatedAt_Read = {
  __typename?: 'LegalDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_CreatedAt_Update = {
  __typename?: 'LegalDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_CreatedBy = {
  __typename?: 'LegalDocAccessFields_createdBy'
  create?: Maybe<LegalDocAccessFields_CreatedBy_Create>
  delete?: Maybe<LegalDocAccessFields_CreatedBy_Delete>
  read?: Maybe<LegalDocAccessFields_CreatedBy_Read>
  update?: Maybe<LegalDocAccessFields_CreatedBy_Update>
}

export type LegalDocAccessFields_CreatedBy_Create = {
  __typename?: 'LegalDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_CreatedBy_Delete = {
  __typename?: 'LegalDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_CreatedBy_Read = {
  __typename?: 'LegalDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_CreatedBy_Update = {
  __typename?: 'LegalDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Description = {
  __typename?: 'LegalDocAccessFields_description'
  create?: Maybe<LegalDocAccessFields_Description_Create>
  delete?: Maybe<LegalDocAccessFields_Description_Delete>
  read?: Maybe<LegalDocAccessFields_Description_Read>
  update?: Maybe<LegalDocAccessFields_Description_Update>
}

export type LegalDocAccessFields_Description_Create = {
  __typename?: 'LegalDocAccessFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Description_Delete = {
  __typename?: 'LegalDocAccessFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Description_Read = {
  __typename?: 'LegalDocAccessFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Description_Update = {
  __typename?: 'LegalDocAccessFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_RichText = {
  __typename?: 'LegalDocAccessFields_richText'
  create?: Maybe<LegalDocAccessFields_RichText_Create>
  delete?: Maybe<LegalDocAccessFields_RichText_Delete>
  read?: Maybe<LegalDocAccessFields_RichText_Read>
  update?: Maybe<LegalDocAccessFields_RichText_Update>
}

export type LegalDocAccessFields_RichText_Create = {
  __typename?: 'LegalDocAccessFields_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_RichText_Delete = {
  __typename?: 'LegalDocAccessFields_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_RichText_Read = {
  __typename?: 'LegalDocAccessFields_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_RichText_Update = {
  __typename?: 'LegalDocAccessFields_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Slug = {
  __typename?: 'LegalDocAccessFields_slug'
  create?: Maybe<LegalDocAccessFields_Slug_Create>
  delete?: Maybe<LegalDocAccessFields_Slug_Delete>
  read?: Maybe<LegalDocAccessFields_Slug_Read>
  update?: Maybe<LegalDocAccessFields_Slug_Update>
}

export type LegalDocAccessFields_Slug_Create = {
  __typename?: 'LegalDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Slug_Delete = {
  __typename?: 'LegalDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Slug_Read = {
  __typename?: 'LegalDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Slug_Update = {
  __typename?: 'LegalDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Title = {
  __typename?: 'LegalDocAccessFields_title'
  create?: Maybe<LegalDocAccessFields_Title_Create>
  delete?: Maybe<LegalDocAccessFields_Title_Delete>
  read?: Maybe<LegalDocAccessFields_Title_Read>
  update?: Maybe<LegalDocAccessFields_Title_Update>
}

export type LegalDocAccessFields_Title_Create = {
  __typename?: 'LegalDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Title_Delete = {
  __typename?: 'LegalDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Title_Read = {
  __typename?: 'LegalDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_Title_Update = {
  __typename?: 'LegalDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_UpdatedAt = {
  __typename?: 'LegalDocAccessFields_updatedAt'
  create?: Maybe<LegalDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<LegalDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<LegalDocAccessFields_UpdatedAt_Read>
  update?: Maybe<LegalDocAccessFields_UpdatedAt_Update>
}

export type LegalDocAccessFields_UpdatedAt_Create = {
  __typename?: 'LegalDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'LegalDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_UpdatedAt_Read = {
  __typename?: 'LegalDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalDocAccessFields_UpdatedAt_Update = {
  __typename?: 'LegalDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalFields = {
  __typename?: 'LegalFields'
  createdAt?: Maybe<LegalFields_CreatedAt>
  createdBy?: Maybe<LegalFields_CreatedBy>
  description?: Maybe<LegalFields_Description>
  richText?: Maybe<LegalFields_RichText>
  slug?: Maybe<LegalFields_Slug>
  title?: Maybe<LegalFields_Title>
  updatedAt?: Maybe<LegalFields_UpdatedAt>
}

export type LegalFields_CreatedAt = {
  __typename?: 'LegalFields_createdAt'
  create?: Maybe<LegalFields_CreatedAt_Create>
  delete?: Maybe<LegalFields_CreatedAt_Delete>
  read?: Maybe<LegalFields_CreatedAt_Read>
  update?: Maybe<LegalFields_CreatedAt_Update>
}

export type LegalFields_CreatedAt_Create = {
  __typename?: 'LegalFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_CreatedAt_Delete = {
  __typename?: 'LegalFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_CreatedAt_Read = {
  __typename?: 'LegalFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_CreatedAt_Update = {
  __typename?: 'LegalFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_CreatedBy = {
  __typename?: 'LegalFields_createdBy'
  create?: Maybe<LegalFields_CreatedBy_Create>
  delete?: Maybe<LegalFields_CreatedBy_Delete>
  read?: Maybe<LegalFields_CreatedBy_Read>
  update?: Maybe<LegalFields_CreatedBy_Update>
}

export type LegalFields_CreatedBy_Create = {
  __typename?: 'LegalFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_CreatedBy_Delete = {
  __typename?: 'LegalFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_CreatedBy_Read = {
  __typename?: 'LegalFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_CreatedBy_Update = {
  __typename?: 'LegalFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Description = {
  __typename?: 'LegalFields_description'
  create?: Maybe<LegalFields_Description_Create>
  delete?: Maybe<LegalFields_Description_Delete>
  read?: Maybe<LegalFields_Description_Read>
  update?: Maybe<LegalFields_Description_Update>
}

export type LegalFields_Description_Create = {
  __typename?: 'LegalFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Description_Delete = {
  __typename?: 'LegalFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Description_Read = {
  __typename?: 'LegalFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Description_Update = {
  __typename?: 'LegalFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_RichText = {
  __typename?: 'LegalFields_richText'
  create?: Maybe<LegalFields_RichText_Create>
  delete?: Maybe<LegalFields_RichText_Delete>
  read?: Maybe<LegalFields_RichText_Read>
  update?: Maybe<LegalFields_RichText_Update>
}

export type LegalFields_RichText_Create = {
  __typename?: 'LegalFields_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_RichText_Delete = {
  __typename?: 'LegalFields_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_RichText_Read = {
  __typename?: 'LegalFields_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_RichText_Update = {
  __typename?: 'LegalFields_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Slug = {
  __typename?: 'LegalFields_slug'
  create?: Maybe<LegalFields_Slug_Create>
  delete?: Maybe<LegalFields_Slug_Delete>
  read?: Maybe<LegalFields_Slug_Read>
  update?: Maybe<LegalFields_Slug_Update>
}

export type LegalFields_Slug_Create = {
  __typename?: 'LegalFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Slug_Delete = {
  __typename?: 'LegalFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Slug_Read = {
  __typename?: 'LegalFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Slug_Update = {
  __typename?: 'LegalFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Title = {
  __typename?: 'LegalFields_title'
  create?: Maybe<LegalFields_Title_Create>
  delete?: Maybe<LegalFields_Title_Delete>
  read?: Maybe<LegalFields_Title_Read>
  update?: Maybe<LegalFields_Title_Update>
}

export type LegalFields_Title_Create = {
  __typename?: 'LegalFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Title_Delete = {
  __typename?: 'LegalFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Title_Read = {
  __typename?: 'LegalFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_Title_Update = {
  __typename?: 'LegalFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_UpdatedAt = {
  __typename?: 'LegalFields_updatedAt'
  create?: Maybe<LegalFields_UpdatedAt_Create>
  delete?: Maybe<LegalFields_UpdatedAt_Delete>
  read?: Maybe<LegalFields_UpdatedAt_Read>
  update?: Maybe<LegalFields_UpdatedAt_Update>
}

export type LegalFields_UpdatedAt_Create = {
  __typename?: 'LegalFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_UpdatedAt_Delete = {
  __typename?: 'LegalFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_UpdatedAt_Read = {
  __typename?: 'LegalFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LegalFields_UpdatedAt_Update = {
  __typename?: 'LegalFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LegalReadAccess = {
  __typename?: 'LegalReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalReadDocAccess = {
  __typename?: 'LegalReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalUpdateAccess = {
  __typename?: 'LegalUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LegalUpdateDocAccess = {
  __typename?: 'LegalUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksCreateAccess = {
  __typename?: 'LinksCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksCreateDocAccess = {
  __typename?: 'LinksCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksDeleteAccess = {
  __typename?: 'LinksDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksDeleteDocAccess = {
  __typename?: 'LinksDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksDocAccessFields = {
  __typename?: 'LinksDocAccessFields'
  createdAt?: Maybe<LinksDocAccessFields_CreatedAt>
  title?: Maybe<LinksDocAccessFields_Title>
  updatedAt?: Maybe<LinksDocAccessFields_UpdatedAt>
  url?: Maybe<LinksDocAccessFields_Url>
}

export type LinksDocAccessFields_CreatedAt = {
  __typename?: 'LinksDocAccessFields_createdAt'
  create?: Maybe<LinksDocAccessFields_CreatedAt_Create>
  delete?: Maybe<LinksDocAccessFields_CreatedAt_Delete>
  read?: Maybe<LinksDocAccessFields_CreatedAt_Read>
  update?: Maybe<LinksDocAccessFields_CreatedAt_Update>
}

export type LinksDocAccessFields_CreatedAt_Create = {
  __typename?: 'LinksDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_CreatedAt_Delete = {
  __typename?: 'LinksDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_CreatedAt_Read = {
  __typename?: 'LinksDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_CreatedAt_Update = {
  __typename?: 'LinksDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Title = {
  __typename?: 'LinksDocAccessFields_title'
  create?: Maybe<LinksDocAccessFields_Title_Create>
  delete?: Maybe<LinksDocAccessFields_Title_Delete>
  read?: Maybe<LinksDocAccessFields_Title_Read>
  update?: Maybe<LinksDocAccessFields_Title_Update>
}

export type LinksDocAccessFields_Title_Create = {
  __typename?: 'LinksDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Title_Delete = {
  __typename?: 'LinksDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Title_Read = {
  __typename?: 'LinksDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Title_Update = {
  __typename?: 'LinksDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_UpdatedAt = {
  __typename?: 'LinksDocAccessFields_updatedAt'
  create?: Maybe<LinksDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<LinksDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<LinksDocAccessFields_UpdatedAt_Read>
  update?: Maybe<LinksDocAccessFields_UpdatedAt_Update>
}

export type LinksDocAccessFields_UpdatedAt_Create = {
  __typename?: 'LinksDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'LinksDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_UpdatedAt_Read = {
  __typename?: 'LinksDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_UpdatedAt_Update = {
  __typename?: 'LinksDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Url = {
  __typename?: 'LinksDocAccessFields_url'
  create?: Maybe<LinksDocAccessFields_Url_Create>
  delete?: Maybe<LinksDocAccessFields_Url_Delete>
  read?: Maybe<LinksDocAccessFields_Url_Read>
  update?: Maybe<LinksDocAccessFields_Url_Update>
}

export type LinksDocAccessFields_Url_Create = {
  __typename?: 'LinksDocAccessFields_url_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Url_Delete = {
  __typename?: 'LinksDocAccessFields_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Url_Read = {
  __typename?: 'LinksDocAccessFields_url_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksDocAccessFields_Url_Update = {
  __typename?: 'LinksDocAccessFields_url_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksFields = {
  __typename?: 'LinksFields'
  createdAt?: Maybe<LinksFields_CreatedAt>
  title?: Maybe<LinksFields_Title>
  updatedAt?: Maybe<LinksFields_UpdatedAt>
  url?: Maybe<LinksFields_Url>
}

export type LinksFields_CreatedAt = {
  __typename?: 'LinksFields_createdAt'
  create?: Maybe<LinksFields_CreatedAt_Create>
  delete?: Maybe<LinksFields_CreatedAt_Delete>
  read?: Maybe<LinksFields_CreatedAt_Read>
  update?: Maybe<LinksFields_CreatedAt_Update>
}

export type LinksFields_CreatedAt_Create = {
  __typename?: 'LinksFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_CreatedAt_Delete = {
  __typename?: 'LinksFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_CreatedAt_Read = {
  __typename?: 'LinksFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_CreatedAt_Update = {
  __typename?: 'LinksFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Title = {
  __typename?: 'LinksFields_title'
  create?: Maybe<LinksFields_Title_Create>
  delete?: Maybe<LinksFields_Title_Delete>
  read?: Maybe<LinksFields_Title_Read>
  update?: Maybe<LinksFields_Title_Update>
}

export type LinksFields_Title_Create = {
  __typename?: 'LinksFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Title_Delete = {
  __typename?: 'LinksFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Title_Read = {
  __typename?: 'LinksFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Title_Update = {
  __typename?: 'LinksFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_UpdatedAt = {
  __typename?: 'LinksFields_updatedAt'
  create?: Maybe<LinksFields_UpdatedAt_Create>
  delete?: Maybe<LinksFields_UpdatedAt_Delete>
  read?: Maybe<LinksFields_UpdatedAt_Read>
  update?: Maybe<LinksFields_UpdatedAt_Update>
}

export type LinksFields_UpdatedAt_Create = {
  __typename?: 'LinksFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_UpdatedAt_Delete = {
  __typename?: 'LinksFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_UpdatedAt_Read = {
  __typename?: 'LinksFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_UpdatedAt_Update = {
  __typename?: 'LinksFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Url = {
  __typename?: 'LinksFields_url'
  create?: Maybe<LinksFields_Url_Create>
  delete?: Maybe<LinksFields_Url_Delete>
  read?: Maybe<LinksFields_Url_Read>
  update?: Maybe<LinksFields_Url_Update>
}

export type LinksFields_Url_Create = {
  __typename?: 'LinksFields_url_Create'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Url_Delete = {
  __typename?: 'LinksFields_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Url_Read = {
  __typename?: 'LinksFields_url_Read'
  permission: Scalars['Boolean']['output']
}

export type LinksFields_Url_Update = {
  __typename?: 'LinksFields_url_Update'
  permission: Scalars['Boolean']['output']
}

export type LinksReadAccess = {
  __typename?: 'LinksReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksReadDocAccess = {
  __typename?: 'LinksReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksUpdateAccess = {
  __typename?: 'LinksUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LinksUpdateDocAccess = {
  __typename?: 'LinksUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedCreateAccess = {
  __typename?: 'LiteEmbeddedCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedCreateDocAccess = {
  __typename?: 'LiteEmbeddedCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedDeleteAccess = {
  __typename?: 'LiteEmbeddedDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedDeleteDocAccess = {
  __typename?: 'LiteEmbeddedDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedDocAccessFields = {
  __typename?: 'LiteEmbeddedDocAccessFields'
  _status?: Maybe<LiteEmbeddedDocAccessFields__Status>
  affiliateCode?: Maybe<LiteEmbeddedDocAccessFields_AffiliateCode>
  createdAt?: Maybe<LiteEmbeddedDocAccessFields_CreatedAt>
  createdBy?: Maybe<LiteEmbeddedDocAccessFields_CreatedBy>
  logo?: Maybe<LiteEmbeddedDocAccessFields_Logo>
  logoHref?: Maybe<LiteEmbeddedDocAccessFields_LogoHref>
  meta?: Maybe<LiteEmbeddedDocAccessFields_Meta>
  offerCategories?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories>
  publishedAt?: Maybe<LiteEmbeddedDocAccessFields_PublishedAt>
  slug?: Maybe<LiteEmbeddedDocAccessFields_Slug>
  title?: Maybe<LiteEmbeddedDocAccessFields_Title>
  updatedAt?: Maybe<LiteEmbeddedDocAccessFields_UpdatedAt>
}

export type LiteEmbeddedDocAccessFields__Status = {
  __typename?: 'LiteEmbeddedDocAccessFields__status'
  create?: Maybe<LiteEmbeddedDocAccessFields__Status_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields__Status_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields__Status_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields__Status_Update>
}

export type LiteEmbeddedDocAccessFields__Status_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields__Status_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields__Status_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields__Status_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_AffiliateCode = {
  __typename?: 'LiteEmbeddedDocAccessFields_affiliateCode'
  create?: Maybe<LiteEmbeddedDocAccessFields_AffiliateCode_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_AffiliateCode_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_AffiliateCode_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_AffiliateCode_Update>
}

export type LiteEmbeddedDocAccessFields_AffiliateCode_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_affiliateCode_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_AffiliateCode_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_affiliateCode_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_AffiliateCode_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_affiliateCode_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_AffiliateCode_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_affiliateCode_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedAt = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdAt'
  create?: Maybe<LiteEmbeddedDocAccessFields_CreatedAt_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_CreatedAt_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_CreatedAt_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_CreatedAt_Update>
}

export type LiteEmbeddedDocAccessFields_CreatedAt_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedAt_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedAt_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedAt_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedBy = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdBy'
  create?: Maybe<LiteEmbeddedDocAccessFields_CreatedBy_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_CreatedBy_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_CreatedBy_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_CreatedBy_Update>
}

export type LiteEmbeddedDocAccessFields_CreatedBy_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedBy_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedBy_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_CreatedBy_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Logo = {
  __typename?: 'LiteEmbeddedDocAccessFields_logo'
  create?: Maybe<LiteEmbeddedDocAccessFields_Logo_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Logo_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Logo_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Logo_Update>
}

export type LiteEmbeddedDocAccessFields_LogoHref = {
  __typename?: 'LiteEmbeddedDocAccessFields_logoHref'
  create?: Maybe<LiteEmbeddedDocAccessFields_LogoHref_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_LogoHref_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_LogoHref_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_LogoHref_Update>
}

export type LiteEmbeddedDocAccessFields_LogoHref_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_logoHref_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_LogoHref_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_logoHref_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_LogoHref_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_logoHref_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_LogoHref_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_logoHref_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Logo_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_logo_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Logo_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_logo_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Logo_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_logo_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Logo_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_logo_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta'
  create?: Maybe<LiteEmbeddedDocAccessFields_Meta_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Meta_Delete>
  fields?: Maybe<LiteEmbeddedDocAccessFields_Meta_Fields>
  read?: Maybe<LiteEmbeddedDocAccessFields_Meta_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Meta_Update>
}

export type LiteEmbeddedDocAccessFields_Meta_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Fields = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_Fields'
  description?: Maybe<LiteEmbeddedDocAccessFields_Meta_Description>
  image?: Maybe<LiteEmbeddedDocAccessFields_Meta_Image>
  jsonLD?: Maybe<LiteEmbeddedDocAccessFields_Meta_JsonLd>
  noIndex?: Maybe<LiteEmbeddedDocAccessFields_Meta_NoIndex>
  title?: Maybe<LiteEmbeddedDocAccessFields_Meta_Title>
}

export type LiteEmbeddedDocAccessFields_Meta_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Description = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_description'
  create?: Maybe<LiteEmbeddedDocAccessFields_Meta_Description_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Meta_Description_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Meta_Description_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Meta_Description_Update>
}

export type LiteEmbeddedDocAccessFields_Meta_Description_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Description_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Description_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Description_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Image = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_image'
  create?: Maybe<LiteEmbeddedDocAccessFields_Meta_Image_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Meta_Image_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Meta_Image_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Meta_Image_Update>
}

export type LiteEmbeddedDocAccessFields_Meta_Image_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Image_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Image_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Image_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_JsonLd = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_jsonLD'
  create?: Maybe<LiteEmbeddedDocAccessFields_Meta_JsonLd_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Meta_JsonLd_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Meta_JsonLd_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Meta_JsonLd_Update>
}

export type LiteEmbeddedDocAccessFields_Meta_JsonLd_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_JsonLd_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_JsonLd_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_JsonLd_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_NoIndex = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_noIndex'
  create?: Maybe<LiteEmbeddedDocAccessFields_Meta_NoIndex_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Meta_NoIndex_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Meta_NoIndex_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Meta_NoIndex_Update>
}

export type LiteEmbeddedDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Title = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_title'
  create?: Maybe<LiteEmbeddedDocAccessFields_Meta_Title_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Meta_Title_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Meta_Title_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Meta_Title_Update>
}

export type LiteEmbeddedDocAccessFields_Meta_Title_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Title_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Title_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Meta_Title_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories'
  create?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Delete>
  fields?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Fields>
  read?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Update>
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Fields = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_Fields'
  category?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Category>
  collection?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Collection>
  id?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Id>
  name?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Name>
  slug?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Slug>
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Category = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_category'
  create?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Category_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Category_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Category_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Category_Update>
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Category_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_category_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Category_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_category_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Category_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_category_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Category_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_category_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Collection = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_collection'
  create?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Collection_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Collection_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Collection_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Collection_Update>
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Collection_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_collection_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Collection_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_collection_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Collection_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_collection_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Collection_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_collection_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Id = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_id'
  create?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Id_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Id_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Id_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Id_Update>
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Id_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_id_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Id_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Id_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_id_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Id_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_id_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Name = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_name'
  create?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Name_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Name_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Name_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Name_Update>
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Name_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_name_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Name_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Name_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_name_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Name_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_name_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Slug = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_slug'
  create?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Slug_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Slug_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Slug_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_OfferCategories_Slug_Update>
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Slug_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Slug_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Slug_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_OfferCategories_Slug_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_offerCategories_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_PublishedAt = {
  __typename?: 'LiteEmbeddedDocAccessFields_publishedAt'
  create?: Maybe<LiteEmbeddedDocAccessFields_PublishedAt_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_PublishedAt_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_PublishedAt_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_PublishedAt_Update>
}

export type LiteEmbeddedDocAccessFields_PublishedAt_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_PublishedAt_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_PublishedAt_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_PublishedAt_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Slug = {
  __typename?: 'LiteEmbeddedDocAccessFields_slug'
  create?: Maybe<LiteEmbeddedDocAccessFields_Slug_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Slug_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Slug_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Slug_Update>
}

export type LiteEmbeddedDocAccessFields_Slug_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Slug_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Slug_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Slug_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Title = {
  __typename?: 'LiteEmbeddedDocAccessFields_title'
  create?: Maybe<LiteEmbeddedDocAccessFields_Title_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_Title_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_Title_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_Title_Update>
}

export type LiteEmbeddedDocAccessFields_Title_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Title_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Title_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_Title_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_UpdatedAt = {
  __typename?: 'LiteEmbeddedDocAccessFields_updatedAt'
  create?: Maybe<LiteEmbeddedDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<LiteEmbeddedDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<LiteEmbeddedDocAccessFields_UpdatedAt_Read>
  update?: Maybe<LiteEmbeddedDocAccessFields_UpdatedAt_Update>
}

export type LiteEmbeddedDocAccessFields_UpdatedAt_Create = {
  __typename?: 'LiteEmbeddedDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'LiteEmbeddedDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_UpdatedAt_Read = {
  __typename?: 'LiteEmbeddedDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedDocAccessFields_UpdatedAt_Update = {
  __typename?: 'LiteEmbeddedDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields = {
  __typename?: 'LiteEmbeddedFields'
  _status?: Maybe<LiteEmbeddedFields__Status>
  affiliateCode?: Maybe<LiteEmbeddedFields_AffiliateCode>
  createdAt?: Maybe<LiteEmbeddedFields_CreatedAt>
  createdBy?: Maybe<LiteEmbeddedFields_CreatedBy>
  logo?: Maybe<LiteEmbeddedFields_Logo>
  logoHref?: Maybe<LiteEmbeddedFields_LogoHref>
  meta?: Maybe<LiteEmbeddedFields_Meta>
  offerCategories?: Maybe<LiteEmbeddedFields_OfferCategories>
  publishedAt?: Maybe<LiteEmbeddedFields_PublishedAt>
  slug?: Maybe<LiteEmbeddedFields_Slug>
  title?: Maybe<LiteEmbeddedFields_Title>
  updatedAt?: Maybe<LiteEmbeddedFields_UpdatedAt>
}

export type LiteEmbeddedFields__Status = {
  __typename?: 'LiteEmbeddedFields__status'
  create?: Maybe<LiteEmbeddedFields__Status_Create>
  delete?: Maybe<LiteEmbeddedFields__Status_Delete>
  read?: Maybe<LiteEmbeddedFields__Status_Read>
  update?: Maybe<LiteEmbeddedFields__Status_Update>
}

export type LiteEmbeddedFields__Status_Create = {
  __typename?: 'LiteEmbeddedFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields__Status_Delete = {
  __typename?: 'LiteEmbeddedFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields__Status_Read = {
  __typename?: 'LiteEmbeddedFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields__Status_Update = {
  __typename?: 'LiteEmbeddedFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_AffiliateCode = {
  __typename?: 'LiteEmbeddedFields_affiliateCode'
  create?: Maybe<LiteEmbeddedFields_AffiliateCode_Create>
  delete?: Maybe<LiteEmbeddedFields_AffiliateCode_Delete>
  read?: Maybe<LiteEmbeddedFields_AffiliateCode_Read>
  update?: Maybe<LiteEmbeddedFields_AffiliateCode_Update>
}

export type LiteEmbeddedFields_AffiliateCode_Create = {
  __typename?: 'LiteEmbeddedFields_affiliateCode_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_AffiliateCode_Delete = {
  __typename?: 'LiteEmbeddedFields_affiliateCode_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_AffiliateCode_Read = {
  __typename?: 'LiteEmbeddedFields_affiliateCode_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_AffiliateCode_Update = {
  __typename?: 'LiteEmbeddedFields_affiliateCode_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedAt = {
  __typename?: 'LiteEmbeddedFields_createdAt'
  create?: Maybe<LiteEmbeddedFields_CreatedAt_Create>
  delete?: Maybe<LiteEmbeddedFields_CreatedAt_Delete>
  read?: Maybe<LiteEmbeddedFields_CreatedAt_Read>
  update?: Maybe<LiteEmbeddedFields_CreatedAt_Update>
}

export type LiteEmbeddedFields_CreatedAt_Create = {
  __typename?: 'LiteEmbeddedFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedAt_Delete = {
  __typename?: 'LiteEmbeddedFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedAt_Read = {
  __typename?: 'LiteEmbeddedFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedAt_Update = {
  __typename?: 'LiteEmbeddedFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedBy = {
  __typename?: 'LiteEmbeddedFields_createdBy'
  create?: Maybe<LiteEmbeddedFields_CreatedBy_Create>
  delete?: Maybe<LiteEmbeddedFields_CreatedBy_Delete>
  read?: Maybe<LiteEmbeddedFields_CreatedBy_Read>
  update?: Maybe<LiteEmbeddedFields_CreatedBy_Update>
}

export type LiteEmbeddedFields_CreatedBy_Create = {
  __typename?: 'LiteEmbeddedFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedBy_Delete = {
  __typename?: 'LiteEmbeddedFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedBy_Read = {
  __typename?: 'LiteEmbeddedFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_CreatedBy_Update = {
  __typename?: 'LiteEmbeddedFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Logo = {
  __typename?: 'LiteEmbeddedFields_logo'
  create?: Maybe<LiteEmbeddedFields_Logo_Create>
  delete?: Maybe<LiteEmbeddedFields_Logo_Delete>
  read?: Maybe<LiteEmbeddedFields_Logo_Read>
  update?: Maybe<LiteEmbeddedFields_Logo_Update>
}

export type LiteEmbeddedFields_LogoHref = {
  __typename?: 'LiteEmbeddedFields_logoHref'
  create?: Maybe<LiteEmbeddedFields_LogoHref_Create>
  delete?: Maybe<LiteEmbeddedFields_LogoHref_Delete>
  read?: Maybe<LiteEmbeddedFields_LogoHref_Read>
  update?: Maybe<LiteEmbeddedFields_LogoHref_Update>
}

export type LiteEmbeddedFields_LogoHref_Create = {
  __typename?: 'LiteEmbeddedFields_logoHref_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_LogoHref_Delete = {
  __typename?: 'LiteEmbeddedFields_logoHref_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_LogoHref_Read = {
  __typename?: 'LiteEmbeddedFields_logoHref_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_LogoHref_Update = {
  __typename?: 'LiteEmbeddedFields_logoHref_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Logo_Create = {
  __typename?: 'LiteEmbeddedFields_logo_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Logo_Delete = {
  __typename?: 'LiteEmbeddedFields_logo_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Logo_Read = {
  __typename?: 'LiteEmbeddedFields_logo_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Logo_Update = {
  __typename?: 'LiteEmbeddedFields_logo_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta = {
  __typename?: 'LiteEmbeddedFields_meta'
  create?: Maybe<LiteEmbeddedFields_Meta_Create>
  delete?: Maybe<LiteEmbeddedFields_Meta_Delete>
  fields?: Maybe<LiteEmbeddedFields_Meta_Fields>
  read?: Maybe<LiteEmbeddedFields_Meta_Read>
  update?: Maybe<LiteEmbeddedFields_Meta_Update>
}

export type LiteEmbeddedFields_Meta_Create = {
  __typename?: 'LiteEmbeddedFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Delete = {
  __typename?: 'LiteEmbeddedFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Fields = {
  __typename?: 'LiteEmbeddedFields_meta_Fields'
  description?: Maybe<LiteEmbeddedFields_Meta_Description>
  image?: Maybe<LiteEmbeddedFields_Meta_Image>
  jsonLD?: Maybe<LiteEmbeddedFields_Meta_JsonLd>
  noIndex?: Maybe<LiteEmbeddedFields_Meta_NoIndex>
  title?: Maybe<LiteEmbeddedFields_Meta_Title>
}

export type LiteEmbeddedFields_Meta_Read = {
  __typename?: 'LiteEmbeddedFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Update = {
  __typename?: 'LiteEmbeddedFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Description = {
  __typename?: 'LiteEmbeddedFields_meta_description'
  create?: Maybe<LiteEmbeddedFields_Meta_Description_Create>
  delete?: Maybe<LiteEmbeddedFields_Meta_Description_Delete>
  read?: Maybe<LiteEmbeddedFields_Meta_Description_Read>
  update?: Maybe<LiteEmbeddedFields_Meta_Description_Update>
}

export type LiteEmbeddedFields_Meta_Description_Create = {
  __typename?: 'LiteEmbeddedFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Description_Delete = {
  __typename?: 'LiteEmbeddedFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Description_Read = {
  __typename?: 'LiteEmbeddedFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Description_Update = {
  __typename?: 'LiteEmbeddedFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Image = {
  __typename?: 'LiteEmbeddedFields_meta_image'
  create?: Maybe<LiteEmbeddedFields_Meta_Image_Create>
  delete?: Maybe<LiteEmbeddedFields_Meta_Image_Delete>
  read?: Maybe<LiteEmbeddedFields_Meta_Image_Read>
  update?: Maybe<LiteEmbeddedFields_Meta_Image_Update>
}

export type LiteEmbeddedFields_Meta_Image_Create = {
  __typename?: 'LiteEmbeddedFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Image_Delete = {
  __typename?: 'LiteEmbeddedFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Image_Read = {
  __typename?: 'LiteEmbeddedFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Image_Update = {
  __typename?: 'LiteEmbeddedFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_JsonLd = {
  __typename?: 'LiteEmbeddedFields_meta_jsonLD'
  create?: Maybe<LiteEmbeddedFields_Meta_JsonLd_Create>
  delete?: Maybe<LiteEmbeddedFields_Meta_JsonLd_Delete>
  read?: Maybe<LiteEmbeddedFields_Meta_JsonLd_Read>
  update?: Maybe<LiteEmbeddedFields_Meta_JsonLd_Update>
}

export type LiteEmbeddedFields_Meta_JsonLd_Create = {
  __typename?: 'LiteEmbeddedFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_JsonLd_Delete = {
  __typename?: 'LiteEmbeddedFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_JsonLd_Read = {
  __typename?: 'LiteEmbeddedFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_JsonLd_Update = {
  __typename?: 'LiteEmbeddedFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_NoIndex = {
  __typename?: 'LiteEmbeddedFields_meta_noIndex'
  create?: Maybe<LiteEmbeddedFields_Meta_NoIndex_Create>
  delete?: Maybe<LiteEmbeddedFields_Meta_NoIndex_Delete>
  read?: Maybe<LiteEmbeddedFields_Meta_NoIndex_Read>
  update?: Maybe<LiteEmbeddedFields_Meta_NoIndex_Update>
}

export type LiteEmbeddedFields_Meta_NoIndex_Create = {
  __typename?: 'LiteEmbeddedFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_NoIndex_Delete = {
  __typename?: 'LiteEmbeddedFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_NoIndex_Read = {
  __typename?: 'LiteEmbeddedFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_NoIndex_Update = {
  __typename?: 'LiteEmbeddedFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Title = {
  __typename?: 'LiteEmbeddedFields_meta_title'
  create?: Maybe<LiteEmbeddedFields_Meta_Title_Create>
  delete?: Maybe<LiteEmbeddedFields_Meta_Title_Delete>
  read?: Maybe<LiteEmbeddedFields_Meta_Title_Read>
  update?: Maybe<LiteEmbeddedFields_Meta_Title_Update>
}

export type LiteEmbeddedFields_Meta_Title_Create = {
  __typename?: 'LiteEmbeddedFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Title_Delete = {
  __typename?: 'LiteEmbeddedFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Title_Read = {
  __typename?: 'LiteEmbeddedFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Meta_Title_Update = {
  __typename?: 'LiteEmbeddedFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories = {
  __typename?: 'LiteEmbeddedFields_offerCategories'
  create?: Maybe<LiteEmbeddedFields_OfferCategories_Create>
  delete?: Maybe<LiteEmbeddedFields_OfferCategories_Delete>
  fields?: Maybe<LiteEmbeddedFields_OfferCategories_Fields>
  read?: Maybe<LiteEmbeddedFields_OfferCategories_Read>
  update?: Maybe<LiteEmbeddedFields_OfferCategories_Update>
}

export type LiteEmbeddedFields_OfferCategories_Create = {
  __typename?: 'LiteEmbeddedFields_offerCategories_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Delete = {
  __typename?: 'LiteEmbeddedFields_offerCategories_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Fields = {
  __typename?: 'LiteEmbeddedFields_offerCategories_Fields'
  category?: Maybe<LiteEmbeddedFields_OfferCategories_Category>
  collection?: Maybe<LiteEmbeddedFields_OfferCategories_Collection>
  id?: Maybe<LiteEmbeddedFields_OfferCategories_Id>
  name?: Maybe<LiteEmbeddedFields_OfferCategories_Name>
  slug?: Maybe<LiteEmbeddedFields_OfferCategories_Slug>
}

export type LiteEmbeddedFields_OfferCategories_Read = {
  __typename?: 'LiteEmbeddedFields_offerCategories_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Update = {
  __typename?: 'LiteEmbeddedFields_offerCategories_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Category = {
  __typename?: 'LiteEmbeddedFields_offerCategories_category'
  create?: Maybe<LiteEmbeddedFields_OfferCategories_Category_Create>
  delete?: Maybe<LiteEmbeddedFields_OfferCategories_Category_Delete>
  read?: Maybe<LiteEmbeddedFields_OfferCategories_Category_Read>
  update?: Maybe<LiteEmbeddedFields_OfferCategories_Category_Update>
}

export type LiteEmbeddedFields_OfferCategories_Category_Create = {
  __typename?: 'LiteEmbeddedFields_offerCategories_category_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Category_Delete = {
  __typename?: 'LiteEmbeddedFields_offerCategories_category_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Category_Read = {
  __typename?: 'LiteEmbeddedFields_offerCategories_category_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Category_Update = {
  __typename?: 'LiteEmbeddedFields_offerCategories_category_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Collection = {
  __typename?: 'LiteEmbeddedFields_offerCategories_collection'
  create?: Maybe<LiteEmbeddedFields_OfferCategories_Collection_Create>
  delete?: Maybe<LiteEmbeddedFields_OfferCategories_Collection_Delete>
  read?: Maybe<LiteEmbeddedFields_OfferCategories_Collection_Read>
  update?: Maybe<LiteEmbeddedFields_OfferCategories_Collection_Update>
}

export type LiteEmbeddedFields_OfferCategories_Collection_Create = {
  __typename?: 'LiteEmbeddedFields_offerCategories_collection_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Collection_Delete = {
  __typename?: 'LiteEmbeddedFields_offerCategories_collection_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Collection_Read = {
  __typename?: 'LiteEmbeddedFields_offerCategories_collection_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Collection_Update = {
  __typename?: 'LiteEmbeddedFields_offerCategories_collection_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Id = {
  __typename?: 'LiteEmbeddedFields_offerCategories_id'
  create?: Maybe<LiteEmbeddedFields_OfferCategories_Id_Create>
  delete?: Maybe<LiteEmbeddedFields_OfferCategories_Id_Delete>
  read?: Maybe<LiteEmbeddedFields_OfferCategories_Id_Read>
  update?: Maybe<LiteEmbeddedFields_OfferCategories_Id_Update>
}

export type LiteEmbeddedFields_OfferCategories_Id_Create = {
  __typename?: 'LiteEmbeddedFields_offerCategories_id_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Id_Delete = {
  __typename?: 'LiteEmbeddedFields_offerCategories_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Id_Read = {
  __typename?: 'LiteEmbeddedFields_offerCategories_id_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Id_Update = {
  __typename?: 'LiteEmbeddedFields_offerCategories_id_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Name = {
  __typename?: 'LiteEmbeddedFields_offerCategories_name'
  create?: Maybe<LiteEmbeddedFields_OfferCategories_Name_Create>
  delete?: Maybe<LiteEmbeddedFields_OfferCategories_Name_Delete>
  read?: Maybe<LiteEmbeddedFields_OfferCategories_Name_Read>
  update?: Maybe<LiteEmbeddedFields_OfferCategories_Name_Update>
}

export type LiteEmbeddedFields_OfferCategories_Name_Create = {
  __typename?: 'LiteEmbeddedFields_offerCategories_name_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Name_Delete = {
  __typename?: 'LiteEmbeddedFields_offerCategories_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Name_Read = {
  __typename?: 'LiteEmbeddedFields_offerCategories_name_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Name_Update = {
  __typename?: 'LiteEmbeddedFields_offerCategories_name_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Slug = {
  __typename?: 'LiteEmbeddedFields_offerCategories_slug'
  create?: Maybe<LiteEmbeddedFields_OfferCategories_Slug_Create>
  delete?: Maybe<LiteEmbeddedFields_OfferCategories_Slug_Delete>
  read?: Maybe<LiteEmbeddedFields_OfferCategories_Slug_Read>
  update?: Maybe<LiteEmbeddedFields_OfferCategories_Slug_Update>
}

export type LiteEmbeddedFields_OfferCategories_Slug_Create = {
  __typename?: 'LiteEmbeddedFields_offerCategories_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Slug_Delete = {
  __typename?: 'LiteEmbeddedFields_offerCategories_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Slug_Read = {
  __typename?: 'LiteEmbeddedFields_offerCategories_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_OfferCategories_Slug_Update = {
  __typename?: 'LiteEmbeddedFields_offerCategories_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_PublishedAt = {
  __typename?: 'LiteEmbeddedFields_publishedAt'
  create?: Maybe<LiteEmbeddedFields_PublishedAt_Create>
  delete?: Maybe<LiteEmbeddedFields_PublishedAt_Delete>
  read?: Maybe<LiteEmbeddedFields_PublishedAt_Read>
  update?: Maybe<LiteEmbeddedFields_PublishedAt_Update>
}

export type LiteEmbeddedFields_PublishedAt_Create = {
  __typename?: 'LiteEmbeddedFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_PublishedAt_Delete = {
  __typename?: 'LiteEmbeddedFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_PublishedAt_Read = {
  __typename?: 'LiteEmbeddedFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_PublishedAt_Update = {
  __typename?: 'LiteEmbeddedFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Slug = {
  __typename?: 'LiteEmbeddedFields_slug'
  create?: Maybe<LiteEmbeddedFields_Slug_Create>
  delete?: Maybe<LiteEmbeddedFields_Slug_Delete>
  read?: Maybe<LiteEmbeddedFields_Slug_Read>
  update?: Maybe<LiteEmbeddedFields_Slug_Update>
}

export type LiteEmbeddedFields_Slug_Create = {
  __typename?: 'LiteEmbeddedFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Slug_Delete = {
  __typename?: 'LiteEmbeddedFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Slug_Read = {
  __typename?: 'LiteEmbeddedFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Slug_Update = {
  __typename?: 'LiteEmbeddedFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Title = {
  __typename?: 'LiteEmbeddedFields_title'
  create?: Maybe<LiteEmbeddedFields_Title_Create>
  delete?: Maybe<LiteEmbeddedFields_Title_Delete>
  read?: Maybe<LiteEmbeddedFields_Title_Read>
  update?: Maybe<LiteEmbeddedFields_Title_Update>
}

export type LiteEmbeddedFields_Title_Create = {
  __typename?: 'LiteEmbeddedFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Title_Delete = {
  __typename?: 'LiteEmbeddedFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Title_Read = {
  __typename?: 'LiteEmbeddedFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_Title_Update = {
  __typename?: 'LiteEmbeddedFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_UpdatedAt = {
  __typename?: 'LiteEmbeddedFields_updatedAt'
  create?: Maybe<LiteEmbeddedFields_UpdatedAt_Create>
  delete?: Maybe<LiteEmbeddedFields_UpdatedAt_Delete>
  read?: Maybe<LiteEmbeddedFields_UpdatedAt_Read>
  update?: Maybe<LiteEmbeddedFields_UpdatedAt_Update>
}

export type LiteEmbeddedFields_UpdatedAt_Create = {
  __typename?: 'LiteEmbeddedFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_UpdatedAt_Delete = {
  __typename?: 'LiteEmbeddedFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_UpdatedAt_Read = {
  __typename?: 'LiteEmbeddedFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedFields_UpdatedAt_Update = {
  __typename?: 'LiteEmbeddedFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type LiteEmbeddedReadAccess = {
  __typename?: 'LiteEmbeddedReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedReadDocAccess = {
  __typename?: 'LiteEmbeddedReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedReadVersionsAccess = {
  __typename?: 'LiteEmbeddedReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedReadVersionsDocAccess = {
  __typename?: 'LiteEmbeddedReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedUpdateAccess = {
  __typename?: 'LiteEmbeddedUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type LiteEmbeddedUpdateDocAccess = {
  __typename?: 'LiteEmbeddedUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceCreateAccess = {
  __typename?: 'MarketplaceCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceCreateDocAccess = {
  __typename?: 'MarketplaceCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceDeleteAccess = {
  __typename?: 'MarketplaceDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceDeleteDocAccess = {
  __typename?: 'MarketplaceDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceDocAccessFields = {
  __typename?: 'MarketplaceDocAccessFields'
  _status?: Maybe<MarketplaceDocAccessFields__Status>
  breadcrumbs?: Maybe<MarketplaceDocAccessFields_Breadcrumbs>
  createdAt?: Maybe<MarketplaceDocAccessFields_CreatedAt>
  createdBy?: Maybe<MarketplaceDocAccessFields_CreatedBy>
  customFooter?: Maybe<MarketplaceDocAccessFields_CustomFooter>
  customHeader?: Maybe<MarketplaceDocAccessFields_CustomHeader>
  hero?: Maybe<MarketplaceDocAccessFields_Hero>
  layout?: Maybe<MarketplaceDocAccessFields_Layout>
  meta?: Maybe<MarketplaceDocAccessFields_Meta>
  offerCategory?: Maybe<MarketplaceDocAccessFields_OfferCategory>
  parent?: Maybe<MarketplaceDocAccessFields_Parent>
  publishedAt?: Maybe<MarketplaceDocAccessFields_PublishedAt>
  slug?: Maybe<MarketplaceDocAccessFields_Slug>
  title?: Maybe<MarketplaceDocAccessFields_Title>
  updatedAt?: Maybe<MarketplaceDocAccessFields_UpdatedAt>
}

export type MarketplaceDocAccessFields__Status = {
  __typename?: 'MarketplaceDocAccessFields__status'
  create?: Maybe<MarketplaceDocAccessFields__Status_Create>
  delete?: Maybe<MarketplaceDocAccessFields__Status_Delete>
  read?: Maybe<MarketplaceDocAccessFields__Status_Read>
  update?: Maybe<MarketplaceDocAccessFields__Status_Update>
}

export type MarketplaceDocAccessFields__Status_Create = {
  __typename?: 'MarketplaceDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields__Status_Delete = {
  __typename?: 'MarketplaceDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields__Status_Read = {
  __typename?: 'MarketplaceDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields__Status_Update = {
  __typename?: 'MarketplaceDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs'
  create?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Fields>
  read?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Read>
  update?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Update>
}

export type MarketplaceDocAccessFields_Breadcrumbs_Create = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Delete = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Fields = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_Fields'
  doc?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Doc>
  id?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Id>
  label?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Label>
  url?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Url>
}

export type MarketplaceDocAccessFields_Breadcrumbs_Read = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Update = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Doc = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_doc'
  create?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Doc_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Doc_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Doc_Read>
  update?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Doc_Update>
}

export type MarketplaceDocAccessFields_Breadcrumbs_Doc_Create = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_doc_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_doc_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Doc_Read = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_doc_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Doc_Update = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_doc_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Id = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_id'
  create?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Id_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Id_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Id_Read>
  update?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Id_Update>
}

export type MarketplaceDocAccessFields_Breadcrumbs_Id_Create = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Id_Delete = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Id_Read = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Id_Update = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Label = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_label'
  create?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Label_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Label_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Label_Read>
  update?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Label_Update>
}

export type MarketplaceDocAccessFields_Breadcrumbs_Label_Create = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_label_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Label_Delete = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Label_Read = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_label_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Label_Update = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_label_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Url = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_url'
  create?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Url_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Url_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Url_Read>
  update?: Maybe<MarketplaceDocAccessFields_Breadcrumbs_Url_Update>
}

export type MarketplaceDocAccessFields_Breadcrumbs_Url_Create = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Url_Delete = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Url_Read = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Breadcrumbs_Url_Update = {
  __typename?: 'MarketplaceDocAccessFields_breadcrumbs_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedAt = {
  __typename?: 'MarketplaceDocAccessFields_createdAt'
  create?: Maybe<MarketplaceDocAccessFields_CreatedAt_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CreatedAt_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CreatedAt_Read>
  update?: Maybe<MarketplaceDocAccessFields_CreatedAt_Update>
}

export type MarketplaceDocAccessFields_CreatedAt_Create = {
  __typename?: 'MarketplaceDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedAt_Delete = {
  __typename?: 'MarketplaceDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedAt_Read = {
  __typename?: 'MarketplaceDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedAt_Update = {
  __typename?: 'MarketplaceDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedBy = {
  __typename?: 'MarketplaceDocAccessFields_createdBy'
  create?: Maybe<MarketplaceDocAccessFields_CreatedBy_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CreatedBy_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CreatedBy_Read>
  update?: Maybe<MarketplaceDocAccessFields_CreatedBy_Update>
}

export type MarketplaceDocAccessFields_CreatedBy_Create = {
  __typename?: 'MarketplaceDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedBy_Delete = {
  __typename?: 'MarketplaceDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedBy_Read = {
  __typename?: 'MarketplaceDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CreatedBy_Update = {
  __typename?: 'MarketplaceDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter = {
  __typename?: 'MarketplaceDocAccessFields_customFooter'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomFooter_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_Fields'
  disclaimers?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<MarketplaceDocAccessFields_CustomFooter_IsHidden>
}

export type MarketplaceDocAccessFields_CustomFooter_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_Fields'
  align?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text>
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_align'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_id'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_number'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_text'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_IsHidden = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_isHidden'
  create?: Maybe<MarketplaceDocAccessFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomFooter_IsHidden_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomFooter_IsHidden_Update>
}

export type MarketplaceDocAccessFields_CustomFooter_IsHidden_Create = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_IsHidden_Read = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomFooter_IsHidden_Update = {
  __typename?: 'MarketplaceDocAccessFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader = {
  __typename?: 'MarketplaceDocAccessFields_customHeader'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomHeader_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_Fields'
  headerDisplay?: Maybe<MarketplaceDocAccessFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<MarketplaceDocAccessFields_CustomHeader_IsHidden>
  loginLink?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink>
  signupLink?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink>
  supportLink?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink>
}

export type MarketplaceDocAccessFields_CustomHeader_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_HeaderDisplay = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_headerDisplay'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_IsHidden = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_isHidden'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_IsHidden_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_IsHidden_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_IsHidden_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_IsHidden_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_IsHidden_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_Fields'
  newTab?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Type>
  url?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Url>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_newTab'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_Fields'
  id?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_id'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_key'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_value'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reference'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reusable'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_targetId'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Type = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_type'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Url = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_url'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_Fields'
  newTab?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Type>
  url?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Url>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_newTab'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_Fields'
  id?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_id'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_key'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_value'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reference'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reusable'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_targetId'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Type = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_type'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Url = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_url'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_Fields'
  newTab?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Type>
  url?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Url>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_newTab'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_Fields'
  id?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_id'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_key'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_value'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reference'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reusable'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_targetId'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Type = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_type'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Url = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_url'
  create?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Update>
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'MarketplaceDocAccessFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero = {
  __typename?: 'MarketplaceDocAccessFields_hero'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_Hero_Fields>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Update>
}

export type MarketplaceDocAccessFields_Hero_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Fields = {
  __typename?: 'MarketplaceDocAccessFields_hero_Fields'
  desktopFallback?: Maybe<MarketplaceDocAccessFields_Hero_DesktopFallback>
  desktopVideo?: Maybe<MarketplaceDocAccessFields_Hero_DesktopVideo>
  disclaimerText?: Maybe<MarketplaceDocAccessFields_Hero_DisclaimerText>
  heroSize?: Maybe<MarketplaceDocAccessFields_Hero_HeroSize>
  hzAlign?: Maybe<MarketplaceDocAccessFields_Hero_HzAlign>
  links?: Maybe<MarketplaceDocAccessFields_Hero_Links>
  media?: Maybe<MarketplaceDocAccessFields_Hero_Media>
  mobileFallback?: Maybe<MarketplaceDocAccessFields_Hero_MobileFallback>
  mobileVideo?: Maybe<MarketplaceDocAccessFields_Hero_MobileVideo>
  productImage?: Maybe<MarketplaceDocAccessFields_Hero_ProductImage>
  reviewRating?: Maybe<MarketplaceDocAccessFields_Hero_ReviewRating>
  reviewText?: Maybe<MarketplaceDocAccessFields_Hero_ReviewText>
  richText?: Maybe<MarketplaceDocAccessFields_Hero_RichText>
  richTextMax?: Maybe<MarketplaceDocAccessFields_Hero_RichTextMax>
  showReviews?: Maybe<MarketplaceDocAccessFields_Hero_ShowReviews>
  type?: Maybe<MarketplaceDocAccessFields_Hero_Type>
  vertAlign?: Maybe<MarketplaceDocAccessFields_Hero_VertAlign>
}

export type MarketplaceDocAccessFields_Hero_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopFallback = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopFallback'
  create?: Maybe<MarketplaceDocAccessFields_Hero_DesktopFallback_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_DesktopFallback_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_DesktopFallback_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_DesktopFallback_Update>
}

export type MarketplaceDocAccessFields_Hero_DesktopFallback_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopFallback_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopFallback_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopFallback_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopVideo = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopVideo'
  create?: Maybe<MarketplaceDocAccessFields_Hero_DesktopVideo_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_DesktopVideo_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_DesktopVideo_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_DesktopVideo_Update>
}

export type MarketplaceDocAccessFields_Hero_DesktopVideo_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopVideo_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopVideo_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DesktopVideo_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_desktopVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DisclaimerText = {
  __typename?: 'MarketplaceDocAccessFields_hero_disclaimerText'
  create?: Maybe<MarketplaceDocAccessFields_Hero_DisclaimerText_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_DisclaimerText_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_DisclaimerText_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_DisclaimerText_Update>
}

export type MarketplaceDocAccessFields_Hero_DisclaimerText_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_disclaimerText_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DisclaimerText_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_disclaimerText_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DisclaimerText_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_disclaimerText_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_DisclaimerText_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_disclaimerText_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HeroSize = {
  __typename?: 'MarketplaceDocAccessFields_hero_heroSize'
  create?: Maybe<MarketplaceDocAccessFields_Hero_HeroSize_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_HeroSize_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_HeroSize_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_HeroSize_Update>
}

export type MarketplaceDocAccessFields_Hero_HeroSize_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_heroSize_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HeroSize_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_heroSize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HeroSize_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_heroSize_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HeroSize_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_heroSize_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HzAlign = {
  __typename?: 'MarketplaceDocAccessFields_hero_hzAlign'
  create?: Maybe<MarketplaceDocAccessFields_Hero_HzAlign_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_HzAlign_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_HzAlign_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_HzAlign_Update>
}

export type MarketplaceDocAccessFields_Hero_HzAlign_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_hzAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HzAlign_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_hzAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HzAlign_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_hzAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_HzAlign_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_hzAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links = {
  __typename?: 'MarketplaceDocAccessFields_hero_links'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_Hero_Links_Fields>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Fields = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_Fields'
  id?: Maybe<MarketplaceDocAccessFields_Hero_Links_Id>
  link?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link>
}

export type MarketplaceDocAccessFields_Hero_Links_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Id = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_id'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Id_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Id_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Id_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Id_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Id_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Id_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Id_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Id_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Fields>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Fields = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_Fields'
  iconAfter?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconAfter>
  iconBefore?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconBefore>
  label?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Label>
  newTab?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_NewTab>
  query?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query>
  reference?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reference>
  reusable?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reusable>
  targetId?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_TargetId>
  type?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Type>
  url?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Url>
  variant?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Variant>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconAfter = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconAfter'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconAfter_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconBefore = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconBefore'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_IconBefore_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Label = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_label'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Label_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Label_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Label_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Label_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Label_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Label_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Label_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Label_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_NewTab = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_newTab'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_NewTab_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Fields>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Fields = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_Fields'
  id?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Id>
  key?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Key>
  value?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Value>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Id = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_id'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Id_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Key = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_key'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Key_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Value = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_value'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Query_Value_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reference = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reference'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reference_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reference_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reference_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reference_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reference_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reference_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reference_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reference_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reusable = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reusable'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Reusable_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_TargetId = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_targetId'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_TargetId_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Type = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_type'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Type_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Type_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Type_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Type_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Type_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Type_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Type_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Type_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Url = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_url'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Url_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Url_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Url_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Url_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Url_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Url_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Url_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Url_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Variant = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_variant'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Variant_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Variant_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Variant_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Links_Link_Variant_Update>
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Variant_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Variant_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Variant_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Links_Link_Variant_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Media = {
  __typename?: 'MarketplaceDocAccessFields_hero_media'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Media_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Media_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Media_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Media_Update>
}

export type MarketplaceDocAccessFields_Hero_Media_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_media_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Media_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Media_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_media_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Media_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_media_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileFallback = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileFallback'
  create?: Maybe<MarketplaceDocAccessFields_Hero_MobileFallback_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_MobileFallback_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_MobileFallback_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_MobileFallback_Update>
}

export type MarketplaceDocAccessFields_Hero_MobileFallback_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileFallback_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileFallback_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileFallback_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileVideo = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileVideo'
  create?: Maybe<MarketplaceDocAccessFields_Hero_MobileVideo_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_MobileVideo_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_MobileVideo_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_MobileVideo_Update>
}

export type MarketplaceDocAccessFields_Hero_MobileVideo_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileVideo_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileVideo_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_MobileVideo_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_mobileVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ProductImage = {
  __typename?: 'MarketplaceDocAccessFields_hero_productImage'
  create?: Maybe<MarketplaceDocAccessFields_Hero_ProductImage_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_ProductImage_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_ProductImage_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_ProductImage_Update>
}

export type MarketplaceDocAccessFields_Hero_ProductImage_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_productImage_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ProductImage_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_productImage_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ProductImage_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_productImage_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ProductImage_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_productImage_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewRating = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewRating'
  create?: Maybe<MarketplaceDocAccessFields_Hero_ReviewRating_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_ReviewRating_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_ReviewRating_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_ReviewRating_Update>
}

export type MarketplaceDocAccessFields_Hero_ReviewRating_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewRating_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewRating_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewRating_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewRating_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewRating_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewRating_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewRating_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewText = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewText'
  create?: Maybe<MarketplaceDocAccessFields_Hero_ReviewText_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_ReviewText_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_ReviewText_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_ReviewText_Update>
}

export type MarketplaceDocAccessFields_Hero_ReviewText_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewText_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewText_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewText_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewText_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewText_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ReviewText_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_reviewText_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichText = {
  __typename?: 'MarketplaceDocAccessFields_hero_richText'
  create?: Maybe<MarketplaceDocAccessFields_Hero_RichText_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_RichText_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_RichText_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_RichText_Update>
}

export type MarketplaceDocAccessFields_Hero_RichTextMax = {
  __typename?: 'MarketplaceDocAccessFields_hero_richTextMax'
  create?: Maybe<MarketplaceDocAccessFields_Hero_RichTextMax_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_RichTextMax_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_RichTextMax_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_RichTextMax_Update>
}

export type MarketplaceDocAccessFields_Hero_RichTextMax_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_richTextMax_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichTextMax_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_richTextMax_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichTextMax_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_richTextMax_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichTextMax_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_richTextMax_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichText_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichText_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichText_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_RichText_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ShowReviews = {
  __typename?: 'MarketplaceDocAccessFields_hero_showReviews'
  create?: Maybe<MarketplaceDocAccessFields_Hero_ShowReviews_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_ShowReviews_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_ShowReviews_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_ShowReviews_Update>
}

export type MarketplaceDocAccessFields_Hero_ShowReviews_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_showReviews_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ShowReviews_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_showReviews_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ShowReviews_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_showReviews_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_ShowReviews_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_showReviews_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Type = {
  __typename?: 'MarketplaceDocAccessFields_hero_type'
  create?: Maybe<MarketplaceDocAccessFields_Hero_Type_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_Type_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_Type_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_Type_Update>
}

export type MarketplaceDocAccessFields_Hero_Type_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Type_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Type_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_Type_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_VertAlign = {
  __typename?: 'MarketplaceDocAccessFields_hero_vertAlign'
  create?: Maybe<MarketplaceDocAccessFields_Hero_VertAlign_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Hero_VertAlign_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Hero_VertAlign_Read>
  update?: Maybe<MarketplaceDocAccessFields_Hero_VertAlign_Update>
}

export type MarketplaceDocAccessFields_Hero_VertAlign_Create = {
  __typename?: 'MarketplaceDocAccessFields_hero_vertAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_VertAlign_Delete = {
  __typename?: 'MarketplaceDocAccessFields_hero_vertAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_VertAlign_Read = {
  __typename?: 'MarketplaceDocAccessFields_hero_vertAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Hero_VertAlign_Update = {
  __typename?: 'MarketplaceDocAccessFields_hero_vertAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Layout = {
  __typename?: 'MarketplaceDocAccessFields_layout'
  create?: Maybe<MarketplaceDocAccessFields_Layout_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Layout_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Layout_Read>
  update?: Maybe<MarketplaceDocAccessFields_Layout_Update>
}

export type MarketplaceDocAccessFields_Layout_Create = {
  __typename?: 'MarketplaceDocAccessFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Layout_Delete = {
  __typename?: 'MarketplaceDocAccessFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Layout_Read = {
  __typename?: 'MarketplaceDocAccessFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Layout_Update = {
  __typename?: 'MarketplaceDocAccessFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta = {
  __typename?: 'MarketplaceDocAccessFields_meta'
  create?: Maybe<MarketplaceDocAccessFields_Meta_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Meta_Delete>
  fields?: Maybe<MarketplaceDocAccessFields_Meta_Fields>
  read?: Maybe<MarketplaceDocAccessFields_Meta_Read>
  update?: Maybe<MarketplaceDocAccessFields_Meta_Update>
}

export type MarketplaceDocAccessFields_Meta_Create = {
  __typename?: 'MarketplaceDocAccessFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Delete = {
  __typename?: 'MarketplaceDocAccessFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Fields = {
  __typename?: 'MarketplaceDocAccessFields_meta_Fields'
  description?: Maybe<MarketplaceDocAccessFields_Meta_Description>
  image?: Maybe<MarketplaceDocAccessFields_Meta_Image>
  jsonLD?: Maybe<MarketplaceDocAccessFields_Meta_JsonLd>
  noIndex?: Maybe<MarketplaceDocAccessFields_Meta_NoIndex>
  title?: Maybe<MarketplaceDocAccessFields_Meta_Title>
}

export type MarketplaceDocAccessFields_Meta_Read = {
  __typename?: 'MarketplaceDocAccessFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Update = {
  __typename?: 'MarketplaceDocAccessFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Description = {
  __typename?: 'MarketplaceDocAccessFields_meta_description'
  create?: Maybe<MarketplaceDocAccessFields_Meta_Description_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Meta_Description_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Meta_Description_Read>
  update?: Maybe<MarketplaceDocAccessFields_Meta_Description_Update>
}

export type MarketplaceDocAccessFields_Meta_Description_Create = {
  __typename?: 'MarketplaceDocAccessFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Description_Delete = {
  __typename?: 'MarketplaceDocAccessFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Description_Read = {
  __typename?: 'MarketplaceDocAccessFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Description_Update = {
  __typename?: 'MarketplaceDocAccessFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Image = {
  __typename?: 'MarketplaceDocAccessFields_meta_image'
  create?: Maybe<MarketplaceDocAccessFields_Meta_Image_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Meta_Image_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Meta_Image_Read>
  update?: Maybe<MarketplaceDocAccessFields_Meta_Image_Update>
}

export type MarketplaceDocAccessFields_Meta_Image_Create = {
  __typename?: 'MarketplaceDocAccessFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Image_Delete = {
  __typename?: 'MarketplaceDocAccessFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Image_Read = {
  __typename?: 'MarketplaceDocAccessFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Image_Update = {
  __typename?: 'MarketplaceDocAccessFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_JsonLd = {
  __typename?: 'MarketplaceDocAccessFields_meta_jsonLD'
  create?: Maybe<MarketplaceDocAccessFields_Meta_JsonLd_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Meta_JsonLd_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Meta_JsonLd_Read>
  update?: Maybe<MarketplaceDocAccessFields_Meta_JsonLd_Update>
}

export type MarketplaceDocAccessFields_Meta_JsonLd_Create = {
  __typename?: 'MarketplaceDocAccessFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_JsonLd_Delete = {
  __typename?: 'MarketplaceDocAccessFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_JsonLd_Read = {
  __typename?: 'MarketplaceDocAccessFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_JsonLd_Update = {
  __typename?: 'MarketplaceDocAccessFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_NoIndex = {
  __typename?: 'MarketplaceDocAccessFields_meta_noIndex'
  create?: Maybe<MarketplaceDocAccessFields_Meta_NoIndex_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Meta_NoIndex_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Meta_NoIndex_Read>
  update?: Maybe<MarketplaceDocAccessFields_Meta_NoIndex_Update>
}

export type MarketplaceDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'MarketplaceDocAccessFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'MarketplaceDocAccessFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'MarketplaceDocAccessFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'MarketplaceDocAccessFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Title = {
  __typename?: 'MarketplaceDocAccessFields_meta_title'
  create?: Maybe<MarketplaceDocAccessFields_Meta_Title_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Meta_Title_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Meta_Title_Read>
  update?: Maybe<MarketplaceDocAccessFields_Meta_Title_Update>
}

export type MarketplaceDocAccessFields_Meta_Title_Create = {
  __typename?: 'MarketplaceDocAccessFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Title_Delete = {
  __typename?: 'MarketplaceDocAccessFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Title_Read = {
  __typename?: 'MarketplaceDocAccessFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Meta_Title_Update = {
  __typename?: 'MarketplaceDocAccessFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_OfferCategory = {
  __typename?: 'MarketplaceDocAccessFields_offerCategory'
  create?: Maybe<MarketplaceDocAccessFields_OfferCategory_Create>
  delete?: Maybe<MarketplaceDocAccessFields_OfferCategory_Delete>
  read?: Maybe<MarketplaceDocAccessFields_OfferCategory_Read>
  update?: Maybe<MarketplaceDocAccessFields_OfferCategory_Update>
}

export type MarketplaceDocAccessFields_OfferCategory_Create = {
  __typename?: 'MarketplaceDocAccessFields_offerCategory_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_OfferCategory_Delete = {
  __typename?: 'MarketplaceDocAccessFields_offerCategory_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_OfferCategory_Read = {
  __typename?: 'MarketplaceDocAccessFields_offerCategory_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_OfferCategory_Update = {
  __typename?: 'MarketplaceDocAccessFields_offerCategory_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Parent = {
  __typename?: 'MarketplaceDocAccessFields_parent'
  create?: Maybe<MarketplaceDocAccessFields_Parent_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Parent_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Parent_Read>
  update?: Maybe<MarketplaceDocAccessFields_Parent_Update>
}

export type MarketplaceDocAccessFields_Parent_Create = {
  __typename?: 'MarketplaceDocAccessFields_parent_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Parent_Delete = {
  __typename?: 'MarketplaceDocAccessFields_parent_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Parent_Read = {
  __typename?: 'MarketplaceDocAccessFields_parent_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Parent_Update = {
  __typename?: 'MarketplaceDocAccessFields_parent_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_PublishedAt = {
  __typename?: 'MarketplaceDocAccessFields_publishedAt'
  create?: Maybe<MarketplaceDocAccessFields_PublishedAt_Create>
  delete?: Maybe<MarketplaceDocAccessFields_PublishedAt_Delete>
  read?: Maybe<MarketplaceDocAccessFields_PublishedAt_Read>
  update?: Maybe<MarketplaceDocAccessFields_PublishedAt_Update>
}

export type MarketplaceDocAccessFields_PublishedAt_Create = {
  __typename?: 'MarketplaceDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_PublishedAt_Delete = {
  __typename?: 'MarketplaceDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_PublishedAt_Read = {
  __typename?: 'MarketplaceDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_PublishedAt_Update = {
  __typename?: 'MarketplaceDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Slug = {
  __typename?: 'MarketplaceDocAccessFields_slug'
  create?: Maybe<MarketplaceDocAccessFields_Slug_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Slug_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Slug_Read>
  update?: Maybe<MarketplaceDocAccessFields_Slug_Update>
}

export type MarketplaceDocAccessFields_Slug_Create = {
  __typename?: 'MarketplaceDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Slug_Delete = {
  __typename?: 'MarketplaceDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Slug_Read = {
  __typename?: 'MarketplaceDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Slug_Update = {
  __typename?: 'MarketplaceDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Title = {
  __typename?: 'MarketplaceDocAccessFields_title'
  create?: Maybe<MarketplaceDocAccessFields_Title_Create>
  delete?: Maybe<MarketplaceDocAccessFields_Title_Delete>
  read?: Maybe<MarketplaceDocAccessFields_Title_Read>
  update?: Maybe<MarketplaceDocAccessFields_Title_Update>
}

export type MarketplaceDocAccessFields_Title_Create = {
  __typename?: 'MarketplaceDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Title_Delete = {
  __typename?: 'MarketplaceDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Title_Read = {
  __typename?: 'MarketplaceDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_Title_Update = {
  __typename?: 'MarketplaceDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_UpdatedAt = {
  __typename?: 'MarketplaceDocAccessFields_updatedAt'
  create?: Maybe<MarketplaceDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<MarketplaceDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<MarketplaceDocAccessFields_UpdatedAt_Read>
  update?: Maybe<MarketplaceDocAccessFields_UpdatedAt_Update>
}

export type MarketplaceDocAccessFields_UpdatedAt_Create = {
  __typename?: 'MarketplaceDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'MarketplaceDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_UpdatedAt_Read = {
  __typename?: 'MarketplaceDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceDocAccessFields_UpdatedAt_Update = {
  __typename?: 'MarketplaceDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields = {
  __typename?: 'MarketplaceFields'
  _status?: Maybe<MarketplaceFields__Status>
  breadcrumbs?: Maybe<MarketplaceFields_Breadcrumbs>
  createdAt?: Maybe<MarketplaceFields_CreatedAt>
  createdBy?: Maybe<MarketplaceFields_CreatedBy>
  customFooter?: Maybe<MarketplaceFields_CustomFooter>
  customHeader?: Maybe<MarketplaceFields_CustomHeader>
  hero?: Maybe<MarketplaceFields_Hero>
  layout?: Maybe<MarketplaceFields_Layout>
  meta?: Maybe<MarketplaceFields_Meta>
  offerCategory?: Maybe<MarketplaceFields_OfferCategory>
  parent?: Maybe<MarketplaceFields_Parent>
  publishedAt?: Maybe<MarketplaceFields_PublishedAt>
  slug?: Maybe<MarketplaceFields_Slug>
  title?: Maybe<MarketplaceFields_Title>
  updatedAt?: Maybe<MarketplaceFields_UpdatedAt>
}

export type MarketplaceFields__Status = {
  __typename?: 'MarketplaceFields__status'
  create?: Maybe<MarketplaceFields__Status_Create>
  delete?: Maybe<MarketplaceFields__Status_Delete>
  read?: Maybe<MarketplaceFields__Status_Read>
  update?: Maybe<MarketplaceFields__Status_Update>
}

export type MarketplaceFields__Status_Create = {
  __typename?: 'MarketplaceFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields__Status_Delete = {
  __typename?: 'MarketplaceFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields__Status_Read = {
  __typename?: 'MarketplaceFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields__Status_Update = {
  __typename?: 'MarketplaceFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs = {
  __typename?: 'MarketplaceFields_breadcrumbs'
  create?: Maybe<MarketplaceFields_Breadcrumbs_Create>
  delete?: Maybe<MarketplaceFields_Breadcrumbs_Delete>
  fields?: Maybe<MarketplaceFields_Breadcrumbs_Fields>
  read?: Maybe<MarketplaceFields_Breadcrumbs_Read>
  update?: Maybe<MarketplaceFields_Breadcrumbs_Update>
}

export type MarketplaceFields_Breadcrumbs_Create = {
  __typename?: 'MarketplaceFields_breadcrumbs_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Delete = {
  __typename?: 'MarketplaceFields_breadcrumbs_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Fields = {
  __typename?: 'MarketplaceFields_breadcrumbs_Fields'
  doc?: Maybe<MarketplaceFields_Breadcrumbs_Doc>
  id?: Maybe<MarketplaceFields_Breadcrumbs_Id>
  label?: Maybe<MarketplaceFields_Breadcrumbs_Label>
  url?: Maybe<MarketplaceFields_Breadcrumbs_Url>
}

export type MarketplaceFields_Breadcrumbs_Read = {
  __typename?: 'MarketplaceFields_breadcrumbs_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Update = {
  __typename?: 'MarketplaceFields_breadcrumbs_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Doc = {
  __typename?: 'MarketplaceFields_breadcrumbs_doc'
  create?: Maybe<MarketplaceFields_Breadcrumbs_Doc_Create>
  delete?: Maybe<MarketplaceFields_Breadcrumbs_Doc_Delete>
  read?: Maybe<MarketplaceFields_Breadcrumbs_Doc_Read>
  update?: Maybe<MarketplaceFields_Breadcrumbs_Doc_Update>
}

export type MarketplaceFields_Breadcrumbs_Doc_Create = {
  __typename?: 'MarketplaceFields_breadcrumbs_doc_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'MarketplaceFields_breadcrumbs_doc_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Doc_Read = {
  __typename?: 'MarketplaceFields_breadcrumbs_doc_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Doc_Update = {
  __typename?: 'MarketplaceFields_breadcrumbs_doc_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Id = {
  __typename?: 'MarketplaceFields_breadcrumbs_id'
  create?: Maybe<MarketplaceFields_Breadcrumbs_Id_Create>
  delete?: Maybe<MarketplaceFields_Breadcrumbs_Id_Delete>
  read?: Maybe<MarketplaceFields_Breadcrumbs_Id_Read>
  update?: Maybe<MarketplaceFields_Breadcrumbs_Id_Update>
}

export type MarketplaceFields_Breadcrumbs_Id_Create = {
  __typename?: 'MarketplaceFields_breadcrumbs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Id_Delete = {
  __typename?: 'MarketplaceFields_breadcrumbs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Id_Read = {
  __typename?: 'MarketplaceFields_breadcrumbs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Id_Update = {
  __typename?: 'MarketplaceFields_breadcrumbs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Label = {
  __typename?: 'MarketplaceFields_breadcrumbs_label'
  create?: Maybe<MarketplaceFields_Breadcrumbs_Label_Create>
  delete?: Maybe<MarketplaceFields_Breadcrumbs_Label_Delete>
  read?: Maybe<MarketplaceFields_Breadcrumbs_Label_Read>
  update?: Maybe<MarketplaceFields_Breadcrumbs_Label_Update>
}

export type MarketplaceFields_Breadcrumbs_Label_Create = {
  __typename?: 'MarketplaceFields_breadcrumbs_label_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Label_Delete = {
  __typename?: 'MarketplaceFields_breadcrumbs_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Label_Read = {
  __typename?: 'MarketplaceFields_breadcrumbs_label_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Label_Update = {
  __typename?: 'MarketplaceFields_breadcrumbs_label_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Url = {
  __typename?: 'MarketplaceFields_breadcrumbs_url'
  create?: Maybe<MarketplaceFields_Breadcrumbs_Url_Create>
  delete?: Maybe<MarketplaceFields_Breadcrumbs_Url_Delete>
  read?: Maybe<MarketplaceFields_Breadcrumbs_Url_Read>
  update?: Maybe<MarketplaceFields_Breadcrumbs_Url_Update>
}

export type MarketplaceFields_Breadcrumbs_Url_Create = {
  __typename?: 'MarketplaceFields_breadcrumbs_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Url_Delete = {
  __typename?: 'MarketplaceFields_breadcrumbs_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Url_Read = {
  __typename?: 'MarketplaceFields_breadcrumbs_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Breadcrumbs_Url_Update = {
  __typename?: 'MarketplaceFields_breadcrumbs_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedAt = {
  __typename?: 'MarketplaceFields_createdAt'
  create?: Maybe<MarketplaceFields_CreatedAt_Create>
  delete?: Maybe<MarketplaceFields_CreatedAt_Delete>
  read?: Maybe<MarketplaceFields_CreatedAt_Read>
  update?: Maybe<MarketplaceFields_CreatedAt_Update>
}

export type MarketplaceFields_CreatedAt_Create = {
  __typename?: 'MarketplaceFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedAt_Delete = {
  __typename?: 'MarketplaceFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedAt_Read = {
  __typename?: 'MarketplaceFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedAt_Update = {
  __typename?: 'MarketplaceFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedBy = {
  __typename?: 'MarketplaceFields_createdBy'
  create?: Maybe<MarketplaceFields_CreatedBy_Create>
  delete?: Maybe<MarketplaceFields_CreatedBy_Delete>
  read?: Maybe<MarketplaceFields_CreatedBy_Read>
  update?: Maybe<MarketplaceFields_CreatedBy_Update>
}

export type MarketplaceFields_CreatedBy_Create = {
  __typename?: 'MarketplaceFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedBy_Delete = {
  __typename?: 'MarketplaceFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedBy_Read = {
  __typename?: 'MarketplaceFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CreatedBy_Update = {
  __typename?: 'MarketplaceFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter = {
  __typename?: 'MarketplaceFields_customFooter'
  create?: Maybe<MarketplaceFields_CustomFooter_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_Delete>
  fields?: Maybe<MarketplaceFields_CustomFooter_Fields>
  read?: Maybe<MarketplaceFields_CustomFooter_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_Update>
}

export type MarketplaceFields_CustomFooter_Create = {
  __typename?: 'MarketplaceFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Delete = {
  __typename?: 'MarketplaceFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Fields = {
  __typename?: 'MarketplaceFields_customFooter_Fields'
  disclaimers?: Maybe<MarketplaceFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<MarketplaceFields_CustomFooter_IsHidden>
}

export type MarketplaceFields_CustomFooter_Read = {
  __typename?: 'MarketplaceFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Update = {
  __typename?: 'MarketplaceFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers'
  create?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Update>
}

export type MarketplaceFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_Fields'
  align?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Text>
}

export type MarketplaceFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_align'
  create?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Align_Update>
}

export type MarketplaceFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_id'
  create?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Id_Update>
}

export type MarketplaceFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_number'
  create?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Number_Update>
}

export type MarketplaceFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_text'
  create?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_Disclaimers_Text_Update>
}

export type MarketplaceFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'MarketplaceFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_IsHidden = {
  __typename?: 'MarketplaceFields_customFooter_isHidden'
  create?: Maybe<MarketplaceFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<MarketplaceFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<MarketplaceFields_CustomFooter_IsHidden_Read>
  update?: Maybe<MarketplaceFields_CustomFooter_IsHidden_Update>
}

export type MarketplaceFields_CustomFooter_IsHidden_Create = {
  __typename?: 'MarketplaceFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'MarketplaceFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_IsHidden_Read = {
  __typename?: 'MarketplaceFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomFooter_IsHidden_Update = {
  __typename?: 'MarketplaceFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader = {
  __typename?: 'MarketplaceFields_customHeader'
  create?: Maybe<MarketplaceFields_CustomHeader_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_Delete>
  fields?: Maybe<MarketplaceFields_CustomHeader_Fields>
  read?: Maybe<MarketplaceFields_CustomHeader_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_Update>
}

export type MarketplaceFields_CustomHeader_Create = {
  __typename?: 'MarketplaceFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_Delete = {
  __typename?: 'MarketplaceFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_Fields = {
  __typename?: 'MarketplaceFields_customHeader_Fields'
  headerDisplay?: Maybe<MarketplaceFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<MarketplaceFields_CustomHeader_IsHidden>
  loginLink?: Maybe<MarketplaceFields_CustomHeader_LoginLink>
  signupLink?: Maybe<MarketplaceFields_CustomHeader_SignupLink>
  supportLink?: Maybe<MarketplaceFields_CustomHeader_SupportLink>
}

export type MarketplaceFields_CustomHeader_Read = {
  __typename?: 'MarketplaceFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_Update = {
  __typename?: 'MarketplaceFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_HeaderDisplay = {
  __typename?: 'MarketplaceFields_customHeader_headerDisplay'
  create?: Maybe<MarketplaceFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_HeaderDisplay_Update>
}

export type MarketplaceFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'MarketplaceFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'MarketplaceFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'MarketplaceFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'MarketplaceFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_IsHidden = {
  __typename?: 'MarketplaceFields_customHeader_isHidden'
  create?: Maybe<MarketplaceFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_IsHidden_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_IsHidden_Update>
}

export type MarketplaceFields_CustomHeader_IsHidden_Create = {
  __typename?: 'MarketplaceFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'MarketplaceFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_IsHidden_Read = {
  __typename?: 'MarketplaceFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_IsHidden_Update = {
  __typename?: 'MarketplaceFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink = {
  __typename?: 'MarketplaceFields_customHeader_loginLink'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_Fields'
  newTab?: Maybe<MarketplaceFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<MarketplaceFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Type>
  url?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Url>
}

export type MarketplaceFields_CustomHeader_LoginLink_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_newTab'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_NewTab_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_Fields'
  id?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Value>
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_id'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_key'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_value'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reference'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reference_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reusable'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Reusable_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_targetId'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_TargetId_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Type = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_type'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Type_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Url = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_url'
  create?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_LoginLink_Url_Update>
}

export type MarketplaceFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'MarketplaceFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink = {
  __typename?: 'MarketplaceFields_customHeader_signupLink'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_Fields'
  newTab?: Maybe<MarketplaceFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<MarketplaceFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Type>
  url?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Url>
}

export type MarketplaceFields_CustomHeader_SignupLink_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_newTab'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_NewTab_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_Fields'
  id?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Value>
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_id'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_key'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_value'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reference'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reference_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reusable'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Reusable_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_targetId'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_TargetId_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Type = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_type'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Type_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Url = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_url'
  create?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SignupLink_Url_Update>
}

export type MarketplaceFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'MarketplaceFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink = {
  __typename?: 'MarketplaceFields_customHeader_supportLink'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_Fields'
  newTab?: Maybe<MarketplaceFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<MarketplaceFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Type>
  url?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Url>
}

export type MarketplaceFields_CustomHeader_SupportLink_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_newTab'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_NewTab_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_Fields'
  id?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Value>
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_id'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_key'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_value'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reference'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reference_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reusable'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Reusable_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_targetId'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_TargetId_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Type = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_type'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Type_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Url = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_url'
  create?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<MarketplaceFields_CustomHeader_SupportLink_Url_Update>
}

export type MarketplaceFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'MarketplaceFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero = {
  __typename?: 'MarketplaceFields_hero'
  create?: Maybe<MarketplaceFields_Hero_Create>
  delete?: Maybe<MarketplaceFields_Hero_Delete>
  fields?: Maybe<MarketplaceFields_Hero_Fields>
  read?: Maybe<MarketplaceFields_Hero_Read>
  update?: Maybe<MarketplaceFields_Hero_Update>
}

export type MarketplaceFields_Hero_Create = {
  __typename?: 'MarketplaceFields_hero_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Delete = {
  __typename?: 'MarketplaceFields_hero_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Fields = {
  __typename?: 'MarketplaceFields_hero_Fields'
  desktopFallback?: Maybe<MarketplaceFields_Hero_DesktopFallback>
  desktopVideo?: Maybe<MarketplaceFields_Hero_DesktopVideo>
  disclaimerText?: Maybe<MarketplaceFields_Hero_DisclaimerText>
  heroSize?: Maybe<MarketplaceFields_Hero_HeroSize>
  hzAlign?: Maybe<MarketplaceFields_Hero_HzAlign>
  links?: Maybe<MarketplaceFields_Hero_Links>
  media?: Maybe<MarketplaceFields_Hero_Media>
  mobileFallback?: Maybe<MarketplaceFields_Hero_MobileFallback>
  mobileVideo?: Maybe<MarketplaceFields_Hero_MobileVideo>
  productImage?: Maybe<MarketplaceFields_Hero_ProductImage>
  reviewRating?: Maybe<MarketplaceFields_Hero_ReviewRating>
  reviewText?: Maybe<MarketplaceFields_Hero_ReviewText>
  richText?: Maybe<MarketplaceFields_Hero_RichText>
  richTextMax?: Maybe<MarketplaceFields_Hero_RichTextMax>
  showReviews?: Maybe<MarketplaceFields_Hero_ShowReviews>
  type?: Maybe<MarketplaceFields_Hero_Type>
  vertAlign?: Maybe<MarketplaceFields_Hero_VertAlign>
}

export type MarketplaceFields_Hero_Read = {
  __typename?: 'MarketplaceFields_hero_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Update = {
  __typename?: 'MarketplaceFields_hero_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopFallback = {
  __typename?: 'MarketplaceFields_hero_desktopFallback'
  create?: Maybe<MarketplaceFields_Hero_DesktopFallback_Create>
  delete?: Maybe<MarketplaceFields_Hero_DesktopFallback_Delete>
  read?: Maybe<MarketplaceFields_Hero_DesktopFallback_Read>
  update?: Maybe<MarketplaceFields_Hero_DesktopFallback_Update>
}

export type MarketplaceFields_Hero_DesktopFallback_Create = {
  __typename?: 'MarketplaceFields_hero_desktopFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopFallback_Delete = {
  __typename?: 'MarketplaceFields_hero_desktopFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopFallback_Read = {
  __typename?: 'MarketplaceFields_hero_desktopFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopFallback_Update = {
  __typename?: 'MarketplaceFields_hero_desktopFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopVideo = {
  __typename?: 'MarketplaceFields_hero_desktopVideo'
  create?: Maybe<MarketplaceFields_Hero_DesktopVideo_Create>
  delete?: Maybe<MarketplaceFields_Hero_DesktopVideo_Delete>
  read?: Maybe<MarketplaceFields_Hero_DesktopVideo_Read>
  update?: Maybe<MarketplaceFields_Hero_DesktopVideo_Update>
}

export type MarketplaceFields_Hero_DesktopVideo_Create = {
  __typename?: 'MarketplaceFields_hero_desktopVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopVideo_Delete = {
  __typename?: 'MarketplaceFields_hero_desktopVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopVideo_Read = {
  __typename?: 'MarketplaceFields_hero_desktopVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DesktopVideo_Update = {
  __typename?: 'MarketplaceFields_hero_desktopVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DisclaimerText = {
  __typename?: 'MarketplaceFields_hero_disclaimerText'
  create?: Maybe<MarketplaceFields_Hero_DisclaimerText_Create>
  delete?: Maybe<MarketplaceFields_Hero_DisclaimerText_Delete>
  read?: Maybe<MarketplaceFields_Hero_DisclaimerText_Read>
  update?: Maybe<MarketplaceFields_Hero_DisclaimerText_Update>
}

export type MarketplaceFields_Hero_DisclaimerText_Create = {
  __typename?: 'MarketplaceFields_hero_disclaimerText_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DisclaimerText_Delete = {
  __typename?: 'MarketplaceFields_hero_disclaimerText_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DisclaimerText_Read = {
  __typename?: 'MarketplaceFields_hero_disclaimerText_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_DisclaimerText_Update = {
  __typename?: 'MarketplaceFields_hero_disclaimerText_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HeroSize = {
  __typename?: 'MarketplaceFields_hero_heroSize'
  create?: Maybe<MarketplaceFields_Hero_HeroSize_Create>
  delete?: Maybe<MarketplaceFields_Hero_HeroSize_Delete>
  read?: Maybe<MarketplaceFields_Hero_HeroSize_Read>
  update?: Maybe<MarketplaceFields_Hero_HeroSize_Update>
}

export type MarketplaceFields_Hero_HeroSize_Create = {
  __typename?: 'MarketplaceFields_hero_heroSize_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HeroSize_Delete = {
  __typename?: 'MarketplaceFields_hero_heroSize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HeroSize_Read = {
  __typename?: 'MarketplaceFields_hero_heroSize_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HeroSize_Update = {
  __typename?: 'MarketplaceFields_hero_heroSize_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HzAlign = {
  __typename?: 'MarketplaceFields_hero_hzAlign'
  create?: Maybe<MarketplaceFields_Hero_HzAlign_Create>
  delete?: Maybe<MarketplaceFields_Hero_HzAlign_Delete>
  read?: Maybe<MarketplaceFields_Hero_HzAlign_Read>
  update?: Maybe<MarketplaceFields_Hero_HzAlign_Update>
}

export type MarketplaceFields_Hero_HzAlign_Create = {
  __typename?: 'MarketplaceFields_hero_hzAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HzAlign_Delete = {
  __typename?: 'MarketplaceFields_hero_hzAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HzAlign_Read = {
  __typename?: 'MarketplaceFields_hero_hzAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_HzAlign_Update = {
  __typename?: 'MarketplaceFields_hero_hzAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links = {
  __typename?: 'MarketplaceFields_hero_links'
  create?: Maybe<MarketplaceFields_Hero_Links_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Delete>
  fields?: Maybe<MarketplaceFields_Hero_Links_Fields>
  read?: Maybe<MarketplaceFields_Hero_Links_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Update>
}

export type MarketplaceFields_Hero_Links_Create = {
  __typename?: 'MarketplaceFields_hero_links_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Delete = {
  __typename?: 'MarketplaceFields_hero_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Fields = {
  __typename?: 'MarketplaceFields_hero_links_Fields'
  id?: Maybe<MarketplaceFields_Hero_Links_Id>
  link?: Maybe<MarketplaceFields_Hero_Links_Link>
}

export type MarketplaceFields_Hero_Links_Read = {
  __typename?: 'MarketplaceFields_hero_links_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Update = {
  __typename?: 'MarketplaceFields_hero_links_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Id = {
  __typename?: 'MarketplaceFields_hero_links_id'
  create?: Maybe<MarketplaceFields_Hero_Links_Id_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Id_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Id_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Id_Update>
}

export type MarketplaceFields_Hero_Links_Id_Create = {
  __typename?: 'MarketplaceFields_hero_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Id_Delete = {
  __typename?: 'MarketplaceFields_hero_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Id_Read = {
  __typename?: 'MarketplaceFields_hero_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Id_Update = {
  __typename?: 'MarketplaceFields_hero_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link = {
  __typename?: 'MarketplaceFields_hero_links_link'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Delete>
  fields?: Maybe<MarketplaceFields_Hero_Links_Link_Fields>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Update>
}

export type MarketplaceFields_Hero_Links_Link_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Fields = {
  __typename?: 'MarketplaceFields_hero_links_link_Fields'
  iconAfter?: Maybe<MarketplaceFields_Hero_Links_Link_IconAfter>
  iconBefore?: Maybe<MarketplaceFields_Hero_Links_Link_IconBefore>
  label?: Maybe<MarketplaceFields_Hero_Links_Link_Label>
  newTab?: Maybe<MarketplaceFields_Hero_Links_Link_NewTab>
  query?: Maybe<MarketplaceFields_Hero_Links_Link_Query>
  reference?: Maybe<MarketplaceFields_Hero_Links_Link_Reference>
  reusable?: Maybe<MarketplaceFields_Hero_Links_Link_Reusable>
  targetId?: Maybe<MarketplaceFields_Hero_Links_Link_TargetId>
  type?: Maybe<MarketplaceFields_Hero_Links_Link_Type>
  url?: Maybe<MarketplaceFields_Hero_Links_Link_Url>
  variant?: Maybe<MarketplaceFields_Hero_Links_Link_Variant>
}

export type MarketplaceFields_Hero_Links_Link_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconAfter = {
  __typename?: 'MarketplaceFields_hero_links_link_iconAfter'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_IconAfter_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_IconAfter_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_IconAfter_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_IconAfter_Update>
}

export type MarketplaceFields_Hero_Links_Link_IconAfter_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconAfter_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconAfter_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconAfter_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconBefore = {
  __typename?: 'MarketplaceFields_hero_links_link_iconBefore'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_IconBefore_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_IconBefore_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_IconBefore_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_IconBefore_Update>
}

export type MarketplaceFields_Hero_Links_Link_IconBefore_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconBefore_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconBefore_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_IconBefore_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Label = {
  __typename?: 'MarketplaceFields_hero_links_link_label'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Label_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Label_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Label_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Label_Update>
}

export type MarketplaceFields_Hero_Links_Link_Label_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Label_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Label_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Label_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_NewTab = {
  __typename?: 'MarketplaceFields_hero_links_link_newTab'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_NewTab_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_NewTab_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_NewTab_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_NewTab_Update>
}

export type MarketplaceFields_Hero_Links_Link_NewTab_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_NewTab_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_NewTab_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_NewTab_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query = {
  __typename?: 'MarketplaceFields_hero_links_link_query'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Delete>
  fields?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Fields>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Update>
}

export type MarketplaceFields_Hero_Links_Link_Query_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Fields = {
  __typename?: 'MarketplaceFields_hero_links_link_query_Fields'
  id?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Id>
  key?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Key>
  value?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Value>
}

export type MarketplaceFields_Hero_Links_Link_Query_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Id = {
  __typename?: 'MarketplaceFields_hero_links_link_query_id'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Id_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Id_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Id_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Id_Update>
}

export type MarketplaceFields_Hero_Links_Link_Query_Id_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Id_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Id_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Id_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Key = {
  __typename?: 'MarketplaceFields_hero_links_link_query_key'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Key_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Key_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Key_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Key_Update>
}

export type MarketplaceFields_Hero_Links_Link_Query_Key_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Key_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Key_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Key_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Value = {
  __typename?: 'MarketplaceFields_hero_links_link_query_value'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Value_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Value_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Value_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Query_Value_Update>
}

export type MarketplaceFields_Hero_Links_Link_Query_Value_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Value_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Value_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Query_Value_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reference = {
  __typename?: 'MarketplaceFields_hero_links_link_reference'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Reference_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Reference_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Reference_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Reference_Update>
}

export type MarketplaceFields_Hero_Links_Link_Reference_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reference_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reference_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reference_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reusable = {
  __typename?: 'MarketplaceFields_hero_links_link_reusable'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Reusable_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Reusable_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Reusable_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Reusable_Update>
}

export type MarketplaceFields_Hero_Links_Link_Reusable_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reusable_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reusable_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Reusable_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_TargetId = {
  __typename?: 'MarketplaceFields_hero_links_link_targetId'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_TargetId_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_TargetId_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_TargetId_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_TargetId_Update>
}

export type MarketplaceFields_Hero_Links_Link_TargetId_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_TargetId_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_TargetId_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_TargetId_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Type = {
  __typename?: 'MarketplaceFields_hero_links_link_type'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Type_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Type_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Type_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Type_Update>
}

export type MarketplaceFields_Hero_Links_Link_Type_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Type_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Type_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Type_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Url = {
  __typename?: 'MarketplaceFields_hero_links_link_url'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Url_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Url_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Url_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Url_Update>
}

export type MarketplaceFields_Hero_Links_Link_Url_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Url_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Url_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Url_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Variant = {
  __typename?: 'MarketplaceFields_hero_links_link_variant'
  create?: Maybe<MarketplaceFields_Hero_Links_Link_Variant_Create>
  delete?: Maybe<MarketplaceFields_Hero_Links_Link_Variant_Delete>
  read?: Maybe<MarketplaceFields_Hero_Links_Link_Variant_Read>
  update?: Maybe<MarketplaceFields_Hero_Links_Link_Variant_Update>
}

export type MarketplaceFields_Hero_Links_Link_Variant_Create = {
  __typename?: 'MarketplaceFields_hero_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Variant_Delete = {
  __typename?: 'MarketplaceFields_hero_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Variant_Read = {
  __typename?: 'MarketplaceFields_hero_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Links_Link_Variant_Update = {
  __typename?: 'MarketplaceFields_hero_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Media = {
  __typename?: 'MarketplaceFields_hero_media'
  create?: Maybe<MarketplaceFields_Hero_Media_Create>
  delete?: Maybe<MarketplaceFields_Hero_Media_Delete>
  read?: Maybe<MarketplaceFields_Hero_Media_Read>
  update?: Maybe<MarketplaceFields_Hero_Media_Update>
}

export type MarketplaceFields_Hero_Media_Create = {
  __typename?: 'MarketplaceFields_hero_media_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Media_Delete = {
  __typename?: 'MarketplaceFields_hero_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Media_Read = {
  __typename?: 'MarketplaceFields_hero_media_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Media_Update = {
  __typename?: 'MarketplaceFields_hero_media_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileFallback = {
  __typename?: 'MarketplaceFields_hero_mobileFallback'
  create?: Maybe<MarketplaceFields_Hero_MobileFallback_Create>
  delete?: Maybe<MarketplaceFields_Hero_MobileFallback_Delete>
  read?: Maybe<MarketplaceFields_Hero_MobileFallback_Read>
  update?: Maybe<MarketplaceFields_Hero_MobileFallback_Update>
}

export type MarketplaceFields_Hero_MobileFallback_Create = {
  __typename?: 'MarketplaceFields_hero_mobileFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileFallback_Delete = {
  __typename?: 'MarketplaceFields_hero_mobileFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileFallback_Read = {
  __typename?: 'MarketplaceFields_hero_mobileFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileFallback_Update = {
  __typename?: 'MarketplaceFields_hero_mobileFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileVideo = {
  __typename?: 'MarketplaceFields_hero_mobileVideo'
  create?: Maybe<MarketplaceFields_Hero_MobileVideo_Create>
  delete?: Maybe<MarketplaceFields_Hero_MobileVideo_Delete>
  read?: Maybe<MarketplaceFields_Hero_MobileVideo_Read>
  update?: Maybe<MarketplaceFields_Hero_MobileVideo_Update>
}

export type MarketplaceFields_Hero_MobileVideo_Create = {
  __typename?: 'MarketplaceFields_hero_mobileVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileVideo_Delete = {
  __typename?: 'MarketplaceFields_hero_mobileVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileVideo_Read = {
  __typename?: 'MarketplaceFields_hero_mobileVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_MobileVideo_Update = {
  __typename?: 'MarketplaceFields_hero_mobileVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ProductImage = {
  __typename?: 'MarketplaceFields_hero_productImage'
  create?: Maybe<MarketplaceFields_Hero_ProductImage_Create>
  delete?: Maybe<MarketplaceFields_Hero_ProductImage_Delete>
  read?: Maybe<MarketplaceFields_Hero_ProductImage_Read>
  update?: Maybe<MarketplaceFields_Hero_ProductImage_Update>
}

export type MarketplaceFields_Hero_ProductImage_Create = {
  __typename?: 'MarketplaceFields_hero_productImage_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ProductImage_Delete = {
  __typename?: 'MarketplaceFields_hero_productImage_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ProductImage_Read = {
  __typename?: 'MarketplaceFields_hero_productImage_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ProductImage_Update = {
  __typename?: 'MarketplaceFields_hero_productImage_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewRating = {
  __typename?: 'MarketplaceFields_hero_reviewRating'
  create?: Maybe<MarketplaceFields_Hero_ReviewRating_Create>
  delete?: Maybe<MarketplaceFields_Hero_ReviewRating_Delete>
  read?: Maybe<MarketplaceFields_Hero_ReviewRating_Read>
  update?: Maybe<MarketplaceFields_Hero_ReviewRating_Update>
}

export type MarketplaceFields_Hero_ReviewRating_Create = {
  __typename?: 'MarketplaceFields_hero_reviewRating_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewRating_Delete = {
  __typename?: 'MarketplaceFields_hero_reviewRating_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewRating_Read = {
  __typename?: 'MarketplaceFields_hero_reviewRating_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewRating_Update = {
  __typename?: 'MarketplaceFields_hero_reviewRating_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewText = {
  __typename?: 'MarketplaceFields_hero_reviewText'
  create?: Maybe<MarketplaceFields_Hero_ReviewText_Create>
  delete?: Maybe<MarketplaceFields_Hero_ReviewText_Delete>
  read?: Maybe<MarketplaceFields_Hero_ReviewText_Read>
  update?: Maybe<MarketplaceFields_Hero_ReviewText_Update>
}

export type MarketplaceFields_Hero_ReviewText_Create = {
  __typename?: 'MarketplaceFields_hero_reviewText_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewText_Delete = {
  __typename?: 'MarketplaceFields_hero_reviewText_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewText_Read = {
  __typename?: 'MarketplaceFields_hero_reviewText_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ReviewText_Update = {
  __typename?: 'MarketplaceFields_hero_reviewText_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichText = {
  __typename?: 'MarketplaceFields_hero_richText'
  create?: Maybe<MarketplaceFields_Hero_RichText_Create>
  delete?: Maybe<MarketplaceFields_Hero_RichText_Delete>
  read?: Maybe<MarketplaceFields_Hero_RichText_Read>
  update?: Maybe<MarketplaceFields_Hero_RichText_Update>
}

export type MarketplaceFields_Hero_RichTextMax = {
  __typename?: 'MarketplaceFields_hero_richTextMax'
  create?: Maybe<MarketplaceFields_Hero_RichTextMax_Create>
  delete?: Maybe<MarketplaceFields_Hero_RichTextMax_Delete>
  read?: Maybe<MarketplaceFields_Hero_RichTextMax_Read>
  update?: Maybe<MarketplaceFields_Hero_RichTextMax_Update>
}

export type MarketplaceFields_Hero_RichTextMax_Create = {
  __typename?: 'MarketplaceFields_hero_richTextMax_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichTextMax_Delete = {
  __typename?: 'MarketplaceFields_hero_richTextMax_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichTextMax_Read = {
  __typename?: 'MarketplaceFields_hero_richTextMax_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichTextMax_Update = {
  __typename?: 'MarketplaceFields_hero_richTextMax_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichText_Create = {
  __typename?: 'MarketplaceFields_hero_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichText_Delete = {
  __typename?: 'MarketplaceFields_hero_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichText_Read = {
  __typename?: 'MarketplaceFields_hero_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_RichText_Update = {
  __typename?: 'MarketplaceFields_hero_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ShowReviews = {
  __typename?: 'MarketplaceFields_hero_showReviews'
  create?: Maybe<MarketplaceFields_Hero_ShowReviews_Create>
  delete?: Maybe<MarketplaceFields_Hero_ShowReviews_Delete>
  read?: Maybe<MarketplaceFields_Hero_ShowReviews_Read>
  update?: Maybe<MarketplaceFields_Hero_ShowReviews_Update>
}

export type MarketplaceFields_Hero_ShowReviews_Create = {
  __typename?: 'MarketplaceFields_hero_showReviews_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ShowReviews_Delete = {
  __typename?: 'MarketplaceFields_hero_showReviews_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ShowReviews_Read = {
  __typename?: 'MarketplaceFields_hero_showReviews_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_ShowReviews_Update = {
  __typename?: 'MarketplaceFields_hero_showReviews_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Type = {
  __typename?: 'MarketplaceFields_hero_type'
  create?: Maybe<MarketplaceFields_Hero_Type_Create>
  delete?: Maybe<MarketplaceFields_Hero_Type_Delete>
  read?: Maybe<MarketplaceFields_Hero_Type_Read>
  update?: Maybe<MarketplaceFields_Hero_Type_Update>
}

export type MarketplaceFields_Hero_Type_Create = {
  __typename?: 'MarketplaceFields_hero_type_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Type_Delete = {
  __typename?: 'MarketplaceFields_hero_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Type_Read = {
  __typename?: 'MarketplaceFields_hero_type_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_Type_Update = {
  __typename?: 'MarketplaceFields_hero_type_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_VertAlign = {
  __typename?: 'MarketplaceFields_hero_vertAlign'
  create?: Maybe<MarketplaceFields_Hero_VertAlign_Create>
  delete?: Maybe<MarketplaceFields_Hero_VertAlign_Delete>
  read?: Maybe<MarketplaceFields_Hero_VertAlign_Read>
  update?: Maybe<MarketplaceFields_Hero_VertAlign_Update>
}

export type MarketplaceFields_Hero_VertAlign_Create = {
  __typename?: 'MarketplaceFields_hero_vertAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_VertAlign_Delete = {
  __typename?: 'MarketplaceFields_hero_vertAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_VertAlign_Read = {
  __typename?: 'MarketplaceFields_hero_vertAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Hero_VertAlign_Update = {
  __typename?: 'MarketplaceFields_hero_vertAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Layout = {
  __typename?: 'MarketplaceFields_layout'
  create?: Maybe<MarketplaceFields_Layout_Create>
  delete?: Maybe<MarketplaceFields_Layout_Delete>
  read?: Maybe<MarketplaceFields_Layout_Read>
  update?: Maybe<MarketplaceFields_Layout_Update>
}

export type MarketplaceFields_Layout_Create = {
  __typename?: 'MarketplaceFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Layout_Delete = {
  __typename?: 'MarketplaceFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Layout_Read = {
  __typename?: 'MarketplaceFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Layout_Update = {
  __typename?: 'MarketplaceFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta = {
  __typename?: 'MarketplaceFields_meta'
  create?: Maybe<MarketplaceFields_Meta_Create>
  delete?: Maybe<MarketplaceFields_Meta_Delete>
  fields?: Maybe<MarketplaceFields_Meta_Fields>
  read?: Maybe<MarketplaceFields_Meta_Read>
  update?: Maybe<MarketplaceFields_Meta_Update>
}

export type MarketplaceFields_Meta_Create = {
  __typename?: 'MarketplaceFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Delete = {
  __typename?: 'MarketplaceFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Fields = {
  __typename?: 'MarketplaceFields_meta_Fields'
  description?: Maybe<MarketplaceFields_Meta_Description>
  image?: Maybe<MarketplaceFields_Meta_Image>
  jsonLD?: Maybe<MarketplaceFields_Meta_JsonLd>
  noIndex?: Maybe<MarketplaceFields_Meta_NoIndex>
  title?: Maybe<MarketplaceFields_Meta_Title>
}

export type MarketplaceFields_Meta_Read = {
  __typename?: 'MarketplaceFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Update = {
  __typename?: 'MarketplaceFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Description = {
  __typename?: 'MarketplaceFields_meta_description'
  create?: Maybe<MarketplaceFields_Meta_Description_Create>
  delete?: Maybe<MarketplaceFields_Meta_Description_Delete>
  read?: Maybe<MarketplaceFields_Meta_Description_Read>
  update?: Maybe<MarketplaceFields_Meta_Description_Update>
}

export type MarketplaceFields_Meta_Description_Create = {
  __typename?: 'MarketplaceFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Description_Delete = {
  __typename?: 'MarketplaceFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Description_Read = {
  __typename?: 'MarketplaceFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Description_Update = {
  __typename?: 'MarketplaceFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Image = {
  __typename?: 'MarketplaceFields_meta_image'
  create?: Maybe<MarketplaceFields_Meta_Image_Create>
  delete?: Maybe<MarketplaceFields_Meta_Image_Delete>
  read?: Maybe<MarketplaceFields_Meta_Image_Read>
  update?: Maybe<MarketplaceFields_Meta_Image_Update>
}

export type MarketplaceFields_Meta_Image_Create = {
  __typename?: 'MarketplaceFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Image_Delete = {
  __typename?: 'MarketplaceFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Image_Read = {
  __typename?: 'MarketplaceFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Image_Update = {
  __typename?: 'MarketplaceFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_JsonLd = {
  __typename?: 'MarketplaceFields_meta_jsonLD'
  create?: Maybe<MarketplaceFields_Meta_JsonLd_Create>
  delete?: Maybe<MarketplaceFields_Meta_JsonLd_Delete>
  read?: Maybe<MarketplaceFields_Meta_JsonLd_Read>
  update?: Maybe<MarketplaceFields_Meta_JsonLd_Update>
}

export type MarketplaceFields_Meta_JsonLd_Create = {
  __typename?: 'MarketplaceFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_JsonLd_Delete = {
  __typename?: 'MarketplaceFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_JsonLd_Read = {
  __typename?: 'MarketplaceFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_JsonLd_Update = {
  __typename?: 'MarketplaceFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_NoIndex = {
  __typename?: 'MarketplaceFields_meta_noIndex'
  create?: Maybe<MarketplaceFields_Meta_NoIndex_Create>
  delete?: Maybe<MarketplaceFields_Meta_NoIndex_Delete>
  read?: Maybe<MarketplaceFields_Meta_NoIndex_Read>
  update?: Maybe<MarketplaceFields_Meta_NoIndex_Update>
}

export type MarketplaceFields_Meta_NoIndex_Create = {
  __typename?: 'MarketplaceFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_NoIndex_Delete = {
  __typename?: 'MarketplaceFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_NoIndex_Read = {
  __typename?: 'MarketplaceFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_NoIndex_Update = {
  __typename?: 'MarketplaceFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Title = {
  __typename?: 'MarketplaceFields_meta_title'
  create?: Maybe<MarketplaceFields_Meta_Title_Create>
  delete?: Maybe<MarketplaceFields_Meta_Title_Delete>
  read?: Maybe<MarketplaceFields_Meta_Title_Read>
  update?: Maybe<MarketplaceFields_Meta_Title_Update>
}

export type MarketplaceFields_Meta_Title_Create = {
  __typename?: 'MarketplaceFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Title_Delete = {
  __typename?: 'MarketplaceFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Title_Read = {
  __typename?: 'MarketplaceFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Meta_Title_Update = {
  __typename?: 'MarketplaceFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_OfferCategory = {
  __typename?: 'MarketplaceFields_offerCategory'
  create?: Maybe<MarketplaceFields_OfferCategory_Create>
  delete?: Maybe<MarketplaceFields_OfferCategory_Delete>
  read?: Maybe<MarketplaceFields_OfferCategory_Read>
  update?: Maybe<MarketplaceFields_OfferCategory_Update>
}

export type MarketplaceFields_OfferCategory_Create = {
  __typename?: 'MarketplaceFields_offerCategory_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_OfferCategory_Delete = {
  __typename?: 'MarketplaceFields_offerCategory_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_OfferCategory_Read = {
  __typename?: 'MarketplaceFields_offerCategory_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_OfferCategory_Update = {
  __typename?: 'MarketplaceFields_offerCategory_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Parent = {
  __typename?: 'MarketplaceFields_parent'
  create?: Maybe<MarketplaceFields_Parent_Create>
  delete?: Maybe<MarketplaceFields_Parent_Delete>
  read?: Maybe<MarketplaceFields_Parent_Read>
  update?: Maybe<MarketplaceFields_Parent_Update>
}

export type MarketplaceFields_Parent_Create = {
  __typename?: 'MarketplaceFields_parent_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Parent_Delete = {
  __typename?: 'MarketplaceFields_parent_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Parent_Read = {
  __typename?: 'MarketplaceFields_parent_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Parent_Update = {
  __typename?: 'MarketplaceFields_parent_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_PublishedAt = {
  __typename?: 'MarketplaceFields_publishedAt'
  create?: Maybe<MarketplaceFields_PublishedAt_Create>
  delete?: Maybe<MarketplaceFields_PublishedAt_Delete>
  read?: Maybe<MarketplaceFields_PublishedAt_Read>
  update?: Maybe<MarketplaceFields_PublishedAt_Update>
}

export type MarketplaceFields_PublishedAt_Create = {
  __typename?: 'MarketplaceFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_PublishedAt_Delete = {
  __typename?: 'MarketplaceFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_PublishedAt_Read = {
  __typename?: 'MarketplaceFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_PublishedAt_Update = {
  __typename?: 'MarketplaceFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Slug = {
  __typename?: 'MarketplaceFields_slug'
  create?: Maybe<MarketplaceFields_Slug_Create>
  delete?: Maybe<MarketplaceFields_Slug_Delete>
  read?: Maybe<MarketplaceFields_Slug_Read>
  update?: Maybe<MarketplaceFields_Slug_Update>
}

export type MarketplaceFields_Slug_Create = {
  __typename?: 'MarketplaceFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Slug_Delete = {
  __typename?: 'MarketplaceFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Slug_Read = {
  __typename?: 'MarketplaceFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Slug_Update = {
  __typename?: 'MarketplaceFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Title = {
  __typename?: 'MarketplaceFields_title'
  create?: Maybe<MarketplaceFields_Title_Create>
  delete?: Maybe<MarketplaceFields_Title_Delete>
  read?: Maybe<MarketplaceFields_Title_Read>
  update?: Maybe<MarketplaceFields_Title_Update>
}

export type MarketplaceFields_Title_Create = {
  __typename?: 'MarketplaceFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Title_Delete = {
  __typename?: 'MarketplaceFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Title_Read = {
  __typename?: 'MarketplaceFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_Title_Update = {
  __typename?: 'MarketplaceFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_UpdatedAt = {
  __typename?: 'MarketplaceFields_updatedAt'
  create?: Maybe<MarketplaceFields_UpdatedAt_Create>
  delete?: Maybe<MarketplaceFields_UpdatedAt_Delete>
  read?: Maybe<MarketplaceFields_UpdatedAt_Read>
  update?: Maybe<MarketplaceFields_UpdatedAt_Update>
}

export type MarketplaceFields_UpdatedAt_Create = {
  __typename?: 'MarketplaceFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_UpdatedAt_Delete = {
  __typename?: 'MarketplaceFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_UpdatedAt_Read = {
  __typename?: 'MarketplaceFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceFields_UpdatedAt_Update = {
  __typename?: 'MarketplaceFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MarketplaceReadAccess = {
  __typename?: 'MarketplaceReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceReadDocAccess = {
  __typename?: 'MarketplaceReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceReadVersionsAccess = {
  __typename?: 'MarketplaceReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceReadVersionsDocAccess = {
  __typename?: 'MarketplaceReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceUpdateAccess = {
  __typename?: 'MarketplaceUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MarketplaceUpdateDocAccess = {
  __typename?: 'MarketplaceUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaCreateAccess = {
  __typename?: 'MediaCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaCreateDocAccess = {
  __typename?: 'MediaCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaDeleteAccess = {
  __typename?: 'MediaDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaDeleteDocAccess = {
  __typename?: 'MediaDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaDocAccessFields = {
  __typename?: 'MediaDocAccessFields'
  alt?: Maybe<MediaDocAccessFields_Alt>
  createdAt?: Maybe<MediaDocAccessFields_CreatedAt>
  createdBy?: Maybe<MediaDocAccessFields_CreatedBy>
  filename?: Maybe<MediaDocAccessFields_Filename>
  filesize?: Maybe<MediaDocAccessFields_Filesize>
  focalX?: Maybe<MediaDocAccessFields_FocalX>
  focalY?: Maybe<MediaDocAccessFields_FocalY>
  height?: Maybe<MediaDocAccessFields_Height>
  mimeType?: Maybe<MediaDocAccessFields_MimeType>
  prefix?: Maybe<MediaDocAccessFields_Prefix>
  sizes?: Maybe<MediaDocAccessFields_Sizes>
  thumbnailURL?: Maybe<MediaDocAccessFields_ThumbnailUrl>
  updatedAt?: Maybe<MediaDocAccessFields_UpdatedAt>
  url?: Maybe<MediaDocAccessFields_Url>
  width?: Maybe<MediaDocAccessFields_Width>
}

export type MediaDocAccessFields_Alt = {
  __typename?: 'MediaDocAccessFields_alt'
  create?: Maybe<MediaDocAccessFields_Alt_Create>
  delete?: Maybe<MediaDocAccessFields_Alt_Delete>
  read?: Maybe<MediaDocAccessFields_Alt_Read>
  update?: Maybe<MediaDocAccessFields_Alt_Update>
}

export type MediaDocAccessFields_Alt_Create = {
  __typename?: 'MediaDocAccessFields_alt_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Alt_Delete = {
  __typename?: 'MediaDocAccessFields_alt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Alt_Read = {
  __typename?: 'MediaDocAccessFields_alt_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Alt_Update = {
  __typename?: 'MediaDocAccessFields_alt_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedAt = {
  __typename?: 'MediaDocAccessFields_createdAt'
  create?: Maybe<MediaDocAccessFields_CreatedAt_Create>
  delete?: Maybe<MediaDocAccessFields_CreatedAt_Delete>
  read?: Maybe<MediaDocAccessFields_CreatedAt_Read>
  update?: Maybe<MediaDocAccessFields_CreatedAt_Update>
}

export type MediaDocAccessFields_CreatedAt_Create = {
  __typename?: 'MediaDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedAt_Delete = {
  __typename?: 'MediaDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedAt_Read = {
  __typename?: 'MediaDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedAt_Update = {
  __typename?: 'MediaDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedBy = {
  __typename?: 'MediaDocAccessFields_createdBy'
  create?: Maybe<MediaDocAccessFields_CreatedBy_Create>
  delete?: Maybe<MediaDocAccessFields_CreatedBy_Delete>
  read?: Maybe<MediaDocAccessFields_CreatedBy_Read>
  update?: Maybe<MediaDocAccessFields_CreatedBy_Update>
}

export type MediaDocAccessFields_CreatedBy_Create = {
  __typename?: 'MediaDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedBy_Delete = {
  __typename?: 'MediaDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedBy_Read = {
  __typename?: 'MediaDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_CreatedBy_Update = {
  __typename?: 'MediaDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filename = {
  __typename?: 'MediaDocAccessFields_filename'
  create?: Maybe<MediaDocAccessFields_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Filename_Update>
}

export type MediaDocAccessFields_Filename_Create = {
  __typename?: 'MediaDocAccessFields_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filename_Read = {
  __typename?: 'MediaDocAccessFields_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filename_Update = {
  __typename?: 'MediaDocAccessFields_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filesize = {
  __typename?: 'MediaDocAccessFields_filesize'
  create?: Maybe<MediaDocAccessFields_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Filesize_Update>
}

export type MediaDocAccessFields_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalX = {
  __typename?: 'MediaDocAccessFields_focalX'
  create?: Maybe<MediaDocAccessFields_FocalX_Create>
  delete?: Maybe<MediaDocAccessFields_FocalX_Delete>
  read?: Maybe<MediaDocAccessFields_FocalX_Read>
  update?: Maybe<MediaDocAccessFields_FocalX_Update>
}

export type MediaDocAccessFields_FocalX_Create = {
  __typename?: 'MediaDocAccessFields_focalX_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalX_Delete = {
  __typename?: 'MediaDocAccessFields_focalX_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalX_Read = {
  __typename?: 'MediaDocAccessFields_focalX_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalX_Update = {
  __typename?: 'MediaDocAccessFields_focalX_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalY = {
  __typename?: 'MediaDocAccessFields_focalY'
  create?: Maybe<MediaDocAccessFields_FocalY_Create>
  delete?: Maybe<MediaDocAccessFields_FocalY_Delete>
  read?: Maybe<MediaDocAccessFields_FocalY_Read>
  update?: Maybe<MediaDocAccessFields_FocalY_Update>
}

export type MediaDocAccessFields_FocalY_Create = {
  __typename?: 'MediaDocAccessFields_focalY_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalY_Delete = {
  __typename?: 'MediaDocAccessFields_focalY_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalY_Read = {
  __typename?: 'MediaDocAccessFields_focalY_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_FocalY_Update = {
  __typename?: 'MediaDocAccessFields_focalY_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Height = {
  __typename?: 'MediaDocAccessFields_height'
  create?: Maybe<MediaDocAccessFields_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Height_Read>
  update?: Maybe<MediaDocAccessFields_Height_Update>
}

export type MediaDocAccessFields_Height_Create = {
  __typename?: 'MediaDocAccessFields_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Height_Delete = {
  __typename?: 'MediaDocAccessFields_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Height_Read = {
  __typename?: 'MediaDocAccessFields_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Height_Update = {
  __typename?: 'MediaDocAccessFields_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_MimeType = {
  __typename?: 'MediaDocAccessFields_mimeType'
  create?: Maybe<MediaDocAccessFields_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_MimeType_Update>
}

export type MediaDocAccessFields_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Prefix = {
  __typename?: 'MediaDocAccessFields_prefix'
  create?: Maybe<MediaDocAccessFields_Prefix_Create>
  delete?: Maybe<MediaDocAccessFields_Prefix_Delete>
  read?: Maybe<MediaDocAccessFields_Prefix_Read>
  update?: Maybe<MediaDocAccessFields_Prefix_Update>
}

export type MediaDocAccessFields_Prefix_Create = {
  __typename?: 'MediaDocAccessFields_prefix_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Prefix_Delete = {
  __typename?: 'MediaDocAccessFields_prefix_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Prefix_Read = {
  __typename?: 'MediaDocAccessFields_prefix_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Prefix_Update = {
  __typename?: 'MediaDocAccessFields_prefix_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes = {
  __typename?: 'MediaDocAccessFields_sizes'
  create?: Maybe<MediaDocAccessFields_Sizes_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Update>
}

export type MediaDocAccessFields_Sizes_Create = {
  __typename?: 'MediaDocAccessFields_sizes_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_Fields'
  banner?: Maybe<MediaDocAccessFields_Sizes_Banner>
  card?: Maybe<MediaDocAccessFields_Sizes_Card>
  feature?: Maybe<MediaDocAccessFields_Sizes_Feature>
  largeAutoHeight?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight>
  largeHero?: Maybe<MediaDocAccessFields_Sizes_LargeHero>
  portrait?: Maybe<MediaDocAccessFields_Sizes_Portrait>
  smallAutoHeight?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight>
  square?: Maybe<MediaDocAccessFields_Sizes_Square>
  squareThumbnail?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail>
}

export type MediaDocAccessFields_Sizes_Read = {
  __typename?: 'MediaDocAccessFields_sizes_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Update = {
  __typename?: 'MediaDocAccessFields_sizes_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner = {
  __typename?: 'MediaDocAccessFields_sizes_banner'
  create?: Maybe<MediaDocAccessFields_Sizes_Banner_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Banner_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_Banner_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_Banner_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Banner_Update>
}

export type MediaDocAccessFields_Sizes_Banner_Create = {
  __typename?: 'MediaDocAccessFields_sizes_banner_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_banner_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_banner_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_Banner_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_Banner_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_Banner_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_Banner_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_Banner_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_Banner_Width>
}

export type MediaDocAccessFields_Sizes_Banner_Read = {
  __typename?: 'MediaDocAccessFields_sizes_banner_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Update = {
  __typename?: 'MediaDocAccessFields_sizes_banner_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_Banner_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Banner_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Banner_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Banner_Filename_Update>
}

export type MediaDocAccessFields_Sizes_Banner_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_Banner_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Banner_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Banner_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Banner_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_Banner_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_banner_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Height = {
  __typename?: 'MediaDocAccessFields_sizes_banner_height'
  create?: Maybe<MediaDocAccessFields_Sizes_Banner_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Banner_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Banner_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Banner_Height_Update>
}

export type MediaDocAccessFields_Sizes_Banner_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_banner_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_banner_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_banner_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_banner_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_banner_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_Banner_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Banner_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Banner_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Banner_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_Banner_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_banner_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_banner_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_banner_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_banner_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Url = {
  __typename?: 'MediaDocAccessFields_sizes_banner_url'
  create?: Maybe<MediaDocAccessFields_Sizes_Banner_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Banner_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Banner_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Banner_Url_Update>
}

export type MediaDocAccessFields_Sizes_Banner_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_banner_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_banner_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_banner_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_banner_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Width = {
  __typename?: 'MediaDocAccessFields_sizes_banner_width'
  create?: Maybe<MediaDocAccessFields_Sizes_Banner_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Banner_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Banner_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Banner_Width_Update>
}

export type MediaDocAccessFields_Sizes_Banner_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_banner_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_banner_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_banner_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Banner_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_banner_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card = {
  __typename?: 'MediaDocAccessFields_sizes_card'
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_Card_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Update>
}

export type MediaDocAccessFields_Sizes_Card_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_card_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_Card_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_Card_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_Card_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_Card_Width>
}

export type MediaDocAccessFields_Sizes_Card_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Update>
}

export type MediaDocAccessFields_Sizes_Card_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_Card_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Height = {
  __typename?: 'MediaDocAccessFields_sizes_card_height'
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Update>
}

export type MediaDocAccessFields_Sizes_Card_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_Card_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Url = {
  __typename?: 'MediaDocAccessFields_sizes_card_url'
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Update>
}

export type MediaDocAccessFields_Sizes_Card_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Width = {
  __typename?: 'MediaDocAccessFields_sizes_card_width'
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Update>
}

export type MediaDocAccessFields_Sizes_Card_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Card_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature = {
  __typename?: 'MediaDocAccessFields_sizes_feature'
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_Feature_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Update>
}

export type MediaDocAccessFields_Sizes_Feature_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_Feature_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_Feature_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_Feature_Width>
}

export type MediaDocAccessFields_Sizes_Feature_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Update>
}

export type MediaDocAccessFields_Sizes_Feature_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_Feature_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Height = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height'
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Update>
}

export type MediaDocAccessFields_Sizes_Feature_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_Feature_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Url = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url'
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Update>
}

export type MediaDocAccessFields_Sizes_Feature_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Width = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width'
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Update>
}

export type MediaDocAccessFields_Sizes_Feature_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Feature_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Update>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Width>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Update>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Height = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_height'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Update>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Url = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_url'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Update>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Width = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_width'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Update>
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeAutoHeight_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeAutoHeight_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Update>
}

export type MediaDocAccessFields_Sizes_LargeHero_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_LargeHero_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Width>
}

export type MediaDocAccessFields_Sizes_LargeHero_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filename_Update>
}

export type MediaDocAccessFields_Sizes_LargeHero_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_LargeHero_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Height = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_height'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Height_Update>
}

export type MediaDocAccessFields_Sizes_LargeHero_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeHero_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeHero_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeHero_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeHero_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_LargeHero_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Url = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_url'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Url_Update>
}

export type MediaDocAccessFields_Sizes_LargeHero_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Width = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_width'
  create?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_LargeHero_Width_Update>
}

export type MediaDocAccessFields_Sizes_LargeHero_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_LargeHero_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_largeHero_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait = {
  __typename?: 'MediaDocAccessFields_sizes_portrait'
  create?: Maybe<MediaDocAccessFields_Sizes_Portrait_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Portrait_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_Portrait_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_Portrait_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Portrait_Update>
}

export type MediaDocAccessFields_Sizes_Portrait_Create = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_Portrait_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_Portrait_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_Portrait_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_Portrait_Width>
}

export type MediaDocAccessFields_Sizes_Portrait_Read = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Update = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filename_Update>
}

export type MediaDocAccessFields_Sizes_Portrait_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Portrait_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_Portrait_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Height = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_height'
  create?: Maybe<MediaDocAccessFields_Sizes_Portrait_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Portrait_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Portrait_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Portrait_Height_Update>
}

export type MediaDocAccessFields_Sizes_Portrait_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_Portrait_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Portrait_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Portrait_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Portrait_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_Portrait_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Url = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_url'
  create?: Maybe<MediaDocAccessFields_Sizes_Portrait_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Portrait_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Portrait_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Portrait_Url_Update>
}

export type MediaDocAccessFields_Sizes_Portrait_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Width = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_width'
  create?: Maybe<MediaDocAccessFields_Sizes_Portrait_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Portrait_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Portrait_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Portrait_Width_Update>
}

export type MediaDocAccessFields_Sizes_Portrait_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Portrait_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_portrait_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight'
  create?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Update>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Create = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Width>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Read = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Update = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Update>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Height = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_height'
  create?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Update>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Url = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_url'
  create?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Update>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Width = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_width'
  create?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Update>
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SmallAutoHeight_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_smallAutoHeight_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square = {
  __typename?: 'MediaDocAccessFields_sizes_square'
  create?: Maybe<MediaDocAccessFields_Sizes_Square_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Square_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_Square_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_Square_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Square_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail'
  create?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Delete>
  fields?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Fields>
  read?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Create = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Width>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Read = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Update = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Height = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_height'
  create?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Height_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Url = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_url'
  create?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Url_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Width = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_width'
  create?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_SquareThumbnail_Width_Update>
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_SquareThumbnail_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_squareThumbnail_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Create = {
  __typename?: 'MediaDocAccessFields_sizes_square_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_square_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_square_Fields'
  filename?: Maybe<MediaDocAccessFields_Sizes_Square_Filename>
  filesize?: Maybe<MediaDocAccessFields_Sizes_Square_Filesize>
  height?: Maybe<MediaDocAccessFields_Sizes_Square_Height>
  mimeType?: Maybe<MediaDocAccessFields_Sizes_Square_MimeType>
  url?: Maybe<MediaDocAccessFields_Sizes_Square_Url>
  width?: Maybe<MediaDocAccessFields_Sizes_Square_Width>
}

export type MediaDocAccessFields_Sizes_Square_Read = {
  __typename?: 'MediaDocAccessFields_sizes_square_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Update = {
  __typename?: 'MediaDocAccessFields_sizes_square_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_square_filename'
  create?: Maybe<MediaDocAccessFields_Sizes_Square_Filename_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Square_Filename_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Square_Filename_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Square_Filename_Update>
}

export type MediaDocAccessFields_Sizes_Square_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_square_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_square_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_square_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_square_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_square_filesize'
  create?: Maybe<MediaDocAccessFields_Sizes_Square_Filesize_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Square_Filesize_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Square_Filesize_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Square_Filesize_Update>
}

export type MediaDocAccessFields_Sizes_Square_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_square_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_square_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_square_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_square_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Height = {
  __typename?: 'MediaDocAccessFields_sizes_square_height'
  create?: Maybe<MediaDocAccessFields_Sizes_Square_Height_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Square_Height_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Square_Height_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Square_Height_Update>
}

export type MediaDocAccessFields_Sizes_Square_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_square_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_square_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_square_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_square_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_square_mimeType'
  create?: Maybe<MediaDocAccessFields_Sizes_Square_MimeType_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Square_MimeType_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Square_MimeType_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Square_MimeType_Update>
}

export type MediaDocAccessFields_Sizes_Square_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_square_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_square_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_square_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_square_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Url = {
  __typename?: 'MediaDocAccessFields_sizes_square_url'
  create?: Maybe<MediaDocAccessFields_Sizes_Square_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Square_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Square_Url_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Square_Url_Update>
}

export type MediaDocAccessFields_Sizes_Square_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_square_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_square_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_square_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_square_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Width = {
  __typename?: 'MediaDocAccessFields_sizes_square_width'
  create?: Maybe<MediaDocAccessFields_Sizes_Square_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Sizes_Square_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Sizes_Square_Width_Read>
  update?: Maybe<MediaDocAccessFields_Sizes_Square_Width_Update>
}

export type MediaDocAccessFields_Sizes_Square_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_square_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_square_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_square_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Sizes_Square_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_square_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_ThumbnailUrl = {
  __typename?: 'MediaDocAccessFields_thumbnailURL'
  create?: Maybe<MediaDocAccessFields_ThumbnailUrl_Create>
  delete?: Maybe<MediaDocAccessFields_ThumbnailUrl_Delete>
  read?: Maybe<MediaDocAccessFields_ThumbnailUrl_Read>
  update?: Maybe<MediaDocAccessFields_ThumbnailUrl_Update>
}

export type MediaDocAccessFields_ThumbnailUrl_Create = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_ThumbnailUrl_Delete = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_ThumbnailUrl_Read = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_ThumbnailUrl_Update = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_UpdatedAt = {
  __typename?: 'MediaDocAccessFields_updatedAt'
  create?: Maybe<MediaDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<MediaDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<MediaDocAccessFields_UpdatedAt_Read>
  update?: Maybe<MediaDocAccessFields_UpdatedAt_Update>
}

export type MediaDocAccessFields_UpdatedAt_Create = {
  __typename?: 'MediaDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'MediaDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_UpdatedAt_Read = {
  __typename?: 'MediaDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_UpdatedAt_Update = {
  __typename?: 'MediaDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Url = {
  __typename?: 'MediaDocAccessFields_url'
  create?: Maybe<MediaDocAccessFields_Url_Create>
  delete?: Maybe<MediaDocAccessFields_Url_Delete>
  read?: Maybe<MediaDocAccessFields_Url_Read>
  update?: Maybe<MediaDocAccessFields_Url_Update>
}

export type MediaDocAccessFields_Url_Create = {
  __typename?: 'MediaDocAccessFields_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Url_Delete = {
  __typename?: 'MediaDocAccessFields_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Url_Read = {
  __typename?: 'MediaDocAccessFields_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Url_Update = {
  __typename?: 'MediaDocAccessFields_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Width = {
  __typename?: 'MediaDocAccessFields_width'
  create?: Maybe<MediaDocAccessFields_Width_Create>
  delete?: Maybe<MediaDocAccessFields_Width_Delete>
  read?: Maybe<MediaDocAccessFields_Width_Read>
  update?: Maybe<MediaDocAccessFields_Width_Update>
}

export type MediaDocAccessFields_Width_Create = {
  __typename?: 'MediaDocAccessFields_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Width_Delete = {
  __typename?: 'MediaDocAccessFields_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Width_Read = {
  __typename?: 'MediaDocAccessFields_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaDocAccessFields_Width_Update = {
  __typename?: 'MediaDocAccessFields_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields = {
  __typename?: 'MediaFields'
  alt?: Maybe<MediaFields_Alt>
  createdAt?: Maybe<MediaFields_CreatedAt>
  createdBy?: Maybe<MediaFields_CreatedBy>
  filename?: Maybe<MediaFields_Filename>
  filesize?: Maybe<MediaFields_Filesize>
  focalX?: Maybe<MediaFields_FocalX>
  focalY?: Maybe<MediaFields_FocalY>
  height?: Maybe<MediaFields_Height>
  mimeType?: Maybe<MediaFields_MimeType>
  prefix?: Maybe<MediaFields_Prefix>
  sizes?: Maybe<MediaFields_Sizes>
  thumbnailURL?: Maybe<MediaFields_ThumbnailUrl>
  updatedAt?: Maybe<MediaFields_UpdatedAt>
  url?: Maybe<MediaFields_Url>
  width?: Maybe<MediaFields_Width>
}

export type MediaFields_Alt = {
  __typename?: 'MediaFields_alt'
  create?: Maybe<MediaFields_Alt_Create>
  delete?: Maybe<MediaFields_Alt_Delete>
  read?: Maybe<MediaFields_Alt_Read>
  update?: Maybe<MediaFields_Alt_Update>
}

export type MediaFields_Alt_Create = {
  __typename?: 'MediaFields_alt_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Alt_Delete = {
  __typename?: 'MediaFields_alt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Alt_Read = {
  __typename?: 'MediaFields_alt_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Alt_Update = {
  __typename?: 'MediaFields_alt_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedAt = {
  __typename?: 'MediaFields_createdAt'
  create?: Maybe<MediaFields_CreatedAt_Create>
  delete?: Maybe<MediaFields_CreatedAt_Delete>
  read?: Maybe<MediaFields_CreatedAt_Read>
  update?: Maybe<MediaFields_CreatedAt_Update>
}

export type MediaFields_CreatedAt_Create = {
  __typename?: 'MediaFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedAt_Delete = {
  __typename?: 'MediaFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedAt_Read = {
  __typename?: 'MediaFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedAt_Update = {
  __typename?: 'MediaFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedBy = {
  __typename?: 'MediaFields_createdBy'
  create?: Maybe<MediaFields_CreatedBy_Create>
  delete?: Maybe<MediaFields_CreatedBy_Delete>
  read?: Maybe<MediaFields_CreatedBy_Read>
  update?: Maybe<MediaFields_CreatedBy_Update>
}

export type MediaFields_CreatedBy_Create = {
  __typename?: 'MediaFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedBy_Delete = {
  __typename?: 'MediaFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedBy_Read = {
  __typename?: 'MediaFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_CreatedBy_Update = {
  __typename?: 'MediaFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filename = {
  __typename?: 'MediaFields_filename'
  create?: Maybe<MediaFields_Filename_Create>
  delete?: Maybe<MediaFields_Filename_Delete>
  read?: Maybe<MediaFields_Filename_Read>
  update?: Maybe<MediaFields_Filename_Update>
}

export type MediaFields_Filename_Create = {
  __typename?: 'MediaFields_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filename_Delete = {
  __typename?: 'MediaFields_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filename_Read = {
  __typename?: 'MediaFields_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filename_Update = {
  __typename?: 'MediaFields_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filesize = {
  __typename?: 'MediaFields_filesize'
  create?: Maybe<MediaFields_Filesize_Create>
  delete?: Maybe<MediaFields_Filesize_Delete>
  read?: Maybe<MediaFields_Filesize_Read>
  update?: Maybe<MediaFields_Filesize_Update>
}

export type MediaFields_Filesize_Create = {
  __typename?: 'MediaFields_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filesize_Delete = {
  __typename?: 'MediaFields_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filesize_Read = {
  __typename?: 'MediaFields_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Filesize_Update = {
  __typename?: 'MediaFields_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalX = {
  __typename?: 'MediaFields_focalX'
  create?: Maybe<MediaFields_FocalX_Create>
  delete?: Maybe<MediaFields_FocalX_Delete>
  read?: Maybe<MediaFields_FocalX_Read>
  update?: Maybe<MediaFields_FocalX_Update>
}

export type MediaFields_FocalX_Create = {
  __typename?: 'MediaFields_focalX_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalX_Delete = {
  __typename?: 'MediaFields_focalX_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalX_Read = {
  __typename?: 'MediaFields_focalX_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalX_Update = {
  __typename?: 'MediaFields_focalX_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalY = {
  __typename?: 'MediaFields_focalY'
  create?: Maybe<MediaFields_FocalY_Create>
  delete?: Maybe<MediaFields_FocalY_Delete>
  read?: Maybe<MediaFields_FocalY_Read>
  update?: Maybe<MediaFields_FocalY_Update>
}

export type MediaFields_FocalY_Create = {
  __typename?: 'MediaFields_focalY_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalY_Delete = {
  __typename?: 'MediaFields_focalY_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalY_Read = {
  __typename?: 'MediaFields_focalY_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_FocalY_Update = {
  __typename?: 'MediaFields_focalY_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Height = {
  __typename?: 'MediaFields_height'
  create?: Maybe<MediaFields_Height_Create>
  delete?: Maybe<MediaFields_Height_Delete>
  read?: Maybe<MediaFields_Height_Read>
  update?: Maybe<MediaFields_Height_Update>
}

export type MediaFields_Height_Create = {
  __typename?: 'MediaFields_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Height_Delete = {
  __typename?: 'MediaFields_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Height_Read = {
  __typename?: 'MediaFields_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Height_Update = {
  __typename?: 'MediaFields_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_MimeType = {
  __typename?: 'MediaFields_mimeType'
  create?: Maybe<MediaFields_MimeType_Create>
  delete?: Maybe<MediaFields_MimeType_Delete>
  read?: Maybe<MediaFields_MimeType_Read>
  update?: Maybe<MediaFields_MimeType_Update>
}

export type MediaFields_MimeType_Create = {
  __typename?: 'MediaFields_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_MimeType_Delete = {
  __typename?: 'MediaFields_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_MimeType_Read = {
  __typename?: 'MediaFields_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_MimeType_Update = {
  __typename?: 'MediaFields_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Prefix = {
  __typename?: 'MediaFields_prefix'
  create?: Maybe<MediaFields_Prefix_Create>
  delete?: Maybe<MediaFields_Prefix_Delete>
  read?: Maybe<MediaFields_Prefix_Read>
  update?: Maybe<MediaFields_Prefix_Update>
}

export type MediaFields_Prefix_Create = {
  __typename?: 'MediaFields_prefix_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Prefix_Delete = {
  __typename?: 'MediaFields_prefix_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Prefix_Read = {
  __typename?: 'MediaFields_prefix_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Prefix_Update = {
  __typename?: 'MediaFields_prefix_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes = {
  __typename?: 'MediaFields_sizes'
  create?: Maybe<MediaFields_Sizes_Create>
  delete?: Maybe<MediaFields_Sizes_Delete>
  fields?: Maybe<MediaFields_Sizes_Fields>
  read?: Maybe<MediaFields_Sizes_Read>
  update?: Maybe<MediaFields_Sizes_Update>
}

export type MediaFields_Sizes_Create = {
  __typename?: 'MediaFields_sizes_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Delete = {
  __typename?: 'MediaFields_sizes_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Fields = {
  __typename?: 'MediaFields_sizes_Fields'
  banner?: Maybe<MediaFields_Sizes_Banner>
  card?: Maybe<MediaFields_Sizes_Card>
  feature?: Maybe<MediaFields_Sizes_Feature>
  largeAutoHeight?: Maybe<MediaFields_Sizes_LargeAutoHeight>
  largeHero?: Maybe<MediaFields_Sizes_LargeHero>
  portrait?: Maybe<MediaFields_Sizes_Portrait>
  smallAutoHeight?: Maybe<MediaFields_Sizes_SmallAutoHeight>
  square?: Maybe<MediaFields_Sizes_Square>
  squareThumbnail?: Maybe<MediaFields_Sizes_SquareThumbnail>
}

export type MediaFields_Sizes_Read = {
  __typename?: 'MediaFields_sizes_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Update = {
  __typename?: 'MediaFields_sizes_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner = {
  __typename?: 'MediaFields_sizes_banner'
  create?: Maybe<MediaFields_Sizes_Banner_Create>
  delete?: Maybe<MediaFields_Sizes_Banner_Delete>
  fields?: Maybe<MediaFields_Sizes_Banner_Fields>
  read?: Maybe<MediaFields_Sizes_Banner_Read>
  update?: Maybe<MediaFields_Sizes_Banner_Update>
}

export type MediaFields_Sizes_Banner_Create = {
  __typename?: 'MediaFields_sizes_banner_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Delete = {
  __typename?: 'MediaFields_sizes_banner_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Fields = {
  __typename?: 'MediaFields_sizes_banner_Fields'
  filename?: Maybe<MediaFields_Sizes_Banner_Filename>
  filesize?: Maybe<MediaFields_Sizes_Banner_Filesize>
  height?: Maybe<MediaFields_Sizes_Banner_Height>
  mimeType?: Maybe<MediaFields_Sizes_Banner_MimeType>
  url?: Maybe<MediaFields_Sizes_Banner_Url>
  width?: Maybe<MediaFields_Sizes_Banner_Width>
}

export type MediaFields_Sizes_Banner_Read = {
  __typename?: 'MediaFields_sizes_banner_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Update = {
  __typename?: 'MediaFields_sizes_banner_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filename = {
  __typename?: 'MediaFields_sizes_banner_filename'
  create?: Maybe<MediaFields_Sizes_Banner_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_Banner_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_Banner_Filename_Read>
  update?: Maybe<MediaFields_Sizes_Banner_Filename_Update>
}

export type MediaFields_Sizes_Banner_Filename_Create = {
  __typename?: 'MediaFields_sizes_banner_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filename_Delete = {
  __typename?: 'MediaFields_sizes_banner_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filename_Read = {
  __typename?: 'MediaFields_sizes_banner_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filename_Update = {
  __typename?: 'MediaFields_sizes_banner_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filesize = {
  __typename?: 'MediaFields_sizes_banner_filesize'
  create?: Maybe<MediaFields_Sizes_Banner_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_Banner_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_Banner_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_Banner_Filesize_Update>
}

export type MediaFields_Sizes_Banner_Filesize_Create = {
  __typename?: 'MediaFields_sizes_banner_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_banner_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filesize_Read = {
  __typename?: 'MediaFields_sizes_banner_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Filesize_Update = {
  __typename?: 'MediaFields_sizes_banner_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Height = {
  __typename?: 'MediaFields_sizes_banner_height'
  create?: Maybe<MediaFields_Sizes_Banner_Height_Create>
  delete?: Maybe<MediaFields_Sizes_Banner_Height_Delete>
  read?: Maybe<MediaFields_Sizes_Banner_Height_Read>
  update?: Maybe<MediaFields_Sizes_Banner_Height_Update>
}

export type MediaFields_Sizes_Banner_Height_Create = {
  __typename?: 'MediaFields_sizes_banner_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Height_Delete = {
  __typename?: 'MediaFields_sizes_banner_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Height_Read = {
  __typename?: 'MediaFields_sizes_banner_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Height_Update = {
  __typename?: 'MediaFields_sizes_banner_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_MimeType = {
  __typename?: 'MediaFields_sizes_banner_mimeType'
  create?: Maybe<MediaFields_Sizes_Banner_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_Banner_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_Banner_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_Banner_MimeType_Update>
}

export type MediaFields_Sizes_Banner_MimeType_Create = {
  __typename?: 'MediaFields_sizes_banner_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_banner_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_MimeType_Read = {
  __typename?: 'MediaFields_sizes_banner_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_MimeType_Update = {
  __typename?: 'MediaFields_sizes_banner_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Url = {
  __typename?: 'MediaFields_sizes_banner_url'
  create?: Maybe<MediaFields_Sizes_Banner_Url_Create>
  delete?: Maybe<MediaFields_Sizes_Banner_Url_Delete>
  read?: Maybe<MediaFields_Sizes_Banner_Url_Read>
  update?: Maybe<MediaFields_Sizes_Banner_Url_Update>
}

export type MediaFields_Sizes_Banner_Url_Create = {
  __typename?: 'MediaFields_sizes_banner_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Url_Delete = {
  __typename?: 'MediaFields_sizes_banner_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Url_Read = {
  __typename?: 'MediaFields_sizes_banner_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Url_Update = {
  __typename?: 'MediaFields_sizes_banner_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Width = {
  __typename?: 'MediaFields_sizes_banner_width'
  create?: Maybe<MediaFields_Sizes_Banner_Width_Create>
  delete?: Maybe<MediaFields_Sizes_Banner_Width_Delete>
  read?: Maybe<MediaFields_Sizes_Banner_Width_Read>
  update?: Maybe<MediaFields_Sizes_Banner_Width_Update>
}

export type MediaFields_Sizes_Banner_Width_Create = {
  __typename?: 'MediaFields_sizes_banner_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Width_Delete = {
  __typename?: 'MediaFields_sizes_banner_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Width_Read = {
  __typename?: 'MediaFields_sizes_banner_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Banner_Width_Update = {
  __typename?: 'MediaFields_sizes_banner_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card = {
  __typename?: 'MediaFields_sizes_card'
  create?: Maybe<MediaFields_Sizes_Card_Create>
  delete?: Maybe<MediaFields_Sizes_Card_Delete>
  fields?: Maybe<MediaFields_Sizes_Card_Fields>
  read?: Maybe<MediaFields_Sizes_Card_Read>
  update?: Maybe<MediaFields_Sizes_Card_Update>
}

export type MediaFields_Sizes_Card_Create = {
  __typename?: 'MediaFields_sizes_card_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Delete = {
  __typename?: 'MediaFields_sizes_card_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Fields = {
  __typename?: 'MediaFields_sizes_card_Fields'
  filename?: Maybe<MediaFields_Sizes_Card_Filename>
  filesize?: Maybe<MediaFields_Sizes_Card_Filesize>
  height?: Maybe<MediaFields_Sizes_Card_Height>
  mimeType?: Maybe<MediaFields_Sizes_Card_MimeType>
  url?: Maybe<MediaFields_Sizes_Card_Url>
  width?: Maybe<MediaFields_Sizes_Card_Width>
}

export type MediaFields_Sizes_Card_Read = {
  __typename?: 'MediaFields_sizes_card_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Update = {
  __typename?: 'MediaFields_sizes_card_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filename = {
  __typename?: 'MediaFields_sizes_card_filename'
  create?: Maybe<MediaFields_Sizes_Card_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_Card_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_Card_Filename_Read>
  update?: Maybe<MediaFields_Sizes_Card_Filename_Update>
}

export type MediaFields_Sizes_Card_Filename_Create = {
  __typename?: 'MediaFields_sizes_card_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filename_Delete = {
  __typename?: 'MediaFields_sizes_card_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filename_Read = {
  __typename?: 'MediaFields_sizes_card_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filename_Update = {
  __typename?: 'MediaFields_sizes_card_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filesize = {
  __typename?: 'MediaFields_sizes_card_filesize'
  create?: Maybe<MediaFields_Sizes_Card_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_Card_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_Card_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_Card_Filesize_Update>
}

export type MediaFields_Sizes_Card_Filesize_Create = {
  __typename?: 'MediaFields_sizes_card_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_card_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filesize_Read = {
  __typename?: 'MediaFields_sizes_card_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Filesize_Update = {
  __typename?: 'MediaFields_sizes_card_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Height = {
  __typename?: 'MediaFields_sizes_card_height'
  create?: Maybe<MediaFields_Sizes_Card_Height_Create>
  delete?: Maybe<MediaFields_Sizes_Card_Height_Delete>
  read?: Maybe<MediaFields_Sizes_Card_Height_Read>
  update?: Maybe<MediaFields_Sizes_Card_Height_Update>
}

export type MediaFields_Sizes_Card_Height_Create = {
  __typename?: 'MediaFields_sizes_card_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Height_Delete = {
  __typename?: 'MediaFields_sizes_card_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Height_Read = {
  __typename?: 'MediaFields_sizes_card_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Height_Update = {
  __typename?: 'MediaFields_sizes_card_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_MimeType = {
  __typename?: 'MediaFields_sizes_card_mimeType'
  create?: Maybe<MediaFields_Sizes_Card_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_Card_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_Card_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_Card_MimeType_Update>
}

export type MediaFields_Sizes_Card_MimeType_Create = {
  __typename?: 'MediaFields_sizes_card_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_card_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_MimeType_Read = {
  __typename?: 'MediaFields_sizes_card_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_MimeType_Update = {
  __typename?: 'MediaFields_sizes_card_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Url = {
  __typename?: 'MediaFields_sizes_card_url'
  create?: Maybe<MediaFields_Sizes_Card_Url_Create>
  delete?: Maybe<MediaFields_Sizes_Card_Url_Delete>
  read?: Maybe<MediaFields_Sizes_Card_Url_Read>
  update?: Maybe<MediaFields_Sizes_Card_Url_Update>
}

export type MediaFields_Sizes_Card_Url_Create = {
  __typename?: 'MediaFields_sizes_card_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Url_Delete = {
  __typename?: 'MediaFields_sizes_card_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Url_Read = {
  __typename?: 'MediaFields_sizes_card_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Url_Update = {
  __typename?: 'MediaFields_sizes_card_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Width = {
  __typename?: 'MediaFields_sizes_card_width'
  create?: Maybe<MediaFields_Sizes_Card_Width_Create>
  delete?: Maybe<MediaFields_Sizes_Card_Width_Delete>
  read?: Maybe<MediaFields_Sizes_Card_Width_Read>
  update?: Maybe<MediaFields_Sizes_Card_Width_Update>
}

export type MediaFields_Sizes_Card_Width_Create = {
  __typename?: 'MediaFields_sizes_card_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Width_Delete = {
  __typename?: 'MediaFields_sizes_card_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Width_Read = {
  __typename?: 'MediaFields_sizes_card_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Card_Width_Update = {
  __typename?: 'MediaFields_sizes_card_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature = {
  __typename?: 'MediaFields_sizes_feature'
  create?: Maybe<MediaFields_Sizes_Feature_Create>
  delete?: Maybe<MediaFields_Sizes_Feature_Delete>
  fields?: Maybe<MediaFields_Sizes_Feature_Fields>
  read?: Maybe<MediaFields_Sizes_Feature_Read>
  update?: Maybe<MediaFields_Sizes_Feature_Update>
}

export type MediaFields_Sizes_Feature_Create = {
  __typename?: 'MediaFields_sizes_feature_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Delete = {
  __typename?: 'MediaFields_sizes_feature_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Fields = {
  __typename?: 'MediaFields_sizes_feature_Fields'
  filename?: Maybe<MediaFields_Sizes_Feature_Filename>
  filesize?: Maybe<MediaFields_Sizes_Feature_Filesize>
  height?: Maybe<MediaFields_Sizes_Feature_Height>
  mimeType?: Maybe<MediaFields_Sizes_Feature_MimeType>
  url?: Maybe<MediaFields_Sizes_Feature_Url>
  width?: Maybe<MediaFields_Sizes_Feature_Width>
}

export type MediaFields_Sizes_Feature_Read = {
  __typename?: 'MediaFields_sizes_feature_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Update = {
  __typename?: 'MediaFields_sizes_feature_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filename = {
  __typename?: 'MediaFields_sizes_feature_filename'
  create?: Maybe<MediaFields_Sizes_Feature_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_Feature_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_Feature_Filename_Read>
  update?: Maybe<MediaFields_Sizes_Feature_Filename_Update>
}

export type MediaFields_Sizes_Feature_Filename_Create = {
  __typename?: 'MediaFields_sizes_feature_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filename_Delete = {
  __typename?: 'MediaFields_sizes_feature_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filename_Read = {
  __typename?: 'MediaFields_sizes_feature_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filename_Update = {
  __typename?: 'MediaFields_sizes_feature_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filesize = {
  __typename?: 'MediaFields_sizes_feature_filesize'
  create?: Maybe<MediaFields_Sizes_Feature_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_Feature_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_Feature_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_Feature_Filesize_Update>
}

export type MediaFields_Sizes_Feature_Filesize_Create = {
  __typename?: 'MediaFields_sizes_feature_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_feature_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filesize_Read = {
  __typename?: 'MediaFields_sizes_feature_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Filesize_Update = {
  __typename?: 'MediaFields_sizes_feature_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Height = {
  __typename?: 'MediaFields_sizes_feature_height'
  create?: Maybe<MediaFields_Sizes_Feature_Height_Create>
  delete?: Maybe<MediaFields_Sizes_Feature_Height_Delete>
  read?: Maybe<MediaFields_Sizes_Feature_Height_Read>
  update?: Maybe<MediaFields_Sizes_Feature_Height_Update>
}

export type MediaFields_Sizes_Feature_Height_Create = {
  __typename?: 'MediaFields_sizes_feature_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Height_Delete = {
  __typename?: 'MediaFields_sizes_feature_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Height_Read = {
  __typename?: 'MediaFields_sizes_feature_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Height_Update = {
  __typename?: 'MediaFields_sizes_feature_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_MimeType = {
  __typename?: 'MediaFields_sizes_feature_mimeType'
  create?: Maybe<MediaFields_Sizes_Feature_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_Feature_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_Feature_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_Feature_MimeType_Update>
}

export type MediaFields_Sizes_Feature_MimeType_Create = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_MimeType_Read = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_MimeType_Update = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Url = {
  __typename?: 'MediaFields_sizes_feature_url'
  create?: Maybe<MediaFields_Sizes_Feature_Url_Create>
  delete?: Maybe<MediaFields_Sizes_Feature_Url_Delete>
  read?: Maybe<MediaFields_Sizes_Feature_Url_Read>
  update?: Maybe<MediaFields_Sizes_Feature_Url_Update>
}

export type MediaFields_Sizes_Feature_Url_Create = {
  __typename?: 'MediaFields_sizes_feature_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Url_Delete = {
  __typename?: 'MediaFields_sizes_feature_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Url_Read = {
  __typename?: 'MediaFields_sizes_feature_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Url_Update = {
  __typename?: 'MediaFields_sizes_feature_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Width = {
  __typename?: 'MediaFields_sizes_feature_width'
  create?: Maybe<MediaFields_Sizes_Feature_Width_Create>
  delete?: Maybe<MediaFields_Sizes_Feature_Width_Delete>
  read?: Maybe<MediaFields_Sizes_Feature_Width_Read>
  update?: Maybe<MediaFields_Sizes_Feature_Width_Update>
}

export type MediaFields_Sizes_Feature_Width_Create = {
  __typename?: 'MediaFields_sizes_feature_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Width_Delete = {
  __typename?: 'MediaFields_sizes_feature_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Width_Read = {
  __typename?: 'MediaFields_sizes_feature_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Feature_Width_Update = {
  __typename?: 'MediaFields_sizes_feature_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight = {
  __typename?: 'MediaFields_sizes_largeAutoHeight'
  create?: Maybe<MediaFields_Sizes_LargeAutoHeight_Create>
  delete?: Maybe<MediaFields_Sizes_LargeAutoHeight_Delete>
  fields?: Maybe<MediaFields_Sizes_LargeAutoHeight_Fields>
  read?: Maybe<MediaFields_Sizes_LargeAutoHeight_Read>
  update?: Maybe<MediaFields_Sizes_LargeAutoHeight_Update>
}

export type MediaFields_Sizes_LargeAutoHeight_Create = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Delete = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Fields = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_Fields'
  filename?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filename>
  filesize?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filesize>
  height?: Maybe<MediaFields_Sizes_LargeAutoHeight_Height>
  mimeType?: Maybe<MediaFields_Sizes_LargeAutoHeight_MimeType>
  url?: Maybe<MediaFields_Sizes_LargeAutoHeight_Url>
  width?: Maybe<MediaFields_Sizes_LargeAutoHeight_Width>
}

export type MediaFields_Sizes_LargeAutoHeight_Read = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Update = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filename = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filename'
  create?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filename_Read>
  update?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filename_Update>
}

export type MediaFields_Sizes_LargeAutoHeight_Filename_Create = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filename_Delete = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filename_Read = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filename_Update = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filesize = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filesize'
  create?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_LargeAutoHeight_Filesize_Update>
}

export type MediaFields_Sizes_LargeAutoHeight_Filesize_Create = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filesize_Read = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Filesize_Update = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Height = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_height'
  create?: Maybe<MediaFields_Sizes_LargeAutoHeight_Height_Create>
  delete?: Maybe<MediaFields_Sizes_LargeAutoHeight_Height_Delete>
  read?: Maybe<MediaFields_Sizes_LargeAutoHeight_Height_Read>
  update?: Maybe<MediaFields_Sizes_LargeAutoHeight_Height_Update>
}

export type MediaFields_Sizes_LargeAutoHeight_Height_Create = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Height_Delete = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Height_Read = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Height_Update = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_MimeType = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_mimeType'
  create?: Maybe<MediaFields_Sizes_LargeAutoHeight_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_LargeAutoHeight_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_LargeAutoHeight_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_LargeAutoHeight_MimeType_Update>
}

export type MediaFields_Sizes_LargeAutoHeight_MimeType_Create = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_MimeType_Read = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_MimeType_Update = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Url = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_url'
  create?: Maybe<MediaFields_Sizes_LargeAutoHeight_Url_Create>
  delete?: Maybe<MediaFields_Sizes_LargeAutoHeight_Url_Delete>
  read?: Maybe<MediaFields_Sizes_LargeAutoHeight_Url_Read>
  update?: Maybe<MediaFields_Sizes_LargeAutoHeight_Url_Update>
}

export type MediaFields_Sizes_LargeAutoHeight_Url_Create = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Url_Delete = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Url_Read = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Url_Update = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Width = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_width'
  create?: Maybe<MediaFields_Sizes_LargeAutoHeight_Width_Create>
  delete?: Maybe<MediaFields_Sizes_LargeAutoHeight_Width_Delete>
  read?: Maybe<MediaFields_Sizes_LargeAutoHeight_Width_Read>
  update?: Maybe<MediaFields_Sizes_LargeAutoHeight_Width_Update>
}

export type MediaFields_Sizes_LargeAutoHeight_Width_Create = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Width_Delete = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Width_Read = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeAutoHeight_Width_Update = {
  __typename?: 'MediaFields_sizes_largeAutoHeight_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero = {
  __typename?: 'MediaFields_sizes_largeHero'
  create?: Maybe<MediaFields_Sizes_LargeHero_Create>
  delete?: Maybe<MediaFields_Sizes_LargeHero_Delete>
  fields?: Maybe<MediaFields_Sizes_LargeHero_Fields>
  read?: Maybe<MediaFields_Sizes_LargeHero_Read>
  update?: Maybe<MediaFields_Sizes_LargeHero_Update>
}

export type MediaFields_Sizes_LargeHero_Create = {
  __typename?: 'MediaFields_sizes_largeHero_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Delete = {
  __typename?: 'MediaFields_sizes_largeHero_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Fields = {
  __typename?: 'MediaFields_sizes_largeHero_Fields'
  filename?: Maybe<MediaFields_Sizes_LargeHero_Filename>
  filesize?: Maybe<MediaFields_Sizes_LargeHero_Filesize>
  height?: Maybe<MediaFields_Sizes_LargeHero_Height>
  mimeType?: Maybe<MediaFields_Sizes_LargeHero_MimeType>
  url?: Maybe<MediaFields_Sizes_LargeHero_Url>
  width?: Maybe<MediaFields_Sizes_LargeHero_Width>
}

export type MediaFields_Sizes_LargeHero_Read = {
  __typename?: 'MediaFields_sizes_largeHero_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Update = {
  __typename?: 'MediaFields_sizes_largeHero_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filename = {
  __typename?: 'MediaFields_sizes_largeHero_filename'
  create?: Maybe<MediaFields_Sizes_LargeHero_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_LargeHero_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_LargeHero_Filename_Read>
  update?: Maybe<MediaFields_Sizes_LargeHero_Filename_Update>
}

export type MediaFields_Sizes_LargeHero_Filename_Create = {
  __typename?: 'MediaFields_sizes_largeHero_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filename_Delete = {
  __typename?: 'MediaFields_sizes_largeHero_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filename_Read = {
  __typename?: 'MediaFields_sizes_largeHero_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filename_Update = {
  __typename?: 'MediaFields_sizes_largeHero_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filesize = {
  __typename?: 'MediaFields_sizes_largeHero_filesize'
  create?: Maybe<MediaFields_Sizes_LargeHero_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_LargeHero_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_LargeHero_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_LargeHero_Filesize_Update>
}

export type MediaFields_Sizes_LargeHero_Filesize_Create = {
  __typename?: 'MediaFields_sizes_largeHero_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_largeHero_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filesize_Read = {
  __typename?: 'MediaFields_sizes_largeHero_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Filesize_Update = {
  __typename?: 'MediaFields_sizes_largeHero_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Height = {
  __typename?: 'MediaFields_sizes_largeHero_height'
  create?: Maybe<MediaFields_Sizes_LargeHero_Height_Create>
  delete?: Maybe<MediaFields_Sizes_LargeHero_Height_Delete>
  read?: Maybe<MediaFields_Sizes_LargeHero_Height_Read>
  update?: Maybe<MediaFields_Sizes_LargeHero_Height_Update>
}

export type MediaFields_Sizes_LargeHero_Height_Create = {
  __typename?: 'MediaFields_sizes_largeHero_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Height_Delete = {
  __typename?: 'MediaFields_sizes_largeHero_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Height_Read = {
  __typename?: 'MediaFields_sizes_largeHero_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Height_Update = {
  __typename?: 'MediaFields_sizes_largeHero_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_MimeType = {
  __typename?: 'MediaFields_sizes_largeHero_mimeType'
  create?: Maybe<MediaFields_Sizes_LargeHero_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_LargeHero_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_LargeHero_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_LargeHero_MimeType_Update>
}

export type MediaFields_Sizes_LargeHero_MimeType_Create = {
  __typename?: 'MediaFields_sizes_largeHero_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_largeHero_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_MimeType_Read = {
  __typename?: 'MediaFields_sizes_largeHero_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_MimeType_Update = {
  __typename?: 'MediaFields_sizes_largeHero_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Url = {
  __typename?: 'MediaFields_sizes_largeHero_url'
  create?: Maybe<MediaFields_Sizes_LargeHero_Url_Create>
  delete?: Maybe<MediaFields_Sizes_LargeHero_Url_Delete>
  read?: Maybe<MediaFields_Sizes_LargeHero_Url_Read>
  update?: Maybe<MediaFields_Sizes_LargeHero_Url_Update>
}

export type MediaFields_Sizes_LargeHero_Url_Create = {
  __typename?: 'MediaFields_sizes_largeHero_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Url_Delete = {
  __typename?: 'MediaFields_sizes_largeHero_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Url_Read = {
  __typename?: 'MediaFields_sizes_largeHero_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Url_Update = {
  __typename?: 'MediaFields_sizes_largeHero_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Width = {
  __typename?: 'MediaFields_sizes_largeHero_width'
  create?: Maybe<MediaFields_Sizes_LargeHero_Width_Create>
  delete?: Maybe<MediaFields_Sizes_LargeHero_Width_Delete>
  read?: Maybe<MediaFields_Sizes_LargeHero_Width_Read>
  update?: Maybe<MediaFields_Sizes_LargeHero_Width_Update>
}

export type MediaFields_Sizes_LargeHero_Width_Create = {
  __typename?: 'MediaFields_sizes_largeHero_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Width_Delete = {
  __typename?: 'MediaFields_sizes_largeHero_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Width_Read = {
  __typename?: 'MediaFields_sizes_largeHero_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_LargeHero_Width_Update = {
  __typename?: 'MediaFields_sizes_largeHero_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait = {
  __typename?: 'MediaFields_sizes_portrait'
  create?: Maybe<MediaFields_Sizes_Portrait_Create>
  delete?: Maybe<MediaFields_Sizes_Portrait_Delete>
  fields?: Maybe<MediaFields_Sizes_Portrait_Fields>
  read?: Maybe<MediaFields_Sizes_Portrait_Read>
  update?: Maybe<MediaFields_Sizes_Portrait_Update>
}

export type MediaFields_Sizes_Portrait_Create = {
  __typename?: 'MediaFields_sizes_portrait_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Delete = {
  __typename?: 'MediaFields_sizes_portrait_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Fields = {
  __typename?: 'MediaFields_sizes_portrait_Fields'
  filename?: Maybe<MediaFields_Sizes_Portrait_Filename>
  filesize?: Maybe<MediaFields_Sizes_Portrait_Filesize>
  height?: Maybe<MediaFields_Sizes_Portrait_Height>
  mimeType?: Maybe<MediaFields_Sizes_Portrait_MimeType>
  url?: Maybe<MediaFields_Sizes_Portrait_Url>
  width?: Maybe<MediaFields_Sizes_Portrait_Width>
}

export type MediaFields_Sizes_Portrait_Read = {
  __typename?: 'MediaFields_sizes_portrait_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Update = {
  __typename?: 'MediaFields_sizes_portrait_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filename = {
  __typename?: 'MediaFields_sizes_portrait_filename'
  create?: Maybe<MediaFields_Sizes_Portrait_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_Portrait_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_Portrait_Filename_Read>
  update?: Maybe<MediaFields_Sizes_Portrait_Filename_Update>
}

export type MediaFields_Sizes_Portrait_Filename_Create = {
  __typename?: 'MediaFields_sizes_portrait_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filename_Delete = {
  __typename?: 'MediaFields_sizes_portrait_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filename_Read = {
  __typename?: 'MediaFields_sizes_portrait_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filename_Update = {
  __typename?: 'MediaFields_sizes_portrait_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filesize = {
  __typename?: 'MediaFields_sizes_portrait_filesize'
  create?: Maybe<MediaFields_Sizes_Portrait_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_Portrait_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_Portrait_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_Portrait_Filesize_Update>
}

export type MediaFields_Sizes_Portrait_Filesize_Create = {
  __typename?: 'MediaFields_sizes_portrait_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_portrait_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filesize_Read = {
  __typename?: 'MediaFields_sizes_portrait_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Filesize_Update = {
  __typename?: 'MediaFields_sizes_portrait_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Height = {
  __typename?: 'MediaFields_sizes_portrait_height'
  create?: Maybe<MediaFields_Sizes_Portrait_Height_Create>
  delete?: Maybe<MediaFields_Sizes_Portrait_Height_Delete>
  read?: Maybe<MediaFields_Sizes_Portrait_Height_Read>
  update?: Maybe<MediaFields_Sizes_Portrait_Height_Update>
}

export type MediaFields_Sizes_Portrait_Height_Create = {
  __typename?: 'MediaFields_sizes_portrait_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Height_Delete = {
  __typename?: 'MediaFields_sizes_portrait_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Height_Read = {
  __typename?: 'MediaFields_sizes_portrait_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Height_Update = {
  __typename?: 'MediaFields_sizes_portrait_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_MimeType = {
  __typename?: 'MediaFields_sizes_portrait_mimeType'
  create?: Maybe<MediaFields_Sizes_Portrait_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_Portrait_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_Portrait_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_Portrait_MimeType_Update>
}

export type MediaFields_Sizes_Portrait_MimeType_Create = {
  __typename?: 'MediaFields_sizes_portrait_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_portrait_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_MimeType_Read = {
  __typename?: 'MediaFields_sizes_portrait_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_MimeType_Update = {
  __typename?: 'MediaFields_sizes_portrait_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Url = {
  __typename?: 'MediaFields_sizes_portrait_url'
  create?: Maybe<MediaFields_Sizes_Portrait_Url_Create>
  delete?: Maybe<MediaFields_Sizes_Portrait_Url_Delete>
  read?: Maybe<MediaFields_Sizes_Portrait_Url_Read>
  update?: Maybe<MediaFields_Sizes_Portrait_Url_Update>
}

export type MediaFields_Sizes_Portrait_Url_Create = {
  __typename?: 'MediaFields_sizes_portrait_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Url_Delete = {
  __typename?: 'MediaFields_sizes_portrait_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Url_Read = {
  __typename?: 'MediaFields_sizes_portrait_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Url_Update = {
  __typename?: 'MediaFields_sizes_portrait_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Width = {
  __typename?: 'MediaFields_sizes_portrait_width'
  create?: Maybe<MediaFields_Sizes_Portrait_Width_Create>
  delete?: Maybe<MediaFields_Sizes_Portrait_Width_Delete>
  read?: Maybe<MediaFields_Sizes_Portrait_Width_Read>
  update?: Maybe<MediaFields_Sizes_Portrait_Width_Update>
}

export type MediaFields_Sizes_Portrait_Width_Create = {
  __typename?: 'MediaFields_sizes_portrait_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Width_Delete = {
  __typename?: 'MediaFields_sizes_portrait_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Width_Read = {
  __typename?: 'MediaFields_sizes_portrait_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Portrait_Width_Update = {
  __typename?: 'MediaFields_sizes_portrait_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight = {
  __typename?: 'MediaFields_sizes_smallAutoHeight'
  create?: Maybe<MediaFields_Sizes_SmallAutoHeight_Create>
  delete?: Maybe<MediaFields_Sizes_SmallAutoHeight_Delete>
  fields?: Maybe<MediaFields_Sizes_SmallAutoHeight_Fields>
  read?: Maybe<MediaFields_Sizes_SmallAutoHeight_Read>
  update?: Maybe<MediaFields_Sizes_SmallAutoHeight_Update>
}

export type MediaFields_Sizes_SmallAutoHeight_Create = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Delete = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Fields = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_Fields'
  filename?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filename>
  filesize?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filesize>
  height?: Maybe<MediaFields_Sizes_SmallAutoHeight_Height>
  mimeType?: Maybe<MediaFields_Sizes_SmallAutoHeight_MimeType>
  url?: Maybe<MediaFields_Sizes_SmallAutoHeight_Url>
  width?: Maybe<MediaFields_Sizes_SmallAutoHeight_Width>
}

export type MediaFields_Sizes_SmallAutoHeight_Read = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Update = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filename = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filename'
  create?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filename_Read>
  update?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filename_Update>
}

export type MediaFields_Sizes_SmallAutoHeight_Filename_Create = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filename_Delete = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filename_Read = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filename_Update = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filesize = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filesize'
  create?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_SmallAutoHeight_Filesize_Update>
}

export type MediaFields_Sizes_SmallAutoHeight_Filesize_Create = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filesize_Read = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Filesize_Update = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Height = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_height'
  create?: Maybe<MediaFields_Sizes_SmallAutoHeight_Height_Create>
  delete?: Maybe<MediaFields_Sizes_SmallAutoHeight_Height_Delete>
  read?: Maybe<MediaFields_Sizes_SmallAutoHeight_Height_Read>
  update?: Maybe<MediaFields_Sizes_SmallAutoHeight_Height_Update>
}

export type MediaFields_Sizes_SmallAutoHeight_Height_Create = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Height_Delete = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Height_Read = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Height_Update = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_MimeType = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_mimeType'
  create?: Maybe<MediaFields_Sizes_SmallAutoHeight_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_SmallAutoHeight_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_SmallAutoHeight_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_SmallAutoHeight_MimeType_Update>
}

export type MediaFields_Sizes_SmallAutoHeight_MimeType_Create = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_MimeType_Read = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_MimeType_Update = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Url = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_url'
  create?: Maybe<MediaFields_Sizes_SmallAutoHeight_Url_Create>
  delete?: Maybe<MediaFields_Sizes_SmallAutoHeight_Url_Delete>
  read?: Maybe<MediaFields_Sizes_SmallAutoHeight_Url_Read>
  update?: Maybe<MediaFields_Sizes_SmallAutoHeight_Url_Update>
}

export type MediaFields_Sizes_SmallAutoHeight_Url_Create = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Url_Delete = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Url_Read = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Url_Update = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Width = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_width'
  create?: Maybe<MediaFields_Sizes_SmallAutoHeight_Width_Create>
  delete?: Maybe<MediaFields_Sizes_SmallAutoHeight_Width_Delete>
  read?: Maybe<MediaFields_Sizes_SmallAutoHeight_Width_Read>
  update?: Maybe<MediaFields_Sizes_SmallAutoHeight_Width_Update>
}

export type MediaFields_Sizes_SmallAutoHeight_Width_Create = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Width_Delete = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Width_Read = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SmallAutoHeight_Width_Update = {
  __typename?: 'MediaFields_sizes_smallAutoHeight_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square = {
  __typename?: 'MediaFields_sizes_square'
  create?: Maybe<MediaFields_Sizes_Square_Create>
  delete?: Maybe<MediaFields_Sizes_Square_Delete>
  fields?: Maybe<MediaFields_Sizes_Square_Fields>
  read?: Maybe<MediaFields_Sizes_Square_Read>
  update?: Maybe<MediaFields_Sizes_Square_Update>
}

export type MediaFields_Sizes_SquareThumbnail = {
  __typename?: 'MediaFields_sizes_squareThumbnail'
  create?: Maybe<MediaFields_Sizes_SquareThumbnail_Create>
  delete?: Maybe<MediaFields_Sizes_SquareThumbnail_Delete>
  fields?: Maybe<MediaFields_Sizes_SquareThumbnail_Fields>
  read?: Maybe<MediaFields_Sizes_SquareThumbnail_Read>
  update?: Maybe<MediaFields_Sizes_SquareThumbnail_Update>
}

export type MediaFields_Sizes_SquareThumbnail_Create = {
  __typename?: 'MediaFields_sizes_squareThumbnail_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Delete = {
  __typename?: 'MediaFields_sizes_squareThumbnail_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Fields = {
  __typename?: 'MediaFields_sizes_squareThumbnail_Fields'
  filename?: Maybe<MediaFields_Sizes_SquareThumbnail_Filename>
  filesize?: Maybe<MediaFields_Sizes_SquareThumbnail_Filesize>
  height?: Maybe<MediaFields_Sizes_SquareThumbnail_Height>
  mimeType?: Maybe<MediaFields_Sizes_SquareThumbnail_MimeType>
  url?: Maybe<MediaFields_Sizes_SquareThumbnail_Url>
  width?: Maybe<MediaFields_Sizes_SquareThumbnail_Width>
}

export type MediaFields_Sizes_SquareThumbnail_Read = {
  __typename?: 'MediaFields_sizes_squareThumbnail_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Update = {
  __typename?: 'MediaFields_sizes_squareThumbnail_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filename = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filename'
  create?: Maybe<MediaFields_Sizes_SquareThumbnail_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_SquareThumbnail_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_SquareThumbnail_Filename_Read>
  update?: Maybe<MediaFields_Sizes_SquareThumbnail_Filename_Update>
}

export type MediaFields_Sizes_SquareThumbnail_Filename_Create = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filename_Delete = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filename_Read = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filename_Update = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filesize = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filesize'
  create?: Maybe<MediaFields_Sizes_SquareThumbnail_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_SquareThumbnail_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_SquareThumbnail_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_SquareThumbnail_Filesize_Update>
}

export type MediaFields_Sizes_SquareThumbnail_Filesize_Create = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filesize_Read = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Filesize_Update = {
  __typename?: 'MediaFields_sizes_squareThumbnail_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Height = {
  __typename?: 'MediaFields_sizes_squareThumbnail_height'
  create?: Maybe<MediaFields_Sizes_SquareThumbnail_Height_Create>
  delete?: Maybe<MediaFields_Sizes_SquareThumbnail_Height_Delete>
  read?: Maybe<MediaFields_Sizes_SquareThumbnail_Height_Read>
  update?: Maybe<MediaFields_Sizes_SquareThumbnail_Height_Update>
}

export type MediaFields_Sizes_SquareThumbnail_Height_Create = {
  __typename?: 'MediaFields_sizes_squareThumbnail_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Height_Delete = {
  __typename?: 'MediaFields_sizes_squareThumbnail_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Height_Read = {
  __typename?: 'MediaFields_sizes_squareThumbnail_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Height_Update = {
  __typename?: 'MediaFields_sizes_squareThumbnail_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_MimeType = {
  __typename?: 'MediaFields_sizes_squareThumbnail_mimeType'
  create?: Maybe<MediaFields_Sizes_SquareThumbnail_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_SquareThumbnail_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_SquareThumbnail_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_SquareThumbnail_MimeType_Update>
}

export type MediaFields_Sizes_SquareThumbnail_MimeType_Create = {
  __typename?: 'MediaFields_sizes_squareThumbnail_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_squareThumbnail_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_MimeType_Read = {
  __typename?: 'MediaFields_sizes_squareThumbnail_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_MimeType_Update = {
  __typename?: 'MediaFields_sizes_squareThumbnail_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Url = {
  __typename?: 'MediaFields_sizes_squareThumbnail_url'
  create?: Maybe<MediaFields_Sizes_SquareThumbnail_Url_Create>
  delete?: Maybe<MediaFields_Sizes_SquareThumbnail_Url_Delete>
  read?: Maybe<MediaFields_Sizes_SquareThumbnail_Url_Read>
  update?: Maybe<MediaFields_Sizes_SquareThumbnail_Url_Update>
}

export type MediaFields_Sizes_SquareThumbnail_Url_Create = {
  __typename?: 'MediaFields_sizes_squareThumbnail_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Url_Delete = {
  __typename?: 'MediaFields_sizes_squareThumbnail_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Url_Read = {
  __typename?: 'MediaFields_sizes_squareThumbnail_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Url_Update = {
  __typename?: 'MediaFields_sizes_squareThumbnail_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Width = {
  __typename?: 'MediaFields_sizes_squareThumbnail_width'
  create?: Maybe<MediaFields_Sizes_SquareThumbnail_Width_Create>
  delete?: Maybe<MediaFields_Sizes_SquareThumbnail_Width_Delete>
  read?: Maybe<MediaFields_Sizes_SquareThumbnail_Width_Read>
  update?: Maybe<MediaFields_Sizes_SquareThumbnail_Width_Update>
}

export type MediaFields_Sizes_SquareThumbnail_Width_Create = {
  __typename?: 'MediaFields_sizes_squareThumbnail_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Width_Delete = {
  __typename?: 'MediaFields_sizes_squareThumbnail_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Width_Read = {
  __typename?: 'MediaFields_sizes_squareThumbnail_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_SquareThumbnail_Width_Update = {
  __typename?: 'MediaFields_sizes_squareThumbnail_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Create = {
  __typename?: 'MediaFields_sizes_square_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Delete = {
  __typename?: 'MediaFields_sizes_square_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Fields = {
  __typename?: 'MediaFields_sizes_square_Fields'
  filename?: Maybe<MediaFields_Sizes_Square_Filename>
  filesize?: Maybe<MediaFields_Sizes_Square_Filesize>
  height?: Maybe<MediaFields_Sizes_Square_Height>
  mimeType?: Maybe<MediaFields_Sizes_Square_MimeType>
  url?: Maybe<MediaFields_Sizes_Square_Url>
  width?: Maybe<MediaFields_Sizes_Square_Width>
}

export type MediaFields_Sizes_Square_Read = {
  __typename?: 'MediaFields_sizes_square_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Update = {
  __typename?: 'MediaFields_sizes_square_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filename = {
  __typename?: 'MediaFields_sizes_square_filename'
  create?: Maybe<MediaFields_Sizes_Square_Filename_Create>
  delete?: Maybe<MediaFields_Sizes_Square_Filename_Delete>
  read?: Maybe<MediaFields_Sizes_Square_Filename_Read>
  update?: Maybe<MediaFields_Sizes_Square_Filename_Update>
}

export type MediaFields_Sizes_Square_Filename_Create = {
  __typename?: 'MediaFields_sizes_square_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filename_Delete = {
  __typename?: 'MediaFields_sizes_square_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filename_Read = {
  __typename?: 'MediaFields_sizes_square_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filename_Update = {
  __typename?: 'MediaFields_sizes_square_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filesize = {
  __typename?: 'MediaFields_sizes_square_filesize'
  create?: Maybe<MediaFields_Sizes_Square_Filesize_Create>
  delete?: Maybe<MediaFields_Sizes_Square_Filesize_Delete>
  read?: Maybe<MediaFields_Sizes_Square_Filesize_Read>
  update?: Maybe<MediaFields_Sizes_Square_Filesize_Update>
}

export type MediaFields_Sizes_Square_Filesize_Create = {
  __typename?: 'MediaFields_sizes_square_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_square_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filesize_Read = {
  __typename?: 'MediaFields_sizes_square_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Filesize_Update = {
  __typename?: 'MediaFields_sizes_square_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Height = {
  __typename?: 'MediaFields_sizes_square_height'
  create?: Maybe<MediaFields_Sizes_Square_Height_Create>
  delete?: Maybe<MediaFields_Sizes_Square_Height_Delete>
  read?: Maybe<MediaFields_Sizes_Square_Height_Read>
  update?: Maybe<MediaFields_Sizes_Square_Height_Update>
}

export type MediaFields_Sizes_Square_Height_Create = {
  __typename?: 'MediaFields_sizes_square_height_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Height_Delete = {
  __typename?: 'MediaFields_sizes_square_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Height_Read = {
  __typename?: 'MediaFields_sizes_square_height_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Height_Update = {
  __typename?: 'MediaFields_sizes_square_height_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_MimeType = {
  __typename?: 'MediaFields_sizes_square_mimeType'
  create?: Maybe<MediaFields_Sizes_Square_MimeType_Create>
  delete?: Maybe<MediaFields_Sizes_Square_MimeType_Delete>
  read?: Maybe<MediaFields_Sizes_Square_MimeType_Read>
  update?: Maybe<MediaFields_Sizes_Square_MimeType_Update>
}

export type MediaFields_Sizes_Square_MimeType_Create = {
  __typename?: 'MediaFields_sizes_square_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_square_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_MimeType_Read = {
  __typename?: 'MediaFields_sizes_square_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_MimeType_Update = {
  __typename?: 'MediaFields_sizes_square_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Url = {
  __typename?: 'MediaFields_sizes_square_url'
  create?: Maybe<MediaFields_Sizes_Square_Url_Create>
  delete?: Maybe<MediaFields_Sizes_Square_Url_Delete>
  read?: Maybe<MediaFields_Sizes_Square_Url_Read>
  update?: Maybe<MediaFields_Sizes_Square_Url_Update>
}

export type MediaFields_Sizes_Square_Url_Create = {
  __typename?: 'MediaFields_sizes_square_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Url_Delete = {
  __typename?: 'MediaFields_sizes_square_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Url_Read = {
  __typename?: 'MediaFields_sizes_square_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Url_Update = {
  __typename?: 'MediaFields_sizes_square_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Width = {
  __typename?: 'MediaFields_sizes_square_width'
  create?: Maybe<MediaFields_Sizes_Square_Width_Create>
  delete?: Maybe<MediaFields_Sizes_Square_Width_Delete>
  read?: Maybe<MediaFields_Sizes_Square_Width_Read>
  update?: Maybe<MediaFields_Sizes_Square_Width_Update>
}

export type MediaFields_Sizes_Square_Width_Create = {
  __typename?: 'MediaFields_sizes_square_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Width_Delete = {
  __typename?: 'MediaFields_sizes_square_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Width_Read = {
  __typename?: 'MediaFields_sizes_square_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Sizes_Square_Width_Update = {
  __typename?: 'MediaFields_sizes_square_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_ThumbnailUrl = {
  __typename?: 'MediaFields_thumbnailURL'
  create?: Maybe<MediaFields_ThumbnailUrl_Create>
  delete?: Maybe<MediaFields_ThumbnailUrl_Delete>
  read?: Maybe<MediaFields_ThumbnailUrl_Read>
  update?: Maybe<MediaFields_ThumbnailUrl_Update>
}

export type MediaFields_ThumbnailUrl_Create = {
  __typename?: 'MediaFields_thumbnailURL_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_ThumbnailUrl_Delete = {
  __typename?: 'MediaFields_thumbnailURL_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_ThumbnailUrl_Read = {
  __typename?: 'MediaFields_thumbnailURL_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_ThumbnailUrl_Update = {
  __typename?: 'MediaFields_thumbnailURL_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_UpdatedAt = {
  __typename?: 'MediaFields_updatedAt'
  create?: Maybe<MediaFields_UpdatedAt_Create>
  delete?: Maybe<MediaFields_UpdatedAt_Delete>
  read?: Maybe<MediaFields_UpdatedAt_Read>
  update?: Maybe<MediaFields_UpdatedAt_Update>
}

export type MediaFields_UpdatedAt_Create = {
  __typename?: 'MediaFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_UpdatedAt_Delete = {
  __typename?: 'MediaFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_UpdatedAt_Read = {
  __typename?: 'MediaFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_UpdatedAt_Update = {
  __typename?: 'MediaFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Url = {
  __typename?: 'MediaFields_url'
  create?: Maybe<MediaFields_Url_Create>
  delete?: Maybe<MediaFields_Url_Delete>
  read?: Maybe<MediaFields_Url_Read>
  update?: Maybe<MediaFields_Url_Update>
}

export type MediaFields_Url_Create = {
  __typename?: 'MediaFields_url_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Url_Delete = {
  __typename?: 'MediaFields_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Url_Read = {
  __typename?: 'MediaFields_url_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Url_Update = {
  __typename?: 'MediaFields_url_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Width = {
  __typename?: 'MediaFields_width'
  create?: Maybe<MediaFields_Width_Create>
  delete?: Maybe<MediaFields_Width_Delete>
  read?: Maybe<MediaFields_Width_Read>
  update?: Maybe<MediaFields_Width_Update>
}

export type MediaFields_Width_Create = {
  __typename?: 'MediaFields_width_Create'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Width_Delete = {
  __typename?: 'MediaFields_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Width_Read = {
  __typename?: 'MediaFields_width_Read'
  permission: Scalars['Boolean']['output']
}

export type MediaFields_Width_Update = {
  __typename?: 'MediaFields_width_Update'
  permission: Scalars['Boolean']['output']
}

export type MediaReadAccess = {
  __typename?: 'MediaReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaReadDocAccess = {
  __typename?: 'MediaReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaUpdateAccess = {
  __typename?: 'MediaUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type MediaUpdateDocAccess = {
  __typename?: 'MediaUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type Mutation = {
  __typename?: 'Mutation'
  createCmsArticle?: Maybe<CmsArticle>
  createCmsAuthor?: Maybe<CmsAuthor>
  createCmsCallout?: Maybe<CmsCallout>
  createCmsCategories?: Maybe<CmsCategories>
  createCmsComment?: Maybe<CmsComment>
  createCmsForm?: Maybe<CmsForm>
  createCmsFormSubmission?: Maybe<CmsFormSubmission>
  createCmsGuide?: Maybe<CmsGuide>
  createCmsLegal?: Maybe<CmsLegal>
  createCmsLinks?: Maybe<CmsLinks>
  createCmsLiteEmbeddedMarketplace?: Maybe<CmsLiteEmbeddedMarketplace>
  createCmsMarketplacePage?: Maybe<CmsMarketplacePage>
  createCmsMedia?: Maybe<CmsMedia>
  createCmsNewsroomArticle?: Maybe<CmsNewsroomArticle>
  createCmsPage?: Maybe<CmsPage>
  createCmsPricing?: Maybe<CmsPricing>
  createCmsRating?: Maybe<CmsRating>
  createCmsRedirect?: Maybe<CmsRedirect>
  createCmsStackerPage?: Maybe<CmsStackerPage>
  createCmsTradeCreditProgram?: Maybe<CmsTradeCreditProgram>
  createCmsTradeCreditProgramTag?: Maybe<CmsTradeCreditProgramTag>
  createCmsTradeCreditRecommendation?: Maybe<CmsTradeCreditRecommendation>
  createCmsTradeCreditVendor?: Maybe<CmsTradeCreditVendor>
  createCmsUser?: Maybe<CmsUser>
  createCmsVideo?: Maybe<CmsVideo>
  createPayloadLockedDocument?: Maybe<PayloadLockedDocument>
  createPayloadPreference?: Maybe<PayloadPreference>
  deleteCmsArticle?: Maybe<CmsArticle>
  deleteCmsAuthor?: Maybe<CmsAuthor>
  deleteCmsCallout?: Maybe<CmsCallout>
  deleteCmsCategories?: Maybe<CmsCategories>
  deleteCmsComment?: Maybe<CmsComment>
  deleteCmsForm?: Maybe<CmsForm>
  deleteCmsFormSubmission?: Maybe<CmsFormSubmission>
  deleteCmsGuide?: Maybe<CmsGuide>
  deleteCmsLegal?: Maybe<CmsLegal>
  deleteCmsLinks?: Maybe<CmsLinks>
  deleteCmsLiteEmbeddedMarketplace?: Maybe<CmsLiteEmbeddedMarketplace>
  deleteCmsMarketplacePage?: Maybe<CmsMarketplacePage>
  deleteCmsMedia?: Maybe<CmsMedia>
  deleteCmsNewsroomArticle?: Maybe<CmsNewsroomArticle>
  deleteCmsPage?: Maybe<CmsPage>
  deleteCmsPricing?: Maybe<CmsPricing>
  deleteCmsRating?: Maybe<CmsRating>
  deleteCmsRedirect?: Maybe<CmsRedirect>
  deleteCmsStackerPage?: Maybe<CmsStackerPage>
  deleteCmsTradeCreditProgram?: Maybe<CmsTradeCreditProgram>
  deleteCmsTradeCreditProgramTag?: Maybe<CmsTradeCreditProgramTag>
  deleteCmsTradeCreditRecommendation?: Maybe<CmsTradeCreditRecommendation>
  deleteCmsTradeCreditVendor?: Maybe<CmsTradeCreditVendor>
  deleteCmsUser?: Maybe<CmsUser>
  deleteCmsVideo?: Maybe<CmsVideo>
  deletePayloadLockedDocument?: Maybe<PayloadLockedDocument>
  deletePayloadPreference?: Maybe<PayloadPreference>
  duplicateCmsArticle?: Maybe<CmsArticle>
  duplicateCmsAuthor?: Maybe<CmsAuthor>
  duplicateCmsCallout?: Maybe<CmsCallout>
  duplicateCmsCategories?: Maybe<CmsCategories>
  duplicateCmsComment?: Maybe<CmsComment>
  duplicateCmsForm?: Maybe<CmsForm>
  duplicateCmsFormSubmission?: Maybe<CmsFormSubmission>
  duplicateCmsGuide?: Maybe<CmsGuide>
  duplicateCmsLegal?: Maybe<CmsLegal>
  duplicateCmsLinks?: Maybe<CmsLinks>
  duplicateCmsLiteEmbeddedMarketplace?: Maybe<CmsLiteEmbeddedMarketplace>
  duplicateCmsMarketplacePage?: Maybe<CmsMarketplacePage>
  duplicateCmsMedia?: Maybe<CmsMedia>
  duplicateCmsNewsroomArticle?: Maybe<CmsNewsroomArticle>
  duplicateCmsPage?: Maybe<CmsPage>
  duplicateCmsPricing?: Maybe<CmsPricing>
  duplicateCmsRating?: Maybe<CmsRating>
  duplicateCmsRedirect?: Maybe<CmsRedirect>
  duplicateCmsStackerPage?: Maybe<CmsStackerPage>
  duplicateCmsTradeCreditProgram?: Maybe<CmsTradeCreditProgram>
  duplicateCmsTradeCreditProgramTag?: Maybe<CmsTradeCreditProgramTag>
  duplicateCmsTradeCreditRecommendation?: Maybe<CmsTradeCreditRecommendation>
  duplicateCmsTradeCreditVendor?: Maybe<CmsTradeCreditVendor>
  duplicateCmsVideo?: Maybe<CmsVideo>
  duplicatePayloadLockedDocument?: Maybe<PayloadLockedDocument>
  duplicatePayloadPreference?: Maybe<PayloadPreference>
  forgotPasswordCmsUser: Scalars['Boolean']['output']
  loginCmsUser?: Maybe<UsersLoginResult>
  logoutCmsUser?: Maybe<Scalars['String']['output']>
  refreshTokenCmsUser?: Maybe<UsersRefreshedCmsUser>
  resetPasswordCmsUser?: Maybe<UsersResetPassword>
  restoreVersionCmsArticle?: Maybe<CmsArticle>
  restoreVersionCmsForm?: Maybe<CmsForm>
  restoreVersionCmsGuide?: Maybe<CmsGuide>
  restoreVersionCmsLiteEmbeddedMarketplace?: Maybe<CmsLiteEmbeddedMarketplace>
  restoreVersionCmsMarketplacePage?: Maybe<CmsMarketplacePage>
  restoreVersionCmsNewsroomArticle?: Maybe<CmsNewsroomArticle>
  restoreVersionCmsPage?: Maybe<CmsPage>
  restoreVersionCmsStackerPage?: Maybe<CmsStackerPage>
  restoreVersionCmsTradeCreditProgram?: Maybe<CmsTradeCreditProgram>
  restoreVersionCmsTradeCreditRecommendation?: Maybe<CmsTradeCreditRecommendation>
  restoreVersionCmsTradeCreditVendor?: Maybe<CmsTradeCreditVendor>
  setUserStorage?: Maybe<CmsUserStorage>
  unlockCmsUser: Scalars['Boolean']['output']
  updateCmsArticle?: Maybe<CmsArticle>
  updateCmsAuthor?: Maybe<CmsAuthor>
  updateCmsCallout?: Maybe<CmsCallout>
  updateCmsCategories?: Maybe<CmsCategories>
  updateCmsComment?: Maybe<CmsComment>
  updateCmsFooter?: Maybe<CmsFooter>
  updateCmsForm?: Maybe<CmsForm>
  updateCmsFormSubmission?: Maybe<CmsFormSubmission>
  updateCmsGuide?: Maybe<CmsGuide>
  updateCmsHeader?: Maybe<CmsHeader>
  updateCmsLegal?: Maybe<CmsLegal>
  updateCmsLinks?: Maybe<CmsLinks>
  updateCmsLiteEmbeddedMarketplace?: Maybe<CmsLiteEmbeddedMarketplace>
  updateCmsMarketplacePage?: Maybe<CmsMarketplacePage>
  updateCmsMedia?: Maybe<CmsMedia>
  updateCmsNewsroomArticle?: Maybe<CmsNewsroomArticle>
  updateCmsPage?: Maybe<CmsPage>
  updateCmsPricing?: Maybe<CmsPricing>
  updateCmsRating?: Maybe<CmsRating>
  updateCmsRedirect?: Maybe<CmsRedirect>
  updateCmsSettings?: Maybe<CmsSettings>
  updateCmsStackerPage?: Maybe<CmsStackerPage>
  updateCmsTradeCreditProgram?: Maybe<CmsTradeCreditProgram>
  updateCmsTradeCreditProgramTag?: Maybe<CmsTradeCreditProgramTag>
  updateCmsTradeCreditRecommendation?: Maybe<CmsTradeCreditRecommendation>
  updateCmsTradeCreditVendor?: Maybe<CmsTradeCreditVendor>
  updateCmsUser?: Maybe<CmsUser>
  updateCmsVideo?: Maybe<CmsVideo>
  updatePayloadLockedDocument?: Maybe<PayloadLockedDocument>
  updatePayloadPreference?: Maybe<PayloadPreference>
  verifyEmailCmsUser?: Maybe<Scalars['Boolean']['output']>
}

export type MutationCreateCmsArticleArgs = {
  data: MutationCmsArticleInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsAuthorArgs = {
  data: MutationCmsAuthorInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsCalloutArgs = {
  data: MutationCmsCalloutInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsCategoriesArgs = {
  data: MutationCmsCategoriesInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsCommentArgs = {
  data: MutationCmsCommentInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsFormArgs = {
  data: MutationCmsFormInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsFormSubmissionArgs = {
  data: MutationCmsFormSubmissionInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsGuideArgs = {
  data: MutationCmsGuideInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsLegalArgs = {
  data: MutationCmsLegalInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsLinksArgs = {
  data: MutationCmsLinksInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsLiteEmbeddedMarketplaceArgs = {
  data: MutationCmsLiteEmbeddedMarketplaceInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsMarketplacePageArgs = {
  data: MutationCmsMarketplacePageInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsMediaArgs = {
  data: MutationCmsMediaInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsNewsroomArticleArgs = {
  data: MutationCmsNewsroomArticleInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsPageArgs = {
  data: MutationCmsPageInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsPricingArgs = {
  data: MutationCmsPricingInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsRatingArgs = {
  data: MutationCmsRatingInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsRedirectArgs = {
  data: MutationCmsRedirectInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsStackerPageArgs = {
  data: MutationCmsStackerPageInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsTradeCreditProgramArgs = {
  data: MutationCmsTradeCreditProgramInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsTradeCreditProgramTagArgs = {
  data: MutationCmsTradeCreditProgramTagInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsTradeCreditRecommendationArgs = {
  data: MutationCmsTradeCreditRecommendationInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsTradeCreditVendorArgs = {
  data: MutationCmsTradeCreditVendorInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsUserArgs = {
  data: MutationCmsUserInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreateCmsVideoArgs = {
  data: MutationCmsVideoInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreatePayloadLockedDocumentArgs = {
  data: MutationPayloadLockedDocumentInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCreatePayloadPreferenceArgs = {
  data: MutationPayloadPreferenceInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationDeleteCmsArticleArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsAuthorArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsCalloutArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsCategoriesArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsCommentArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsFormArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsFormSubmissionArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsGuideArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsLegalArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsLinksArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsLiteEmbeddedMarketplaceArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsMarketplacePageArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsMediaArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsNewsroomArticleArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsPageArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsPricingArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsRatingArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsRedirectArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsStackerPageArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsTradeCreditProgramArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsTradeCreditProgramTagArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsTradeCreditRecommendationArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsTradeCreditVendorArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsUserArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCmsVideoArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeletePayloadLockedDocumentArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeletePayloadPreferenceArgs = {
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsArticleArgs = {
  data: MutationCmsArticleInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsAuthorArgs = {
  data: MutationCmsAuthorInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsCalloutArgs = {
  data: MutationCmsCalloutInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsCategoriesArgs = {
  data: MutationCmsCategoriesInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsCommentArgs = {
  data: MutationCmsCommentInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsFormArgs = {
  data: MutationCmsFormInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsFormSubmissionArgs = {
  data: MutationCmsFormSubmissionInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsGuideArgs = {
  data: MutationCmsGuideInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsLegalArgs = {
  data: MutationCmsLegalInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsLinksArgs = {
  data: MutationCmsLinksInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsLiteEmbeddedMarketplaceArgs = {
  data: MutationCmsLiteEmbeddedMarketplaceInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsMarketplacePageArgs = {
  data: MutationCmsMarketplacePageInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsMediaArgs = {
  data: MutationCmsMediaInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsNewsroomArticleArgs = {
  data: MutationCmsNewsroomArticleInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsPageArgs = {
  data: MutationCmsPageInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsPricingArgs = {
  data: MutationCmsPricingInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsRatingArgs = {
  data: MutationCmsRatingInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsRedirectArgs = {
  data: MutationCmsRedirectInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsStackerPageArgs = {
  data: MutationCmsStackerPageInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsTradeCreditProgramArgs = {
  data: MutationCmsTradeCreditProgramInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsTradeCreditProgramTagArgs = {
  data: MutationCmsTradeCreditProgramTagInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsTradeCreditRecommendationArgs = {
  data: MutationCmsTradeCreditRecommendationInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsTradeCreditVendorArgs = {
  data: MutationCmsTradeCreditVendorInput
  id: Scalars['Int']['input']
}

export type MutationDuplicateCmsVideoArgs = {
  data: MutationCmsVideoInput
  id: Scalars['Int']['input']
}

export type MutationDuplicatePayloadLockedDocumentArgs = {
  data: MutationPayloadLockedDocumentInput
  id: Scalars['Int']['input']
}

export type MutationDuplicatePayloadPreferenceArgs = {
  data: MutationPayloadPreferenceInput
  id: Scalars['Int']['input']
}

export type MutationForgotPasswordCmsUserArgs = {
  disableEmail?: InputMaybe<Scalars['Boolean']['input']>
  email: Scalars['String']['input']
  expiration?: InputMaybe<Scalars['Int']['input']>
}

export type MutationLoginCmsUserArgs = {
  email: Scalars['String']['input']
  password?: InputMaybe<Scalars['String']['input']>
}

export type MutationResetPasswordCmsUserArgs = {
  password?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
}

export type MutationRestoreVersionCmsArticleArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsFormArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsGuideArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsLiteEmbeddedMarketplaceArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsMarketplacePageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsNewsroomArticleArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsStackerPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsTradeCreditProgramArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsTradeCreditRecommendationArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationRestoreVersionCmsTradeCreditVendorArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type MutationSetUserStorageArgs = {
  key: Scalars['String']['input']
  method: UserStorageMethod
  value: Scalars['String']['input']
}

export type MutationUnlockCmsUserArgs = {
  email: Scalars['String']['input']
}

export type MutationUpdateCmsArticleArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsArticleUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsAuthorArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsAuthorUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsCalloutArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsCalloutUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsCategoriesArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsCategoriesUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsCommentArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsCommentUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsFooterArgs = {
  data: MutationCmsFooterInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateCmsFormArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsFormUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsFormSubmissionArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsFormSubmissionUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsGuideArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsGuideUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsHeaderArgs = {
  data: MutationCmsHeaderInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateCmsLegalArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsLegalUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsLinksArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsLinksUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsLiteEmbeddedMarketplaceArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsLiteEmbeddedMarketplaceUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsMarketplacePageArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsMarketplacePageUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsMediaArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsMediaUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsNewsroomArticleArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsNewsroomArticleUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsPageArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsPageUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsPricingArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsPricingUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsRatingArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsRatingUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsRedirectArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsRedirectUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsSettingsArgs = {
  data: MutationCmsSettingsInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateCmsStackerPageArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsStackerPageUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsTradeCreditProgramArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsTradeCreditProgramUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsTradeCreditProgramTagArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsTradeCreditProgramTagUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsTradeCreditRecommendationArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsTradeCreditRecommendationUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsTradeCreditVendorArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsTradeCreditVendorUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsUserArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsUserUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdateCmsVideoArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationCmsVideoUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdatePayloadLockedDocumentArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationPayloadLockedDocumentUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationUpdatePayloadPreferenceArgs = {
  autosave?: InputMaybe<Scalars['Boolean']['input']>
  data: MutationPayloadPreferenceUpdateInput
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type MutationVerifyEmailCmsUserArgs = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type NewsroomCreateAccess = {
  __typename?: 'NewsroomCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomCreateDocAccess = {
  __typename?: 'NewsroomCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomDeleteAccess = {
  __typename?: 'NewsroomDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomDeleteDocAccess = {
  __typename?: 'NewsroomDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomDocAccessFields = {
  __typename?: 'NewsroomDocAccessFields'
  _status?: Maybe<NewsroomDocAccessFields__Status>
  authors?: Maybe<NewsroomDocAccessFields_Authors>
  createdAt?: Maybe<NewsroomDocAccessFields_CreatedAt>
  createdBy?: Maybe<NewsroomDocAccessFields_CreatedBy>
  customFooter?: Maybe<NewsroomDocAccessFields_CustomFooter>
  customHeader?: Maybe<NewsroomDocAccessFields_CustomHeader>
  excerpt?: Maybe<NewsroomDocAccessFields_Excerpt>
  image?: Maybe<NewsroomDocAccessFields_Image>
  layout?: Maybe<NewsroomDocAccessFields_Layout>
  meta?: Maybe<NewsroomDocAccessFields_Meta>
  publishedAt?: Maybe<NewsroomDocAccessFields_PublishedAt>
  richText?: Maybe<NewsroomDocAccessFields_RichText>
  slug?: Maybe<NewsroomDocAccessFields_Slug>
  title?: Maybe<NewsroomDocAccessFields_Title>
  updatedAt?: Maybe<NewsroomDocAccessFields_UpdatedAt>
  wordpressPostId?: Maybe<NewsroomDocAccessFields_WordpressPostId>
}

export type NewsroomDocAccessFields__Status = {
  __typename?: 'NewsroomDocAccessFields__status'
  create?: Maybe<NewsroomDocAccessFields__Status_Create>
  delete?: Maybe<NewsroomDocAccessFields__Status_Delete>
  read?: Maybe<NewsroomDocAccessFields__Status_Read>
  update?: Maybe<NewsroomDocAccessFields__Status_Update>
}

export type NewsroomDocAccessFields__Status_Create = {
  __typename?: 'NewsroomDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields__Status_Delete = {
  __typename?: 'NewsroomDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields__Status_Read = {
  __typename?: 'NewsroomDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields__Status_Update = {
  __typename?: 'NewsroomDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Authors = {
  __typename?: 'NewsroomDocAccessFields_authors'
  create?: Maybe<NewsroomDocAccessFields_Authors_Create>
  delete?: Maybe<NewsroomDocAccessFields_Authors_Delete>
  read?: Maybe<NewsroomDocAccessFields_Authors_Read>
  update?: Maybe<NewsroomDocAccessFields_Authors_Update>
}

export type NewsroomDocAccessFields_Authors_Create = {
  __typename?: 'NewsroomDocAccessFields_authors_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Authors_Delete = {
  __typename?: 'NewsroomDocAccessFields_authors_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Authors_Read = {
  __typename?: 'NewsroomDocAccessFields_authors_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Authors_Update = {
  __typename?: 'NewsroomDocAccessFields_authors_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedAt = {
  __typename?: 'NewsroomDocAccessFields_createdAt'
  create?: Maybe<NewsroomDocAccessFields_CreatedAt_Create>
  delete?: Maybe<NewsroomDocAccessFields_CreatedAt_Delete>
  read?: Maybe<NewsroomDocAccessFields_CreatedAt_Read>
  update?: Maybe<NewsroomDocAccessFields_CreatedAt_Update>
}

export type NewsroomDocAccessFields_CreatedAt_Create = {
  __typename?: 'NewsroomDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedAt_Delete = {
  __typename?: 'NewsroomDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedAt_Read = {
  __typename?: 'NewsroomDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedAt_Update = {
  __typename?: 'NewsroomDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedBy = {
  __typename?: 'NewsroomDocAccessFields_createdBy'
  create?: Maybe<NewsroomDocAccessFields_CreatedBy_Create>
  delete?: Maybe<NewsroomDocAccessFields_CreatedBy_Delete>
  read?: Maybe<NewsroomDocAccessFields_CreatedBy_Read>
  update?: Maybe<NewsroomDocAccessFields_CreatedBy_Update>
}

export type NewsroomDocAccessFields_CreatedBy_Create = {
  __typename?: 'NewsroomDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedBy_Delete = {
  __typename?: 'NewsroomDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedBy_Read = {
  __typename?: 'NewsroomDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CreatedBy_Update = {
  __typename?: 'NewsroomDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter = {
  __typename?: 'NewsroomDocAccessFields_customFooter'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomFooter_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_Update>
}

export type NewsroomDocAccessFields_CustomFooter_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Fields = {
  __typename?: 'NewsroomDocAccessFields_customFooter_Fields'
  disclaimers?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<NewsroomDocAccessFields_CustomFooter_IsHidden>
}

export type NewsroomDocAccessFields_CustomFooter_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Update>
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_Fields'
  align?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Text>
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_align'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Update>
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_id'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Update>
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_number'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Update>
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_text'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Update>
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_IsHidden = {
  __typename?: 'NewsroomDocAccessFields_customFooter_isHidden'
  create?: Maybe<NewsroomDocAccessFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomFooter_IsHidden_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomFooter_IsHidden_Update>
}

export type NewsroomDocAccessFields_CustomFooter_IsHidden_Create = {
  __typename?: 'NewsroomDocAccessFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'NewsroomDocAccessFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_IsHidden_Read = {
  __typename?: 'NewsroomDocAccessFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomFooter_IsHidden_Update = {
  __typename?: 'NewsroomDocAccessFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader = {
  __typename?: 'NewsroomDocAccessFields_customHeader'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomHeader_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_Update>
}

export type NewsroomDocAccessFields_CustomHeader_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_Fields = {
  __typename?: 'NewsroomDocAccessFields_customHeader_Fields'
  headerDisplay?: Maybe<NewsroomDocAccessFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<NewsroomDocAccessFields_CustomHeader_IsHidden>
  loginLink?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink>
  signupLink?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink>
  supportLink?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink>
}

export type NewsroomDocAccessFields_CustomHeader_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_HeaderDisplay = {
  __typename?: 'NewsroomDocAccessFields_customHeader_headerDisplay'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Update>
}

export type NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_IsHidden = {
  __typename?: 'NewsroomDocAccessFields_customHeader_isHidden'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_IsHidden_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_IsHidden_Update>
}

export type NewsroomDocAccessFields_CustomHeader_IsHidden_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_IsHidden_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_IsHidden_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_Fields'
  newTab?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Type>
  url?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Url>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_newTab'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_Fields'
  id?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_id'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_key'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_value'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reference'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reusable'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_targetId'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Type = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_type'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Url = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_url'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Update>
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_Fields'
  newTab?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Type>
  url?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Url>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_newTab'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_Fields'
  id?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_id'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_key'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_value'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reference'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reusable'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_targetId'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Type = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_type'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Url = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_url'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_Fields'
  newTab?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Type>
  url?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Url>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_newTab'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_Fields'
  id?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_id'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_key'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_value'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reference'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reusable'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_targetId'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Type = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_type'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Url = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_url'
  create?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Update>
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'NewsroomDocAccessFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Excerpt = {
  __typename?: 'NewsroomDocAccessFields_excerpt'
  create?: Maybe<NewsroomDocAccessFields_Excerpt_Create>
  delete?: Maybe<NewsroomDocAccessFields_Excerpt_Delete>
  read?: Maybe<NewsroomDocAccessFields_Excerpt_Read>
  update?: Maybe<NewsroomDocAccessFields_Excerpt_Update>
}

export type NewsroomDocAccessFields_Excerpt_Create = {
  __typename?: 'NewsroomDocAccessFields_excerpt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Excerpt_Delete = {
  __typename?: 'NewsroomDocAccessFields_excerpt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Excerpt_Read = {
  __typename?: 'NewsroomDocAccessFields_excerpt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Excerpt_Update = {
  __typename?: 'NewsroomDocAccessFields_excerpt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Image = {
  __typename?: 'NewsroomDocAccessFields_image'
  create?: Maybe<NewsroomDocAccessFields_Image_Create>
  delete?: Maybe<NewsroomDocAccessFields_Image_Delete>
  read?: Maybe<NewsroomDocAccessFields_Image_Read>
  update?: Maybe<NewsroomDocAccessFields_Image_Update>
}

export type NewsroomDocAccessFields_Image_Create = {
  __typename?: 'NewsroomDocAccessFields_image_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Image_Delete = {
  __typename?: 'NewsroomDocAccessFields_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Image_Read = {
  __typename?: 'NewsroomDocAccessFields_image_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Image_Update = {
  __typename?: 'NewsroomDocAccessFields_image_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Layout = {
  __typename?: 'NewsroomDocAccessFields_layout'
  create?: Maybe<NewsroomDocAccessFields_Layout_Create>
  delete?: Maybe<NewsroomDocAccessFields_Layout_Delete>
  read?: Maybe<NewsroomDocAccessFields_Layout_Read>
  update?: Maybe<NewsroomDocAccessFields_Layout_Update>
}

export type NewsroomDocAccessFields_Layout_Create = {
  __typename?: 'NewsroomDocAccessFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Layout_Delete = {
  __typename?: 'NewsroomDocAccessFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Layout_Read = {
  __typename?: 'NewsroomDocAccessFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Layout_Update = {
  __typename?: 'NewsroomDocAccessFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta = {
  __typename?: 'NewsroomDocAccessFields_meta'
  create?: Maybe<NewsroomDocAccessFields_Meta_Create>
  delete?: Maybe<NewsroomDocAccessFields_Meta_Delete>
  fields?: Maybe<NewsroomDocAccessFields_Meta_Fields>
  read?: Maybe<NewsroomDocAccessFields_Meta_Read>
  update?: Maybe<NewsroomDocAccessFields_Meta_Update>
}

export type NewsroomDocAccessFields_Meta_Create = {
  __typename?: 'NewsroomDocAccessFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Delete = {
  __typename?: 'NewsroomDocAccessFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Fields = {
  __typename?: 'NewsroomDocAccessFields_meta_Fields'
  description?: Maybe<NewsroomDocAccessFields_Meta_Description>
  image?: Maybe<NewsroomDocAccessFields_Meta_Image>
  jsonLD?: Maybe<NewsroomDocAccessFields_Meta_JsonLd>
  noIndex?: Maybe<NewsroomDocAccessFields_Meta_NoIndex>
  title?: Maybe<NewsroomDocAccessFields_Meta_Title>
}

export type NewsroomDocAccessFields_Meta_Read = {
  __typename?: 'NewsroomDocAccessFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Update = {
  __typename?: 'NewsroomDocAccessFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Description = {
  __typename?: 'NewsroomDocAccessFields_meta_description'
  create?: Maybe<NewsroomDocAccessFields_Meta_Description_Create>
  delete?: Maybe<NewsroomDocAccessFields_Meta_Description_Delete>
  read?: Maybe<NewsroomDocAccessFields_Meta_Description_Read>
  update?: Maybe<NewsroomDocAccessFields_Meta_Description_Update>
}

export type NewsroomDocAccessFields_Meta_Description_Create = {
  __typename?: 'NewsroomDocAccessFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Description_Delete = {
  __typename?: 'NewsroomDocAccessFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Description_Read = {
  __typename?: 'NewsroomDocAccessFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Description_Update = {
  __typename?: 'NewsroomDocAccessFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Image = {
  __typename?: 'NewsroomDocAccessFields_meta_image'
  create?: Maybe<NewsroomDocAccessFields_Meta_Image_Create>
  delete?: Maybe<NewsroomDocAccessFields_Meta_Image_Delete>
  read?: Maybe<NewsroomDocAccessFields_Meta_Image_Read>
  update?: Maybe<NewsroomDocAccessFields_Meta_Image_Update>
}

export type NewsroomDocAccessFields_Meta_Image_Create = {
  __typename?: 'NewsroomDocAccessFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Image_Delete = {
  __typename?: 'NewsroomDocAccessFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Image_Read = {
  __typename?: 'NewsroomDocAccessFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Image_Update = {
  __typename?: 'NewsroomDocAccessFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_JsonLd = {
  __typename?: 'NewsroomDocAccessFields_meta_jsonLD'
  create?: Maybe<NewsroomDocAccessFields_Meta_JsonLd_Create>
  delete?: Maybe<NewsroomDocAccessFields_Meta_JsonLd_Delete>
  read?: Maybe<NewsroomDocAccessFields_Meta_JsonLd_Read>
  update?: Maybe<NewsroomDocAccessFields_Meta_JsonLd_Update>
}

export type NewsroomDocAccessFields_Meta_JsonLd_Create = {
  __typename?: 'NewsroomDocAccessFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_JsonLd_Delete = {
  __typename?: 'NewsroomDocAccessFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_JsonLd_Read = {
  __typename?: 'NewsroomDocAccessFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_JsonLd_Update = {
  __typename?: 'NewsroomDocAccessFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_NoIndex = {
  __typename?: 'NewsroomDocAccessFields_meta_noIndex'
  create?: Maybe<NewsroomDocAccessFields_Meta_NoIndex_Create>
  delete?: Maybe<NewsroomDocAccessFields_Meta_NoIndex_Delete>
  read?: Maybe<NewsroomDocAccessFields_Meta_NoIndex_Read>
  update?: Maybe<NewsroomDocAccessFields_Meta_NoIndex_Update>
}

export type NewsroomDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'NewsroomDocAccessFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'NewsroomDocAccessFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'NewsroomDocAccessFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'NewsroomDocAccessFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Title = {
  __typename?: 'NewsroomDocAccessFields_meta_title'
  create?: Maybe<NewsroomDocAccessFields_Meta_Title_Create>
  delete?: Maybe<NewsroomDocAccessFields_Meta_Title_Delete>
  read?: Maybe<NewsroomDocAccessFields_Meta_Title_Read>
  update?: Maybe<NewsroomDocAccessFields_Meta_Title_Update>
}

export type NewsroomDocAccessFields_Meta_Title_Create = {
  __typename?: 'NewsroomDocAccessFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Title_Delete = {
  __typename?: 'NewsroomDocAccessFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Title_Read = {
  __typename?: 'NewsroomDocAccessFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Meta_Title_Update = {
  __typename?: 'NewsroomDocAccessFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_PublishedAt = {
  __typename?: 'NewsroomDocAccessFields_publishedAt'
  create?: Maybe<NewsroomDocAccessFields_PublishedAt_Create>
  delete?: Maybe<NewsroomDocAccessFields_PublishedAt_Delete>
  read?: Maybe<NewsroomDocAccessFields_PublishedAt_Read>
  update?: Maybe<NewsroomDocAccessFields_PublishedAt_Update>
}

export type NewsroomDocAccessFields_PublishedAt_Create = {
  __typename?: 'NewsroomDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_PublishedAt_Delete = {
  __typename?: 'NewsroomDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_PublishedAt_Read = {
  __typename?: 'NewsroomDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_PublishedAt_Update = {
  __typename?: 'NewsroomDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_RichText = {
  __typename?: 'NewsroomDocAccessFields_richText'
  create?: Maybe<NewsroomDocAccessFields_RichText_Create>
  delete?: Maybe<NewsroomDocAccessFields_RichText_Delete>
  read?: Maybe<NewsroomDocAccessFields_RichText_Read>
  update?: Maybe<NewsroomDocAccessFields_RichText_Update>
}

export type NewsroomDocAccessFields_RichText_Create = {
  __typename?: 'NewsroomDocAccessFields_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_RichText_Delete = {
  __typename?: 'NewsroomDocAccessFields_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_RichText_Read = {
  __typename?: 'NewsroomDocAccessFields_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_RichText_Update = {
  __typename?: 'NewsroomDocAccessFields_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Slug = {
  __typename?: 'NewsroomDocAccessFields_slug'
  create?: Maybe<NewsroomDocAccessFields_Slug_Create>
  delete?: Maybe<NewsroomDocAccessFields_Slug_Delete>
  read?: Maybe<NewsroomDocAccessFields_Slug_Read>
  update?: Maybe<NewsroomDocAccessFields_Slug_Update>
}

export type NewsroomDocAccessFields_Slug_Create = {
  __typename?: 'NewsroomDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Slug_Delete = {
  __typename?: 'NewsroomDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Slug_Read = {
  __typename?: 'NewsroomDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Slug_Update = {
  __typename?: 'NewsroomDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Title = {
  __typename?: 'NewsroomDocAccessFields_title'
  create?: Maybe<NewsroomDocAccessFields_Title_Create>
  delete?: Maybe<NewsroomDocAccessFields_Title_Delete>
  read?: Maybe<NewsroomDocAccessFields_Title_Read>
  update?: Maybe<NewsroomDocAccessFields_Title_Update>
}

export type NewsroomDocAccessFields_Title_Create = {
  __typename?: 'NewsroomDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Title_Delete = {
  __typename?: 'NewsroomDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Title_Read = {
  __typename?: 'NewsroomDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_Title_Update = {
  __typename?: 'NewsroomDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_UpdatedAt = {
  __typename?: 'NewsroomDocAccessFields_updatedAt'
  create?: Maybe<NewsroomDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<NewsroomDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<NewsroomDocAccessFields_UpdatedAt_Read>
  update?: Maybe<NewsroomDocAccessFields_UpdatedAt_Update>
}

export type NewsroomDocAccessFields_UpdatedAt_Create = {
  __typename?: 'NewsroomDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'NewsroomDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_UpdatedAt_Read = {
  __typename?: 'NewsroomDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_UpdatedAt_Update = {
  __typename?: 'NewsroomDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_WordpressPostId = {
  __typename?: 'NewsroomDocAccessFields_wordpressPostId'
  create?: Maybe<NewsroomDocAccessFields_WordpressPostId_Create>
  delete?: Maybe<NewsroomDocAccessFields_WordpressPostId_Delete>
  read?: Maybe<NewsroomDocAccessFields_WordpressPostId_Read>
  update?: Maybe<NewsroomDocAccessFields_WordpressPostId_Update>
}

export type NewsroomDocAccessFields_WordpressPostId_Create = {
  __typename?: 'NewsroomDocAccessFields_wordpressPostId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_WordpressPostId_Delete = {
  __typename?: 'NewsroomDocAccessFields_wordpressPostId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_WordpressPostId_Read = {
  __typename?: 'NewsroomDocAccessFields_wordpressPostId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomDocAccessFields_WordpressPostId_Update = {
  __typename?: 'NewsroomDocAccessFields_wordpressPostId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields = {
  __typename?: 'NewsroomFields'
  _status?: Maybe<NewsroomFields__Status>
  authors?: Maybe<NewsroomFields_Authors>
  createdAt?: Maybe<NewsroomFields_CreatedAt>
  createdBy?: Maybe<NewsroomFields_CreatedBy>
  customFooter?: Maybe<NewsroomFields_CustomFooter>
  customHeader?: Maybe<NewsroomFields_CustomHeader>
  excerpt?: Maybe<NewsroomFields_Excerpt>
  image?: Maybe<NewsroomFields_Image>
  layout?: Maybe<NewsroomFields_Layout>
  meta?: Maybe<NewsroomFields_Meta>
  publishedAt?: Maybe<NewsroomFields_PublishedAt>
  richText?: Maybe<NewsroomFields_RichText>
  slug?: Maybe<NewsroomFields_Slug>
  title?: Maybe<NewsroomFields_Title>
  updatedAt?: Maybe<NewsroomFields_UpdatedAt>
  wordpressPostId?: Maybe<NewsroomFields_WordpressPostId>
}

export type NewsroomFields__Status = {
  __typename?: 'NewsroomFields__status'
  create?: Maybe<NewsroomFields__Status_Create>
  delete?: Maybe<NewsroomFields__Status_Delete>
  read?: Maybe<NewsroomFields__Status_Read>
  update?: Maybe<NewsroomFields__Status_Update>
}

export type NewsroomFields__Status_Create = {
  __typename?: 'NewsroomFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields__Status_Delete = {
  __typename?: 'NewsroomFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields__Status_Read = {
  __typename?: 'NewsroomFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields__Status_Update = {
  __typename?: 'NewsroomFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Authors = {
  __typename?: 'NewsroomFields_authors'
  create?: Maybe<NewsroomFields_Authors_Create>
  delete?: Maybe<NewsroomFields_Authors_Delete>
  read?: Maybe<NewsroomFields_Authors_Read>
  update?: Maybe<NewsroomFields_Authors_Update>
}

export type NewsroomFields_Authors_Create = {
  __typename?: 'NewsroomFields_authors_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Authors_Delete = {
  __typename?: 'NewsroomFields_authors_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Authors_Read = {
  __typename?: 'NewsroomFields_authors_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Authors_Update = {
  __typename?: 'NewsroomFields_authors_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedAt = {
  __typename?: 'NewsroomFields_createdAt'
  create?: Maybe<NewsroomFields_CreatedAt_Create>
  delete?: Maybe<NewsroomFields_CreatedAt_Delete>
  read?: Maybe<NewsroomFields_CreatedAt_Read>
  update?: Maybe<NewsroomFields_CreatedAt_Update>
}

export type NewsroomFields_CreatedAt_Create = {
  __typename?: 'NewsroomFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedAt_Delete = {
  __typename?: 'NewsroomFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedAt_Read = {
  __typename?: 'NewsroomFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedAt_Update = {
  __typename?: 'NewsroomFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedBy = {
  __typename?: 'NewsroomFields_createdBy'
  create?: Maybe<NewsroomFields_CreatedBy_Create>
  delete?: Maybe<NewsroomFields_CreatedBy_Delete>
  read?: Maybe<NewsroomFields_CreatedBy_Read>
  update?: Maybe<NewsroomFields_CreatedBy_Update>
}

export type NewsroomFields_CreatedBy_Create = {
  __typename?: 'NewsroomFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedBy_Delete = {
  __typename?: 'NewsroomFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedBy_Read = {
  __typename?: 'NewsroomFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CreatedBy_Update = {
  __typename?: 'NewsroomFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter = {
  __typename?: 'NewsroomFields_customFooter'
  create?: Maybe<NewsroomFields_CustomFooter_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_Delete>
  fields?: Maybe<NewsroomFields_CustomFooter_Fields>
  read?: Maybe<NewsroomFields_CustomFooter_Read>
  update?: Maybe<NewsroomFields_CustomFooter_Update>
}

export type NewsroomFields_CustomFooter_Create = {
  __typename?: 'NewsroomFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Delete = {
  __typename?: 'NewsroomFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Fields = {
  __typename?: 'NewsroomFields_customFooter_Fields'
  disclaimers?: Maybe<NewsroomFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<NewsroomFields_CustomFooter_IsHidden>
}

export type NewsroomFields_CustomFooter_Read = {
  __typename?: 'NewsroomFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Update = {
  __typename?: 'NewsroomFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers = {
  __typename?: 'NewsroomFields_customFooter_disclaimers'
  create?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Update>
}

export type NewsroomFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_Fields'
  align?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Text>
}

export type NewsroomFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_align'
  create?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Align_Update>
}

export type NewsroomFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_id'
  create?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Id_Update>
}

export type NewsroomFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_number'
  create?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Number_Update>
}

export type NewsroomFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_text'
  create?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<NewsroomFields_CustomFooter_Disclaimers_Text_Update>
}

export type NewsroomFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'NewsroomFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_IsHidden = {
  __typename?: 'NewsroomFields_customFooter_isHidden'
  create?: Maybe<NewsroomFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<NewsroomFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<NewsroomFields_CustomFooter_IsHidden_Read>
  update?: Maybe<NewsroomFields_CustomFooter_IsHidden_Update>
}

export type NewsroomFields_CustomFooter_IsHidden_Create = {
  __typename?: 'NewsroomFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'NewsroomFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_IsHidden_Read = {
  __typename?: 'NewsroomFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomFooter_IsHidden_Update = {
  __typename?: 'NewsroomFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader = {
  __typename?: 'NewsroomFields_customHeader'
  create?: Maybe<NewsroomFields_CustomHeader_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_Delete>
  fields?: Maybe<NewsroomFields_CustomHeader_Fields>
  read?: Maybe<NewsroomFields_CustomHeader_Read>
  update?: Maybe<NewsroomFields_CustomHeader_Update>
}

export type NewsroomFields_CustomHeader_Create = {
  __typename?: 'NewsroomFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_Delete = {
  __typename?: 'NewsroomFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_Fields = {
  __typename?: 'NewsroomFields_customHeader_Fields'
  headerDisplay?: Maybe<NewsroomFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<NewsroomFields_CustomHeader_IsHidden>
  loginLink?: Maybe<NewsroomFields_CustomHeader_LoginLink>
  signupLink?: Maybe<NewsroomFields_CustomHeader_SignupLink>
  supportLink?: Maybe<NewsroomFields_CustomHeader_SupportLink>
}

export type NewsroomFields_CustomHeader_Read = {
  __typename?: 'NewsroomFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_Update = {
  __typename?: 'NewsroomFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_HeaderDisplay = {
  __typename?: 'NewsroomFields_customHeader_headerDisplay'
  create?: Maybe<NewsroomFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<NewsroomFields_CustomHeader_HeaderDisplay_Update>
}

export type NewsroomFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'NewsroomFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'NewsroomFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'NewsroomFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'NewsroomFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_IsHidden = {
  __typename?: 'NewsroomFields_customHeader_isHidden'
  create?: Maybe<NewsroomFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_IsHidden_Read>
  update?: Maybe<NewsroomFields_CustomHeader_IsHidden_Update>
}

export type NewsroomFields_CustomHeader_IsHidden_Create = {
  __typename?: 'NewsroomFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'NewsroomFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_IsHidden_Read = {
  __typename?: 'NewsroomFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_IsHidden_Update = {
  __typename?: 'NewsroomFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink = {
  __typename?: 'NewsroomFields_customHeader_loginLink'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<NewsroomFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'NewsroomFields_customHeader_loginLink_Fields'
  newTab?: Maybe<NewsroomFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<NewsroomFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<NewsroomFields_CustomHeader_LoginLink_Type>
  url?: Maybe<NewsroomFields_CustomHeader_LoginLink_Url>
}

export type NewsroomFields_CustomHeader_LoginLink_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'NewsroomFields_customHeader_loginLink_newTab'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_NewTab_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_Fields'
  id?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Value>
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_id'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_key'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_value'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reference'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reference_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reusable'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Reusable_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'NewsroomFields_customHeader_loginLink_targetId'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_TargetId_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Type = {
  __typename?: 'NewsroomFields_customHeader_loginLink_type'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Type_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Url = {
  __typename?: 'NewsroomFields_customHeader_loginLink_url'
  create?: Maybe<NewsroomFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<NewsroomFields_CustomHeader_LoginLink_Url_Update>
}

export type NewsroomFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'NewsroomFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'NewsroomFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'NewsroomFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'NewsroomFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink = {
  __typename?: 'NewsroomFields_customHeader_signupLink'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<NewsroomFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'NewsroomFields_customHeader_signupLink_Fields'
  newTab?: Maybe<NewsroomFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<NewsroomFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<NewsroomFields_CustomHeader_SignupLink_Type>
  url?: Maybe<NewsroomFields_CustomHeader_SignupLink_Url>
}

export type NewsroomFields_CustomHeader_SignupLink_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'NewsroomFields_customHeader_signupLink_newTab'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_NewTab_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_Fields'
  id?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Value>
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_id'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_key'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_value'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reference'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reference_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reusable'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Reusable_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'NewsroomFields_customHeader_signupLink_targetId'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_TargetId_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Type = {
  __typename?: 'NewsroomFields_customHeader_signupLink_type'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Type_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Url = {
  __typename?: 'NewsroomFields_customHeader_signupLink_url'
  create?: Maybe<NewsroomFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SignupLink_Url_Update>
}

export type NewsroomFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'NewsroomFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'NewsroomFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'NewsroomFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'NewsroomFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink = {
  __typename?: 'NewsroomFields_customHeader_supportLink'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<NewsroomFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'NewsroomFields_customHeader_supportLink_Fields'
  newTab?: Maybe<NewsroomFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<NewsroomFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<NewsroomFields_CustomHeader_SupportLink_Type>
  url?: Maybe<NewsroomFields_CustomHeader_SupportLink_Url>
}

export type NewsroomFields_CustomHeader_SupportLink_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'NewsroomFields_customHeader_supportLink_newTab'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_NewTab_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_Fields'
  id?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Value>
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_id'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_key'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_value'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reference'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reference_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reusable'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Reusable_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'NewsroomFields_customHeader_supportLink_targetId'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_TargetId_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Type = {
  __typename?: 'NewsroomFields_customHeader_supportLink_type'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Type_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Url = {
  __typename?: 'NewsroomFields_customHeader_supportLink_url'
  create?: Maybe<NewsroomFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<NewsroomFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<NewsroomFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<NewsroomFields_CustomHeader_SupportLink_Url_Update>
}

export type NewsroomFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'NewsroomFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'NewsroomFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'NewsroomFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'NewsroomFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Excerpt = {
  __typename?: 'NewsroomFields_excerpt'
  create?: Maybe<NewsroomFields_Excerpt_Create>
  delete?: Maybe<NewsroomFields_Excerpt_Delete>
  read?: Maybe<NewsroomFields_Excerpt_Read>
  update?: Maybe<NewsroomFields_Excerpt_Update>
}

export type NewsroomFields_Excerpt_Create = {
  __typename?: 'NewsroomFields_excerpt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Excerpt_Delete = {
  __typename?: 'NewsroomFields_excerpt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Excerpt_Read = {
  __typename?: 'NewsroomFields_excerpt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Excerpt_Update = {
  __typename?: 'NewsroomFields_excerpt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Image = {
  __typename?: 'NewsroomFields_image'
  create?: Maybe<NewsroomFields_Image_Create>
  delete?: Maybe<NewsroomFields_Image_Delete>
  read?: Maybe<NewsroomFields_Image_Read>
  update?: Maybe<NewsroomFields_Image_Update>
}

export type NewsroomFields_Image_Create = {
  __typename?: 'NewsroomFields_image_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Image_Delete = {
  __typename?: 'NewsroomFields_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Image_Read = {
  __typename?: 'NewsroomFields_image_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Image_Update = {
  __typename?: 'NewsroomFields_image_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Layout = {
  __typename?: 'NewsroomFields_layout'
  create?: Maybe<NewsroomFields_Layout_Create>
  delete?: Maybe<NewsroomFields_Layout_Delete>
  read?: Maybe<NewsroomFields_Layout_Read>
  update?: Maybe<NewsroomFields_Layout_Update>
}

export type NewsroomFields_Layout_Create = {
  __typename?: 'NewsroomFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Layout_Delete = {
  __typename?: 'NewsroomFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Layout_Read = {
  __typename?: 'NewsroomFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Layout_Update = {
  __typename?: 'NewsroomFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta = {
  __typename?: 'NewsroomFields_meta'
  create?: Maybe<NewsroomFields_Meta_Create>
  delete?: Maybe<NewsroomFields_Meta_Delete>
  fields?: Maybe<NewsroomFields_Meta_Fields>
  read?: Maybe<NewsroomFields_Meta_Read>
  update?: Maybe<NewsroomFields_Meta_Update>
}

export type NewsroomFields_Meta_Create = {
  __typename?: 'NewsroomFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Delete = {
  __typename?: 'NewsroomFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Fields = {
  __typename?: 'NewsroomFields_meta_Fields'
  description?: Maybe<NewsroomFields_Meta_Description>
  image?: Maybe<NewsroomFields_Meta_Image>
  jsonLD?: Maybe<NewsroomFields_Meta_JsonLd>
  noIndex?: Maybe<NewsroomFields_Meta_NoIndex>
  title?: Maybe<NewsroomFields_Meta_Title>
}

export type NewsroomFields_Meta_Read = {
  __typename?: 'NewsroomFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Update = {
  __typename?: 'NewsroomFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Description = {
  __typename?: 'NewsroomFields_meta_description'
  create?: Maybe<NewsroomFields_Meta_Description_Create>
  delete?: Maybe<NewsroomFields_Meta_Description_Delete>
  read?: Maybe<NewsroomFields_Meta_Description_Read>
  update?: Maybe<NewsroomFields_Meta_Description_Update>
}

export type NewsroomFields_Meta_Description_Create = {
  __typename?: 'NewsroomFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Description_Delete = {
  __typename?: 'NewsroomFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Description_Read = {
  __typename?: 'NewsroomFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Description_Update = {
  __typename?: 'NewsroomFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Image = {
  __typename?: 'NewsroomFields_meta_image'
  create?: Maybe<NewsroomFields_Meta_Image_Create>
  delete?: Maybe<NewsroomFields_Meta_Image_Delete>
  read?: Maybe<NewsroomFields_Meta_Image_Read>
  update?: Maybe<NewsroomFields_Meta_Image_Update>
}

export type NewsroomFields_Meta_Image_Create = {
  __typename?: 'NewsroomFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Image_Delete = {
  __typename?: 'NewsroomFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Image_Read = {
  __typename?: 'NewsroomFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Image_Update = {
  __typename?: 'NewsroomFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_JsonLd = {
  __typename?: 'NewsroomFields_meta_jsonLD'
  create?: Maybe<NewsroomFields_Meta_JsonLd_Create>
  delete?: Maybe<NewsroomFields_Meta_JsonLd_Delete>
  read?: Maybe<NewsroomFields_Meta_JsonLd_Read>
  update?: Maybe<NewsroomFields_Meta_JsonLd_Update>
}

export type NewsroomFields_Meta_JsonLd_Create = {
  __typename?: 'NewsroomFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_JsonLd_Delete = {
  __typename?: 'NewsroomFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_JsonLd_Read = {
  __typename?: 'NewsroomFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_JsonLd_Update = {
  __typename?: 'NewsroomFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_NoIndex = {
  __typename?: 'NewsroomFields_meta_noIndex'
  create?: Maybe<NewsroomFields_Meta_NoIndex_Create>
  delete?: Maybe<NewsroomFields_Meta_NoIndex_Delete>
  read?: Maybe<NewsroomFields_Meta_NoIndex_Read>
  update?: Maybe<NewsroomFields_Meta_NoIndex_Update>
}

export type NewsroomFields_Meta_NoIndex_Create = {
  __typename?: 'NewsroomFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_NoIndex_Delete = {
  __typename?: 'NewsroomFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_NoIndex_Read = {
  __typename?: 'NewsroomFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_NoIndex_Update = {
  __typename?: 'NewsroomFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Title = {
  __typename?: 'NewsroomFields_meta_title'
  create?: Maybe<NewsroomFields_Meta_Title_Create>
  delete?: Maybe<NewsroomFields_Meta_Title_Delete>
  read?: Maybe<NewsroomFields_Meta_Title_Read>
  update?: Maybe<NewsroomFields_Meta_Title_Update>
}

export type NewsroomFields_Meta_Title_Create = {
  __typename?: 'NewsroomFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Title_Delete = {
  __typename?: 'NewsroomFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Title_Read = {
  __typename?: 'NewsroomFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Meta_Title_Update = {
  __typename?: 'NewsroomFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_PublishedAt = {
  __typename?: 'NewsroomFields_publishedAt'
  create?: Maybe<NewsroomFields_PublishedAt_Create>
  delete?: Maybe<NewsroomFields_PublishedAt_Delete>
  read?: Maybe<NewsroomFields_PublishedAt_Read>
  update?: Maybe<NewsroomFields_PublishedAt_Update>
}

export type NewsroomFields_PublishedAt_Create = {
  __typename?: 'NewsroomFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_PublishedAt_Delete = {
  __typename?: 'NewsroomFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_PublishedAt_Read = {
  __typename?: 'NewsroomFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_PublishedAt_Update = {
  __typename?: 'NewsroomFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_RichText = {
  __typename?: 'NewsroomFields_richText'
  create?: Maybe<NewsroomFields_RichText_Create>
  delete?: Maybe<NewsroomFields_RichText_Delete>
  read?: Maybe<NewsroomFields_RichText_Read>
  update?: Maybe<NewsroomFields_RichText_Update>
}

export type NewsroomFields_RichText_Create = {
  __typename?: 'NewsroomFields_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_RichText_Delete = {
  __typename?: 'NewsroomFields_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_RichText_Read = {
  __typename?: 'NewsroomFields_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_RichText_Update = {
  __typename?: 'NewsroomFields_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Slug = {
  __typename?: 'NewsroomFields_slug'
  create?: Maybe<NewsroomFields_Slug_Create>
  delete?: Maybe<NewsroomFields_Slug_Delete>
  read?: Maybe<NewsroomFields_Slug_Read>
  update?: Maybe<NewsroomFields_Slug_Update>
}

export type NewsroomFields_Slug_Create = {
  __typename?: 'NewsroomFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Slug_Delete = {
  __typename?: 'NewsroomFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Slug_Read = {
  __typename?: 'NewsroomFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Slug_Update = {
  __typename?: 'NewsroomFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Title = {
  __typename?: 'NewsroomFields_title'
  create?: Maybe<NewsroomFields_Title_Create>
  delete?: Maybe<NewsroomFields_Title_Delete>
  read?: Maybe<NewsroomFields_Title_Read>
  update?: Maybe<NewsroomFields_Title_Update>
}

export type NewsroomFields_Title_Create = {
  __typename?: 'NewsroomFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Title_Delete = {
  __typename?: 'NewsroomFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Title_Read = {
  __typename?: 'NewsroomFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_Title_Update = {
  __typename?: 'NewsroomFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_UpdatedAt = {
  __typename?: 'NewsroomFields_updatedAt'
  create?: Maybe<NewsroomFields_UpdatedAt_Create>
  delete?: Maybe<NewsroomFields_UpdatedAt_Delete>
  read?: Maybe<NewsroomFields_UpdatedAt_Read>
  update?: Maybe<NewsroomFields_UpdatedAt_Update>
}

export type NewsroomFields_UpdatedAt_Create = {
  __typename?: 'NewsroomFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_UpdatedAt_Delete = {
  __typename?: 'NewsroomFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_UpdatedAt_Read = {
  __typename?: 'NewsroomFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_UpdatedAt_Update = {
  __typename?: 'NewsroomFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_WordpressPostId = {
  __typename?: 'NewsroomFields_wordpressPostId'
  create?: Maybe<NewsroomFields_WordpressPostId_Create>
  delete?: Maybe<NewsroomFields_WordpressPostId_Delete>
  read?: Maybe<NewsroomFields_WordpressPostId_Read>
  update?: Maybe<NewsroomFields_WordpressPostId_Update>
}

export type NewsroomFields_WordpressPostId_Create = {
  __typename?: 'NewsroomFields_wordpressPostId_Create'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_WordpressPostId_Delete = {
  __typename?: 'NewsroomFields_wordpressPostId_Delete'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_WordpressPostId_Read = {
  __typename?: 'NewsroomFields_wordpressPostId_Read'
  permission: Scalars['Boolean']['output']
}

export type NewsroomFields_WordpressPostId_Update = {
  __typename?: 'NewsroomFields_wordpressPostId_Update'
  permission: Scalars['Boolean']['output']
}

export type NewsroomReadAccess = {
  __typename?: 'NewsroomReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomReadDocAccess = {
  __typename?: 'NewsroomReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomReadVersionsAccess = {
  __typename?: 'NewsroomReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomReadVersionsDocAccess = {
  __typename?: 'NewsroomReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomUpdateAccess = {
  __typename?: 'NewsroomUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type NewsroomUpdateDocAccess = {
  __typename?: 'NewsroomUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesCreateAccess = {
  __typename?: 'PagesCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesCreateDocAccess = {
  __typename?: 'PagesCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesDeleteAccess = {
  __typename?: 'PagesDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesDeleteDocAccess = {
  __typename?: 'PagesDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesDocAccessFields = {
  __typename?: 'PagesDocAccessFields'
  _status?: Maybe<PagesDocAccessFields__Status>
  breadcrumbs?: Maybe<PagesDocAccessFields_Breadcrumbs>
  createdAt?: Maybe<PagesDocAccessFields_CreatedAt>
  createdBy?: Maybe<PagesDocAccessFields_CreatedBy>
  customFooter?: Maybe<PagesDocAccessFields_CustomFooter>
  customHeader?: Maybe<PagesDocAccessFields_CustomHeader>
  hero?: Maybe<PagesDocAccessFields_Hero>
  layout?: Maybe<PagesDocAccessFields_Layout>
  meta?: Maybe<PagesDocAccessFields_Meta>
  parent?: Maybe<PagesDocAccessFields_Parent>
  publishedAt?: Maybe<PagesDocAccessFields_PublishedAt>
  slug?: Maybe<PagesDocAccessFields_Slug>
  title?: Maybe<PagesDocAccessFields_Title>
  updatedAt?: Maybe<PagesDocAccessFields_UpdatedAt>
}

export type PagesDocAccessFields__Status = {
  __typename?: 'PagesDocAccessFields__status'
  create?: Maybe<PagesDocAccessFields__Status_Create>
  delete?: Maybe<PagesDocAccessFields__Status_Delete>
  read?: Maybe<PagesDocAccessFields__Status_Read>
  update?: Maybe<PagesDocAccessFields__Status_Update>
}

export type PagesDocAccessFields__Status_Create = {
  __typename?: 'PagesDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields__Status_Delete = {
  __typename?: 'PagesDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields__Status_Read = {
  __typename?: 'PagesDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields__Status_Update = {
  __typename?: 'PagesDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs = {
  __typename?: 'PagesDocAccessFields_breadcrumbs'
  create?: Maybe<PagesDocAccessFields_Breadcrumbs_Create>
  delete?: Maybe<PagesDocAccessFields_Breadcrumbs_Delete>
  fields?: Maybe<PagesDocAccessFields_Breadcrumbs_Fields>
  read?: Maybe<PagesDocAccessFields_Breadcrumbs_Read>
  update?: Maybe<PagesDocAccessFields_Breadcrumbs_Update>
}

export type PagesDocAccessFields_Breadcrumbs_Create = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Delete = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Fields = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_Fields'
  doc?: Maybe<PagesDocAccessFields_Breadcrumbs_Doc>
  id?: Maybe<PagesDocAccessFields_Breadcrumbs_Id>
  label?: Maybe<PagesDocAccessFields_Breadcrumbs_Label>
  url?: Maybe<PagesDocAccessFields_Breadcrumbs_Url>
}

export type PagesDocAccessFields_Breadcrumbs_Read = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Update = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Doc = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_doc'
  create?: Maybe<PagesDocAccessFields_Breadcrumbs_Doc_Create>
  delete?: Maybe<PagesDocAccessFields_Breadcrumbs_Doc_Delete>
  read?: Maybe<PagesDocAccessFields_Breadcrumbs_Doc_Read>
  update?: Maybe<PagesDocAccessFields_Breadcrumbs_Doc_Update>
}

export type PagesDocAccessFields_Breadcrumbs_Doc_Create = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_doc_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_doc_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Doc_Read = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_doc_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Doc_Update = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_doc_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Id = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_id'
  create?: Maybe<PagesDocAccessFields_Breadcrumbs_Id_Create>
  delete?: Maybe<PagesDocAccessFields_Breadcrumbs_Id_Delete>
  read?: Maybe<PagesDocAccessFields_Breadcrumbs_Id_Read>
  update?: Maybe<PagesDocAccessFields_Breadcrumbs_Id_Update>
}

export type PagesDocAccessFields_Breadcrumbs_Id_Create = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Id_Delete = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Id_Read = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Id_Update = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Label = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_label'
  create?: Maybe<PagesDocAccessFields_Breadcrumbs_Label_Create>
  delete?: Maybe<PagesDocAccessFields_Breadcrumbs_Label_Delete>
  read?: Maybe<PagesDocAccessFields_Breadcrumbs_Label_Read>
  update?: Maybe<PagesDocAccessFields_Breadcrumbs_Label_Update>
}

export type PagesDocAccessFields_Breadcrumbs_Label_Create = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_label_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Label_Delete = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Label_Read = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_label_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Label_Update = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_label_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Url = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_url'
  create?: Maybe<PagesDocAccessFields_Breadcrumbs_Url_Create>
  delete?: Maybe<PagesDocAccessFields_Breadcrumbs_Url_Delete>
  read?: Maybe<PagesDocAccessFields_Breadcrumbs_Url_Read>
  update?: Maybe<PagesDocAccessFields_Breadcrumbs_Url_Update>
}

export type PagesDocAccessFields_Breadcrumbs_Url_Create = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Url_Delete = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Url_Read = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Breadcrumbs_Url_Update = {
  __typename?: 'PagesDocAccessFields_breadcrumbs_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedAt = {
  __typename?: 'PagesDocAccessFields_createdAt'
  create?: Maybe<PagesDocAccessFields_CreatedAt_Create>
  delete?: Maybe<PagesDocAccessFields_CreatedAt_Delete>
  read?: Maybe<PagesDocAccessFields_CreatedAt_Read>
  update?: Maybe<PagesDocAccessFields_CreatedAt_Update>
}

export type PagesDocAccessFields_CreatedAt_Create = {
  __typename?: 'PagesDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PagesDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedAt_Read = {
  __typename?: 'PagesDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedAt_Update = {
  __typename?: 'PagesDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedBy = {
  __typename?: 'PagesDocAccessFields_createdBy'
  create?: Maybe<PagesDocAccessFields_CreatedBy_Create>
  delete?: Maybe<PagesDocAccessFields_CreatedBy_Delete>
  read?: Maybe<PagesDocAccessFields_CreatedBy_Read>
  update?: Maybe<PagesDocAccessFields_CreatedBy_Update>
}

export type PagesDocAccessFields_CreatedBy_Create = {
  __typename?: 'PagesDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedBy_Delete = {
  __typename?: 'PagesDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedBy_Read = {
  __typename?: 'PagesDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CreatedBy_Update = {
  __typename?: 'PagesDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter = {
  __typename?: 'PagesDocAccessFields_customFooter'
  create?: Maybe<PagesDocAccessFields_CustomFooter_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomFooter_Fields>
  read?: Maybe<PagesDocAccessFields_CustomFooter_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_Update>
}

export type PagesDocAccessFields_CustomFooter_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Fields = {
  __typename?: 'PagesDocAccessFields_customFooter_Fields'
  disclaimers?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<PagesDocAccessFields_CustomFooter_IsHidden>
}

export type PagesDocAccessFields_CustomFooter_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers'
  create?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Update>
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_Fields'
  align?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Text>
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_align'
  create?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Align_Update>
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_id'
  create?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Id_Update>
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_number'
  create?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Number_Update>
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_text'
  create?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_Disclaimers_Text_Update>
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_IsHidden = {
  __typename?: 'PagesDocAccessFields_customFooter_isHidden'
  create?: Maybe<PagesDocAccessFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<PagesDocAccessFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<PagesDocAccessFields_CustomFooter_IsHidden_Read>
  update?: Maybe<PagesDocAccessFields_CustomFooter_IsHidden_Update>
}

export type PagesDocAccessFields_CustomFooter_IsHidden_Create = {
  __typename?: 'PagesDocAccessFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'PagesDocAccessFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_IsHidden_Read = {
  __typename?: 'PagesDocAccessFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomFooter_IsHidden_Update = {
  __typename?: 'PagesDocAccessFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader = {
  __typename?: 'PagesDocAccessFields_customHeader'
  create?: Maybe<PagesDocAccessFields_CustomHeader_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomHeader_Fields>
  read?: Maybe<PagesDocAccessFields_CustomHeader_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_Update>
}

export type PagesDocAccessFields_CustomHeader_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_Fields = {
  __typename?: 'PagesDocAccessFields_customHeader_Fields'
  headerDisplay?: Maybe<PagesDocAccessFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<PagesDocAccessFields_CustomHeader_IsHidden>
  loginLink?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink>
  signupLink?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink>
  supportLink?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink>
}

export type PagesDocAccessFields_CustomHeader_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_HeaderDisplay = {
  __typename?: 'PagesDocAccessFields_customHeader_headerDisplay'
  create?: Maybe<PagesDocAccessFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_HeaderDisplay_Update>
}

export type PagesDocAccessFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_IsHidden = {
  __typename?: 'PagesDocAccessFields_customHeader_isHidden'
  create?: Maybe<PagesDocAccessFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_IsHidden_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_IsHidden_Update>
}

export type PagesDocAccessFields_CustomHeader_IsHidden_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_IsHidden_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_IsHidden_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_Fields'
  newTab?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Type>
  url?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Url>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_newTab'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_Fields'
  id?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Value>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_id'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_key'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_value'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reference'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reference_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reusable'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_targetId'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Type = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_type'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Type_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Url = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_url'
  create?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_LoginLink_Url_Update>
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_Fields'
  newTab?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Type>
  url?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Url>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_newTab'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_Fields'
  id?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Value>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_id'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_key'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_value'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reference'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reference_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reusable'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_targetId'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Type = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_type'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Type_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Url = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_url'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SignupLink_Url_Update>
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_Fields'
  newTab?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Type>
  url?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Url>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_newTab'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_Fields'
  id?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Value>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_id'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_key'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_value'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reference'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reference_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reusable'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_targetId'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Type = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_type'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Type_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Url = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_url'
  create?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<PagesDocAccessFields_CustomHeader_SupportLink_Url_Update>
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'PagesDocAccessFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero = {
  __typename?: 'PagesDocAccessFields_hero'
  create?: Maybe<PagesDocAccessFields_Hero_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Delete>
  fields?: Maybe<PagesDocAccessFields_Hero_Fields>
  read?: Maybe<PagesDocAccessFields_Hero_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Update>
}

export type PagesDocAccessFields_Hero_Create = {
  __typename?: 'PagesDocAccessFields_hero_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Delete = {
  __typename?: 'PagesDocAccessFields_hero_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Fields = {
  __typename?: 'PagesDocAccessFields_hero_Fields'
  desktopFallback?: Maybe<PagesDocAccessFields_Hero_DesktopFallback>
  desktopVideo?: Maybe<PagesDocAccessFields_Hero_DesktopVideo>
  disclaimerText?: Maybe<PagesDocAccessFields_Hero_DisclaimerText>
  heroSize?: Maybe<PagesDocAccessFields_Hero_HeroSize>
  hzAlign?: Maybe<PagesDocAccessFields_Hero_HzAlign>
  links?: Maybe<PagesDocAccessFields_Hero_Links>
  media?: Maybe<PagesDocAccessFields_Hero_Media>
  mobileFallback?: Maybe<PagesDocAccessFields_Hero_MobileFallback>
  mobileVideo?: Maybe<PagesDocAccessFields_Hero_MobileVideo>
  productImage?: Maybe<PagesDocAccessFields_Hero_ProductImage>
  reviewRating?: Maybe<PagesDocAccessFields_Hero_ReviewRating>
  reviewText?: Maybe<PagesDocAccessFields_Hero_ReviewText>
  richText?: Maybe<PagesDocAccessFields_Hero_RichText>
  richTextMax?: Maybe<PagesDocAccessFields_Hero_RichTextMax>
  showReviews?: Maybe<PagesDocAccessFields_Hero_ShowReviews>
  type?: Maybe<PagesDocAccessFields_Hero_Type>
  vertAlign?: Maybe<PagesDocAccessFields_Hero_VertAlign>
}

export type PagesDocAccessFields_Hero_Read = {
  __typename?: 'PagesDocAccessFields_hero_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Update = {
  __typename?: 'PagesDocAccessFields_hero_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopFallback = {
  __typename?: 'PagesDocAccessFields_hero_desktopFallback'
  create?: Maybe<PagesDocAccessFields_Hero_DesktopFallback_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_DesktopFallback_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_DesktopFallback_Read>
  update?: Maybe<PagesDocAccessFields_Hero_DesktopFallback_Update>
}

export type PagesDocAccessFields_Hero_DesktopFallback_Create = {
  __typename?: 'PagesDocAccessFields_hero_desktopFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopFallback_Delete = {
  __typename?: 'PagesDocAccessFields_hero_desktopFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopFallback_Read = {
  __typename?: 'PagesDocAccessFields_hero_desktopFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopFallback_Update = {
  __typename?: 'PagesDocAccessFields_hero_desktopFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopVideo = {
  __typename?: 'PagesDocAccessFields_hero_desktopVideo'
  create?: Maybe<PagesDocAccessFields_Hero_DesktopVideo_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_DesktopVideo_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_DesktopVideo_Read>
  update?: Maybe<PagesDocAccessFields_Hero_DesktopVideo_Update>
}

export type PagesDocAccessFields_Hero_DesktopVideo_Create = {
  __typename?: 'PagesDocAccessFields_hero_desktopVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopVideo_Delete = {
  __typename?: 'PagesDocAccessFields_hero_desktopVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopVideo_Read = {
  __typename?: 'PagesDocAccessFields_hero_desktopVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DesktopVideo_Update = {
  __typename?: 'PagesDocAccessFields_hero_desktopVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DisclaimerText = {
  __typename?: 'PagesDocAccessFields_hero_disclaimerText'
  create?: Maybe<PagesDocAccessFields_Hero_DisclaimerText_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_DisclaimerText_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_DisclaimerText_Read>
  update?: Maybe<PagesDocAccessFields_Hero_DisclaimerText_Update>
}

export type PagesDocAccessFields_Hero_DisclaimerText_Create = {
  __typename?: 'PagesDocAccessFields_hero_disclaimerText_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DisclaimerText_Delete = {
  __typename?: 'PagesDocAccessFields_hero_disclaimerText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DisclaimerText_Read = {
  __typename?: 'PagesDocAccessFields_hero_disclaimerText_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_DisclaimerText_Update = {
  __typename?: 'PagesDocAccessFields_hero_disclaimerText_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HeroSize = {
  __typename?: 'PagesDocAccessFields_hero_heroSize'
  create?: Maybe<PagesDocAccessFields_Hero_HeroSize_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_HeroSize_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_HeroSize_Read>
  update?: Maybe<PagesDocAccessFields_Hero_HeroSize_Update>
}

export type PagesDocAccessFields_Hero_HeroSize_Create = {
  __typename?: 'PagesDocAccessFields_hero_heroSize_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HeroSize_Delete = {
  __typename?: 'PagesDocAccessFields_hero_heroSize_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HeroSize_Read = {
  __typename?: 'PagesDocAccessFields_hero_heroSize_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HeroSize_Update = {
  __typename?: 'PagesDocAccessFields_hero_heroSize_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HzAlign = {
  __typename?: 'PagesDocAccessFields_hero_hzAlign'
  create?: Maybe<PagesDocAccessFields_Hero_HzAlign_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_HzAlign_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_HzAlign_Read>
  update?: Maybe<PagesDocAccessFields_Hero_HzAlign_Update>
}

export type PagesDocAccessFields_Hero_HzAlign_Create = {
  __typename?: 'PagesDocAccessFields_hero_hzAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HzAlign_Delete = {
  __typename?: 'PagesDocAccessFields_hero_hzAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HzAlign_Read = {
  __typename?: 'PagesDocAccessFields_hero_hzAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_HzAlign_Update = {
  __typename?: 'PagesDocAccessFields_hero_hzAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links = {
  __typename?: 'PagesDocAccessFields_hero_links'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Delete>
  fields?: Maybe<PagesDocAccessFields_Hero_Links_Fields>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Update>
}

export type PagesDocAccessFields_Hero_Links_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Fields = {
  __typename?: 'PagesDocAccessFields_hero_links_Fields'
  id?: Maybe<PagesDocAccessFields_Hero_Links_Id>
  link?: Maybe<PagesDocAccessFields_Hero_Links_Link>
}

export type PagesDocAccessFields_Hero_Links_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Id = {
  __typename?: 'PagesDocAccessFields_hero_links_id'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Id_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Id_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Id_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Id_Update>
}

export type PagesDocAccessFields_Hero_Links_Id_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Id_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Id_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Id_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link = {
  __typename?: 'PagesDocAccessFields_hero_links_link'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Delete>
  fields?: Maybe<PagesDocAccessFields_Hero_Links_Link_Fields>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Fields = {
  __typename?: 'PagesDocAccessFields_hero_links_link_Fields'
  iconAfter?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconAfter>
  iconBefore?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconBefore>
  label?: Maybe<PagesDocAccessFields_Hero_Links_Link_Label>
  newTab?: Maybe<PagesDocAccessFields_Hero_Links_Link_NewTab>
  query?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query>
  reference?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reference>
  reusable?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reusable>
  targetId?: Maybe<PagesDocAccessFields_Hero_Links_Link_TargetId>
  type?: Maybe<PagesDocAccessFields_Hero_Links_Link_Type>
  url?: Maybe<PagesDocAccessFields_Hero_Links_Link_Url>
  variant?: Maybe<PagesDocAccessFields_Hero_Links_Link_Variant>
}

export type PagesDocAccessFields_Hero_Links_Link_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconAfter = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconAfter'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconAfter_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconAfter_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconAfter_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconAfter_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_IconAfter_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconAfter_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconAfter_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconAfter_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconBefore = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconBefore'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconBefore_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconBefore_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconBefore_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_IconBefore_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_IconBefore_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconBefore_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconBefore_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_IconBefore_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Label = {
  __typename?: 'PagesDocAccessFields_hero_links_link_label'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Label_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Label_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Label_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Label_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Label_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Label_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Label_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Label_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_NewTab = {
  __typename?: 'PagesDocAccessFields_hero_links_link_newTab'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_NewTab_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_NewTab_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_NewTab_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_NewTab_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_NewTab_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_NewTab_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_NewTab_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_NewTab_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Delete>
  fields?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Fields>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Fields = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_Fields'
  id?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Id>
  key?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Key>
  value?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Value>
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Id = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_id'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Id_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Id_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Id_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Id_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Id_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Id_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Id_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Id_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Key = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_key'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Key_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Key_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Key_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Key_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Key_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Key_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Key_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Key_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Value = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_value'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Value_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Value_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Value_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Query_Value_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Value_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Value_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Value_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Query_Value_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reference = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reference'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reference_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reference_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reference_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reference_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Reference_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reference_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reference_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reference_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reusable = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reusable'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reusable_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reusable_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reusable_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Reusable_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Reusable_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reusable_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reusable_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Reusable_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_TargetId = {
  __typename?: 'PagesDocAccessFields_hero_links_link_targetId'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_TargetId_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_TargetId_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_TargetId_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_TargetId_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_TargetId_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_TargetId_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_TargetId_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_TargetId_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Type = {
  __typename?: 'PagesDocAccessFields_hero_links_link_type'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Type_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Type_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Type_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Type_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Type_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Type_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Type_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Type_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Url = {
  __typename?: 'PagesDocAccessFields_hero_links_link_url'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Url_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Url_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Url_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Url_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Url_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Url_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Url_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Url_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Variant = {
  __typename?: 'PagesDocAccessFields_hero_links_link_variant'
  create?: Maybe<PagesDocAccessFields_Hero_Links_Link_Variant_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Links_Link_Variant_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Links_Link_Variant_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Links_Link_Variant_Update>
}

export type PagesDocAccessFields_Hero_Links_Link_Variant_Create = {
  __typename?: 'PagesDocAccessFields_hero_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Variant_Delete = {
  __typename?: 'PagesDocAccessFields_hero_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Variant_Read = {
  __typename?: 'PagesDocAccessFields_hero_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Links_Link_Variant_Update = {
  __typename?: 'PagesDocAccessFields_hero_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Media = {
  __typename?: 'PagesDocAccessFields_hero_media'
  create?: Maybe<PagesDocAccessFields_Hero_Media_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Media_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Media_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Media_Update>
}

export type PagesDocAccessFields_Hero_Media_Create = {
  __typename?: 'PagesDocAccessFields_hero_media_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Media_Delete = {
  __typename?: 'PagesDocAccessFields_hero_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Media_Read = {
  __typename?: 'PagesDocAccessFields_hero_media_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Media_Update = {
  __typename?: 'PagesDocAccessFields_hero_media_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileFallback = {
  __typename?: 'PagesDocAccessFields_hero_mobileFallback'
  create?: Maybe<PagesDocAccessFields_Hero_MobileFallback_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_MobileFallback_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_MobileFallback_Read>
  update?: Maybe<PagesDocAccessFields_Hero_MobileFallback_Update>
}

export type PagesDocAccessFields_Hero_MobileFallback_Create = {
  __typename?: 'PagesDocAccessFields_hero_mobileFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileFallback_Delete = {
  __typename?: 'PagesDocAccessFields_hero_mobileFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileFallback_Read = {
  __typename?: 'PagesDocAccessFields_hero_mobileFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileFallback_Update = {
  __typename?: 'PagesDocAccessFields_hero_mobileFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileVideo = {
  __typename?: 'PagesDocAccessFields_hero_mobileVideo'
  create?: Maybe<PagesDocAccessFields_Hero_MobileVideo_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_MobileVideo_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_MobileVideo_Read>
  update?: Maybe<PagesDocAccessFields_Hero_MobileVideo_Update>
}

export type PagesDocAccessFields_Hero_MobileVideo_Create = {
  __typename?: 'PagesDocAccessFields_hero_mobileVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileVideo_Delete = {
  __typename?: 'PagesDocAccessFields_hero_mobileVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileVideo_Read = {
  __typename?: 'PagesDocAccessFields_hero_mobileVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_MobileVideo_Update = {
  __typename?: 'PagesDocAccessFields_hero_mobileVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ProductImage = {
  __typename?: 'PagesDocAccessFields_hero_productImage'
  create?: Maybe<PagesDocAccessFields_Hero_ProductImage_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_ProductImage_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_ProductImage_Read>
  update?: Maybe<PagesDocAccessFields_Hero_ProductImage_Update>
}

export type PagesDocAccessFields_Hero_ProductImage_Create = {
  __typename?: 'PagesDocAccessFields_hero_productImage_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ProductImage_Delete = {
  __typename?: 'PagesDocAccessFields_hero_productImage_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ProductImage_Read = {
  __typename?: 'PagesDocAccessFields_hero_productImage_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ProductImage_Update = {
  __typename?: 'PagesDocAccessFields_hero_productImage_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewRating = {
  __typename?: 'PagesDocAccessFields_hero_reviewRating'
  create?: Maybe<PagesDocAccessFields_Hero_ReviewRating_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_ReviewRating_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_ReviewRating_Read>
  update?: Maybe<PagesDocAccessFields_Hero_ReviewRating_Update>
}

export type PagesDocAccessFields_Hero_ReviewRating_Create = {
  __typename?: 'PagesDocAccessFields_hero_reviewRating_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewRating_Delete = {
  __typename?: 'PagesDocAccessFields_hero_reviewRating_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewRating_Read = {
  __typename?: 'PagesDocAccessFields_hero_reviewRating_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewRating_Update = {
  __typename?: 'PagesDocAccessFields_hero_reviewRating_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewText = {
  __typename?: 'PagesDocAccessFields_hero_reviewText'
  create?: Maybe<PagesDocAccessFields_Hero_ReviewText_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_ReviewText_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_ReviewText_Read>
  update?: Maybe<PagesDocAccessFields_Hero_ReviewText_Update>
}

export type PagesDocAccessFields_Hero_ReviewText_Create = {
  __typename?: 'PagesDocAccessFields_hero_reviewText_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewText_Delete = {
  __typename?: 'PagesDocAccessFields_hero_reviewText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewText_Read = {
  __typename?: 'PagesDocAccessFields_hero_reviewText_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ReviewText_Update = {
  __typename?: 'PagesDocAccessFields_hero_reviewText_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichText = {
  __typename?: 'PagesDocAccessFields_hero_richText'
  create?: Maybe<PagesDocAccessFields_Hero_RichText_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_RichText_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_RichText_Read>
  update?: Maybe<PagesDocAccessFields_Hero_RichText_Update>
}

export type PagesDocAccessFields_Hero_RichTextMax = {
  __typename?: 'PagesDocAccessFields_hero_richTextMax'
  create?: Maybe<PagesDocAccessFields_Hero_RichTextMax_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_RichTextMax_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_RichTextMax_Read>
  update?: Maybe<PagesDocAccessFields_Hero_RichTextMax_Update>
}

export type PagesDocAccessFields_Hero_RichTextMax_Create = {
  __typename?: 'PagesDocAccessFields_hero_richTextMax_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichTextMax_Delete = {
  __typename?: 'PagesDocAccessFields_hero_richTextMax_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichTextMax_Read = {
  __typename?: 'PagesDocAccessFields_hero_richTextMax_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichTextMax_Update = {
  __typename?: 'PagesDocAccessFields_hero_richTextMax_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichText_Create = {
  __typename?: 'PagesDocAccessFields_hero_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichText_Delete = {
  __typename?: 'PagesDocAccessFields_hero_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichText_Read = {
  __typename?: 'PagesDocAccessFields_hero_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_RichText_Update = {
  __typename?: 'PagesDocAccessFields_hero_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ShowReviews = {
  __typename?: 'PagesDocAccessFields_hero_showReviews'
  create?: Maybe<PagesDocAccessFields_Hero_ShowReviews_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_ShowReviews_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_ShowReviews_Read>
  update?: Maybe<PagesDocAccessFields_Hero_ShowReviews_Update>
}

export type PagesDocAccessFields_Hero_ShowReviews_Create = {
  __typename?: 'PagesDocAccessFields_hero_showReviews_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ShowReviews_Delete = {
  __typename?: 'PagesDocAccessFields_hero_showReviews_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ShowReviews_Read = {
  __typename?: 'PagesDocAccessFields_hero_showReviews_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_ShowReviews_Update = {
  __typename?: 'PagesDocAccessFields_hero_showReviews_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Type = {
  __typename?: 'PagesDocAccessFields_hero_type'
  create?: Maybe<PagesDocAccessFields_Hero_Type_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_Type_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_Type_Read>
  update?: Maybe<PagesDocAccessFields_Hero_Type_Update>
}

export type PagesDocAccessFields_Hero_Type_Create = {
  __typename?: 'PagesDocAccessFields_hero_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Type_Delete = {
  __typename?: 'PagesDocAccessFields_hero_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Type_Read = {
  __typename?: 'PagesDocAccessFields_hero_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_Type_Update = {
  __typename?: 'PagesDocAccessFields_hero_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_VertAlign = {
  __typename?: 'PagesDocAccessFields_hero_vertAlign'
  create?: Maybe<PagesDocAccessFields_Hero_VertAlign_Create>
  delete?: Maybe<PagesDocAccessFields_Hero_VertAlign_Delete>
  read?: Maybe<PagesDocAccessFields_Hero_VertAlign_Read>
  update?: Maybe<PagesDocAccessFields_Hero_VertAlign_Update>
}

export type PagesDocAccessFields_Hero_VertAlign_Create = {
  __typename?: 'PagesDocAccessFields_hero_vertAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_VertAlign_Delete = {
  __typename?: 'PagesDocAccessFields_hero_vertAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_VertAlign_Read = {
  __typename?: 'PagesDocAccessFields_hero_vertAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Hero_VertAlign_Update = {
  __typename?: 'PagesDocAccessFields_hero_vertAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Layout = {
  __typename?: 'PagesDocAccessFields_layout'
  create?: Maybe<PagesDocAccessFields_Layout_Create>
  delete?: Maybe<PagesDocAccessFields_Layout_Delete>
  read?: Maybe<PagesDocAccessFields_Layout_Read>
  update?: Maybe<PagesDocAccessFields_Layout_Update>
}

export type PagesDocAccessFields_Layout_Create = {
  __typename?: 'PagesDocAccessFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Layout_Delete = {
  __typename?: 'PagesDocAccessFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Layout_Read = {
  __typename?: 'PagesDocAccessFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Layout_Update = {
  __typename?: 'PagesDocAccessFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta = {
  __typename?: 'PagesDocAccessFields_meta'
  create?: Maybe<PagesDocAccessFields_Meta_Create>
  delete?: Maybe<PagesDocAccessFields_Meta_Delete>
  fields?: Maybe<PagesDocAccessFields_Meta_Fields>
  read?: Maybe<PagesDocAccessFields_Meta_Read>
  update?: Maybe<PagesDocAccessFields_Meta_Update>
}

export type PagesDocAccessFields_Meta_Create = {
  __typename?: 'PagesDocAccessFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Delete = {
  __typename?: 'PagesDocAccessFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Fields = {
  __typename?: 'PagesDocAccessFields_meta_Fields'
  description?: Maybe<PagesDocAccessFields_Meta_Description>
  image?: Maybe<PagesDocAccessFields_Meta_Image>
  jsonLD?: Maybe<PagesDocAccessFields_Meta_JsonLd>
  noIndex?: Maybe<PagesDocAccessFields_Meta_NoIndex>
  title?: Maybe<PagesDocAccessFields_Meta_Title>
}

export type PagesDocAccessFields_Meta_Read = {
  __typename?: 'PagesDocAccessFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Update = {
  __typename?: 'PagesDocAccessFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Description = {
  __typename?: 'PagesDocAccessFields_meta_description'
  create?: Maybe<PagesDocAccessFields_Meta_Description_Create>
  delete?: Maybe<PagesDocAccessFields_Meta_Description_Delete>
  read?: Maybe<PagesDocAccessFields_Meta_Description_Read>
  update?: Maybe<PagesDocAccessFields_Meta_Description_Update>
}

export type PagesDocAccessFields_Meta_Description_Create = {
  __typename?: 'PagesDocAccessFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Description_Delete = {
  __typename?: 'PagesDocAccessFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Description_Read = {
  __typename?: 'PagesDocAccessFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Description_Update = {
  __typename?: 'PagesDocAccessFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Image = {
  __typename?: 'PagesDocAccessFields_meta_image'
  create?: Maybe<PagesDocAccessFields_Meta_Image_Create>
  delete?: Maybe<PagesDocAccessFields_Meta_Image_Delete>
  read?: Maybe<PagesDocAccessFields_Meta_Image_Read>
  update?: Maybe<PagesDocAccessFields_Meta_Image_Update>
}

export type PagesDocAccessFields_Meta_Image_Create = {
  __typename?: 'PagesDocAccessFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Image_Delete = {
  __typename?: 'PagesDocAccessFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Image_Read = {
  __typename?: 'PagesDocAccessFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Image_Update = {
  __typename?: 'PagesDocAccessFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_JsonLd = {
  __typename?: 'PagesDocAccessFields_meta_jsonLD'
  create?: Maybe<PagesDocAccessFields_Meta_JsonLd_Create>
  delete?: Maybe<PagesDocAccessFields_Meta_JsonLd_Delete>
  read?: Maybe<PagesDocAccessFields_Meta_JsonLd_Read>
  update?: Maybe<PagesDocAccessFields_Meta_JsonLd_Update>
}

export type PagesDocAccessFields_Meta_JsonLd_Create = {
  __typename?: 'PagesDocAccessFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_JsonLd_Delete = {
  __typename?: 'PagesDocAccessFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_JsonLd_Read = {
  __typename?: 'PagesDocAccessFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_JsonLd_Update = {
  __typename?: 'PagesDocAccessFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_NoIndex = {
  __typename?: 'PagesDocAccessFields_meta_noIndex'
  create?: Maybe<PagesDocAccessFields_Meta_NoIndex_Create>
  delete?: Maybe<PagesDocAccessFields_Meta_NoIndex_Delete>
  read?: Maybe<PagesDocAccessFields_Meta_NoIndex_Read>
  update?: Maybe<PagesDocAccessFields_Meta_NoIndex_Update>
}

export type PagesDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'PagesDocAccessFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'PagesDocAccessFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'PagesDocAccessFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'PagesDocAccessFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Title = {
  __typename?: 'PagesDocAccessFields_meta_title'
  create?: Maybe<PagesDocAccessFields_Meta_Title_Create>
  delete?: Maybe<PagesDocAccessFields_Meta_Title_Delete>
  read?: Maybe<PagesDocAccessFields_Meta_Title_Read>
  update?: Maybe<PagesDocAccessFields_Meta_Title_Update>
}

export type PagesDocAccessFields_Meta_Title_Create = {
  __typename?: 'PagesDocAccessFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Title_Delete = {
  __typename?: 'PagesDocAccessFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Title_Read = {
  __typename?: 'PagesDocAccessFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Meta_Title_Update = {
  __typename?: 'PagesDocAccessFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Parent = {
  __typename?: 'PagesDocAccessFields_parent'
  create?: Maybe<PagesDocAccessFields_Parent_Create>
  delete?: Maybe<PagesDocAccessFields_Parent_Delete>
  read?: Maybe<PagesDocAccessFields_Parent_Read>
  update?: Maybe<PagesDocAccessFields_Parent_Update>
}

export type PagesDocAccessFields_Parent_Create = {
  __typename?: 'PagesDocAccessFields_parent_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Parent_Delete = {
  __typename?: 'PagesDocAccessFields_parent_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Parent_Read = {
  __typename?: 'PagesDocAccessFields_parent_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Parent_Update = {
  __typename?: 'PagesDocAccessFields_parent_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_PublishedAt = {
  __typename?: 'PagesDocAccessFields_publishedAt'
  create?: Maybe<PagesDocAccessFields_PublishedAt_Create>
  delete?: Maybe<PagesDocAccessFields_PublishedAt_Delete>
  read?: Maybe<PagesDocAccessFields_PublishedAt_Read>
  update?: Maybe<PagesDocAccessFields_PublishedAt_Update>
}

export type PagesDocAccessFields_PublishedAt_Create = {
  __typename?: 'PagesDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_PublishedAt_Delete = {
  __typename?: 'PagesDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_PublishedAt_Read = {
  __typename?: 'PagesDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_PublishedAt_Update = {
  __typename?: 'PagesDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Slug = {
  __typename?: 'PagesDocAccessFields_slug'
  create?: Maybe<PagesDocAccessFields_Slug_Create>
  delete?: Maybe<PagesDocAccessFields_Slug_Delete>
  read?: Maybe<PagesDocAccessFields_Slug_Read>
  update?: Maybe<PagesDocAccessFields_Slug_Update>
}

export type PagesDocAccessFields_Slug_Create = {
  __typename?: 'PagesDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Slug_Delete = {
  __typename?: 'PagesDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Slug_Read = {
  __typename?: 'PagesDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Slug_Update = {
  __typename?: 'PagesDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Title = {
  __typename?: 'PagesDocAccessFields_title'
  create?: Maybe<PagesDocAccessFields_Title_Create>
  delete?: Maybe<PagesDocAccessFields_Title_Delete>
  read?: Maybe<PagesDocAccessFields_Title_Read>
  update?: Maybe<PagesDocAccessFields_Title_Update>
}

export type PagesDocAccessFields_Title_Create = {
  __typename?: 'PagesDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Title_Delete = {
  __typename?: 'PagesDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Title_Read = {
  __typename?: 'PagesDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_Title_Update = {
  __typename?: 'PagesDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_UpdatedAt = {
  __typename?: 'PagesDocAccessFields_updatedAt'
  create?: Maybe<PagesDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<PagesDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<PagesDocAccessFields_UpdatedAt_Read>
  update?: Maybe<PagesDocAccessFields_UpdatedAt_Update>
}

export type PagesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PagesDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PagesDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PagesDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PagesDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields = {
  __typename?: 'PagesFields'
  _status?: Maybe<PagesFields__Status>
  breadcrumbs?: Maybe<PagesFields_Breadcrumbs>
  createdAt?: Maybe<PagesFields_CreatedAt>
  createdBy?: Maybe<PagesFields_CreatedBy>
  customFooter?: Maybe<PagesFields_CustomFooter>
  customHeader?: Maybe<PagesFields_CustomHeader>
  hero?: Maybe<PagesFields_Hero>
  layout?: Maybe<PagesFields_Layout>
  meta?: Maybe<PagesFields_Meta>
  parent?: Maybe<PagesFields_Parent>
  publishedAt?: Maybe<PagesFields_PublishedAt>
  slug?: Maybe<PagesFields_Slug>
  title?: Maybe<PagesFields_Title>
  updatedAt?: Maybe<PagesFields_UpdatedAt>
}

export type PagesFields__Status = {
  __typename?: 'PagesFields__status'
  create?: Maybe<PagesFields__Status_Create>
  delete?: Maybe<PagesFields__Status_Delete>
  read?: Maybe<PagesFields__Status_Read>
  update?: Maybe<PagesFields__Status_Update>
}

export type PagesFields__Status_Create = {
  __typename?: 'PagesFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields__Status_Delete = {
  __typename?: 'PagesFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields__Status_Read = {
  __typename?: 'PagesFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields__Status_Update = {
  __typename?: 'PagesFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs = {
  __typename?: 'PagesFields_breadcrumbs'
  create?: Maybe<PagesFields_Breadcrumbs_Create>
  delete?: Maybe<PagesFields_Breadcrumbs_Delete>
  fields?: Maybe<PagesFields_Breadcrumbs_Fields>
  read?: Maybe<PagesFields_Breadcrumbs_Read>
  update?: Maybe<PagesFields_Breadcrumbs_Update>
}

export type PagesFields_Breadcrumbs_Create = {
  __typename?: 'PagesFields_breadcrumbs_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Delete = {
  __typename?: 'PagesFields_breadcrumbs_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Fields = {
  __typename?: 'PagesFields_breadcrumbs_Fields'
  doc?: Maybe<PagesFields_Breadcrumbs_Doc>
  id?: Maybe<PagesFields_Breadcrumbs_Id>
  label?: Maybe<PagesFields_Breadcrumbs_Label>
  url?: Maybe<PagesFields_Breadcrumbs_Url>
}

export type PagesFields_Breadcrumbs_Read = {
  __typename?: 'PagesFields_breadcrumbs_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Update = {
  __typename?: 'PagesFields_breadcrumbs_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Doc = {
  __typename?: 'PagesFields_breadcrumbs_doc'
  create?: Maybe<PagesFields_Breadcrumbs_Doc_Create>
  delete?: Maybe<PagesFields_Breadcrumbs_Doc_Delete>
  read?: Maybe<PagesFields_Breadcrumbs_Doc_Read>
  update?: Maybe<PagesFields_Breadcrumbs_Doc_Update>
}

export type PagesFields_Breadcrumbs_Doc_Create = {
  __typename?: 'PagesFields_breadcrumbs_doc_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Doc_Delete = {
  __typename?: 'PagesFields_breadcrumbs_doc_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Doc_Read = {
  __typename?: 'PagesFields_breadcrumbs_doc_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Doc_Update = {
  __typename?: 'PagesFields_breadcrumbs_doc_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Id = {
  __typename?: 'PagesFields_breadcrumbs_id'
  create?: Maybe<PagesFields_Breadcrumbs_Id_Create>
  delete?: Maybe<PagesFields_Breadcrumbs_Id_Delete>
  read?: Maybe<PagesFields_Breadcrumbs_Id_Read>
  update?: Maybe<PagesFields_Breadcrumbs_Id_Update>
}

export type PagesFields_Breadcrumbs_Id_Create = {
  __typename?: 'PagesFields_breadcrumbs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Id_Delete = {
  __typename?: 'PagesFields_breadcrumbs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Id_Read = {
  __typename?: 'PagesFields_breadcrumbs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Id_Update = {
  __typename?: 'PagesFields_breadcrumbs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Label = {
  __typename?: 'PagesFields_breadcrumbs_label'
  create?: Maybe<PagesFields_Breadcrumbs_Label_Create>
  delete?: Maybe<PagesFields_Breadcrumbs_Label_Delete>
  read?: Maybe<PagesFields_Breadcrumbs_Label_Read>
  update?: Maybe<PagesFields_Breadcrumbs_Label_Update>
}

export type PagesFields_Breadcrumbs_Label_Create = {
  __typename?: 'PagesFields_breadcrumbs_label_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Label_Delete = {
  __typename?: 'PagesFields_breadcrumbs_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Label_Read = {
  __typename?: 'PagesFields_breadcrumbs_label_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Label_Update = {
  __typename?: 'PagesFields_breadcrumbs_label_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Url = {
  __typename?: 'PagesFields_breadcrumbs_url'
  create?: Maybe<PagesFields_Breadcrumbs_Url_Create>
  delete?: Maybe<PagesFields_Breadcrumbs_Url_Delete>
  read?: Maybe<PagesFields_Breadcrumbs_Url_Read>
  update?: Maybe<PagesFields_Breadcrumbs_Url_Update>
}

export type PagesFields_Breadcrumbs_Url_Create = {
  __typename?: 'PagesFields_breadcrumbs_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Url_Delete = {
  __typename?: 'PagesFields_breadcrumbs_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Url_Read = {
  __typename?: 'PagesFields_breadcrumbs_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Breadcrumbs_Url_Update = {
  __typename?: 'PagesFields_breadcrumbs_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedAt = {
  __typename?: 'PagesFields_createdAt'
  create?: Maybe<PagesFields_CreatedAt_Create>
  delete?: Maybe<PagesFields_CreatedAt_Delete>
  read?: Maybe<PagesFields_CreatedAt_Read>
  update?: Maybe<PagesFields_CreatedAt_Update>
}

export type PagesFields_CreatedAt_Create = {
  __typename?: 'PagesFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedAt_Delete = {
  __typename?: 'PagesFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedAt_Read = {
  __typename?: 'PagesFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedAt_Update = {
  __typename?: 'PagesFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedBy = {
  __typename?: 'PagesFields_createdBy'
  create?: Maybe<PagesFields_CreatedBy_Create>
  delete?: Maybe<PagesFields_CreatedBy_Delete>
  read?: Maybe<PagesFields_CreatedBy_Read>
  update?: Maybe<PagesFields_CreatedBy_Update>
}

export type PagesFields_CreatedBy_Create = {
  __typename?: 'PagesFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedBy_Delete = {
  __typename?: 'PagesFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedBy_Read = {
  __typename?: 'PagesFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CreatedBy_Update = {
  __typename?: 'PagesFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter = {
  __typename?: 'PagesFields_customFooter'
  create?: Maybe<PagesFields_CustomFooter_Create>
  delete?: Maybe<PagesFields_CustomFooter_Delete>
  fields?: Maybe<PagesFields_CustomFooter_Fields>
  read?: Maybe<PagesFields_CustomFooter_Read>
  update?: Maybe<PagesFields_CustomFooter_Update>
}

export type PagesFields_CustomFooter_Create = {
  __typename?: 'PagesFields_customFooter_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Delete = {
  __typename?: 'PagesFields_customFooter_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Fields = {
  __typename?: 'PagesFields_customFooter_Fields'
  disclaimers?: Maybe<PagesFields_CustomFooter_Disclaimers>
  isHidden?: Maybe<PagesFields_CustomFooter_IsHidden>
}

export type PagesFields_CustomFooter_Read = {
  __typename?: 'PagesFields_customFooter_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Update = {
  __typename?: 'PagesFields_customFooter_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers = {
  __typename?: 'PagesFields_customFooter_disclaimers'
  create?: Maybe<PagesFields_CustomFooter_Disclaimers_Create>
  delete?: Maybe<PagesFields_CustomFooter_Disclaimers_Delete>
  fields?: Maybe<PagesFields_CustomFooter_Disclaimers_Fields>
  read?: Maybe<PagesFields_CustomFooter_Disclaimers_Read>
  update?: Maybe<PagesFields_CustomFooter_Disclaimers_Update>
}

export type PagesFields_CustomFooter_Disclaimers_Create = {
  __typename?: 'PagesFields_customFooter_disclaimers_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Delete = {
  __typename?: 'PagesFields_customFooter_disclaimers_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Fields = {
  __typename?: 'PagesFields_customFooter_disclaimers_Fields'
  align?: Maybe<PagesFields_CustomFooter_Disclaimers_Align>
  id?: Maybe<PagesFields_CustomFooter_Disclaimers_Id>
  includeAsterick?: Maybe<PagesFields_CustomFooter_Disclaimers_IncludeAsterick>
  number?: Maybe<PagesFields_CustomFooter_Disclaimers_Number>
  text?: Maybe<PagesFields_CustomFooter_Disclaimers_Text>
}

export type PagesFields_CustomFooter_Disclaimers_Read = {
  __typename?: 'PagesFields_customFooter_disclaimers_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Update = {
  __typename?: 'PagesFields_customFooter_disclaimers_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Align = {
  __typename?: 'PagesFields_customFooter_disclaimers_align'
  create?: Maybe<PagesFields_CustomFooter_Disclaimers_Align_Create>
  delete?: Maybe<PagesFields_CustomFooter_Disclaimers_Align_Delete>
  read?: Maybe<PagesFields_CustomFooter_Disclaimers_Align_Read>
  update?: Maybe<PagesFields_CustomFooter_Disclaimers_Align_Update>
}

export type PagesFields_CustomFooter_Disclaimers_Align_Create = {
  __typename?: 'PagesFields_customFooter_disclaimers_align_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Align_Delete = {
  __typename?: 'PagesFields_customFooter_disclaimers_align_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Align_Read = {
  __typename?: 'PagesFields_customFooter_disclaimers_align_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Align_Update = {
  __typename?: 'PagesFields_customFooter_disclaimers_align_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Id = {
  __typename?: 'PagesFields_customFooter_disclaimers_id'
  create?: Maybe<PagesFields_CustomFooter_Disclaimers_Id_Create>
  delete?: Maybe<PagesFields_CustomFooter_Disclaimers_Id_Delete>
  read?: Maybe<PagesFields_CustomFooter_Disclaimers_Id_Read>
  update?: Maybe<PagesFields_CustomFooter_Disclaimers_Id_Update>
}

export type PagesFields_CustomFooter_Disclaimers_Id_Create = {
  __typename?: 'PagesFields_customFooter_disclaimers_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Id_Delete = {
  __typename?: 'PagesFields_customFooter_disclaimers_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Id_Read = {
  __typename?: 'PagesFields_customFooter_disclaimers_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Id_Update = {
  __typename?: 'PagesFields_customFooter_disclaimers_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_IncludeAsterick = {
  __typename?: 'PagesFields_customFooter_disclaimers_includeAsterick'
  create?: Maybe<PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Create>
  delete?: Maybe<PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Delete>
  read?: Maybe<PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Read>
  update?: Maybe<PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Update>
}

export type PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Create = {
  __typename?: 'PagesFields_customFooter_disclaimers_includeAsterick_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Delete = {
  __typename?: 'PagesFields_customFooter_disclaimers_includeAsterick_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Read = {
  __typename?: 'PagesFields_customFooter_disclaimers_includeAsterick_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_IncludeAsterick_Update = {
  __typename?: 'PagesFields_customFooter_disclaimers_includeAsterick_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Number = {
  __typename?: 'PagesFields_customFooter_disclaimers_number'
  create?: Maybe<PagesFields_CustomFooter_Disclaimers_Number_Create>
  delete?: Maybe<PagesFields_CustomFooter_Disclaimers_Number_Delete>
  read?: Maybe<PagesFields_CustomFooter_Disclaimers_Number_Read>
  update?: Maybe<PagesFields_CustomFooter_Disclaimers_Number_Update>
}

export type PagesFields_CustomFooter_Disclaimers_Number_Create = {
  __typename?: 'PagesFields_customFooter_disclaimers_number_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Number_Delete = {
  __typename?: 'PagesFields_customFooter_disclaimers_number_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Number_Read = {
  __typename?: 'PagesFields_customFooter_disclaimers_number_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Number_Update = {
  __typename?: 'PagesFields_customFooter_disclaimers_number_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Text = {
  __typename?: 'PagesFields_customFooter_disclaimers_text'
  create?: Maybe<PagesFields_CustomFooter_Disclaimers_Text_Create>
  delete?: Maybe<PagesFields_CustomFooter_Disclaimers_Text_Delete>
  read?: Maybe<PagesFields_CustomFooter_Disclaimers_Text_Read>
  update?: Maybe<PagesFields_CustomFooter_Disclaimers_Text_Update>
}

export type PagesFields_CustomFooter_Disclaimers_Text_Create = {
  __typename?: 'PagesFields_customFooter_disclaimers_text_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Text_Delete = {
  __typename?: 'PagesFields_customFooter_disclaimers_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Text_Read = {
  __typename?: 'PagesFields_customFooter_disclaimers_text_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_Disclaimers_Text_Update = {
  __typename?: 'PagesFields_customFooter_disclaimers_text_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_IsHidden = {
  __typename?: 'PagesFields_customFooter_isHidden'
  create?: Maybe<PagesFields_CustomFooter_IsHidden_Create>
  delete?: Maybe<PagesFields_CustomFooter_IsHidden_Delete>
  read?: Maybe<PagesFields_CustomFooter_IsHidden_Read>
  update?: Maybe<PagesFields_CustomFooter_IsHidden_Update>
}

export type PagesFields_CustomFooter_IsHidden_Create = {
  __typename?: 'PagesFields_customFooter_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_IsHidden_Delete = {
  __typename?: 'PagesFields_customFooter_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_IsHidden_Read = {
  __typename?: 'PagesFields_customFooter_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomFooter_IsHidden_Update = {
  __typename?: 'PagesFields_customFooter_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader = {
  __typename?: 'PagesFields_customHeader'
  create?: Maybe<PagesFields_CustomHeader_Create>
  delete?: Maybe<PagesFields_CustomHeader_Delete>
  fields?: Maybe<PagesFields_CustomHeader_Fields>
  read?: Maybe<PagesFields_CustomHeader_Read>
  update?: Maybe<PagesFields_CustomHeader_Update>
}

export type PagesFields_CustomHeader_Create = {
  __typename?: 'PagesFields_customHeader_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_Delete = {
  __typename?: 'PagesFields_customHeader_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_Fields = {
  __typename?: 'PagesFields_customHeader_Fields'
  headerDisplay?: Maybe<PagesFields_CustomHeader_HeaderDisplay>
  isHidden?: Maybe<PagesFields_CustomHeader_IsHidden>
  loginLink?: Maybe<PagesFields_CustomHeader_LoginLink>
  signupLink?: Maybe<PagesFields_CustomHeader_SignupLink>
  supportLink?: Maybe<PagesFields_CustomHeader_SupportLink>
}

export type PagesFields_CustomHeader_Read = {
  __typename?: 'PagesFields_customHeader_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_Update = {
  __typename?: 'PagesFields_customHeader_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_HeaderDisplay = {
  __typename?: 'PagesFields_customHeader_headerDisplay'
  create?: Maybe<PagesFields_CustomHeader_HeaderDisplay_Create>
  delete?: Maybe<PagesFields_CustomHeader_HeaderDisplay_Delete>
  read?: Maybe<PagesFields_CustomHeader_HeaderDisplay_Read>
  update?: Maybe<PagesFields_CustomHeader_HeaderDisplay_Update>
}

export type PagesFields_CustomHeader_HeaderDisplay_Create = {
  __typename?: 'PagesFields_customHeader_headerDisplay_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_HeaderDisplay_Delete = {
  __typename?: 'PagesFields_customHeader_headerDisplay_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_HeaderDisplay_Read = {
  __typename?: 'PagesFields_customHeader_headerDisplay_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_HeaderDisplay_Update = {
  __typename?: 'PagesFields_customHeader_headerDisplay_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_IsHidden = {
  __typename?: 'PagesFields_customHeader_isHidden'
  create?: Maybe<PagesFields_CustomHeader_IsHidden_Create>
  delete?: Maybe<PagesFields_CustomHeader_IsHidden_Delete>
  read?: Maybe<PagesFields_CustomHeader_IsHidden_Read>
  update?: Maybe<PagesFields_CustomHeader_IsHidden_Update>
}

export type PagesFields_CustomHeader_IsHidden_Create = {
  __typename?: 'PagesFields_customHeader_isHidden_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_IsHidden_Delete = {
  __typename?: 'PagesFields_customHeader_isHidden_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_IsHidden_Read = {
  __typename?: 'PagesFields_customHeader_isHidden_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_IsHidden_Update = {
  __typename?: 'PagesFields_customHeader_isHidden_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink = {
  __typename?: 'PagesFields_customHeader_loginLink'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Delete>
  fields?: Maybe<PagesFields_CustomHeader_LoginLink_Fields>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Update>
}

export type PagesFields_CustomHeader_LoginLink_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Fields = {
  __typename?: 'PagesFields_customHeader_loginLink_Fields'
  newTab?: Maybe<PagesFields_CustomHeader_LoginLink_NewTab>
  query?: Maybe<PagesFields_CustomHeader_LoginLink_Query>
  reference?: Maybe<PagesFields_CustomHeader_LoginLink_Reference>
  reusable?: Maybe<PagesFields_CustomHeader_LoginLink_Reusable>
  targetId?: Maybe<PagesFields_CustomHeader_LoginLink_TargetId>
  type?: Maybe<PagesFields_CustomHeader_LoginLink_Type>
  url?: Maybe<PagesFields_CustomHeader_LoginLink_Url>
}

export type PagesFields_CustomHeader_LoginLink_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_NewTab = {
  __typename?: 'PagesFields_customHeader_loginLink_newTab'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_NewTab_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_NewTab_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_NewTab_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_NewTab_Update>
}

export type PagesFields_CustomHeader_LoginLink_NewTab_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_NewTab_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_NewTab_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_NewTab_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query = {
  __typename?: 'PagesFields_customHeader_loginLink_query'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Delete>
  fields?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Fields>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Update>
}

export type PagesFields_CustomHeader_LoginLink_Query_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Fields = {
  __typename?: 'PagesFields_customHeader_loginLink_query_Fields'
  id?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Id>
  key?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Key>
  value?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Value>
}

export type PagesFields_CustomHeader_LoginLink_Query_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Id = {
  __typename?: 'PagesFields_customHeader_loginLink_query_id'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Id_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Id_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Id_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Id_Update>
}

export type PagesFields_CustomHeader_LoginLink_Query_Id_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Id_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Id_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Id_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Key = {
  __typename?: 'PagesFields_customHeader_loginLink_query_key'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Key_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Key_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Key_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Key_Update>
}

export type PagesFields_CustomHeader_LoginLink_Query_Key_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Key_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Key_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Key_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Value = {
  __typename?: 'PagesFields_customHeader_loginLink_query_value'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Value_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Value_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Value_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Query_Value_Update>
}

export type PagesFields_CustomHeader_LoginLink_Query_Value_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Value_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Value_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Query_Value_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reference = {
  __typename?: 'PagesFields_customHeader_loginLink_reference'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Reference_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Reference_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Reference_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Reference_Update>
}

export type PagesFields_CustomHeader_LoginLink_Reference_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reference_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reference_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reference_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reusable = {
  __typename?: 'PagesFields_customHeader_loginLink_reusable'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Reusable_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Reusable_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Reusable_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Reusable_Update>
}

export type PagesFields_CustomHeader_LoginLink_Reusable_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reusable_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reusable_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Reusable_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_TargetId = {
  __typename?: 'PagesFields_customHeader_loginLink_targetId'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_TargetId_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_TargetId_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_TargetId_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_TargetId_Update>
}

export type PagesFields_CustomHeader_LoginLink_TargetId_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_TargetId_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_TargetId_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_TargetId_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Type = {
  __typename?: 'PagesFields_customHeader_loginLink_type'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Type_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Type_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Type_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Type_Update>
}

export type PagesFields_CustomHeader_LoginLink_Type_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Type_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Type_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Type_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Url = {
  __typename?: 'PagesFields_customHeader_loginLink_url'
  create?: Maybe<PagesFields_CustomHeader_LoginLink_Url_Create>
  delete?: Maybe<PagesFields_CustomHeader_LoginLink_Url_Delete>
  read?: Maybe<PagesFields_CustomHeader_LoginLink_Url_Read>
  update?: Maybe<PagesFields_CustomHeader_LoginLink_Url_Update>
}

export type PagesFields_CustomHeader_LoginLink_Url_Create = {
  __typename?: 'PagesFields_customHeader_loginLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Url_Delete = {
  __typename?: 'PagesFields_customHeader_loginLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Url_Read = {
  __typename?: 'PagesFields_customHeader_loginLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_LoginLink_Url_Update = {
  __typename?: 'PagesFields_customHeader_loginLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink = {
  __typename?: 'PagesFields_customHeader_signupLink'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Delete>
  fields?: Maybe<PagesFields_CustomHeader_SignupLink_Fields>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Update>
}

export type PagesFields_CustomHeader_SignupLink_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Fields = {
  __typename?: 'PagesFields_customHeader_signupLink_Fields'
  newTab?: Maybe<PagesFields_CustomHeader_SignupLink_NewTab>
  query?: Maybe<PagesFields_CustomHeader_SignupLink_Query>
  reference?: Maybe<PagesFields_CustomHeader_SignupLink_Reference>
  reusable?: Maybe<PagesFields_CustomHeader_SignupLink_Reusable>
  targetId?: Maybe<PagesFields_CustomHeader_SignupLink_TargetId>
  type?: Maybe<PagesFields_CustomHeader_SignupLink_Type>
  url?: Maybe<PagesFields_CustomHeader_SignupLink_Url>
}

export type PagesFields_CustomHeader_SignupLink_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_NewTab = {
  __typename?: 'PagesFields_customHeader_signupLink_newTab'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_NewTab_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_NewTab_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_NewTab_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_NewTab_Update>
}

export type PagesFields_CustomHeader_SignupLink_NewTab_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_NewTab_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_NewTab_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_NewTab_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query = {
  __typename?: 'PagesFields_customHeader_signupLink_query'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Delete>
  fields?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Fields>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Update>
}

export type PagesFields_CustomHeader_SignupLink_Query_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Fields = {
  __typename?: 'PagesFields_customHeader_signupLink_query_Fields'
  id?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Id>
  key?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Key>
  value?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Value>
}

export type PagesFields_CustomHeader_SignupLink_Query_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Id = {
  __typename?: 'PagesFields_customHeader_signupLink_query_id'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Id_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Id_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Id_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Id_Update>
}

export type PagesFields_CustomHeader_SignupLink_Query_Id_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Id_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Id_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Id_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Key = {
  __typename?: 'PagesFields_customHeader_signupLink_query_key'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Key_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Key_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Key_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Key_Update>
}

export type PagesFields_CustomHeader_SignupLink_Query_Key_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Key_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Key_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Key_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Value = {
  __typename?: 'PagesFields_customHeader_signupLink_query_value'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Value_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Value_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Value_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Query_Value_Update>
}

export type PagesFields_CustomHeader_SignupLink_Query_Value_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Value_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Value_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Query_Value_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reference = {
  __typename?: 'PagesFields_customHeader_signupLink_reference'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Reference_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Reference_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Reference_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Reference_Update>
}

export type PagesFields_CustomHeader_SignupLink_Reference_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reference_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reference_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reference_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reusable = {
  __typename?: 'PagesFields_customHeader_signupLink_reusable'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Reusable_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Reusable_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Reusable_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Reusable_Update>
}

export type PagesFields_CustomHeader_SignupLink_Reusable_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reusable_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reusable_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Reusable_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_TargetId = {
  __typename?: 'PagesFields_customHeader_signupLink_targetId'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_TargetId_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_TargetId_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_TargetId_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_TargetId_Update>
}

export type PagesFields_CustomHeader_SignupLink_TargetId_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_TargetId_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_TargetId_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_TargetId_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Type = {
  __typename?: 'PagesFields_customHeader_signupLink_type'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Type_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Type_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Type_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Type_Update>
}

export type PagesFields_CustomHeader_SignupLink_Type_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Type_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Type_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Type_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Url = {
  __typename?: 'PagesFields_customHeader_signupLink_url'
  create?: Maybe<PagesFields_CustomHeader_SignupLink_Url_Create>
  delete?: Maybe<PagesFields_CustomHeader_SignupLink_Url_Delete>
  read?: Maybe<PagesFields_CustomHeader_SignupLink_Url_Read>
  update?: Maybe<PagesFields_CustomHeader_SignupLink_Url_Update>
}

export type PagesFields_CustomHeader_SignupLink_Url_Create = {
  __typename?: 'PagesFields_customHeader_signupLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Url_Delete = {
  __typename?: 'PagesFields_customHeader_signupLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Url_Read = {
  __typename?: 'PagesFields_customHeader_signupLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SignupLink_Url_Update = {
  __typename?: 'PagesFields_customHeader_signupLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink = {
  __typename?: 'PagesFields_customHeader_supportLink'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Delete>
  fields?: Maybe<PagesFields_CustomHeader_SupportLink_Fields>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Update>
}

export type PagesFields_CustomHeader_SupportLink_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Fields = {
  __typename?: 'PagesFields_customHeader_supportLink_Fields'
  newTab?: Maybe<PagesFields_CustomHeader_SupportLink_NewTab>
  query?: Maybe<PagesFields_CustomHeader_SupportLink_Query>
  reference?: Maybe<PagesFields_CustomHeader_SupportLink_Reference>
  reusable?: Maybe<PagesFields_CustomHeader_SupportLink_Reusable>
  targetId?: Maybe<PagesFields_CustomHeader_SupportLink_TargetId>
  type?: Maybe<PagesFields_CustomHeader_SupportLink_Type>
  url?: Maybe<PagesFields_CustomHeader_SupportLink_Url>
}

export type PagesFields_CustomHeader_SupportLink_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_NewTab = {
  __typename?: 'PagesFields_customHeader_supportLink_newTab'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_NewTab_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_NewTab_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_NewTab_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_NewTab_Update>
}

export type PagesFields_CustomHeader_SupportLink_NewTab_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_NewTab_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_NewTab_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_NewTab_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query = {
  __typename?: 'PagesFields_customHeader_supportLink_query'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Delete>
  fields?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Fields>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Update>
}

export type PagesFields_CustomHeader_SupportLink_Query_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Fields = {
  __typename?: 'PagesFields_customHeader_supportLink_query_Fields'
  id?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Id>
  key?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Key>
  value?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Value>
}

export type PagesFields_CustomHeader_SupportLink_Query_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Id = {
  __typename?: 'PagesFields_customHeader_supportLink_query_id'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Id_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Id_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Id_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Id_Update>
}

export type PagesFields_CustomHeader_SupportLink_Query_Id_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Id_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Id_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Id_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Key = {
  __typename?: 'PagesFields_customHeader_supportLink_query_key'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Key_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Key_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Key_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Key_Update>
}

export type PagesFields_CustomHeader_SupportLink_Query_Key_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Key_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Key_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Key_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Value = {
  __typename?: 'PagesFields_customHeader_supportLink_query_value'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Value_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Value_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Value_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Query_Value_Update>
}

export type PagesFields_CustomHeader_SupportLink_Query_Value_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Value_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Value_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Query_Value_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reference = {
  __typename?: 'PagesFields_customHeader_supportLink_reference'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Reference_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Reference_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Reference_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Reference_Update>
}

export type PagesFields_CustomHeader_SupportLink_Reference_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reference_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reference_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reference_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reusable = {
  __typename?: 'PagesFields_customHeader_supportLink_reusable'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Reusable_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Reusable_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Reusable_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Reusable_Update>
}

export type PagesFields_CustomHeader_SupportLink_Reusable_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reusable_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reusable_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Reusable_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_TargetId = {
  __typename?: 'PagesFields_customHeader_supportLink_targetId'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_TargetId_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_TargetId_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_TargetId_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_TargetId_Update>
}

export type PagesFields_CustomHeader_SupportLink_TargetId_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_TargetId_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_TargetId_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_TargetId_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Type = {
  __typename?: 'PagesFields_customHeader_supportLink_type'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Type_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Type_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Type_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Type_Update>
}

export type PagesFields_CustomHeader_SupportLink_Type_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Type_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Type_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Type_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Url = {
  __typename?: 'PagesFields_customHeader_supportLink_url'
  create?: Maybe<PagesFields_CustomHeader_SupportLink_Url_Create>
  delete?: Maybe<PagesFields_CustomHeader_SupportLink_Url_Delete>
  read?: Maybe<PagesFields_CustomHeader_SupportLink_Url_Read>
  update?: Maybe<PagesFields_CustomHeader_SupportLink_Url_Update>
}

export type PagesFields_CustomHeader_SupportLink_Url_Create = {
  __typename?: 'PagesFields_customHeader_supportLink_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Url_Delete = {
  __typename?: 'PagesFields_customHeader_supportLink_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Url_Read = {
  __typename?: 'PagesFields_customHeader_supportLink_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_CustomHeader_SupportLink_Url_Update = {
  __typename?: 'PagesFields_customHeader_supportLink_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero = {
  __typename?: 'PagesFields_hero'
  create?: Maybe<PagesFields_Hero_Create>
  delete?: Maybe<PagesFields_Hero_Delete>
  fields?: Maybe<PagesFields_Hero_Fields>
  read?: Maybe<PagesFields_Hero_Read>
  update?: Maybe<PagesFields_Hero_Update>
}

export type PagesFields_Hero_Create = {
  __typename?: 'PagesFields_hero_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Delete = {
  __typename?: 'PagesFields_hero_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Fields = {
  __typename?: 'PagesFields_hero_Fields'
  desktopFallback?: Maybe<PagesFields_Hero_DesktopFallback>
  desktopVideo?: Maybe<PagesFields_Hero_DesktopVideo>
  disclaimerText?: Maybe<PagesFields_Hero_DisclaimerText>
  heroSize?: Maybe<PagesFields_Hero_HeroSize>
  hzAlign?: Maybe<PagesFields_Hero_HzAlign>
  links?: Maybe<PagesFields_Hero_Links>
  media?: Maybe<PagesFields_Hero_Media>
  mobileFallback?: Maybe<PagesFields_Hero_MobileFallback>
  mobileVideo?: Maybe<PagesFields_Hero_MobileVideo>
  productImage?: Maybe<PagesFields_Hero_ProductImage>
  reviewRating?: Maybe<PagesFields_Hero_ReviewRating>
  reviewText?: Maybe<PagesFields_Hero_ReviewText>
  richText?: Maybe<PagesFields_Hero_RichText>
  richTextMax?: Maybe<PagesFields_Hero_RichTextMax>
  showReviews?: Maybe<PagesFields_Hero_ShowReviews>
  type?: Maybe<PagesFields_Hero_Type>
  vertAlign?: Maybe<PagesFields_Hero_VertAlign>
}

export type PagesFields_Hero_Read = {
  __typename?: 'PagesFields_hero_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Update = {
  __typename?: 'PagesFields_hero_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopFallback = {
  __typename?: 'PagesFields_hero_desktopFallback'
  create?: Maybe<PagesFields_Hero_DesktopFallback_Create>
  delete?: Maybe<PagesFields_Hero_DesktopFallback_Delete>
  read?: Maybe<PagesFields_Hero_DesktopFallback_Read>
  update?: Maybe<PagesFields_Hero_DesktopFallback_Update>
}

export type PagesFields_Hero_DesktopFallback_Create = {
  __typename?: 'PagesFields_hero_desktopFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopFallback_Delete = {
  __typename?: 'PagesFields_hero_desktopFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopFallback_Read = {
  __typename?: 'PagesFields_hero_desktopFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopFallback_Update = {
  __typename?: 'PagesFields_hero_desktopFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopVideo = {
  __typename?: 'PagesFields_hero_desktopVideo'
  create?: Maybe<PagesFields_Hero_DesktopVideo_Create>
  delete?: Maybe<PagesFields_Hero_DesktopVideo_Delete>
  read?: Maybe<PagesFields_Hero_DesktopVideo_Read>
  update?: Maybe<PagesFields_Hero_DesktopVideo_Update>
}

export type PagesFields_Hero_DesktopVideo_Create = {
  __typename?: 'PagesFields_hero_desktopVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopVideo_Delete = {
  __typename?: 'PagesFields_hero_desktopVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopVideo_Read = {
  __typename?: 'PagesFields_hero_desktopVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DesktopVideo_Update = {
  __typename?: 'PagesFields_hero_desktopVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DisclaimerText = {
  __typename?: 'PagesFields_hero_disclaimerText'
  create?: Maybe<PagesFields_Hero_DisclaimerText_Create>
  delete?: Maybe<PagesFields_Hero_DisclaimerText_Delete>
  read?: Maybe<PagesFields_Hero_DisclaimerText_Read>
  update?: Maybe<PagesFields_Hero_DisclaimerText_Update>
}

export type PagesFields_Hero_DisclaimerText_Create = {
  __typename?: 'PagesFields_hero_disclaimerText_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DisclaimerText_Delete = {
  __typename?: 'PagesFields_hero_disclaimerText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DisclaimerText_Read = {
  __typename?: 'PagesFields_hero_disclaimerText_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_DisclaimerText_Update = {
  __typename?: 'PagesFields_hero_disclaimerText_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HeroSize = {
  __typename?: 'PagesFields_hero_heroSize'
  create?: Maybe<PagesFields_Hero_HeroSize_Create>
  delete?: Maybe<PagesFields_Hero_HeroSize_Delete>
  read?: Maybe<PagesFields_Hero_HeroSize_Read>
  update?: Maybe<PagesFields_Hero_HeroSize_Update>
}

export type PagesFields_Hero_HeroSize_Create = {
  __typename?: 'PagesFields_hero_heroSize_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HeroSize_Delete = {
  __typename?: 'PagesFields_hero_heroSize_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HeroSize_Read = {
  __typename?: 'PagesFields_hero_heroSize_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HeroSize_Update = {
  __typename?: 'PagesFields_hero_heroSize_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HzAlign = {
  __typename?: 'PagesFields_hero_hzAlign'
  create?: Maybe<PagesFields_Hero_HzAlign_Create>
  delete?: Maybe<PagesFields_Hero_HzAlign_Delete>
  read?: Maybe<PagesFields_Hero_HzAlign_Read>
  update?: Maybe<PagesFields_Hero_HzAlign_Update>
}

export type PagesFields_Hero_HzAlign_Create = {
  __typename?: 'PagesFields_hero_hzAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HzAlign_Delete = {
  __typename?: 'PagesFields_hero_hzAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HzAlign_Read = {
  __typename?: 'PagesFields_hero_hzAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_HzAlign_Update = {
  __typename?: 'PagesFields_hero_hzAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links = {
  __typename?: 'PagesFields_hero_links'
  create?: Maybe<PagesFields_Hero_Links_Create>
  delete?: Maybe<PagesFields_Hero_Links_Delete>
  fields?: Maybe<PagesFields_Hero_Links_Fields>
  read?: Maybe<PagesFields_Hero_Links_Read>
  update?: Maybe<PagesFields_Hero_Links_Update>
}

export type PagesFields_Hero_Links_Create = {
  __typename?: 'PagesFields_hero_links_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Delete = {
  __typename?: 'PagesFields_hero_links_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Fields = {
  __typename?: 'PagesFields_hero_links_Fields'
  id?: Maybe<PagesFields_Hero_Links_Id>
  link?: Maybe<PagesFields_Hero_Links_Link>
}

export type PagesFields_Hero_Links_Read = {
  __typename?: 'PagesFields_hero_links_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Update = {
  __typename?: 'PagesFields_hero_links_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Id = {
  __typename?: 'PagesFields_hero_links_id'
  create?: Maybe<PagesFields_Hero_Links_Id_Create>
  delete?: Maybe<PagesFields_Hero_Links_Id_Delete>
  read?: Maybe<PagesFields_Hero_Links_Id_Read>
  update?: Maybe<PagesFields_Hero_Links_Id_Update>
}

export type PagesFields_Hero_Links_Id_Create = {
  __typename?: 'PagesFields_hero_links_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Id_Delete = {
  __typename?: 'PagesFields_hero_links_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Id_Read = {
  __typename?: 'PagesFields_hero_links_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Id_Update = {
  __typename?: 'PagesFields_hero_links_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link = {
  __typename?: 'PagesFields_hero_links_link'
  create?: Maybe<PagesFields_Hero_Links_Link_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Delete>
  fields?: Maybe<PagesFields_Hero_Links_Link_Fields>
  read?: Maybe<PagesFields_Hero_Links_Link_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Update>
}

export type PagesFields_Hero_Links_Link_Create = {
  __typename?: 'PagesFields_hero_links_link_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Delete = {
  __typename?: 'PagesFields_hero_links_link_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Fields = {
  __typename?: 'PagesFields_hero_links_link_Fields'
  iconAfter?: Maybe<PagesFields_Hero_Links_Link_IconAfter>
  iconBefore?: Maybe<PagesFields_Hero_Links_Link_IconBefore>
  label?: Maybe<PagesFields_Hero_Links_Link_Label>
  newTab?: Maybe<PagesFields_Hero_Links_Link_NewTab>
  query?: Maybe<PagesFields_Hero_Links_Link_Query>
  reference?: Maybe<PagesFields_Hero_Links_Link_Reference>
  reusable?: Maybe<PagesFields_Hero_Links_Link_Reusable>
  targetId?: Maybe<PagesFields_Hero_Links_Link_TargetId>
  type?: Maybe<PagesFields_Hero_Links_Link_Type>
  url?: Maybe<PagesFields_Hero_Links_Link_Url>
  variant?: Maybe<PagesFields_Hero_Links_Link_Variant>
}

export type PagesFields_Hero_Links_Link_Read = {
  __typename?: 'PagesFields_hero_links_link_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Update = {
  __typename?: 'PagesFields_hero_links_link_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconAfter = {
  __typename?: 'PagesFields_hero_links_link_iconAfter'
  create?: Maybe<PagesFields_Hero_Links_Link_IconAfter_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_IconAfter_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_IconAfter_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_IconAfter_Update>
}

export type PagesFields_Hero_Links_Link_IconAfter_Create = {
  __typename?: 'PagesFields_hero_links_link_iconAfter_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconAfter_Delete = {
  __typename?: 'PagesFields_hero_links_link_iconAfter_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconAfter_Read = {
  __typename?: 'PagesFields_hero_links_link_iconAfter_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconAfter_Update = {
  __typename?: 'PagesFields_hero_links_link_iconAfter_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconBefore = {
  __typename?: 'PagesFields_hero_links_link_iconBefore'
  create?: Maybe<PagesFields_Hero_Links_Link_IconBefore_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_IconBefore_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_IconBefore_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_IconBefore_Update>
}

export type PagesFields_Hero_Links_Link_IconBefore_Create = {
  __typename?: 'PagesFields_hero_links_link_iconBefore_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconBefore_Delete = {
  __typename?: 'PagesFields_hero_links_link_iconBefore_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconBefore_Read = {
  __typename?: 'PagesFields_hero_links_link_iconBefore_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_IconBefore_Update = {
  __typename?: 'PagesFields_hero_links_link_iconBefore_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Label = {
  __typename?: 'PagesFields_hero_links_link_label'
  create?: Maybe<PagesFields_Hero_Links_Link_Label_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Label_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Label_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Label_Update>
}

export type PagesFields_Hero_Links_Link_Label_Create = {
  __typename?: 'PagesFields_hero_links_link_label_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Label_Delete = {
  __typename?: 'PagesFields_hero_links_link_label_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Label_Read = {
  __typename?: 'PagesFields_hero_links_link_label_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Label_Update = {
  __typename?: 'PagesFields_hero_links_link_label_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_NewTab = {
  __typename?: 'PagesFields_hero_links_link_newTab'
  create?: Maybe<PagesFields_Hero_Links_Link_NewTab_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_NewTab_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_NewTab_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_NewTab_Update>
}

export type PagesFields_Hero_Links_Link_NewTab_Create = {
  __typename?: 'PagesFields_hero_links_link_newTab_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_NewTab_Delete = {
  __typename?: 'PagesFields_hero_links_link_newTab_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_NewTab_Read = {
  __typename?: 'PagesFields_hero_links_link_newTab_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_NewTab_Update = {
  __typename?: 'PagesFields_hero_links_link_newTab_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query = {
  __typename?: 'PagesFields_hero_links_link_query'
  create?: Maybe<PagesFields_Hero_Links_Link_Query_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Query_Delete>
  fields?: Maybe<PagesFields_Hero_Links_Link_Query_Fields>
  read?: Maybe<PagesFields_Hero_Links_Link_Query_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Query_Update>
}

export type PagesFields_Hero_Links_Link_Query_Create = {
  __typename?: 'PagesFields_hero_links_link_query_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Delete = {
  __typename?: 'PagesFields_hero_links_link_query_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Fields = {
  __typename?: 'PagesFields_hero_links_link_query_Fields'
  id?: Maybe<PagesFields_Hero_Links_Link_Query_Id>
  key?: Maybe<PagesFields_Hero_Links_Link_Query_Key>
  value?: Maybe<PagesFields_Hero_Links_Link_Query_Value>
}

export type PagesFields_Hero_Links_Link_Query_Read = {
  __typename?: 'PagesFields_hero_links_link_query_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Update = {
  __typename?: 'PagesFields_hero_links_link_query_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Id = {
  __typename?: 'PagesFields_hero_links_link_query_id'
  create?: Maybe<PagesFields_Hero_Links_Link_Query_Id_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Query_Id_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Query_Id_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Query_Id_Update>
}

export type PagesFields_Hero_Links_Link_Query_Id_Create = {
  __typename?: 'PagesFields_hero_links_link_query_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Id_Delete = {
  __typename?: 'PagesFields_hero_links_link_query_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Id_Read = {
  __typename?: 'PagesFields_hero_links_link_query_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Id_Update = {
  __typename?: 'PagesFields_hero_links_link_query_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Key = {
  __typename?: 'PagesFields_hero_links_link_query_key'
  create?: Maybe<PagesFields_Hero_Links_Link_Query_Key_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Query_Key_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Query_Key_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Query_Key_Update>
}

export type PagesFields_Hero_Links_Link_Query_Key_Create = {
  __typename?: 'PagesFields_hero_links_link_query_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Key_Delete = {
  __typename?: 'PagesFields_hero_links_link_query_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Key_Read = {
  __typename?: 'PagesFields_hero_links_link_query_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Key_Update = {
  __typename?: 'PagesFields_hero_links_link_query_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Value = {
  __typename?: 'PagesFields_hero_links_link_query_value'
  create?: Maybe<PagesFields_Hero_Links_Link_Query_Value_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Query_Value_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Query_Value_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Query_Value_Update>
}

export type PagesFields_Hero_Links_Link_Query_Value_Create = {
  __typename?: 'PagesFields_hero_links_link_query_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Value_Delete = {
  __typename?: 'PagesFields_hero_links_link_query_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Value_Read = {
  __typename?: 'PagesFields_hero_links_link_query_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Query_Value_Update = {
  __typename?: 'PagesFields_hero_links_link_query_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reference = {
  __typename?: 'PagesFields_hero_links_link_reference'
  create?: Maybe<PagesFields_Hero_Links_Link_Reference_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Reference_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Reference_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Reference_Update>
}

export type PagesFields_Hero_Links_Link_Reference_Create = {
  __typename?: 'PagesFields_hero_links_link_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reference_Delete = {
  __typename?: 'PagesFields_hero_links_link_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reference_Read = {
  __typename?: 'PagesFields_hero_links_link_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reference_Update = {
  __typename?: 'PagesFields_hero_links_link_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reusable = {
  __typename?: 'PagesFields_hero_links_link_reusable'
  create?: Maybe<PagesFields_Hero_Links_Link_Reusable_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Reusable_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Reusable_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Reusable_Update>
}

export type PagesFields_Hero_Links_Link_Reusable_Create = {
  __typename?: 'PagesFields_hero_links_link_reusable_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reusable_Delete = {
  __typename?: 'PagesFields_hero_links_link_reusable_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reusable_Read = {
  __typename?: 'PagesFields_hero_links_link_reusable_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Reusable_Update = {
  __typename?: 'PagesFields_hero_links_link_reusable_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_TargetId = {
  __typename?: 'PagesFields_hero_links_link_targetId'
  create?: Maybe<PagesFields_Hero_Links_Link_TargetId_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_TargetId_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_TargetId_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_TargetId_Update>
}

export type PagesFields_Hero_Links_Link_TargetId_Create = {
  __typename?: 'PagesFields_hero_links_link_targetId_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_TargetId_Delete = {
  __typename?: 'PagesFields_hero_links_link_targetId_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_TargetId_Read = {
  __typename?: 'PagesFields_hero_links_link_targetId_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_TargetId_Update = {
  __typename?: 'PagesFields_hero_links_link_targetId_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Type = {
  __typename?: 'PagesFields_hero_links_link_type'
  create?: Maybe<PagesFields_Hero_Links_Link_Type_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Type_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Type_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Type_Update>
}

export type PagesFields_Hero_Links_Link_Type_Create = {
  __typename?: 'PagesFields_hero_links_link_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Type_Delete = {
  __typename?: 'PagesFields_hero_links_link_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Type_Read = {
  __typename?: 'PagesFields_hero_links_link_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Type_Update = {
  __typename?: 'PagesFields_hero_links_link_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Url = {
  __typename?: 'PagesFields_hero_links_link_url'
  create?: Maybe<PagesFields_Hero_Links_Link_Url_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Url_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Url_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Url_Update>
}

export type PagesFields_Hero_Links_Link_Url_Create = {
  __typename?: 'PagesFields_hero_links_link_url_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Url_Delete = {
  __typename?: 'PagesFields_hero_links_link_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Url_Read = {
  __typename?: 'PagesFields_hero_links_link_url_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Url_Update = {
  __typename?: 'PagesFields_hero_links_link_url_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Variant = {
  __typename?: 'PagesFields_hero_links_link_variant'
  create?: Maybe<PagesFields_Hero_Links_Link_Variant_Create>
  delete?: Maybe<PagesFields_Hero_Links_Link_Variant_Delete>
  read?: Maybe<PagesFields_Hero_Links_Link_Variant_Read>
  update?: Maybe<PagesFields_Hero_Links_Link_Variant_Update>
}

export type PagesFields_Hero_Links_Link_Variant_Create = {
  __typename?: 'PagesFields_hero_links_link_variant_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Variant_Delete = {
  __typename?: 'PagesFields_hero_links_link_variant_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Variant_Read = {
  __typename?: 'PagesFields_hero_links_link_variant_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Links_Link_Variant_Update = {
  __typename?: 'PagesFields_hero_links_link_variant_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Media = {
  __typename?: 'PagesFields_hero_media'
  create?: Maybe<PagesFields_Hero_Media_Create>
  delete?: Maybe<PagesFields_Hero_Media_Delete>
  read?: Maybe<PagesFields_Hero_Media_Read>
  update?: Maybe<PagesFields_Hero_Media_Update>
}

export type PagesFields_Hero_Media_Create = {
  __typename?: 'PagesFields_hero_media_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Media_Delete = {
  __typename?: 'PagesFields_hero_media_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Media_Read = {
  __typename?: 'PagesFields_hero_media_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Media_Update = {
  __typename?: 'PagesFields_hero_media_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileFallback = {
  __typename?: 'PagesFields_hero_mobileFallback'
  create?: Maybe<PagesFields_Hero_MobileFallback_Create>
  delete?: Maybe<PagesFields_Hero_MobileFallback_Delete>
  read?: Maybe<PagesFields_Hero_MobileFallback_Read>
  update?: Maybe<PagesFields_Hero_MobileFallback_Update>
}

export type PagesFields_Hero_MobileFallback_Create = {
  __typename?: 'PagesFields_hero_mobileFallback_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileFallback_Delete = {
  __typename?: 'PagesFields_hero_mobileFallback_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileFallback_Read = {
  __typename?: 'PagesFields_hero_mobileFallback_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileFallback_Update = {
  __typename?: 'PagesFields_hero_mobileFallback_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileVideo = {
  __typename?: 'PagesFields_hero_mobileVideo'
  create?: Maybe<PagesFields_Hero_MobileVideo_Create>
  delete?: Maybe<PagesFields_Hero_MobileVideo_Delete>
  read?: Maybe<PagesFields_Hero_MobileVideo_Read>
  update?: Maybe<PagesFields_Hero_MobileVideo_Update>
}

export type PagesFields_Hero_MobileVideo_Create = {
  __typename?: 'PagesFields_hero_mobileVideo_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileVideo_Delete = {
  __typename?: 'PagesFields_hero_mobileVideo_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileVideo_Read = {
  __typename?: 'PagesFields_hero_mobileVideo_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_MobileVideo_Update = {
  __typename?: 'PagesFields_hero_mobileVideo_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ProductImage = {
  __typename?: 'PagesFields_hero_productImage'
  create?: Maybe<PagesFields_Hero_ProductImage_Create>
  delete?: Maybe<PagesFields_Hero_ProductImage_Delete>
  read?: Maybe<PagesFields_Hero_ProductImage_Read>
  update?: Maybe<PagesFields_Hero_ProductImage_Update>
}

export type PagesFields_Hero_ProductImage_Create = {
  __typename?: 'PagesFields_hero_productImage_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ProductImage_Delete = {
  __typename?: 'PagesFields_hero_productImage_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ProductImage_Read = {
  __typename?: 'PagesFields_hero_productImage_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ProductImage_Update = {
  __typename?: 'PagesFields_hero_productImage_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewRating = {
  __typename?: 'PagesFields_hero_reviewRating'
  create?: Maybe<PagesFields_Hero_ReviewRating_Create>
  delete?: Maybe<PagesFields_Hero_ReviewRating_Delete>
  read?: Maybe<PagesFields_Hero_ReviewRating_Read>
  update?: Maybe<PagesFields_Hero_ReviewRating_Update>
}

export type PagesFields_Hero_ReviewRating_Create = {
  __typename?: 'PagesFields_hero_reviewRating_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewRating_Delete = {
  __typename?: 'PagesFields_hero_reviewRating_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewRating_Read = {
  __typename?: 'PagesFields_hero_reviewRating_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewRating_Update = {
  __typename?: 'PagesFields_hero_reviewRating_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewText = {
  __typename?: 'PagesFields_hero_reviewText'
  create?: Maybe<PagesFields_Hero_ReviewText_Create>
  delete?: Maybe<PagesFields_Hero_ReviewText_Delete>
  read?: Maybe<PagesFields_Hero_ReviewText_Read>
  update?: Maybe<PagesFields_Hero_ReviewText_Update>
}

export type PagesFields_Hero_ReviewText_Create = {
  __typename?: 'PagesFields_hero_reviewText_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewText_Delete = {
  __typename?: 'PagesFields_hero_reviewText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewText_Read = {
  __typename?: 'PagesFields_hero_reviewText_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ReviewText_Update = {
  __typename?: 'PagesFields_hero_reviewText_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichText = {
  __typename?: 'PagesFields_hero_richText'
  create?: Maybe<PagesFields_Hero_RichText_Create>
  delete?: Maybe<PagesFields_Hero_RichText_Delete>
  read?: Maybe<PagesFields_Hero_RichText_Read>
  update?: Maybe<PagesFields_Hero_RichText_Update>
}

export type PagesFields_Hero_RichTextMax = {
  __typename?: 'PagesFields_hero_richTextMax'
  create?: Maybe<PagesFields_Hero_RichTextMax_Create>
  delete?: Maybe<PagesFields_Hero_RichTextMax_Delete>
  read?: Maybe<PagesFields_Hero_RichTextMax_Read>
  update?: Maybe<PagesFields_Hero_RichTextMax_Update>
}

export type PagesFields_Hero_RichTextMax_Create = {
  __typename?: 'PagesFields_hero_richTextMax_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichTextMax_Delete = {
  __typename?: 'PagesFields_hero_richTextMax_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichTextMax_Read = {
  __typename?: 'PagesFields_hero_richTextMax_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichTextMax_Update = {
  __typename?: 'PagesFields_hero_richTextMax_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichText_Create = {
  __typename?: 'PagesFields_hero_richText_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichText_Delete = {
  __typename?: 'PagesFields_hero_richText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichText_Read = {
  __typename?: 'PagesFields_hero_richText_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_RichText_Update = {
  __typename?: 'PagesFields_hero_richText_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ShowReviews = {
  __typename?: 'PagesFields_hero_showReviews'
  create?: Maybe<PagesFields_Hero_ShowReviews_Create>
  delete?: Maybe<PagesFields_Hero_ShowReviews_Delete>
  read?: Maybe<PagesFields_Hero_ShowReviews_Read>
  update?: Maybe<PagesFields_Hero_ShowReviews_Update>
}

export type PagesFields_Hero_ShowReviews_Create = {
  __typename?: 'PagesFields_hero_showReviews_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ShowReviews_Delete = {
  __typename?: 'PagesFields_hero_showReviews_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ShowReviews_Read = {
  __typename?: 'PagesFields_hero_showReviews_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_ShowReviews_Update = {
  __typename?: 'PagesFields_hero_showReviews_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Type = {
  __typename?: 'PagesFields_hero_type'
  create?: Maybe<PagesFields_Hero_Type_Create>
  delete?: Maybe<PagesFields_Hero_Type_Delete>
  read?: Maybe<PagesFields_Hero_Type_Read>
  update?: Maybe<PagesFields_Hero_Type_Update>
}

export type PagesFields_Hero_Type_Create = {
  __typename?: 'PagesFields_hero_type_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Type_Delete = {
  __typename?: 'PagesFields_hero_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Type_Read = {
  __typename?: 'PagesFields_hero_type_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_Type_Update = {
  __typename?: 'PagesFields_hero_type_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_VertAlign = {
  __typename?: 'PagesFields_hero_vertAlign'
  create?: Maybe<PagesFields_Hero_VertAlign_Create>
  delete?: Maybe<PagesFields_Hero_VertAlign_Delete>
  read?: Maybe<PagesFields_Hero_VertAlign_Read>
  update?: Maybe<PagesFields_Hero_VertAlign_Update>
}

export type PagesFields_Hero_VertAlign_Create = {
  __typename?: 'PagesFields_hero_vertAlign_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_VertAlign_Delete = {
  __typename?: 'PagesFields_hero_vertAlign_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_VertAlign_Read = {
  __typename?: 'PagesFields_hero_vertAlign_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Hero_VertAlign_Update = {
  __typename?: 'PagesFields_hero_vertAlign_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Layout = {
  __typename?: 'PagesFields_layout'
  create?: Maybe<PagesFields_Layout_Create>
  delete?: Maybe<PagesFields_Layout_Delete>
  read?: Maybe<PagesFields_Layout_Read>
  update?: Maybe<PagesFields_Layout_Update>
}

export type PagesFields_Layout_Create = {
  __typename?: 'PagesFields_layout_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Layout_Delete = {
  __typename?: 'PagesFields_layout_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Layout_Read = {
  __typename?: 'PagesFields_layout_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Layout_Update = {
  __typename?: 'PagesFields_layout_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta = {
  __typename?: 'PagesFields_meta'
  create?: Maybe<PagesFields_Meta_Create>
  delete?: Maybe<PagesFields_Meta_Delete>
  fields?: Maybe<PagesFields_Meta_Fields>
  read?: Maybe<PagesFields_Meta_Read>
  update?: Maybe<PagesFields_Meta_Update>
}

export type PagesFields_Meta_Create = {
  __typename?: 'PagesFields_meta_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Delete = {
  __typename?: 'PagesFields_meta_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Fields = {
  __typename?: 'PagesFields_meta_Fields'
  description?: Maybe<PagesFields_Meta_Description>
  image?: Maybe<PagesFields_Meta_Image>
  jsonLD?: Maybe<PagesFields_Meta_JsonLd>
  noIndex?: Maybe<PagesFields_Meta_NoIndex>
  title?: Maybe<PagesFields_Meta_Title>
}

export type PagesFields_Meta_Read = {
  __typename?: 'PagesFields_meta_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Update = {
  __typename?: 'PagesFields_meta_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Description = {
  __typename?: 'PagesFields_meta_description'
  create?: Maybe<PagesFields_Meta_Description_Create>
  delete?: Maybe<PagesFields_Meta_Description_Delete>
  read?: Maybe<PagesFields_Meta_Description_Read>
  update?: Maybe<PagesFields_Meta_Description_Update>
}

export type PagesFields_Meta_Description_Create = {
  __typename?: 'PagesFields_meta_description_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Description_Delete = {
  __typename?: 'PagesFields_meta_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Description_Read = {
  __typename?: 'PagesFields_meta_description_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Description_Update = {
  __typename?: 'PagesFields_meta_description_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Image = {
  __typename?: 'PagesFields_meta_image'
  create?: Maybe<PagesFields_Meta_Image_Create>
  delete?: Maybe<PagesFields_Meta_Image_Delete>
  read?: Maybe<PagesFields_Meta_Image_Read>
  update?: Maybe<PagesFields_Meta_Image_Update>
}

export type PagesFields_Meta_Image_Create = {
  __typename?: 'PagesFields_meta_image_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Image_Delete = {
  __typename?: 'PagesFields_meta_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Image_Read = {
  __typename?: 'PagesFields_meta_image_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Image_Update = {
  __typename?: 'PagesFields_meta_image_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_JsonLd = {
  __typename?: 'PagesFields_meta_jsonLD'
  create?: Maybe<PagesFields_Meta_JsonLd_Create>
  delete?: Maybe<PagesFields_Meta_JsonLd_Delete>
  read?: Maybe<PagesFields_Meta_JsonLd_Read>
  update?: Maybe<PagesFields_Meta_JsonLd_Update>
}

export type PagesFields_Meta_JsonLd_Create = {
  __typename?: 'PagesFields_meta_jsonLD_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_JsonLd_Delete = {
  __typename?: 'PagesFields_meta_jsonLD_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_JsonLd_Read = {
  __typename?: 'PagesFields_meta_jsonLD_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_JsonLd_Update = {
  __typename?: 'PagesFields_meta_jsonLD_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_NoIndex = {
  __typename?: 'PagesFields_meta_noIndex'
  create?: Maybe<PagesFields_Meta_NoIndex_Create>
  delete?: Maybe<PagesFields_Meta_NoIndex_Delete>
  read?: Maybe<PagesFields_Meta_NoIndex_Read>
  update?: Maybe<PagesFields_Meta_NoIndex_Update>
}

export type PagesFields_Meta_NoIndex_Create = {
  __typename?: 'PagesFields_meta_noIndex_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_NoIndex_Delete = {
  __typename?: 'PagesFields_meta_noIndex_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_NoIndex_Read = {
  __typename?: 'PagesFields_meta_noIndex_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_NoIndex_Update = {
  __typename?: 'PagesFields_meta_noIndex_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Title = {
  __typename?: 'PagesFields_meta_title'
  create?: Maybe<PagesFields_Meta_Title_Create>
  delete?: Maybe<PagesFields_Meta_Title_Delete>
  read?: Maybe<PagesFields_Meta_Title_Read>
  update?: Maybe<PagesFields_Meta_Title_Update>
}

export type PagesFields_Meta_Title_Create = {
  __typename?: 'PagesFields_meta_title_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Title_Delete = {
  __typename?: 'PagesFields_meta_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Title_Read = {
  __typename?: 'PagesFields_meta_title_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Meta_Title_Update = {
  __typename?: 'PagesFields_meta_title_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Parent = {
  __typename?: 'PagesFields_parent'
  create?: Maybe<PagesFields_Parent_Create>
  delete?: Maybe<PagesFields_Parent_Delete>
  read?: Maybe<PagesFields_Parent_Read>
  update?: Maybe<PagesFields_Parent_Update>
}

export type PagesFields_Parent_Create = {
  __typename?: 'PagesFields_parent_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Parent_Delete = {
  __typename?: 'PagesFields_parent_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Parent_Read = {
  __typename?: 'PagesFields_parent_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Parent_Update = {
  __typename?: 'PagesFields_parent_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_PublishedAt = {
  __typename?: 'PagesFields_publishedAt'
  create?: Maybe<PagesFields_PublishedAt_Create>
  delete?: Maybe<PagesFields_PublishedAt_Delete>
  read?: Maybe<PagesFields_PublishedAt_Read>
  update?: Maybe<PagesFields_PublishedAt_Update>
}

export type PagesFields_PublishedAt_Create = {
  __typename?: 'PagesFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_PublishedAt_Delete = {
  __typename?: 'PagesFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_PublishedAt_Read = {
  __typename?: 'PagesFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_PublishedAt_Update = {
  __typename?: 'PagesFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Slug = {
  __typename?: 'PagesFields_slug'
  create?: Maybe<PagesFields_Slug_Create>
  delete?: Maybe<PagesFields_Slug_Delete>
  read?: Maybe<PagesFields_Slug_Read>
  update?: Maybe<PagesFields_Slug_Update>
}

export type PagesFields_Slug_Create = {
  __typename?: 'PagesFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Slug_Delete = {
  __typename?: 'PagesFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Slug_Read = {
  __typename?: 'PagesFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Slug_Update = {
  __typename?: 'PagesFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Title = {
  __typename?: 'PagesFields_title'
  create?: Maybe<PagesFields_Title_Create>
  delete?: Maybe<PagesFields_Title_Delete>
  read?: Maybe<PagesFields_Title_Read>
  update?: Maybe<PagesFields_Title_Update>
}

export type PagesFields_Title_Create = {
  __typename?: 'PagesFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Title_Delete = {
  __typename?: 'PagesFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Title_Read = {
  __typename?: 'PagesFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_Title_Update = {
  __typename?: 'PagesFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_UpdatedAt = {
  __typename?: 'PagesFields_updatedAt'
  create?: Maybe<PagesFields_UpdatedAt_Create>
  delete?: Maybe<PagesFields_UpdatedAt_Delete>
  read?: Maybe<PagesFields_UpdatedAt_Read>
  update?: Maybe<PagesFields_UpdatedAt_Update>
}

export type PagesFields_UpdatedAt_Create = {
  __typename?: 'PagesFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_UpdatedAt_Delete = {
  __typename?: 'PagesFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_UpdatedAt_Read = {
  __typename?: 'PagesFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PagesFields_UpdatedAt_Update = {
  __typename?: 'PagesFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PagesReadAccess = {
  __typename?: 'PagesReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesReadDocAccess = {
  __typename?: 'PagesReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesReadVersionsAccess = {
  __typename?: 'PagesReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesReadVersionsDocAccess = {
  __typename?: 'PagesReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesUpdateAccess = {
  __typename?: 'PagesUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PagesUpdateDocAccess = {
  __typename?: 'PagesUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocument = {
  __typename?: 'PayloadLockedDocument'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  document?: Maybe<PayloadLockedDocument_Document_Relationship>
  globalSlug?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  user: PayloadLockedDocument_User_Relationship
}

export type PayloadLockedDocumentDocumentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type PayloadLockedDocumentUpdate_DocumentRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo = {
  Articles: 'articles',
  Authors: 'authors',
  Callouts: 'callouts',
  Categories: 'categories',
  Comments: 'comments',
  FormSubmissions: 'form_submissions',
  Forms: 'forms',
  Guides: 'guides',
  Legal: 'legal',
  Links: 'links',
  LiteEmbedded: 'lite_embedded',
  Marketplace: 'marketplace',
  Media: 'media',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Pricing: 'pricing',
  Ratings: 'ratings',
  Redirects: 'redirects',
  SearchResults: 'search_results',
  Stacker: 'stacker',
  TcProgramTags: 'tc_program_tags',
  TcPrograms: 'tc_programs',
  TcVendors: 'tc_vendors',
  TradeCreditVendors: 'trade_credit_vendors',
  UserStorage: 'user_storage',
  Users: 'users',
  Videos: 'videos',
} as const

export type PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo =
  (typeof PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo)[keyof typeof PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo]
export type PayloadLockedDocumentUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo = {
  Users: 'users',
} as const

export type PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo =
  (typeof PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo)[keyof typeof PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo]
export type PayloadLockedDocument_Document =
  | CmsArticle
  | CmsAuthor
  | CmsCallout
  | CmsCategories
  | CmsComment
  | CmsForm
  | CmsFormSubmission
  | CmsGuide
  | CmsLegal
  | CmsLinks
  | CmsLiteEmbeddedMarketplace
  | CmsMarketplacePage
  | CmsMedia
  | CmsNewsroomArticle
  | CmsPage
  | CmsPricing
  | CmsRating
  | CmsRedirect
  | CmsSearchResult
  | CmsStackerPage
  | CmsTradeCreditProgram
  | CmsTradeCreditProgramTag
  | CmsTradeCreditRecommendation
  | CmsTradeCreditVendor
  | CmsUser
  | CmsVideo

export type PayloadLockedDocument_DocumentRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocument_DocumentRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadLockedDocument_DocumentRelationshipInputRelationTo = {
  Articles: 'articles',
  Authors: 'authors',
  Callouts: 'callouts',
  Categories: 'categories',
  Comments: 'comments',
  FormSubmissions: 'form_submissions',
  Forms: 'forms',
  Guides: 'guides',
  Legal: 'legal',
  Links: 'links',
  LiteEmbedded: 'lite_embedded',
  Marketplace: 'marketplace',
  Media: 'media',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Pricing: 'pricing',
  Ratings: 'ratings',
  Redirects: 'redirects',
  SearchResults: 'search_results',
  Stacker: 'stacker',
  TcProgramTags: 'tc_program_tags',
  TcPrograms: 'tc_programs',
  TcVendors: 'tc_vendors',
  TradeCreditVendors: 'trade_credit_vendors',
  UserStorage: 'user_storage',
  Users: 'users',
  Videos: 'videos',
} as const

export type PayloadLockedDocument_DocumentRelationshipInputRelationTo =
  (typeof PayloadLockedDocument_DocumentRelationshipInputRelationTo)[keyof typeof PayloadLockedDocument_DocumentRelationshipInputRelationTo]
export const PayloadLockedDocument_Document_RelationTo = {
  Articles: 'articles',
  Authors: 'authors',
  Callouts: 'callouts',
  Categories: 'categories',
  Comments: 'comments',
  FormSubmissions: 'form_submissions',
  Forms: 'forms',
  Guides: 'guides',
  Legal: 'legal',
  Links: 'links',
  LiteEmbedded: 'lite_embedded',
  Marketplace: 'marketplace',
  Media: 'media',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Pricing: 'pricing',
  Ratings: 'ratings',
  Redirects: 'redirects',
  SearchResults: 'search_results',
  Stacker: 'stacker',
  TcProgramTags: 'tc_program_tags',
  TcPrograms: 'tc_programs',
  TcVendors: 'tc_vendors',
  TradeCreditVendors: 'trade_credit_vendors',
  Users: 'users',
  Videos: 'videos',
} as const

export type PayloadLockedDocument_Document_RelationTo =
  (typeof PayloadLockedDocument_Document_RelationTo)[keyof typeof PayloadLockedDocument_Document_RelationTo]
export type PayloadLockedDocument_Document_Relationship = {
  __typename?: 'PayloadLockedDocument_Document_Relationship'
  relationTo?: Maybe<PayloadLockedDocument_Document_RelationTo>
  value?: Maybe<PayloadLockedDocument_Document>
}

export type PayloadLockedDocument_User = CmsUser

export type PayloadLockedDocument_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocument_UserRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadLockedDocument_UserRelationshipInputRelationTo = {
  Users: 'users',
} as const

export type PayloadLockedDocument_UserRelationshipInputRelationTo =
  (typeof PayloadLockedDocument_UserRelationshipInputRelationTo)[keyof typeof PayloadLockedDocument_UserRelationshipInputRelationTo]
export const PayloadLockedDocument_User_RelationTo = {
  Users: 'users',
} as const

export type PayloadLockedDocument_User_RelationTo =
  (typeof PayloadLockedDocument_User_RelationTo)[keyof typeof PayloadLockedDocument_User_RelationTo]
export type PayloadLockedDocument_User_Relationship = {
  __typename?: 'PayloadLockedDocument_User_Relationship'
  relationTo?: Maybe<PayloadLockedDocument_User_RelationTo>
  value?: Maybe<PayloadLockedDocument_User>
}

export type PayloadLockedDocument_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type PayloadLockedDocument_Document_Relation = {
  relationTo?: InputMaybe<PayloadLockedDocument_Document_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadLockedDocument_Document_Relation_RelationTo = {
  Articles: 'articles',
  Authors: 'authors',
  Callouts: 'callouts',
  Categories: 'categories',
  Comments: 'comments',
  FormSubmissions: 'form_submissions',
  Forms: 'forms',
  Guides: 'guides',
  Legal: 'legal',
  Links: 'links',
  LiteEmbedded: 'lite_embedded',
  Marketplace: 'marketplace',
  Media: 'media',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Pricing: 'pricing',
  Ratings: 'ratings',
  Redirects: 'redirects',
  SearchResults: 'search_results',
  Stacker: 'stacker',
  TcProgramTags: 'tc_program_tags',
  TcPrograms: 'tc_programs',
  TcVendors: 'tc_vendors',
  TradeCreditVendors: 'trade_credit_vendors',
  UserStorage: 'user_storage',
  Users: 'users',
  Videos: 'videos',
} as const

export type PayloadLockedDocument_Document_Relation_RelationTo =
  (typeof PayloadLockedDocument_Document_Relation_RelationTo)[keyof typeof PayloadLockedDocument_Document_Relation_RelationTo]
export type PayloadLockedDocument_GlobalSlug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type PayloadLockedDocument_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type PayloadLockedDocument_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type PayloadLockedDocument_User_Relation = {
  relationTo?: InputMaybe<PayloadLockedDocument_User_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadLockedDocument_User_Relation_RelationTo = {
  Users: 'users',
} as const

export type PayloadLockedDocument_User_Relation_RelationTo =
  (typeof PayloadLockedDocument_User_Relation_RelationTo)[keyof typeof PayloadLockedDocument_User_Relation_RelationTo]
export type PayloadLockedDocument_Where = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>
  user?: InputMaybe<PayloadLockedDocument_User_Relation>
}

export type PayloadLockedDocument_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>
  user?: InputMaybe<PayloadLockedDocument_User_Relation>
}

export type PayloadLockedDocument_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>
  user?: InputMaybe<PayloadLockedDocument_User_Relation>
}

export type PayloadLockedDocuments = {
  __typename?: 'PayloadLockedDocuments'
  docs?: Maybe<Array<Maybe<PayloadLockedDocument>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type PayloadLockedDocumentsCreateAccess = {
  __typename?: 'PayloadLockedDocumentsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocumentsCreateDocAccess = {
  __typename?: 'PayloadLockedDocumentsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocumentsDeleteAccess = {
  __typename?: 'PayloadLockedDocumentsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocumentsDeleteDocAccess = {
  __typename?: 'PayloadLockedDocumentsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocumentsDocAccessFields = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields'
  createdAt?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt>
  document?: Maybe<PayloadLockedDocumentsDocAccessFields_Document>
  globalSlug?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug>
  updatedAt?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt>
  user?: Maybe<PayloadLockedDocumentsDocAccessFields_User>
}

export type PayloadLockedDocumentsDocAccessFields_CreatedAt = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt'
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Read>
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Update>
}

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_Document = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document'
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Create>
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Delete>
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Read>
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Update>
}

export type PayloadLockedDocumentsDocAccessFields_Document_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_Document_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_Document_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_Document_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug'
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create>
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete>
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read>
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update>
}

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt'
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update>
}

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_User = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user'
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Create>
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Delete>
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Read>
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Update>
}

export type PayloadLockedDocumentsDocAccessFields_User_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_User_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_User_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsDocAccessFields_User_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields = {
  __typename?: 'PayloadLockedDocumentsFields'
  createdAt?: Maybe<PayloadLockedDocumentsFields_CreatedAt>
  document?: Maybe<PayloadLockedDocumentsFields_Document>
  globalSlug?: Maybe<PayloadLockedDocumentsFields_GlobalSlug>
  updatedAt?: Maybe<PayloadLockedDocumentsFields_UpdatedAt>
  user?: Maybe<PayloadLockedDocumentsFields_User>
}

export type PayloadLockedDocumentsFields_CreatedAt = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt'
  create?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Create>
  delete?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Delete>
  read?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Read>
  update?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Update>
}

export type PayloadLockedDocumentsFields_CreatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_CreatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_CreatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_CreatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_Document = {
  __typename?: 'PayloadLockedDocumentsFields_document'
  create?: Maybe<PayloadLockedDocumentsFields_Document_Create>
  delete?: Maybe<PayloadLockedDocumentsFields_Document_Delete>
  read?: Maybe<PayloadLockedDocumentsFields_Document_Read>
  update?: Maybe<PayloadLockedDocumentsFields_Document_Update>
}

export type PayloadLockedDocumentsFields_Document_Create = {
  __typename?: 'PayloadLockedDocumentsFields_document_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_Document_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_document_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_Document_Read = {
  __typename?: 'PayloadLockedDocumentsFields_document_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_Document_Update = {
  __typename?: 'PayloadLockedDocumentsFields_document_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_GlobalSlug = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug'
  create?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Create>
  delete?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Delete>
  read?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Read>
  update?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Update>
}

export type PayloadLockedDocumentsFields_GlobalSlug_Create = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_GlobalSlug_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_GlobalSlug_Read = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_GlobalSlug_Update = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_UpdatedAt = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt'
  create?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Create>
  delete?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Delete>
  read?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Read>
  update?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Update>
}

export type PayloadLockedDocumentsFields_UpdatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_UpdatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_UpdatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_UpdatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_User = {
  __typename?: 'PayloadLockedDocumentsFields_user'
  create?: Maybe<PayloadLockedDocumentsFields_User_Create>
  delete?: Maybe<PayloadLockedDocumentsFields_User_Delete>
  read?: Maybe<PayloadLockedDocumentsFields_User_Read>
  update?: Maybe<PayloadLockedDocumentsFields_User_Update>
}

export type PayloadLockedDocumentsFields_User_Create = {
  __typename?: 'PayloadLockedDocumentsFields_user_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_User_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_user_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_User_Read = {
  __typename?: 'PayloadLockedDocumentsFields_user_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsFields_User_Update = {
  __typename?: 'PayloadLockedDocumentsFields_user_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadLockedDocumentsReadAccess = {
  __typename?: 'PayloadLockedDocumentsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocumentsReadDocAccess = {
  __typename?: 'PayloadLockedDocumentsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocumentsUpdateAccess = {
  __typename?: 'PayloadLockedDocumentsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadLockedDocumentsUpdateDocAccess = {
  __typename?: 'PayloadLockedDocumentsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreference = {
  __typename?: 'PayloadPreference'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  key?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  user: PayloadPreference_User_Relationship
  value?: Maybe<Scalars['JSON']['output']>
}

export type PayloadPreferenceUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadPreferenceUpdate_UserRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadPreferenceUpdate_UserRelationshipInputRelationTo = {
  Users: 'users',
} as const

export type PayloadPreferenceUpdate_UserRelationshipInputRelationTo =
  (typeof PayloadPreferenceUpdate_UserRelationshipInputRelationTo)[keyof typeof PayloadPreferenceUpdate_UserRelationshipInputRelationTo]
export type PayloadPreference_User = CmsUser

export type PayloadPreference_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadPreference_UserRelationshipInputRelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadPreference_UserRelationshipInputRelationTo = {
  Users: 'users',
} as const

export type PayloadPreference_UserRelationshipInputRelationTo =
  (typeof PayloadPreference_UserRelationshipInputRelationTo)[keyof typeof PayloadPreference_UserRelationshipInputRelationTo]
export const PayloadPreference_User_RelationTo = {
  Users: 'users',
} as const

export type PayloadPreference_User_RelationTo =
  (typeof PayloadPreference_User_RelationTo)[keyof typeof PayloadPreference_User_RelationTo]
export type PayloadPreference_User_Relationship = {
  __typename?: 'PayloadPreference_User_Relationship'
  relationTo?: Maybe<PayloadPreference_User_RelationTo>
  value?: Maybe<PayloadPreference_User>
}

export type PayloadPreference_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type PayloadPreference_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type PayloadPreference_Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type PayloadPreference_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type PayloadPreference_User_Relation = {
  relationTo?: InputMaybe<PayloadPreference_User_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const PayloadPreference_User_Relation_RelationTo = {
  Users: 'users',
} as const

export type PayloadPreference_User_Relation_RelationTo =
  (typeof PayloadPreference_User_Relation_RelationTo)[keyof typeof PayloadPreference_User_Relation_RelationTo]
export type PayloadPreference_Value_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  intersects?: InputMaybe<Scalars['JSON']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  within?: InputMaybe<Scalars['JSON']['input']>
}

export type PayloadPreference_Where = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>
  id?: InputMaybe<PayloadPreference_Id_Operator>
  key?: InputMaybe<PayloadPreference_Key_Operator>
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>
  user?: InputMaybe<PayloadPreference_User_Relation>
  value?: InputMaybe<PayloadPreference_Value_Operator>
}

export type PayloadPreference_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>
  id?: InputMaybe<PayloadPreference_Id_Operator>
  key?: InputMaybe<PayloadPreference_Key_Operator>
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>
  user?: InputMaybe<PayloadPreference_User_Relation>
  value?: InputMaybe<PayloadPreference_Value_Operator>
}

export type PayloadPreference_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>
  id?: InputMaybe<PayloadPreference_Id_Operator>
  key?: InputMaybe<PayloadPreference_Key_Operator>
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>
  user?: InputMaybe<PayloadPreference_User_Relation>
  value?: InputMaybe<PayloadPreference_Value_Operator>
}

export type PayloadPreferences = {
  __typename?: 'PayloadPreferences'
  docs?: Maybe<Array<Maybe<PayloadPreference>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type PayloadPreferencesCreateAccess = {
  __typename?: 'PayloadPreferencesCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreferencesCreateDocAccess = {
  __typename?: 'PayloadPreferencesCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreferencesDeleteAccess = {
  __typename?: 'PayloadPreferencesDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreferencesDeleteDocAccess = {
  __typename?: 'PayloadPreferencesDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreferencesDocAccessFields = {
  __typename?: 'PayloadPreferencesDocAccessFields'
  createdAt?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt>
  key?: Maybe<PayloadPreferencesDocAccessFields_Key>
  updatedAt?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt>
  user?: Maybe<PayloadPreferencesDocAccessFields_User>
  value?: Maybe<PayloadPreferencesDocAccessFields_Value>
}

export type PayloadPreferencesDocAccessFields_CreatedAt = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt'
  create?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Create>
  delete?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Delete>
  read?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Read>
  update?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Update>
}

export type PayloadPreferencesDocAccessFields_CreatedAt_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_CreatedAt_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_CreatedAt_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Key = {
  __typename?: 'PayloadPreferencesDocAccessFields_key'
  create?: Maybe<PayloadPreferencesDocAccessFields_Key_Create>
  delete?: Maybe<PayloadPreferencesDocAccessFields_Key_Delete>
  read?: Maybe<PayloadPreferencesDocAccessFields_Key_Read>
  update?: Maybe<PayloadPreferencesDocAccessFields_Key_Update>
}

export type PayloadPreferencesDocAccessFields_Key_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Key_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Key_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Key_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_UpdatedAt = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt'
  create?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Read>
  update?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Update>
}

export type PayloadPreferencesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_User = {
  __typename?: 'PayloadPreferencesDocAccessFields_user'
  create?: Maybe<PayloadPreferencesDocAccessFields_User_Create>
  delete?: Maybe<PayloadPreferencesDocAccessFields_User_Delete>
  read?: Maybe<PayloadPreferencesDocAccessFields_User_Read>
  update?: Maybe<PayloadPreferencesDocAccessFields_User_Update>
}

export type PayloadPreferencesDocAccessFields_User_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_User_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_User_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_User_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Value = {
  __typename?: 'PayloadPreferencesDocAccessFields_value'
  create?: Maybe<PayloadPreferencesDocAccessFields_Value_Create>
  delete?: Maybe<PayloadPreferencesDocAccessFields_Value_Delete>
  read?: Maybe<PayloadPreferencesDocAccessFields_Value_Read>
  update?: Maybe<PayloadPreferencesDocAccessFields_Value_Update>
}

export type PayloadPreferencesDocAccessFields_Value_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Value_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Value_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesDocAccessFields_Value_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields = {
  __typename?: 'PayloadPreferencesFields'
  createdAt?: Maybe<PayloadPreferencesFields_CreatedAt>
  key?: Maybe<PayloadPreferencesFields_Key>
  updatedAt?: Maybe<PayloadPreferencesFields_UpdatedAt>
  user?: Maybe<PayloadPreferencesFields_User>
  value?: Maybe<PayloadPreferencesFields_Value>
}

export type PayloadPreferencesFields_CreatedAt = {
  __typename?: 'PayloadPreferencesFields_createdAt'
  create?: Maybe<PayloadPreferencesFields_CreatedAt_Create>
  delete?: Maybe<PayloadPreferencesFields_CreatedAt_Delete>
  read?: Maybe<PayloadPreferencesFields_CreatedAt_Read>
  update?: Maybe<PayloadPreferencesFields_CreatedAt_Update>
}

export type PayloadPreferencesFields_CreatedAt_Create = {
  __typename?: 'PayloadPreferencesFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_CreatedAt_Delete = {
  __typename?: 'PayloadPreferencesFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_CreatedAt_Read = {
  __typename?: 'PayloadPreferencesFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_CreatedAt_Update = {
  __typename?: 'PayloadPreferencesFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Key = {
  __typename?: 'PayloadPreferencesFields_key'
  create?: Maybe<PayloadPreferencesFields_Key_Create>
  delete?: Maybe<PayloadPreferencesFields_Key_Delete>
  read?: Maybe<PayloadPreferencesFields_Key_Read>
  update?: Maybe<PayloadPreferencesFields_Key_Update>
}

export type PayloadPreferencesFields_Key_Create = {
  __typename?: 'PayloadPreferencesFields_key_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Key_Delete = {
  __typename?: 'PayloadPreferencesFields_key_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Key_Read = {
  __typename?: 'PayloadPreferencesFields_key_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Key_Update = {
  __typename?: 'PayloadPreferencesFields_key_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_UpdatedAt = {
  __typename?: 'PayloadPreferencesFields_updatedAt'
  create?: Maybe<PayloadPreferencesFields_UpdatedAt_Create>
  delete?: Maybe<PayloadPreferencesFields_UpdatedAt_Delete>
  read?: Maybe<PayloadPreferencesFields_UpdatedAt_Read>
  update?: Maybe<PayloadPreferencesFields_UpdatedAt_Update>
}

export type PayloadPreferencesFields_UpdatedAt_Create = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_UpdatedAt_Delete = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_UpdatedAt_Read = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_UpdatedAt_Update = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_User = {
  __typename?: 'PayloadPreferencesFields_user'
  create?: Maybe<PayloadPreferencesFields_User_Create>
  delete?: Maybe<PayloadPreferencesFields_User_Delete>
  read?: Maybe<PayloadPreferencesFields_User_Read>
  update?: Maybe<PayloadPreferencesFields_User_Update>
}

export type PayloadPreferencesFields_User_Create = {
  __typename?: 'PayloadPreferencesFields_user_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_User_Delete = {
  __typename?: 'PayloadPreferencesFields_user_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_User_Read = {
  __typename?: 'PayloadPreferencesFields_user_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_User_Update = {
  __typename?: 'PayloadPreferencesFields_user_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Value = {
  __typename?: 'PayloadPreferencesFields_value'
  create?: Maybe<PayloadPreferencesFields_Value_Create>
  delete?: Maybe<PayloadPreferencesFields_Value_Delete>
  read?: Maybe<PayloadPreferencesFields_Value_Read>
  update?: Maybe<PayloadPreferencesFields_Value_Update>
}

export type PayloadPreferencesFields_Value_Create = {
  __typename?: 'PayloadPreferencesFields_value_Create'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Value_Delete = {
  __typename?: 'PayloadPreferencesFields_value_Delete'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Value_Read = {
  __typename?: 'PayloadPreferencesFields_value_Read'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesFields_Value_Update = {
  __typename?: 'PayloadPreferencesFields_value_Update'
  permission: Scalars['Boolean']['output']
}

export type PayloadPreferencesReadAccess = {
  __typename?: 'PayloadPreferencesReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreferencesReadDocAccess = {
  __typename?: 'PayloadPreferencesReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreferencesUpdateAccess = {
  __typename?: 'PayloadPreferencesUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PayloadPreferencesUpdateDocAccess = {
  __typename?: 'PayloadPreferencesUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingCreateAccess = {
  __typename?: 'PricingCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingCreateDocAccess = {
  __typename?: 'PricingCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingDeleteAccess = {
  __typename?: 'PricingDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingDeleteDocAccess = {
  __typename?: 'PricingDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingDocAccessFields = {
  __typename?: 'PricingDocAccessFields'
  buttonText?: Maybe<PricingDocAccessFields_ButtonText>
  buttonUrl?: Maybe<PricingDocAccessFields_ButtonUrl>
  createdAt?: Maybe<PricingDocAccessFields_CreatedAt>
  createdBy?: Maybe<PricingDocAccessFields_CreatedBy>
  features?: Maybe<PricingDocAccessFields_Features>
  includes?: Maybe<PricingDocAccessFields_Includes>
  isPopular?: Maybe<PricingDocAccessFields_IsPopular>
  popularText?: Maybe<PricingDocAccessFields_PopularText>
  priceMonthly?: Maybe<PricingDocAccessFields_PriceMonthly>
  priceQuarterly?: Maybe<PricingDocAccessFields_PriceQuarterly>
  priceYearly?: Maybe<PricingDocAccessFields_PriceYearly>
  tierDescription?: Maybe<PricingDocAccessFields_TierDescription>
  tierName?: Maybe<PricingDocAccessFields_TierName>
  updatedAt?: Maybe<PricingDocAccessFields_UpdatedAt>
}

export type PricingDocAccessFields_ButtonText = {
  __typename?: 'PricingDocAccessFields_buttonText'
  create?: Maybe<PricingDocAccessFields_ButtonText_Create>
  delete?: Maybe<PricingDocAccessFields_ButtonText_Delete>
  read?: Maybe<PricingDocAccessFields_ButtonText_Read>
  update?: Maybe<PricingDocAccessFields_ButtonText_Update>
}

export type PricingDocAccessFields_ButtonText_Create = {
  __typename?: 'PricingDocAccessFields_buttonText_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_ButtonText_Delete = {
  __typename?: 'PricingDocAccessFields_buttonText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_ButtonText_Read = {
  __typename?: 'PricingDocAccessFields_buttonText_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_ButtonText_Update = {
  __typename?: 'PricingDocAccessFields_buttonText_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_ButtonUrl = {
  __typename?: 'PricingDocAccessFields_buttonUrl'
  create?: Maybe<PricingDocAccessFields_ButtonUrl_Create>
  delete?: Maybe<PricingDocAccessFields_ButtonUrl_Delete>
  read?: Maybe<PricingDocAccessFields_ButtonUrl_Read>
  update?: Maybe<PricingDocAccessFields_ButtonUrl_Update>
}

export type PricingDocAccessFields_ButtonUrl_Create = {
  __typename?: 'PricingDocAccessFields_buttonUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_ButtonUrl_Delete = {
  __typename?: 'PricingDocAccessFields_buttonUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_ButtonUrl_Read = {
  __typename?: 'PricingDocAccessFields_buttonUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_ButtonUrl_Update = {
  __typename?: 'PricingDocAccessFields_buttonUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedAt = {
  __typename?: 'PricingDocAccessFields_createdAt'
  create?: Maybe<PricingDocAccessFields_CreatedAt_Create>
  delete?: Maybe<PricingDocAccessFields_CreatedAt_Delete>
  read?: Maybe<PricingDocAccessFields_CreatedAt_Read>
  update?: Maybe<PricingDocAccessFields_CreatedAt_Update>
}

export type PricingDocAccessFields_CreatedAt_Create = {
  __typename?: 'PricingDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PricingDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedAt_Read = {
  __typename?: 'PricingDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedAt_Update = {
  __typename?: 'PricingDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedBy = {
  __typename?: 'PricingDocAccessFields_createdBy'
  create?: Maybe<PricingDocAccessFields_CreatedBy_Create>
  delete?: Maybe<PricingDocAccessFields_CreatedBy_Delete>
  read?: Maybe<PricingDocAccessFields_CreatedBy_Read>
  update?: Maybe<PricingDocAccessFields_CreatedBy_Update>
}

export type PricingDocAccessFields_CreatedBy_Create = {
  __typename?: 'PricingDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedBy_Delete = {
  __typename?: 'PricingDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedBy_Read = {
  __typename?: 'PricingDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_CreatedBy_Update = {
  __typename?: 'PricingDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features = {
  __typename?: 'PricingDocAccessFields_features'
  create?: Maybe<PricingDocAccessFields_Features_Create>
  delete?: Maybe<PricingDocAccessFields_Features_Delete>
  fields?: Maybe<PricingDocAccessFields_Features_Fields>
  read?: Maybe<PricingDocAccessFields_Features_Read>
  update?: Maybe<PricingDocAccessFields_Features_Update>
}

export type PricingDocAccessFields_Features_Create = {
  __typename?: 'PricingDocAccessFields_features_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Delete = {
  __typename?: 'PricingDocAccessFields_features_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Fields = {
  __typename?: 'PricingDocAccessFields_features_Fields'
  disclaimer?: Maybe<PricingDocAccessFields_Features_Disclaimer>
  id?: Maybe<PricingDocAccessFields_Features_Id>
  text?: Maybe<PricingDocAccessFields_Features_Text>
}

export type PricingDocAccessFields_Features_Read = {
  __typename?: 'PricingDocAccessFields_features_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Update = {
  __typename?: 'PricingDocAccessFields_features_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Disclaimer = {
  __typename?: 'PricingDocAccessFields_features_disclaimer'
  create?: Maybe<PricingDocAccessFields_Features_Disclaimer_Create>
  delete?: Maybe<PricingDocAccessFields_Features_Disclaimer_Delete>
  read?: Maybe<PricingDocAccessFields_Features_Disclaimer_Read>
  update?: Maybe<PricingDocAccessFields_Features_Disclaimer_Update>
}

export type PricingDocAccessFields_Features_Disclaimer_Create = {
  __typename?: 'PricingDocAccessFields_features_disclaimer_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Disclaimer_Delete = {
  __typename?: 'PricingDocAccessFields_features_disclaimer_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Disclaimer_Read = {
  __typename?: 'PricingDocAccessFields_features_disclaimer_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Disclaimer_Update = {
  __typename?: 'PricingDocAccessFields_features_disclaimer_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Id = {
  __typename?: 'PricingDocAccessFields_features_id'
  create?: Maybe<PricingDocAccessFields_Features_Id_Create>
  delete?: Maybe<PricingDocAccessFields_Features_Id_Delete>
  read?: Maybe<PricingDocAccessFields_Features_Id_Read>
  update?: Maybe<PricingDocAccessFields_Features_Id_Update>
}

export type PricingDocAccessFields_Features_Id_Create = {
  __typename?: 'PricingDocAccessFields_features_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Id_Delete = {
  __typename?: 'PricingDocAccessFields_features_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Id_Read = {
  __typename?: 'PricingDocAccessFields_features_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Id_Update = {
  __typename?: 'PricingDocAccessFields_features_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Text = {
  __typename?: 'PricingDocAccessFields_features_text'
  create?: Maybe<PricingDocAccessFields_Features_Text_Create>
  delete?: Maybe<PricingDocAccessFields_Features_Text_Delete>
  read?: Maybe<PricingDocAccessFields_Features_Text_Read>
  update?: Maybe<PricingDocAccessFields_Features_Text_Update>
}

export type PricingDocAccessFields_Features_Text_Create = {
  __typename?: 'PricingDocAccessFields_features_text_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Text_Delete = {
  __typename?: 'PricingDocAccessFields_features_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Text_Read = {
  __typename?: 'PricingDocAccessFields_features_text_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Features_Text_Update = {
  __typename?: 'PricingDocAccessFields_features_text_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Includes = {
  __typename?: 'PricingDocAccessFields_includes'
  create?: Maybe<PricingDocAccessFields_Includes_Create>
  delete?: Maybe<PricingDocAccessFields_Includes_Delete>
  read?: Maybe<PricingDocAccessFields_Includes_Read>
  update?: Maybe<PricingDocAccessFields_Includes_Update>
}

export type PricingDocAccessFields_Includes_Create = {
  __typename?: 'PricingDocAccessFields_includes_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Includes_Delete = {
  __typename?: 'PricingDocAccessFields_includes_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Includes_Read = {
  __typename?: 'PricingDocAccessFields_includes_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_Includes_Update = {
  __typename?: 'PricingDocAccessFields_includes_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_IsPopular = {
  __typename?: 'PricingDocAccessFields_isPopular'
  create?: Maybe<PricingDocAccessFields_IsPopular_Create>
  delete?: Maybe<PricingDocAccessFields_IsPopular_Delete>
  read?: Maybe<PricingDocAccessFields_IsPopular_Read>
  update?: Maybe<PricingDocAccessFields_IsPopular_Update>
}

export type PricingDocAccessFields_IsPopular_Create = {
  __typename?: 'PricingDocAccessFields_isPopular_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_IsPopular_Delete = {
  __typename?: 'PricingDocAccessFields_isPopular_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_IsPopular_Read = {
  __typename?: 'PricingDocAccessFields_isPopular_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_IsPopular_Update = {
  __typename?: 'PricingDocAccessFields_isPopular_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PopularText = {
  __typename?: 'PricingDocAccessFields_popularText'
  create?: Maybe<PricingDocAccessFields_PopularText_Create>
  delete?: Maybe<PricingDocAccessFields_PopularText_Delete>
  read?: Maybe<PricingDocAccessFields_PopularText_Read>
  update?: Maybe<PricingDocAccessFields_PopularText_Update>
}

export type PricingDocAccessFields_PopularText_Create = {
  __typename?: 'PricingDocAccessFields_popularText_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PopularText_Delete = {
  __typename?: 'PricingDocAccessFields_popularText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PopularText_Read = {
  __typename?: 'PricingDocAccessFields_popularText_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PopularText_Update = {
  __typename?: 'PricingDocAccessFields_popularText_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceMonthly = {
  __typename?: 'PricingDocAccessFields_priceMonthly'
  create?: Maybe<PricingDocAccessFields_PriceMonthly_Create>
  delete?: Maybe<PricingDocAccessFields_PriceMonthly_Delete>
  read?: Maybe<PricingDocAccessFields_PriceMonthly_Read>
  update?: Maybe<PricingDocAccessFields_PriceMonthly_Update>
}

export type PricingDocAccessFields_PriceMonthly_Create = {
  __typename?: 'PricingDocAccessFields_priceMonthly_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceMonthly_Delete = {
  __typename?: 'PricingDocAccessFields_priceMonthly_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceMonthly_Read = {
  __typename?: 'PricingDocAccessFields_priceMonthly_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceMonthly_Update = {
  __typename?: 'PricingDocAccessFields_priceMonthly_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceQuarterly = {
  __typename?: 'PricingDocAccessFields_priceQuarterly'
  create?: Maybe<PricingDocAccessFields_PriceQuarterly_Create>
  delete?: Maybe<PricingDocAccessFields_PriceQuarterly_Delete>
  read?: Maybe<PricingDocAccessFields_PriceQuarterly_Read>
  update?: Maybe<PricingDocAccessFields_PriceQuarterly_Update>
}

export type PricingDocAccessFields_PriceQuarterly_Create = {
  __typename?: 'PricingDocAccessFields_priceQuarterly_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceQuarterly_Delete = {
  __typename?: 'PricingDocAccessFields_priceQuarterly_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceQuarterly_Read = {
  __typename?: 'PricingDocAccessFields_priceQuarterly_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceQuarterly_Update = {
  __typename?: 'PricingDocAccessFields_priceQuarterly_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceYearly = {
  __typename?: 'PricingDocAccessFields_priceYearly'
  create?: Maybe<PricingDocAccessFields_PriceYearly_Create>
  delete?: Maybe<PricingDocAccessFields_PriceYearly_Delete>
  read?: Maybe<PricingDocAccessFields_PriceYearly_Read>
  update?: Maybe<PricingDocAccessFields_PriceYearly_Update>
}

export type PricingDocAccessFields_PriceYearly_Create = {
  __typename?: 'PricingDocAccessFields_priceYearly_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceYearly_Delete = {
  __typename?: 'PricingDocAccessFields_priceYearly_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceYearly_Read = {
  __typename?: 'PricingDocAccessFields_priceYearly_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_PriceYearly_Update = {
  __typename?: 'PricingDocAccessFields_priceYearly_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierDescription = {
  __typename?: 'PricingDocAccessFields_tierDescription'
  create?: Maybe<PricingDocAccessFields_TierDescription_Create>
  delete?: Maybe<PricingDocAccessFields_TierDescription_Delete>
  read?: Maybe<PricingDocAccessFields_TierDescription_Read>
  update?: Maybe<PricingDocAccessFields_TierDescription_Update>
}

export type PricingDocAccessFields_TierDescription_Create = {
  __typename?: 'PricingDocAccessFields_tierDescription_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierDescription_Delete = {
  __typename?: 'PricingDocAccessFields_tierDescription_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierDescription_Read = {
  __typename?: 'PricingDocAccessFields_tierDescription_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierDescription_Update = {
  __typename?: 'PricingDocAccessFields_tierDescription_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierName = {
  __typename?: 'PricingDocAccessFields_tierName'
  create?: Maybe<PricingDocAccessFields_TierName_Create>
  delete?: Maybe<PricingDocAccessFields_TierName_Delete>
  read?: Maybe<PricingDocAccessFields_TierName_Read>
  update?: Maybe<PricingDocAccessFields_TierName_Update>
}

export type PricingDocAccessFields_TierName_Create = {
  __typename?: 'PricingDocAccessFields_tierName_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierName_Delete = {
  __typename?: 'PricingDocAccessFields_tierName_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierName_Read = {
  __typename?: 'PricingDocAccessFields_tierName_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_TierName_Update = {
  __typename?: 'PricingDocAccessFields_tierName_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_UpdatedAt = {
  __typename?: 'PricingDocAccessFields_updatedAt'
  create?: Maybe<PricingDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<PricingDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<PricingDocAccessFields_UpdatedAt_Read>
  update?: Maybe<PricingDocAccessFields_UpdatedAt_Update>
}

export type PricingDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PricingDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PricingDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PricingDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PricingDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields = {
  __typename?: 'PricingFields'
  buttonText?: Maybe<PricingFields_ButtonText>
  buttonUrl?: Maybe<PricingFields_ButtonUrl>
  createdAt?: Maybe<PricingFields_CreatedAt>
  createdBy?: Maybe<PricingFields_CreatedBy>
  features?: Maybe<PricingFields_Features>
  includes?: Maybe<PricingFields_Includes>
  isPopular?: Maybe<PricingFields_IsPopular>
  popularText?: Maybe<PricingFields_PopularText>
  priceMonthly?: Maybe<PricingFields_PriceMonthly>
  priceQuarterly?: Maybe<PricingFields_PriceQuarterly>
  priceYearly?: Maybe<PricingFields_PriceYearly>
  tierDescription?: Maybe<PricingFields_TierDescription>
  tierName?: Maybe<PricingFields_TierName>
  updatedAt?: Maybe<PricingFields_UpdatedAt>
}

export type PricingFields_ButtonText = {
  __typename?: 'PricingFields_buttonText'
  create?: Maybe<PricingFields_ButtonText_Create>
  delete?: Maybe<PricingFields_ButtonText_Delete>
  read?: Maybe<PricingFields_ButtonText_Read>
  update?: Maybe<PricingFields_ButtonText_Update>
}

export type PricingFields_ButtonText_Create = {
  __typename?: 'PricingFields_buttonText_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_ButtonText_Delete = {
  __typename?: 'PricingFields_buttonText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_ButtonText_Read = {
  __typename?: 'PricingFields_buttonText_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_ButtonText_Update = {
  __typename?: 'PricingFields_buttonText_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_ButtonUrl = {
  __typename?: 'PricingFields_buttonUrl'
  create?: Maybe<PricingFields_ButtonUrl_Create>
  delete?: Maybe<PricingFields_ButtonUrl_Delete>
  read?: Maybe<PricingFields_ButtonUrl_Read>
  update?: Maybe<PricingFields_ButtonUrl_Update>
}

export type PricingFields_ButtonUrl_Create = {
  __typename?: 'PricingFields_buttonUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_ButtonUrl_Delete = {
  __typename?: 'PricingFields_buttonUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_ButtonUrl_Read = {
  __typename?: 'PricingFields_buttonUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_ButtonUrl_Update = {
  __typename?: 'PricingFields_buttonUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedAt = {
  __typename?: 'PricingFields_createdAt'
  create?: Maybe<PricingFields_CreatedAt_Create>
  delete?: Maybe<PricingFields_CreatedAt_Delete>
  read?: Maybe<PricingFields_CreatedAt_Read>
  update?: Maybe<PricingFields_CreatedAt_Update>
}

export type PricingFields_CreatedAt_Create = {
  __typename?: 'PricingFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedAt_Delete = {
  __typename?: 'PricingFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedAt_Read = {
  __typename?: 'PricingFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedAt_Update = {
  __typename?: 'PricingFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedBy = {
  __typename?: 'PricingFields_createdBy'
  create?: Maybe<PricingFields_CreatedBy_Create>
  delete?: Maybe<PricingFields_CreatedBy_Delete>
  read?: Maybe<PricingFields_CreatedBy_Read>
  update?: Maybe<PricingFields_CreatedBy_Update>
}

export type PricingFields_CreatedBy_Create = {
  __typename?: 'PricingFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedBy_Delete = {
  __typename?: 'PricingFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedBy_Read = {
  __typename?: 'PricingFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_CreatedBy_Update = {
  __typename?: 'PricingFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features = {
  __typename?: 'PricingFields_features'
  create?: Maybe<PricingFields_Features_Create>
  delete?: Maybe<PricingFields_Features_Delete>
  fields?: Maybe<PricingFields_Features_Fields>
  read?: Maybe<PricingFields_Features_Read>
  update?: Maybe<PricingFields_Features_Update>
}

export type PricingFields_Features_Create = {
  __typename?: 'PricingFields_features_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Delete = {
  __typename?: 'PricingFields_features_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Fields = {
  __typename?: 'PricingFields_features_Fields'
  disclaimer?: Maybe<PricingFields_Features_Disclaimer>
  id?: Maybe<PricingFields_Features_Id>
  text?: Maybe<PricingFields_Features_Text>
}

export type PricingFields_Features_Read = {
  __typename?: 'PricingFields_features_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Update = {
  __typename?: 'PricingFields_features_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Disclaimer = {
  __typename?: 'PricingFields_features_disclaimer'
  create?: Maybe<PricingFields_Features_Disclaimer_Create>
  delete?: Maybe<PricingFields_Features_Disclaimer_Delete>
  read?: Maybe<PricingFields_Features_Disclaimer_Read>
  update?: Maybe<PricingFields_Features_Disclaimer_Update>
}

export type PricingFields_Features_Disclaimer_Create = {
  __typename?: 'PricingFields_features_disclaimer_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Disclaimer_Delete = {
  __typename?: 'PricingFields_features_disclaimer_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Disclaimer_Read = {
  __typename?: 'PricingFields_features_disclaimer_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Disclaimer_Update = {
  __typename?: 'PricingFields_features_disclaimer_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Id = {
  __typename?: 'PricingFields_features_id'
  create?: Maybe<PricingFields_Features_Id_Create>
  delete?: Maybe<PricingFields_Features_Id_Delete>
  read?: Maybe<PricingFields_Features_Id_Read>
  update?: Maybe<PricingFields_Features_Id_Update>
}

export type PricingFields_Features_Id_Create = {
  __typename?: 'PricingFields_features_id_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Id_Delete = {
  __typename?: 'PricingFields_features_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Id_Read = {
  __typename?: 'PricingFields_features_id_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Id_Update = {
  __typename?: 'PricingFields_features_id_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Text = {
  __typename?: 'PricingFields_features_text'
  create?: Maybe<PricingFields_Features_Text_Create>
  delete?: Maybe<PricingFields_Features_Text_Delete>
  read?: Maybe<PricingFields_Features_Text_Read>
  update?: Maybe<PricingFields_Features_Text_Update>
}

export type PricingFields_Features_Text_Create = {
  __typename?: 'PricingFields_features_text_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Text_Delete = {
  __typename?: 'PricingFields_features_text_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Text_Read = {
  __typename?: 'PricingFields_features_text_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Features_Text_Update = {
  __typename?: 'PricingFields_features_text_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Includes = {
  __typename?: 'PricingFields_includes'
  create?: Maybe<PricingFields_Includes_Create>
  delete?: Maybe<PricingFields_Includes_Delete>
  read?: Maybe<PricingFields_Includes_Read>
  update?: Maybe<PricingFields_Includes_Update>
}

export type PricingFields_Includes_Create = {
  __typename?: 'PricingFields_includes_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Includes_Delete = {
  __typename?: 'PricingFields_includes_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Includes_Read = {
  __typename?: 'PricingFields_includes_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_Includes_Update = {
  __typename?: 'PricingFields_includes_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_IsPopular = {
  __typename?: 'PricingFields_isPopular'
  create?: Maybe<PricingFields_IsPopular_Create>
  delete?: Maybe<PricingFields_IsPopular_Delete>
  read?: Maybe<PricingFields_IsPopular_Read>
  update?: Maybe<PricingFields_IsPopular_Update>
}

export type PricingFields_IsPopular_Create = {
  __typename?: 'PricingFields_isPopular_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_IsPopular_Delete = {
  __typename?: 'PricingFields_isPopular_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_IsPopular_Read = {
  __typename?: 'PricingFields_isPopular_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_IsPopular_Update = {
  __typename?: 'PricingFields_isPopular_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PopularText = {
  __typename?: 'PricingFields_popularText'
  create?: Maybe<PricingFields_PopularText_Create>
  delete?: Maybe<PricingFields_PopularText_Delete>
  read?: Maybe<PricingFields_PopularText_Read>
  update?: Maybe<PricingFields_PopularText_Update>
}

export type PricingFields_PopularText_Create = {
  __typename?: 'PricingFields_popularText_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PopularText_Delete = {
  __typename?: 'PricingFields_popularText_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PopularText_Read = {
  __typename?: 'PricingFields_popularText_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PopularText_Update = {
  __typename?: 'PricingFields_popularText_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceMonthly = {
  __typename?: 'PricingFields_priceMonthly'
  create?: Maybe<PricingFields_PriceMonthly_Create>
  delete?: Maybe<PricingFields_PriceMonthly_Delete>
  read?: Maybe<PricingFields_PriceMonthly_Read>
  update?: Maybe<PricingFields_PriceMonthly_Update>
}

export type PricingFields_PriceMonthly_Create = {
  __typename?: 'PricingFields_priceMonthly_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceMonthly_Delete = {
  __typename?: 'PricingFields_priceMonthly_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceMonthly_Read = {
  __typename?: 'PricingFields_priceMonthly_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceMonthly_Update = {
  __typename?: 'PricingFields_priceMonthly_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceQuarterly = {
  __typename?: 'PricingFields_priceQuarterly'
  create?: Maybe<PricingFields_PriceQuarterly_Create>
  delete?: Maybe<PricingFields_PriceQuarterly_Delete>
  read?: Maybe<PricingFields_PriceQuarterly_Read>
  update?: Maybe<PricingFields_PriceQuarterly_Update>
}

export type PricingFields_PriceQuarterly_Create = {
  __typename?: 'PricingFields_priceQuarterly_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceQuarterly_Delete = {
  __typename?: 'PricingFields_priceQuarterly_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceQuarterly_Read = {
  __typename?: 'PricingFields_priceQuarterly_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceQuarterly_Update = {
  __typename?: 'PricingFields_priceQuarterly_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceYearly = {
  __typename?: 'PricingFields_priceYearly'
  create?: Maybe<PricingFields_PriceYearly_Create>
  delete?: Maybe<PricingFields_PriceYearly_Delete>
  read?: Maybe<PricingFields_PriceYearly_Read>
  update?: Maybe<PricingFields_PriceYearly_Update>
}

export type PricingFields_PriceYearly_Create = {
  __typename?: 'PricingFields_priceYearly_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceYearly_Delete = {
  __typename?: 'PricingFields_priceYearly_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceYearly_Read = {
  __typename?: 'PricingFields_priceYearly_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_PriceYearly_Update = {
  __typename?: 'PricingFields_priceYearly_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierDescription = {
  __typename?: 'PricingFields_tierDescription'
  create?: Maybe<PricingFields_TierDescription_Create>
  delete?: Maybe<PricingFields_TierDescription_Delete>
  read?: Maybe<PricingFields_TierDescription_Read>
  update?: Maybe<PricingFields_TierDescription_Update>
}

export type PricingFields_TierDescription_Create = {
  __typename?: 'PricingFields_tierDescription_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierDescription_Delete = {
  __typename?: 'PricingFields_tierDescription_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierDescription_Read = {
  __typename?: 'PricingFields_tierDescription_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierDescription_Update = {
  __typename?: 'PricingFields_tierDescription_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierName = {
  __typename?: 'PricingFields_tierName'
  create?: Maybe<PricingFields_TierName_Create>
  delete?: Maybe<PricingFields_TierName_Delete>
  read?: Maybe<PricingFields_TierName_Read>
  update?: Maybe<PricingFields_TierName_Update>
}

export type PricingFields_TierName_Create = {
  __typename?: 'PricingFields_tierName_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierName_Delete = {
  __typename?: 'PricingFields_tierName_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierName_Read = {
  __typename?: 'PricingFields_tierName_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_TierName_Update = {
  __typename?: 'PricingFields_tierName_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_UpdatedAt = {
  __typename?: 'PricingFields_updatedAt'
  create?: Maybe<PricingFields_UpdatedAt_Create>
  delete?: Maybe<PricingFields_UpdatedAt_Delete>
  read?: Maybe<PricingFields_UpdatedAt_Read>
  update?: Maybe<PricingFields_UpdatedAt_Update>
}

export type PricingFields_UpdatedAt_Create = {
  __typename?: 'PricingFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_UpdatedAt_Delete = {
  __typename?: 'PricingFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_UpdatedAt_Read = {
  __typename?: 'PricingFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type PricingFields_UpdatedAt_Update = {
  __typename?: 'PricingFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type PricingReadAccess = {
  __typename?: 'PricingReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingReadDocAccess = {
  __typename?: 'PricingReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingUpdateAccess = {
  __typename?: 'PricingUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type PricingUpdateDocAccess = {
  __typename?: 'PricingUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type Query = {
  __typename?: 'Query'
  Access?: Maybe<Access>
  CmsArticle?: Maybe<CmsArticle>
  CmsArticles?: Maybe<CmsArticles>
  CmsAuthor?: Maybe<CmsAuthor>
  CmsAuthors?: Maybe<CmsAuthors>
  CmsCallout?: Maybe<CmsCallout>
  CmsCallouts?: Maybe<CmsCallouts>
  CmsCategories?: Maybe<CmsCategories>
  CmsComment?: Maybe<CmsComment>
  CmsComments?: Maybe<CmsComments>
  CmsFooter?: Maybe<CmsFooter>
  CmsForm?: Maybe<CmsForm>
  CmsFormSubmission?: Maybe<CmsFormSubmission>
  CmsFormSubmissions?: Maybe<CmsFormSubmissions>
  CmsForms?: Maybe<CmsForms>
  CmsGuide?: Maybe<CmsGuide>
  CmsGuides?: Maybe<CmsGuides>
  CmsHeader?: Maybe<CmsHeader>
  CmsLegal?: Maybe<CmsLegal>
  CmsLegals?: Maybe<CmsLegals>
  CmsLinks?: Maybe<CmsLinks>
  CmsLiteEmbeddedMarketplace?: Maybe<CmsLiteEmbeddedMarketplace>
  CmsLiteEmbeddedMarketplaces?: Maybe<CmsLiteEmbeddedMarketplaces>
  CmsMarketplacePage?: Maybe<CmsMarketplacePage>
  CmsMarketplacePages?: Maybe<CmsMarketplacePages>
  CmsMedia?: Maybe<CmsMedia>
  CmsMedias?: Maybe<CmsMedias>
  CmsNewsroomArticle?: Maybe<CmsNewsroomArticle>
  CmsNewsroomArticles?: Maybe<CmsNewsroomArticles>
  CmsPage?: Maybe<CmsPage>
  CmsPages?: Maybe<CmsPages>
  CmsPricing?: Maybe<CmsPricing>
  CmsPricings?: Maybe<CmsPricings>
  CmsRating?: Maybe<CmsRating>
  CmsRatings?: Maybe<CmsRatings>
  CmsRedirect?: Maybe<CmsRedirect>
  CmsRedirects?: Maybe<CmsRedirects>
  CmsSearch?: Maybe<CmsSearch>
  CmsSettings?: Maybe<CmsSettings>
  CmsStackerPage?: Maybe<CmsStackerPage>
  CmsStackerPages?: Maybe<CmsStackerPages>
  CmsTradeCreditProgram?: Maybe<CmsTradeCreditProgram>
  CmsTradeCreditProgramTag?: Maybe<CmsTradeCreditProgramTag>
  CmsTradeCreditProgramTags?: Maybe<CmsTradeCreditProgramTags>
  CmsTradeCreditPrograms?: Maybe<CmsTradeCreditPrograms>
  CmsTradeCreditRecommendation?: Maybe<CmsTradeCreditRecommendation>
  CmsTradeCreditRecommendations?: Maybe<CmsTradeCreditRecommendations>
  CmsTradeCreditVendor?: Maybe<CmsTradeCreditVendor>
  CmsTradeCreditVendors?: Maybe<CmsTradeCreditVendors>
  CmsUser?: Maybe<CmsUser>
  CmsUsers?: Maybe<CmsUsers>
  CmsVideo?: Maybe<CmsVideo>
  CmsVideos?: Maybe<CmsVideos>
  PayloadLockedDocument?: Maybe<PayloadLockedDocument>
  PayloadLockedDocuments?: Maybe<PayloadLockedDocuments>
  PayloadPreference?: Maybe<PayloadPreference>
  PayloadPreferences?: Maybe<PayloadPreferences>
  allCmsCategories?: Maybe<AllCmsCategories>
  allCmsLinks?: Maybe<AllCmsLinks>
  countCmsArticles?: Maybe<CountCmsArticles>
  countCmsAuthors?: Maybe<CountCmsAuthors>
  countCmsCallouts?: Maybe<CountCmsCallouts>
  countCmsComments?: Maybe<CountCmsComments>
  countCmsFormSubmissions?: Maybe<CountCmsFormSubmissions>
  countCmsForms?: Maybe<CountCmsForms>
  countCmsGuides?: Maybe<CountCmsGuides>
  countCmsLegals?: Maybe<CountCmsLegals>
  countCmsLiteEmbeddedMarketplaces?: Maybe<CountCmsLiteEmbeddedMarketplaces>
  countCmsMarketplacePages?: Maybe<CountCmsMarketplacePages>
  countCmsMedias?: Maybe<CountCmsMedias>
  countCmsNewsroomArticles?: Maybe<CountCmsNewsroomArticles>
  countCmsPages?: Maybe<CountCmsPages>
  countCmsPricings?: Maybe<CountCmsPricings>
  countCmsRatings?: Maybe<CountCmsRatings>
  countCmsRedirects?: Maybe<CountCmsRedirects>
  countCmsStackerPages?: Maybe<CountCmsStackerPages>
  countCmsTradeCreditProgramTags?: Maybe<CountCmsTradeCreditProgramTags>
  countCmsTradeCreditPrograms?: Maybe<CountCmsTradeCreditPrograms>
  countCmsTradeCreditRecommendations?: Maybe<CountCmsTradeCreditRecommendations>
  countCmsTradeCreditVendors?: Maybe<CountCmsTradeCreditVendors>
  countCmsUsers?: Maybe<CountCmsUsers>
  countCmsVideos?: Maybe<CountCmsVideos>
  countPayloadLockedDocuments?: Maybe<CountPayloadLockedDocuments>
  countPayloadPreferences?: Maybe<CountPayloadPreferences>
  countallCmsCategories?: Maybe<CountallCmsCategories>
  countallCmsLinks?: Maybe<CountallCmsLinks>
  docAccessCmsArticle?: Maybe<ArticlesDocAccess>
  docAccessCmsAuthor?: Maybe<AuthorsDocAccess>
  docAccessCmsCallout?: Maybe<CalloutsDocAccess>
  docAccessCmsCategories?: Maybe<CategoriesDocAccess>
  docAccessCmsComment?: Maybe<CommentsDocAccess>
  docAccessCmsFooter?: Maybe<FooterDocAccess>
  docAccessCmsForm?: Maybe<FormsDocAccess>
  docAccessCmsFormSubmission?: Maybe<Form_SubmissionsDocAccess>
  docAccessCmsGuide?: Maybe<GuidesDocAccess>
  docAccessCmsHeader?: Maybe<HeaderDocAccess>
  docAccessCmsLegal?: Maybe<LegalDocAccess>
  docAccessCmsLinks?: Maybe<LinksDocAccess>
  docAccessCmsLiteEmbeddedMarketplace?: Maybe<Lite_EmbeddedDocAccess>
  docAccessCmsMarketplacePage?: Maybe<MarketplaceDocAccess>
  docAccessCmsMedia?: Maybe<MediaDocAccess>
  docAccessCmsNewsroomArticle?: Maybe<NewsroomDocAccess>
  docAccessCmsPage?: Maybe<PagesDocAccess>
  docAccessCmsPricing?: Maybe<PricingDocAccess>
  docAccessCmsRating?: Maybe<RatingsDocAccess>
  docAccessCmsRedirect?: Maybe<RedirectsDocAccess>
  docAccessCmsSettings?: Maybe<SettingsDocAccess>
  docAccessCmsStackerPage?: Maybe<StackerDocAccess>
  docAccessCmsTradeCreditProgram?: Maybe<Tc_ProgramsDocAccess>
  docAccessCmsTradeCreditProgramTag?: Maybe<Tc_Program_TagsDocAccess>
  docAccessCmsTradeCreditRecommendation?: Maybe<Trade_Credit_VendorsDocAccess>
  docAccessCmsTradeCreditVendor?: Maybe<Tc_VendorsDocAccess>
  docAccessCmsUser?: Maybe<UsersDocAccess>
  docAccessCmsVideo?: Maybe<VideosDocAccess>
  docAccessPayloadLockedDocument?: Maybe<Payload_Locked_DocumentsDocAccess>
  docAccessPayloadPreference?: Maybe<Payload_PreferencesDocAccess>
  getUserStorage?: Maybe<CmsUserStorage>
  initializedCmsUser?: Maybe<Scalars['Boolean']['output']>
  meCmsUser?: Maybe<UsersMe>
  versionCmsArticle?: Maybe<CmsArticleVersion>
  versionCmsForm?: Maybe<CmsFormVersion>
  versionCmsGuide?: Maybe<CmsGuideVersion>
  versionCmsLiteEmbeddedMarketplace?: Maybe<CmsLiteEmbeddedMarketplaceVersion>
  versionCmsMarketplacePage?: Maybe<CmsMarketplacePageVersion>
  versionCmsNewsroomArticle?: Maybe<CmsNewsroomArticleVersion>
  versionCmsPage?: Maybe<CmsPageVersion>
  versionCmsStackerPage?: Maybe<CmsStackerPageVersion>
  versionCmsTradeCreditProgram?: Maybe<CmsTradeCreditProgramVersion>
  versionCmsTradeCreditRecommendation?: Maybe<CmsTradeCreditRecommendationVersion>
  versionCmsTradeCreditVendor?: Maybe<CmsTradeCreditVendorVersion>
  versionsCmsArticles?: Maybe<VersionsCmsArticles>
  versionsCmsForms?: Maybe<VersionsCmsForms>
  versionsCmsGuides?: Maybe<VersionsCmsGuides>
  versionsCmsLiteEmbeddedMarketplaces?: Maybe<VersionsCmsLiteEmbeddedMarketplaces>
  versionsCmsMarketplacePages?: Maybe<VersionsCmsMarketplacePages>
  versionsCmsNewsroomArticles?: Maybe<VersionsCmsNewsroomArticles>
  versionsCmsPages?: Maybe<VersionsCmsPages>
  versionsCmsStackerPages?: Maybe<VersionsCmsStackerPages>
  versionsCmsTradeCreditPrograms?: Maybe<VersionsCmsTradeCreditPrograms>
  versionsCmsTradeCreditRecommendations?: Maybe<VersionsCmsTradeCreditRecommendations>
  versionsCmsTradeCreditVendors?: Maybe<VersionsCmsTradeCreditVendors>
}

export type QueryCmsArticleArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsArticle_Where>
}

export type QueryCmsAuthorArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsAuthorsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsAuthor_Where>
}

export type QueryCmsCalloutArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsCalloutsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsCallout_Where>
}

export type QueryCmsCategoriesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsCommentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsCommentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsComment_Where>
}

export type QueryCmsFooterArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCmsFormArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsFormSubmissionArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsFormSubmissionsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsFormSubmission_Where>
}

export type QueryCmsFormsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsForm_Where>
}

export type QueryCmsGuideArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsGuidesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsGuide_Where>
}

export type QueryCmsHeaderArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCmsLegalArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsLegalsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsLegal_Where>
}

export type QueryCmsLinksArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsLiteEmbeddedMarketplaceArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsLiteEmbeddedMarketplacesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsLiteEmbeddedMarketplace_Where>
}

export type QueryCmsMarketplacePageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsMarketplacePagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsMarketplacePage_Where>
}

export type QueryCmsMediaArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsMediasArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsMedia_Where>
}

export type QueryCmsNewsroomArticleArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsNewsroomArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsNewsroomArticle_Where>
}

export type QueryCmsPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsPage_Where>
}

export type QueryCmsPricingArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsPricingsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsPricing_Where>
}

export type QueryCmsRatingArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsRatingsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsRating_Where>
}

export type QueryCmsRedirectArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsRedirectsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsRedirect_Where>
}

export type QueryCmsSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  searchText: Scalars['String']['input']
}

export type QueryCmsSettingsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCmsStackerPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsStackerPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsStackerPage_Where>
}

export type QueryCmsTradeCreditProgramArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsTradeCreditProgramTagArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsTradeCreditProgramTagsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsTradeCreditProgramTag_Where>
}

export type QueryCmsTradeCreditProgramsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsTradeCreditProgram_Where>
}

export type QueryCmsTradeCreditRecommendationArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsTradeCreditRecommendationsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsTradeCreditRecommendation_Where>
}

export type QueryCmsTradeCreditVendorArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsTradeCreditVendorsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsTradeCreditVendor_Where>
}

export type QueryCmsUserArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsUsersArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsUser_Where>
}

export type QueryCmsVideoArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryCmsVideosArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsVideo_Where>
}

export type QueryPayloadLockedDocumentArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryPayloadLockedDocumentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<PayloadLockedDocument_Where>
}

export type QueryPayloadPreferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
}

export type QueryPayloadPreferencesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<PayloadPreference_Where>
}

export type QueryAllCmsCategoriesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsCategories_Where>
}

export type QueryAllCmsLinksArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<CmsLinks_Where>
}

export type QueryCountCmsArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsArticle_Where>
}

export type QueryCountCmsAuthorsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsAuthor_Where>
}

export type QueryCountCmsCalloutsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsCallout_Where>
}

export type QueryCountCmsCommentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsComment_Where>
}

export type QueryCountCmsFormSubmissionsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsFormSubmission_Where>
}

export type QueryCountCmsFormsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsForm_Where>
}

export type QueryCountCmsGuidesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsGuide_Where>
}

export type QueryCountCmsLegalsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsLegal_Where>
}

export type QueryCountCmsLiteEmbeddedMarketplacesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsLiteEmbeddedMarketplace_Where>
}

export type QueryCountCmsMarketplacePagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsMarketplacePage_Where>
}

export type QueryCountCmsMediasArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsMedia_Where>
}

export type QueryCountCmsNewsroomArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsNewsroomArticle_Where>
}

export type QueryCountCmsPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsPage_Where>
}

export type QueryCountCmsPricingsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsPricing_Where>
}

export type QueryCountCmsRatingsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsRating_Where>
}

export type QueryCountCmsRedirectsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsRedirect_Where>
}

export type QueryCountCmsStackerPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsStackerPage_Where>
}

export type QueryCountCmsTradeCreditProgramTagsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsTradeCreditProgramTag_Where>
}

export type QueryCountCmsTradeCreditProgramsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsTradeCreditProgram_Where>
}

export type QueryCountCmsTradeCreditRecommendationsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsTradeCreditRecommendation_Where>
}

export type QueryCountCmsTradeCreditVendorsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsTradeCreditVendor_Where>
}

export type QueryCountCmsUsersArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsUser_Where>
}

export type QueryCountCmsVideosArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsVideo_Where>
}

export type QueryCountPayloadLockedDocumentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PayloadLockedDocument_Where>
}

export type QueryCountPayloadPreferencesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PayloadPreference_Where>
}

export type QueryCountallCmsCategoriesArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsCategories_Where>
}

export type QueryCountallCmsLinksArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<CmsLinks_Where>
}

export type QueryDocAccessCmsArticleArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsAuthorArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsCalloutArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsCategoriesArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsCommentArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsFormArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsFormSubmissionArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsGuideArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsLegalArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsLinksArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsLiteEmbeddedMarketplaceArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsMarketplacePageArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsMediaArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsNewsroomArticleArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsPageArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsPricingArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsRatingArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsRedirectArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsStackerPageArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsTradeCreditProgramArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsTradeCreditProgramTagArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsTradeCreditRecommendationArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsTradeCreditVendorArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsUserArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessCmsVideoArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessPayloadLockedDocumentArgs = {
  id: Scalars['Int']['input']
}

export type QueryDocAccessPayloadPreferenceArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetUserStorageArgs = {
  key: Scalars['String']['input']
  method: UserStorageMethod
}

export type QueryVersionCmsArticleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsFormArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsGuideArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsLiteEmbeddedMarketplaceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsMarketplacePageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsNewsroomArticleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsStackerPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsTradeCreditProgramArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsTradeCreditRecommendationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionCmsTradeCreditVendorArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVersionsCmsArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsArticle_Where>
}

export type QueryVersionsCmsFormsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsForm_Where>
}

export type QueryVersionsCmsGuidesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsGuide_Where>
}

export type QueryVersionsCmsLiteEmbeddedMarketplacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Where>
}

export type QueryVersionsCmsMarketplacePagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsMarketplacePage_Where>
}

export type QueryVersionsCmsNewsroomArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsNewsroomArticle_Where>
}

export type QueryVersionsCmsPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsPage_Where>
}

export type QueryVersionsCmsStackerPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsStackerPage_Where>
}

export type QueryVersionsCmsTradeCreditProgramsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsTradeCreditProgram_Where>
}

export type QueryVersionsCmsTradeCreditRecommendationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsTradeCreditRecommendation_Where>
}

export type QueryVersionsCmsTradeCreditVendorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pagination?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  where?: InputMaybe<VersionsCmsTradeCreditVendor_Where>
}

export type RatingsCreateAccess = {
  __typename?: 'RatingsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RatingsCreateDocAccess = {
  __typename?: 'RatingsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RatingsDeleteAccess = {
  __typename?: 'RatingsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RatingsDeleteDocAccess = {
  __typename?: 'RatingsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RatingsDocAccessFields = {
  __typename?: 'RatingsDocAccessFields'
  average?: Maybe<RatingsDocAccessFields_Average>
  createdAt?: Maybe<RatingsDocAccessFields_CreatedAt>
  fiveStar?: Maybe<RatingsDocAccessFields_FiveStar>
  fourStar?: Maybe<RatingsDocAccessFields_FourStar>
  oneStar?: Maybe<RatingsDocAccessFields_OneStar>
  threeStar?: Maybe<RatingsDocAccessFields_ThreeStar>
  total?: Maybe<RatingsDocAccessFields_Total>
  twoStar?: Maybe<RatingsDocAccessFields_TwoStar>
  updatedAt?: Maybe<RatingsDocAccessFields_UpdatedAt>
}

export type RatingsDocAccessFields_Average = {
  __typename?: 'RatingsDocAccessFields_average'
  create?: Maybe<RatingsDocAccessFields_Average_Create>
  delete?: Maybe<RatingsDocAccessFields_Average_Delete>
  read?: Maybe<RatingsDocAccessFields_Average_Read>
  update?: Maybe<RatingsDocAccessFields_Average_Update>
}

export type RatingsDocAccessFields_Average_Create = {
  __typename?: 'RatingsDocAccessFields_average_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_Average_Delete = {
  __typename?: 'RatingsDocAccessFields_average_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_Average_Read = {
  __typename?: 'RatingsDocAccessFields_average_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_Average_Update = {
  __typename?: 'RatingsDocAccessFields_average_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_CreatedAt = {
  __typename?: 'RatingsDocAccessFields_createdAt'
  create?: Maybe<RatingsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<RatingsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<RatingsDocAccessFields_CreatedAt_Read>
  update?: Maybe<RatingsDocAccessFields_CreatedAt_Update>
}

export type RatingsDocAccessFields_CreatedAt_Create = {
  __typename?: 'RatingsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'RatingsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_CreatedAt_Read = {
  __typename?: 'RatingsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_CreatedAt_Update = {
  __typename?: 'RatingsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FiveStar = {
  __typename?: 'RatingsDocAccessFields_fiveStar'
  create?: Maybe<RatingsDocAccessFields_FiveStar_Create>
  delete?: Maybe<RatingsDocAccessFields_FiveStar_Delete>
  read?: Maybe<RatingsDocAccessFields_FiveStar_Read>
  update?: Maybe<RatingsDocAccessFields_FiveStar_Update>
}

export type RatingsDocAccessFields_FiveStar_Create = {
  __typename?: 'RatingsDocAccessFields_fiveStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FiveStar_Delete = {
  __typename?: 'RatingsDocAccessFields_fiveStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FiveStar_Read = {
  __typename?: 'RatingsDocAccessFields_fiveStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FiveStar_Update = {
  __typename?: 'RatingsDocAccessFields_fiveStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FourStar = {
  __typename?: 'RatingsDocAccessFields_fourStar'
  create?: Maybe<RatingsDocAccessFields_FourStar_Create>
  delete?: Maybe<RatingsDocAccessFields_FourStar_Delete>
  read?: Maybe<RatingsDocAccessFields_FourStar_Read>
  update?: Maybe<RatingsDocAccessFields_FourStar_Update>
}

export type RatingsDocAccessFields_FourStar_Create = {
  __typename?: 'RatingsDocAccessFields_fourStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FourStar_Delete = {
  __typename?: 'RatingsDocAccessFields_fourStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FourStar_Read = {
  __typename?: 'RatingsDocAccessFields_fourStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_FourStar_Update = {
  __typename?: 'RatingsDocAccessFields_fourStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_OneStar = {
  __typename?: 'RatingsDocAccessFields_oneStar'
  create?: Maybe<RatingsDocAccessFields_OneStar_Create>
  delete?: Maybe<RatingsDocAccessFields_OneStar_Delete>
  read?: Maybe<RatingsDocAccessFields_OneStar_Read>
  update?: Maybe<RatingsDocAccessFields_OneStar_Update>
}

export type RatingsDocAccessFields_OneStar_Create = {
  __typename?: 'RatingsDocAccessFields_oneStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_OneStar_Delete = {
  __typename?: 'RatingsDocAccessFields_oneStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_OneStar_Read = {
  __typename?: 'RatingsDocAccessFields_oneStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_OneStar_Update = {
  __typename?: 'RatingsDocAccessFields_oneStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_ThreeStar = {
  __typename?: 'RatingsDocAccessFields_threeStar'
  create?: Maybe<RatingsDocAccessFields_ThreeStar_Create>
  delete?: Maybe<RatingsDocAccessFields_ThreeStar_Delete>
  read?: Maybe<RatingsDocAccessFields_ThreeStar_Read>
  update?: Maybe<RatingsDocAccessFields_ThreeStar_Update>
}

export type RatingsDocAccessFields_ThreeStar_Create = {
  __typename?: 'RatingsDocAccessFields_threeStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_ThreeStar_Delete = {
  __typename?: 'RatingsDocAccessFields_threeStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_ThreeStar_Read = {
  __typename?: 'RatingsDocAccessFields_threeStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_ThreeStar_Update = {
  __typename?: 'RatingsDocAccessFields_threeStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_Total = {
  __typename?: 'RatingsDocAccessFields_total'
  create?: Maybe<RatingsDocAccessFields_Total_Create>
  delete?: Maybe<RatingsDocAccessFields_Total_Delete>
  read?: Maybe<RatingsDocAccessFields_Total_Read>
  update?: Maybe<RatingsDocAccessFields_Total_Update>
}

export type RatingsDocAccessFields_Total_Create = {
  __typename?: 'RatingsDocAccessFields_total_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_Total_Delete = {
  __typename?: 'RatingsDocAccessFields_total_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_Total_Read = {
  __typename?: 'RatingsDocAccessFields_total_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_Total_Update = {
  __typename?: 'RatingsDocAccessFields_total_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_TwoStar = {
  __typename?: 'RatingsDocAccessFields_twoStar'
  create?: Maybe<RatingsDocAccessFields_TwoStar_Create>
  delete?: Maybe<RatingsDocAccessFields_TwoStar_Delete>
  read?: Maybe<RatingsDocAccessFields_TwoStar_Read>
  update?: Maybe<RatingsDocAccessFields_TwoStar_Update>
}

export type RatingsDocAccessFields_TwoStar_Create = {
  __typename?: 'RatingsDocAccessFields_twoStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_TwoStar_Delete = {
  __typename?: 'RatingsDocAccessFields_twoStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_TwoStar_Read = {
  __typename?: 'RatingsDocAccessFields_twoStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_TwoStar_Update = {
  __typename?: 'RatingsDocAccessFields_twoStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_UpdatedAt = {
  __typename?: 'RatingsDocAccessFields_updatedAt'
  create?: Maybe<RatingsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<RatingsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<RatingsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<RatingsDocAccessFields_UpdatedAt_Update>
}

export type RatingsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'RatingsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'RatingsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'RatingsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'RatingsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields = {
  __typename?: 'RatingsFields'
  average?: Maybe<RatingsFields_Average>
  createdAt?: Maybe<RatingsFields_CreatedAt>
  fiveStar?: Maybe<RatingsFields_FiveStar>
  fourStar?: Maybe<RatingsFields_FourStar>
  oneStar?: Maybe<RatingsFields_OneStar>
  threeStar?: Maybe<RatingsFields_ThreeStar>
  total?: Maybe<RatingsFields_Total>
  twoStar?: Maybe<RatingsFields_TwoStar>
  updatedAt?: Maybe<RatingsFields_UpdatedAt>
}

export type RatingsFields_Average = {
  __typename?: 'RatingsFields_average'
  create?: Maybe<RatingsFields_Average_Create>
  delete?: Maybe<RatingsFields_Average_Delete>
  read?: Maybe<RatingsFields_Average_Read>
  update?: Maybe<RatingsFields_Average_Update>
}

export type RatingsFields_Average_Create = {
  __typename?: 'RatingsFields_average_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_Average_Delete = {
  __typename?: 'RatingsFields_average_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_Average_Read = {
  __typename?: 'RatingsFields_average_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_Average_Update = {
  __typename?: 'RatingsFields_average_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_CreatedAt = {
  __typename?: 'RatingsFields_createdAt'
  create?: Maybe<RatingsFields_CreatedAt_Create>
  delete?: Maybe<RatingsFields_CreatedAt_Delete>
  read?: Maybe<RatingsFields_CreatedAt_Read>
  update?: Maybe<RatingsFields_CreatedAt_Update>
}

export type RatingsFields_CreatedAt_Create = {
  __typename?: 'RatingsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_CreatedAt_Delete = {
  __typename?: 'RatingsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_CreatedAt_Read = {
  __typename?: 'RatingsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_CreatedAt_Update = {
  __typename?: 'RatingsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FiveStar = {
  __typename?: 'RatingsFields_fiveStar'
  create?: Maybe<RatingsFields_FiveStar_Create>
  delete?: Maybe<RatingsFields_FiveStar_Delete>
  read?: Maybe<RatingsFields_FiveStar_Read>
  update?: Maybe<RatingsFields_FiveStar_Update>
}

export type RatingsFields_FiveStar_Create = {
  __typename?: 'RatingsFields_fiveStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FiveStar_Delete = {
  __typename?: 'RatingsFields_fiveStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FiveStar_Read = {
  __typename?: 'RatingsFields_fiveStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FiveStar_Update = {
  __typename?: 'RatingsFields_fiveStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FourStar = {
  __typename?: 'RatingsFields_fourStar'
  create?: Maybe<RatingsFields_FourStar_Create>
  delete?: Maybe<RatingsFields_FourStar_Delete>
  read?: Maybe<RatingsFields_FourStar_Read>
  update?: Maybe<RatingsFields_FourStar_Update>
}

export type RatingsFields_FourStar_Create = {
  __typename?: 'RatingsFields_fourStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FourStar_Delete = {
  __typename?: 'RatingsFields_fourStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FourStar_Read = {
  __typename?: 'RatingsFields_fourStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_FourStar_Update = {
  __typename?: 'RatingsFields_fourStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_OneStar = {
  __typename?: 'RatingsFields_oneStar'
  create?: Maybe<RatingsFields_OneStar_Create>
  delete?: Maybe<RatingsFields_OneStar_Delete>
  read?: Maybe<RatingsFields_OneStar_Read>
  update?: Maybe<RatingsFields_OneStar_Update>
}

export type RatingsFields_OneStar_Create = {
  __typename?: 'RatingsFields_oneStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_OneStar_Delete = {
  __typename?: 'RatingsFields_oneStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_OneStar_Read = {
  __typename?: 'RatingsFields_oneStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_OneStar_Update = {
  __typename?: 'RatingsFields_oneStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_ThreeStar = {
  __typename?: 'RatingsFields_threeStar'
  create?: Maybe<RatingsFields_ThreeStar_Create>
  delete?: Maybe<RatingsFields_ThreeStar_Delete>
  read?: Maybe<RatingsFields_ThreeStar_Read>
  update?: Maybe<RatingsFields_ThreeStar_Update>
}

export type RatingsFields_ThreeStar_Create = {
  __typename?: 'RatingsFields_threeStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_ThreeStar_Delete = {
  __typename?: 'RatingsFields_threeStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_ThreeStar_Read = {
  __typename?: 'RatingsFields_threeStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_ThreeStar_Update = {
  __typename?: 'RatingsFields_threeStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_Total = {
  __typename?: 'RatingsFields_total'
  create?: Maybe<RatingsFields_Total_Create>
  delete?: Maybe<RatingsFields_Total_Delete>
  read?: Maybe<RatingsFields_Total_Read>
  update?: Maybe<RatingsFields_Total_Update>
}

export type RatingsFields_Total_Create = {
  __typename?: 'RatingsFields_total_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_Total_Delete = {
  __typename?: 'RatingsFields_total_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_Total_Read = {
  __typename?: 'RatingsFields_total_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_Total_Update = {
  __typename?: 'RatingsFields_total_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_TwoStar = {
  __typename?: 'RatingsFields_twoStar'
  create?: Maybe<RatingsFields_TwoStar_Create>
  delete?: Maybe<RatingsFields_TwoStar_Delete>
  read?: Maybe<RatingsFields_TwoStar_Read>
  update?: Maybe<RatingsFields_TwoStar_Update>
}

export type RatingsFields_TwoStar_Create = {
  __typename?: 'RatingsFields_twoStar_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_TwoStar_Delete = {
  __typename?: 'RatingsFields_twoStar_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_TwoStar_Read = {
  __typename?: 'RatingsFields_twoStar_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_TwoStar_Update = {
  __typename?: 'RatingsFields_twoStar_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_UpdatedAt = {
  __typename?: 'RatingsFields_updatedAt'
  create?: Maybe<RatingsFields_UpdatedAt_Create>
  delete?: Maybe<RatingsFields_UpdatedAt_Delete>
  read?: Maybe<RatingsFields_UpdatedAt_Read>
  update?: Maybe<RatingsFields_UpdatedAt_Update>
}

export type RatingsFields_UpdatedAt_Create = {
  __typename?: 'RatingsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_UpdatedAt_Delete = {
  __typename?: 'RatingsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_UpdatedAt_Read = {
  __typename?: 'RatingsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RatingsFields_UpdatedAt_Update = {
  __typename?: 'RatingsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RatingsReadAccess = {
  __typename?: 'RatingsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RatingsReadDocAccess = {
  __typename?: 'RatingsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RatingsUpdateAccess = {
  __typename?: 'RatingsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RatingsUpdateDocAccess = {
  __typename?: 'RatingsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsCreateAccess = {
  __typename?: 'RedirectsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsCreateDocAccess = {
  __typename?: 'RedirectsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsDeleteAccess = {
  __typename?: 'RedirectsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsDeleteDocAccess = {
  __typename?: 'RedirectsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsDocAccessFields = {
  __typename?: 'RedirectsDocAccessFields'
  createdAt?: Maybe<RedirectsDocAccessFields_CreatedAt>
  from?: Maybe<RedirectsDocAccessFields_From>
  permanent?: Maybe<RedirectsDocAccessFields_Permanent>
  to?: Maybe<RedirectsDocAccessFields_To>
  updatedAt?: Maybe<RedirectsDocAccessFields_UpdatedAt>
}

export type RedirectsDocAccessFields_CreatedAt = {
  __typename?: 'RedirectsDocAccessFields_createdAt'
  create?: Maybe<RedirectsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<RedirectsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<RedirectsDocAccessFields_CreatedAt_Read>
  update?: Maybe<RedirectsDocAccessFields_CreatedAt_Update>
}

export type RedirectsDocAccessFields_CreatedAt_Create = {
  __typename?: 'RedirectsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'RedirectsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_CreatedAt_Read = {
  __typename?: 'RedirectsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_CreatedAt_Update = {
  __typename?: 'RedirectsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_From = {
  __typename?: 'RedirectsDocAccessFields_from'
  create?: Maybe<RedirectsDocAccessFields_From_Create>
  delete?: Maybe<RedirectsDocAccessFields_From_Delete>
  read?: Maybe<RedirectsDocAccessFields_From_Read>
  update?: Maybe<RedirectsDocAccessFields_From_Update>
}

export type RedirectsDocAccessFields_From_Create = {
  __typename?: 'RedirectsDocAccessFields_from_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_From_Delete = {
  __typename?: 'RedirectsDocAccessFields_from_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_From_Read = {
  __typename?: 'RedirectsDocAccessFields_from_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_From_Update = {
  __typename?: 'RedirectsDocAccessFields_from_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_Permanent = {
  __typename?: 'RedirectsDocAccessFields_permanent'
  create?: Maybe<RedirectsDocAccessFields_Permanent_Create>
  delete?: Maybe<RedirectsDocAccessFields_Permanent_Delete>
  read?: Maybe<RedirectsDocAccessFields_Permanent_Read>
  update?: Maybe<RedirectsDocAccessFields_Permanent_Update>
}

export type RedirectsDocAccessFields_Permanent_Create = {
  __typename?: 'RedirectsDocAccessFields_permanent_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_Permanent_Delete = {
  __typename?: 'RedirectsDocAccessFields_permanent_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_Permanent_Read = {
  __typename?: 'RedirectsDocAccessFields_permanent_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_Permanent_Update = {
  __typename?: 'RedirectsDocAccessFields_permanent_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To = {
  __typename?: 'RedirectsDocAccessFields_to'
  create?: Maybe<RedirectsDocAccessFields_To_Create>
  delete?: Maybe<RedirectsDocAccessFields_To_Delete>
  fields?: Maybe<RedirectsDocAccessFields_To_Fields>
  read?: Maybe<RedirectsDocAccessFields_To_Read>
  update?: Maybe<RedirectsDocAccessFields_To_Update>
}

export type RedirectsDocAccessFields_To_Create = {
  __typename?: 'RedirectsDocAccessFields_to_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Delete = {
  __typename?: 'RedirectsDocAccessFields_to_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Fields = {
  __typename?: 'RedirectsDocAccessFields_to_Fields'
  reference?: Maybe<RedirectsDocAccessFields_To_Reference>
  type?: Maybe<RedirectsDocAccessFields_To_Type>
  url?: Maybe<RedirectsDocAccessFields_To_Url>
}

export type RedirectsDocAccessFields_To_Read = {
  __typename?: 'RedirectsDocAccessFields_to_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Update = {
  __typename?: 'RedirectsDocAccessFields_to_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Reference = {
  __typename?: 'RedirectsDocAccessFields_to_reference'
  create?: Maybe<RedirectsDocAccessFields_To_Reference_Create>
  delete?: Maybe<RedirectsDocAccessFields_To_Reference_Delete>
  read?: Maybe<RedirectsDocAccessFields_To_Reference_Read>
  update?: Maybe<RedirectsDocAccessFields_To_Reference_Update>
}

export type RedirectsDocAccessFields_To_Reference_Create = {
  __typename?: 'RedirectsDocAccessFields_to_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Reference_Delete = {
  __typename?: 'RedirectsDocAccessFields_to_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Reference_Read = {
  __typename?: 'RedirectsDocAccessFields_to_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Reference_Update = {
  __typename?: 'RedirectsDocAccessFields_to_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Type = {
  __typename?: 'RedirectsDocAccessFields_to_type'
  create?: Maybe<RedirectsDocAccessFields_To_Type_Create>
  delete?: Maybe<RedirectsDocAccessFields_To_Type_Delete>
  read?: Maybe<RedirectsDocAccessFields_To_Type_Read>
  update?: Maybe<RedirectsDocAccessFields_To_Type_Update>
}

export type RedirectsDocAccessFields_To_Type_Create = {
  __typename?: 'RedirectsDocAccessFields_to_type_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Type_Delete = {
  __typename?: 'RedirectsDocAccessFields_to_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Type_Read = {
  __typename?: 'RedirectsDocAccessFields_to_type_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Type_Update = {
  __typename?: 'RedirectsDocAccessFields_to_type_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Url = {
  __typename?: 'RedirectsDocAccessFields_to_url'
  create?: Maybe<RedirectsDocAccessFields_To_Url_Create>
  delete?: Maybe<RedirectsDocAccessFields_To_Url_Delete>
  read?: Maybe<RedirectsDocAccessFields_To_Url_Read>
  update?: Maybe<RedirectsDocAccessFields_To_Url_Update>
}

export type RedirectsDocAccessFields_To_Url_Create = {
  __typename?: 'RedirectsDocAccessFields_to_url_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Url_Delete = {
  __typename?: 'RedirectsDocAccessFields_to_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Url_Read = {
  __typename?: 'RedirectsDocAccessFields_to_url_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_To_Url_Update = {
  __typename?: 'RedirectsDocAccessFields_to_url_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_UpdatedAt = {
  __typename?: 'RedirectsDocAccessFields_updatedAt'
  create?: Maybe<RedirectsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<RedirectsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<RedirectsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<RedirectsDocAccessFields_UpdatedAt_Update>
}

export type RedirectsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'RedirectsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'RedirectsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'RedirectsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'RedirectsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields = {
  __typename?: 'RedirectsFields'
  createdAt?: Maybe<RedirectsFields_CreatedAt>
  from?: Maybe<RedirectsFields_From>
  permanent?: Maybe<RedirectsFields_Permanent>
  to?: Maybe<RedirectsFields_To>
  updatedAt?: Maybe<RedirectsFields_UpdatedAt>
}

export type RedirectsFields_CreatedAt = {
  __typename?: 'RedirectsFields_createdAt'
  create?: Maybe<RedirectsFields_CreatedAt_Create>
  delete?: Maybe<RedirectsFields_CreatedAt_Delete>
  read?: Maybe<RedirectsFields_CreatedAt_Read>
  update?: Maybe<RedirectsFields_CreatedAt_Update>
}

export type RedirectsFields_CreatedAt_Create = {
  __typename?: 'RedirectsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_CreatedAt_Delete = {
  __typename?: 'RedirectsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_CreatedAt_Read = {
  __typename?: 'RedirectsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_CreatedAt_Update = {
  __typename?: 'RedirectsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_From = {
  __typename?: 'RedirectsFields_from'
  create?: Maybe<RedirectsFields_From_Create>
  delete?: Maybe<RedirectsFields_From_Delete>
  read?: Maybe<RedirectsFields_From_Read>
  update?: Maybe<RedirectsFields_From_Update>
}

export type RedirectsFields_From_Create = {
  __typename?: 'RedirectsFields_from_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_From_Delete = {
  __typename?: 'RedirectsFields_from_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_From_Read = {
  __typename?: 'RedirectsFields_from_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_From_Update = {
  __typename?: 'RedirectsFields_from_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_Permanent = {
  __typename?: 'RedirectsFields_permanent'
  create?: Maybe<RedirectsFields_Permanent_Create>
  delete?: Maybe<RedirectsFields_Permanent_Delete>
  read?: Maybe<RedirectsFields_Permanent_Read>
  update?: Maybe<RedirectsFields_Permanent_Update>
}

export type RedirectsFields_Permanent_Create = {
  __typename?: 'RedirectsFields_permanent_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_Permanent_Delete = {
  __typename?: 'RedirectsFields_permanent_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_Permanent_Read = {
  __typename?: 'RedirectsFields_permanent_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_Permanent_Update = {
  __typename?: 'RedirectsFields_permanent_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To = {
  __typename?: 'RedirectsFields_to'
  create?: Maybe<RedirectsFields_To_Create>
  delete?: Maybe<RedirectsFields_To_Delete>
  fields?: Maybe<RedirectsFields_To_Fields>
  read?: Maybe<RedirectsFields_To_Read>
  update?: Maybe<RedirectsFields_To_Update>
}

export type RedirectsFields_To_Create = {
  __typename?: 'RedirectsFields_to_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Delete = {
  __typename?: 'RedirectsFields_to_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Fields = {
  __typename?: 'RedirectsFields_to_Fields'
  reference?: Maybe<RedirectsFields_To_Reference>
  type?: Maybe<RedirectsFields_To_Type>
  url?: Maybe<RedirectsFields_To_Url>
}

export type RedirectsFields_To_Read = {
  __typename?: 'RedirectsFields_to_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Update = {
  __typename?: 'RedirectsFields_to_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Reference = {
  __typename?: 'RedirectsFields_to_reference'
  create?: Maybe<RedirectsFields_To_Reference_Create>
  delete?: Maybe<RedirectsFields_To_Reference_Delete>
  read?: Maybe<RedirectsFields_To_Reference_Read>
  update?: Maybe<RedirectsFields_To_Reference_Update>
}

export type RedirectsFields_To_Reference_Create = {
  __typename?: 'RedirectsFields_to_reference_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Reference_Delete = {
  __typename?: 'RedirectsFields_to_reference_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Reference_Read = {
  __typename?: 'RedirectsFields_to_reference_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Reference_Update = {
  __typename?: 'RedirectsFields_to_reference_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Type = {
  __typename?: 'RedirectsFields_to_type'
  create?: Maybe<RedirectsFields_To_Type_Create>
  delete?: Maybe<RedirectsFields_To_Type_Delete>
  read?: Maybe<RedirectsFields_To_Type_Read>
  update?: Maybe<RedirectsFields_To_Type_Update>
}

export type RedirectsFields_To_Type_Create = {
  __typename?: 'RedirectsFields_to_type_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Type_Delete = {
  __typename?: 'RedirectsFields_to_type_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Type_Read = {
  __typename?: 'RedirectsFields_to_type_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Type_Update = {
  __typename?: 'RedirectsFields_to_type_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Url = {
  __typename?: 'RedirectsFields_to_url'
  create?: Maybe<RedirectsFields_To_Url_Create>
  delete?: Maybe<RedirectsFields_To_Url_Delete>
  read?: Maybe<RedirectsFields_To_Url_Read>
  update?: Maybe<RedirectsFields_To_Url_Update>
}

export type RedirectsFields_To_Url_Create = {
  __typename?: 'RedirectsFields_to_url_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Url_Delete = {
  __typename?: 'RedirectsFields_to_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Url_Read = {
  __typename?: 'RedirectsFields_to_url_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_To_Url_Update = {
  __typename?: 'RedirectsFields_to_url_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_UpdatedAt = {
  __typename?: 'RedirectsFields_updatedAt'
  create?: Maybe<RedirectsFields_UpdatedAt_Create>
  delete?: Maybe<RedirectsFields_UpdatedAt_Delete>
  read?: Maybe<RedirectsFields_UpdatedAt_Read>
  update?: Maybe<RedirectsFields_UpdatedAt_Update>
}

export type RedirectsFields_UpdatedAt_Create = {
  __typename?: 'RedirectsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_UpdatedAt_Delete = {
  __typename?: 'RedirectsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_UpdatedAt_Read = {
  __typename?: 'RedirectsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type RedirectsFields_UpdatedAt_Update = {
  __typename?: 'RedirectsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type RedirectsReadAccess = {
  __typename?: 'RedirectsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsReadDocAccess = {
  __typename?: 'RedirectsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsUpdateAccess = {
  __typename?: 'RedirectsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type RedirectsUpdateDocAccess = {
  __typename?: 'RedirectsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type SearchResultsCreateAccess = {
  __typename?: 'SearchResultsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type SearchResultsDeleteAccess = {
  __typename?: 'SearchResultsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type SearchResultsFields = {
  __typename?: 'SearchResultsFields'
  createdAt?: Maybe<SearchResultsFields_CreatedAt>
  doc?: Maybe<SearchResultsFields_Doc>
  excerpt?: Maybe<SearchResultsFields_Excerpt>
  priority?: Maybe<SearchResultsFields_Priority>
  title?: Maybe<SearchResultsFields_Title>
  updatedAt?: Maybe<SearchResultsFields_UpdatedAt>
}

export type SearchResultsFields_CreatedAt = {
  __typename?: 'SearchResultsFields_createdAt'
  create?: Maybe<SearchResultsFields_CreatedAt_Create>
  delete?: Maybe<SearchResultsFields_CreatedAt_Delete>
  read?: Maybe<SearchResultsFields_CreatedAt_Read>
  update?: Maybe<SearchResultsFields_CreatedAt_Update>
}

export type SearchResultsFields_CreatedAt_Create = {
  __typename?: 'SearchResultsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_CreatedAt_Delete = {
  __typename?: 'SearchResultsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_CreatedAt_Read = {
  __typename?: 'SearchResultsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_CreatedAt_Update = {
  __typename?: 'SearchResultsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Doc = {
  __typename?: 'SearchResultsFields_doc'
  create?: Maybe<SearchResultsFields_Doc_Create>
  delete?: Maybe<SearchResultsFields_Doc_Delete>
  read?: Maybe<SearchResultsFields_Doc_Read>
  update?: Maybe<SearchResultsFields_Doc_Update>
}

export type SearchResultsFields_Doc_Create = {
  __typename?: 'SearchResultsFields_doc_Create'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Doc_Delete = {
  __typename?: 'SearchResultsFields_doc_Delete'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Doc_Read = {
  __typename?: 'SearchResultsFields_doc_Read'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Doc_Update = {
  __typename?: 'SearchResultsFields_doc_Update'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Excerpt = {
  __typename?: 'SearchResultsFields_excerpt'
  create?: Maybe<SearchResultsFields_Excerpt_Create>
  delete?: Maybe<SearchResultsFields_Excerpt_Delete>
  read?: Maybe<SearchResultsFields_Excerpt_Read>
  update?: Maybe<SearchResultsFields_Excerpt_Update>
}

export type SearchResultsFields_Excerpt_Create = {
  __typename?: 'SearchResultsFields_excerpt_Create'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Excerpt_Delete = {
  __typename?: 'SearchResultsFields_excerpt_Delete'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Excerpt_Read = {
  __typename?: 'SearchResultsFields_excerpt_Read'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Excerpt_Update = {
  __typename?: 'SearchResultsFields_excerpt_Update'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Priority = {
  __typename?: 'SearchResultsFields_priority'
  create?: Maybe<SearchResultsFields_Priority_Create>
  delete?: Maybe<SearchResultsFields_Priority_Delete>
  read?: Maybe<SearchResultsFields_Priority_Read>
  update?: Maybe<SearchResultsFields_Priority_Update>
}

export type SearchResultsFields_Priority_Create = {
  __typename?: 'SearchResultsFields_priority_Create'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Priority_Delete = {
  __typename?: 'SearchResultsFields_priority_Delete'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Priority_Read = {
  __typename?: 'SearchResultsFields_priority_Read'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Priority_Update = {
  __typename?: 'SearchResultsFields_priority_Update'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Title = {
  __typename?: 'SearchResultsFields_title'
  create?: Maybe<SearchResultsFields_Title_Create>
  delete?: Maybe<SearchResultsFields_Title_Delete>
  read?: Maybe<SearchResultsFields_Title_Read>
  update?: Maybe<SearchResultsFields_Title_Update>
}

export type SearchResultsFields_Title_Create = {
  __typename?: 'SearchResultsFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Title_Delete = {
  __typename?: 'SearchResultsFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Title_Read = {
  __typename?: 'SearchResultsFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_Title_Update = {
  __typename?: 'SearchResultsFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_UpdatedAt = {
  __typename?: 'SearchResultsFields_updatedAt'
  create?: Maybe<SearchResultsFields_UpdatedAt_Create>
  delete?: Maybe<SearchResultsFields_UpdatedAt_Delete>
  read?: Maybe<SearchResultsFields_UpdatedAt_Read>
  update?: Maybe<SearchResultsFields_UpdatedAt_Update>
}

export type SearchResultsFields_UpdatedAt_Create = {
  __typename?: 'SearchResultsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_UpdatedAt_Delete = {
  __typename?: 'SearchResultsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_UpdatedAt_Read = {
  __typename?: 'SearchResultsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsFields_UpdatedAt_Update = {
  __typename?: 'SearchResultsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type SearchResultsReadAccess = {
  __typename?: 'SearchResultsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type SearchResultsUpdateAccess = {
  __typename?: 'SearchResultsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerCreateAccess = {
  __typename?: 'StackerCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerCreateDocAccess = {
  __typename?: 'StackerCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerDeleteAccess = {
  __typename?: 'StackerDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerDeleteDocAccess = {
  __typename?: 'StackerDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerDocAccessFields = {
  __typename?: 'StackerDocAccessFields'
  _status?: Maybe<StackerDocAccessFields__Status>
  affiliateCode?: Maybe<StackerDocAccessFields_AffiliateCode>
  createdAt?: Maybe<StackerDocAccessFields_CreatedAt>
  createdBy?: Maybe<StackerDocAccessFields_CreatedBy>
  offerCategories?: Maybe<StackerDocAccessFields_OfferCategories>
  publishedAt?: Maybe<StackerDocAccessFields_PublishedAt>
  slug?: Maybe<StackerDocAccessFields_Slug>
  title?: Maybe<StackerDocAccessFields_Title>
  updatedAt?: Maybe<StackerDocAccessFields_UpdatedAt>
}

export type StackerDocAccessFields__Status = {
  __typename?: 'StackerDocAccessFields__status'
  create?: Maybe<StackerDocAccessFields__Status_Create>
  delete?: Maybe<StackerDocAccessFields__Status_Delete>
  read?: Maybe<StackerDocAccessFields__Status_Read>
  update?: Maybe<StackerDocAccessFields__Status_Update>
}

export type StackerDocAccessFields__Status_Create = {
  __typename?: 'StackerDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields__Status_Delete = {
  __typename?: 'StackerDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields__Status_Read = {
  __typename?: 'StackerDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields__Status_Update = {
  __typename?: 'StackerDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_AffiliateCode = {
  __typename?: 'StackerDocAccessFields_affiliateCode'
  create?: Maybe<StackerDocAccessFields_AffiliateCode_Create>
  delete?: Maybe<StackerDocAccessFields_AffiliateCode_Delete>
  read?: Maybe<StackerDocAccessFields_AffiliateCode_Read>
  update?: Maybe<StackerDocAccessFields_AffiliateCode_Update>
}

export type StackerDocAccessFields_AffiliateCode_Create = {
  __typename?: 'StackerDocAccessFields_affiliateCode_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_AffiliateCode_Delete = {
  __typename?: 'StackerDocAccessFields_affiliateCode_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_AffiliateCode_Read = {
  __typename?: 'StackerDocAccessFields_affiliateCode_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_AffiliateCode_Update = {
  __typename?: 'StackerDocAccessFields_affiliateCode_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedAt = {
  __typename?: 'StackerDocAccessFields_createdAt'
  create?: Maybe<StackerDocAccessFields_CreatedAt_Create>
  delete?: Maybe<StackerDocAccessFields_CreatedAt_Delete>
  read?: Maybe<StackerDocAccessFields_CreatedAt_Read>
  update?: Maybe<StackerDocAccessFields_CreatedAt_Update>
}

export type StackerDocAccessFields_CreatedAt_Create = {
  __typename?: 'StackerDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedAt_Delete = {
  __typename?: 'StackerDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedAt_Read = {
  __typename?: 'StackerDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedAt_Update = {
  __typename?: 'StackerDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedBy = {
  __typename?: 'StackerDocAccessFields_createdBy'
  create?: Maybe<StackerDocAccessFields_CreatedBy_Create>
  delete?: Maybe<StackerDocAccessFields_CreatedBy_Delete>
  read?: Maybe<StackerDocAccessFields_CreatedBy_Read>
  update?: Maybe<StackerDocAccessFields_CreatedBy_Update>
}

export type StackerDocAccessFields_CreatedBy_Create = {
  __typename?: 'StackerDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedBy_Delete = {
  __typename?: 'StackerDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedBy_Read = {
  __typename?: 'StackerDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_CreatedBy_Update = {
  __typename?: 'StackerDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories = {
  __typename?: 'StackerDocAccessFields_offerCategories'
  create?: Maybe<StackerDocAccessFields_OfferCategories_Create>
  delete?: Maybe<StackerDocAccessFields_OfferCategories_Delete>
  fields?: Maybe<StackerDocAccessFields_OfferCategories_Fields>
  read?: Maybe<StackerDocAccessFields_OfferCategories_Read>
  update?: Maybe<StackerDocAccessFields_OfferCategories_Update>
}

export type StackerDocAccessFields_OfferCategories_Create = {
  __typename?: 'StackerDocAccessFields_offerCategories_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Delete = {
  __typename?: 'StackerDocAccessFields_offerCategories_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Fields = {
  __typename?: 'StackerDocAccessFields_offerCategories_Fields'
  category?: Maybe<StackerDocAccessFields_OfferCategories_Category>
  collection?: Maybe<StackerDocAccessFields_OfferCategories_Collection>
  id?: Maybe<StackerDocAccessFields_OfferCategories_Id>
  name?: Maybe<StackerDocAccessFields_OfferCategories_Name>
  slug?: Maybe<StackerDocAccessFields_OfferCategories_Slug>
}

export type StackerDocAccessFields_OfferCategories_Read = {
  __typename?: 'StackerDocAccessFields_offerCategories_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Update = {
  __typename?: 'StackerDocAccessFields_offerCategories_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Category = {
  __typename?: 'StackerDocAccessFields_offerCategories_category'
  create?: Maybe<StackerDocAccessFields_OfferCategories_Category_Create>
  delete?: Maybe<StackerDocAccessFields_OfferCategories_Category_Delete>
  read?: Maybe<StackerDocAccessFields_OfferCategories_Category_Read>
  update?: Maybe<StackerDocAccessFields_OfferCategories_Category_Update>
}

export type StackerDocAccessFields_OfferCategories_Category_Create = {
  __typename?: 'StackerDocAccessFields_offerCategories_category_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Category_Delete = {
  __typename?: 'StackerDocAccessFields_offerCategories_category_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Category_Read = {
  __typename?: 'StackerDocAccessFields_offerCategories_category_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Category_Update = {
  __typename?: 'StackerDocAccessFields_offerCategories_category_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Collection = {
  __typename?: 'StackerDocAccessFields_offerCategories_collection'
  create?: Maybe<StackerDocAccessFields_OfferCategories_Collection_Create>
  delete?: Maybe<StackerDocAccessFields_OfferCategories_Collection_Delete>
  read?: Maybe<StackerDocAccessFields_OfferCategories_Collection_Read>
  update?: Maybe<StackerDocAccessFields_OfferCategories_Collection_Update>
}

export type StackerDocAccessFields_OfferCategories_Collection_Create = {
  __typename?: 'StackerDocAccessFields_offerCategories_collection_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Collection_Delete = {
  __typename?: 'StackerDocAccessFields_offerCategories_collection_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Collection_Read = {
  __typename?: 'StackerDocAccessFields_offerCategories_collection_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Collection_Update = {
  __typename?: 'StackerDocAccessFields_offerCategories_collection_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Id = {
  __typename?: 'StackerDocAccessFields_offerCategories_id'
  create?: Maybe<StackerDocAccessFields_OfferCategories_Id_Create>
  delete?: Maybe<StackerDocAccessFields_OfferCategories_Id_Delete>
  read?: Maybe<StackerDocAccessFields_OfferCategories_Id_Read>
  update?: Maybe<StackerDocAccessFields_OfferCategories_Id_Update>
}

export type StackerDocAccessFields_OfferCategories_Id_Create = {
  __typename?: 'StackerDocAccessFields_offerCategories_id_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Id_Delete = {
  __typename?: 'StackerDocAccessFields_offerCategories_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Id_Read = {
  __typename?: 'StackerDocAccessFields_offerCategories_id_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Id_Update = {
  __typename?: 'StackerDocAccessFields_offerCategories_id_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Name = {
  __typename?: 'StackerDocAccessFields_offerCategories_name'
  create?: Maybe<StackerDocAccessFields_OfferCategories_Name_Create>
  delete?: Maybe<StackerDocAccessFields_OfferCategories_Name_Delete>
  read?: Maybe<StackerDocAccessFields_OfferCategories_Name_Read>
  update?: Maybe<StackerDocAccessFields_OfferCategories_Name_Update>
}

export type StackerDocAccessFields_OfferCategories_Name_Create = {
  __typename?: 'StackerDocAccessFields_offerCategories_name_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Name_Delete = {
  __typename?: 'StackerDocAccessFields_offerCategories_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Name_Read = {
  __typename?: 'StackerDocAccessFields_offerCategories_name_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Name_Update = {
  __typename?: 'StackerDocAccessFields_offerCategories_name_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Slug = {
  __typename?: 'StackerDocAccessFields_offerCategories_slug'
  create?: Maybe<StackerDocAccessFields_OfferCategories_Slug_Create>
  delete?: Maybe<StackerDocAccessFields_OfferCategories_Slug_Delete>
  read?: Maybe<StackerDocAccessFields_OfferCategories_Slug_Read>
  update?: Maybe<StackerDocAccessFields_OfferCategories_Slug_Update>
}

export type StackerDocAccessFields_OfferCategories_Slug_Create = {
  __typename?: 'StackerDocAccessFields_offerCategories_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Slug_Delete = {
  __typename?: 'StackerDocAccessFields_offerCategories_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Slug_Read = {
  __typename?: 'StackerDocAccessFields_offerCategories_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_OfferCategories_Slug_Update = {
  __typename?: 'StackerDocAccessFields_offerCategories_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_PublishedAt = {
  __typename?: 'StackerDocAccessFields_publishedAt'
  create?: Maybe<StackerDocAccessFields_PublishedAt_Create>
  delete?: Maybe<StackerDocAccessFields_PublishedAt_Delete>
  read?: Maybe<StackerDocAccessFields_PublishedAt_Read>
  update?: Maybe<StackerDocAccessFields_PublishedAt_Update>
}

export type StackerDocAccessFields_PublishedAt_Create = {
  __typename?: 'StackerDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_PublishedAt_Delete = {
  __typename?: 'StackerDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_PublishedAt_Read = {
  __typename?: 'StackerDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_PublishedAt_Update = {
  __typename?: 'StackerDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Slug = {
  __typename?: 'StackerDocAccessFields_slug'
  create?: Maybe<StackerDocAccessFields_Slug_Create>
  delete?: Maybe<StackerDocAccessFields_Slug_Delete>
  read?: Maybe<StackerDocAccessFields_Slug_Read>
  update?: Maybe<StackerDocAccessFields_Slug_Update>
}

export type StackerDocAccessFields_Slug_Create = {
  __typename?: 'StackerDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Slug_Delete = {
  __typename?: 'StackerDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Slug_Read = {
  __typename?: 'StackerDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Slug_Update = {
  __typename?: 'StackerDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Title = {
  __typename?: 'StackerDocAccessFields_title'
  create?: Maybe<StackerDocAccessFields_Title_Create>
  delete?: Maybe<StackerDocAccessFields_Title_Delete>
  read?: Maybe<StackerDocAccessFields_Title_Read>
  update?: Maybe<StackerDocAccessFields_Title_Update>
}

export type StackerDocAccessFields_Title_Create = {
  __typename?: 'StackerDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Title_Delete = {
  __typename?: 'StackerDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Title_Read = {
  __typename?: 'StackerDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_Title_Update = {
  __typename?: 'StackerDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_UpdatedAt = {
  __typename?: 'StackerDocAccessFields_updatedAt'
  create?: Maybe<StackerDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<StackerDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<StackerDocAccessFields_UpdatedAt_Read>
  update?: Maybe<StackerDocAccessFields_UpdatedAt_Update>
}

export type StackerDocAccessFields_UpdatedAt_Create = {
  __typename?: 'StackerDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'StackerDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_UpdatedAt_Read = {
  __typename?: 'StackerDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerDocAccessFields_UpdatedAt_Update = {
  __typename?: 'StackerDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields = {
  __typename?: 'StackerFields'
  _status?: Maybe<StackerFields__Status>
  affiliateCode?: Maybe<StackerFields_AffiliateCode>
  createdAt?: Maybe<StackerFields_CreatedAt>
  createdBy?: Maybe<StackerFields_CreatedBy>
  offerCategories?: Maybe<StackerFields_OfferCategories>
  publishedAt?: Maybe<StackerFields_PublishedAt>
  slug?: Maybe<StackerFields_Slug>
  title?: Maybe<StackerFields_Title>
  updatedAt?: Maybe<StackerFields_UpdatedAt>
}

export type StackerFields__Status = {
  __typename?: 'StackerFields__status'
  create?: Maybe<StackerFields__Status_Create>
  delete?: Maybe<StackerFields__Status_Delete>
  read?: Maybe<StackerFields__Status_Read>
  update?: Maybe<StackerFields__Status_Update>
}

export type StackerFields__Status_Create = {
  __typename?: 'StackerFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields__Status_Delete = {
  __typename?: 'StackerFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields__Status_Read = {
  __typename?: 'StackerFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields__Status_Update = {
  __typename?: 'StackerFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_AffiliateCode = {
  __typename?: 'StackerFields_affiliateCode'
  create?: Maybe<StackerFields_AffiliateCode_Create>
  delete?: Maybe<StackerFields_AffiliateCode_Delete>
  read?: Maybe<StackerFields_AffiliateCode_Read>
  update?: Maybe<StackerFields_AffiliateCode_Update>
}

export type StackerFields_AffiliateCode_Create = {
  __typename?: 'StackerFields_affiliateCode_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_AffiliateCode_Delete = {
  __typename?: 'StackerFields_affiliateCode_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_AffiliateCode_Read = {
  __typename?: 'StackerFields_affiliateCode_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_AffiliateCode_Update = {
  __typename?: 'StackerFields_affiliateCode_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedAt = {
  __typename?: 'StackerFields_createdAt'
  create?: Maybe<StackerFields_CreatedAt_Create>
  delete?: Maybe<StackerFields_CreatedAt_Delete>
  read?: Maybe<StackerFields_CreatedAt_Read>
  update?: Maybe<StackerFields_CreatedAt_Update>
}

export type StackerFields_CreatedAt_Create = {
  __typename?: 'StackerFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedAt_Delete = {
  __typename?: 'StackerFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedAt_Read = {
  __typename?: 'StackerFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedAt_Update = {
  __typename?: 'StackerFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedBy = {
  __typename?: 'StackerFields_createdBy'
  create?: Maybe<StackerFields_CreatedBy_Create>
  delete?: Maybe<StackerFields_CreatedBy_Delete>
  read?: Maybe<StackerFields_CreatedBy_Read>
  update?: Maybe<StackerFields_CreatedBy_Update>
}

export type StackerFields_CreatedBy_Create = {
  __typename?: 'StackerFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedBy_Delete = {
  __typename?: 'StackerFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedBy_Read = {
  __typename?: 'StackerFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_CreatedBy_Update = {
  __typename?: 'StackerFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories = {
  __typename?: 'StackerFields_offerCategories'
  create?: Maybe<StackerFields_OfferCategories_Create>
  delete?: Maybe<StackerFields_OfferCategories_Delete>
  fields?: Maybe<StackerFields_OfferCategories_Fields>
  read?: Maybe<StackerFields_OfferCategories_Read>
  update?: Maybe<StackerFields_OfferCategories_Update>
}

export type StackerFields_OfferCategories_Create = {
  __typename?: 'StackerFields_offerCategories_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Delete = {
  __typename?: 'StackerFields_offerCategories_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Fields = {
  __typename?: 'StackerFields_offerCategories_Fields'
  category?: Maybe<StackerFields_OfferCategories_Category>
  collection?: Maybe<StackerFields_OfferCategories_Collection>
  id?: Maybe<StackerFields_OfferCategories_Id>
  name?: Maybe<StackerFields_OfferCategories_Name>
  slug?: Maybe<StackerFields_OfferCategories_Slug>
}

export type StackerFields_OfferCategories_Read = {
  __typename?: 'StackerFields_offerCategories_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Update = {
  __typename?: 'StackerFields_offerCategories_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Category = {
  __typename?: 'StackerFields_offerCategories_category'
  create?: Maybe<StackerFields_OfferCategories_Category_Create>
  delete?: Maybe<StackerFields_OfferCategories_Category_Delete>
  read?: Maybe<StackerFields_OfferCategories_Category_Read>
  update?: Maybe<StackerFields_OfferCategories_Category_Update>
}

export type StackerFields_OfferCategories_Category_Create = {
  __typename?: 'StackerFields_offerCategories_category_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Category_Delete = {
  __typename?: 'StackerFields_offerCategories_category_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Category_Read = {
  __typename?: 'StackerFields_offerCategories_category_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Category_Update = {
  __typename?: 'StackerFields_offerCategories_category_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Collection = {
  __typename?: 'StackerFields_offerCategories_collection'
  create?: Maybe<StackerFields_OfferCategories_Collection_Create>
  delete?: Maybe<StackerFields_OfferCategories_Collection_Delete>
  read?: Maybe<StackerFields_OfferCategories_Collection_Read>
  update?: Maybe<StackerFields_OfferCategories_Collection_Update>
}

export type StackerFields_OfferCategories_Collection_Create = {
  __typename?: 'StackerFields_offerCategories_collection_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Collection_Delete = {
  __typename?: 'StackerFields_offerCategories_collection_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Collection_Read = {
  __typename?: 'StackerFields_offerCategories_collection_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Collection_Update = {
  __typename?: 'StackerFields_offerCategories_collection_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Id = {
  __typename?: 'StackerFields_offerCategories_id'
  create?: Maybe<StackerFields_OfferCategories_Id_Create>
  delete?: Maybe<StackerFields_OfferCategories_Id_Delete>
  read?: Maybe<StackerFields_OfferCategories_Id_Read>
  update?: Maybe<StackerFields_OfferCategories_Id_Update>
}

export type StackerFields_OfferCategories_Id_Create = {
  __typename?: 'StackerFields_offerCategories_id_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Id_Delete = {
  __typename?: 'StackerFields_offerCategories_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Id_Read = {
  __typename?: 'StackerFields_offerCategories_id_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Id_Update = {
  __typename?: 'StackerFields_offerCategories_id_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Name = {
  __typename?: 'StackerFields_offerCategories_name'
  create?: Maybe<StackerFields_OfferCategories_Name_Create>
  delete?: Maybe<StackerFields_OfferCategories_Name_Delete>
  read?: Maybe<StackerFields_OfferCategories_Name_Read>
  update?: Maybe<StackerFields_OfferCategories_Name_Update>
}

export type StackerFields_OfferCategories_Name_Create = {
  __typename?: 'StackerFields_offerCategories_name_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Name_Delete = {
  __typename?: 'StackerFields_offerCategories_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Name_Read = {
  __typename?: 'StackerFields_offerCategories_name_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Name_Update = {
  __typename?: 'StackerFields_offerCategories_name_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Slug = {
  __typename?: 'StackerFields_offerCategories_slug'
  create?: Maybe<StackerFields_OfferCategories_Slug_Create>
  delete?: Maybe<StackerFields_OfferCategories_Slug_Delete>
  read?: Maybe<StackerFields_OfferCategories_Slug_Read>
  update?: Maybe<StackerFields_OfferCategories_Slug_Update>
}

export type StackerFields_OfferCategories_Slug_Create = {
  __typename?: 'StackerFields_offerCategories_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Slug_Delete = {
  __typename?: 'StackerFields_offerCategories_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Slug_Read = {
  __typename?: 'StackerFields_offerCategories_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_OfferCategories_Slug_Update = {
  __typename?: 'StackerFields_offerCategories_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_PublishedAt = {
  __typename?: 'StackerFields_publishedAt'
  create?: Maybe<StackerFields_PublishedAt_Create>
  delete?: Maybe<StackerFields_PublishedAt_Delete>
  read?: Maybe<StackerFields_PublishedAt_Read>
  update?: Maybe<StackerFields_PublishedAt_Update>
}

export type StackerFields_PublishedAt_Create = {
  __typename?: 'StackerFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_PublishedAt_Delete = {
  __typename?: 'StackerFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_PublishedAt_Read = {
  __typename?: 'StackerFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_PublishedAt_Update = {
  __typename?: 'StackerFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Slug = {
  __typename?: 'StackerFields_slug'
  create?: Maybe<StackerFields_Slug_Create>
  delete?: Maybe<StackerFields_Slug_Delete>
  read?: Maybe<StackerFields_Slug_Read>
  update?: Maybe<StackerFields_Slug_Update>
}

export type StackerFields_Slug_Create = {
  __typename?: 'StackerFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Slug_Delete = {
  __typename?: 'StackerFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Slug_Read = {
  __typename?: 'StackerFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Slug_Update = {
  __typename?: 'StackerFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Title = {
  __typename?: 'StackerFields_title'
  create?: Maybe<StackerFields_Title_Create>
  delete?: Maybe<StackerFields_Title_Delete>
  read?: Maybe<StackerFields_Title_Read>
  update?: Maybe<StackerFields_Title_Update>
}

export type StackerFields_Title_Create = {
  __typename?: 'StackerFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Title_Delete = {
  __typename?: 'StackerFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Title_Read = {
  __typename?: 'StackerFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_Title_Update = {
  __typename?: 'StackerFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_UpdatedAt = {
  __typename?: 'StackerFields_updatedAt'
  create?: Maybe<StackerFields_UpdatedAt_Create>
  delete?: Maybe<StackerFields_UpdatedAt_Delete>
  read?: Maybe<StackerFields_UpdatedAt_Read>
  update?: Maybe<StackerFields_UpdatedAt_Update>
}

export type StackerFields_UpdatedAt_Create = {
  __typename?: 'StackerFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_UpdatedAt_Delete = {
  __typename?: 'StackerFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_UpdatedAt_Read = {
  __typename?: 'StackerFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type StackerFields_UpdatedAt_Update = {
  __typename?: 'StackerFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type StackerReadAccess = {
  __typename?: 'StackerReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerReadDocAccess = {
  __typename?: 'StackerReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerReadVersionsAccess = {
  __typename?: 'StackerReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerReadVersionsDocAccess = {
  __typename?: 'StackerReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerUpdateAccess = {
  __typename?: 'StackerUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type StackerUpdateDocAccess = {
  __typename?: 'StackerUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsCreateAccess = {
  __typename?: 'TcProgramTagsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsCreateDocAccess = {
  __typename?: 'TcProgramTagsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsDeleteAccess = {
  __typename?: 'TcProgramTagsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsDeleteDocAccess = {
  __typename?: 'TcProgramTagsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsDocAccessFields = {
  __typename?: 'TcProgramTagsDocAccessFields'
  createdAt?: Maybe<TcProgramTagsDocAccessFields_CreatedAt>
  slug?: Maybe<TcProgramTagsDocAccessFields_Slug>
  title?: Maybe<TcProgramTagsDocAccessFields_Title>
  updatedAt?: Maybe<TcProgramTagsDocAccessFields_UpdatedAt>
}

export type TcProgramTagsDocAccessFields_CreatedAt = {
  __typename?: 'TcProgramTagsDocAccessFields_createdAt'
  create?: Maybe<TcProgramTagsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<TcProgramTagsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<TcProgramTagsDocAccessFields_CreatedAt_Read>
  update?: Maybe<TcProgramTagsDocAccessFields_CreatedAt_Update>
}

export type TcProgramTagsDocAccessFields_CreatedAt_Create = {
  __typename?: 'TcProgramTagsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'TcProgramTagsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_CreatedAt_Read = {
  __typename?: 'TcProgramTagsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_CreatedAt_Update = {
  __typename?: 'TcProgramTagsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Slug = {
  __typename?: 'TcProgramTagsDocAccessFields_slug'
  create?: Maybe<TcProgramTagsDocAccessFields_Slug_Create>
  delete?: Maybe<TcProgramTagsDocAccessFields_Slug_Delete>
  read?: Maybe<TcProgramTagsDocAccessFields_Slug_Read>
  update?: Maybe<TcProgramTagsDocAccessFields_Slug_Update>
}

export type TcProgramTagsDocAccessFields_Slug_Create = {
  __typename?: 'TcProgramTagsDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Slug_Delete = {
  __typename?: 'TcProgramTagsDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Slug_Read = {
  __typename?: 'TcProgramTagsDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Slug_Update = {
  __typename?: 'TcProgramTagsDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Title = {
  __typename?: 'TcProgramTagsDocAccessFields_title'
  create?: Maybe<TcProgramTagsDocAccessFields_Title_Create>
  delete?: Maybe<TcProgramTagsDocAccessFields_Title_Delete>
  read?: Maybe<TcProgramTagsDocAccessFields_Title_Read>
  update?: Maybe<TcProgramTagsDocAccessFields_Title_Update>
}

export type TcProgramTagsDocAccessFields_Title_Create = {
  __typename?: 'TcProgramTagsDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Title_Delete = {
  __typename?: 'TcProgramTagsDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Title_Read = {
  __typename?: 'TcProgramTagsDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_Title_Update = {
  __typename?: 'TcProgramTagsDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_UpdatedAt = {
  __typename?: 'TcProgramTagsDocAccessFields_updatedAt'
  create?: Maybe<TcProgramTagsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<TcProgramTagsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<TcProgramTagsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<TcProgramTagsDocAccessFields_UpdatedAt_Update>
}

export type TcProgramTagsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'TcProgramTagsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'TcProgramTagsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'TcProgramTagsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'TcProgramTagsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields = {
  __typename?: 'TcProgramTagsFields'
  createdAt?: Maybe<TcProgramTagsFields_CreatedAt>
  slug?: Maybe<TcProgramTagsFields_Slug>
  title?: Maybe<TcProgramTagsFields_Title>
  updatedAt?: Maybe<TcProgramTagsFields_UpdatedAt>
}

export type TcProgramTagsFields_CreatedAt = {
  __typename?: 'TcProgramTagsFields_createdAt'
  create?: Maybe<TcProgramTagsFields_CreatedAt_Create>
  delete?: Maybe<TcProgramTagsFields_CreatedAt_Delete>
  read?: Maybe<TcProgramTagsFields_CreatedAt_Read>
  update?: Maybe<TcProgramTagsFields_CreatedAt_Update>
}

export type TcProgramTagsFields_CreatedAt_Create = {
  __typename?: 'TcProgramTagsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_CreatedAt_Delete = {
  __typename?: 'TcProgramTagsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_CreatedAt_Read = {
  __typename?: 'TcProgramTagsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_CreatedAt_Update = {
  __typename?: 'TcProgramTagsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Slug = {
  __typename?: 'TcProgramTagsFields_slug'
  create?: Maybe<TcProgramTagsFields_Slug_Create>
  delete?: Maybe<TcProgramTagsFields_Slug_Delete>
  read?: Maybe<TcProgramTagsFields_Slug_Read>
  update?: Maybe<TcProgramTagsFields_Slug_Update>
}

export type TcProgramTagsFields_Slug_Create = {
  __typename?: 'TcProgramTagsFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Slug_Delete = {
  __typename?: 'TcProgramTagsFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Slug_Read = {
  __typename?: 'TcProgramTagsFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Slug_Update = {
  __typename?: 'TcProgramTagsFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Title = {
  __typename?: 'TcProgramTagsFields_title'
  create?: Maybe<TcProgramTagsFields_Title_Create>
  delete?: Maybe<TcProgramTagsFields_Title_Delete>
  read?: Maybe<TcProgramTagsFields_Title_Read>
  update?: Maybe<TcProgramTagsFields_Title_Update>
}

export type TcProgramTagsFields_Title_Create = {
  __typename?: 'TcProgramTagsFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Title_Delete = {
  __typename?: 'TcProgramTagsFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Title_Read = {
  __typename?: 'TcProgramTagsFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_Title_Update = {
  __typename?: 'TcProgramTagsFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_UpdatedAt = {
  __typename?: 'TcProgramTagsFields_updatedAt'
  create?: Maybe<TcProgramTagsFields_UpdatedAt_Create>
  delete?: Maybe<TcProgramTagsFields_UpdatedAt_Delete>
  read?: Maybe<TcProgramTagsFields_UpdatedAt_Read>
  update?: Maybe<TcProgramTagsFields_UpdatedAt_Update>
}

export type TcProgramTagsFields_UpdatedAt_Create = {
  __typename?: 'TcProgramTagsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_UpdatedAt_Delete = {
  __typename?: 'TcProgramTagsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_UpdatedAt_Read = {
  __typename?: 'TcProgramTagsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsFields_UpdatedAt_Update = {
  __typename?: 'TcProgramTagsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramTagsReadAccess = {
  __typename?: 'TcProgramTagsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsReadDocAccess = {
  __typename?: 'TcProgramTagsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsUpdateAccess = {
  __typename?: 'TcProgramTagsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramTagsUpdateDocAccess = {
  __typename?: 'TcProgramTagsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsCreateAccess = {
  __typename?: 'TcProgramsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsCreateDocAccess = {
  __typename?: 'TcProgramsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsDeleteAccess = {
  __typename?: 'TcProgramsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsDeleteDocAccess = {
  __typename?: 'TcProgramsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsDocAccessFields = {
  __typename?: 'TcProgramsDocAccessFields'
  _status?: Maybe<TcProgramsDocAccessFields__Status>
  applyUrl?: Maybe<TcProgramsDocAccessFields_ApplyUrl>
  createdAt?: Maybe<TcProgramsDocAccessFields_CreatedAt>
  createdBy?: Maybe<TcProgramsDocAccessFields_CreatedBy>
  creditLimitHighCents?: Maybe<TcProgramsDocAccessFields_CreditLimitHighCents>
  creditLimitLowCents?: Maybe<TcProgramsDocAccessFields_CreditLimitLowCents>
  description?: Maybe<TcProgramsDocAccessFields_Description>
  fees?: Maybe<TcProgramsDocAccessFields_Fees>
  minReqs?: Maybe<TcProgramsDocAccessFields_MinReqs>
  notes?: Maybe<TcProgramsDocAccessFields_Notes>
  publishedAt?: Maybe<TcProgramsDocAccessFields_PublishedAt>
  reportsTo?: Maybe<TcProgramsDocAccessFields_ReportsTo>
  slug?: Maybe<TcProgramsDocAccessFields_Slug>
  tags?: Maybe<TcProgramsDocAccessFields_Tags>
  terms?: Maybe<TcProgramsDocAccessFields_Terms>
  title?: Maybe<TcProgramsDocAccessFields_Title>
  updatedAt?: Maybe<TcProgramsDocAccessFields_UpdatedAt>
  vendor?: Maybe<TcProgramsDocAccessFields_Vendor>
}

export type TcProgramsDocAccessFields__Status = {
  __typename?: 'TcProgramsDocAccessFields__status'
  create?: Maybe<TcProgramsDocAccessFields__Status_Create>
  delete?: Maybe<TcProgramsDocAccessFields__Status_Delete>
  read?: Maybe<TcProgramsDocAccessFields__Status_Read>
  update?: Maybe<TcProgramsDocAccessFields__Status_Update>
}

export type TcProgramsDocAccessFields__Status_Create = {
  __typename?: 'TcProgramsDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields__Status_Delete = {
  __typename?: 'TcProgramsDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields__Status_Read = {
  __typename?: 'TcProgramsDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields__Status_Update = {
  __typename?: 'TcProgramsDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ApplyUrl = {
  __typename?: 'TcProgramsDocAccessFields_applyUrl'
  create?: Maybe<TcProgramsDocAccessFields_ApplyUrl_Create>
  delete?: Maybe<TcProgramsDocAccessFields_ApplyUrl_Delete>
  read?: Maybe<TcProgramsDocAccessFields_ApplyUrl_Read>
  update?: Maybe<TcProgramsDocAccessFields_ApplyUrl_Update>
}

export type TcProgramsDocAccessFields_ApplyUrl_Create = {
  __typename?: 'TcProgramsDocAccessFields_applyUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ApplyUrl_Delete = {
  __typename?: 'TcProgramsDocAccessFields_applyUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ApplyUrl_Read = {
  __typename?: 'TcProgramsDocAccessFields_applyUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ApplyUrl_Update = {
  __typename?: 'TcProgramsDocAccessFields_applyUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedAt = {
  __typename?: 'TcProgramsDocAccessFields_createdAt'
  create?: Maybe<TcProgramsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<TcProgramsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<TcProgramsDocAccessFields_CreatedAt_Read>
  update?: Maybe<TcProgramsDocAccessFields_CreatedAt_Update>
}

export type TcProgramsDocAccessFields_CreatedAt_Create = {
  __typename?: 'TcProgramsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'TcProgramsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedAt_Read = {
  __typename?: 'TcProgramsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedAt_Update = {
  __typename?: 'TcProgramsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedBy = {
  __typename?: 'TcProgramsDocAccessFields_createdBy'
  create?: Maybe<TcProgramsDocAccessFields_CreatedBy_Create>
  delete?: Maybe<TcProgramsDocAccessFields_CreatedBy_Delete>
  read?: Maybe<TcProgramsDocAccessFields_CreatedBy_Read>
  update?: Maybe<TcProgramsDocAccessFields_CreatedBy_Update>
}

export type TcProgramsDocAccessFields_CreatedBy_Create = {
  __typename?: 'TcProgramsDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedBy_Delete = {
  __typename?: 'TcProgramsDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedBy_Read = {
  __typename?: 'TcProgramsDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreatedBy_Update = {
  __typename?: 'TcProgramsDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitHighCents = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitHighCents'
  create?: Maybe<TcProgramsDocAccessFields_CreditLimitHighCents_Create>
  delete?: Maybe<TcProgramsDocAccessFields_CreditLimitHighCents_Delete>
  read?: Maybe<TcProgramsDocAccessFields_CreditLimitHighCents_Read>
  update?: Maybe<TcProgramsDocAccessFields_CreditLimitHighCents_Update>
}

export type TcProgramsDocAccessFields_CreditLimitHighCents_Create = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitHighCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitHighCents_Delete = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitHighCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitHighCents_Read = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitHighCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitHighCents_Update = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitHighCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitLowCents = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitLowCents'
  create?: Maybe<TcProgramsDocAccessFields_CreditLimitLowCents_Create>
  delete?: Maybe<TcProgramsDocAccessFields_CreditLimitLowCents_Delete>
  read?: Maybe<TcProgramsDocAccessFields_CreditLimitLowCents_Read>
  update?: Maybe<TcProgramsDocAccessFields_CreditLimitLowCents_Update>
}

export type TcProgramsDocAccessFields_CreditLimitLowCents_Create = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitLowCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitLowCents_Delete = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitLowCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitLowCents_Read = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitLowCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_CreditLimitLowCents_Update = {
  __typename?: 'TcProgramsDocAccessFields_creditLimitLowCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Description = {
  __typename?: 'TcProgramsDocAccessFields_description'
  create?: Maybe<TcProgramsDocAccessFields_Description_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Description_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Description_Read>
  update?: Maybe<TcProgramsDocAccessFields_Description_Update>
}

export type TcProgramsDocAccessFields_Description_Create = {
  __typename?: 'TcProgramsDocAccessFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Description_Delete = {
  __typename?: 'TcProgramsDocAccessFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Description_Read = {
  __typename?: 'TcProgramsDocAccessFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Description_Update = {
  __typename?: 'TcProgramsDocAccessFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees = {
  __typename?: 'TcProgramsDocAccessFields_fees'
  create?: Maybe<TcProgramsDocAccessFields_Fees_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Fees_Delete>
  fields?: Maybe<TcProgramsDocAccessFields_Fees_Fields>
  read?: Maybe<TcProgramsDocAccessFields_Fees_Read>
  update?: Maybe<TcProgramsDocAccessFields_Fees_Update>
}

export type TcProgramsDocAccessFields_Fees_Create = {
  __typename?: 'TcProgramsDocAccessFields_fees_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_Delete = {
  __typename?: 'TcProgramsDocAccessFields_fees_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_Fields = {
  __typename?: 'TcProgramsDocAccessFields_fees_Fields'
  amountHighCents?: Maybe<TcProgramsDocAccessFields_Fees_AmountHighCents>
  amountLowCents?: Maybe<TcProgramsDocAccessFields_Fees_AmountLowCents>
  id?: Maybe<TcProgramsDocAccessFields_Fees_Id>
  paymentPeriod?: Maybe<TcProgramsDocAccessFields_Fees_PaymentPeriod>
}

export type TcProgramsDocAccessFields_Fees_Read = {
  __typename?: 'TcProgramsDocAccessFields_fees_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_Update = {
  __typename?: 'TcProgramsDocAccessFields_fees_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountHighCents = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountHighCents'
  create?: Maybe<TcProgramsDocAccessFields_Fees_AmountHighCents_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Fees_AmountHighCents_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Fees_AmountHighCents_Read>
  update?: Maybe<TcProgramsDocAccessFields_Fees_AmountHighCents_Update>
}

export type TcProgramsDocAccessFields_Fees_AmountHighCents_Create = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountHighCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountHighCents_Delete = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountHighCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountHighCents_Read = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountHighCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountHighCents_Update = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountHighCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountLowCents = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountLowCents'
  create?: Maybe<TcProgramsDocAccessFields_Fees_AmountLowCents_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Fees_AmountLowCents_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Fees_AmountLowCents_Read>
  update?: Maybe<TcProgramsDocAccessFields_Fees_AmountLowCents_Update>
}

export type TcProgramsDocAccessFields_Fees_AmountLowCents_Create = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountLowCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountLowCents_Delete = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountLowCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountLowCents_Read = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountLowCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_AmountLowCents_Update = {
  __typename?: 'TcProgramsDocAccessFields_fees_amountLowCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_Id = {
  __typename?: 'TcProgramsDocAccessFields_fees_id'
  create?: Maybe<TcProgramsDocAccessFields_Fees_Id_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Fees_Id_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Fees_Id_Read>
  update?: Maybe<TcProgramsDocAccessFields_Fees_Id_Update>
}

export type TcProgramsDocAccessFields_Fees_Id_Create = {
  __typename?: 'TcProgramsDocAccessFields_fees_id_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_Id_Delete = {
  __typename?: 'TcProgramsDocAccessFields_fees_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_Id_Read = {
  __typename?: 'TcProgramsDocAccessFields_fees_id_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_Id_Update = {
  __typename?: 'TcProgramsDocAccessFields_fees_id_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_PaymentPeriod = {
  __typename?: 'TcProgramsDocAccessFields_fees_paymentPeriod'
  create?: Maybe<TcProgramsDocAccessFields_Fees_PaymentPeriod_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Fees_PaymentPeriod_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Fees_PaymentPeriod_Read>
  update?: Maybe<TcProgramsDocAccessFields_Fees_PaymentPeriod_Update>
}

export type TcProgramsDocAccessFields_Fees_PaymentPeriod_Create = {
  __typename?: 'TcProgramsDocAccessFields_fees_paymentPeriod_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_PaymentPeriod_Delete = {
  __typename?: 'TcProgramsDocAccessFields_fees_paymentPeriod_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_PaymentPeriod_Read = {
  __typename?: 'TcProgramsDocAccessFields_fees_paymentPeriod_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Fees_PaymentPeriod_Update = {
  __typename?: 'TcProgramsDocAccessFields_fees_paymentPeriod_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs = {
  __typename?: 'TcProgramsDocAccessFields_minReqs'
  create?: Maybe<TcProgramsDocAccessFields_MinReqs_Create>
  delete?: Maybe<TcProgramsDocAccessFields_MinReqs_Delete>
  fields?: Maybe<TcProgramsDocAccessFields_MinReqs_Fields>
  read?: Maybe<TcProgramsDocAccessFields_MinReqs_Read>
  update?: Maybe<TcProgramsDocAccessFields_MinReqs_Update>
}

export type TcProgramsDocAccessFields_MinReqs_Create = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_Delete = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_Fields = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_Fields'
  amountCents?: Maybe<TcProgramsDocAccessFields_MinReqs_AmountCents>
  id?: Maybe<TcProgramsDocAccessFields_MinReqs_Id>
  orderUnit?: Maybe<TcProgramsDocAccessFields_MinReqs_OrderUnit>
}

export type TcProgramsDocAccessFields_MinReqs_Read = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_Update = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_AmountCents = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_amountCents'
  create?: Maybe<TcProgramsDocAccessFields_MinReqs_AmountCents_Create>
  delete?: Maybe<TcProgramsDocAccessFields_MinReqs_AmountCents_Delete>
  read?: Maybe<TcProgramsDocAccessFields_MinReqs_AmountCents_Read>
  update?: Maybe<TcProgramsDocAccessFields_MinReqs_AmountCents_Update>
}

export type TcProgramsDocAccessFields_MinReqs_AmountCents_Create = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_amountCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_AmountCents_Delete = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_amountCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_AmountCents_Read = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_amountCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_AmountCents_Update = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_amountCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_Id = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_id'
  create?: Maybe<TcProgramsDocAccessFields_MinReqs_Id_Create>
  delete?: Maybe<TcProgramsDocAccessFields_MinReqs_Id_Delete>
  read?: Maybe<TcProgramsDocAccessFields_MinReqs_Id_Read>
  update?: Maybe<TcProgramsDocAccessFields_MinReqs_Id_Update>
}

export type TcProgramsDocAccessFields_MinReqs_Id_Create = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_Id_Delete = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_Id_Read = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_Id_Update = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_OrderUnit = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_orderUnit'
  create?: Maybe<TcProgramsDocAccessFields_MinReqs_OrderUnit_Create>
  delete?: Maybe<TcProgramsDocAccessFields_MinReqs_OrderUnit_Delete>
  read?: Maybe<TcProgramsDocAccessFields_MinReqs_OrderUnit_Read>
  update?: Maybe<TcProgramsDocAccessFields_MinReqs_OrderUnit_Update>
}

export type TcProgramsDocAccessFields_MinReqs_OrderUnit_Create = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_orderUnit_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_OrderUnit_Delete = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_orderUnit_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_OrderUnit_Read = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_orderUnit_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_MinReqs_OrderUnit_Update = {
  __typename?: 'TcProgramsDocAccessFields_minReqs_orderUnit_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Notes = {
  __typename?: 'TcProgramsDocAccessFields_notes'
  create?: Maybe<TcProgramsDocAccessFields_Notes_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Notes_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Notes_Read>
  update?: Maybe<TcProgramsDocAccessFields_Notes_Update>
}

export type TcProgramsDocAccessFields_Notes_Create = {
  __typename?: 'TcProgramsDocAccessFields_notes_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Notes_Delete = {
  __typename?: 'TcProgramsDocAccessFields_notes_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Notes_Read = {
  __typename?: 'TcProgramsDocAccessFields_notes_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Notes_Update = {
  __typename?: 'TcProgramsDocAccessFields_notes_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_PublishedAt = {
  __typename?: 'TcProgramsDocAccessFields_publishedAt'
  create?: Maybe<TcProgramsDocAccessFields_PublishedAt_Create>
  delete?: Maybe<TcProgramsDocAccessFields_PublishedAt_Delete>
  read?: Maybe<TcProgramsDocAccessFields_PublishedAt_Read>
  update?: Maybe<TcProgramsDocAccessFields_PublishedAt_Update>
}

export type TcProgramsDocAccessFields_PublishedAt_Create = {
  __typename?: 'TcProgramsDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_PublishedAt_Delete = {
  __typename?: 'TcProgramsDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_PublishedAt_Read = {
  __typename?: 'TcProgramsDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_PublishedAt_Update = {
  __typename?: 'TcProgramsDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ReportsTo = {
  __typename?: 'TcProgramsDocAccessFields_reportsTo'
  create?: Maybe<TcProgramsDocAccessFields_ReportsTo_Create>
  delete?: Maybe<TcProgramsDocAccessFields_ReportsTo_Delete>
  read?: Maybe<TcProgramsDocAccessFields_ReportsTo_Read>
  update?: Maybe<TcProgramsDocAccessFields_ReportsTo_Update>
}

export type TcProgramsDocAccessFields_ReportsTo_Create = {
  __typename?: 'TcProgramsDocAccessFields_reportsTo_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ReportsTo_Delete = {
  __typename?: 'TcProgramsDocAccessFields_reportsTo_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ReportsTo_Read = {
  __typename?: 'TcProgramsDocAccessFields_reportsTo_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_ReportsTo_Update = {
  __typename?: 'TcProgramsDocAccessFields_reportsTo_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Slug = {
  __typename?: 'TcProgramsDocAccessFields_slug'
  create?: Maybe<TcProgramsDocAccessFields_Slug_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Slug_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Slug_Read>
  update?: Maybe<TcProgramsDocAccessFields_Slug_Update>
}

export type TcProgramsDocAccessFields_Slug_Create = {
  __typename?: 'TcProgramsDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Slug_Delete = {
  __typename?: 'TcProgramsDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Slug_Read = {
  __typename?: 'TcProgramsDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Slug_Update = {
  __typename?: 'TcProgramsDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Tags = {
  __typename?: 'TcProgramsDocAccessFields_tags'
  create?: Maybe<TcProgramsDocAccessFields_Tags_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Tags_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Tags_Read>
  update?: Maybe<TcProgramsDocAccessFields_Tags_Update>
}

export type TcProgramsDocAccessFields_Tags_Create = {
  __typename?: 'TcProgramsDocAccessFields_tags_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Tags_Delete = {
  __typename?: 'TcProgramsDocAccessFields_tags_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Tags_Read = {
  __typename?: 'TcProgramsDocAccessFields_tags_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Tags_Update = {
  __typename?: 'TcProgramsDocAccessFields_tags_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms = {
  __typename?: 'TcProgramsDocAccessFields_terms'
  create?: Maybe<TcProgramsDocAccessFields_Terms_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Terms_Delete>
  fields?: Maybe<TcProgramsDocAccessFields_Terms_Fields>
  read?: Maybe<TcProgramsDocAccessFields_Terms_Read>
  update?: Maybe<TcProgramsDocAccessFields_Terms_Update>
}

export type TcProgramsDocAccessFields_Terms_Create = {
  __typename?: 'TcProgramsDocAccessFields_terms_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_Delete = {
  __typename?: 'TcProgramsDocAccessFields_terms_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_Fields = {
  __typename?: 'TcProgramsDocAccessFields_terms_Fields'
  discountDurationDays?: Maybe<TcProgramsDocAccessFields_Terms_DiscountDurationDays>
  discountPercentage?: Maybe<TcProgramsDocAccessFields_Terms_DiscountPercentage>
  id?: Maybe<TcProgramsDocAccessFields_Terms_Id>
  netDueAfterDays?: Maybe<TcProgramsDocAccessFields_Terms_NetDueAfterDays>
}

export type TcProgramsDocAccessFields_Terms_Read = {
  __typename?: 'TcProgramsDocAccessFields_terms_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_Update = {
  __typename?: 'TcProgramsDocAccessFields_terms_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountDurationDays = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountDurationDays'
  create?: Maybe<TcProgramsDocAccessFields_Terms_DiscountDurationDays_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Terms_DiscountDurationDays_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Terms_DiscountDurationDays_Read>
  update?: Maybe<TcProgramsDocAccessFields_Terms_DiscountDurationDays_Update>
}

export type TcProgramsDocAccessFields_Terms_DiscountDurationDays_Create = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountDurationDays_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountDurationDays_Delete = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountDurationDays_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountDurationDays_Read = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountDurationDays_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountDurationDays_Update = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountDurationDays_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountPercentage = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountPercentage'
  create?: Maybe<TcProgramsDocAccessFields_Terms_DiscountPercentage_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Terms_DiscountPercentage_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Terms_DiscountPercentage_Read>
  update?: Maybe<TcProgramsDocAccessFields_Terms_DiscountPercentage_Update>
}

export type TcProgramsDocAccessFields_Terms_DiscountPercentage_Create = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountPercentage_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountPercentage_Delete = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountPercentage_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountPercentage_Read = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountPercentage_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_DiscountPercentage_Update = {
  __typename?: 'TcProgramsDocAccessFields_terms_discountPercentage_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_Id = {
  __typename?: 'TcProgramsDocAccessFields_terms_id'
  create?: Maybe<TcProgramsDocAccessFields_Terms_Id_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Terms_Id_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Terms_Id_Read>
  update?: Maybe<TcProgramsDocAccessFields_Terms_Id_Update>
}

export type TcProgramsDocAccessFields_Terms_Id_Create = {
  __typename?: 'TcProgramsDocAccessFields_terms_id_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_Id_Delete = {
  __typename?: 'TcProgramsDocAccessFields_terms_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_Id_Read = {
  __typename?: 'TcProgramsDocAccessFields_terms_id_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_Id_Update = {
  __typename?: 'TcProgramsDocAccessFields_terms_id_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_NetDueAfterDays = {
  __typename?: 'TcProgramsDocAccessFields_terms_netDueAfterDays'
  create?: Maybe<TcProgramsDocAccessFields_Terms_NetDueAfterDays_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Terms_NetDueAfterDays_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Terms_NetDueAfterDays_Read>
  update?: Maybe<TcProgramsDocAccessFields_Terms_NetDueAfterDays_Update>
}

export type TcProgramsDocAccessFields_Terms_NetDueAfterDays_Create = {
  __typename?: 'TcProgramsDocAccessFields_terms_netDueAfterDays_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_NetDueAfterDays_Delete = {
  __typename?: 'TcProgramsDocAccessFields_terms_netDueAfterDays_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_NetDueAfterDays_Read = {
  __typename?: 'TcProgramsDocAccessFields_terms_netDueAfterDays_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Terms_NetDueAfterDays_Update = {
  __typename?: 'TcProgramsDocAccessFields_terms_netDueAfterDays_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Title = {
  __typename?: 'TcProgramsDocAccessFields_title'
  create?: Maybe<TcProgramsDocAccessFields_Title_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Title_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Title_Read>
  update?: Maybe<TcProgramsDocAccessFields_Title_Update>
}

export type TcProgramsDocAccessFields_Title_Create = {
  __typename?: 'TcProgramsDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Title_Delete = {
  __typename?: 'TcProgramsDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Title_Read = {
  __typename?: 'TcProgramsDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Title_Update = {
  __typename?: 'TcProgramsDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_UpdatedAt = {
  __typename?: 'TcProgramsDocAccessFields_updatedAt'
  create?: Maybe<TcProgramsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<TcProgramsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<TcProgramsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<TcProgramsDocAccessFields_UpdatedAt_Update>
}

export type TcProgramsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'TcProgramsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'TcProgramsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'TcProgramsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'TcProgramsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Vendor = {
  __typename?: 'TcProgramsDocAccessFields_vendor'
  create?: Maybe<TcProgramsDocAccessFields_Vendor_Create>
  delete?: Maybe<TcProgramsDocAccessFields_Vendor_Delete>
  read?: Maybe<TcProgramsDocAccessFields_Vendor_Read>
  update?: Maybe<TcProgramsDocAccessFields_Vendor_Update>
}

export type TcProgramsDocAccessFields_Vendor_Create = {
  __typename?: 'TcProgramsDocAccessFields_vendor_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Vendor_Delete = {
  __typename?: 'TcProgramsDocAccessFields_vendor_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Vendor_Read = {
  __typename?: 'TcProgramsDocAccessFields_vendor_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsDocAccessFields_Vendor_Update = {
  __typename?: 'TcProgramsDocAccessFields_vendor_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields = {
  __typename?: 'TcProgramsFields'
  _status?: Maybe<TcProgramsFields__Status>
  applyUrl?: Maybe<TcProgramsFields_ApplyUrl>
  createdAt?: Maybe<TcProgramsFields_CreatedAt>
  createdBy?: Maybe<TcProgramsFields_CreatedBy>
  creditLimitHighCents?: Maybe<TcProgramsFields_CreditLimitHighCents>
  creditLimitLowCents?: Maybe<TcProgramsFields_CreditLimitLowCents>
  description?: Maybe<TcProgramsFields_Description>
  fees?: Maybe<TcProgramsFields_Fees>
  minReqs?: Maybe<TcProgramsFields_MinReqs>
  notes?: Maybe<TcProgramsFields_Notes>
  publishedAt?: Maybe<TcProgramsFields_PublishedAt>
  reportsTo?: Maybe<TcProgramsFields_ReportsTo>
  slug?: Maybe<TcProgramsFields_Slug>
  tags?: Maybe<TcProgramsFields_Tags>
  terms?: Maybe<TcProgramsFields_Terms>
  title?: Maybe<TcProgramsFields_Title>
  updatedAt?: Maybe<TcProgramsFields_UpdatedAt>
  vendor?: Maybe<TcProgramsFields_Vendor>
}

export type TcProgramsFields__Status = {
  __typename?: 'TcProgramsFields__status'
  create?: Maybe<TcProgramsFields__Status_Create>
  delete?: Maybe<TcProgramsFields__Status_Delete>
  read?: Maybe<TcProgramsFields__Status_Read>
  update?: Maybe<TcProgramsFields__Status_Update>
}

export type TcProgramsFields__Status_Create = {
  __typename?: 'TcProgramsFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields__Status_Delete = {
  __typename?: 'TcProgramsFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields__Status_Read = {
  __typename?: 'TcProgramsFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields__Status_Update = {
  __typename?: 'TcProgramsFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ApplyUrl = {
  __typename?: 'TcProgramsFields_applyUrl'
  create?: Maybe<TcProgramsFields_ApplyUrl_Create>
  delete?: Maybe<TcProgramsFields_ApplyUrl_Delete>
  read?: Maybe<TcProgramsFields_ApplyUrl_Read>
  update?: Maybe<TcProgramsFields_ApplyUrl_Update>
}

export type TcProgramsFields_ApplyUrl_Create = {
  __typename?: 'TcProgramsFields_applyUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ApplyUrl_Delete = {
  __typename?: 'TcProgramsFields_applyUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ApplyUrl_Read = {
  __typename?: 'TcProgramsFields_applyUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ApplyUrl_Update = {
  __typename?: 'TcProgramsFields_applyUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedAt = {
  __typename?: 'TcProgramsFields_createdAt'
  create?: Maybe<TcProgramsFields_CreatedAt_Create>
  delete?: Maybe<TcProgramsFields_CreatedAt_Delete>
  read?: Maybe<TcProgramsFields_CreatedAt_Read>
  update?: Maybe<TcProgramsFields_CreatedAt_Update>
}

export type TcProgramsFields_CreatedAt_Create = {
  __typename?: 'TcProgramsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedAt_Delete = {
  __typename?: 'TcProgramsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedAt_Read = {
  __typename?: 'TcProgramsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedAt_Update = {
  __typename?: 'TcProgramsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedBy = {
  __typename?: 'TcProgramsFields_createdBy'
  create?: Maybe<TcProgramsFields_CreatedBy_Create>
  delete?: Maybe<TcProgramsFields_CreatedBy_Delete>
  read?: Maybe<TcProgramsFields_CreatedBy_Read>
  update?: Maybe<TcProgramsFields_CreatedBy_Update>
}

export type TcProgramsFields_CreatedBy_Create = {
  __typename?: 'TcProgramsFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedBy_Delete = {
  __typename?: 'TcProgramsFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedBy_Read = {
  __typename?: 'TcProgramsFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreatedBy_Update = {
  __typename?: 'TcProgramsFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitHighCents = {
  __typename?: 'TcProgramsFields_creditLimitHighCents'
  create?: Maybe<TcProgramsFields_CreditLimitHighCents_Create>
  delete?: Maybe<TcProgramsFields_CreditLimitHighCents_Delete>
  read?: Maybe<TcProgramsFields_CreditLimitHighCents_Read>
  update?: Maybe<TcProgramsFields_CreditLimitHighCents_Update>
}

export type TcProgramsFields_CreditLimitHighCents_Create = {
  __typename?: 'TcProgramsFields_creditLimitHighCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitHighCents_Delete = {
  __typename?: 'TcProgramsFields_creditLimitHighCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitHighCents_Read = {
  __typename?: 'TcProgramsFields_creditLimitHighCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitHighCents_Update = {
  __typename?: 'TcProgramsFields_creditLimitHighCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitLowCents = {
  __typename?: 'TcProgramsFields_creditLimitLowCents'
  create?: Maybe<TcProgramsFields_CreditLimitLowCents_Create>
  delete?: Maybe<TcProgramsFields_CreditLimitLowCents_Delete>
  read?: Maybe<TcProgramsFields_CreditLimitLowCents_Read>
  update?: Maybe<TcProgramsFields_CreditLimitLowCents_Update>
}

export type TcProgramsFields_CreditLimitLowCents_Create = {
  __typename?: 'TcProgramsFields_creditLimitLowCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitLowCents_Delete = {
  __typename?: 'TcProgramsFields_creditLimitLowCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitLowCents_Read = {
  __typename?: 'TcProgramsFields_creditLimitLowCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_CreditLimitLowCents_Update = {
  __typename?: 'TcProgramsFields_creditLimitLowCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Description = {
  __typename?: 'TcProgramsFields_description'
  create?: Maybe<TcProgramsFields_Description_Create>
  delete?: Maybe<TcProgramsFields_Description_Delete>
  read?: Maybe<TcProgramsFields_Description_Read>
  update?: Maybe<TcProgramsFields_Description_Update>
}

export type TcProgramsFields_Description_Create = {
  __typename?: 'TcProgramsFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Description_Delete = {
  __typename?: 'TcProgramsFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Description_Read = {
  __typename?: 'TcProgramsFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Description_Update = {
  __typename?: 'TcProgramsFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees = {
  __typename?: 'TcProgramsFields_fees'
  create?: Maybe<TcProgramsFields_Fees_Create>
  delete?: Maybe<TcProgramsFields_Fees_Delete>
  fields?: Maybe<TcProgramsFields_Fees_Fields>
  read?: Maybe<TcProgramsFields_Fees_Read>
  update?: Maybe<TcProgramsFields_Fees_Update>
}

export type TcProgramsFields_Fees_Create = {
  __typename?: 'TcProgramsFields_fees_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_Delete = {
  __typename?: 'TcProgramsFields_fees_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_Fields = {
  __typename?: 'TcProgramsFields_fees_Fields'
  amountHighCents?: Maybe<TcProgramsFields_Fees_AmountHighCents>
  amountLowCents?: Maybe<TcProgramsFields_Fees_AmountLowCents>
  id?: Maybe<TcProgramsFields_Fees_Id>
  paymentPeriod?: Maybe<TcProgramsFields_Fees_PaymentPeriod>
}

export type TcProgramsFields_Fees_Read = {
  __typename?: 'TcProgramsFields_fees_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_Update = {
  __typename?: 'TcProgramsFields_fees_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountHighCents = {
  __typename?: 'TcProgramsFields_fees_amountHighCents'
  create?: Maybe<TcProgramsFields_Fees_AmountHighCents_Create>
  delete?: Maybe<TcProgramsFields_Fees_AmountHighCents_Delete>
  read?: Maybe<TcProgramsFields_Fees_AmountHighCents_Read>
  update?: Maybe<TcProgramsFields_Fees_AmountHighCents_Update>
}

export type TcProgramsFields_Fees_AmountHighCents_Create = {
  __typename?: 'TcProgramsFields_fees_amountHighCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountHighCents_Delete = {
  __typename?: 'TcProgramsFields_fees_amountHighCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountHighCents_Read = {
  __typename?: 'TcProgramsFields_fees_amountHighCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountHighCents_Update = {
  __typename?: 'TcProgramsFields_fees_amountHighCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountLowCents = {
  __typename?: 'TcProgramsFields_fees_amountLowCents'
  create?: Maybe<TcProgramsFields_Fees_AmountLowCents_Create>
  delete?: Maybe<TcProgramsFields_Fees_AmountLowCents_Delete>
  read?: Maybe<TcProgramsFields_Fees_AmountLowCents_Read>
  update?: Maybe<TcProgramsFields_Fees_AmountLowCents_Update>
}

export type TcProgramsFields_Fees_AmountLowCents_Create = {
  __typename?: 'TcProgramsFields_fees_amountLowCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountLowCents_Delete = {
  __typename?: 'TcProgramsFields_fees_amountLowCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountLowCents_Read = {
  __typename?: 'TcProgramsFields_fees_amountLowCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_AmountLowCents_Update = {
  __typename?: 'TcProgramsFields_fees_amountLowCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_Id = {
  __typename?: 'TcProgramsFields_fees_id'
  create?: Maybe<TcProgramsFields_Fees_Id_Create>
  delete?: Maybe<TcProgramsFields_Fees_Id_Delete>
  read?: Maybe<TcProgramsFields_Fees_Id_Read>
  update?: Maybe<TcProgramsFields_Fees_Id_Update>
}

export type TcProgramsFields_Fees_Id_Create = {
  __typename?: 'TcProgramsFields_fees_id_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_Id_Delete = {
  __typename?: 'TcProgramsFields_fees_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_Id_Read = {
  __typename?: 'TcProgramsFields_fees_id_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_Id_Update = {
  __typename?: 'TcProgramsFields_fees_id_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_PaymentPeriod = {
  __typename?: 'TcProgramsFields_fees_paymentPeriod'
  create?: Maybe<TcProgramsFields_Fees_PaymentPeriod_Create>
  delete?: Maybe<TcProgramsFields_Fees_PaymentPeriod_Delete>
  read?: Maybe<TcProgramsFields_Fees_PaymentPeriod_Read>
  update?: Maybe<TcProgramsFields_Fees_PaymentPeriod_Update>
}

export type TcProgramsFields_Fees_PaymentPeriod_Create = {
  __typename?: 'TcProgramsFields_fees_paymentPeriod_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_PaymentPeriod_Delete = {
  __typename?: 'TcProgramsFields_fees_paymentPeriod_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_PaymentPeriod_Read = {
  __typename?: 'TcProgramsFields_fees_paymentPeriod_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Fees_PaymentPeriod_Update = {
  __typename?: 'TcProgramsFields_fees_paymentPeriod_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs = {
  __typename?: 'TcProgramsFields_minReqs'
  create?: Maybe<TcProgramsFields_MinReqs_Create>
  delete?: Maybe<TcProgramsFields_MinReqs_Delete>
  fields?: Maybe<TcProgramsFields_MinReqs_Fields>
  read?: Maybe<TcProgramsFields_MinReqs_Read>
  update?: Maybe<TcProgramsFields_MinReqs_Update>
}

export type TcProgramsFields_MinReqs_Create = {
  __typename?: 'TcProgramsFields_minReqs_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_Delete = {
  __typename?: 'TcProgramsFields_minReqs_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_Fields = {
  __typename?: 'TcProgramsFields_minReqs_Fields'
  amountCents?: Maybe<TcProgramsFields_MinReqs_AmountCents>
  id?: Maybe<TcProgramsFields_MinReqs_Id>
  orderUnit?: Maybe<TcProgramsFields_MinReqs_OrderUnit>
}

export type TcProgramsFields_MinReqs_Read = {
  __typename?: 'TcProgramsFields_minReqs_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_Update = {
  __typename?: 'TcProgramsFields_minReqs_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_AmountCents = {
  __typename?: 'TcProgramsFields_minReqs_amountCents'
  create?: Maybe<TcProgramsFields_MinReqs_AmountCents_Create>
  delete?: Maybe<TcProgramsFields_MinReqs_AmountCents_Delete>
  read?: Maybe<TcProgramsFields_MinReqs_AmountCents_Read>
  update?: Maybe<TcProgramsFields_MinReqs_AmountCents_Update>
}

export type TcProgramsFields_MinReqs_AmountCents_Create = {
  __typename?: 'TcProgramsFields_minReqs_amountCents_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_AmountCents_Delete = {
  __typename?: 'TcProgramsFields_minReqs_amountCents_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_AmountCents_Read = {
  __typename?: 'TcProgramsFields_minReqs_amountCents_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_AmountCents_Update = {
  __typename?: 'TcProgramsFields_minReqs_amountCents_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_Id = {
  __typename?: 'TcProgramsFields_minReqs_id'
  create?: Maybe<TcProgramsFields_MinReqs_Id_Create>
  delete?: Maybe<TcProgramsFields_MinReqs_Id_Delete>
  read?: Maybe<TcProgramsFields_MinReqs_Id_Read>
  update?: Maybe<TcProgramsFields_MinReqs_Id_Update>
}

export type TcProgramsFields_MinReqs_Id_Create = {
  __typename?: 'TcProgramsFields_minReqs_id_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_Id_Delete = {
  __typename?: 'TcProgramsFields_minReqs_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_Id_Read = {
  __typename?: 'TcProgramsFields_minReqs_id_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_Id_Update = {
  __typename?: 'TcProgramsFields_minReqs_id_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_OrderUnit = {
  __typename?: 'TcProgramsFields_minReqs_orderUnit'
  create?: Maybe<TcProgramsFields_MinReqs_OrderUnit_Create>
  delete?: Maybe<TcProgramsFields_MinReqs_OrderUnit_Delete>
  read?: Maybe<TcProgramsFields_MinReqs_OrderUnit_Read>
  update?: Maybe<TcProgramsFields_MinReqs_OrderUnit_Update>
}

export type TcProgramsFields_MinReqs_OrderUnit_Create = {
  __typename?: 'TcProgramsFields_minReqs_orderUnit_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_OrderUnit_Delete = {
  __typename?: 'TcProgramsFields_minReqs_orderUnit_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_OrderUnit_Read = {
  __typename?: 'TcProgramsFields_minReqs_orderUnit_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_MinReqs_OrderUnit_Update = {
  __typename?: 'TcProgramsFields_minReqs_orderUnit_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Notes = {
  __typename?: 'TcProgramsFields_notes'
  create?: Maybe<TcProgramsFields_Notes_Create>
  delete?: Maybe<TcProgramsFields_Notes_Delete>
  read?: Maybe<TcProgramsFields_Notes_Read>
  update?: Maybe<TcProgramsFields_Notes_Update>
}

export type TcProgramsFields_Notes_Create = {
  __typename?: 'TcProgramsFields_notes_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Notes_Delete = {
  __typename?: 'TcProgramsFields_notes_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Notes_Read = {
  __typename?: 'TcProgramsFields_notes_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Notes_Update = {
  __typename?: 'TcProgramsFields_notes_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_PublishedAt = {
  __typename?: 'TcProgramsFields_publishedAt'
  create?: Maybe<TcProgramsFields_PublishedAt_Create>
  delete?: Maybe<TcProgramsFields_PublishedAt_Delete>
  read?: Maybe<TcProgramsFields_PublishedAt_Read>
  update?: Maybe<TcProgramsFields_PublishedAt_Update>
}

export type TcProgramsFields_PublishedAt_Create = {
  __typename?: 'TcProgramsFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_PublishedAt_Delete = {
  __typename?: 'TcProgramsFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_PublishedAt_Read = {
  __typename?: 'TcProgramsFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_PublishedAt_Update = {
  __typename?: 'TcProgramsFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ReportsTo = {
  __typename?: 'TcProgramsFields_reportsTo'
  create?: Maybe<TcProgramsFields_ReportsTo_Create>
  delete?: Maybe<TcProgramsFields_ReportsTo_Delete>
  read?: Maybe<TcProgramsFields_ReportsTo_Read>
  update?: Maybe<TcProgramsFields_ReportsTo_Update>
}

export type TcProgramsFields_ReportsTo_Create = {
  __typename?: 'TcProgramsFields_reportsTo_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ReportsTo_Delete = {
  __typename?: 'TcProgramsFields_reportsTo_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ReportsTo_Read = {
  __typename?: 'TcProgramsFields_reportsTo_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_ReportsTo_Update = {
  __typename?: 'TcProgramsFields_reportsTo_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Slug = {
  __typename?: 'TcProgramsFields_slug'
  create?: Maybe<TcProgramsFields_Slug_Create>
  delete?: Maybe<TcProgramsFields_Slug_Delete>
  read?: Maybe<TcProgramsFields_Slug_Read>
  update?: Maybe<TcProgramsFields_Slug_Update>
}

export type TcProgramsFields_Slug_Create = {
  __typename?: 'TcProgramsFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Slug_Delete = {
  __typename?: 'TcProgramsFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Slug_Read = {
  __typename?: 'TcProgramsFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Slug_Update = {
  __typename?: 'TcProgramsFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Tags = {
  __typename?: 'TcProgramsFields_tags'
  create?: Maybe<TcProgramsFields_Tags_Create>
  delete?: Maybe<TcProgramsFields_Tags_Delete>
  read?: Maybe<TcProgramsFields_Tags_Read>
  update?: Maybe<TcProgramsFields_Tags_Update>
}

export type TcProgramsFields_Tags_Create = {
  __typename?: 'TcProgramsFields_tags_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Tags_Delete = {
  __typename?: 'TcProgramsFields_tags_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Tags_Read = {
  __typename?: 'TcProgramsFields_tags_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Tags_Update = {
  __typename?: 'TcProgramsFields_tags_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms = {
  __typename?: 'TcProgramsFields_terms'
  create?: Maybe<TcProgramsFields_Terms_Create>
  delete?: Maybe<TcProgramsFields_Terms_Delete>
  fields?: Maybe<TcProgramsFields_Terms_Fields>
  read?: Maybe<TcProgramsFields_Terms_Read>
  update?: Maybe<TcProgramsFields_Terms_Update>
}

export type TcProgramsFields_Terms_Create = {
  __typename?: 'TcProgramsFields_terms_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_Delete = {
  __typename?: 'TcProgramsFields_terms_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_Fields = {
  __typename?: 'TcProgramsFields_terms_Fields'
  discountDurationDays?: Maybe<TcProgramsFields_Terms_DiscountDurationDays>
  discountPercentage?: Maybe<TcProgramsFields_Terms_DiscountPercentage>
  id?: Maybe<TcProgramsFields_Terms_Id>
  netDueAfterDays?: Maybe<TcProgramsFields_Terms_NetDueAfterDays>
}

export type TcProgramsFields_Terms_Read = {
  __typename?: 'TcProgramsFields_terms_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_Update = {
  __typename?: 'TcProgramsFields_terms_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountDurationDays = {
  __typename?: 'TcProgramsFields_terms_discountDurationDays'
  create?: Maybe<TcProgramsFields_Terms_DiscountDurationDays_Create>
  delete?: Maybe<TcProgramsFields_Terms_DiscountDurationDays_Delete>
  read?: Maybe<TcProgramsFields_Terms_DiscountDurationDays_Read>
  update?: Maybe<TcProgramsFields_Terms_DiscountDurationDays_Update>
}

export type TcProgramsFields_Terms_DiscountDurationDays_Create = {
  __typename?: 'TcProgramsFields_terms_discountDurationDays_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountDurationDays_Delete = {
  __typename?: 'TcProgramsFields_terms_discountDurationDays_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountDurationDays_Read = {
  __typename?: 'TcProgramsFields_terms_discountDurationDays_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountDurationDays_Update = {
  __typename?: 'TcProgramsFields_terms_discountDurationDays_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountPercentage = {
  __typename?: 'TcProgramsFields_terms_discountPercentage'
  create?: Maybe<TcProgramsFields_Terms_DiscountPercentage_Create>
  delete?: Maybe<TcProgramsFields_Terms_DiscountPercentage_Delete>
  read?: Maybe<TcProgramsFields_Terms_DiscountPercentage_Read>
  update?: Maybe<TcProgramsFields_Terms_DiscountPercentage_Update>
}

export type TcProgramsFields_Terms_DiscountPercentage_Create = {
  __typename?: 'TcProgramsFields_terms_discountPercentage_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountPercentage_Delete = {
  __typename?: 'TcProgramsFields_terms_discountPercentage_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountPercentage_Read = {
  __typename?: 'TcProgramsFields_terms_discountPercentage_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_DiscountPercentage_Update = {
  __typename?: 'TcProgramsFields_terms_discountPercentage_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_Id = {
  __typename?: 'TcProgramsFields_terms_id'
  create?: Maybe<TcProgramsFields_Terms_Id_Create>
  delete?: Maybe<TcProgramsFields_Terms_Id_Delete>
  read?: Maybe<TcProgramsFields_Terms_Id_Read>
  update?: Maybe<TcProgramsFields_Terms_Id_Update>
}

export type TcProgramsFields_Terms_Id_Create = {
  __typename?: 'TcProgramsFields_terms_id_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_Id_Delete = {
  __typename?: 'TcProgramsFields_terms_id_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_Id_Read = {
  __typename?: 'TcProgramsFields_terms_id_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_Id_Update = {
  __typename?: 'TcProgramsFields_terms_id_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_NetDueAfterDays = {
  __typename?: 'TcProgramsFields_terms_netDueAfterDays'
  create?: Maybe<TcProgramsFields_Terms_NetDueAfterDays_Create>
  delete?: Maybe<TcProgramsFields_Terms_NetDueAfterDays_Delete>
  read?: Maybe<TcProgramsFields_Terms_NetDueAfterDays_Read>
  update?: Maybe<TcProgramsFields_Terms_NetDueAfterDays_Update>
}

export type TcProgramsFields_Terms_NetDueAfterDays_Create = {
  __typename?: 'TcProgramsFields_terms_netDueAfterDays_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_NetDueAfterDays_Delete = {
  __typename?: 'TcProgramsFields_terms_netDueAfterDays_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_NetDueAfterDays_Read = {
  __typename?: 'TcProgramsFields_terms_netDueAfterDays_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Terms_NetDueAfterDays_Update = {
  __typename?: 'TcProgramsFields_terms_netDueAfterDays_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Title = {
  __typename?: 'TcProgramsFields_title'
  create?: Maybe<TcProgramsFields_Title_Create>
  delete?: Maybe<TcProgramsFields_Title_Delete>
  read?: Maybe<TcProgramsFields_Title_Read>
  update?: Maybe<TcProgramsFields_Title_Update>
}

export type TcProgramsFields_Title_Create = {
  __typename?: 'TcProgramsFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Title_Delete = {
  __typename?: 'TcProgramsFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Title_Read = {
  __typename?: 'TcProgramsFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Title_Update = {
  __typename?: 'TcProgramsFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_UpdatedAt = {
  __typename?: 'TcProgramsFields_updatedAt'
  create?: Maybe<TcProgramsFields_UpdatedAt_Create>
  delete?: Maybe<TcProgramsFields_UpdatedAt_Delete>
  read?: Maybe<TcProgramsFields_UpdatedAt_Read>
  update?: Maybe<TcProgramsFields_UpdatedAt_Update>
}

export type TcProgramsFields_UpdatedAt_Create = {
  __typename?: 'TcProgramsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_UpdatedAt_Delete = {
  __typename?: 'TcProgramsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_UpdatedAt_Read = {
  __typename?: 'TcProgramsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_UpdatedAt_Update = {
  __typename?: 'TcProgramsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Vendor = {
  __typename?: 'TcProgramsFields_vendor'
  create?: Maybe<TcProgramsFields_Vendor_Create>
  delete?: Maybe<TcProgramsFields_Vendor_Delete>
  read?: Maybe<TcProgramsFields_Vendor_Read>
  update?: Maybe<TcProgramsFields_Vendor_Update>
}

export type TcProgramsFields_Vendor_Create = {
  __typename?: 'TcProgramsFields_vendor_Create'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Vendor_Delete = {
  __typename?: 'TcProgramsFields_vendor_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Vendor_Read = {
  __typename?: 'TcProgramsFields_vendor_Read'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsFields_Vendor_Update = {
  __typename?: 'TcProgramsFields_vendor_Update'
  permission: Scalars['Boolean']['output']
}

export type TcProgramsReadAccess = {
  __typename?: 'TcProgramsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsReadDocAccess = {
  __typename?: 'TcProgramsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsReadVersionsAccess = {
  __typename?: 'TcProgramsReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsReadVersionsDocAccess = {
  __typename?: 'TcProgramsReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsUpdateAccess = {
  __typename?: 'TcProgramsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcProgramsUpdateDocAccess = {
  __typename?: 'TcProgramsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsCreateAccess = {
  __typename?: 'TcVendorsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsCreateDocAccess = {
  __typename?: 'TcVendorsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsDeleteAccess = {
  __typename?: 'TcVendorsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsDeleteDocAccess = {
  __typename?: 'TcVendorsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsDocAccessFields = {
  __typename?: 'TcVendorsDocAccessFields'
  _status?: Maybe<TcVendorsDocAccessFields__Status>
  active?: Maybe<TcVendorsDocAccessFields_Active>
  createdAt?: Maybe<TcVendorsDocAccessFields_CreatedAt>
  createdBy?: Maybe<TcVendorsDocAccessFields_CreatedBy>
  logo?: Maybe<TcVendorsDocAccessFields_Logo>
  publishedAt?: Maybe<TcVendorsDocAccessFields_PublishedAt>
  slug?: Maybe<TcVendorsDocAccessFields_Slug>
  title?: Maybe<TcVendorsDocAccessFields_Title>
  updatedAt?: Maybe<TcVendorsDocAccessFields_UpdatedAt>
  websiteUrl?: Maybe<TcVendorsDocAccessFields_WebsiteUrl>
}

export type TcVendorsDocAccessFields__Status = {
  __typename?: 'TcVendorsDocAccessFields__status'
  create?: Maybe<TcVendorsDocAccessFields__Status_Create>
  delete?: Maybe<TcVendorsDocAccessFields__Status_Delete>
  read?: Maybe<TcVendorsDocAccessFields__Status_Read>
  update?: Maybe<TcVendorsDocAccessFields__Status_Update>
}

export type TcVendorsDocAccessFields__Status_Create = {
  __typename?: 'TcVendorsDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields__Status_Delete = {
  __typename?: 'TcVendorsDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields__Status_Read = {
  __typename?: 'TcVendorsDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields__Status_Update = {
  __typename?: 'TcVendorsDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Active = {
  __typename?: 'TcVendorsDocAccessFields_active'
  create?: Maybe<TcVendorsDocAccessFields_Active_Create>
  delete?: Maybe<TcVendorsDocAccessFields_Active_Delete>
  read?: Maybe<TcVendorsDocAccessFields_Active_Read>
  update?: Maybe<TcVendorsDocAccessFields_Active_Update>
}

export type TcVendorsDocAccessFields_Active_Create = {
  __typename?: 'TcVendorsDocAccessFields_active_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Active_Delete = {
  __typename?: 'TcVendorsDocAccessFields_active_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Active_Read = {
  __typename?: 'TcVendorsDocAccessFields_active_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Active_Update = {
  __typename?: 'TcVendorsDocAccessFields_active_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedAt = {
  __typename?: 'TcVendorsDocAccessFields_createdAt'
  create?: Maybe<TcVendorsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<TcVendorsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<TcVendorsDocAccessFields_CreatedAt_Read>
  update?: Maybe<TcVendorsDocAccessFields_CreatedAt_Update>
}

export type TcVendorsDocAccessFields_CreatedAt_Create = {
  __typename?: 'TcVendorsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'TcVendorsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedAt_Read = {
  __typename?: 'TcVendorsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedAt_Update = {
  __typename?: 'TcVendorsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedBy = {
  __typename?: 'TcVendorsDocAccessFields_createdBy'
  create?: Maybe<TcVendorsDocAccessFields_CreatedBy_Create>
  delete?: Maybe<TcVendorsDocAccessFields_CreatedBy_Delete>
  read?: Maybe<TcVendorsDocAccessFields_CreatedBy_Read>
  update?: Maybe<TcVendorsDocAccessFields_CreatedBy_Update>
}

export type TcVendorsDocAccessFields_CreatedBy_Create = {
  __typename?: 'TcVendorsDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedBy_Delete = {
  __typename?: 'TcVendorsDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedBy_Read = {
  __typename?: 'TcVendorsDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_CreatedBy_Update = {
  __typename?: 'TcVendorsDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Logo = {
  __typename?: 'TcVendorsDocAccessFields_logo'
  create?: Maybe<TcVendorsDocAccessFields_Logo_Create>
  delete?: Maybe<TcVendorsDocAccessFields_Logo_Delete>
  read?: Maybe<TcVendorsDocAccessFields_Logo_Read>
  update?: Maybe<TcVendorsDocAccessFields_Logo_Update>
}

export type TcVendorsDocAccessFields_Logo_Create = {
  __typename?: 'TcVendorsDocAccessFields_logo_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Logo_Delete = {
  __typename?: 'TcVendorsDocAccessFields_logo_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Logo_Read = {
  __typename?: 'TcVendorsDocAccessFields_logo_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Logo_Update = {
  __typename?: 'TcVendorsDocAccessFields_logo_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_PublishedAt = {
  __typename?: 'TcVendorsDocAccessFields_publishedAt'
  create?: Maybe<TcVendorsDocAccessFields_PublishedAt_Create>
  delete?: Maybe<TcVendorsDocAccessFields_PublishedAt_Delete>
  read?: Maybe<TcVendorsDocAccessFields_PublishedAt_Read>
  update?: Maybe<TcVendorsDocAccessFields_PublishedAt_Update>
}

export type TcVendorsDocAccessFields_PublishedAt_Create = {
  __typename?: 'TcVendorsDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_PublishedAt_Delete = {
  __typename?: 'TcVendorsDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_PublishedAt_Read = {
  __typename?: 'TcVendorsDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_PublishedAt_Update = {
  __typename?: 'TcVendorsDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Slug = {
  __typename?: 'TcVendorsDocAccessFields_slug'
  create?: Maybe<TcVendorsDocAccessFields_Slug_Create>
  delete?: Maybe<TcVendorsDocAccessFields_Slug_Delete>
  read?: Maybe<TcVendorsDocAccessFields_Slug_Read>
  update?: Maybe<TcVendorsDocAccessFields_Slug_Update>
}

export type TcVendorsDocAccessFields_Slug_Create = {
  __typename?: 'TcVendorsDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Slug_Delete = {
  __typename?: 'TcVendorsDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Slug_Read = {
  __typename?: 'TcVendorsDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Slug_Update = {
  __typename?: 'TcVendorsDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Title = {
  __typename?: 'TcVendorsDocAccessFields_title'
  create?: Maybe<TcVendorsDocAccessFields_Title_Create>
  delete?: Maybe<TcVendorsDocAccessFields_Title_Delete>
  read?: Maybe<TcVendorsDocAccessFields_Title_Read>
  update?: Maybe<TcVendorsDocAccessFields_Title_Update>
}

export type TcVendorsDocAccessFields_Title_Create = {
  __typename?: 'TcVendorsDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Title_Delete = {
  __typename?: 'TcVendorsDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Title_Read = {
  __typename?: 'TcVendorsDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_Title_Update = {
  __typename?: 'TcVendorsDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_UpdatedAt = {
  __typename?: 'TcVendorsDocAccessFields_updatedAt'
  create?: Maybe<TcVendorsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<TcVendorsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<TcVendorsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<TcVendorsDocAccessFields_UpdatedAt_Update>
}

export type TcVendorsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'TcVendorsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'TcVendorsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'TcVendorsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'TcVendorsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_WebsiteUrl = {
  __typename?: 'TcVendorsDocAccessFields_websiteUrl'
  create?: Maybe<TcVendorsDocAccessFields_WebsiteUrl_Create>
  delete?: Maybe<TcVendorsDocAccessFields_WebsiteUrl_Delete>
  read?: Maybe<TcVendorsDocAccessFields_WebsiteUrl_Read>
  update?: Maybe<TcVendorsDocAccessFields_WebsiteUrl_Update>
}

export type TcVendorsDocAccessFields_WebsiteUrl_Create = {
  __typename?: 'TcVendorsDocAccessFields_websiteUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_WebsiteUrl_Delete = {
  __typename?: 'TcVendorsDocAccessFields_websiteUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_WebsiteUrl_Read = {
  __typename?: 'TcVendorsDocAccessFields_websiteUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsDocAccessFields_WebsiteUrl_Update = {
  __typename?: 'TcVendorsDocAccessFields_websiteUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields = {
  __typename?: 'TcVendorsFields'
  _status?: Maybe<TcVendorsFields__Status>
  active?: Maybe<TcVendorsFields_Active>
  createdAt?: Maybe<TcVendorsFields_CreatedAt>
  createdBy?: Maybe<TcVendorsFields_CreatedBy>
  logo?: Maybe<TcVendorsFields_Logo>
  publishedAt?: Maybe<TcVendorsFields_PublishedAt>
  slug?: Maybe<TcVendorsFields_Slug>
  title?: Maybe<TcVendorsFields_Title>
  updatedAt?: Maybe<TcVendorsFields_UpdatedAt>
  websiteUrl?: Maybe<TcVendorsFields_WebsiteUrl>
}

export type TcVendorsFields__Status = {
  __typename?: 'TcVendorsFields__status'
  create?: Maybe<TcVendorsFields__Status_Create>
  delete?: Maybe<TcVendorsFields__Status_Delete>
  read?: Maybe<TcVendorsFields__Status_Read>
  update?: Maybe<TcVendorsFields__Status_Update>
}

export type TcVendorsFields__Status_Create = {
  __typename?: 'TcVendorsFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields__Status_Delete = {
  __typename?: 'TcVendorsFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields__Status_Read = {
  __typename?: 'TcVendorsFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields__Status_Update = {
  __typename?: 'TcVendorsFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Active = {
  __typename?: 'TcVendorsFields_active'
  create?: Maybe<TcVendorsFields_Active_Create>
  delete?: Maybe<TcVendorsFields_Active_Delete>
  read?: Maybe<TcVendorsFields_Active_Read>
  update?: Maybe<TcVendorsFields_Active_Update>
}

export type TcVendorsFields_Active_Create = {
  __typename?: 'TcVendorsFields_active_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Active_Delete = {
  __typename?: 'TcVendorsFields_active_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Active_Read = {
  __typename?: 'TcVendorsFields_active_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Active_Update = {
  __typename?: 'TcVendorsFields_active_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedAt = {
  __typename?: 'TcVendorsFields_createdAt'
  create?: Maybe<TcVendorsFields_CreatedAt_Create>
  delete?: Maybe<TcVendorsFields_CreatedAt_Delete>
  read?: Maybe<TcVendorsFields_CreatedAt_Read>
  update?: Maybe<TcVendorsFields_CreatedAt_Update>
}

export type TcVendorsFields_CreatedAt_Create = {
  __typename?: 'TcVendorsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedAt_Delete = {
  __typename?: 'TcVendorsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedAt_Read = {
  __typename?: 'TcVendorsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedAt_Update = {
  __typename?: 'TcVendorsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedBy = {
  __typename?: 'TcVendorsFields_createdBy'
  create?: Maybe<TcVendorsFields_CreatedBy_Create>
  delete?: Maybe<TcVendorsFields_CreatedBy_Delete>
  read?: Maybe<TcVendorsFields_CreatedBy_Read>
  update?: Maybe<TcVendorsFields_CreatedBy_Update>
}

export type TcVendorsFields_CreatedBy_Create = {
  __typename?: 'TcVendorsFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedBy_Delete = {
  __typename?: 'TcVendorsFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedBy_Read = {
  __typename?: 'TcVendorsFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_CreatedBy_Update = {
  __typename?: 'TcVendorsFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Logo = {
  __typename?: 'TcVendorsFields_logo'
  create?: Maybe<TcVendorsFields_Logo_Create>
  delete?: Maybe<TcVendorsFields_Logo_Delete>
  read?: Maybe<TcVendorsFields_Logo_Read>
  update?: Maybe<TcVendorsFields_Logo_Update>
}

export type TcVendorsFields_Logo_Create = {
  __typename?: 'TcVendorsFields_logo_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Logo_Delete = {
  __typename?: 'TcVendorsFields_logo_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Logo_Read = {
  __typename?: 'TcVendorsFields_logo_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Logo_Update = {
  __typename?: 'TcVendorsFields_logo_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_PublishedAt = {
  __typename?: 'TcVendorsFields_publishedAt'
  create?: Maybe<TcVendorsFields_PublishedAt_Create>
  delete?: Maybe<TcVendorsFields_PublishedAt_Delete>
  read?: Maybe<TcVendorsFields_PublishedAt_Read>
  update?: Maybe<TcVendorsFields_PublishedAt_Update>
}

export type TcVendorsFields_PublishedAt_Create = {
  __typename?: 'TcVendorsFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_PublishedAt_Delete = {
  __typename?: 'TcVendorsFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_PublishedAt_Read = {
  __typename?: 'TcVendorsFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_PublishedAt_Update = {
  __typename?: 'TcVendorsFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Slug = {
  __typename?: 'TcVendorsFields_slug'
  create?: Maybe<TcVendorsFields_Slug_Create>
  delete?: Maybe<TcVendorsFields_Slug_Delete>
  read?: Maybe<TcVendorsFields_Slug_Read>
  update?: Maybe<TcVendorsFields_Slug_Update>
}

export type TcVendorsFields_Slug_Create = {
  __typename?: 'TcVendorsFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Slug_Delete = {
  __typename?: 'TcVendorsFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Slug_Read = {
  __typename?: 'TcVendorsFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Slug_Update = {
  __typename?: 'TcVendorsFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Title = {
  __typename?: 'TcVendorsFields_title'
  create?: Maybe<TcVendorsFields_Title_Create>
  delete?: Maybe<TcVendorsFields_Title_Delete>
  read?: Maybe<TcVendorsFields_Title_Read>
  update?: Maybe<TcVendorsFields_Title_Update>
}

export type TcVendorsFields_Title_Create = {
  __typename?: 'TcVendorsFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Title_Delete = {
  __typename?: 'TcVendorsFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Title_Read = {
  __typename?: 'TcVendorsFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_Title_Update = {
  __typename?: 'TcVendorsFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_UpdatedAt = {
  __typename?: 'TcVendorsFields_updatedAt'
  create?: Maybe<TcVendorsFields_UpdatedAt_Create>
  delete?: Maybe<TcVendorsFields_UpdatedAt_Delete>
  read?: Maybe<TcVendorsFields_UpdatedAt_Read>
  update?: Maybe<TcVendorsFields_UpdatedAt_Update>
}

export type TcVendorsFields_UpdatedAt_Create = {
  __typename?: 'TcVendorsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_UpdatedAt_Delete = {
  __typename?: 'TcVendorsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_UpdatedAt_Read = {
  __typename?: 'TcVendorsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_UpdatedAt_Update = {
  __typename?: 'TcVendorsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_WebsiteUrl = {
  __typename?: 'TcVendorsFields_websiteUrl'
  create?: Maybe<TcVendorsFields_WebsiteUrl_Create>
  delete?: Maybe<TcVendorsFields_WebsiteUrl_Delete>
  read?: Maybe<TcVendorsFields_WebsiteUrl_Read>
  update?: Maybe<TcVendorsFields_WebsiteUrl_Update>
}

export type TcVendorsFields_WebsiteUrl_Create = {
  __typename?: 'TcVendorsFields_websiteUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_WebsiteUrl_Delete = {
  __typename?: 'TcVendorsFields_websiteUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_WebsiteUrl_Read = {
  __typename?: 'TcVendorsFields_websiteUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsFields_WebsiteUrl_Update = {
  __typename?: 'TcVendorsFields_websiteUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type TcVendorsReadAccess = {
  __typename?: 'TcVendorsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsReadDocAccess = {
  __typename?: 'TcVendorsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsReadVersionsAccess = {
  __typename?: 'TcVendorsReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsReadVersionsDocAccess = {
  __typename?: 'TcVendorsReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsUpdateAccess = {
  __typename?: 'TcVendorsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TcVendorsUpdateDocAccess = {
  __typename?: 'TcVendorsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsCreateAccess = {
  __typename?: 'TradeCreditVendorsCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsCreateDocAccess = {
  __typename?: 'TradeCreditVendorsCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsDeleteAccess = {
  __typename?: 'TradeCreditVendorsDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsDeleteDocAccess = {
  __typename?: 'TradeCreditVendorsDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsDocAccessFields = {
  __typename?: 'TradeCreditVendorsDocAccessFields'
  _status?: Maybe<TradeCreditVendorsDocAccessFields__Status>
  applyUrl?: Maybe<TradeCreditVendorsDocAccessFields_ApplyUrl>
  createdAt?: Maybe<TradeCreditVendorsDocAccessFields_CreatedAt>
  createdBy?: Maybe<TradeCreditVendorsDocAccessFields_CreatedBy>
  description?: Maybe<TradeCreditVendorsDocAccessFields_Description>
  image?: Maybe<TradeCreditVendorsDocAccessFields_Image>
  publishedAt?: Maybe<TradeCreditVendorsDocAccessFields_PublishedAt>
  slug?: Maybe<TradeCreditVendorsDocAccessFields_Slug>
  title?: Maybe<TradeCreditVendorsDocAccessFields_Title>
  updatedAt?: Maybe<TradeCreditVendorsDocAccessFields_UpdatedAt>
}

export type TradeCreditVendorsDocAccessFields__Status = {
  __typename?: 'TradeCreditVendorsDocAccessFields__status'
  create?: Maybe<TradeCreditVendorsDocAccessFields__Status_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields__Status_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields__Status_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields__Status_Update>
}

export type TradeCreditVendorsDocAccessFields__Status_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields__Status_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields__Status_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields__Status_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_ApplyUrl = {
  __typename?: 'TradeCreditVendorsDocAccessFields_applyUrl'
  create?: Maybe<TradeCreditVendorsDocAccessFields_ApplyUrl_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_ApplyUrl_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_ApplyUrl_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_ApplyUrl_Update>
}

export type TradeCreditVendorsDocAccessFields_ApplyUrl_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_applyUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_ApplyUrl_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_applyUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_ApplyUrl_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_applyUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_ApplyUrl_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_applyUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedAt = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdAt'
  create?: Maybe<TradeCreditVendorsDocAccessFields_CreatedAt_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_CreatedAt_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_CreatedAt_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_CreatedAt_Update>
}

export type TradeCreditVendorsDocAccessFields_CreatedAt_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedAt_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedAt_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedBy = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdBy'
  create?: Maybe<TradeCreditVendorsDocAccessFields_CreatedBy_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_CreatedBy_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_CreatedBy_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_CreatedBy_Update>
}

export type TradeCreditVendorsDocAccessFields_CreatedBy_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedBy_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedBy_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_CreatedBy_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Description = {
  __typename?: 'TradeCreditVendorsDocAccessFields_description'
  create?: Maybe<TradeCreditVendorsDocAccessFields_Description_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_Description_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_Description_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_Description_Update>
}

export type TradeCreditVendorsDocAccessFields_Description_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Description_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Description_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Description_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Image = {
  __typename?: 'TradeCreditVendorsDocAccessFields_image'
  create?: Maybe<TradeCreditVendorsDocAccessFields_Image_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_Image_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_Image_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_Image_Update>
}

export type TradeCreditVendorsDocAccessFields_Image_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_image_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Image_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Image_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_image_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Image_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_image_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_PublishedAt = {
  __typename?: 'TradeCreditVendorsDocAccessFields_publishedAt'
  create?: Maybe<TradeCreditVendorsDocAccessFields_PublishedAt_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_PublishedAt_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_PublishedAt_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_PublishedAt_Update>
}

export type TradeCreditVendorsDocAccessFields_PublishedAt_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_PublishedAt_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_PublishedAt_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_PublishedAt_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Slug = {
  __typename?: 'TradeCreditVendorsDocAccessFields_slug'
  create?: Maybe<TradeCreditVendorsDocAccessFields_Slug_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_Slug_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_Slug_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_Slug_Update>
}

export type TradeCreditVendorsDocAccessFields_Slug_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Slug_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Slug_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Slug_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Title = {
  __typename?: 'TradeCreditVendorsDocAccessFields_title'
  create?: Maybe<TradeCreditVendorsDocAccessFields_Title_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_Title_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_Title_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_Title_Update>
}

export type TradeCreditVendorsDocAccessFields_Title_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Title_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Title_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_Title_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_UpdatedAt = {
  __typename?: 'TradeCreditVendorsDocAccessFields_updatedAt'
  create?: Maybe<TradeCreditVendorsDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<TradeCreditVendorsDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<TradeCreditVendorsDocAccessFields_UpdatedAt_Read>
  update?: Maybe<TradeCreditVendorsDocAccessFields_UpdatedAt_Update>
}

export type TradeCreditVendorsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'TradeCreditVendorsDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'TradeCreditVendorsDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'TradeCreditVendorsDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'TradeCreditVendorsDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields = {
  __typename?: 'TradeCreditVendorsFields'
  _status?: Maybe<TradeCreditVendorsFields__Status>
  applyUrl?: Maybe<TradeCreditVendorsFields_ApplyUrl>
  createdAt?: Maybe<TradeCreditVendorsFields_CreatedAt>
  createdBy?: Maybe<TradeCreditVendorsFields_CreatedBy>
  description?: Maybe<TradeCreditVendorsFields_Description>
  image?: Maybe<TradeCreditVendorsFields_Image>
  publishedAt?: Maybe<TradeCreditVendorsFields_PublishedAt>
  slug?: Maybe<TradeCreditVendorsFields_Slug>
  title?: Maybe<TradeCreditVendorsFields_Title>
  updatedAt?: Maybe<TradeCreditVendorsFields_UpdatedAt>
}

export type TradeCreditVendorsFields__Status = {
  __typename?: 'TradeCreditVendorsFields__status'
  create?: Maybe<TradeCreditVendorsFields__Status_Create>
  delete?: Maybe<TradeCreditVendorsFields__Status_Delete>
  read?: Maybe<TradeCreditVendorsFields__Status_Read>
  update?: Maybe<TradeCreditVendorsFields__Status_Update>
}

export type TradeCreditVendorsFields__Status_Create = {
  __typename?: 'TradeCreditVendorsFields__status_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields__Status_Delete = {
  __typename?: 'TradeCreditVendorsFields__status_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields__Status_Read = {
  __typename?: 'TradeCreditVendorsFields__status_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields__Status_Update = {
  __typename?: 'TradeCreditVendorsFields__status_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_ApplyUrl = {
  __typename?: 'TradeCreditVendorsFields_applyUrl'
  create?: Maybe<TradeCreditVendorsFields_ApplyUrl_Create>
  delete?: Maybe<TradeCreditVendorsFields_ApplyUrl_Delete>
  read?: Maybe<TradeCreditVendorsFields_ApplyUrl_Read>
  update?: Maybe<TradeCreditVendorsFields_ApplyUrl_Update>
}

export type TradeCreditVendorsFields_ApplyUrl_Create = {
  __typename?: 'TradeCreditVendorsFields_applyUrl_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_ApplyUrl_Delete = {
  __typename?: 'TradeCreditVendorsFields_applyUrl_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_ApplyUrl_Read = {
  __typename?: 'TradeCreditVendorsFields_applyUrl_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_ApplyUrl_Update = {
  __typename?: 'TradeCreditVendorsFields_applyUrl_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedAt = {
  __typename?: 'TradeCreditVendorsFields_createdAt'
  create?: Maybe<TradeCreditVendorsFields_CreatedAt_Create>
  delete?: Maybe<TradeCreditVendorsFields_CreatedAt_Delete>
  read?: Maybe<TradeCreditVendorsFields_CreatedAt_Read>
  update?: Maybe<TradeCreditVendorsFields_CreatedAt_Update>
}

export type TradeCreditVendorsFields_CreatedAt_Create = {
  __typename?: 'TradeCreditVendorsFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedAt_Delete = {
  __typename?: 'TradeCreditVendorsFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedAt_Read = {
  __typename?: 'TradeCreditVendorsFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedAt_Update = {
  __typename?: 'TradeCreditVendorsFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedBy = {
  __typename?: 'TradeCreditVendorsFields_createdBy'
  create?: Maybe<TradeCreditVendorsFields_CreatedBy_Create>
  delete?: Maybe<TradeCreditVendorsFields_CreatedBy_Delete>
  read?: Maybe<TradeCreditVendorsFields_CreatedBy_Read>
  update?: Maybe<TradeCreditVendorsFields_CreatedBy_Update>
}

export type TradeCreditVendorsFields_CreatedBy_Create = {
  __typename?: 'TradeCreditVendorsFields_createdBy_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedBy_Delete = {
  __typename?: 'TradeCreditVendorsFields_createdBy_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedBy_Read = {
  __typename?: 'TradeCreditVendorsFields_createdBy_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_CreatedBy_Update = {
  __typename?: 'TradeCreditVendorsFields_createdBy_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Description = {
  __typename?: 'TradeCreditVendorsFields_description'
  create?: Maybe<TradeCreditVendorsFields_Description_Create>
  delete?: Maybe<TradeCreditVendorsFields_Description_Delete>
  read?: Maybe<TradeCreditVendorsFields_Description_Read>
  update?: Maybe<TradeCreditVendorsFields_Description_Update>
}

export type TradeCreditVendorsFields_Description_Create = {
  __typename?: 'TradeCreditVendorsFields_description_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Description_Delete = {
  __typename?: 'TradeCreditVendorsFields_description_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Description_Read = {
  __typename?: 'TradeCreditVendorsFields_description_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Description_Update = {
  __typename?: 'TradeCreditVendorsFields_description_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Image = {
  __typename?: 'TradeCreditVendorsFields_image'
  create?: Maybe<TradeCreditVendorsFields_Image_Create>
  delete?: Maybe<TradeCreditVendorsFields_Image_Delete>
  read?: Maybe<TradeCreditVendorsFields_Image_Read>
  update?: Maybe<TradeCreditVendorsFields_Image_Update>
}

export type TradeCreditVendorsFields_Image_Create = {
  __typename?: 'TradeCreditVendorsFields_image_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Image_Delete = {
  __typename?: 'TradeCreditVendorsFields_image_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Image_Read = {
  __typename?: 'TradeCreditVendorsFields_image_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Image_Update = {
  __typename?: 'TradeCreditVendorsFields_image_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_PublishedAt = {
  __typename?: 'TradeCreditVendorsFields_publishedAt'
  create?: Maybe<TradeCreditVendorsFields_PublishedAt_Create>
  delete?: Maybe<TradeCreditVendorsFields_PublishedAt_Delete>
  read?: Maybe<TradeCreditVendorsFields_PublishedAt_Read>
  update?: Maybe<TradeCreditVendorsFields_PublishedAt_Update>
}

export type TradeCreditVendorsFields_PublishedAt_Create = {
  __typename?: 'TradeCreditVendorsFields_publishedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_PublishedAt_Delete = {
  __typename?: 'TradeCreditVendorsFields_publishedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_PublishedAt_Read = {
  __typename?: 'TradeCreditVendorsFields_publishedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_PublishedAt_Update = {
  __typename?: 'TradeCreditVendorsFields_publishedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Slug = {
  __typename?: 'TradeCreditVendorsFields_slug'
  create?: Maybe<TradeCreditVendorsFields_Slug_Create>
  delete?: Maybe<TradeCreditVendorsFields_Slug_Delete>
  read?: Maybe<TradeCreditVendorsFields_Slug_Read>
  update?: Maybe<TradeCreditVendorsFields_Slug_Update>
}

export type TradeCreditVendorsFields_Slug_Create = {
  __typename?: 'TradeCreditVendorsFields_slug_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Slug_Delete = {
  __typename?: 'TradeCreditVendorsFields_slug_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Slug_Read = {
  __typename?: 'TradeCreditVendorsFields_slug_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Slug_Update = {
  __typename?: 'TradeCreditVendorsFields_slug_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Title = {
  __typename?: 'TradeCreditVendorsFields_title'
  create?: Maybe<TradeCreditVendorsFields_Title_Create>
  delete?: Maybe<TradeCreditVendorsFields_Title_Delete>
  read?: Maybe<TradeCreditVendorsFields_Title_Read>
  update?: Maybe<TradeCreditVendorsFields_Title_Update>
}

export type TradeCreditVendorsFields_Title_Create = {
  __typename?: 'TradeCreditVendorsFields_title_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Title_Delete = {
  __typename?: 'TradeCreditVendorsFields_title_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Title_Read = {
  __typename?: 'TradeCreditVendorsFields_title_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_Title_Update = {
  __typename?: 'TradeCreditVendorsFields_title_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_UpdatedAt = {
  __typename?: 'TradeCreditVendorsFields_updatedAt'
  create?: Maybe<TradeCreditVendorsFields_UpdatedAt_Create>
  delete?: Maybe<TradeCreditVendorsFields_UpdatedAt_Delete>
  read?: Maybe<TradeCreditVendorsFields_UpdatedAt_Read>
  update?: Maybe<TradeCreditVendorsFields_UpdatedAt_Update>
}

export type TradeCreditVendorsFields_UpdatedAt_Create = {
  __typename?: 'TradeCreditVendorsFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_UpdatedAt_Delete = {
  __typename?: 'TradeCreditVendorsFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_UpdatedAt_Read = {
  __typename?: 'TradeCreditVendorsFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsFields_UpdatedAt_Update = {
  __typename?: 'TradeCreditVendorsFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type TradeCreditVendorsReadAccess = {
  __typename?: 'TradeCreditVendorsReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsReadDocAccess = {
  __typename?: 'TradeCreditVendorsReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsReadVersionsAccess = {
  __typename?: 'TradeCreditVendorsReadVersionsAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsReadVersionsDocAccess = {
  __typename?: 'TradeCreditVendorsReadVersionsDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsUpdateAccess = {
  __typename?: 'TradeCreditVendorsUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type TradeCreditVendorsUpdateDocAccess = {
  __typename?: 'TradeCreditVendorsUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export const UserStorageMethod = {
  Device: 'device',
} as const

export type UserStorageMethod = (typeof UserStorageMethod)[keyof typeof UserStorageMethod]
export type UsersCreateAccess = {
  __typename?: 'UsersCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersCreateDocAccess = {
  __typename?: 'UsersCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersDeleteAccess = {
  __typename?: 'UsersDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersDeleteDocAccess = {
  __typename?: 'UsersDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersDocAccessFields = {
  __typename?: 'UsersDocAccessFields'
  createdAt?: Maybe<UsersDocAccessFields_CreatedAt>
  email?: Maybe<UsersDocAccessFields_Email>
  name?: Maybe<UsersDocAccessFields_Name>
  roles?: Maybe<UsersDocAccessFields_Roles>
  sub?: Maybe<UsersDocAccessFields_Sub>
  updatedAt?: Maybe<UsersDocAccessFields_UpdatedAt>
}

export type UsersDocAccessFields_CreatedAt = {
  __typename?: 'UsersDocAccessFields_createdAt'
  create?: Maybe<UsersDocAccessFields_CreatedAt_Create>
  delete?: Maybe<UsersDocAccessFields_CreatedAt_Delete>
  read?: Maybe<UsersDocAccessFields_CreatedAt_Read>
  update?: Maybe<UsersDocAccessFields_CreatedAt_Update>
}

export type UsersDocAccessFields_CreatedAt_Create = {
  __typename?: 'UsersDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_CreatedAt_Delete = {
  __typename?: 'UsersDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_CreatedAt_Read = {
  __typename?: 'UsersDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_CreatedAt_Update = {
  __typename?: 'UsersDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Email = {
  __typename?: 'UsersDocAccessFields_email'
  create?: Maybe<UsersDocAccessFields_Email_Create>
  delete?: Maybe<UsersDocAccessFields_Email_Delete>
  read?: Maybe<UsersDocAccessFields_Email_Read>
  update?: Maybe<UsersDocAccessFields_Email_Update>
}

export type UsersDocAccessFields_Email_Create = {
  __typename?: 'UsersDocAccessFields_email_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Email_Delete = {
  __typename?: 'UsersDocAccessFields_email_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Email_Read = {
  __typename?: 'UsersDocAccessFields_email_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Email_Update = {
  __typename?: 'UsersDocAccessFields_email_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Name = {
  __typename?: 'UsersDocAccessFields_name'
  create?: Maybe<UsersDocAccessFields_Name_Create>
  delete?: Maybe<UsersDocAccessFields_Name_Delete>
  read?: Maybe<UsersDocAccessFields_Name_Read>
  update?: Maybe<UsersDocAccessFields_Name_Update>
}

export type UsersDocAccessFields_Name_Create = {
  __typename?: 'UsersDocAccessFields_name_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Name_Delete = {
  __typename?: 'UsersDocAccessFields_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Name_Read = {
  __typename?: 'UsersDocAccessFields_name_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Name_Update = {
  __typename?: 'UsersDocAccessFields_name_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Roles = {
  __typename?: 'UsersDocAccessFields_roles'
  create?: Maybe<UsersDocAccessFields_Roles_Create>
  delete?: Maybe<UsersDocAccessFields_Roles_Delete>
  read?: Maybe<UsersDocAccessFields_Roles_Read>
  update?: Maybe<UsersDocAccessFields_Roles_Update>
}

export type UsersDocAccessFields_Roles_Create = {
  __typename?: 'UsersDocAccessFields_roles_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Roles_Delete = {
  __typename?: 'UsersDocAccessFields_roles_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Roles_Read = {
  __typename?: 'UsersDocAccessFields_roles_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Roles_Update = {
  __typename?: 'UsersDocAccessFields_roles_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Sub = {
  __typename?: 'UsersDocAccessFields_sub'
  create?: Maybe<UsersDocAccessFields_Sub_Create>
  delete?: Maybe<UsersDocAccessFields_Sub_Delete>
  read?: Maybe<UsersDocAccessFields_Sub_Read>
  update?: Maybe<UsersDocAccessFields_Sub_Update>
}

export type UsersDocAccessFields_Sub_Create = {
  __typename?: 'UsersDocAccessFields_sub_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Sub_Delete = {
  __typename?: 'UsersDocAccessFields_sub_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Sub_Read = {
  __typename?: 'UsersDocAccessFields_sub_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_Sub_Update = {
  __typename?: 'UsersDocAccessFields_sub_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_UpdatedAt = {
  __typename?: 'UsersDocAccessFields_updatedAt'
  create?: Maybe<UsersDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<UsersDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<UsersDocAccessFields_UpdatedAt_Read>
  update?: Maybe<UsersDocAccessFields_UpdatedAt_Update>
}

export type UsersDocAccessFields_UpdatedAt_Create = {
  __typename?: 'UsersDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'UsersDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_UpdatedAt_Read = {
  __typename?: 'UsersDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersDocAccessFields_UpdatedAt_Update = {
  __typename?: 'UsersDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersFields = {
  __typename?: 'UsersFields'
  createdAt?: Maybe<UsersFields_CreatedAt>
  email?: Maybe<UsersFields_Email>
  name?: Maybe<UsersFields_Name>
  roles?: Maybe<UsersFields_Roles>
  sub?: Maybe<UsersFields_Sub>
  updatedAt?: Maybe<UsersFields_UpdatedAt>
}

export type UsersFields_CreatedAt = {
  __typename?: 'UsersFields_createdAt'
  create?: Maybe<UsersFields_CreatedAt_Create>
  delete?: Maybe<UsersFields_CreatedAt_Delete>
  read?: Maybe<UsersFields_CreatedAt_Read>
  update?: Maybe<UsersFields_CreatedAt_Update>
}

export type UsersFields_CreatedAt_Create = {
  __typename?: 'UsersFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_CreatedAt_Delete = {
  __typename?: 'UsersFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_CreatedAt_Read = {
  __typename?: 'UsersFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_CreatedAt_Update = {
  __typename?: 'UsersFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Email = {
  __typename?: 'UsersFields_email'
  create?: Maybe<UsersFields_Email_Create>
  delete?: Maybe<UsersFields_Email_Delete>
  read?: Maybe<UsersFields_Email_Read>
  update?: Maybe<UsersFields_Email_Update>
}

export type UsersFields_Email_Create = {
  __typename?: 'UsersFields_email_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Email_Delete = {
  __typename?: 'UsersFields_email_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Email_Read = {
  __typename?: 'UsersFields_email_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Email_Update = {
  __typename?: 'UsersFields_email_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Name = {
  __typename?: 'UsersFields_name'
  create?: Maybe<UsersFields_Name_Create>
  delete?: Maybe<UsersFields_Name_Delete>
  read?: Maybe<UsersFields_Name_Read>
  update?: Maybe<UsersFields_Name_Update>
}

export type UsersFields_Name_Create = {
  __typename?: 'UsersFields_name_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Name_Delete = {
  __typename?: 'UsersFields_name_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Name_Read = {
  __typename?: 'UsersFields_name_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Name_Update = {
  __typename?: 'UsersFields_name_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Roles = {
  __typename?: 'UsersFields_roles'
  create?: Maybe<UsersFields_Roles_Create>
  delete?: Maybe<UsersFields_Roles_Delete>
  read?: Maybe<UsersFields_Roles_Read>
  update?: Maybe<UsersFields_Roles_Update>
}

export type UsersFields_Roles_Create = {
  __typename?: 'UsersFields_roles_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Roles_Delete = {
  __typename?: 'UsersFields_roles_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Roles_Read = {
  __typename?: 'UsersFields_roles_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Roles_Update = {
  __typename?: 'UsersFields_roles_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Sub = {
  __typename?: 'UsersFields_sub'
  create?: Maybe<UsersFields_Sub_Create>
  delete?: Maybe<UsersFields_Sub_Delete>
  read?: Maybe<UsersFields_Sub_Read>
  update?: Maybe<UsersFields_Sub_Update>
}

export type UsersFields_Sub_Create = {
  __typename?: 'UsersFields_sub_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Sub_Delete = {
  __typename?: 'UsersFields_sub_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Sub_Read = {
  __typename?: 'UsersFields_sub_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_Sub_Update = {
  __typename?: 'UsersFields_sub_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_UpdatedAt = {
  __typename?: 'UsersFields_updatedAt'
  create?: Maybe<UsersFields_UpdatedAt_Create>
  delete?: Maybe<UsersFields_UpdatedAt_Delete>
  read?: Maybe<UsersFields_UpdatedAt_Read>
  update?: Maybe<UsersFields_UpdatedAt_Update>
}

export type UsersFields_UpdatedAt_Create = {
  __typename?: 'UsersFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_UpdatedAt_Delete = {
  __typename?: 'UsersFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_UpdatedAt_Read = {
  __typename?: 'UsersFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type UsersFields_UpdatedAt_Update = {
  __typename?: 'UsersFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type UsersReadAccess = {
  __typename?: 'UsersReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersReadDocAccess = {
  __typename?: 'UsersReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersUnlockAccess = {
  __typename?: 'UsersUnlockAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersUnlockDocAccess = {
  __typename?: 'UsersUnlockDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersUpdateAccess = {
  __typename?: 'UsersUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type UsersUpdateDocAccess = {
  __typename?: 'UsersUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosCreateAccess = {
  __typename?: 'VideosCreateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosCreateDocAccess = {
  __typename?: 'VideosCreateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosDeleteAccess = {
  __typename?: 'VideosDeleteAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosDeleteDocAccess = {
  __typename?: 'VideosDeleteDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosDocAccessFields = {
  __typename?: 'VideosDocAccessFields'
  createdAt?: Maybe<VideosDocAccessFields_CreatedAt>
  filename?: Maybe<VideosDocAccessFields_Filename>
  filesize?: Maybe<VideosDocAccessFields_Filesize>
  focalX?: Maybe<VideosDocAccessFields_FocalX>
  focalY?: Maybe<VideosDocAccessFields_FocalY>
  height?: Maybe<VideosDocAccessFields_Height>
  mimeType?: Maybe<VideosDocAccessFields_MimeType>
  prefix?: Maybe<VideosDocAccessFields_Prefix>
  thumbnailURL?: Maybe<VideosDocAccessFields_ThumbnailUrl>
  updatedAt?: Maybe<VideosDocAccessFields_UpdatedAt>
  url?: Maybe<VideosDocAccessFields_Url>
  width?: Maybe<VideosDocAccessFields_Width>
}

export type VideosDocAccessFields_CreatedAt = {
  __typename?: 'VideosDocAccessFields_createdAt'
  create?: Maybe<VideosDocAccessFields_CreatedAt_Create>
  delete?: Maybe<VideosDocAccessFields_CreatedAt_Delete>
  read?: Maybe<VideosDocAccessFields_CreatedAt_Read>
  update?: Maybe<VideosDocAccessFields_CreatedAt_Update>
}

export type VideosDocAccessFields_CreatedAt_Create = {
  __typename?: 'VideosDocAccessFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_CreatedAt_Delete = {
  __typename?: 'VideosDocAccessFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_CreatedAt_Read = {
  __typename?: 'VideosDocAccessFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_CreatedAt_Update = {
  __typename?: 'VideosDocAccessFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filename = {
  __typename?: 'VideosDocAccessFields_filename'
  create?: Maybe<VideosDocAccessFields_Filename_Create>
  delete?: Maybe<VideosDocAccessFields_Filename_Delete>
  read?: Maybe<VideosDocAccessFields_Filename_Read>
  update?: Maybe<VideosDocAccessFields_Filename_Update>
}

export type VideosDocAccessFields_Filename_Create = {
  __typename?: 'VideosDocAccessFields_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filename_Delete = {
  __typename?: 'VideosDocAccessFields_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filename_Read = {
  __typename?: 'VideosDocAccessFields_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filename_Update = {
  __typename?: 'VideosDocAccessFields_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filesize = {
  __typename?: 'VideosDocAccessFields_filesize'
  create?: Maybe<VideosDocAccessFields_Filesize_Create>
  delete?: Maybe<VideosDocAccessFields_Filesize_Delete>
  read?: Maybe<VideosDocAccessFields_Filesize_Read>
  update?: Maybe<VideosDocAccessFields_Filesize_Update>
}

export type VideosDocAccessFields_Filesize_Create = {
  __typename?: 'VideosDocAccessFields_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filesize_Delete = {
  __typename?: 'VideosDocAccessFields_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filesize_Read = {
  __typename?: 'VideosDocAccessFields_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Filesize_Update = {
  __typename?: 'VideosDocAccessFields_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalX = {
  __typename?: 'VideosDocAccessFields_focalX'
  create?: Maybe<VideosDocAccessFields_FocalX_Create>
  delete?: Maybe<VideosDocAccessFields_FocalX_Delete>
  read?: Maybe<VideosDocAccessFields_FocalX_Read>
  update?: Maybe<VideosDocAccessFields_FocalX_Update>
}

export type VideosDocAccessFields_FocalX_Create = {
  __typename?: 'VideosDocAccessFields_focalX_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalX_Delete = {
  __typename?: 'VideosDocAccessFields_focalX_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalX_Read = {
  __typename?: 'VideosDocAccessFields_focalX_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalX_Update = {
  __typename?: 'VideosDocAccessFields_focalX_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalY = {
  __typename?: 'VideosDocAccessFields_focalY'
  create?: Maybe<VideosDocAccessFields_FocalY_Create>
  delete?: Maybe<VideosDocAccessFields_FocalY_Delete>
  read?: Maybe<VideosDocAccessFields_FocalY_Read>
  update?: Maybe<VideosDocAccessFields_FocalY_Update>
}

export type VideosDocAccessFields_FocalY_Create = {
  __typename?: 'VideosDocAccessFields_focalY_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalY_Delete = {
  __typename?: 'VideosDocAccessFields_focalY_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalY_Read = {
  __typename?: 'VideosDocAccessFields_focalY_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_FocalY_Update = {
  __typename?: 'VideosDocAccessFields_focalY_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Height = {
  __typename?: 'VideosDocAccessFields_height'
  create?: Maybe<VideosDocAccessFields_Height_Create>
  delete?: Maybe<VideosDocAccessFields_Height_Delete>
  read?: Maybe<VideosDocAccessFields_Height_Read>
  update?: Maybe<VideosDocAccessFields_Height_Update>
}

export type VideosDocAccessFields_Height_Create = {
  __typename?: 'VideosDocAccessFields_height_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Height_Delete = {
  __typename?: 'VideosDocAccessFields_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Height_Read = {
  __typename?: 'VideosDocAccessFields_height_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Height_Update = {
  __typename?: 'VideosDocAccessFields_height_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_MimeType = {
  __typename?: 'VideosDocAccessFields_mimeType'
  create?: Maybe<VideosDocAccessFields_MimeType_Create>
  delete?: Maybe<VideosDocAccessFields_MimeType_Delete>
  read?: Maybe<VideosDocAccessFields_MimeType_Read>
  update?: Maybe<VideosDocAccessFields_MimeType_Update>
}

export type VideosDocAccessFields_MimeType_Create = {
  __typename?: 'VideosDocAccessFields_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_MimeType_Delete = {
  __typename?: 'VideosDocAccessFields_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_MimeType_Read = {
  __typename?: 'VideosDocAccessFields_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_MimeType_Update = {
  __typename?: 'VideosDocAccessFields_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Prefix = {
  __typename?: 'VideosDocAccessFields_prefix'
  create?: Maybe<VideosDocAccessFields_Prefix_Create>
  delete?: Maybe<VideosDocAccessFields_Prefix_Delete>
  read?: Maybe<VideosDocAccessFields_Prefix_Read>
  update?: Maybe<VideosDocAccessFields_Prefix_Update>
}

export type VideosDocAccessFields_Prefix_Create = {
  __typename?: 'VideosDocAccessFields_prefix_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Prefix_Delete = {
  __typename?: 'VideosDocAccessFields_prefix_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Prefix_Read = {
  __typename?: 'VideosDocAccessFields_prefix_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Prefix_Update = {
  __typename?: 'VideosDocAccessFields_prefix_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_ThumbnailUrl = {
  __typename?: 'VideosDocAccessFields_thumbnailURL'
  create?: Maybe<VideosDocAccessFields_ThumbnailUrl_Create>
  delete?: Maybe<VideosDocAccessFields_ThumbnailUrl_Delete>
  read?: Maybe<VideosDocAccessFields_ThumbnailUrl_Read>
  update?: Maybe<VideosDocAccessFields_ThumbnailUrl_Update>
}

export type VideosDocAccessFields_ThumbnailUrl_Create = {
  __typename?: 'VideosDocAccessFields_thumbnailURL_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_ThumbnailUrl_Delete = {
  __typename?: 'VideosDocAccessFields_thumbnailURL_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_ThumbnailUrl_Read = {
  __typename?: 'VideosDocAccessFields_thumbnailURL_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_ThumbnailUrl_Update = {
  __typename?: 'VideosDocAccessFields_thumbnailURL_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_UpdatedAt = {
  __typename?: 'VideosDocAccessFields_updatedAt'
  create?: Maybe<VideosDocAccessFields_UpdatedAt_Create>
  delete?: Maybe<VideosDocAccessFields_UpdatedAt_Delete>
  read?: Maybe<VideosDocAccessFields_UpdatedAt_Read>
  update?: Maybe<VideosDocAccessFields_UpdatedAt_Update>
}

export type VideosDocAccessFields_UpdatedAt_Create = {
  __typename?: 'VideosDocAccessFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'VideosDocAccessFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_UpdatedAt_Read = {
  __typename?: 'VideosDocAccessFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_UpdatedAt_Update = {
  __typename?: 'VideosDocAccessFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Url = {
  __typename?: 'VideosDocAccessFields_url'
  create?: Maybe<VideosDocAccessFields_Url_Create>
  delete?: Maybe<VideosDocAccessFields_Url_Delete>
  read?: Maybe<VideosDocAccessFields_Url_Read>
  update?: Maybe<VideosDocAccessFields_Url_Update>
}

export type VideosDocAccessFields_Url_Create = {
  __typename?: 'VideosDocAccessFields_url_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Url_Delete = {
  __typename?: 'VideosDocAccessFields_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Url_Read = {
  __typename?: 'VideosDocAccessFields_url_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Url_Update = {
  __typename?: 'VideosDocAccessFields_url_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Width = {
  __typename?: 'VideosDocAccessFields_width'
  create?: Maybe<VideosDocAccessFields_Width_Create>
  delete?: Maybe<VideosDocAccessFields_Width_Delete>
  read?: Maybe<VideosDocAccessFields_Width_Read>
  update?: Maybe<VideosDocAccessFields_Width_Update>
}

export type VideosDocAccessFields_Width_Create = {
  __typename?: 'VideosDocAccessFields_width_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Width_Delete = {
  __typename?: 'VideosDocAccessFields_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Width_Read = {
  __typename?: 'VideosDocAccessFields_width_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosDocAccessFields_Width_Update = {
  __typename?: 'VideosDocAccessFields_width_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields = {
  __typename?: 'VideosFields'
  createdAt?: Maybe<VideosFields_CreatedAt>
  filename?: Maybe<VideosFields_Filename>
  filesize?: Maybe<VideosFields_Filesize>
  focalX?: Maybe<VideosFields_FocalX>
  focalY?: Maybe<VideosFields_FocalY>
  height?: Maybe<VideosFields_Height>
  mimeType?: Maybe<VideosFields_MimeType>
  prefix?: Maybe<VideosFields_Prefix>
  thumbnailURL?: Maybe<VideosFields_ThumbnailUrl>
  updatedAt?: Maybe<VideosFields_UpdatedAt>
  url?: Maybe<VideosFields_Url>
  width?: Maybe<VideosFields_Width>
}

export type VideosFields_CreatedAt = {
  __typename?: 'VideosFields_createdAt'
  create?: Maybe<VideosFields_CreatedAt_Create>
  delete?: Maybe<VideosFields_CreatedAt_Delete>
  read?: Maybe<VideosFields_CreatedAt_Read>
  update?: Maybe<VideosFields_CreatedAt_Update>
}

export type VideosFields_CreatedAt_Create = {
  __typename?: 'VideosFields_createdAt_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_CreatedAt_Delete = {
  __typename?: 'VideosFields_createdAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_CreatedAt_Read = {
  __typename?: 'VideosFields_createdAt_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_CreatedAt_Update = {
  __typename?: 'VideosFields_createdAt_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filename = {
  __typename?: 'VideosFields_filename'
  create?: Maybe<VideosFields_Filename_Create>
  delete?: Maybe<VideosFields_Filename_Delete>
  read?: Maybe<VideosFields_Filename_Read>
  update?: Maybe<VideosFields_Filename_Update>
}

export type VideosFields_Filename_Create = {
  __typename?: 'VideosFields_filename_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filename_Delete = {
  __typename?: 'VideosFields_filename_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filename_Read = {
  __typename?: 'VideosFields_filename_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filename_Update = {
  __typename?: 'VideosFields_filename_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filesize = {
  __typename?: 'VideosFields_filesize'
  create?: Maybe<VideosFields_Filesize_Create>
  delete?: Maybe<VideosFields_Filesize_Delete>
  read?: Maybe<VideosFields_Filesize_Read>
  update?: Maybe<VideosFields_Filesize_Update>
}

export type VideosFields_Filesize_Create = {
  __typename?: 'VideosFields_filesize_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filesize_Delete = {
  __typename?: 'VideosFields_filesize_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filesize_Read = {
  __typename?: 'VideosFields_filesize_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Filesize_Update = {
  __typename?: 'VideosFields_filesize_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalX = {
  __typename?: 'VideosFields_focalX'
  create?: Maybe<VideosFields_FocalX_Create>
  delete?: Maybe<VideosFields_FocalX_Delete>
  read?: Maybe<VideosFields_FocalX_Read>
  update?: Maybe<VideosFields_FocalX_Update>
}

export type VideosFields_FocalX_Create = {
  __typename?: 'VideosFields_focalX_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalX_Delete = {
  __typename?: 'VideosFields_focalX_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalX_Read = {
  __typename?: 'VideosFields_focalX_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalX_Update = {
  __typename?: 'VideosFields_focalX_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalY = {
  __typename?: 'VideosFields_focalY'
  create?: Maybe<VideosFields_FocalY_Create>
  delete?: Maybe<VideosFields_FocalY_Delete>
  read?: Maybe<VideosFields_FocalY_Read>
  update?: Maybe<VideosFields_FocalY_Update>
}

export type VideosFields_FocalY_Create = {
  __typename?: 'VideosFields_focalY_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalY_Delete = {
  __typename?: 'VideosFields_focalY_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalY_Read = {
  __typename?: 'VideosFields_focalY_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_FocalY_Update = {
  __typename?: 'VideosFields_focalY_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Height = {
  __typename?: 'VideosFields_height'
  create?: Maybe<VideosFields_Height_Create>
  delete?: Maybe<VideosFields_Height_Delete>
  read?: Maybe<VideosFields_Height_Read>
  update?: Maybe<VideosFields_Height_Update>
}

export type VideosFields_Height_Create = {
  __typename?: 'VideosFields_height_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Height_Delete = {
  __typename?: 'VideosFields_height_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Height_Read = {
  __typename?: 'VideosFields_height_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Height_Update = {
  __typename?: 'VideosFields_height_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_MimeType = {
  __typename?: 'VideosFields_mimeType'
  create?: Maybe<VideosFields_MimeType_Create>
  delete?: Maybe<VideosFields_MimeType_Delete>
  read?: Maybe<VideosFields_MimeType_Read>
  update?: Maybe<VideosFields_MimeType_Update>
}

export type VideosFields_MimeType_Create = {
  __typename?: 'VideosFields_mimeType_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_MimeType_Delete = {
  __typename?: 'VideosFields_mimeType_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_MimeType_Read = {
  __typename?: 'VideosFields_mimeType_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_MimeType_Update = {
  __typename?: 'VideosFields_mimeType_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Prefix = {
  __typename?: 'VideosFields_prefix'
  create?: Maybe<VideosFields_Prefix_Create>
  delete?: Maybe<VideosFields_Prefix_Delete>
  read?: Maybe<VideosFields_Prefix_Read>
  update?: Maybe<VideosFields_Prefix_Update>
}

export type VideosFields_Prefix_Create = {
  __typename?: 'VideosFields_prefix_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Prefix_Delete = {
  __typename?: 'VideosFields_prefix_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Prefix_Read = {
  __typename?: 'VideosFields_prefix_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Prefix_Update = {
  __typename?: 'VideosFields_prefix_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_ThumbnailUrl = {
  __typename?: 'VideosFields_thumbnailURL'
  create?: Maybe<VideosFields_ThumbnailUrl_Create>
  delete?: Maybe<VideosFields_ThumbnailUrl_Delete>
  read?: Maybe<VideosFields_ThumbnailUrl_Read>
  update?: Maybe<VideosFields_ThumbnailUrl_Update>
}

export type VideosFields_ThumbnailUrl_Create = {
  __typename?: 'VideosFields_thumbnailURL_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_ThumbnailUrl_Delete = {
  __typename?: 'VideosFields_thumbnailURL_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_ThumbnailUrl_Read = {
  __typename?: 'VideosFields_thumbnailURL_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_ThumbnailUrl_Update = {
  __typename?: 'VideosFields_thumbnailURL_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_UpdatedAt = {
  __typename?: 'VideosFields_updatedAt'
  create?: Maybe<VideosFields_UpdatedAt_Create>
  delete?: Maybe<VideosFields_UpdatedAt_Delete>
  read?: Maybe<VideosFields_UpdatedAt_Read>
  update?: Maybe<VideosFields_UpdatedAt_Update>
}

export type VideosFields_UpdatedAt_Create = {
  __typename?: 'VideosFields_updatedAt_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_UpdatedAt_Delete = {
  __typename?: 'VideosFields_updatedAt_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_UpdatedAt_Read = {
  __typename?: 'VideosFields_updatedAt_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_UpdatedAt_Update = {
  __typename?: 'VideosFields_updatedAt_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Url = {
  __typename?: 'VideosFields_url'
  create?: Maybe<VideosFields_Url_Create>
  delete?: Maybe<VideosFields_Url_Delete>
  read?: Maybe<VideosFields_Url_Read>
  update?: Maybe<VideosFields_Url_Update>
}

export type VideosFields_Url_Create = {
  __typename?: 'VideosFields_url_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Url_Delete = {
  __typename?: 'VideosFields_url_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Url_Read = {
  __typename?: 'VideosFields_url_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Url_Update = {
  __typename?: 'VideosFields_url_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Width = {
  __typename?: 'VideosFields_width'
  create?: Maybe<VideosFields_Width_Create>
  delete?: Maybe<VideosFields_Width_Delete>
  read?: Maybe<VideosFields_Width_Read>
  update?: Maybe<VideosFields_Width_Update>
}

export type VideosFields_Width_Create = {
  __typename?: 'VideosFields_width_Create'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Width_Delete = {
  __typename?: 'VideosFields_width_Delete'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Width_Read = {
  __typename?: 'VideosFields_width_Read'
  permission: Scalars['Boolean']['output']
}

export type VideosFields_Width_Update = {
  __typename?: 'VideosFields_width_Update'
  permission: Scalars['Boolean']['output']
}

export type VideosReadAccess = {
  __typename?: 'VideosReadAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosReadDocAccess = {
  __typename?: 'VideosReadDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosUpdateAccess = {
  __typename?: 'VideosUpdateAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type VideosUpdateDocAccess = {
  __typename?: 'VideosUpdateDocAccess'
  permission: Scalars['Boolean']['output']
  where?: Maybe<Scalars['JSONObject']['output']>
}

export type AllCmsCategories = {
  __typename?: 'allCmsCategories'
  docs?: Maybe<Array<Maybe<CmsCategories>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type AllCmsLinks = {
  __typename?: 'allCmsLinks'
  docs?: Maybe<Array<Maybe<CmsLinks>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type ArticlesAccess = {
  __typename?: 'articlesAccess'
  create?: Maybe<ArticlesCreateAccess>
  delete?: Maybe<ArticlesDeleteAccess>
  fields?: Maybe<ArticlesFields>
  read?: Maybe<ArticlesReadAccess>
  readVersions?: Maybe<ArticlesReadVersionsAccess>
  update?: Maybe<ArticlesUpdateAccess>
}

export type ArticlesDocAccess = {
  __typename?: 'articlesDocAccess'
  create?: Maybe<ArticlesCreateDocAccess>
  delete?: Maybe<ArticlesDeleteDocAccess>
  fields?: Maybe<ArticlesDocAccessFields>
  read?: Maybe<ArticlesReadDocAccess>
  readVersions?: Maybe<ArticlesReadVersionsDocAccess>
  update?: Maybe<ArticlesUpdateDocAccess>
}

export type AuthorsAccess = {
  __typename?: 'authorsAccess'
  create?: Maybe<AuthorsCreateAccess>
  delete?: Maybe<AuthorsDeleteAccess>
  fields?: Maybe<AuthorsFields>
  read?: Maybe<AuthorsReadAccess>
  update?: Maybe<AuthorsUpdateAccess>
}

export type AuthorsDocAccess = {
  __typename?: 'authorsDocAccess'
  create?: Maybe<AuthorsCreateDocAccess>
  delete?: Maybe<AuthorsDeleteDocAccess>
  fields?: Maybe<AuthorsDocAccessFields>
  read?: Maybe<AuthorsReadDocAccess>
  update?: Maybe<AuthorsUpdateDocAccess>
}

export type CalloutsAccess = {
  __typename?: 'calloutsAccess'
  create?: Maybe<CalloutsCreateAccess>
  delete?: Maybe<CalloutsDeleteAccess>
  fields?: Maybe<CalloutsFields>
  read?: Maybe<CalloutsReadAccess>
  update?: Maybe<CalloutsUpdateAccess>
}

export type CalloutsDocAccess = {
  __typename?: 'calloutsDocAccess'
  create?: Maybe<CalloutsCreateDocAccess>
  delete?: Maybe<CalloutsDeleteDocAccess>
  fields?: Maybe<CalloutsDocAccessFields>
  read?: Maybe<CalloutsReadDocAccess>
  update?: Maybe<CalloutsUpdateDocAccess>
}

export type CategoriesAccess = {
  __typename?: 'categoriesAccess'
  create?: Maybe<CategoriesCreateAccess>
  delete?: Maybe<CategoriesDeleteAccess>
  fields?: Maybe<CategoriesFields>
  read?: Maybe<CategoriesReadAccess>
  update?: Maybe<CategoriesUpdateAccess>
}

export type CategoriesDocAccess = {
  __typename?: 'categoriesDocAccess'
  create?: Maybe<CategoriesCreateDocAccess>
  delete?: Maybe<CategoriesDeleteDocAccess>
  fields?: Maybe<CategoriesDocAccessFields>
  read?: Maybe<CategoriesReadDocAccess>
  update?: Maybe<CategoriesUpdateDocAccess>
}

export type CommentsAccess = {
  __typename?: 'commentsAccess'
  create?: Maybe<CommentsCreateAccess>
  delete?: Maybe<CommentsDeleteAccess>
  fields?: Maybe<CommentsFields>
  read?: Maybe<CommentsReadAccess>
  update?: Maybe<CommentsUpdateAccess>
}

export type CommentsDocAccess = {
  __typename?: 'commentsDocAccess'
  create?: Maybe<CommentsCreateDocAccess>
  delete?: Maybe<CommentsDeleteDocAccess>
  fields?: Maybe<CommentsDocAccessFields>
  read?: Maybe<CommentsReadDocAccess>
  update?: Maybe<CommentsUpdateDocAccess>
}

export type CountCmsArticles = {
  __typename?: 'countCmsArticles'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsAuthors = {
  __typename?: 'countCmsAuthors'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsCallouts = {
  __typename?: 'countCmsCallouts'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsComments = {
  __typename?: 'countCmsComments'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsFormSubmissions = {
  __typename?: 'countCmsFormSubmissions'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsForms = {
  __typename?: 'countCmsForms'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsGuides = {
  __typename?: 'countCmsGuides'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsLegals = {
  __typename?: 'countCmsLegals'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsLiteEmbeddedMarketplaces = {
  __typename?: 'countCmsLiteEmbeddedMarketplaces'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsMarketplacePages = {
  __typename?: 'countCmsMarketplacePages'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsMedias = {
  __typename?: 'countCmsMedias'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsNewsroomArticles = {
  __typename?: 'countCmsNewsroomArticles'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsPages = {
  __typename?: 'countCmsPages'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsPricings = {
  __typename?: 'countCmsPricings'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsRatings = {
  __typename?: 'countCmsRatings'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsRedirects = {
  __typename?: 'countCmsRedirects'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsStackerPages = {
  __typename?: 'countCmsStackerPages'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsTradeCreditProgramTags = {
  __typename?: 'countCmsTradeCreditProgramTags'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsTradeCreditPrograms = {
  __typename?: 'countCmsTradeCreditPrograms'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsTradeCreditRecommendations = {
  __typename?: 'countCmsTradeCreditRecommendations'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsTradeCreditVendors = {
  __typename?: 'countCmsTradeCreditVendors'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsUsers = {
  __typename?: 'countCmsUsers'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountCmsVideos = {
  __typename?: 'countCmsVideos'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountPayloadLockedDocuments = {
  __typename?: 'countPayloadLockedDocuments'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountPayloadPreferences = {
  __typename?: 'countPayloadPreferences'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountallCmsCategories = {
  __typename?: 'countallCmsCategories'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type CountallCmsLinks = {
  __typename?: 'countallCmsLinks'
  totalDocs?: Maybe<Scalars['Int']['output']>
}

export type FooterAccess = {
  __typename?: 'footerAccess'
  fields?: Maybe<CmsFooterFields>
  read?: Maybe<CmsFooterReadAccess>
  update?: Maybe<CmsFooterUpdateAccess>
}

export type FooterDocAccess = {
  __typename?: 'footerDocAccess'
  fields?: Maybe<CmsFooterDocAccessFields>
  read?: Maybe<CmsFooterReadDocAccess>
  update?: Maybe<CmsFooterUpdateDocAccess>
}

export type Form_SubmissionsAccess = {
  __typename?: 'form_submissionsAccess'
  create?: Maybe<FormSubmissionsCreateAccess>
  delete?: Maybe<FormSubmissionsDeleteAccess>
  fields?: Maybe<FormSubmissionsFields>
  read?: Maybe<FormSubmissionsReadAccess>
  update?: Maybe<FormSubmissionsUpdateAccess>
}

export type Form_SubmissionsDocAccess = {
  __typename?: 'form_submissionsDocAccess'
  create?: Maybe<FormSubmissionsCreateDocAccess>
  delete?: Maybe<FormSubmissionsDeleteDocAccess>
  fields?: Maybe<FormSubmissionsDocAccessFields>
  read?: Maybe<FormSubmissionsReadDocAccess>
  update?: Maybe<FormSubmissionsUpdateDocAccess>
}

export type FormsAccess = {
  __typename?: 'formsAccess'
  create?: Maybe<FormsCreateAccess>
  delete?: Maybe<FormsDeleteAccess>
  fields?: Maybe<FormsFields>
  read?: Maybe<FormsReadAccess>
  readVersions?: Maybe<FormsReadVersionsAccess>
  update?: Maybe<FormsUpdateAccess>
}

export type FormsDocAccess = {
  __typename?: 'formsDocAccess'
  create?: Maybe<FormsCreateDocAccess>
  delete?: Maybe<FormsDeleteDocAccess>
  fields?: Maybe<FormsDocAccessFields>
  read?: Maybe<FormsReadDocAccess>
  readVersions?: Maybe<FormsReadVersionsDocAccess>
  update?: Maybe<FormsUpdateDocAccess>
}

export type GuidesAccess = {
  __typename?: 'guidesAccess'
  create?: Maybe<GuidesCreateAccess>
  delete?: Maybe<GuidesDeleteAccess>
  fields?: Maybe<GuidesFields>
  read?: Maybe<GuidesReadAccess>
  readVersions?: Maybe<GuidesReadVersionsAccess>
  update?: Maybe<GuidesUpdateAccess>
}

export type GuidesDocAccess = {
  __typename?: 'guidesDocAccess'
  create?: Maybe<GuidesCreateDocAccess>
  delete?: Maybe<GuidesDeleteDocAccess>
  fields?: Maybe<GuidesDocAccessFields>
  read?: Maybe<GuidesReadDocAccess>
  readVersions?: Maybe<GuidesReadVersionsDocAccess>
  update?: Maybe<GuidesUpdateDocAccess>
}

export type HeaderAccess = {
  __typename?: 'headerAccess'
  fields?: Maybe<CmsHeaderFields>
  read?: Maybe<CmsHeaderReadAccess>
  update?: Maybe<CmsHeaderUpdateAccess>
}

export type HeaderDocAccess = {
  __typename?: 'headerDocAccess'
  fields?: Maybe<CmsHeaderDocAccessFields>
  read?: Maybe<CmsHeaderReadDocAccess>
  update?: Maybe<CmsHeaderUpdateDocAccess>
}

export type LegalAccess = {
  __typename?: 'legalAccess'
  create?: Maybe<LegalCreateAccess>
  delete?: Maybe<LegalDeleteAccess>
  fields?: Maybe<LegalFields>
  read?: Maybe<LegalReadAccess>
  update?: Maybe<LegalUpdateAccess>
}

export type LegalDocAccess = {
  __typename?: 'legalDocAccess'
  create?: Maybe<LegalCreateDocAccess>
  delete?: Maybe<LegalDeleteDocAccess>
  fields?: Maybe<LegalDocAccessFields>
  read?: Maybe<LegalReadDocAccess>
  update?: Maybe<LegalUpdateDocAccess>
}

export type LinksAccess = {
  __typename?: 'linksAccess'
  create?: Maybe<LinksCreateAccess>
  delete?: Maybe<LinksDeleteAccess>
  fields?: Maybe<LinksFields>
  read?: Maybe<LinksReadAccess>
  update?: Maybe<LinksUpdateAccess>
}

export type LinksDocAccess = {
  __typename?: 'linksDocAccess'
  create?: Maybe<LinksCreateDocAccess>
  delete?: Maybe<LinksDeleteDocAccess>
  fields?: Maybe<LinksDocAccessFields>
  read?: Maybe<LinksReadDocAccess>
  update?: Maybe<LinksUpdateDocAccess>
}

export type Lite_EmbeddedAccess = {
  __typename?: 'lite_embeddedAccess'
  create?: Maybe<LiteEmbeddedCreateAccess>
  delete?: Maybe<LiteEmbeddedDeleteAccess>
  fields?: Maybe<LiteEmbeddedFields>
  read?: Maybe<LiteEmbeddedReadAccess>
  readVersions?: Maybe<LiteEmbeddedReadVersionsAccess>
  update?: Maybe<LiteEmbeddedUpdateAccess>
}

export type Lite_EmbeddedDocAccess = {
  __typename?: 'lite_embeddedDocAccess'
  create?: Maybe<LiteEmbeddedCreateDocAccess>
  delete?: Maybe<LiteEmbeddedDeleteDocAccess>
  fields?: Maybe<LiteEmbeddedDocAccessFields>
  read?: Maybe<LiteEmbeddedReadDocAccess>
  readVersions?: Maybe<LiteEmbeddedReadVersionsDocAccess>
  update?: Maybe<LiteEmbeddedUpdateDocAccess>
}

export type MarketplaceAccess = {
  __typename?: 'marketplaceAccess'
  create?: Maybe<MarketplaceCreateAccess>
  delete?: Maybe<MarketplaceDeleteAccess>
  fields?: Maybe<MarketplaceFields>
  read?: Maybe<MarketplaceReadAccess>
  readVersions?: Maybe<MarketplaceReadVersionsAccess>
  update?: Maybe<MarketplaceUpdateAccess>
}

export type MarketplaceDocAccess = {
  __typename?: 'marketplaceDocAccess'
  create?: Maybe<MarketplaceCreateDocAccess>
  delete?: Maybe<MarketplaceDeleteDocAccess>
  fields?: Maybe<MarketplaceDocAccessFields>
  read?: Maybe<MarketplaceReadDocAccess>
  readVersions?: Maybe<MarketplaceReadVersionsDocAccess>
  update?: Maybe<MarketplaceUpdateDocAccess>
}

export type MediaAccess = {
  __typename?: 'mediaAccess'
  create?: Maybe<MediaCreateAccess>
  delete?: Maybe<MediaDeleteAccess>
  fields?: Maybe<MediaFields>
  read?: Maybe<MediaReadAccess>
  update?: Maybe<MediaUpdateAccess>
}

export type MediaDocAccess = {
  __typename?: 'mediaDocAccess'
  create?: Maybe<MediaCreateDocAccess>
  delete?: Maybe<MediaDeleteDocAccess>
  fields?: Maybe<MediaDocAccessFields>
  read?: Maybe<MediaReadDocAccess>
  update?: Maybe<MediaUpdateDocAccess>
}

export type MutationCmsArticleInput = {
  _status?: InputMaybe<CmsArticle__Status_MutationInput>
  authors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  content?: InputMaybe<MutationCmsArticle_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsArticle_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsArticle_CustomHeaderInput>
  excerpt: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  meta: MutationCmsArticle_MetaInput
  publishedAt?: InputMaybe<Scalars['String']['input']>
  ratings?: InputMaybe<Scalars['Int']['input']>
  readTimeEstimate?: InputMaybe<Scalars['Float']['input']>
  relatedArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  resourceCategory?: InputMaybe<CmsArticle_ResourceCategory_MutationInput>
  richText?: InputMaybe<Scalars['JSON']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Array<InputMaybe<MutationCmsArticle_SummaryInput>>>
  tableOfContents?: InputMaybe<Array<InputMaybe<MutationCmsArticle_TableOfContentsInput>>>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
  wordCount?: InputMaybe<Scalars['Float']['input']>
  wordpressPostId?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticleUpdateInput = {
  _status?: InputMaybe<CmsArticleUpdate__Status_MutationInput>
  authors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  content?: InputMaybe<MutationCmsArticleUpdate_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsArticleUpdate_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsArticleUpdate_CustomHeaderInput>
  excerpt?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['Int']['input']>
  meta: MutationCmsArticleUpdate_MetaInput
  publishedAt?: InputMaybe<Scalars['String']['input']>
  ratings?: InputMaybe<Scalars['Int']['input']>
  readTimeEstimate?: InputMaybe<Scalars['Float']['input']>
  relatedArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  resourceCategory?: InputMaybe<CmsArticleUpdate_ResourceCategory_MutationInput>
  richText?: InputMaybe<Scalars['JSON']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Array<InputMaybe<MutationCmsArticleUpdate_SummaryInput>>>
  tableOfContents?: InputMaybe<Array<InputMaybe<MutationCmsArticleUpdate_TableOfContentsInput>>>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  wordCount?: InputMaybe<Scalars['Float']['input']>
  wordpressPostId?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticleUpdate_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsArticleUpdate_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsArticleUpdate_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsArticleUpdate_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsArticleUpdate_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsArticleUpdate_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsArticleUpdate_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsArticleUpdate_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsArticleUpdate_CustomHeader_SupportLinkInput>
}

export type MutationCmsArticleUpdate_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsArticleUpdate_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticleUpdate_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsArticleUpdate_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsArticleUpdate_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticleUpdate_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsArticleUpdate_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsArticleUpdate_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticleUpdate_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsArticleUpdate_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsArticleUpdate_SummaryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticleUpdate_TableOfContentsInput = {
  id?: InputMaybe<Scalars['String']['input']>
  idAttribute?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticle_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsArticle_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsArticle_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsArticle_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsArticle_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsArticle_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsArticle_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsArticle_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsArticle_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsArticle_CustomHeader_SupportLinkInput>
}

export type MutationCmsArticle_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsArticle_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsArticle_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsArticle_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticle_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsArticle_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsArticle_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsArticle_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsArticle_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticle_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsArticle_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsArticle_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsArticle_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsArticle_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticle_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsArticle_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsArticle_SummaryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsArticle_TableOfContentsInput = {
  id?: InputMaybe<Scalars['String']['input']>
  idAttribute?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsAuthorInput = {
  bio?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  media?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  shortBio: Scalars['String']['input']
  slug?: InputMaybe<Scalars['String']['input']>
  socials?: InputMaybe<MutationCmsAuthor_SocialsInput>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsAuthorUpdateInput = {
  bio?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  media?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  shortBio?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  socials?: InputMaybe<MutationCmsAuthorUpdate_SocialsInput>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsAuthorUpdate_SocialsInput = {
  facebook?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  x?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsAuthor_SocialsInput = {
  facebook?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  x?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCalloutInput = {
  callout?: InputMaybe<MutationCmsCallout_CalloutInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCalloutUpdateInput = {
  callout?: InputMaybe<MutationCmsCalloutUpdate_CalloutInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCalloutUpdate_CalloutInput = {
  emphasis?: InputMaybe<CmsCalloutUpdate_Callout_Emphasis_MutationInput>
  heading?: InputMaybe<Scalars['String']['input']>
  iconName?: InputMaybe<Scalars['String']['input']>
  intent?: InputMaybe<CmsCalloutUpdate_Callout_Intent_MutationInput>
  links?: InputMaybe<Array<InputMaybe<MutationCmsCalloutUpdate_Callout_LinksInput>>>
  richText?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsCalloutUpdate_Callout_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsCalloutUpdate_Callout_Links_LinkInput>
}

export type MutationCmsCalloutUpdate_Callout_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsCalloutUpdate_Callout_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsCalloutUpdate_Callout_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsCalloutUpdate_Callout_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsCalloutUpdate_Callout_Links_Link_Variant_MutationInput>
}

export type MutationCmsCalloutUpdate_Callout_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsCallout_CalloutInput = {
  emphasis?: InputMaybe<CmsCallout_Callout_Emphasis_MutationInput>
  heading?: InputMaybe<Scalars['String']['input']>
  iconName?: InputMaybe<Scalars['String']['input']>
  intent?: InputMaybe<CmsCallout_Callout_Intent_MutationInput>
  links?: InputMaybe<Array<InputMaybe<MutationCmsCallout_Callout_LinksInput>>>
  richText?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsCallout_Callout_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsCallout_Callout_Links_LinkInput>
}

export type MutationCmsCallout_Callout_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsCallout_Callout_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsCallout_Callout_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsCallout_Callout_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsCallout_Callout_Links_Link_Variant_MutationInput>
}

export type MutationCmsCallout_Callout_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsCategoriesInput = {
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCmsCategories_BreadcrumbsInput>>>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  isPublic?: InputMaybe<Scalars['Boolean']['input']>
  parent?: InputMaybe<Scalars['Int']['input']>
  slug: Scalars['String']['input']
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCategoriesUpdateInput = {
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCmsCategoriesUpdate_BreadcrumbsInput>>>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  isPublic?: InputMaybe<Scalars['Boolean']['input']>
  parent?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCategoriesUpdate_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCategories_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCommentInput = {
  author?: InputMaybe<Scalars['Int']['input']>
  authorIp?: InputMaybe<Scalars['String']['input']>
  authorName?: InputMaybe<Scalars['String']['input']>
  authorUserAgent?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  isApproved?: InputMaybe<Scalars['Boolean']['input']>
  rejectReason?: InputMaybe<Scalars['String']['input']>
  replyComment?: InputMaybe<Scalars['Int']['input']>
  replyPost?: InputMaybe<CmsComment_ReplyPostRelationshipInput>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsCommentUpdateInput = {
  author?: InputMaybe<Scalars['Int']['input']>
  authorIp?: InputMaybe<Scalars['String']['input']>
  authorName?: InputMaybe<Scalars['String']['input']>
  authorUserAgent?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  isApproved?: InputMaybe<Scalars['Boolean']['input']>
  rejectReason?: InputMaybe<Scalars['String']['input']>
  replyComment?: InputMaybe<Scalars['Int']['input']>
  replyPost?: InputMaybe<CmsCommentUpdate_ReplyPostRelationshipInput>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFooterInput = {
  copyrightText: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['String']['input']>
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsFooter_DisclaimersInput>>>
  footerColumns?: InputMaybe<Array<InputMaybe<MutationCmsFooter_FooterColumnsInput>>>
  termsLinks?: InputMaybe<Array<InputMaybe<MutationCmsFooter_TermsLinksInput>>>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFooter_DisclaimersInput = {
  align?: InputMaybe<CmsFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsFooter_FooterColumnsInput = {
  id?: InputMaybe<Scalars['String']['input']>
  linkColumns?: InputMaybe<MutationCmsFooter_FooterColumns_LinkColumnsInput>
}

export type MutationCmsFooter_FooterColumns_LinkColumnsInput = {
  columnTitle?: InputMaybe<Scalars['String']['input']>
  links?: InputMaybe<Array<InputMaybe<MutationCmsFooter_FooterColumns_LinkColumns_LinksInput>>>
}

export type MutationCmsFooter_FooterColumns_LinkColumns_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsFooter_FooterColumns_LinkColumns_Links_LinkInput>
}

export type MutationCmsFooter_FooterColumns_LinkColumns_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsFooter_FooterColumns_LinkColumns_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsFooter_FooterColumns_LinkColumns_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsFooter_FooterColumns_LinkColumns_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFooter_FooterColumns_LinkColumns_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsFooter_TermsLinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsFooter_TermsLinks_LinkInput>
}

export type MutationCmsFooter_TermsLinks_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsFooter_TermsLinks_Link_QueryInput>>>
  reference?: InputMaybe<CmsFooter_TermsLinks_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsFooter_TermsLinks_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFooter_TermsLinks_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsFormInput = {
  _status?: InputMaybe<CmsForm__Status_MutationInput>
  confirmationMessage: Scalars['JSON']['input']
  confirmationType?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['JSON']['input']>
  emails?: InputMaybe<Array<InputMaybe<MutationCmsForm_EmailsInput>>>
  fields?: InputMaybe<Scalars['JSON']['input']>
  redirect: MutationCmsForm_RedirectInput
  slug: Scalars['String']['input']
  submitButtonLabel?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFormSubmissionInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  form?: InputMaybe<Scalars['Int']['input']>
  submissionData?: InputMaybe<Array<InputMaybe<MutationCmsFormSubmission_SubmissionDataInput>>>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFormSubmissionUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  form?: InputMaybe<Scalars['Int']['input']>
  submissionData?: InputMaybe<Array<InputMaybe<MutationCmsFormSubmissionUpdate_SubmissionDataInput>>>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFormSubmissionUpdate_SubmissionDataInput = {
  field: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  value: Scalars['String']['input']
}

export type MutationCmsFormSubmission_SubmissionDataInput = {
  field: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  value: Scalars['String']['input']
}

export type MutationCmsFormUpdateInput = {
  _status?: InputMaybe<CmsFormUpdate__Status_MutationInput>
  confirmationMessage?: InputMaybe<Scalars['JSON']['input']>
  confirmationType?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['JSON']['input']>
  emails?: InputMaybe<Array<InputMaybe<MutationCmsFormUpdate_EmailsInput>>>
  fields?: InputMaybe<Scalars['JSON']['input']>
  redirect: MutationCmsFormUpdate_RedirectInput
  slug?: InputMaybe<Scalars['String']['input']>
  submitButtonLabel?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsFormUpdate_EmailsInput = {
  bcc?: InputMaybe<Scalars['String']['input']>
  cc?: InputMaybe<Scalars['String']['input']>
  emailFrom?: InputMaybe<Scalars['String']['input']>
  emailTo?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['JSON']['input']>
  replyTo?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
}

export type MutationCmsFormUpdate_RedirectInput = {
  reference?: InputMaybe<CmsFormUpdate_Redirect_ReferenceRelationshipInput>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsForm_EmailsInput = {
  bcc?: InputMaybe<Scalars['String']['input']>
  cc?: InputMaybe<Scalars['String']['input']>
  emailFrom?: InputMaybe<Scalars['String']['input']>
  emailTo?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  message?: InputMaybe<Scalars['JSON']['input']>
  replyTo?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
}

export type MutationCmsForm_RedirectInput = {
  reference?: InputMaybe<CmsForm_Redirect_ReferenceRelationshipInput>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsGuideInput = {
  _status?: InputMaybe<CmsGuide__Status_MutationInput>
  authors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  chapters?: InputMaybe<Array<InputMaybe<MutationCmsGuide_ChaptersInput>>>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  header?: InputMaybe<Scalars['JSON']['input']>
  intro?: InputMaybe<Scalars['JSON']['input']>
  media?: InputMaybe<Scalars['Int']['input']>
  meta: MutationCmsGuide_MetaInput
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  timeEstimate?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsGuideUpdateInput = {
  _status?: InputMaybe<CmsGuideUpdate__Status_MutationInput>
  authors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  chapters?: InputMaybe<Array<InputMaybe<MutationCmsGuideUpdate_ChaptersInput>>>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  header?: InputMaybe<Scalars['JSON']['input']>
  intro?: InputMaybe<Scalars['JSON']['input']>
  media?: InputMaybe<Scalars['Int']['input']>
  meta: MutationCmsGuideUpdate_MetaInput
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  timeEstimate?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsGuideUpdate_ChaptersInput = {
  id?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['Int']['input']>
  link?: InputMaybe<MutationCmsGuideUpdate_Chapters_LinkInput>
  title?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsGuideUpdate_Chapters_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsGuideUpdate_Chapters_Link_QueryInput>>>
  reference?: InputMaybe<CmsGuideUpdate_Chapters_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsGuideUpdate_Chapters_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsGuideUpdate_Chapters_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsGuideUpdate_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsGuide_ChaptersInput = {
  id?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['Int']['input']>
  link?: InputMaybe<MutationCmsGuide_Chapters_LinkInput>
  title?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsGuide_Chapters_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsGuide_Chapters_Link_QueryInput>>>
  reference?: InputMaybe<CmsGuide_Chapters_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsGuide_Chapters_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsGuide_Chapters_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsGuide_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsHeaderInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  loginLink: MutationCmsHeader_LoginLinkInput
  nav?: InputMaybe<Array<InputMaybe<MutationCmsHeader_NavInput>>>
  signupLink: MutationCmsHeader_SignupLinkInput
  supportLink: MutationCmsHeader_SupportLinkInput
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsHeader_NavInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsHeader_Nav_LinkInput>
  submenu: MutationCmsHeader_Nav_SubmenuInput
  title: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type MutationCmsHeader_Nav_LinkInput = {
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsHeader_Nav_Link_QueryInput>>>
  reference?: InputMaybe<CmsHeader_Nav_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsHeader_Nav_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsHeader_Nav_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsHeader_Nav_SubmenuInput = {
  categories?: InputMaybe<Array<InputMaybe<MutationCmsHeader_Nav_Submenu_CategoriesInput>>>
}

export type MutationCmsHeader_Nav_Submenu_CategoriesInput = {
  id?: InputMaybe<Scalars['String']['input']>
  items?: InputMaybe<Array<InputMaybe<MutationCmsHeader_Nav_Submenu_Categories_ItemsInput>>>
  name: Scalars['String']['input']
}

export type MutationCmsHeader_Nav_Submenu_Categories_ItemsInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  link: MutationCmsHeader_Nav_Submenu_Categories_Items_LinkInput
  title: Scalars['String']['input']
}

export type MutationCmsHeader_Nav_Submenu_Categories_Items_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsHeader_Nav_Submenu_Categories_Items_Link_QueryInput>>>
  reference?: InputMaybe<CmsHeader_Nav_Submenu_Categories_Items_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsHeader_Nav_Submenu_Categories_Items_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsHeader_Nav_Submenu_Categories_Items_Link_Variant_MutationInput>
}

export type MutationCmsHeader_Nav_Submenu_Categories_Items_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsLegalInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  description: Scalars['String']['input']
  richText?: InputMaybe<Scalars['JSON']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsLegalUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsLinksInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
  url: Scalars['String']['input']
}

export type MutationCmsLinksUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsLiteEmbeddedMarketplaceInput = {
  _status?: InputMaybe<CmsLiteEmbeddedMarketplace__Status_MutationInput>
  affiliateCode?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  logo?: InputMaybe<Scalars['Int']['input']>
  logoHref?: InputMaybe<Scalars['String']['input']>
  meta: MutationCmsLiteEmbeddedMarketplace_MetaInput
  offerCategories?: InputMaybe<Array<InputMaybe<MutationCmsLiteEmbeddedMarketplace_OfferCategoriesInput>>>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsLiteEmbeddedMarketplaceUpdateInput = {
  _status?: InputMaybe<CmsLiteEmbeddedMarketplaceUpdate__Status_MutationInput>
  affiliateCode?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  logo?: InputMaybe<Scalars['Int']['input']>
  logoHref?: InputMaybe<Scalars['String']['input']>
  meta: MutationCmsLiteEmbeddedMarketplaceUpdate_MetaInput
  offerCategories?: InputMaybe<Array<InputMaybe<MutationCmsLiteEmbeddedMarketplaceUpdate_OfferCategoriesInput>>>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsLiteEmbeddedMarketplaceUpdate_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsLiteEmbeddedMarketplaceUpdate_OfferCategoriesInput = {
  category: CmsLiteEmbeddedMarketplaceUpdate_OfferCategories_Category_MutationInput
  collection: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
}

export type MutationCmsLiteEmbeddedMarketplace_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsLiteEmbeddedMarketplace_OfferCategoriesInput = {
  category: CmsLiteEmbeddedMarketplace_OfferCategories_Category_MutationInput
  collection: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
}

export type MutationCmsMarketplacePageInput = {
  _status?: InputMaybe<CmsMarketplacePage__Status_MutationInput>
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePage_BreadcrumbsInput>>>
  content?: InputMaybe<MutationCmsMarketplacePage_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsMarketplacePage_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsMarketplacePage_CustomHeaderInput>
  hero?: InputMaybe<MutationCmsMarketplacePage_HeroInput>
  meta: MutationCmsMarketplacePage_MetaInput
  offerCategory: CmsMarketplacePage_OfferCategory_MutationInput
  parent?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePageUpdateInput = {
  _status?: InputMaybe<CmsMarketplacePageUpdate__Status_MutationInput>
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePageUpdate_BreadcrumbsInput>>>
  content?: InputMaybe<MutationCmsMarketplacePageUpdate_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsMarketplacePageUpdate_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsMarketplacePageUpdate_CustomHeaderInput>
  hero?: InputMaybe<MutationCmsMarketplacePageUpdate_HeroInput>
  meta: MutationCmsMarketplacePageUpdate_MetaInput
  offerCategory?: InputMaybe<CmsMarketplacePageUpdate_OfferCategory_MutationInput>
  parent?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePageUpdate_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePageUpdate_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsMarketplacePageUpdate_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePageUpdate_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsMarketplacePageUpdate_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsMarketplacePageUpdate_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsMarketplacePageUpdate_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsMarketplacePageUpdate_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsMarketplacePageUpdate_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsMarketplacePageUpdate_CustomHeader_SupportLinkInput>
}

export type MutationCmsMarketplacePageUpdate_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePageUpdate_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePageUpdate_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePageUpdate_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePageUpdate_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePageUpdate_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePageUpdate_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePageUpdate_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePageUpdate_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePageUpdate_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePageUpdate_HeroInput = {
  desktopFallback?: InputMaybe<Scalars['Int']['input']>
  desktopVideo?: InputMaybe<Scalars['Int']['input']>
  disclaimerText?: InputMaybe<Scalars['String']['input']>
  heroSize?: InputMaybe<Scalars['String']['input']>
  hzAlign?: InputMaybe<CmsMarketplacePageUpdate_Hero_HzAlign_MutationInput>
  links?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePageUpdate_Hero_LinksInput>>>
  media?: InputMaybe<Scalars['Int']['input']>
  mobileFallback?: InputMaybe<Scalars['Int']['input']>
  mobileVideo?: InputMaybe<Scalars['Int']['input']>
  productImage?: InputMaybe<Scalars['Int']['input']>
  reviewRating?: InputMaybe<Scalars['Float']['input']>
  reviewText?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  richTextMax?: InputMaybe<Scalars['Float']['input']>
  showReviews?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<CmsMarketplacePageUpdate_Hero_Type_MutationInput>
  vertAlign?: InputMaybe<CmsMarketplacePageUpdate_Hero_VertAlign_MutationInput>
}

export type MutationCmsMarketplacePageUpdate_Hero_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsMarketplacePageUpdate_Hero_Links_LinkInput>
}

export type MutationCmsMarketplacePageUpdate_Hero_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePageUpdate_Hero_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePageUpdate_Hero_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePageUpdate_Hero_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsMarketplacePageUpdate_Hero_Links_Link_Variant_MutationInput>
}

export type MutationCmsMarketplacePageUpdate_Hero_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePageUpdate_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsMarketplacePage_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePage_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsMarketplacePage_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePage_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsMarketplacePage_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsMarketplacePage_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsMarketplacePage_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsMarketplacePage_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsMarketplacePage_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsMarketplacePage_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsMarketplacePage_CustomHeader_SupportLinkInput>
}

export type MutationCmsMarketplacePage_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePage_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePage_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePage_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePage_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePage_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePage_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePage_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePage_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePage_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePage_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePage_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePage_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePage_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsMarketplacePage_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePage_HeroInput = {
  desktopFallback?: InputMaybe<Scalars['Int']['input']>
  desktopVideo?: InputMaybe<Scalars['Int']['input']>
  disclaimerText?: InputMaybe<Scalars['String']['input']>
  heroSize?: InputMaybe<Scalars['String']['input']>
  hzAlign?: InputMaybe<CmsMarketplacePage_Hero_HzAlign_MutationInput>
  links?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePage_Hero_LinksInput>>>
  media?: InputMaybe<Scalars['Int']['input']>
  mobileFallback?: InputMaybe<Scalars['Int']['input']>
  mobileVideo?: InputMaybe<Scalars['Int']['input']>
  productImage?: InputMaybe<Scalars['Int']['input']>
  reviewRating?: InputMaybe<Scalars['Float']['input']>
  reviewText?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  richTextMax?: InputMaybe<Scalars['Float']['input']>
  showReviews?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<CmsMarketplacePage_Hero_Type_MutationInput>
  vertAlign?: InputMaybe<CmsMarketplacePage_Hero_VertAlign_MutationInput>
}

export type MutationCmsMarketplacePage_Hero_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsMarketplacePage_Hero_Links_LinkInput>
}

export type MutationCmsMarketplacePage_Hero_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsMarketplacePage_Hero_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsMarketplacePage_Hero_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsMarketplacePage_Hero_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsMarketplacePage_Hero_Links_Link_Variant_MutationInput>
}

export type MutationCmsMarketplacePage_Hero_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsMarketplacePage_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsMediaInput = {
  alt: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  focalX?: InputMaybe<Scalars['Float']['input']>
  focalY?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  prefix?: InputMaybe<Scalars['String']['input']>
  sizes?: InputMaybe<MutationCmsMedia_SizesInput>
  thumbnailURL?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdateInput = {
  alt?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  focalX?: InputMaybe<Scalars['Float']['input']>
  focalY?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  prefix?: InputMaybe<Scalars['String']['input']>
  sizes?: InputMaybe<MutationCmsMediaUpdate_SizesInput>
  thumbnailURL?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_SizesInput = {
  banner?: InputMaybe<MutationCmsMediaUpdate_Sizes_BannerInput>
  card?: InputMaybe<MutationCmsMediaUpdate_Sizes_CardInput>
  feature?: InputMaybe<MutationCmsMediaUpdate_Sizes_FeatureInput>
  largeAutoHeight?: InputMaybe<MutationCmsMediaUpdate_Sizes_LargeAutoHeightInput>
  largeHero?: InputMaybe<MutationCmsMediaUpdate_Sizes_LargeHeroInput>
  portrait?: InputMaybe<MutationCmsMediaUpdate_Sizes_PortraitInput>
  smallAutoHeight?: InputMaybe<MutationCmsMediaUpdate_Sizes_SmallAutoHeightInput>
  square?: InputMaybe<MutationCmsMediaUpdate_Sizes_SquareInput>
  squareThumbnail?: InputMaybe<MutationCmsMediaUpdate_Sizes_SquareThumbnailInput>
}

export type MutationCmsMediaUpdate_Sizes_BannerInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_CardInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_FeatureInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_LargeAutoHeightInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_LargeHeroInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_PortraitInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_SmallAutoHeightInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_SquareInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMediaUpdate_Sizes_SquareThumbnailInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_SizesInput = {
  banner?: InputMaybe<MutationCmsMedia_Sizes_BannerInput>
  card?: InputMaybe<MutationCmsMedia_Sizes_CardInput>
  feature?: InputMaybe<MutationCmsMedia_Sizes_FeatureInput>
  largeAutoHeight?: InputMaybe<MutationCmsMedia_Sizes_LargeAutoHeightInput>
  largeHero?: InputMaybe<MutationCmsMedia_Sizes_LargeHeroInput>
  portrait?: InputMaybe<MutationCmsMedia_Sizes_PortraitInput>
  smallAutoHeight?: InputMaybe<MutationCmsMedia_Sizes_SmallAutoHeightInput>
  square?: InputMaybe<MutationCmsMedia_Sizes_SquareInput>
  squareThumbnail?: InputMaybe<MutationCmsMedia_Sizes_SquareThumbnailInput>
}

export type MutationCmsMedia_Sizes_BannerInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_CardInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_FeatureInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_LargeAutoHeightInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_LargeHeroInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_PortraitInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_SmallAutoHeightInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_SquareInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsMedia_Sizes_SquareThumbnailInput = {
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsNewsroomArticleInput = {
  _status?: InputMaybe<CmsNewsroomArticle__Status_MutationInput>
  authors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  content?: InputMaybe<MutationCmsNewsroomArticle_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsNewsroomArticle_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsNewsroomArticle_CustomHeaderInput>
  excerpt: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  meta: MutationCmsNewsroomArticle_MetaInput
  publishedAt?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
  wordpressPostId?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticleUpdateInput = {
  _status?: InputMaybe<CmsNewsroomArticleUpdate__Status_MutationInput>
  authors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  content?: InputMaybe<MutationCmsNewsroomArticleUpdate_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsNewsroomArticleUpdate_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsNewsroomArticleUpdate_CustomHeaderInput>
  excerpt?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['Int']['input']>
  meta: MutationCmsNewsroomArticleUpdate_MetaInput
  publishedAt?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  wordpressPostId?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticleUpdate_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsNewsroomArticleUpdate_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticleUpdate_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsNewsroomArticleUpdate_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsNewsroomArticleUpdate_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsNewsroomArticleUpdate_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsNewsroomArticleUpdate_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsNewsroomArticleUpdate_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsNewsroomArticleUpdate_CustomHeader_SupportLinkInput>
}

export type MutationCmsNewsroomArticleUpdate_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticleUpdate_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticleUpdate_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsNewsroomArticleUpdate_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticleUpdate_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticleUpdate_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsNewsroomArticleUpdate_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticleUpdate_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsNewsroomArticleUpdate_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticleUpdate_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsNewsroomArticleUpdate_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsNewsroomArticle_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsNewsroomArticle_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticle_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsNewsroomArticle_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsNewsroomArticle_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsNewsroomArticle_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsNewsroomArticle_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsNewsroomArticle_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsNewsroomArticle_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsNewsroomArticle_CustomHeader_SupportLinkInput>
}

export type MutationCmsNewsroomArticle_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticle_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsNewsroomArticle_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticle_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsNewsroomArticle_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticle_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsNewsroomArticle_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticle_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsNewsroomArticle_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsNewsroomArticle_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsNewsroomArticle_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsNewsroomArticle_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsNewsroomArticle_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsNewsroomArticle_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsPageInput = {
  _status?: InputMaybe<CmsPage__Status_MutationInput>
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCmsPage_BreadcrumbsInput>>>
  content?: InputMaybe<MutationCmsPage_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsPage_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsPage_CustomHeaderInput>
  hero?: InputMaybe<MutationCmsPage_HeroInput>
  meta: MutationCmsPage_MetaInput
  parent?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPageUpdateInput = {
  _status?: InputMaybe<CmsPageUpdate__Status_MutationInput>
  breadcrumbs?: InputMaybe<Array<InputMaybe<MutationCmsPageUpdate_BreadcrumbsInput>>>
  content?: InputMaybe<MutationCmsPageUpdate_ContentInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  customFooter?: InputMaybe<MutationCmsPageUpdate_CustomFooterInput>
  customHeader?: InputMaybe<MutationCmsPageUpdate_CustomHeaderInput>
  hero?: InputMaybe<MutationCmsPageUpdate_HeroInput>
  meta: MutationCmsPageUpdate_MetaInput
  parent?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPageUpdate_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPageUpdate_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsPageUpdate_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsPageUpdate_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsPageUpdate_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsPageUpdate_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsPageUpdate_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsPageUpdate_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsPageUpdate_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsPageUpdate_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsPageUpdate_CustomHeader_SupportLinkInput>
}

export type MutationCmsPageUpdate_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPageUpdate_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsPageUpdate_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPageUpdate_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPageUpdate_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPageUpdate_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPageUpdate_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsPageUpdate_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPageUpdate_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPageUpdate_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPageUpdate_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPageUpdate_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsPageUpdate_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPageUpdate_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPageUpdate_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPageUpdate_HeroInput = {
  desktopFallback?: InputMaybe<Scalars['Int']['input']>
  desktopVideo?: InputMaybe<Scalars['Int']['input']>
  disclaimerText?: InputMaybe<Scalars['String']['input']>
  heroSize?: InputMaybe<Scalars['String']['input']>
  hzAlign?: InputMaybe<CmsPageUpdate_Hero_HzAlign_MutationInput>
  links?: InputMaybe<Array<InputMaybe<MutationCmsPageUpdate_Hero_LinksInput>>>
  media?: InputMaybe<Scalars['Int']['input']>
  mobileFallback?: InputMaybe<Scalars['Int']['input']>
  mobileVideo?: InputMaybe<Scalars['Int']['input']>
  productImage?: InputMaybe<Scalars['Int']['input']>
  reviewRating?: InputMaybe<Scalars['Float']['input']>
  reviewText?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  richTextMax?: InputMaybe<Scalars['Float']['input']>
  showReviews?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<CmsPageUpdate_Hero_Type_MutationInput>
  vertAlign?: InputMaybe<CmsPageUpdate_Hero_VertAlign_MutationInput>
}

export type MutationCmsPageUpdate_Hero_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsPageUpdate_Hero_Links_LinkInput>
}

export type MutationCmsPageUpdate_Hero_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPageUpdate_Hero_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsPageUpdate_Hero_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPageUpdate_Hero_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsPageUpdate_Hero_Links_Link_Variant_MutationInput>
}

export type MutationCmsPageUpdate_Hero_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPageUpdate_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsPage_BreadcrumbsInput = {
  doc?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPage_ContentInput = {
  layout?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationCmsPage_CustomFooterInput = {
  disclaimers?: InputMaybe<Array<InputMaybe<MutationCmsPage_CustomFooter_DisclaimersInput>>>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationCmsPage_CustomFooter_DisclaimersInput = {
  align?: InputMaybe<CmsPage_CustomFooter_Disclaimers_Align_MutationInput>
  id?: InputMaybe<Scalars['String']['input']>
  includeAsterick?: InputMaybe<Scalars['Boolean']['input']>
  number?: InputMaybe<Scalars['Float']['input']>
  text?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsPage_CustomHeaderInput = {
  headerDisplay?: InputMaybe<CmsPage_CustomHeader_HeaderDisplay_MutationInput>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  loginLink?: InputMaybe<MutationCmsPage_CustomHeader_LoginLinkInput>
  signupLink?: InputMaybe<MutationCmsPage_CustomHeader_SignupLinkInput>
  supportLink?: InputMaybe<MutationCmsPage_CustomHeader_SupportLinkInput>
}

export type MutationCmsPage_CustomHeader_LoginLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPage_CustomHeader_LoginLink_QueryInput>>>
  reference?: InputMaybe<CmsPage_CustomHeader_LoginLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPage_CustomHeader_LoginLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPage_CustomHeader_LoginLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPage_CustomHeader_SignupLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPage_CustomHeader_SignupLink_QueryInput>>>
  reference?: InputMaybe<CmsPage_CustomHeader_SignupLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPage_CustomHeader_SignupLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPage_CustomHeader_SignupLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPage_CustomHeader_SupportLinkInput = {
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPage_CustomHeader_SupportLink_QueryInput>>>
  reference?: InputMaybe<CmsPage_CustomHeader_SupportLink_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPage_CustomHeader_SupportLink_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPage_CustomHeader_SupportLink_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPage_HeroInput = {
  desktopFallback?: InputMaybe<Scalars['Int']['input']>
  desktopVideo?: InputMaybe<Scalars['Int']['input']>
  disclaimerText?: InputMaybe<Scalars['String']['input']>
  heroSize?: InputMaybe<Scalars['String']['input']>
  hzAlign?: InputMaybe<CmsPage_Hero_HzAlign_MutationInput>
  links?: InputMaybe<Array<InputMaybe<MutationCmsPage_Hero_LinksInput>>>
  media?: InputMaybe<Scalars['Int']['input']>
  mobileFallback?: InputMaybe<Scalars['Int']['input']>
  mobileVideo?: InputMaybe<Scalars['Int']['input']>
  productImage?: InputMaybe<Scalars['Int']['input']>
  reviewRating?: InputMaybe<Scalars['Float']['input']>
  reviewText?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  richTextMax?: InputMaybe<Scalars['Float']['input']>
  showReviews?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<CmsPage_Hero_Type_MutationInput>
  vertAlign?: InputMaybe<CmsPage_Hero_VertAlign_MutationInput>
}

export type MutationCmsPage_Hero_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsPage_Hero_Links_LinkInput>
}

export type MutationCmsPage_Hero_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsPage_Hero_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsPage_Hero_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsPage_Hero_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsPage_Hero_Links_Link_Variant_MutationInput>
}

export type MutationCmsPage_Hero_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsPage_MetaInput = {
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  jsonLD?: InputMaybe<Scalars['String']['input']>
  noIndex?: InputMaybe<Scalars['Boolean']['input']>
  title: Scalars['String']['input']
}

export type MutationCmsPricingInput = {
  buttonText: Scalars['String']['input']
  buttonUrl: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  features?: InputMaybe<Array<InputMaybe<MutationCmsPricing_FeaturesInput>>>
  includes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  isPopular?: InputMaybe<Scalars['Boolean']['input']>
  popularText?: InputMaybe<Scalars['String']['input']>
  priceMonthly: Scalars['Float']['input']
  priceQuarterly: Scalars['Float']['input']
  priceYearly: Scalars['Float']['input']
  tierDescription: Scalars['String']['input']
  tierName: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPricingUpdateInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>
  buttonUrl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  features?: InputMaybe<Array<InputMaybe<MutationCmsPricingUpdate_FeaturesInput>>>
  includes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  isPopular?: InputMaybe<Scalars['Boolean']['input']>
  popularText?: InputMaybe<Scalars['String']['input']>
  priceMonthly?: InputMaybe<Scalars['Float']['input']>
  priceQuarterly?: InputMaybe<Scalars['Float']['input']>
  priceYearly?: InputMaybe<Scalars['Float']['input']>
  tierDescription?: InputMaybe<Scalars['String']['input']>
  tierName?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsPricingUpdate_FeaturesInput = {
  disclaimer?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  text: Scalars['JSON']['input']
}

export type MutationCmsPricing_FeaturesInput = {
  disclaimer?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  text: Scalars['JSON']['input']
}

export type MutationCmsRatingInput = {
  average?: InputMaybe<Scalars['Float']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  fiveStar?: InputMaybe<Scalars['Float']['input']>
  fourStar?: InputMaybe<Scalars['Float']['input']>
  oneStar?: InputMaybe<Scalars['Float']['input']>
  threeStar?: InputMaybe<Scalars['Float']['input']>
  total?: InputMaybe<Scalars['Float']['input']>
  twoStar?: InputMaybe<Scalars['Float']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsRatingUpdateInput = {
  average?: InputMaybe<Scalars['Float']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  fiveStar?: InputMaybe<Scalars['Float']['input']>
  fourStar?: InputMaybe<Scalars['Float']['input']>
  oneStar?: InputMaybe<Scalars['Float']['input']>
  threeStar?: InputMaybe<Scalars['Float']['input']>
  total?: InputMaybe<Scalars['Float']['input']>
  twoStar?: InputMaybe<Scalars['Float']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsRedirectInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  from: Scalars['String']['input']
  permanent?: InputMaybe<Scalars['Boolean']['input']>
  to: MutationCmsRedirect_ToInput
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsRedirectUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  from?: InputMaybe<Scalars['String']['input']>
  permanent?: InputMaybe<Scalars['Boolean']['input']>
  to: MutationCmsRedirectUpdate_ToInput
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsRedirectUpdate_ToInput = {
  reference?: InputMaybe<CmsRedirectUpdate_To_ReferenceRelationshipInput>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsRedirect_ToInput = {
  reference?: InputMaybe<CmsRedirect_To_ReferenceRelationshipInput>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsSettingsInput = {
  articlesPage?: InputMaybe<Scalars['Int']['input']>
  blog?: InputMaybe<MutationCmsSettings_BlogInput>
  createdAt?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['Int']['input']>
  newsroom?: InputMaybe<MutationCmsSettings_NewsroomInput>
  sameAs?: InputMaybe<Array<InputMaybe<MutationCmsSettings_SameAsInput>>>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsSettings_BlogInput = {
  featuredArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  filterCategories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  popularArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type MutationCmsSettings_NewsroomInput = {
  hero?: InputMaybe<MutationCmsSettings_Newsroom_HeroInput>
}

export type MutationCmsSettings_Newsroom_HeroInput = {
  desktopFallback?: InputMaybe<Scalars['Int']['input']>
  desktopVideo?: InputMaybe<Scalars['Int']['input']>
  disclaimerText?: InputMaybe<Scalars['String']['input']>
  heroSize?: InputMaybe<Scalars['String']['input']>
  hzAlign?: InputMaybe<CmsSettings_Newsroom_Hero_HzAlign_MutationInput>
  links?: InputMaybe<Array<InputMaybe<MutationCmsSettings_Newsroom_Hero_LinksInput>>>
  media?: InputMaybe<Scalars['Int']['input']>
  mobileFallback?: InputMaybe<Scalars['Int']['input']>
  mobileVideo?: InputMaybe<Scalars['Int']['input']>
  productImage?: InputMaybe<Scalars['Int']['input']>
  reviewRating?: InputMaybe<Scalars['Float']['input']>
  reviewText?: InputMaybe<Scalars['String']['input']>
  richText?: InputMaybe<Scalars['JSON']['input']>
  richTextMax?: InputMaybe<Scalars['Float']['input']>
  showReviews?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<CmsSettings_Newsroom_Hero_Type_MutationInput>
  vertAlign?: InputMaybe<CmsSettings_Newsroom_Hero_VertAlign_MutationInput>
}

export type MutationCmsSettings_Newsroom_Hero_LinksInput = {
  id?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<MutationCmsSettings_Newsroom_Hero_Links_LinkInput>
}

export type MutationCmsSettings_Newsroom_Hero_Links_LinkInput = {
  iconAfter?: InputMaybe<Scalars['String']['input']>
  iconBefore?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  query?: InputMaybe<Array<InputMaybe<MutationCmsSettings_Newsroom_Hero_Links_Link_QueryInput>>>
  reference?: InputMaybe<CmsSettings_Newsroom_Hero_Links_Link_ReferenceRelationshipInput>
  reusable?: InputMaybe<CmsSettings_Newsroom_Hero_Links_Link_ReusableRelationshipInput>
  targetId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<CmsSettings_Newsroom_Hero_Links_Link_Variant_MutationInput>
}

export type MutationCmsSettings_Newsroom_Hero_Links_Link_QueryInput = {
  id?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type MutationCmsSettings_SameAsInput = {
  id?: InputMaybe<Scalars['String']['input']>
  value: Scalars['String']['input']
}

export type MutationCmsStackerPageInput = {
  _status?: InputMaybe<CmsStackerPage__Status_MutationInput>
  affiliateCode?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  offerCategories?: InputMaybe<Array<InputMaybe<MutationCmsStackerPage_OfferCategoriesInput>>>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsStackerPageUpdateInput = {
  _status?: InputMaybe<CmsStackerPageUpdate__Status_MutationInput>
  affiliateCode?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  offerCategories?: InputMaybe<Array<InputMaybe<MutationCmsStackerPageUpdate_OfferCategoriesInput>>>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsStackerPageUpdate_OfferCategoriesInput = {
  category: CmsStackerPageUpdate_OfferCategories_Category_MutationInput
  collection: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
}

export type MutationCmsStackerPage_OfferCategoriesInput = {
  category: CmsStackerPage_OfferCategories_Category_MutationInput
  collection: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
}

export type MutationCmsTradeCreditProgramInput = {
  _status?: InputMaybe<CmsTradeCreditProgram__Status_MutationInput>
  applyUrl: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  creditLimitHighCents?: InputMaybe<Scalars['Float']['input']>
  creditLimitLowCents?: InputMaybe<Scalars['Float']['input']>
  description: Scalars['String']['input']
  fees?: InputMaybe<Array<InputMaybe<MutationCmsTradeCreditProgram_FeesInput>>>
  minReqs?: InputMaybe<Array<InputMaybe<MutationCmsTradeCreditProgram_MinReqsInput>>>
  notes?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  reportsTo?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgram_ReportsTo_MutationInput>>>
  slug?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  terms?: InputMaybe<Array<InputMaybe<MutationCmsTradeCreditProgram_TermsInput>>>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
  vendor?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsTradeCreditProgramTagInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsTradeCreditProgramTagUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsTradeCreditProgramUpdateInput = {
  _status?: InputMaybe<CmsTradeCreditProgramUpdate__Status_MutationInput>
  applyUrl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  creditLimitHighCents?: InputMaybe<Scalars['Float']['input']>
  creditLimitLowCents?: InputMaybe<Scalars['Float']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  fees?: InputMaybe<Array<InputMaybe<MutationCmsTradeCreditProgramUpdate_FeesInput>>>
  minReqs?: InputMaybe<Array<InputMaybe<MutationCmsTradeCreditProgramUpdate_MinReqsInput>>>
  notes?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  reportsTo?: InputMaybe<Array<InputMaybe<CmsTradeCreditProgramUpdate_ReportsTo_MutationInput>>>
  slug?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  terms?: InputMaybe<Array<InputMaybe<MutationCmsTradeCreditProgramUpdate_TermsInput>>>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  vendor?: InputMaybe<Scalars['Int']['input']>
}

export type MutationCmsTradeCreditProgramUpdate_FeesInput = {
  amountHighCents?: InputMaybe<Scalars['Float']['input']>
  amountLowCents: Scalars['Float']['input']
  id?: InputMaybe<Scalars['String']['input']>
  paymentPeriod: CmsTradeCreditProgramUpdate_Fees_PaymentPeriod_MutationInput
}

export type MutationCmsTradeCreditProgramUpdate_MinReqsInput = {
  amountCents: Scalars['Float']['input']
  id?: InputMaybe<Scalars['String']['input']>
  orderUnit: CmsTradeCreditProgramUpdate_MinReqs_OrderUnit_MutationInput
}

export type MutationCmsTradeCreditProgramUpdate_TermsInput = {
  discountDurationDays: Scalars['Float']['input']
  discountPercentage: Scalars['Float']['input']
  id?: InputMaybe<Scalars['String']['input']>
  netDueAfterDays: Scalars['Float']['input']
}

export type MutationCmsTradeCreditProgram_FeesInput = {
  amountHighCents?: InputMaybe<Scalars['Float']['input']>
  amountLowCents: Scalars['Float']['input']
  id?: InputMaybe<Scalars['String']['input']>
  paymentPeriod: CmsTradeCreditProgram_Fees_PaymentPeriod_MutationInput
}

export type MutationCmsTradeCreditProgram_MinReqsInput = {
  amountCents: Scalars['Float']['input']
  id?: InputMaybe<Scalars['String']['input']>
  orderUnit: CmsTradeCreditProgram_MinReqs_OrderUnit_MutationInput
}

export type MutationCmsTradeCreditProgram_TermsInput = {
  discountDurationDays: Scalars['Float']['input']
  discountPercentage: Scalars['Float']['input']
  id?: InputMaybe<Scalars['String']['input']>
  netDueAfterDays: Scalars['Float']['input']
}

export type MutationCmsTradeCreditRecommendationInput = {
  _status?: InputMaybe<CmsTradeCreditRecommendation__Status_MutationInput>
  applyUrl: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  description: Scalars['String']['input']
  image?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsTradeCreditRecommendationUpdateInput = {
  _status?: InputMaybe<CmsTradeCreditRecommendationUpdate__Status_MutationInput>
  applyUrl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsTradeCreditVendorInput = {
  _status?: InputMaybe<CmsTradeCreditVendor__Status_MutationInput>
  active?: InputMaybe<Scalars['Boolean']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  logo?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['String']['input']>
  websiteUrl: Scalars['String']['input']
}

export type MutationCmsTradeCreditVendorUpdateInput = {
  _status?: InputMaybe<CmsTradeCreditVendorUpdate__Status_MutationInput>
  active?: InputMaybe<Scalars['Boolean']['input']>
  createdAt?: InputMaybe<Scalars['String']['input']>
  createdBy?: InputMaybe<Scalars['Int']['input']>
  logo?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsUserInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  hash?: InputMaybe<Scalars['String']['input']>
  lockUntil?: InputMaybe<Scalars['String']['input']>
  loginAttempts?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  resetPasswordExpiration?: InputMaybe<Scalars['String']['input']>
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>
  roles?: InputMaybe<Array<InputMaybe<CmsUser_Roles_MutationInput>>>
  salt?: InputMaybe<Scalars['String']['input']>
  sub?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsUserUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  hash?: InputMaybe<Scalars['String']['input']>
  lockUntil?: InputMaybe<Scalars['String']['input']>
  loginAttempts?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  resetPasswordExpiration?: InputMaybe<Scalars['String']['input']>
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>
  roles?: InputMaybe<Array<InputMaybe<CmsUserUpdate_Roles_MutationInput>>>
  salt?: InputMaybe<Scalars['String']['input']>
  sub?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
}

export type MutationCmsVideoInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  focalX?: InputMaybe<Scalars['Float']['input']>
  focalY?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  prefix?: InputMaybe<Scalars['String']['input']>
  thumbnailURL?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationCmsVideoUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Float']['input']>
  focalX?: InputMaybe<Scalars['Float']['input']>
  focalY?: InputMaybe<Scalars['Float']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  prefix?: InputMaybe<Scalars['String']['input']>
  thumbnailURL?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

export type MutationPayloadLockedDocumentInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  document?: InputMaybe<PayloadLockedDocument_DocumentRelationshipInput>
  globalSlug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<PayloadLockedDocument_UserRelationshipInput>
}

export type MutationPayloadLockedDocumentUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  document?: InputMaybe<PayloadLockedDocumentUpdate_DocumentRelationshipInput>
  globalSlug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<PayloadLockedDocumentUpdate_UserRelationshipInput>
}

export type MutationPayloadPreferenceInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<PayloadPreference_UserRelationshipInput>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export type MutationPayloadPreferenceUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<PayloadPreferenceUpdate_UserRelationshipInput>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export type NewsroomAccess = {
  __typename?: 'newsroomAccess'
  create?: Maybe<NewsroomCreateAccess>
  delete?: Maybe<NewsroomDeleteAccess>
  fields?: Maybe<NewsroomFields>
  read?: Maybe<NewsroomReadAccess>
  readVersions?: Maybe<NewsroomReadVersionsAccess>
  update?: Maybe<NewsroomUpdateAccess>
}

export type NewsroomDocAccess = {
  __typename?: 'newsroomDocAccess'
  create?: Maybe<NewsroomCreateDocAccess>
  delete?: Maybe<NewsroomDeleteDocAccess>
  fields?: Maybe<NewsroomDocAccessFields>
  read?: Maybe<NewsroomReadDocAccess>
  readVersions?: Maybe<NewsroomReadVersionsDocAccess>
  update?: Maybe<NewsroomUpdateDocAccess>
}

export type PagesAccess = {
  __typename?: 'pagesAccess'
  create?: Maybe<PagesCreateAccess>
  delete?: Maybe<PagesDeleteAccess>
  fields?: Maybe<PagesFields>
  read?: Maybe<PagesReadAccess>
  readVersions?: Maybe<PagesReadVersionsAccess>
  update?: Maybe<PagesUpdateAccess>
}

export type PagesDocAccess = {
  __typename?: 'pagesDocAccess'
  create?: Maybe<PagesCreateDocAccess>
  delete?: Maybe<PagesDeleteDocAccess>
  fields?: Maybe<PagesDocAccessFields>
  read?: Maybe<PagesReadDocAccess>
  readVersions?: Maybe<PagesReadVersionsDocAccess>
  update?: Maybe<PagesUpdateDocAccess>
}

export type Payload_Locked_DocumentsAccess = {
  __typename?: 'payload_locked_documentsAccess'
  create?: Maybe<PayloadLockedDocumentsCreateAccess>
  delete?: Maybe<PayloadLockedDocumentsDeleteAccess>
  fields?: Maybe<PayloadLockedDocumentsFields>
  read?: Maybe<PayloadLockedDocumentsReadAccess>
  update?: Maybe<PayloadLockedDocumentsUpdateAccess>
}

export type Payload_Locked_DocumentsDocAccess = {
  __typename?: 'payload_locked_documentsDocAccess'
  create?: Maybe<PayloadLockedDocumentsCreateDocAccess>
  delete?: Maybe<PayloadLockedDocumentsDeleteDocAccess>
  fields?: Maybe<PayloadLockedDocumentsDocAccessFields>
  read?: Maybe<PayloadLockedDocumentsReadDocAccess>
  update?: Maybe<PayloadLockedDocumentsUpdateDocAccess>
}

export type Payload_PreferencesAccess = {
  __typename?: 'payload_preferencesAccess'
  create?: Maybe<PayloadPreferencesCreateAccess>
  delete?: Maybe<PayloadPreferencesDeleteAccess>
  fields?: Maybe<PayloadPreferencesFields>
  read?: Maybe<PayloadPreferencesReadAccess>
  update?: Maybe<PayloadPreferencesUpdateAccess>
}

export type Payload_PreferencesDocAccess = {
  __typename?: 'payload_preferencesDocAccess'
  create?: Maybe<PayloadPreferencesCreateDocAccess>
  delete?: Maybe<PayloadPreferencesDeleteDocAccess>
  fields?: Maybe<PayloadPreferencesDocAccessFields>
  read?: Maybe<PayloadPreferencesReadDocAccess>
  update?: Maybe<PayloadPreferencesUpdateDocAccess>
}

export type PricingAccess = {
  __typename?: 'pricingAccess'
  create?: Maybe<PricingCreateAccess>
  delete?: Maybe<PricingDeleteAccess>
  fields?: Maybe<PricingFields>
  read?: Maybe<PricingReadAccess>
  update?: Maybe<PricingUpdateAccess>
}

export type PricingDocAccess = {
  __typename?: 'pricingDocAccess'
  create?: Maybe<PricingCreateDocAccess>
  delete?: Maybe<PricingDeleteDocAccess>
  fields?: Maybe<PricingDocAccessFields>
  read?: Maybe<PricingReadDocAccess>
  update?: Maybe<PricingUpdateDocAccess>
}

export type RatingsAccess = {
  __typename?: 'ratingsAccess'
  create?: Maybe<RatingsCreateAccess>
  delete?: Maybe<RatingsDeleteAccess>
  fields?: Maybe<RatingsFields>
  read?: Maybe<RatingsReadAccess>
  update?: Maybe<RatingsUpdateAccess>
}

export type RatingsDocAccess = {
  __typename?: 'ratingsDocAccess'
  create?: Maybe<RatingsCreateDocAccess>
  delete?: Maybe<RatingsDeleteDocAccess>
  fields?: Maybe<RatingsDocAccessFields>
  read?: Maybe<RatingsReadDocAccess>
  update?: Maybe<RatingsUpdateDocAccess>
}

export type RedirectsAccess = {
  __typename?: 'redirectsAccess'
  create?: Maybe<RedirectsCreateAccess>
  delete?: Maybe<RedirectsDeleteAccess>
  fields?: Maybe<RedirectsFields>
  read?: Maybe<RedirectsReadAccess>
  update?: Maybe<RedirectsUpdateAccess>
}

export type RedirectsDocAccess = {
  __typename?: 'redirectsDocAccess'
  create?: Maybe<RedirectsCreateDocAccess>
  delete?: Maybe<RedirectsDeleteDocAccess>
  fields?: Maybe<RedirectsDocAccessFields>
  read?: Maybe<RedirectsReadDocAccess>
  update?: Maybe<RedirectsUpdateDocAccess>
}

export type Search_ResultsAccess = {
  __typename?: 'search_resultsAccess'
  create?: Maybe<SearchResultsCreateAccess>
  delete?: Maybe<SearchResultsDeleteAccess>
  fields?: Maybe<SearchResultsFields>
  read?: Maybe<SearchResultsReadAccess>
  update?: Maybe<SearchResultsUpdateAccess>
}

export type SettingsAccess = {
  __typename?: 'settingsAccess'
  fields?: Maybe<CmsSettingsFields>
  read?: Maybe<CmsSettingsReadAccess>
  update?: Maybe<CmsSettingsUpdateAccess>
}

export type SettingsDocAccess = {
  __typename?: 'settingsDocAccess'
  fields?: Maybe<CmsSettingsDocAccessFields>
  read?: Maybe<CmsSettingsReadDocAccess>
  update?: Maybe<CmsSettingsUpdateDocAccess>
}

export type StackerAccess = {
  __typename?: 'stackerAccess'
  create?: Maybe<StackerCreateAccess>
  delete?: Maybe<StackerDeleteAccess>
  fields?: Maybe<StackerFields>
  read?: Maybe<StackerReadAccess>
  readVersions?: Maybe<StackerReadVersionsAccess>
  update?: Maybe<StackerUpdateAccess>
}

export type StackerDocAccess = {
  __typename?: 'stackerDocAccess'
  create?: Maybe<StackerCreateDocAccess>
  delete?: Maybe<StackerDeleteDocAccess>
  fields?: Maybe<StackerDocAccessFields>
  read?: Maybe<StackerReadDocAccess>
  readVersions?: Maybe<StackerReadVersionsDocAccess>
  update?: Maybe<StackerUpdateDocAccess>
}

export type Tc_Program_TagsAccess = {
  __typename?: 'tc_program_tagsAccess'
  create?: Maybe<TcProgramTagsCreateAccess>
  delete?: Maybe<TcProgramTagsDeleteAccess>
  fields?: Maybe<TcProgramTagsFields>
  read?: Maybe<TcProgramTagsReadAccess>
  update?: Maybe<TcProgramTagsUpdateAccess>
}

export type Tc_Program_TagsDocAccess = {
  __typename?: 'tc_program_tagsDocAccess'
  create?: Maybe<TcProgramTagsCreateDocAccess>
  delete?: Maybe<TcProgramTagsDeleteDocAccess>
  fields?: Maybe<TcProgramTagsDocAccessFields>
  read?: Maybe<TcProgramTagsReadDocAccess>
  update?: Maybe<TcProgramTagsUpdateDocAccess>
}

export type Tc_ProgramsAccess = {
  __typename?: 'tc_programsAccess'
  create?: Maybe<TcProgramsCreateAccess>
  delete?: Maybe<TcProgramsDeleteAccess>
  fields?: Maybe<TcProgramsFields>
  read?: Maybe<TcProgramsReadAccess>
  readVersions?: Maybe<TcProgramsReadVersionsAccess>
  update?: Maybe<TcProgramsUpdateAccess>
}

export type Tc_ProgramsDocAccess = {
  __typename?: 'tc_programsDocAccess'
  create?: Maybe<TcProgramsCreateDocAccess>
  delete?: Maybe<TcProgramsDeleteDocAccess>
  fields?: Maybe<TcProgramsDocAccessFields>
  read?: Maybe<TcProgramsReadDocAccess>
  readVersions?: Maybe<TcProgramsReadVersionsDocAccess>
  update?: Maybe<TcProgramsUpdateDocAccess>
}

export type Tc_VendorsAccess = {
  __typename?: 'tc_vendorsAccess'
  create?: Maybe<TcVendorsCreateAccess>
  delete?: Maybe<TcVendorsDeleteAccess>
  fields?: Maybe<TcVendorsFields>
  read?: Maybe<TcVendorsReadAccess>
  readVersions?: Maybe<TcVendorsReadVersionsAccess>
  update?: Maybe<TcVendorsUpdateAccess>
}

export type Tc_VendorsDocAccess = {
  __typename?: 'tc_vendorsDocAccess'
  create?: Maybe<TcVendorsCreateDocAccess>
  delete?: Maybe<TcVendorsDeleteDocAccess>
  fields?: Maybe<TcVendorsDocAccessFields>
  read?: Maybe<TcVendorsReadDocAccess>
  readVersions?: Maybe<TcVendorsReadVersionsDocAccess>
  update?: Maybe<TcVendorsUpdateDocAccess>
}

export type Trade_Credit_VendorsAccess = {
  __typename?: 'trade_credit_vendorsAccess'
  create?: Maybe<TradeCreditVendorsCreateAccess>
  delete?: Maybe<TradeCreditVendorsDeleteAccess>
  fields?: Maybe<TradeCreditVendorsFields>
  read?: Maybe<TradeCreditVendorsReadAccess>
  readVersions?: Maybe<TradeCreditVendorsReadVersionsAccess>
  update?: Maybe<TradeCreditVendorsUpdateAccess>
}

export type Trade_Credit_VendorsDocAccess = {
  __typename?: 'trade_credit_vendorsDocAccess'
  create?: Maybe<TradeCreditVendorsCreateDocAccess>
  delete?: Maybe<TradeCreditVendorsDeleteDocAccess>
  fields?: Maybe<TradeCreditVendorsDocAccessFields>
  read?: Maybe<TradeCreditVendorsReadDocAccess>
  readVersions?: Maybe<TradeCreditVendorsReadVersionsDocAccess>
  update?: Maybe<TradeCreditVendorsUpdateDocAccess>
}

export type UsersAccess = {
  __typename?: 'usersAccess'
  create?: Maybe<UsersCreateAccess>
  delete?: Maybe<UsersDeleteAccess>
  fields?: Maybe<UsersFields>
  read?: Maybe<UsersReadAccess>
  unlock?: Maybe<UsersUnlockAccess>
  update?: Maybe<UsersUpdateAccess>
}

export type UsersDocAccess = {
  __typename?: 'usersDocAccess'
  create?: Maybe<UsersCreateDocAccess>
  delete?: Maybe<UsersDeleteDocAccess>
  fields?: Maybe<UsersDocAccessFields>
  read?: Maybe<UsersReadDocAccess>
  unlock?: Maybe<UsersUnlockDocAccess>
  update?: Maybe<UsersUpdateDocAccess>
}

export type UsersJwt = {
  __typename?: 'usersJWT'
  collection: Scalars['String']['output']
  email: Scalars['EmailAddress']['output']
}

export type UsersLoginResult = {
  __typename?: 'usersLoginResult'
  exp?: Maybe<Scalars['Int']['output']>
  token?: Maybe<Scalars['String']['output']>
  user?: Maybe<CmsUser>
}

export type UsersMe = {
  __typename?: 'usersMe'
  collection?: Maybe<Scalars['String']['output']>
  exp?: Maybe<Scalars['Int']['output']>
  strategy?: Maybe<Scalars['String']['output']>
  token?: Maybe<Scalars['String']['output']>
  user?: Maybe<CmsUser>
}

export type UsersRefreshedCmsUser = {
  __typename?: 'usersRefreshedCmsUser'
  exp?: Maybe<Scalars['Int']['output']>
  refreshedToken?: Maybe<Scalars['String']['output']>
  strategy?: Maybe<Scalars['String']['output']>
  user?: Maybe<UsersJwt>
}

export type UsersResetPassword = {
  __typename?: 'usersResetPassword'
  token?: Maybe<Scalars['String']['output']>
  user?: Maybe<CmsUser>
}

export type VersionsCmsArticle_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsArticle_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsArticle_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsArticle_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsArticle_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsArticle_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsArticle_Version___Status_Input =
  (typeof VersionsCmsArticle_Version___Status_Input)[keyof typeof VersionsCmsArticle_Version___Status_Input]
export type VersionsCmsArticle_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsArticle_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsArticle_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version___Status_Input>>>
}

export type VersionsCmsArticle_Version__Authors_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsArticle_Version__Categories_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsArticle_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsArticle_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input =
  (typeof VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input)[keyof typeof VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input]
export type VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Input>>>
}

export type VersionsCmsArticle_Version__CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsArticle_Version__CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsArticle_Version__CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsArticle_Version__CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input =
  (typeof VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input)[keyof typeof VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input]
export type VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Input>>>
}

export type VersionsCmsArticle_Version__CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type VersionsCmsArticle_Version__CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input =
  (typeof VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input)[keyof typeof VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input]
export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Input>
}

export type VersionsCmsArticle_Version__CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type VersionsCmsArticle_Version__CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input =
  (typeof VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input)[keyof typeof VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input]
export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Input>
}

export type VersionsCmsArticle_Version__CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type VersionsCmsArticle_Version__CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input =
  (typeof VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input)[keyof typeof VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input]
export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Input>
}

export type VersionsCmsArticle_Version__CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsArticle_Version__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsArticle_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsArticle_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsArticle_Version__Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsArticle_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsArticle_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsArticle_Version__Ratings_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsArticle_Version__ReadTimeEstimate_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsArticle_Version__RelatedArticles_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const VersionsCmsArticle_Version__ResourceCategory_Input = {
  AccountingSoftware: 'accounting_software',
  BusinessChecking: 'business_checking',
  BusinessCreditCard: 'business_credit_card',
  BusinessCreditScores: 'business_credit_scores',
  BusinessFormation: 'business_formation',
  BusinessTaxes: 'business_taxes',
  CreditBuilding: 'credit_building',
  InsuranceResource: 'insurance_resource',
  MerchantServices: 'merchant_services',
  PayrollServices: 'payroll_services',
  Resource: 'resource',
  SmallBusinessLoans: 'small_business_loans',
} as const

export type VersionsCmsArticle_Version__ResourceCategory_Input =
  (typeof VersionsCmsArticle_Version__ResourceCategory_Input)[keyof typeof VersionsCmsArticle_Version__ResourceCategory_Input]
export type VersionsCmsArticle_Version__ResourceCategory_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Input>>>
  equals?: InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Input>>>
  not_equals?: InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Input>>>
}

export type VersionsCmsArticle_Version__RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsArticle_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__Summary__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__Summary__Text_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsArticle_Version__TableOfContents__IdAttribute_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__TableOfContents__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__TableOfContents__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsArticle_Version__WordCount_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsArticle_Version__WordpressPostId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsArticle_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsArticle_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsArticle_Id_Operator>
  latest?: InputMaybe<VersionsCmsArticle_Latest_Operator>
  parent?: InputMaybe<VersionsCmsArticle_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsArticle_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsArticle_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsArticle_Version__Authors_Operator>
  version__categories?: InputMaybe<VersionsCmsArticle_Version__Categories_Operator>
  version__createdAt?: InputMaybe<VersionsCmsArticle_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsArticle_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Url_Operator>
  version__excerpt?: InputMaybe<VersionsCmsArticle_Version__Excerpt_Operator>
  version__image?: InputMaybe<VersionsCmsArticle_Version__Image_Operator>
  version__meta__description?: InputMaybe<VersionsCmsArticle_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsArticle_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsArticle_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsArticle_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsArticle_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsArticle_Version__PublishedAt_Operator>
  version__ratings?: InputMaybe<VersionsCmsArticle_Version__Ratings_Operator>
  version__readTimeEstimate?: InputMaybe<VersionsCmsArticle_Version__ReadTimeEstimate_Operator>
  version__relatedArticles?: InputMaybe<VersionsCmsArticle_Version__RelatedArticles_Operator>
  version__resourceCategory?: InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Operator>
  version__richText?: InputMaybe<VersionsCmsArticle_Version__RichText_Operator>
  version__slug?: InputMaybe<VersionsCmsArticle_Version__Slug_Operator>
  version__summary__id?: InputMaybe<VersionsCmsArticle_Version__Summary__Id_Operator>
  version__summary__text?: InputMaybe<VersionsCmsArticle_Version__Summary__Text_Operator>
  version__tableOfContents__id?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__Id_Operator>
  version__tableOfContents__idAttribute?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__IdAttribute_Operator>
  version__tableOfContents__text?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__Text_Operator>
  version__title?: InputMaybe<VersionsCmsArticle_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsArticle_Version__UpdatedAt_Operator>
  version__wordCount?: InputMaybe<VersionsCmsArticle_Version__WordCount_Operator>
  version__wordpressPostId?: InputMaybe<VersionsCmsArticle_Version__WordpressPostId_Operator>
}

export type VersionsCmsArticle_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsArticle_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsArticle_Id_Operator>
  latest?: InputMaybe<VersionsCmsArticle_Latest_Operator>
  parent?: InputMaybe<VersionsCmsArticle_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsArticle_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsArticle_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsArticle_Version__Authors_Operator>
  version__categories?: InputMaybe<VersionsCmsArticle_Version__Categories_Operator>
  version__createdAt?: InputMaybe<VersionsCmsArticle_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsArticle_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Url_Operator>
  version__excerpt?: InputMaybe<VersionsCmsArticle_Version__Excerpt_Operator>
  version__image?: InputMaybe<VersionsCmsArticle_Version__Image_Operator>
  version__meta__description?: InputMaybe<VersionsCmsArticle_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsArticle_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsArticle_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsArticle_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsArticle_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsArticle_Version__PublishedAt_Operator>
  version__ratings?: InputMaybe<VersionsCmsArticle_Version__Ratings_Operator>
  version__readTimeEstimate?: InputMaybe<VersionsCmsArticle_Version__ReadTimeEstimate_Operator>
  version__relatedArticles?: InputMaybe<VersionsCmsArticle_Version__RelatedArticles_Operator>
  version__resourceCategory?: InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Operator>
  version__richText?: InputMaybe<VersionsCmsArticle_Version__RichText_Operator>
  version__slug?: InputMaybe<VersionsCmsArticle_Version__Slug_Operator>
  version__summary__id?: InputMaybe<VersionsCmsArticle_Version__Summary__Id_Operator>
  version__summary__text?: InputMaybe<VersionsCmsArticle_Version__Summary__Text_Operator>
  version__tableOfContents__id?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__Id_Operator>
  version__tableOfContents__idAttribute?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__IdAttribute_Operator>
  version__tableOfContents__text?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__Text_Operator>
  version__title?: InputMaybe<VersionsCmsArticle_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsArticle_Version__UpdatedAt_Operator>
  version__wordCount?: InputMaybe<VersionsCmsArticle_Version__WordCount_Operator>
  version__wordpressPostId?: InputMaybe<VersionsCmsArticle_Version__WordpressPostId_Operator>
}

export type VersionsCmsArticle_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsArticle_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsArticle_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsArticle_Id_Operator>
  latest?: InputMaybe<VersionsCmsArticle_Latest_Operator>
  parent?: InputMaybe<VersionsCmsArticle_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsArticle_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsArticle_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsArticle_Version__Authors_Operator>
  version__categories?: InputMaybe<VersionsCmsArticle_Version__Categories_Operator>
  version__createdAt?: InputMaybe<VersionsCmsArticle_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsArticle_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsArticle_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsArticle_Version__CustomHeader__SupportLink__Url_Operator>
  version__excerpt?: InputMaybe<VersionsCmsArticle_Version__Excerpt_Operator>
  version__image?: InputMaybe<VersionsCmsArticle_Version__Image_Operator>
  version__meta__description?: InputMaybe<VersionsCmsArticle_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsArticle_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsArticle_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsArticle_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsArticle_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsArticle_Version__PublishedAt_Operator>
  version__ratings?: InputMaybe<VersionsCmsArticle_Version__Ratings_Operator>
  version__readTimeEstimate?: InputMaybe<VersionsCmsArticle_Version__ReadTimeEstimate_Operator>
  version__relatedArticles?: InputMaybe<VersionsCmsArticle_Version__RelatedArticles_Operator>
  version__resourceCategory?: InputMaybe<VersionsCmsArticle_Version__ResourceCategory_Operator>
  version__richText?: InputMaybe<VersionsCmsArticle_Version__RichText_Operator>
  version__slug?: InputMaybe<VersionsCmsArticle_Version__Slug_Operator>
  version__summary__id?: InputMaybe<VersionsCmsArticle_Version__Summary__Id_Operator>
  version__summary__text?: InputMaybe<VersionsCmsArticle_Version__Summary__Text_Operator>
  version__tableOfContents__id?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__Id_Operator>
  version__tableOfContents__idAttribute?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__IdAttribute_Operator>
  version__tableOfContents__text?: InputMaybe<VersionsCmsArticle_Version__TableOfContents__Text_Operator>
  version__title?: InputMaybe<VersionsCmsArticle_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsArticle_Version__UpdatedAt_Operator>
  version__wordCount?: InputMaybe<VersionsCmsArticle_Version__WordCount_Operator>
  version__wordpressPostId?: InputMaybe<VersionsCmsArticle_Version__WordpressPostId_Operator>
}

export type VersionsCmsArticles = {
  __typename?: 'versionsCmsArticles'
  docs?: Maybe<Array<Maybe<CmsArticleVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsForm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsForm_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsForm_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsForm_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsForm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsForm_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsForm_Version___Status_Input =
  (typeof VersionsCmsForm_Version___Status_Input)[keyof typeof VersionsCmsForm_Version___Status_Input]
export type VersionsCmsForm_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsForm_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsForm_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Version___Status_Input>>>
}

export type VersionsCmsForm_Version__ConfirmationMessage_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsForm_Version__ConfirmationType_Input = {
  Message: 'message',
  Redirect: 'redirect',
} as const

export type VersionsCmsForm_Version__ConfirmationType_Input =
  (typeof VersionsCmsForm_Version__ConfirmationType_Input)[keyof typeof VersionsCmsForm_Version__ConfirmationType_Input]
export type VersionsCmsForm_Version__ConfirmationType_Operator = {
  contains?: InputMaybe<VersionsCmsForm_Version__ConfirmationType_Input>
  equals?: InputMaybe<VersionsCmsForm_Version__ConfirmationType_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsForm_Version__ConfirmationType_Input>
  not_equals?: InputMaybe<VersionsCmsForm_Version__ConfirmationType_Input>
}

export type VersionsCmsForm_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsForm_Version__Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsForm_Version__Emails__Bcc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Emails__Cc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Emails__EmailFrom_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Emails__EmailTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Emails__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Emails__Message_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsForm_Version__Emails__ReplyTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Emails__Subject_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Redirect__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsForm_Version__Redirect__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsForm_Version__Redirect__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
  Stacker: 'stacker',
} as const

export type VersionsCmsForm_Version__Redirect__Reference_Relation_RelationTo =
  (typeof VersionsCmsForm_Version__Redirect__Reference_Relation_RelationTo)[keyof typeof VersionsCmsForm_Version__Redirect__Reference_Relation_RelationTo]
export const VersionsCmsForm_Version__Redirect__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
} as const

export type VersionsCmsForm_Version__Redirect__Type_Input =
  (typeof VersionsCmsForm_Version__Redirect__Type_Input)[keyof typeof VersionsCmsForm_Version__Redirect__Type_Input]
export type VersionsCmsForm_Version__Redirect__Type_Operator = {
  contains?: InputMaybe<VersionsCmsForm_Version__Redirect__Type_Input>
  equals?: InputMaybe<VersionsCmsForm_Version__Redirect__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsForm_Version__Redirect__Type_Input>
  not_equals?: InputMaybe<VersionsCmsForm_Version__Redirect__Type_Input>
}

export type VersionsCmsForm_Version__Redirect__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__SubmitButtonLabel_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsForm_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsForm_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsForm_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsForm_Id_Operator>
  latest?: InputMaybe<VersionsCmsForm_Latest_Operator>
  parent?: InputMaybe<VersionsCmsForm_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsForm_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsForm_Version___Status_Operator>
  version__confirmationMessage?: InputMaybe<VersionsCmsForm_Version__ConfirmationMessage_Operator>
  version__confirmationType?: InputMaybe<VersionsCmsForm_Version__ConfirmationType_Operator>
  version__createdAt?: InputMaybe<VersionsCmsForm_Version__CreatedAt_Operator>
  version__description?: InputMaybe<VersionsCmsForm_Version__Description_Operator>
  version__emails__bcc?: InputMaybe<VersionsCmsForm_Version__Emails__Bcc_Operator>
  version__emails__cc?: InputMaybe<VersionsCmsForm_Version__Emails__Cc_Operator>
  version__emails__emailFrom?: InputMaybe<VersionsCmsForm_Version__Emails__EmailFrom_Operator>
  version__emails__emailTo?: InputMaybe<VersionsCmsForm_Version__Emails__EmailTo_Operator>
  version__emails__id?: InputMaybe<VersionsCmsForm_Version__Emails__Id_Operator>
  version__emails__message?: InputMaybe<VersionsCmsForm_Version__Emails__Message_Operator>
  version__emails__replyTo?: InputMaybe<VersionsCmsForm_Version__Emails__ReplyTo_Operator>
  version__emails__subject?: InputMaybe<VersionsCmsForm_Version__Emails__Subject_Operator>
  version__redirect__reference?: InputMaybe<VersionsCmsForm_Version__Redirect__Reference_Relation>
  version__redirect__type?: InputMaybe<VersionsCmsForm_Version__Redirect__Type_Operator>
  version__redirect__url?: InputMaybe<VersionsCmsForm_Version__Redirect__Url_Operator>
  version__slug?: InputMaybe<VersionsCmsForm_Version__Slug_Operator>
  version__submitButtonLabel?: InputMaybe<VersionsCmsForm_Version__SubmitButtonLabel_Operator>
  version__title?: InputMaybe<VersionsCmsForm_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsForm_Version__UpdatedAt_Operator>
}

export type VersionsCmsForm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsForm_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsForm_Id_Operator>
  latest?: InputMaybe<VersionsCmsForm_Latest_Operator>
  parent?: InputMaybe<VersionsCmsForm_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsForm_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsForm_Version___Status_Operator>
  version__confirmationMessage?: InputMaybe<VersionsCmsForm_Version__ConfirmationMessage_Operator>
  version__confirmationType?: InputMaybe<VersionsCmsForm_Version__ConfirmationType_Operator>
  version__createdAt?: InputMaybe<VersionsCmsForm_Version__CreatedAt_Operator>
  version__description?: InputMaybe<VersionsCmsForm_Version__Description_Operator>
  version__emails__bcc?: InputMaybe<VersionsCmsForm_Version__Emails__Bcc_Operator>
  version__emails__cc?: InputMaybe<VersionsCmsForm_Version__Emails__Cc_Operator>
  version__emails__emailFrom?: InputMaybe<VersionsCmsForm_Version__Emails__EmailFrom_Operator>
  version__emails__emailTo?: InputMaybe<VersionsCmsForm_Version__Emails__EmailTo_Operator>
  version__emails__id?: InputMaybe<VersionsCmsForm_Version__Emails__Id_Operator>
  version__emails__message?: InputMaybe<VersionsCmsForm_Version__Emails__Message_Operator>
  version__emails__replyTo?: InputMaybe<VersionsCmsForm_Version__Emails__ReplyTo_Operator>
  version__emails__subject?: InputMaybe<VersionsCmsForm_Version__Emails__Subject_Operator>
  version__redirect__reference?: InputMaybe<VersionsCmsForm_Version__Redirect__Reference_Relation>
  version__redirect__type?: InputMaybe<VersionsCmsForm_Version__Redirect__Type_Operator>
  version__redirect__url?: InputMaybe<VersionsCmsForm_Version__Redirect__Url_Operator>
  version__slug?: InputMaybe<VersionsCmsForm_Version__Slug_Operator>
  version__submitButtonLabel?: InputMaybe<VersionsCmsForm_Version__SubmitButtonLabel_Operator>
  version__title?: InputMaybe<VersionsCmsForm_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsForm_Version__UpdatedAt_Operator>
}

export type VersionsCmsForm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsForm_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsForm_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsForm_Id_Operator>
  latest?: InputMaybe<VersionsCmsForm_Latest_Operator>
  parent?: InputMaybe<VersionsCmsForm_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsForm_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsForm_Version___Status_Operator>
  version__confirmationMessage?: InputMaybe<VersionsCmsForm_Version__ConfirmationMessage_Operator>
  version__confirmationType?: InputMaybe<VersionsCmsForm_Version__ConfirmationType_Operator>
  version__createdAt?: InputMaybe<VersionsCmsForm_Version__CreatedAt_Operator>
  version__description?: InputMaybe<VersionsCmsForm_Version__Description_Operator>
  version__emails__bcc?: InputMaybe<VersionsCmsForm_Version__Emails__Bcc_Operator>
  version__emails__cc?: InputMaybe<VersionsCmsForm_Version__Emails__Cc_Operator>
  version__emails__emailFrom?: InputMaybe<VersionsCmsForm_Version__Emails__EmailFrom_Operator>
  version__emails__emailTo?: InputMaybe<VersionsCmsForm_Version__Emails__EmailTo_Operator>
  version__emails__id?: InputMaybe<VersionsCmsForm_Version__Emails__Id_Operator>
  version__emails__message?: InputMaybe<VersionsCmsForm_Version__Emails__Message_Operator>
  version__emails__replyTo?: InputMaybe<VersionsCmsForm_Version__Emails__ReplyTo_Operator>
  version__emails__subject?: InputMaybe<VersionsCmsForm_Version__Emails__Subject_Operator>
  version__redirect__reference?: InputMaybe<VersionsCmsForm_Version__Redirect__Reference_Relation>
  version__redirect__type?: InputMaybe<VersionsCmsForm_Version__Redirect__Type_Operator>
  version__redirect__url?: InputMaybe<VersionsCmsForm_Version__Redirect__Url_Operator>
  version__slug?: InputMaybe<VersionsCmsForm_Version__Slug_Operator>
  version__submitButtonLabel?: InputMaybe<VersionsCmsForm_Version__SubmitButtonLabel_Operator>
  version__title?: InputMaybe<VersionsCmsForm_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsForm_Version__UpdatedAt_Operator>
}

export type VersionsCmsForms = {
  __typename?: 'versionsCmsForms'
  docs?: Maybe<Array<Maybe<CmsFormVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsGuide_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsGuide_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsGuide_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsGuide_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsGuide_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsGuide_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsGuide_Version___Status_Input =
  (typeof VersionsCmsGuide_Version___Status_Input)[keyof typeof VersionsCmsGuide_Version___Status_Input]
export type VersionsCmsGuide_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsGuide_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsGuide_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Version___Status_Input>>>
}

export type VersionsCmsGuide_Version__Authors_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Link__IconAfter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Link__IconBefore_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Link__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Link__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsGuide_Version__Chapters__Link__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Link__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Link__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Link__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsGuide_Version__Chapters__Link__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsGuide_Version__Chapters__Link__Reference_Relation_RelationTo =
  (typeof VersionsCmsGuide_Version__Chapters__Link__Reference_Relation_RelationTo)[keyof typeof VersionsCmsGuide_Version__Chapters__Link__Reference_Relation_RelationTo]
export type VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation_RelationTo =
  (typeof VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation_RelationTo]
export type VersionsCmsGuide_Version__Chapters__Link__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsGuide_Version__Chapters__Link__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsGuide_Version__Chapters__Link__Type_Input =
  (typeof VersionsCmsGuide_Version__Chapters__Link__Type_Input)[keyof typeof VersionsCmsGuide_Version__Chapters__Link__Type_Input]
export type VersionsCmsGuide_Version__Chapters__Link__Type_Operator = {
  contains?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Type_Input>
  equals?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Type_Input>
  not_equals?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Type_Input>
}

export type VersionsCmsGuide_Version__Chapters__Link__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Chapters__Title_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsGuide_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsGuide_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsGuide_Version__Header_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsGuide_Version__Intro_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsGuide_Version__Media_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsGuide_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsGuide_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsGuide_Version__Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsGuide_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsGuide_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsGuide_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__TimeEstimate_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsGuide_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsGuide_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsGuide_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsGuide_Id_Operator>
  latest?: InputMaybe<VersionsCmsGuide_Latest_Operator>
  parent?: InputMaybe<VersionsCmsGuide_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsGuide_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsGuide_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsGuide_Version__Authors_Operator>
  version__chapters__id?: InputMaybe<VersionsCmsGuide_Version__Chapters__Id_Operator>
  version__chapters__image?: InputMaybe<VersionsCmsGuide_Version__Chapters__Image_Operator>
  version__chapters__link__iconAfter?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__IconAfter_Operator>
  version__chapters__link__iconBefore?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__IconBefore_Operator>
  version__chapters__link__label?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Label_Operator>
  version__chapters__link__newTab?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__NewTab_Operator>
  version__chapters__link__query__id?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Id_Operator>
  version__chapters__link__query__key?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Key_Operator>
  version__chapters__link__query__value?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Value_Operator>
  version__chapters__link__reference?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reference_Relation>
  version__chapters__link__reusable?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation>
  version__chapters__link__targetId?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__TargetId_Operator>
  version__chapters__link__type?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Type_Operator>
  version__chapters__link__url?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Url_Operator>
  version__chapters__title?: InputMaybe<VersionsCmsGuide_Version__Chapters__Title_Operator>
  version__createdAt?: InputMaybe<VersionsCmsGuide_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsGuide_Version__CreatedBy_Operator>
  version__header?: InputMaybe<VersionsCmsGuide_Version__Header_Operator>
  version__intro?: InputMaybe<VersionsCmsGuide_Version__Intro_Operator>
  version__media?: InputMaybe<VersionsCmsGuide_Version__Media_Operator>
  version__meta__description?: InputMaybe<VersionsCmsGuide_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsGuide_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsGuide_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsGuide_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsGuide_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsGuide_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsGuide_Version__Slug_Operator>
  version__timeEstimate?: InputMaybe<VersionsCmsGuide_Version__TimeEstimate_Operator>
  version__title?: InputMaybe<VersionsCmsGuide_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsGuide_Version__UpdatedAt_Operator>
}

export type VersionsCmsGuide_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsGuide_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsGuide_Id_Operator>
  latest?: InputMaybe<VersionsCmsGuide_Latest_Operator>
  parent?: InputMaybe<VersionsCmsGuide_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsGuide_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsGuide_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsGuide_Version__Authors_Operator>
  version__chapters__id?: InputMaybe<VersionsCmsGuide_Version__Chapters__Id_Operator>
  version__chapters__image?: InputMaybe<VersionsCmsGuide_Version__Chapters__Image_Operator>
  version__chapters__link__iconAfter?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__IconAfter_Operator>
  version__chapters__link__iconBefore?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__IconBefore_Operator>
  version__chapters__link__label?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Label_Operator>
  version__chapters__link__newTab?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__NewTab_Operator>
  version__chapters__link__query__id?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Id_Operator>
  version__chapters__link__query__key?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Key_Operator>
  version__chapters__link__query__value?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Value_Operator>
  version__chapters__link__reference?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reference_Relation>
  version__chapters__link__reusable?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation>
  version__chapters__link__targetId?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__TargetId_Operator>
  version__chapters__link__type?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Type_Operator>
  version__chapters__link__url?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Url_Operator>
  version__chapters__title?: InputMaybe<VersionsCmsGuide_Version__Chapters__Title_Operator>
  version__createdAt?: InputMaybe<VersionsCmsGuide_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsGuide_Version__CreatedBy_Operator>
  version__header?: InputMaybe<VersionsCmsGuide_Version__Header_Operator>
  version__intro?: InputMaybe<VersionsCmsGuide_Version__Intro_Operator>
  version__media?: InputMaybe<VersionsCmsGuide_Version__Media_Operator>
  version__meta__description?: InputMaybe<VersionsCmsGuide_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsGuide_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsGuide_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsGuide_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsGuide_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsGuide_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsGuide_Version__Slug_Operator>
  version__timeEstimate?: InputMaybe<VersionsCmsGuide_Version__TimeEstimate_Operator>
  version__title?: InputMaybe<VersionsCmsGuide_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsGuide_Version__UpdatedAt_Operator>
}

export type VersionsCmsGuide_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsGuide_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsGuide_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsGuide_Id_Operator>
  latest?: InputMaybe<VersionsCmsGuide_Latest_Operator>
  parent?: InputMaybe<VersionsCmsGuide_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsGuide_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsGuide_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsGuide_Version__Authors_Operator>
  version__chapters__id?: InputMaybe<VersionsCmsGuide_Version__Chapters__Id_Operator>
  version__chapters__image?: InputMaybe<VersionsCmsGuide_Version__Chapters__Image_Operator>
  version__chapters__link__iconAfter?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__IconAfter_Operator>
  version__chapters__link__iconBefore?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__IconBefore_Operator>
  version__chapters__link__label?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Label_Operator>
  version__chapters__link__newTab?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__NewTab_Operator>
  version__chapters__link__query__id?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Id_Operator>
  version__chapters__link__query__key?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Key_Operator>
  version__chapters__link__query__value?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Query__Value_Operator>
  version__chapters__link__reference?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reference_Relation>
  version__chapters__link__reusable?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Reusable_Relation>
  version__chapters__link__targetId?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__TargetId_Operator>
  version__chapters__link__type?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Type_Operator>
  version__chapters__link__url?: InputMaybe<VersionsCmsGuide_Version__Chapters__Link__Url_Operator>
  version__chapters__title?: InputMaybe<VersionsCmsGuide_Version__Chapters__Title_Operator>
  version__createdAt?: InputMaybe<VersionsCmsGuide_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsGuide_Version__CreatedBy_Operator>
  version__header?: InputMaybe<VersionsCmsGuide_Version__Header_Operator>
  version__intro?: InputMaybe<VersionsCmsGuide_Version__Intro_Operator>
  version__media?: InputMaybe<VersionsCmsGuide_Version__Media_Operator>
  version__meta__description?: InputMaybe<VersionsCmsGuide_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsGuide_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsGuide_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsGuide_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsGuide_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsGuide_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsGuide_Version__Slug_Operator>
  version__timeEstimate?: InputMaybe<VersionsCmsGuide_Version__TimeEstimate_Operator>
  version__title?: InputMaybe<VersionsCmsGuide_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsGuide_Version__UpdatedAt_Operator>
}

export type VersionsCmsGuides = {
  __typename?: 'versionsCmsGuides'
  docs?: Maybe<Array<Maybe<CmsGuideVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsLiteEmbeddedMarketplace_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input =
  (typeof VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input)[keyof typeof VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input]
export type VersionsCmsLiteEmbeddedMarketplace_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Input>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__AffiliateCode_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__LogoHref_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Logo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input =
  (typeof VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input)[keyof typeof VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input]
export type VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input>>>
  equals?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input>>>
  not_equals?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Input>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Collection_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsLiteEmbeddedMarketplace_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsLiteEmbeddedMarketplace_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Id_Operator>
  latest?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Latest_Operator>
  parent?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Operator>
  version__affiliateCode?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__AffiliateCode_Operator>
  version__createdAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__CreatedBy_Operator>
  version__logo?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Logo_Operator>
  version__logoHref?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__LogoHref_Operator>
  version__meta__description?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Title_Operator>
  version__offerCategories__category?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Operator>
  version__offerCategories__collection?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Collection_Operator>
  version__offerCategories__id?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Id_Operator>
  version__offerCategories__name?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Name_Operator>
  version__offerCategories__slug?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Slug_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__UpdatedAt_Operator>
}

export type VersionsCmsLiteEmbeddedMarketplace_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Id_Operator>
  latest?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Latest_Operator>
  parent?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Operator>
  version__affiliateCode?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__AffiliateCode_Operator>
  version__createdAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__CreatedBy_Operator>
  version__logo?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Logo_Operator>
  version__logoHref?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__LogoHref_Operator>
  version__meta__description?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Title_Operator>
  version__offerCategories__category?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Operator>
  version__offerCategories__collection?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Collection_Operator>
  version__offerCategories__id?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Id_Operator>
  version__offerCategories__name?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Name_Operator>
  version__offerCategories__slug?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Slug_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__UpdatedAt_Operator>
}

export type VersionsCmsLiteEmbeddedMarketplace_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Id_Operator>
  latest?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Latest_Operator>
  parent?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version___Status_Operator>
  version__affiliateCode?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__AffiliateCode_Operator>
  version__createdAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__CreatedBy_Operator>
  version__logo?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Logo_Operator>
  version__logoHref?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__LogoHref_Operator>
  version__meta__description?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Meta__Title_Operator>
  version__offerCategories__category?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Category_Operator>
  version__offerCategories__collection?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Collection_Operator>
  version__offerCategories__id?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Id_Operator>
  version__offerCategories__name?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Name_Operator>
  version__offerCategories__slug?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__OfferCategories__Slug_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsLiteEmbeddedMarketplace_Version__UpdatedAt_Operator>
}

export type VersionsCmsLiteEmbeddedMarketplaces = {
  __typename?: 'versionsCmsLiteEmbeddedMarketplaces'
  docs?: Maybe<Array<Maybe<CmsLiteEmbeddedMarketplaceVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsMarketplacePage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsMarketplacePage_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsMarketplacePage_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsMarketplacePage_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsMarketplacePage_Version___Status_Input =
  (typeof VersionsCmsMarketplacePage_Version___Status_Input)[keyof typeof VersionsCmsMarketplacePage_Version___Status_Input]
export type VersionsCmsMarketplacePage_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version___Status_Input>>>
}

export type VersionsCmsMarketplacePage_Version__Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsMarketplacePage_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input =
  (typeof VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input)[keyof typeof VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input]
export type VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Input>>>
}

export type VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input]
export type VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Input>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input]
export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Input>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input]
export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Input>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input =
  (typeof VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input)[keyof typeof VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input]
export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Input>
}

export type VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__DesktopFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__DesktopVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__DisclaimerText_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export const VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input = {
  Full: 'full',
  Partial: 'partial',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input =
  (typeof VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input]
export type VersionsCmsMarketplacePage_Version__Hero__HeroSize_Operator = {
  contains?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HeroSize_Input>
}

export const VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input =
  (typeof VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input]
export type VersionsCmsMarketplacePage_Version__Hero__HzAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Input>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconAfter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconBefore_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation_RelationTo =
  (typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation_RelationTo]
export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input =
  (typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input]
export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Operator = {
  contains?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Input>
}

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input =
  (typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input]
export type VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Input>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__Media_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__MobileFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__MobileVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__ProductImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__ReviewRating_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsMarketplacePage_Version__Hero__ReviewText_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Hero__RichTextMax_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsMarketplacePage_Version__Hero__RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsMarketplacePage_Version__Hero__ShowReviews_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const VersionsCmsMarketplacePage_Version__Hero__Type_Input = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__Type_Input =
  (typeof VersionsCmsMarketplacePage_Version__Hero__Type_Input)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__Type_Input]
export type VersionsCmsMarketplacePage_Version__Hero__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Input>>>
}

export const VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input =
  (typeof VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input)[keyof typeof VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input]
export type VersionsCmsMarketplacePage_Version__Hero__VertAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Input>>>
}

export type VersionsCmsMarketplacePage_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsMarketplacePage_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsMarketplacePage_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsMarketplacePage_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsMarketplacePage_Version__OfferCategory_Input = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type VersionsCmsMarketplacePage_Version__OfferCategory_Input =
  (typeof VersionsCmsMarketplacePage_Version__OfferCategory_Input)[keyof typeof VersionsCmsMarketplacePage_Version__OfferCategory_Input]
export type VersionsCmsMarketplacePage_Version__OfferCategory_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Input>>>
  equals?: InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Input>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Input>>>
  not_equals?: InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Input>>>
}

export type VersionsCmsMarketplacePage_Version__Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsMarketplacePage_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsMarketplacePage_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsMarketplacePage_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsMarketplacePage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsMarketplacePage_Id_Operator>
  latest?: InputMaybe<VersionsCmsMarketplacePage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsMarketplacePage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsMarketplacePage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsMarketplacePage_Version___Status_Operator>
  version__breadcrumbs__doc?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Doc_Operator>
  version__breadcrumbs__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Id_Operator>
  version__breadcrumbs__label?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Label_Operator>
  version__breadcrumbs__url?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Url_Operator>
  version__createdAt?: InputMaybe<VersionsCmsMarketplacePage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsMarketplacePage_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Url_Operator>
  version__hero__desktopFallback?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DesktopFallback_Operator>
  version__hero__desktopVideo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DesktopVideo_Operator>
  version__hero__disclaimerText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DisclaimerText_Operator>
  version__hero__heroSize?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HeroSize_Operator>
  version__hero__hzAlign?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Operator>
  version__hero__links__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Id_Operator>
  version__hero__links__link__iconAfter?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconAfter_Operator>
  version__hero__links__link__iconBefore?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconBefore_Operator>
  version__hero__links__link__label?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Label_Operator>
  version__hero__links__link__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__NewTab_Operator>
  version__hero__links__link__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Id_Operator>
  version__hero__links__link__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Key_Operator>
  version__hero__links__link__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Value_Operator>
  version__hero__links__link__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation>
  version__hero__links__link__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation>
  version__hero__links__link__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__TargetId_Operator>
  version__hero__links__link__type?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Operator>
  version__hero__links__link__url?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Url_Operator>
  version__hero__links__link__variant?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Operator>
  version__hero__media?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Media_Operator>
  version__hero__mobileFallback?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__MobileFallback_Operator>
  version__hero__mobileVideo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__MobileVideo_Operator>
  version__hero__productImage?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ProductImage_Operator>
  version__hero__reviewRating?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ReviewRating_Operator>
  version__hero__reviewText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ReviewText_Operator>
  version__hero__richText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__RichText_Operator>
  version__hero__richTextMax?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__RichTextMax_Operator>
  version__hero__showReviews?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ShowReviews_Operator>
  version__hero__type?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Operator>
  version__hero__vertAlign?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Operator>
  version__meta__description?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Title_Operator>
  version__offerCategory?: InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Operator>
  version__parent?: InputMaybe<VersionsCmsMarketplacePage_Version__Parent_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsMarketplacePage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsMarketplacePage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsMarketplacePage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsMarketplacePage_Version__UpdatedAt_Operator>
}

export type VersionsCmsMarketplacePage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsMarketplacePage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsMarketplacePage_Id_Operator>
  latest?: InputMaybe<VersionsCmsMarketplacePage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsMarketplacePage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsMarketplacePage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsMarketplacePage_Version___Status_Operator>
  version__breadcrumbs__doc?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Doc_Operator>
  version__breadcrumbs__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Id_Operator>
  version__breadcrumbs__label?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Label_Operator>
  version__breadcrumbs__url?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Url_Operator>
  version__createdAt?: InputMaybe<VersionsCmsMarketplacePage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsMarketplacePage_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Url_Operator>
  version__hero__desktopFallback?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DesktopFallback_Operator>
  version__hero__desktopVideo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DesktopVideo_Operator>
  version__hero__disclaimerText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DisclaimerText_Operator>
  version__hero__heroSize?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HeroSize_Operator>
  version__hero__hzAlign?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Operator>
  version__hero__links__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Id_Operator>
  version__hero__links__link__iconAfter?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconAfter_Operator>
  version__hero__links__link__iconBefore?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconBefore_Operator>
  version__hero__links__link__label?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Label_Operator>
  version__hero__links__link__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__NewTab_Operator>
  version__hero__links__link__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Id_Operator>
  version__hero__links__link__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Key_Operator>
  version__hero__links__link__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Value_Operator>
  version__hero__links__link__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation>
  version__hero__links__link__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation>
  version__hero__links__link__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__TargetId_Operator>
  version__hero__links__link__type?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Operator>
  version__hero__links__link__url?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Url_Operator>
  version__hero__links__link__variant?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Operator>
  version__hero__media?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Media_Operator>
  version__hero__mobileFallback?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__MobileFallback_Operator>
  version__hero__mobileVideo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__MobileVideo_Operator>
  version__hero__productImage?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ProductImage_Operator>
  version__hero__reviewRating?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ReviewRating_Operator>
  version__hero__reviewText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ReviewText_Operator>
  version__hero__richText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__RichText_Operator>
  version__hero__richTextMax?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__RichTextMax_Operator>
  version__hero__showReviews?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ShowReviews_Operator>
  version__hero__type?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Operator>
  version__hero__vertAlign?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Operator>
  version__meta__description?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Title_Operator>
  version__offerCategory?: InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Operator>
  version__parent?: InputMaybe<VersionsCmsMarketplacePage_Version__Parent_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsMarketplacePage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsMarketplacePage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsMarketplacePage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsMarketplacePage_Version__UpdatedAt_Operator>
}

export type VersionsCmsMarketplacePage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsMarketplacePage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsMarketplacePage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsMarketplacePage_Id_Operator>
  latest?: InputMaybe<VersionsCmsMarketplacePage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsMarketplacePage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsMarketplacePage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsMarketplacePage_Version___Status_Operator>
  version__breadcrumbs__doc?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Doc_Operator>
  version__breadcrumbs__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Id_Operator>
  version__breadcrumbs__label?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Label_Operator>
  version__breadcrumbs__url?: InputMaybe<VersionsCmsMarketplacePage_Version__Breadcrumbs__Url_Operator>
  version__createdAt?: InputMaybe<VersionsCmsMarketplacePage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsMarketplacePage_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsMarketplacePage_Version__CustomHeader__SupportLink__Url_Operator>
  version__hero__desktopFallback?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DesktopFallback_Operator>
  version__hero__desktopVideo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DesktopVideo_Operator>
  version__hero__disclaimerText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__DisclaimerText_Operator>
  version__hero__heroSize?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HeroSize_Operator>
  version__hero__hzAlign?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__HzAlign_Operator>
  version__hero__links__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Id_Operator>
  version__hero__links__link__iconAfter?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconAfter_Operator>
  version__hero__links__link__iconBefore?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__IconBefore_Operator>
  version__hero__links__link__label?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Label_Operator>
  version__hero__links__link__newTab?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__NewTab_Operator>
  version__hero__links__link__query__id?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Id_Operator>
  version__hero__links__link__query__key?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Key_Operator>
  version__hero__links__link__query__value?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Query__Value_Operator>
  version__hero__links__link__reference?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reference_Relation>
  version__hero__links__link__reusable?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Reusable_Relation>
  version__hero__links__link__targetId?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__TargetId_Operator>
  version__hero__links__link__type?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Type_Operator>
  version__hero__links__link__url?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Url_Operator>
  version__hero__links__link__variant?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Links__Link__Variant_Operator>
  version__hero__media?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Media_Operator>
  version__hero__mobileFallback?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__MobileFallback_Operator>
  version__hero__mobileVideo?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__MobileVideo_Operator>
  version__hero__productImage?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ProductImage_Operator>
  version__hero__reviewRating?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ReviewRating_Operator>
  version__hero__reviewText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ReviewText_Operator>
  version__hero__richText?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__RichText_Operator>
  version__hero__richTextMax?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__RichTextMax_Operator>
  version__hero__showReviews?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__ShowReviews_Operator>
  version__hero__type?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__Type_Operator>
  version__hero__vertAlign?: InputMaybe<VersionsCmsMarketplacePage_Version__Hero__VertAlign_Operator>
  version__meta__description?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsMarketplacePage_Version__Meta__Title_Operator>
  version__offerCategory?: InputMaybe<VersionsCmsMarketplacePage_Version__OfferCategory_Operator>
  version__parent?: InputMaybe<VersionsCmsMarketplacePage_Version__Parent_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsMarketplacePage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsMarketplacePage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsMarketplacePage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsMarketplacePage_Version__UpdatedAt_Operator>
}

export type VersionsCmsMarketplacePages = {
  __typename?: 'versionsCmsMarketplacePages'
  docs?: Maybe<Array<Maybe<CmsMarketplacePageVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsNewsroomArticle_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsNewsroomArticle_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsNewsroomArticle_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsNewsroomArticle_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsNewsroomArticle_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsNewsroomArticle_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsNewsroomArticle_Version___Status_Input =
  (typeof VersionsCmsNewsroomArticle_Version___Status_Input)[keyof typeof VersionsCmsNewsroomArticle_Version___Status_Input]
export type VersionsCmsNewsroomArticle_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Input>>>
}

export type VersionsCmsNewsroomArticle_Version__Authors_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsNewsroomArticle_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input =
  (typeof VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input]
export type VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Input>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Input>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Input>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Input>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input =
  (typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input)[keyof typeof VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input]
export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Input>
}

export type VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsNewsroomArticle_Version__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsNewsroomArticle_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsNewsroomArticle_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsNewsroomArticle_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsNewsroomArticle_Version__RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsNewsroomArticle_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsNewsroomArticle_Version__WordpressPostId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsNewsroomArticle_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsNewsroomArticle_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsNewsroomArticle_Id_Operator>
  latest?: InputMaybe<VersionsCmsNewsroomArticle_Latest_Operator>
  parent?: InputMaybe<VersionsCmsNewsroomArticle_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsNewsroomArticle_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsNewsroomArticle_Version__Authors_Operator>
  version__createdAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsNewsroomArticle_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Url_Operator>
  version__excerpt?: InputMaybe<VersionsCmsNewsroomArticle_Version__Excerpt_Operator>
  version__image?: InputMaybe<VersionsCmsNewsroomArticle_Version__Image_Operator>
  version__meta__description?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__PublishedAt_Operator>
  version__richText?: InputMaybe<VersionsCmsNewsroomArticle_Version__RichText_Operator>
  version__slug?: InputMaybe<VersionsCmsNewsroomArticle_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsNewsroomArticle_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__UpdatedAt_Operator>
  version__wordpressPostId?: InputMaybe<VersionsCmsNewsroomArticle_Version__WordpressPostId_Operator>
}

export type VersionsCmsNewsroomArticle_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsNewsroomArticle_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsNewsroomArticle_Id_Operator>
  latest?: InputMaybe<VersionsCmsNewsroomArticle_Latest_Operator>
  parent?: InputMaybe<VersionsCmsNewsroomArticle_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsNewsroomArticle_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsNewsroomArticle_Version__Authors_Operator>
  version__createdAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsNewsroomArticle_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Url_Operator>
  version__excerpt?: InputMaybe<VersionsCmsNewsroomArticle_Version__Excerpt_Operator>
  version__image?: InputMaybe<VersionsCmsNewsroomArticle_Version__Image_Operator>
  version__meta__description?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__PublishedAt_Operator>
  version__richText?: InputMaybe<VersionsCmsNewsroomArticle_Version__RichText_Operator>
  version__slug?: InputMaybe<VersionsCmsNewsroomArticle_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsNewsroomArticle_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__UpdatedAt_Operator>
  version__wordpressPostId?: InputMaybe<VersionsCmsNewsroomArticle_Version__WordpressPostId_Operator>
}

export type VersionsCmsNewsroomArticle_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsNewsroomArticle_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsNewsroomArticle_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsNewsroomArticle_Id_Operator>
  latest?: InputMaybe<VersionsCmsNewsroomArticle_Latest_Operator>
  parent?: InputMaybe<VersionsCmsNewsroomArticle_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsNewsroomArticle_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsNewsroomArticle_Version___Status_Operator>
  version__authors?: InputMaybe<VersionsCmsNewsroomArticle_Version__Authors_Operator>
  version__createdAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsNewsroomArticle_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsNewsroomArticle_Version__CustomHeader__SupportLink__Url_Operator>
  version__excerpt?: InputMaybe<VersionsCmsNewsroomArticle_Version__Excerpt_Operator>
  version__image?: InputMaybe<VersionsCmsNewsroomArticle_Version__Image_Operator>
  version__meta__description?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsNewsroomArticle_Version__Meta__Title_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__PublishedAt_Operator>
  version__richText?: InputMaybe<VersionsCmsNewsroomArticle_Version__RichText_Operator>
  version__slug?: InputMaybe<VersionsCmsNewsroomArticle_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsNewsroomArticle_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsNewsroomArticle_Version__UpdatedAt_Operator>
  version__wordpressPostId?: InputMaybe<VersionsCmsNewsroomArticle_Version__WordpressPostId_Operator>
}

export type VersionsCmsNewsroomArticles = {
  __typename?: 'versionsCmsNewsroomArticles'
  docs?: Maybe<Array<Maybe<CmsNewsroomArticleVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsPage_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsPage_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsPage_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsPage_Version___Status_Input =
  (typeof VersionsCmsPage_Version___Status_Input)[keyof typeof VersionsCmsPage_Version___Status_Input]
export type VersionsCmsPage_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsPage_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsPage_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version___Status_Input>>>
}

export type VersionsCmsPage_Version__Breadcrumbs__Doc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Breadcrumbs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Breadcrumbs__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Breadcrumbs__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsPage_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input =
  (typeof VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input)[keyof typeof VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input]
export type VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input>>>
  equals?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input>>>
  not_equals?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Input>>>
}

export type VersionsCmsPage_Version__CustomFooter__Disclaimers__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Version__CustomFooter__Disclaimers__Number_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsPage_Version__CustomFooter__Disclaimers__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__CustomFooter__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input = {
  Solid: 'solid',
  Transparent: 'transparent',
} as const

export type VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input =
  (typeof VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input)[keyof typeof VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input]
export type VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input>>>
  equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input>>>
  not_equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Input>>>
}

export type VersionsCmsPage_Version__CustomHeader__IsHidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Version__CustomHeader__LoginLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation_RelationTo]
export type VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation_RelationTo]
export type VersionsCmsPage_Version__CustomHeader__LoginLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input =
  (typeof VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input)[keyof typeof VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input]
export type VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input>
  equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Input>
}

export type VersionsCmsPage_Version__CustomHeader__LoginLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SignupLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation_RelationTo]
export type VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation_RelationTo]
export type VersionsCmsPage_Version__CustomHeader__SignupLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input =
  (typeof VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input)[keyof typeof VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input]
export type VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input>
  equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Input>
}

export type VersionsCmsPage_Version__CustomHeader__SignupLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SupportLink__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation_RelationTo]
export type VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation_RelationTo]
export type VersionsCmsPage_Version__CustomHeader__SupportLink__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input =
  (typeof VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input)[keyof typeof VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input]
export type VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Operator = {
  contains?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input>
  equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input>
  not_equals?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Input>
}

export type VersionsCmsPage_Version__CustomHeader__SupportLink__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__DesktopFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Hero__DesktopVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Hero__DisclaimerText_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export const VersionsCmsPage_Version__Hero__HeroSize_Input = {
  Full: 'full',
  Partial: 'partial',
} as const

export type VersionsCmsPage_Version__Hero__HeroSize_Input =
  (typeof VersionsCmsPage_Version__Hero__HeroSize_Input)[keyof typeof VersionsCmsPage_Version__Hero__HeroSize_Input]
export type VersionsCmsPage_Version__Hero__HeroSize_Operator = {
  contains?: InputMaybe<VersionsCmsPage_Version__Hero__HeroSize_Input>
  equals?: InputMaybe<VersionsCmsPage_Version__Hero__HeroSize_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsPage_Version__Hero__HeroSize_Input>
  not_equals?: InputMaybe<VersionsCmsPage_Version__Hero__HeroSize_Input>
}

export const VersionsCmsPage_Version__Hero__HzAlign_Input = {
  Center: 'center',
  Left: 'left',
  Right: 'right',
} as const

export type VersionsCmsPage_Version__Hero__HzAlign_Input =
  (typeof VersionsCmsPage_Version__Hero__HzAlign_Input)[keyof typeof VersionsCmsPage_Version__Hero__HzAlign_Input]
export type VersionsCmsPage_Version__Hero__HzAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Input>>>
  equals?: InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Input>>>
  not_equals?: InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Input>>>
}

export type VersionsCmsPage_Version__Hero__Links__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__Links__Link__IconAfter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__Links__Link__IconBefore_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__Links__Link__Label_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__Links__Link__NewTab_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Version__Hero__Links__Link__Query__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__Links__Link__Query__Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__Links__Link__Query__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation_RelationTo = {
  Articles: 'articles',
  Guides: 'guides',
  Marketplace: 'marketplace',
  Newsroom: 'newsroom',
  Pages: 'pages',
} as const

export type VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation_RelationTo]
export type VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation = {
  relationTo?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation_RelationTo>
  value?: InputMaybe<Scalars['JSON']['input']>
}

export const VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation_RelationTo = {
  Links: 'links',
} as const

export type VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation_RelationTo =
  (typeof VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation_RelationTo)[keyof typeof VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation_RelationTo]
export type VersionsCmsPage_Version__Hero__Links__Link__TargetId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsPage_Version__Hero__Links__Link__Type_Input = {
  Custom: 'custom',
  Reference: 'reference',
  Reusable: 'reusable',
} as const

export type VersionsCmsPage_Version__Hero__Links__Link__Type_Input =
  (typeof VersionsCmsPage_Version__Hero__Links__Link__Type_Input)[keyof typeof VersionsCmsPage_Version__Hero__Links__Link__Type_Input]
export type VersionsCmsPage_Version__Hero__Links__Link__Type_Operator = {
  contains?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Type_Input>
  equals?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Type_Input>
  not_equals?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Type_Input>
}

export type VersionsCmsPage_Version__Hero__Links__Link__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsPage_Version__Hero__Links__Link__Variant_Input = {
  AppleApp: 'appleApp',
  Default: 'default',
  GoogleApp: 'googleApp',
  Plain: 'plain',
  Primary: 'primary',
  PrimaryCritical: 'primaryCritical',
  PrimaryPlain: 'primaryPlain',
  Prime: 'prime',
} as const

export type VersionsCmsPage_Version__Hero__Links__Link__Variant_Input =
  (typeof VersionsCmsPage_Version__Hero__Links__Link__Variant_Input)[keyof typeof VersionsCmsPage_Version__Hero__Links__Link__Variant_Input]
export type VersionsCmsPage_Version__Hero__Links__Link__Variant_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Input>>>
  equals?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Input>>>
  not_equals?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Input>>>
}

export type VersionsCmsPage_Version__Hero__Media_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Hero__MobileFallback_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Hero__MobileVideo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Hero__ProductImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Hero__ReviewRating_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsPage_Version__Hero__ReviewText_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Hero__RichTextMax_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsPage_Version__Hero__RichText_Operator = {
  contains?: InputMaybe<Scalars['JSON']['input']>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['JSON']['input']>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
}

export type VersionsCmsPage_Version__Hero__ShowReviews_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export const VersionsCmsPage_Version__Hero__Type_Input = {
  BannerHero: 'bannerHero',
  HighImpact: 'highImpact',
  MediumImpact: 'mediumImpact',
  None: 'none',
  ProductHero: 'productHero',
  VideoHero: 'videoHero',
} as const

export type VersionsCmsPage_Version__Hero__Type_Input =
  (typeof VersionsCmsPage_Version__Hero__Type_Input)[keyof typeof VersionsCmsPage_Version__Hero__Type_Input]
export type VersionsCmsPage_Version__Hero__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__Type_Input>>>
  equals?: InputMaybe<VersionsCmsPage_Version__Hero__Type_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__Type_Input>>>
  not_equals?: InputMaybe<VersionsCmsPage_Version__Hero__Type_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__Type_Input>>>
}

export const VersionsCmsPage_Version__Hero__VertAlign_Input = {
  Bottom: 'bottom',
  Center: 'center',
  Top: 'top',
} as const

export type VersionsCmsPage_Version__Hero__VertAlign_Input =
  (typeof VersionsCmsPage_Version__Hero__VertAlign_Input)[keyof typeof VersionsCmsPage_Version__Hero__VertAlign_Input]
export type VersionsCmsPage_Version__Hero__VertAlign_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Input>>>
  equals?: InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Input>>>
  not_equals?: InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Input>>>
}

export type VersionsCmsPage_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsPage_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__Meta__JsonLd_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsPage_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsPage_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsPage_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsPage_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsPage_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsPage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsPage_Id_Operator>
  latest?: InputMaybe<VersionsCmsPage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsPage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsPage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsPage_Version___Status_Operator>
  version__breadcrumbs__doc?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Doc_Operator>
  version__breadcrumbs__id?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Id_Operator>
  version__breadcrumbs__label?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Label_Operator>
  version__breadcrumbs__url?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Url_Operator>
  version__createdAt?: InputMaybe<VersionsCmsPage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsPage_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsPage_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsPage_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Url_Operator>
  version__hero__desktopFallback?: InputMaybe<VersionsCmsPage_Version__Hero__DesktopFallback_Operator>
  version__hero__desktopVideo?: InputMaybe<VersionsCmsPage_Version__Hero__DesktopVideo_Operator>
  version__hero__disclaimerText?: InputMaybe<VersionsCmsPage_Version__Hero__DisclaimerText_Operator>
  version__hero__heroSize?: InputMaybe<VersionsCmsPage_Version__Hero__HeroSize_Operator>
  version__hero__hzAlign?: InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Operator>
  version__hero__links__id?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Id_Operator>
  version__hero__links__link__iconAfter?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__IconAfter_Operator>
  version__hero__links__link__iconBefore?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__IconBefore_Operator>
  version__hero__links__link__label?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Label_Operator>
  version__hero__links__link__newTab?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__NewTab_Operator>
  version__hero__links__link__query__id?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Id_Operator>
  version__hero__links__link__query__key?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Key_Operator>
  version__hero__links__link__query__value?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Value_Operator>
  version__hero__links__link__reference?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation>
  version__hero__links__link__reusable?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation>
  version__hero__links__link__targetId?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__TargetId_Operator>
  version__hero__links__link__type?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Type_Operator>
  version__hero__links__link__url?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Url_Operator>
  version__hero__links__link__variant?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Operator>
  version__hero__media?: InputMaybe<VersionsCmsPage_Version__Hero__Media_Operator>
  version__hero__mobileFallback?: InputMaybe<VersionsCmsPage_Version__Hero__MobileFallback_Operator>
  version__hero__mobileVideo?: InputMaybe<VersionsCmsPage_Version__Hero__MobileVideo_Operator>
  version__hero__productImage?: InputMaybe<VersionsCmsPage_Version__Hero__ProductImage_Operator>
  version__hero__reviewRating?: InputMaybe<VersionsCmsPage_Version__Hero__ReviewRating_Operator>
  version__hero__reviewText?: InputMaybe<VersionsCmsPage_Version__Hero__ReviewText_Operator>
  version__hero__richText?: InputMaybe<VersionsCmsPage_Version__Hero__RichText_Operator>
  version__hero__richTextMax?: InputMaybe<VersionsCmsPage_Version__Hero__RichTextMax_Operator>
  version__hero__showReviews?: InputMaybe<VersionsCmsPage_Version__Hero__ShowReviews_Operator>
  version__hero__type?: InputMaybe<VersionsCmsPage_Version__Hero__Type_Operator>
  version__hero__vertAlign?: InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Operator>
  version__meta__description?: InputMaybe<VersionsCmsPage_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsPage_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsPage_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsPage_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsPage_Version__Meta__Title_Operator>
  version__parent?: InputMaybe<VersionsCmsPage_Version__Parent_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsPage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsPage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsPage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsPage_Version__UpdatedAt_Operator>
}

export type VersionsCmsPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsPage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsPage_Id_Operator>
  latest?: InputMaybe<VersionsCmsPage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsPage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsPage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsPage_Version___Status_Operator>
  version__breadcrumbs__doc?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Doc_Operator>
  version__breadcrumbs__id?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Id_Operator>
  version__breadcrumbs__label?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Label_Operator>
  version__breadcrumbs__url?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Url_Operator>
  version__createdAt?: InputMaybe<VersionsCmsPage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsPage_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsPage_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsPage_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Url_Operator>
  version__hero__desktopFallback?: InputMaybe<VersionsCmsPage_Version__Hero__DesktopFallback_Operator>
  version__hero__desktopVideo?: InputMaybe<VersionsCmsPage_Version__Hero__DesktopVideo_Operator>
  version__hero__disclaimerText?: InputMaybe<VersionsCmsPage_Version__Hero__DisclaimerText_Operator>
  version__hero__heroSize?: InputMaybe<VersionsCmsPage_Version__Hero__HeroSize_Operator>
  version__hero__hzAlign?: InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Operator>
  version__hero__links__id?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Id_Operator>
  version__hero__links__link__iconAfter?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__IconAfter_Operator>
  version__hero__links__link__iconBefore?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__IconBefore_Operator>
  version__hero__links__link__label?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Label_Operator>
  version__hero__links__link__newTab?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__NewTab_Operator>
  version__hero__links__link__query__id?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Id_Operator>
  version__hero__links__link__query__key?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Key_Operator>
  version__hero__links__link__query__value?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Value_Operator>
  version__hero__links__link__reference?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation>
  version__hero__links__link__reusable?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation>
  version__hero__links__link__targetId?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__TargetId_Operator>
  version__hero__links__link__type?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Type_Operator>
  version__hero__links__link__url?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Url_Operator>
  version__hero__links__link__variant?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Operator>
  version__hero__media?: InputMaybe<VersionsCmsPage_Version__Hero__Media_Operator>
  version__hero__mobileFallback?: InputMaybe<VersionsCmsPage_Version__Hero__MobileFallback_Operator>
  version__hero__mobileVideo?: InputMaybe<VersionsCmsPage_Version__Hero__MobileVideo_Operator>
  version__hero__productImage?: InputMaybe<VersionsCmsPage_Version__Hero__ProductImage_Operator>
  version__hero__reviewRating?: InputMaybe<VersionsCmsPage_Version__Hero__ReviewRating_Operator>
  version__hero__reviewText?: InputMaybe<VersionsCmsPage_Version__Hero__ReviewText_Operator>
  version__hero__richText?: InputMaybe<VersionsCmsPage_Version__Hero__RichText_Operator>
  version__hero__richTextMax?: InputMaybe<VersionsCmsPage_Version__Hero__RichTextMax_Operator>
  version__hero__showReviews?: InputMaybe<VersionsCmsPage_Version__Hero__ShowReviews_Operator>
  version__hero__type?: InputMaybe<VersionsCmsPage_Version__Hero__Type_Operator>
  version__hero__vertAlign?: InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Operator>
  version__meta__description?: InputMaybe<VersionsCmsPage_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsPage_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsPage_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsPage_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsPage_Version__Meta__Title_Operator>
  version__parent?: InputMaybe<VersionsCmsPage_Version__Parent_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsPage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsPage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsPage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsPage_Version__UpdatedAt_Operator>
}

export type VersionsCmsPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsPage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsPage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsPage_Id_Operator>
  latest?: InputMaybe<VersionsCmsPage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsPage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsPage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsPage_Version___Status_Operator>
  version__breadcrumbs__doc?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Doc_Operator>
  version__breadcrumbs__id?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Id_Operator>
  version__breadcrumbs__label?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Label_Operator>
  version__breadcrumbs__url?: InputMaybe<VersionsCmsPage_Version__Breadcrumbs__Url_Operator>
  version__createdAt?: InputMaybe<VersionsCmsPage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsPage_Version__CreatedBy_Operator>
  version__customFooter__disclaimers__align?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Align_Operator>
  version__customFooter__disclaimers__id?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Id_Operator>
  version__customFooter__disclaimers__includeAsterick?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__IncludeAsterick_Operator>
  version__customFooter__disclaimers__number?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Number_Operator>
  version__customFooter__disclaimers__text?: InputMaybe<VersionsCmsPage_Version__CustomFooter__Disclaimers__Text_Operator>
  version__customFooter__isHidden?: InputMaybe<VersionsCmsPage_Version__CustomFooter__IsHidden_Operator>
  version__customHeader__headerDisplay?: InputMaybe<VersionsCmsPage_Version__CustomHeader__HeaderDisplay_Operator>
  version__customHeader__isHidden?: InputMaybe<VersionsCmsPage_Version__CustomHeader__IsHidden_Operator>
  version__customHeader__loginLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__NewTab_Operator>
  version__customHeader__loginLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Id_Operator>
  version__customHeader__loginLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Key_Operator>
  version__customHeader__loginLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Query__Value_Operator>
  version__customHeader__loginLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reference_Relation>
  version__customHeader__loginLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Reusable_Relation>
  version__customHeader__loginLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__TargetId_Operator>
  version__customHeader__loginLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Type_Operator>
  version__customHeader__loginLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__LoginLink__Url_Operator>
  version__customHeader__signupLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__NewTab_Operator>
  version__customHeader__signupLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Id_Operator>
  version__customHeader__signupLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Key_Operator>
  version__customHeader__signupLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Query__Value_Operator>
  version__customHeader__signupLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reference_Relation>
  version__customHeader__signupLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Reusable_Relation>
  version__customHeader__signupLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__TargetId_Operator>
  version__customHeader__signupLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Type_Operator>
  version__customHeader__signupLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SignupLink__Url_Operator>
  version__customHeader__supportLink__newTab?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__NewTab_Operator>
  version__customHeader__supportLink__query__id?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Id_Operator>
  version__customHeader__supportLink__query__key?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Key_Operator>
  version__customHeader__supportLink__query__value?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Query__Value_Operator>
  version__customHeader__supportLink__reference?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reference_Relation>
  version__customHeader__supportLink__reusable?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Reusable_Relation>
  version__customHeader__supportLink__targetId?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__TargetId_Operator>
  version__customHeader__supportLink__type?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Type_Operator>
  version__customHeader__supportLink__url?: InputMaybe<VersionsCmsPage_Version__CustomHeader__SupportLink__Url_Operator>
  version__hero__desktopFallback?: InputMaybe<VersionsCmsPage_Version__Hero__DesktopFallback_Operator>
  version__hero__desktopVideo?: InputMaybe<VersionsCmsPage_Version__Hero__DesktopVideo_Operator>
  version__hero__disclaimerText?: InputMaybe<VersionsCmsPage_Version__Hero__DisclaimerText_Operator>
  version__hero__heroSize?: InputMaybe<VersionsCmsPage_Version__Hero__HeroSize_Operator>
  version__hero__hzAlign?: InputMaybe<VersionsCmsPage_Version__Hero__HzAlign_Operator>
  version__hero__links__id?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Id_Operator>
  version__hero__links__link__iconAfter?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__IconAfter_Operator>
  version__hero__links__link__iconBefore?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__IconBefore_Operator>
  version__hero__links__link__label?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Label_Operator>
  version__hero__links__link__newTab?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__NewTab_Operator>
  version__hero__links__link__query__id?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Id_Operator>
  version__hero__links__link__query__key?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Key_Operator>
  version__hero__links__link__query__value?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Query__Value_Operator>
  version__hero__links__link__reference?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reference_Relation>
  version__hero__links__link__reusable?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Reusable_Relation>
  version__hero__links__link__targetId?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__TargetId_Operator>
  version__hero__links__link__type?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Type_Operator>
  version__hero__links__link__url?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Url_Operator>
  version__hero__links__link__variant?: InputMaybe<VersionsCmsPage_Version__Hero__Links__Link__Variant_Operator>
  version__hero__media?: InputMaybe<VersionsCmsPage_Version__Hero__Media_Operator>
  version__hero__mobileFallback?: InputMaybe<VersionsCmsPage_Version__Hero__MobileFallback_Operator>
  version__hero__mobileVideo?: InputMaybe<VersionsCmsPage_Version__Hero__MobileVideo_Operator>
  version__hero__productImage?: InputMaybe<VersionsCmsPage_Version__Hero__ProductImage_Operator>
  version__hero__reviewRating?: InputMaybe<VersionsCmsPage_Version__Hero__ReviewRating_Operator>
  version__hero__reviewText?: InputMaybe<VersionsCmsPage_Version__Hero__ReviewText_Operator>
  version__hero__richText?: InputMaybe<VersionsCmsPage_Version__Hero__RichText_Operator>
  version__hero__richTextMax?: InputMaybe<VersionsCmsPage_Version__Hero__RichTextMax_Operator>
  version__hero__showReviews?: InputMaybe<VersionsCmsPage_Version__Hero__ShowReviews_Operator>
  version__hero__type?: InputMaybe<VersionsCmsPage_Version__Hero__Type_Operator>
  version__hero__vertAlign?: InputMaybe<VersionsCmsPage_Version__Hero__VertAlign_Operator>
  version__meta__description?: InputMaybe<VersionsCmsPage_Version__Meta__Description_Operator>
  version__meta__image?: InputMaybe<VersionsCmsPage_Version__Meta__Image_Operator>
  version__meta__jsonLD?: InputMaybe<VersionsCmsPage_Version__Meta__JsonLd_Operator>
  version__meta__noIndex?: InputMaybe<VersionsCmsPage_Version__Meta__NoIndex_Operator>
  version__meta__title?: InputMaybe<VersionsCmsPage_Version__Meta__Title_Operator>
  version__parent?: InputMaybe<VersionsCmsPage_Version__Parent_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsPage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsPage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsPage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsPage_Version__UpdatedAt_Operator>
}

export type VersionsCmsPages = {
  __typename?: 'versionsCmsPages'
  docs?: Maybe<Array<Maybe<CmsPageVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsStackerPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsStackerPage_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsStackerPage_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsStackerPage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsStackerPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsStackerPage_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsStackerPage_Version___Status_Input =
  (typeof VersionsCmsStackerPage_Version___Status_Input)[keyof typeof VersionsCmsStackerPage_Version___Status_Input]
export type VersionsCmsStackerPage_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsStackerPage_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsStackerPage_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Version___Status_Input>>>
}

export type VersionsCmsStackerPage_Version__AffiliateCode_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsStackerPage_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsStackerPage_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export const VersionsCmsStackerPage_Version__OfferCategories__Category_Input = {
  Accounting: 'accounting',
  BusinessChecking: 'businessChecking',
  BusinessCreditCards: 'businessCreditCards',
  BusinessFormation: 'businessFormation',
  BusinessInsurance: 'businessInsurance',
  BusinessLoans: 'businessLoans',
  BusinessTaxes: 'businessTaxes',
  MerchantServices: 'merchantServices',
  Payroll: 'payroll',
  PersonalCreditCards: 'personalCreditCards',
} as const

export type VersionsCmsStackerPage_Version__OfferCategories__Category_Input =
  (typeof VersionsCmsStackerPage_Version__OfferCategories__Category_Input)[keyof typeof VersionsCmsStackerPage_Version__OfferCategories__Category_Input]
export type VersionsCmsStackerPage_Version__OfferCategories__Category_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Input>>>
  equals?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Input>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Input>>>
  not_equals?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Input>>>
}

export type VersionsCmsStackerPage_Version__OfferCategories__Collection_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsStackerPage_Version__OfferCategories__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsStackerPage_Version__OfferCategories__Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsStackerPage_Version__OfferCategories__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsStackerPage_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsStackerPage_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsStackerPage_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsStackerPage_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsStackerPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsStackerPage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsStackerPage_Id_Operator>
  latest?: InputMaybe<VersionsCmsStackerPage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsStackerPage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsStackerPage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsStackerPage_Version___Status_Operator>
  version__affiliateCode?: InputMaybe<VersionsCmsStackerPage_Version__AffiliateCode_Operator>
  version__createdAt?: InputMaybe<VersionsCmsStackerPage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsStackerPage_Version__CreatedBy_Operator>
  version__offerCategories__category?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Operator>
  version__offerCategories__collection?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Collection_Operator>
  version__offerCategories__id?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Id_Operator>
  version__offerCategories__name?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Name_Operator>
  version__offerCategories__slug?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Slug_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsStackerPage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsStackerPage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsStackerPage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsStackerPage_Version__UpdatedAt_Operator>
}

export type VersionsCmsStackerPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsStackerPage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsStackerPage_Id_Operator>
  latest?: InputMaybe<VersionsCmsStackerPage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsStackerPage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsStackerPage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsStackerPage_Version___Status_Operator>
  version__affiliateCode?: InputMaybe<VersionsCmsStackerPage_Version__AffiliateCode_Operator>
  version__createdAt?: InputMaybe<VersionsCmsStackerPage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsStackerPage_Version__CreatedBy_Operator>
  version__offerCategories__category?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Operator>
  version__offerCategories__collection?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Collection_Operator>
  version__offerCategories__id?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Id_Operator>
  version__offerCategories__name?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Name_Operator>
  version__offerCategories__slug?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Slug_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsStackerPage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsStackerPage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsStackerPage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsStackerPage_Version__UpdatedAt_Operator>
}

export type VersionsCmsStackerPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsStackerPage_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsStackerPage_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsStackerPage_Id_Operator>
  latest?: InputMaybe<VersionsCmsStackerPage_Latest_Operator>
  parent?: InputMaybe<VersionsCmsStackerPage_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsStackerPage_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsStackerPage_Version___Status_Operator>
  version__affiliateCode?: InputMaybe<VersionsCmsStackerPage_Version__AffiliateCode_Operator>
  version__createdAt?: InputMaybe<VersionsCmsStackerPage_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsStackerPage_Version__CreatedBy_Operator>
  version__offerCategories__category?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Category_Operator>
  version__offerCategories__collection?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Collection_Operator>
  version__offerCategories__id?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Id_Operator>
  version__offerCategories__name?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Name_Operator>
  version__offerCategories__slug?: InputMaybe<VersionsCmsStackerPage_Version__OfferCategories__Slug_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsStackerPage_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsStackerPage_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsStackerPage_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsStackerPage_Version__UpdatedAt_Operator>
}

export type VersionsCmsStackerPages = {
  __typename?: 'versionsCmsStackerPages'
  docs?: Maybe<Array<Maybe<CmsStackerPageVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsTradeCreditProgram_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditProgram_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsTradeCreditProgram_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsTradeCreditProgram_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditProgram_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsTradeCreditProgram_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsTradeCreditProgram_Version___Status_Input =
  (typeof VersionsCmsTradeCreditProgram_Version___Status_Input)[keyof typeof VersionsCmsTradeCreditProgram_Version___Status_Input]
export type VersionsCmsTradeCreditProgram_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Input>>>
}

export type VersionsCmsTradeCreditProgram_Version__ApplyUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditProgram_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditProgram_Version__CreditLimitHighCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__CreditLimitLowCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Fees__AmountHighCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Fees__AmountLowCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Fees__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input = {
  Annual: 'annual',
  Biannual: 'biannual',
  Monthly: 'monthly',
  OneTime: 'one_time',
  Quarterly: 'quarterly',
  Unspecified: 'unspecified',
} as const

export type VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input =
  (typeof VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input)[keyof typeof VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input]
export type VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input>>>
  equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input>>>
  not_equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Input>>>
}

export type VersionsCmsTradeCreditProgram_Version__MinReqs__AmountCents_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__MinReqs__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export const VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input = {
  Month: 'month',
  Order: 'order',
  Quarter: 'quarter',
  Unspecified: 'unspecified',
  Year: 'year',
} as const

export type VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input =
  (typeof VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input)[keyof typeof VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input]
export type VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input>>>
  equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input>>>
  not_equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Input>>>
}

export type VersionsCmsTradeCreditProgram_Version__Notes_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsTradeCreditProgram_Version__ReportsTo_Input = {
  Ansonia: 'ansonia',
  Cortera: 'cortera',
  CreditSafe: 'credit_safe',
  DunAndBradstreet: 'dun_and_bradstreet',
  Equifax: 'equifax',
  Experian: 'experian',
  Moodys: 'moodys',
  Unspecified: 'unspecified',
} as const

export type VersionsCmsTradeCreditProgram_Version__ReportsTo_Input =
  (typeof VersionsCmsTradeCreditProgram_Version__ReportsTo_Input)[keyof typeof VersionsCmsTradeCreditProgram_Version__ReportsTo_Input]
export type VersionsCmsTradeCreditProgram_Version__ReportsTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Input>>>
  equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Input>>>
  not_equals?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Input>>>
}

export type VersionsCmsTradeCreditProgram_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditProgram_Version__Tags_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditProgram_Version__Terms__DiscountDurationDays_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Terms__DiscountPercentage_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Terms__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditProgram_Version__Terms__NetDueAfterDays_Operator = {
  equals?: InputMaybe<Scalars['Float']['input']>
  greater_than?: InputMaybe<Scalars['Float']['input']>
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>
  less_than?: InputMaybe<Scalars['Float']['input']>
  less_than_equal?: InputMaybe<Scalars['Float']['input']>
  not_equals?: InputMaybe<Scalars['Float']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditProgram_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditProgram_Version__Vendor_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditProgram_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditProgram_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditProgram_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditProgram_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditProgram_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditProgram_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Operator>
  version__applyUrl?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ApplyUrl_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreatedBy_Operator>
  version__creditLimitHighCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreditLimitHighCents_Operator>
  version__creditLimitLowCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreditLimitLowCents_Operator>
  version__description?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Description_Operator>
  version__fees__amountHighCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__AmountHighCents_Operator>
  version__fees__amountLowCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__AmountLowCents_Operator>
  version__fees__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__Id_Operator>
  version__fees__paymentPeriod?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Operator>
  version__minReqs__amountCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__AmountCents_Operator>
  version__minReqs__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__Id_Operator>
  version__minReqs__orderUnit?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Operator>
  version__notes?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Notes_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__PublishedAt_Operator>
  version__reportsTo?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Slug_Operator>
  version__tags?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Tags_Operator>
  version__terms__discountDurationDays?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__DiscountDurationDays_Operator>
  version__terms__discountPercentage?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__DiscountPercentage_Operator>
  version__terms__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__Id_Operator>
  version__terms__netDueAfterDays?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__NetDueAfterDays_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__UpdatedAt_Operator>
  version__vendor?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Vendor_Operator>
}

export type VersionsCmsTradeCreditProgram_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditProgram_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditProgram_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditProgram_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditProgram_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditProgram_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Operator>
  version__applyUrl?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ApplyUrl_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreatedBy_Operator>
  version__creditLimitHighCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreditLimitHighCents_Operator>
  version__creditLimitLowCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreditLimitLowCents_Operator>
  version__description?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Description_Operator>
  version__fees__amountHighCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__AmountHighCents_Operator>
  version__fees__amountLowCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__AmountLowCents_Operator>
  version__fees__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__Id_Operator>
  version__fees__paymentPeriod?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Operator>
  version__minReqs__amountCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__AmountCents_Operator>
  version__minReqs__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__Id_Operator>
  version__minReqs__orderUnit?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Operator>
  version__notes?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Notes_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__PublishedAt_Operator>
  version__reportsTo?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Slug_Operator>
  version__tags?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Tags_Operator>
  version__terms__discountDurationDays?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__DiscountDurationDays_Operator>
  version__terms__discountPercentage?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__DiscountPercentage_Operator>
  version__terms__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__Id_Operator>
  version__terms__netDueAfterDays?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__NetDueAfterDays_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__UpdatedAt_Operator>
  version__vendor?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Vendor_Operator>
}

export type VersionsCmsTradeCreditProgram_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditProgram_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditProgram_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditProgram_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditProgram_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditProgram_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditProgram_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditProgram_Version___Status_Operator>
  version__applyUrl?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ApplyUrl_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreatedBy_Operator>
  version__creditLimitHighCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreditLimitHighCents_Operator>
  version__creditLimitLowCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__CreditLimitLowCents_Operator>
  version__description?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Description_Operator>
  version__fees__amountHighCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__AmountHighCents_Operator>
  version__fees__amountLowCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__AmountLowCents_Operator>
  version__fees__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__Id_Operator>
  version__fees__paymentPeriod?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Fees__PaymentPeriod_Operator>
  version__minReqs__amountCents?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__AmountCents_Operator>
  version__minReqs__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__Id_Operator>
  version__minReqs__orderUnit?: InputMaybe<VersionsCmsTradeCreditProgram_Version__MinReqs__OrderUnit_Operator>
  version__notes?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Notes_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__PublishedAt_Operator>
  version__reportsTo?: InputMaybe<VersionsCmsTradeCreditProgram_Version__ReportsTo_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Slug_Operator>
  version__tags?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Tags_Operator>
  version__terms__discountDurationDays?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__DiscountDurationDays_Operator>
  version__terms__discountPercentage?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__DiscountPercentage_Operator>
  version__terms__id?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__Id_Operator>
  version__terms__netDueAfterDays?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Terms__NetDueAfterDays_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditProgram_Version__UpdatedAt_Operator>
  version__vendor?: InputMaybe<VersionsCmsTradeCreditProgram_Version__Vendor_Operator>
}

export type VersionsCmsTradeCreditPrograms = {
  __typename?: 'versionsCmsTradeCreditPrograms'
  docs?: Maybe<Array<Maybe<CmsTradeCreditProgramVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsTradeCreditRecommendation_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditRecommendation_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsTradeCreditRecommendation_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsTradeCreditRecommendation_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditRecommendation_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsTradeCreditRecommendation_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsTradeCreditRecommendation_Version___Status_Input =
  (typeof VersionsCmsTradeCreditRecommendation_Version___Status_Input)[keyof typeof VersionsCmsTradeCreditRecommendation_Version___Status_Input]
export type VersionsCmsTradeCreditRecommendation_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Input>>>
}

export type VersionsCmsTradeCreditRecommendation_Version__ApplyUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditRecommendation_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditRecommendation_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditRecommendation_Version__Description_Operator = {
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
}

export type VersionsCmsTradeCreditRecommendation_Version__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditRecommendation_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditRecommendation_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditRecommendation_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditRecommendation_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditRecommendation_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditRecommendation_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditRecommendation_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditRecommendation_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Operator>
  version__applyUrl?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__ApplyUrl_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__CreatedBy_Operator>
  version__description?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Description_Operator>
  version__image?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Image_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__UpdatedAt_Operator>
}

export type VersionsCmsTradeCreditRecommendation_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditRecommendation_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditRecommendation_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditRecommendation_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Operator>
  version__applyUrl?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__ApplyUrl_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__CreatedBy_Operator>
  version__description?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Description_Operator>
  version__image?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Image_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__UpdatedAt_Operator>
}

export type VersionsCmsTradeCreditRecommendation_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditRecommendation_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditRecommendation_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditRecommendation_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditRecommendation_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version___Status_Operator>
  version__applyUrl?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__ApplyUrl_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__CreatedBy_Operator>
  version__description?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Description_Operator>
  version__image?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Image_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditRecommendation_Version__UpdatedAt_Operator>
}

export type VersionsCmsTradeCreditRecommendations = {
  __typename?: 'versionsCmsTradeCreditRecommendations'
  docs?: Maybe<Array<Maybe<CmsTradeCreditRecommendationVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VersionsCmsTradeCreditVendor_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditVendor_Id_Operator = {
  equals?: InputMaybe<Scalars['Int']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['Int']['input']>
  greater_than_equal?: InputMaybe<Scalars['Int']['input']>
  less_than?: InputMaybe<Scalars['Int']['input']>
  less_than_equal?: InputMaybe<Scalars['Int']['input']>
  not_equals?: InputMaybe<Scalars['Int']['input']>
}

export type VersionsCmsTradeCreditVendor_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsTradeCreditVendor_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditVendor_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export const VersionsCmsTradeCreditVendor_Version___Status_Input = {
  Draft: 'draft',
  Published: 'published',
} as const

export type VersionsCmsTradeCreditVendor_Version___Status_Input =
  (typeof VersionsCmsTradeCreditVendor_Version___Status_Input)[keyof typeof VersionsCmsTradeCreditVendor_Version___Status_Input]
export type VersionsCmsTradeCreditVendor_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Input>>>
  equals?: InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Input>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Input>>>
  not_equals?: InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Input>
  not_in?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Input>>>
}

export type VersionsCmsTradeCreditVendor_Version__Active_Operator = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  not_equals?: InputMaybe<Scalars['Boolean']['input']>
}

export type VersionsCmsTradeCreditVendor_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditVendor_Version__CreatedBy_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditVendor_Version__Logo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  equals?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  not_equals?: InputMaybe<Scalars['JSON']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
}

export type VersionsCmsTradeCreditVendor_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditVendor_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditVendor_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditVendor_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']['input']>
  exists?: InputMaybe<Scalars['Boolean']['input']>
  greater_than?: InputMaybe<Scalars['DateTime']['input']>
  greater_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  less_than?: InputMaybe<Scalars['DateTime']['input']>
  less_than_equal?: InputMaybe<Scalars['DateTime']['input']>
  like?: InputMaybe<Scalars['DateTime']['input']>
  not_equals?: InputMaybe<Scalars['DateTime']['input']>
}

export type VersionsCmsTradeCreditVendor_Version__WebsiteUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  like?: InputMaybe<Scalars['String']['input']>
  not_equals?: InputMaybe<Scalars['String']['input']>
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type VersionsCmsTradeCreditVendor_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditVendor_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditVendor_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditVendor_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditVendor_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditVendor_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Operator>
  version__active?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Active_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditVendor_Version__CreatedBy_Operator>
  version__logo?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Logo_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__UpdatedAt_Operator>
  version__websiteUrl?: InputMaybe<VersionsCmsTradeCreditVendor_Version__WebsiteUrl_Operator>
}

export type VersionsCmsTradeCreditVendor_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditVendor_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditVendor_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditVendor_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditVendor_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditVendor_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Operator>
  version__active?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Active_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditVendor_Version__CreatedBy_Operator>
  version__logo?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Logo_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__UpdatedAt_Operator>
  version__websiteUrl?: InputMaybe<VersionsCmsTradeCreditVendor_Version__WebsiteUrl_Operator>
}

export type VersionsCmsTradeCreditVendor_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Where_And>>>
  OR?: InputMaybe<Array<InputMaybe<VersionsCmsTradeCreditVendor_Where_Or>>>
  createdAt?: InputMaybe<VersionsCmsTradeCreditVendor_CreatedAt_Operator>
  id?: InputMaybe<VersionsCmsTradeCreditVendor_Id_Operator>
  latest?: InputMaybe<VersionsCmsTradeCreditVendor_Latest_Operator>
  parent?: InputMaybe<VersionsCmsTradeCreditVendor_Parent_Operator>
  updatedAt?: InputMaybe<VersionsCmsTradeCreditVendor_UpdatedAt_Operator>
  version___status?: InputMaybe<VersionsCmsTradeCreditVendor_Version___Status_Operator>
  version__active?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Active_Operator>
  version__createdAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__CreatedAt_Operator>
  version__createdBy?: InputMaybe<VersionsCmsTradeCreditVendor_Version__CreatedBy_Operator>
  version__logo?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Logo_Operator>
  version__publishedAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__PublishedAt_Operator>
  version__slug?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Slug_Operator>
  version__title?: InputMaybe<VersionsCmsTradeCreditVendor_Version__Title_Operator>
  version__updatedAt?: InputMaybe<VersionsCmsTradeCreditVendor_Version__UpdatedAt_Operator>
  version__websiteUrl?: InputMaybe<VersionsCmsTradeCreditVendor_Version__WebsiteUrl_Operator>
}

export type VersionsCmsTradeCreditVendors = {
  __typename?: 'versionsCmsTradeCreditVendors'
  docs?: Maybe<Array<Maybe<CmsTradeCreditVendorVersion>>>
  hasNextPage?: Maybe<Scalars['Boolean']['output']>
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>
  limit?: Maybe<Scalars['Int']['output']>
  nextPage?: Maybe<Scalars['Int']['output']>
  offset?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  pagingCounter?: Maybe<Scalars['Int']['output']>
  prevPage?: Maybe<Scalars['Int']['output']>
  totalDocs?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

export type VideosAccess = {
  __typename?: 'videosAccess'
  create?: Maybe<VideosCreateAccess>
  delete?: Maybe<VideosDeleteAccess>
  fields?: Maybe<VideosFields>
  read?: Maybe<VideosReadAccess>
  update?: Maybe<VideosUpdateAccess>
}

export type VideosDocAccess = {
  __typename?: 'videosDocAccess'
  create?: Maybe<VideosCreateDocAccess>
  delete?: Maybe<VideosDeleteDocAccess>
  fields?: Maybe<VideosDocAccessFields>
  read?: Maybe<VideosReadDocAccess>
  update?: Maybe<VideosUpdateDocAccess>
}

export type PopulateRedirectsQueryVariables = Exact<{ [key: string]: never }>

export type PopulateRedirectsQuery = {
  __typename?: 'Query'
  CmsRedirects?: {
    __typename?: 'CmsRedirects'
    docs?: Array<{
      __typename?: 'CmsRedirect'
      permanent?: boolean | null
      from: string
      to?: {
        __typename?: 'CmsRedirect_To'
        type?: CmsRedirect_To_Type | null
        url?: string | null
        reference?: {
          __typename?: 'CmsRedirect_To_Reference_Relationship'
          relationTo?: CmsRedirect_To_Reference_RelationTo | null
          value?:
            | { __typename?: 'CmsArticle'; slug?: string | null }
            | { __typename?: 'CmsGuide'; slug?: string | null }
            | {
                __typename?: 'CmsMarketplacePage'
                slug?: string | null
                parent?: { __typename?: 'CmsMarketplacePage'; slug?: string | null } | null
              }
            | { __typename?: 'CmsNewsroomArticle'; slug?: string | null }
            | {
                __typename?: 'CmsPage'
                slug?: string | null
                parent?: { __typename?: 'CmsPage'; slug?: string | null } | null
              }
            | { __typename?: 'CmsStackerPage'; slug?: string | null }
            | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SettingsQueryVariables = Exact<{ [key: string]: never }>

export type SettingsQuery = {
  __typename?: 'Query'
  CmsSettings?: {
    __typename?: 'CmsSettings'
    logo?:
      | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
      | null
    sameAs?: Array<{ __typename?: 'CmsSettings_SameAs'; value?: string | null }> | null
  } | null
}

export type AccordionFragmentFragment = {
  __typename?: 'CmsAccordion'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsAccordion_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  accordionItems?: Array<{
    __typename?: 'CmsAccordion_AccordionItems'
    title?: string | null
    mainContent?: any | null
  }> | null
} & { ' $fragmentName'?: 'AccordionFragmentFragment' }

export type AlertBannerBlockFragmentFragment = {
  __typename?: 'CmsAlertBannerBlock'
  alert?: {
    __typename?: 'CmsAlertBannerBlock_Alert'
    richText?: any | null
    intent?: CmsAlertBannerBlock_Alert_Intent | null
  } | null
} & { ' $fragmentName'?: 'AlertBannerBlockFragmentFragment' }

export type ArchiveFragmentFragment = {
  __typename?: 'CmsArchive'
  invertBackground?: boolean | null
  populateBy?: CmsArchive_PopulateBy | null
  resourceCategory?: CmsArchive_ResourceCategory | null
  limit?: number | null
  populatedDocsTotal?: number | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsArchive_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  categories?: Array<
    { __typename?: 'CmsCategories' } & {
      ' $fragmentRefs'?: { CollectionArchiveCategoriesFragmentFragment: CollectionArchiveCategoriesFragmentFragment }
    }
  > | null
  selectedDocs?: Array<
    { __typename?: 'CmsArchive_SelectedDocs_Relationship' } & {
      ' $fragmentRefs'?: { CollectionArchiveSelectedDocsFragment: CollectionArchiveSelectedDocsFragment }
    }
  > | null
  populatedDocs?: Array<
    { __typename?: 'CmsArchive_PopulatedDocs_Relationship' } & {
      ' $fragmentRefs'?: { CollectionArchivePopulatedDocsFragment: CollectionArchivePopulatedDocsFragment }
    }
  > | null
} & { ' $fragmentName'?: 'ArchiveFragmentFragment' }

export type BentoFragmentFragment = {
  __typename?: 'CmsBento'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsBento_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  rows?: Array<{
    __typename?: 'CmsBento_Rows'
    cols?: Array<{
      __typename?: 'CmsBento_Rows_Cols'
      size?: CmsBento_Rows_Cols_Size | null
      richText?: any | null
      bgMedia?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
      overlay?: Array<{
        __typename?: 'CmsBento_Rows_Cols_Overlay'
        size?: CmsBento_Rows_Cols_Overlay_Size | null
        media?: { __typename?: 'CmsMedia'; url?: string | null; alt: string } | null
      }> | null
    }> | null
  }> | null
} & { ' $fragmentName'?: 'BentoFragmentFragment' }

export type BlocksWithExperimentFragmentFragment = {
  __typename?: 'CmsContentLayout'
  layout?: Array<
    | ({ __typename: 'CmsAccordion' } & { ' $fragmentRefs'?: { AccordionFragmentFragment: AccordionFragmentFragment } })
    | ({ __typename: 'CmsAlertBannerBlock' } & {
        ' $fragmentRefs'?: { AlertBannerBlockFragmentFragment: AlertBannerBlockFragmentFragment }
      })
    | ({ __typename: 'CmsArchive' } & { ' $fragmentRefs'?: { ArchiveFragmentFragment: ArchiveFragmentFragment } })
    | ({ __typename: 'CmsBento' } & { ' $fragmentRefs'?: { BentoFragmentFragment: BentoFragmentFragment } })
    | ({ __typename: 'CmsCTA' } & {
        ' $fragmentRefs'?: { CallToActionBlockFragmentFragment: CallToActionBlockFragmentFragment }
      })
    | ({ __typename: 'CmsCalloutBlock' } & {
        ' $fragmentRefs'?: { CalloutBlockFragmentFragment: CalloutBlockFragmentFragment }
      })
    | ({ __typename: 'CmsCarousel' } & { ' $fragmentRefs'?: { CarouselFragmentFragment: CarouselFragmentFragment } })
    | ({ __typename: 'CmsContent' } & { ' $fragmentRefs'?: { ContentFragmentFragment: ContentFragmentFragment } })
    | ({ __typename: 'CmsCrossLinks' } & {
        ' $fragmentRefs'?: { CrossLinksFragmentFragment: CrossLinksFragmentFragment }
      })
    | ({ __typename: 'CmsDevicePreview' } & {
        ' $fragmentRefs'?: { DevicePreviewFragmentFragment: DevicePreviewFragmentFragment }
      })
    | ({ __typename: 'CmsDisclaimers' } & {
        ' $fragmentRefs'?: { DisclaimersFragmentFragment: DisclaimersFragmentFragment }
      })
    | ({ __typename: 'CmsDownloadBanner' } & {
        ' $fragmentRefs'?: { DownloadBannerFragmentFragment: DownloadBannerFragmentFragment }
      })
    | ({ __typename: 'CmsExperiment' } & {
        ' $fragmentRefs'?: { ExperimentFragmentFragment: ExperimentFragmentFragment }
      })
    | ({ __typename: 'CmsFeatureGrid' } & {
        ' $fragmentRefs'?: { FeatureGridFragmentFragment: FeatureGridFragmentFragment }
      })
    | ({ __typename: 'CmsFeatureSection' } & {
        ' $fragmentRefs'?: { FeatureSectionFragmentFragment: FeatureSectionFragmentFragment }
      })
    | ({ __typename: 'CmsFormBlock' } & { ' $fragmentRefs'?: { FormBlockFragmentFragment: FormBlockFragmentFragment } })
    | ({ __typename: 'CmsImageBlock' } & {
        ' $fragmentRefs'?: { ImageBlockFragmentFragment: ImageBlockFragmentFragment }
      })
    | ({ __typename: 'CmsLegalBlock' } & {
        ' $fragmentRefs'?: { LegalBlockFragmentFragment: LegalBlockFragmentFragment }
      })
    | ({ __typename: 'CmsOfferBlock' } & {
        ' $fragmentRefs'?: { OfferBlockFragmentFragment: OfferBlockFragmentFragment }
      })
    | ({ __typename: 'CmsPriceTier' } & { ' $fragmentRefs'?: { PriceTierFragmentFragment: PriceTierFragmentFragment } })
    | ({ __typename: 'CmsProsConsBlock' } & {
        ' $fragmentRefs'?: { ProsConsFragmentFragment: ProsConsFragmentFragment }
      })
    | ({ __typename: 'CmsQuote' } & { ' $fragmentRefs'?: { QuoteFragmentFragment: QuoteFragmentFragment } })
    | ({ __typename: 'CmsResources' } & { ' $fragmentRefs'?: { ResourcesFragmentFragment: ResourcesFragmentFragment } })
    | ({ __typename: 'CmsRichTextBlock' } & {
        ' $fragmentRefs'?: { RichTextBlockFragmentFragment: RichTextBlockFragmentFragment }
      })
    | ({ __typename: 'CmsRichTextSection' } & {
        ' $fragmentRefs'?: { RichTextSectionFragmentFragment: RichTextSectionFragmentFragment }
      })
    | ({ __typename: 'CmsTableBlock' } & {
        ' $fragmentRefs'?: { TableBlockFragmentFragment: TableBlockFragmentFragment }
      })
    | ({ __typename: 'CmsVideoBlock' } & {
        ' $fragmentRefs'?: { VideoBlockFragmentFragment: VideoBlockFragmentFragment }
      })
    | ({ __typename: 'CmsVideoEmbedBlock' } & {
        ' $fragmentRefs'?: { VideoEmbedBlockFragmentFragment: VideoEmbedBlockFragmentFragment }
      })
  > | null
} & { ' $fragmentName'?: 'BlocksWithExperimentFragmentFragment' }

export type CallToActionBlockFragmentFragment = {
  __typename?: 'CmsCTA'
  headline?: any | null
  ctaBannerType?: CmsCta_CtaBannerType | null
  showReviews?: boolean | null
  reviewText?: string | null
  reviewRating?: number | null
  media?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
  links?: Array<{
    __typename?: 'CmsCTA_Links'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  productImage?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'CallToActionBlockFragmentFragment' }

export type CalloutBlockFragmentFragment = {
  __typename?: 'CmsCalloutBlock'
  calloutReference?: {
    __typename?: 'CmsCallout'
    callout?: {
      __typename?: 'CmsCallout_Callout'
      iconName?: string | null
      heading?: string | null
      richText?: any | null
      emphasis?: CmsCallout_Callout_Emphasis | null
      intent?: CmsCallout_Callout_Intent | null
      links?: Array<{
        __typename?: 'CmsCallout_Callout_Links'
        link?:
          | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
          | null
      }> | null
    } | null
  } | null
} & { ' $fragmentName'?: 'CalloutBlockFragmentFragment' }

export type CarouselFragmentFragment = {
  __typename?: 'CmsCarousel'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsCarousel_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  slides?: Array<{
    __typename?: 'CmsCarousel_Slides'
    media?:
      | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
      | null
  }> | null
} & { ' $fragmentName'?: 'CarouselFragmentFragment' }

export type ContentFragmentFragment = {
  __typename?: 'CmsContent'
  invertBackground?: boolean | null
  columnsAlign?: CmsContent_ColumnsAlign | null
  columnsMaxWidth?: number | null
  columns?: Array<{
    __typename?: 'CmsContent_Columns'
    richText?: any | null
    colSpanLg?: number | null
    colSpanMd?: number | null
    colSpanSm?: number | null
    ctaAlign?: CmsContent_Columns_CtaAlign | null
    ctas?: Array<{
      __typename?: 'CmsContent_Columns_Ctas'
      link?:
        | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
        | null
    }> | null
  }> | null
} & { ' $fragmentName'?: 'ContentFragmentFragment' }

export type CrossLinksFragmentFragment = {
  __typename?: 'CmsCrossLinks'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsCrossLinks_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  crossLinksCards?: Array<{
    __typename?: 'CmsCrossLinks_CrossLinksCards'
    topic?: string | null
    title?: string | null
    media?:
      | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
      | null
    selectedDoc?: {
      __typename?: 'CmsCrossLinks_CrossLinksCards_SelectedDoc_Relationship'
      relationTo?: CmsCrossLinks_CrossLinksCards_SelectedDoc_RelationTo | null
      value?:
        | {
            __typename?: 'CmsArticle'
            id: number
            slug?: string | null
            title?: string | null
            meta?: {
              __typename?: 'CmsMeta'
              title?: string | null
              image?:
                | ({ __typename?: 'CmsMedia' } & {
                    ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                  })
                | null
            } | null
          }
        | {
            __typename?: 'CmsGuide'
            id: number
            slug?: string | null
            title?: string | null
            meta?: {
              __typename?: 'CmsMeta'
              title?: string | null
              image?:
                | ({ __typename?: 'CmsMedia' } & {
                    ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                  })
                | null
            } | null
          }
        | {
            __typename?: 'CmsMarketplacePage'
            id: number
            slug?: string | null
            title?: string | null
            parent?: { __typename?: 'CmsMarketplacePage'; slug?: string | null } | null
            meta?: {
              __typename?: 'CmsMeta'
              title?: string | null
              image?:
                | ({ __typename?: 'CmsMedia' } & {
                    ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                  })
                | null
            } | null
          }
        | {
            __typename?: 'CmsNewsroomArticle'
            id: number
            slug?: string | null
            title?: string | null
            meta?: {
              __typename?: 'CmsMeta'
              title?: string | null
              image?:
                | ({ __typename?: 'CmsMedia' } & {
                    ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                  })
                | null
            } | null
          }
        | {
            __typename?: 'CmsPage'
            id: number
            slug?: string | null
            title?: string | null
            parent?: { __typename?: 'CmsPage'; slug?: string | null } | null
            meta?: {
              __typename?: 'CmsMeta'
              title?: string | null
              image?:
                | ({ __typename?: 'CmsMedia' } & {
                    ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                  })
                | null
            } | null
          }
        | null
    } | null
  }> | null
} & { ' $fragmentName'?: 'CrossLinksFragmentFragment' }

export type DevicePreviewFragmentFragment = {
  __typename?: 'CmsDevicePreview'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsDevicePreview_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  phoneMedia?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
  laptopMedia?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'DevicePreviewFragmentFragment' }

export type DisclaimersFragmentFragment = {
  __typename?: 'CmsDisclaimers'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsDisclaimers_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  disclaimers?: Array<
    { __typename?: 'CmsDisclaimersArray' } & {
      ' $fragmentRefs'?: { CmsDisclaimerFragmentFragment: CmsDisclaimerFragmentFragment }
    }
  > | null
} & { ' $fragmentName'?: 'DisclaimersFragmentFragment' }

export type DownloadBannerFragmentFragment = {
  __typename?: 'CmsDownloadBanner'
  invertBackground?: boolean | null
  richText?: any | null
  media?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'DownloadBannerFragmentFragment' }

export type CheckboxFragmentFragment = {
  __typename?: 'CmsCheckboxFormField'
  name?: string | null
  label?: string | null
  boolDefaultValue?: boolean | null
} & { ' $fragmentName'?: 'CheckboxFragmentFragment' }

export type CreditQualityFragmentFragment = {
  __typename?: 'CmsCreditQualityFormField'
  name?: string | null
  label?: string | null
  required?: boolean | null
} & { ' $fragmentName'?: 'CreditQualityFragmentFragment' }

export type EmailFragmentFragment = {
  __typename?: 'CmsEmailFormField'
  name?: string | null
  label?: string | null
  required?: boolean | null
} & { ' $fragmentName'?: 'EmailFragmentFragment' }

export type MessageFragmentFragment = { __typename?: 'CmsMessageFormField'; message?: any | null } & {
  ' $fragmentName'?: 'MessageFragmentFragment'
}

export type NumberFragmentFragment = {
  __typename?: 'CmsNumberFormField'
  name?: string | null
  label?: string | null
  required?: boolean | null
  numberDefaultValue?: number | null
} & { ' $fragmentName'?: 'NumberFragmentFragment' }

export type SelectFragmentFragment = {
  __typename?: 'CmsSelectFormField'
  name?: string | null
  label?: string | null
  defaultValue?: string | null
  required?: boolean | null
  options?: Array<{ __typename?: 'CmsSelectFormField_Options'; label?: string | null; value?: string | null }> | null
} & { ' $fragmentName'?: 'SelectFragmentFragment' }

export type StateFormFieldFragmentFragment = {
  __typename?: 'CmsStateFormField'
  name?: string | null
  label?: string | null
  required?: boolean | null
} & { ' $fragmentName'?: 'StateFormFieldFragmentFragment' }

export type TextFragmentFragment = {
  __typename?: 'CmsTextFormField'
  name?: string | null
  label?: string | null
  defaultValue?: string | null
  required?: boolean | null
} & { ' $fragmentName'?: 'TextFragmentFragment' }

export type TextAreaFragmentFragment = {
  __typename?: 'CmsTextAreaFormField'
  name?: string | null
  label?: string | null
  defaultValue?: string | null
  required?: boolean | null
} & { ' $fragmentName'?: 'TextAreaFragmentFragment' }

export type TimeInBusinessFragmentFragment = {
  __typename?: 'CmsTimeInBusinessFormField'
  name?: string | null
  label?: string | null
  required?: boolean | null
} & { ' $fragmentName'?: 'TimeInBusinessFragmentFragment' }

export type DynamicFormFragmentFragment = {
  __typename?: 'CmsForm'
  id: number
  submitButtonLabel?: string | null
  fields?: Array<
    | ({ __typename: 'CmsCheckboxFormField' } & {
        ' $fragmentRefs'?: { CheckboxFragmentFragment: CheckboxFragmentFragment }
      })
    | ({ __typename: 'CmsCreditQualityFormField' } & {
        ' $fragmentRefs'?: { CreditQualityFragmentFragment: CreditQualityFragmentFragment }
      })
    | ({ __typename: 'CmsEmailFormField' } & { ' $fragmentRefs'?: { EmailFragmentFragment: EmailFragmentFragment } })
    | ({ __typename: 'CmsMessageFormField' } & {
        ' $fragmentRefs'?: { MessageFragmentFragment: MessageFragmentFragment }
      })
    | ({ __typename: 'CmsNumberFormField' } & { ' $fragmentRefs'?: { NumberFragmentFragment: NumberFragmentFragment } })
    | ({ __typename: 'CmsSelectFormField' } & { ' $fragmentRefs'?: { SelectFragmentFragment: SelectFragmentFragment } })
    | ({ __typename: 'CmsStateFormField' } & {
        ' $fragmentRefs'?: { StateFormFieldFragmentFragment: StateFormFieldFragmentFragment }
      })
    | ({ __typename: 'CmsTextAreaFormField' } & {
        ' $fragmentRefs'?: { TextAreaFragmentFragment: TextAreaFragmentFragment }
      })
    | ({ __typename: 'CmsTextFormField' } & { ' $fragmentRefs'?: { TextFragmentFragment: TextFragmentFragment } })
    | ({ __typename: 'CmsTimeInBusinessFormField' } & {
        ' $fragmentRefs'?: { TimeInBusinessFragmentFragment: TimeInBusinessFragmentFragment }
      })
  > | null
} & { ' $fragmentName'?: 'DynamicFormFragmentFragment' }

export type FormBlockFragmentFragment = {
  __typename?: 'CmsFormBlock'
  form?:
    | ({ __typename?: 'CmsForm' } & { ' $fragmentRefs'?: { DynamicFormFragmentFragment: DynamicFormFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'FormBlockFragmentFragment' }

export type ExperimentFragmentFragment = {
  __typename?: 'CmsExperiment'
  featureFlag?: { __typename?: 'CmsFeatureFlag'; key?: string | null; value?: string | null } | null
  layout?: Array<
    | ({ __typename: 'CmsAccordion' } & { ' $fragmentRefs'?: { AccordionFragmentFragment: AccordionFragmentFragment } })
    | ({ __typename: 'CmsAlertBannerBlock' } & {
        ' $fragmentRefs'?: { AlertBannerBlockFragmentFragment: AlertBannerBlockFragmentFragment }
      })
    | ({ __typename: 'CmsArchive' } & { ' $fragmentRefs'?: { ArchiveFragmentFragment: ArchiveFragmentFragment } })
    | ({ __typename: 'CmsBento' } & { ' $fragmentRefs'?: { BentoFragmentFragment: BentoFragmentFragment } })
    | ({ __typename: 'CmsCTA' } & {
        ' $fragmentRefs'?: { CallToActionBlockFragmentFragment: CallToActionBlockFragmentFragment }
      })
    | ({ __typename: 'CmsCalloutBlock' } & {
        ' $fragmentRefs'?: { CalloutBlockFragmentFragment: CalloutBlockFragmentFragment }
      })
    | ({ __typename: 'CmsCarousel' } & { ' $fragmentRefs'?: { CarouselFragmentFragment: CarouselFragmentFragment } })
    | ({ __typename: 'CmsContent' } & { ' $fragmentRefs'?: { ContentFragmentFragment: ContentFragmentFragment } })
    | ({ __typename: 'CmsCrossLinks' } & {
        ' $fragmentRefs'?: { CrossLinksFragmentFragment: CrossLinksFragmentFragment }
      })
    | ({ __typename: 'CmsDevicePreview' } & {
        ' $fragmentRefs'?: { DevicePreviewFragmentFragment: DevicePreviewFragmentFragment }
      })
    | ({ __typename: 'CmsDisclaimers' } & {
        ' $fragmentRefs'?: { DisclaimersFragmentFragment: DisclaimersFragmentFragment }
      })
    | ({ __typename: 'CmsDownloadBanner' } & {
        ' $fragmentRefs'?: { DownloadBannerFragmentFragment: DownloadBannerFragmentFragment }
      })
    | ({ __typename: 'CmsFeatureGrid' } & {
        ' $fragmentRefs'?: { FeatureGridFragmentFragment: FeatureGridFragmentFragment }
      })
    | ({ __typename: 'CmsFeatureSection' } & {
        ' $fragmentRefs'?: { FeatureSectionFragmentFragment: FeatureSectionFragmentFragment }
      })
    | ({ __typename: 'CmsFormBlock' } & { ' $fragmentRefs'?: { FormBlockFragmentFragment: FormBlockFragmentFragment } })
    | ({ __typename: 'CmsImageBlock' } & {
        ' $fragmentRefs'?: { ImageBlockFragmentFragment: ImageBlockFragmentFragment }
      })
    | ({ __typename: 'CmsLegalBlock' } & {
        ' $fragmentRefs'?: { LegalBlockFragmentFragment: LegalBlockFragmentFragment }
      })
    | ({ __typename: 'CmsOfferBlock' } & {
        ' $fragmentRefs'?: { OfferBlockFragmentFragment: OfferBlockFragmentFragment }
      })
    | ({ __typename: 'CmsPriceTier' } & { ' $fragmentRefs'?: { PriceTierFragmentFragment: PriceTierFragmentFragment } })
    | ({ __typename: 'CmsQuote' } & { ' $fragmentRefs'?: { QuoteFragmentFragment: QuoteFragmentFragment } })
    | ({ __typename: 'CmsResources' } & { ' $fragmentRefs'?: { ResourcesFragmentFragment: ResourcesFragmentFragment } })
    | ({ __typename: 'CmsRichTextBlock' } & {
        ' $fragmentRefs'?: { RichTextBlockFragmentFragment: RichTextBlockFragmentFragment }
      })
    | ({ __typename: 'CmsRichTextSection' } & {
        ' $fragmentRefs'?: { RichTextSectionFragmentFragment: RichTextSectionFragmentFragment }
      })
    | ({ __typename: 'CmsTableBlock' } & {
        ' $fragmentRefs'?: { TableBlockFragmentFragment: TableBlockFragmentFragment }
      })
    | ({ __typename: 'CmsVideoBlock' } & {
        ' $fragmentRefs'?: { VideoBlockFragmentFragment: VideoBlockFragmentFragment }
      })
    | ({ __typename: 'CmsVideoEmbedBlock' } & {
        ' $fragmentRefs'?: { VideoEmbedBlockFragmentFragment: VideoEmbedBlockFragmentFragment }
      })
  > | null
} & { ' $fragmentName'?: 'ExperimentFragmentFragment' }

export type FeatureGridFragmentFragment = {
  __typename?: 'CmsFeatureGrid'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: { CmsSectionFragmentFragment: CmsSectionFragmentFragment }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsFeatureGrid_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  features?: Array<{
    __typename?: 'CmsFeatureGrid_Features'
    title?: string | null
    description?: string | null
    iconName?: string | null
    fillIcon?: boolean | null
  }> | null
} & { ' $fragmentName'?: 'FeatureGridFragmentFragment' }

export type FeatureSectionFragmentFragment = {
  __typename?: 'CmsFeatureSection'
  invertBackground?: boolean | null
  align?: CmsFeatureSection_Align | null
  template?: CmsFeatureSection_Template | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsFeatureSection_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  tmplStats?: Array<{
    __typename?: 'CmsFeatureSection_TmplStats'
    data?: string | null
    description?: any | null
  }> | null
  bgMedia?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'FeatureSectionFragmentFragment' }

export type ImageBlockFragmentFragment = {
  __typename?: 'CmsImageBlock'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsImageBlock_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  image?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'ImageBlockFragmentFragment' }

export type LegalBlockFragmentFragment = {
  __typename?: 'CmsLegalBlock'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsLegalBlock_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  legal?: { __typename?: 'CmsLegal'; richText?: any | null } | null
} & { ' $fragmentName'?: 'LegalBlockFragmentFragment' }

export type OfferBlockFragmentFragment = {
  __typename?: 'CmsOfferBlock'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsOfferBlock_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  marketplaceOffer?: {
    __typename?: 'CmsOfferBlock_MarketplaceOffer'
    category?: string | null
    offerId?: string | null
  } | null
} & { ' $fragmentName'?: 'OfferBlockFragmentFragment' }

export type PriceTierFragmentFragment = {
  __typename?: 'CmsPriceTier'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsPriceTier_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  tiers?: Array<{
    __typename?: 'CmsPriceTier_Tiers'
    tier?: {
      __typename?: 'CmsPricing'
      tierName: string
      tierDescription: string
      priceMonthly: number
      priceQuarterly: number
      priceYearly: number
      isPopular?: boolean | null
      popularText?: string | null
      buttonText: string
      buttonUrl: string
      includes?: Array<{ __typename?: 'CmsPricing'; tierName: string }> | null
      features?: Array<{ __typename?: 'CmsPricing_Features'; text?: any | null; disclaimer?: any | null }> | null
    } | null
  }> | null
} & { ' $fragmentName'?: 'PriceTierFragmentFragment' }

export type ProsConsFragmentFragment = {
  __typename?: 'CmsProsConsBlock'
  pros?: string | null
  cons?: string | null
} & { ' $fragmentName'?: 'ProsConsFragmentFragment' }

export type QuoteFragmentFragment = {
  __typename?: 'CmsQuote'
  invertBackground?: boolean | null
  quoteStyle?: CmsQuote_QuoteStyle | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsQuote_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  quotes?: Array<{
    __typename?: 'CmsQuote_Quotes'
    author?: string | null
    business?: string | null
    quoteText?: any | null
  }> | null
} & { ' $fragmentName'?: 'QuoteFragmentFragment' }

export type ResourcesFragmentFragment = {
  __typename?: 'CmsResources'
  invertBackground?: boolean | null
  cardsGridType?: CmsResources_CardsGridType | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsResources_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  cards?: Array<{
    __typename?: 'CmsResources_Cards'
    title?: string | null
    description?: string | null
    linkAppearance?: CmsResources_Cards_LinkAppearance | null
    media?:
      | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
      | null
    link?:
      | ({ __typename?: 'CmsLink' } & {
          ' $fragmentRefs'?: {
            CmsLinkWithMetaFragmentFragment: CmsLinkWithMetaFragmentFragment
            ResolveHrefFragmentFragment: ResolveHrefFragmentFragment
          }
        })
      | null
  }> | null
} & { ' $fragmentName'?: 'ResourcesFragmentFragment' }

export type RichTextBlockFragmentFragment = {
  __typename?: 'CmsRichTextBlock'
  richTextContent?: any | null
  tableOfContents?: Array<{
    __typename?: 'CmsRichTextBlock_TableOfContents'
    idAttribute?: string | null
    text?: string | null
  }> | null
  richTextSettings?: { __typename?: 'CmsRichTextBlock_RichTextSettings'; enableTOC?: boolean | null } | null
} & { ' $fragmentName'?: 'RichTextBlockFragmentFragment' }

export type RichTextNestedBlocksFragmentFragment = {
  __typename?: 'CmsRichTextNestedBlocks'
  layout?: Array<
    | ({ __typename: 'CmsAccordion' } & { ' $fragmentRefs'?: { AccordionFragmentFragment: AccordionFragmentFragment } })
    | ({ __typename: 'CmsCTA' } & {
        ' $fragmentRefs'?: { CallToActionBlockFragmentFragment: CallToActionBlockFragmentFragment }
      })
    | { __typename: 'CmsCalloutBlock' }
    | ({ __typename: 'CmsContent' } & { ' $fragmentRefs'?: { ContentFragmentFragment: ContentFragmentFragment } })
    | ({ __typename: 'CmsImageBlock' } & {
        ' $fragmentRefs'?: { ImageBlockFragmentFragment: ImageBlockFragmentFragment }
      })
    | ({ __typename: 'CmsOfferBlock' } & {
        ' $fragmentRefs'?: { OfferBlockFragmentFragment: OfferBlockFragmentFragment }
      })
    | ({ __typename: 'CmsTableBlock' } & {
        ' $fragmentRefs'?: { TableBlockFragmentFragment: TableBlockFragmentFragment }
      })
    | ({ __typename: 'CmsVideoBlock' } & {
        ' $fragmentRefs'?: { VideoBlockFragmentFragment: VideoBlockFragmentFragment }
      })
  > | null
} & { ' $fragmentName'?: 'RichTextNestedBlocksFragmentFragment' }

export type RichTextSectionFragmentFragment = {
  __typename?: 'CmsRichTextSection'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsRichTextSection_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  richTextSections?: Array<{
    __typename?: 'CmsRichTextSection_RichTextSections'
    header?: string | null
    featuredImage?:
      | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
      | null
    content?:
      | ({ __typename?: 'CmsRichTextNestedBlocks' } & {
          ' $fragmentRefs'?: { RichTextNestedBlocksFragmentFragment: RichTextNestedBlocksFragmentFragment }
        })
      | null
  }> | null
} & { ' $fragmentName'?: 'RichTextSectionFragmentFragment' }

export type TableBlockFragmentFragment = {
  __typename?: 'CmsTableBlock'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsTableBlock_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  table?: {
    __typename?: 'CmsTableBlock_Table'
    columns?: Array<{ __typename?: 'CmsTableBlock_Table_Columns'; header?: string | null }> | null
    rows?: Array<{
      __typename?: 'CmsTableBlock_Table_Rows'
      cells?: Array<{ __typename?: 'CmsTableBlock_Table_Rows_Cells'; cell?: string | null }> | null
    }> | null
  } | null
} & { ' $fragmentName'?: 'TableBlockFragmentFragment' }

export type VideoBlockFragmentFragment = {
  __typename?: 'CmsVideoBlock'
  invertBackground?: boolean | null
  section?:
    | ({ __typename?: 'CmsSection' } & {
        ' $fragmentRefs'?: {
          CmsSectionFragmentFragment: CmsSectionFragmentFragment
          CmsBlockSectionFragmentFragment: CmsBlockSectionFragmentFragment
        }
      })
    | null
  ctas?: Array<{
    __typename?: 'CmsVideoBlock_Ctas'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  video?:
    | ({ __typename?: 'CmsVideo' } & { ' $fragmentRefs'?: { CmsVideoFragmentFragment: CmsVideoFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'VideoBlockFragmentFragment' }

export type VideoEmbedBlockFragmentFragment = {
  __typename?: 'CmsVideoEmbedBlock'
  embedType?: CmsVideoEmbedBlock_EmbedType | null
  embedUrl?: string | null
} & { ' $fragmentName'?: 'VideoEmbedBlockFragmentFragment' }

export type CmsBlockSectionFragmentFragment = {
  __typename?: 'CmsSection'
  element?: { __typename?: 'CmsSection_Element'; elemId?: string | null; className?: string | null } | null
} & { ' $fragmentName'?: 'CmsBlockSectionFragmentFragment' }

export type ArticleFragmentFragment = {
  __typename?: 'CmsArticle'
  id: number
  slug?: string | null
  title?: string | null
  readTimeEstimate?: number | null
  resourceCategory?: CmsArticle_ResourceCategory | null
  _status?: CmsArticle__Status | null
  meta?: {
    __typename?: 'CmsMeta'
    image?:
      | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
      | null
  } | null
} & { ' $fragmentName'?: 'ArticleFragmentFragment' }

export type CollectionArchiveSelectedDocsFragment = {
  __typename?: 'CmsArchive_SelectedDocs_Relationship'
  relationTo?: CmsArchive_SelectedDocs_RelationTo | null
  value?:
    | ({ __typename?: 'CmsArticle' } & { ' $fragmentRefs'?: { ArticleFragmentFragment: ArticleFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'CollectionArchiveSelectedDocsFragment' }

export type CollectionArchivePopulatedDocsFragment = {
  __typename?: 'CmsArchive_PopulatedDocs_Relationship'
  relationTo?: CmsArchive_PopulatedDocs_RelationTo | null
  value?:
    | ({ __typename?: 'CmsArticle' } & { ' $fragmentRefs'?: { ArticleFragmentFragment: ArticleFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'CollectionArchivePopulatedDocsFragment' }

export type CollectionArchiveCategoriesFragmentFragment = { __typename?: 'CmsCategories'; id: number } & {
  ' $fragmentName'?: 'CollectionArchiveCategoriesFragmentFragment'
}

export type CmsDisclaimerFragmentFragment = {
  __typename?: 'CmsDisclaimersArray'
  align?: CmsDisclaimersArray_Align | null
  includeAsterick?: boolean | null
  number?: number | null
  text?: { __typename?: 'CmsLegal'; richText?: any | null } | null
} & { ' $fragmentName'?: 'CmsDisclaimerFragmentFragment' }

export type FooterFragmentFragment = {
  __typename?: 'CmsFooter'
  copyrightText: string
  footerColumns?: Array<{
    __typename?: 'CmsFooter_FooterColumns'
    linkColumns?: {
      __typename?: 'CmsFooter_FooterColumns_LinkColumns'
      columnTitle?: string | null
      links?: Array<{
        __typename?: 'CmsFooter_FooterColumns_LinkColumns_Links'
        link?:
          | ({ __typename?: 'CmsLink'; label?: string | null } & {
              ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment }
            })
          | null
      }> | null
    } | null
  }> | null
  termsLinks?: Array<{
    __typename?: 'CmsFooter_TermsLinks'
    link?:
      | ({ __typename?: 'CmsLink'; label?: string | null } & {
          ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment }
        })
      | null
  }> | null
  disclaimers?: Array<
    { __typename?: 'CmsDisclaimersArray' } & {
      ' $fragmentRefs'?: { CmsDisclaimerFragmentFragment: CmsDisclaimerFragmentFragment }
    }
  > | null
} & { ' $fragmentName'?: 'FooterFragmentFragment' }

export type ListItemLinkFragmentFragment = ({
  __typename?: 'CmsLink'
  iconBefore?: string | null
  iconAfter?: string | null
} & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } }) & {
  ' $fragmentName'?: 'ListItemLinkFragmentFragment'
}

export type HeaderNavbarFragmentFragment = {
  __typename?: 'CmsHeader_Nav'
  type?: CmsHeader_Nav_Type | null
  title?: string | null
  submenu?: {
    __typename?: 'CmsHeader_Nav_Submenu'
    categories?: Array<{
      __typename?: 'CmsHeader_Nav_Submenu_Categories'
      name?: string | null
      items?: Array<{
        __typename?: 'CmsHeader_Nav_Submenu_Categories_Items'
        title?: string | null
        description?: string | null
        link?:
          | ({ __typename?: 'CmsLink' } & {
              ' $fragmentRefs'?: { ListItemLinkFragmentFragment: ListItemLinkFragmentFragment }
            })
          | null
      }> | null
    }> | null
  } | null
  link?:
    | ({ __typename?: 'CmsLink' } & {
        ' $fragmentRefs'?: {
          ListItemLinkFragmentFragment: ListItemLinkFragmentFragment
          ResolveHrefFragmentFragment: ResolveHrefFragmentFragment
        }
      })
    | null
} & { ' $fragmentName'?: 'HeaderNavbarFragmentFragment' }

export type HeroFragmentFragment = {
  __typename?: 'CmsHero'
  type?: CmsHero_Type | null
  richText?: any | null
  richTextMax?: number | null
  hzAlign?: CmsHero_HzAlign | null
  vertAlign?: CmsHero_VertAlign | null
  showReviews?: boolean | null
  reviewRating?: number | null
  reviewText?: string | null
  heroSize?: CmsHero_HeroSize | null
  disclaimerText?: string | null
  mobileVideo?:
    | ({ __typename?: 'CmsVideo' } & { ' $fragmentRefs'?: { CmsVideoFragmentFragment: CmsVideoFragmentFragment } })
    | null
  desktopVideo?:
    | ({ __typename?: 'CmsVideo' } & { ' $fragmentRefs'?: { CmsVideoFragmentFragment: CmsVideoFragmentFragment } })
    | null
  mobileFallback?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
  desktopFallback?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
  links?: Array<{
    __typename?: 'CmsHero_Links'
    link?:
      | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
      | null
  }> | null
  media?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
  productImage?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'HeroFragmentFragment' }

export type CmsLinkFragmentFragment = {
  __typename?: 'CmsLink'
  label?: string | null
  type?: CmsLink_Type | null
  variant?: CmsLink_Variant | null
  newTab?: boolean | null
  url?: string | null
  targetId?: string | null
  query?: Array<{ __typename?: 'CmsLink_Query'; key?: string | null; value?: string | null }> | null
  reference?: {
    __typename?: 'CmsLink_Reference_Relationship'
    relationTo?: CmsLink_Reference_RelationTo | null
    value?:
      | { __typename?: 'CmsArticle'; slug?: string | null }
      | { __typename?: 'CmsGuide'; slug?: string | null }
      | {
          __typename?: 'CmsMarketplacePage'
          slug?: string | null
          parent?: { __typename?: 'CmsMarketplacePage'; slug?: string | null } | null
        }
      | { __typename?: 'CmsNewsroomArticle'; slug?: string | null }
      | {
          __typename?: 'CmsPage'
          slug?: string | null
          parent?: { __typename?: 'CmsPage'; slug?: string | null } | null
        }
      | null
  } | null
  reusable?: {
    __typename?: 'CmsLink_Reusable_Relationship'
    relationTo?: CmsLink_Reusable_RelationTo | null
    value?: { __typename?: 'CmsLinks'; url: string } | null
  } | null
} & { ' $fragmentName'?: 'CmsLinkFragmentFragment' }

export type CmsLinkWithMetaFragmentFragment = {
  __typename?: 'CmsLink'
  label?: string | null
  type?: CmsLink_Type | null
  variant?: CmsLink_Variant | null
  newTab?: boolean | null
  url?: string | null
  targetId?: string | null
  query?: Array<{ __typename?: 'CmsLink_Query'; key?: string | null; value?: string | null }> | null
  reference?: {
    __typename?: 'CmsLink_Reference_Relationship'
    relationTo?: CmsLink_Reference_RelationTo | null
    value?:
      | {
          __typename?: 'CmsArticle'
          slug?: string | null
          meta?: {
            __typename?: 'CmsMeta'
            description?: string | null
            title?: string | null
            image?:
              | ({ __typename?: 'CmsMedia' } & {
                  ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                })
              | null
          } | null
        }
      | {
          __typename?: 'CmsGuide'
          slug?: string | null
          meta?: {
            __typename?: 'CmsMeta'
            description?: string | null
            title?: string | null
            image?:
              | ({ __typename?: 'CmsMedia' } & {
                  ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                })
              | null
          } | null
        }
      | {
          __typename?: 'CmsMarketplacePage'
          slug?: string | null
          parent?: { __typename?: 'CmsMarketplacePage'; slug?: string | null } | null
          meta?: {
            __typename?: 'CmsMeta'
            description?: string | null
            title?: string | null
            image?:
              | ({ __typename?: 'CmsMedia' } & {
                  ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                })
              | null
          } | null
        }
      | {
          __typename?: 'CmsNewsroomArticle'
          slug?: string | null
          meta?: {
            __typename?: 'CmsMeta'
            description?: string | null
            title?: string | null
            image?:
              | ({ __typename?: 'CmsMedia' } & {
                  ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                })
              | null
          } | null
        }
      | {
          __typename?: 'CmsPage'
          slug?: string | null
          parent?: { __typename?: 'CmsPage'; slug?: string | null } | null
          meta?: {
            __typename?: 'CmsMeta'
            description?: string | null
            title?: string | null
            image?:
              | ({ __typename?: 'CmsMedia' } & {
                  ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
                })
              | null
          } | null
        }
      | null
  } | null
  reusable?: {
    __typename?: 'CmsLink_Reusable_Relationship'
    relationTo?: CmsLink_Reusable_RelationTo | null
    value?: { __typename?: 'CmsLinks'; url: string } | null
  } | null
} & { ' $fragmentName'?: 'CmsLinkWithMetaFragmentFragment' }

export type CmsSectionFragmentFragment = {
  __typename?: 'CmsSection'
  heading?: any | null
  ctaAlign?: CmsSection_CtaAlign | null
  headingMax?: number | null
} & { ' $fragmentName'?: 'CmsSectionFragmentFragment' }

export type CmsCustomFooterFragmentFragment = {
  __typename?: 'CmsCustomFooter'
  isHidden?: boolean | null
  disclaimers?: Array<
    { __typename?: 'CmsDisclaimersArray' } & {
      ' $fragmentRefs'?: { CmsDisclaimerFragmentFragment: CmsDisclaimerFragmentFragment }
    }
  > | null
} & { ' $fragmentName'?: 'CmsCustomFooterFragmentFragment' }

export type CmsCustomHeaderFragmentFragment = {
  __typename?: 'CmsCustomHeader'
  isHidden?: boolean | null
  headerDisplay?: CmsCustomHeader_HeaderDisplay | null
  loginLink?:
    | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment } })
    | null
  signupLink?:
    | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment } })
    | null
  supportLink?:
    | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'CmsCustomHeaderFragmentFragment' }

export type HeaderQueryVariables = Exact<{ [key: string]: never }>

export type HeaderQuery = {
  __typename?: 'Query'
  CmsHeader?: {
    __typename?: 'CmsHeader'
    nav?: Array<
      { __typename?: 'CmsHeader_Nav' } & {
        ' $fragmentRefs'?: { HeaderNavbarFragmentFragment: HeaderNavbarFragmentFragment }
      }
    > | null
    loginLink?:
      | ({ __typename?: 'CmsLink' } & {
          ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment }
        })
      | null
    signupLink?:
      | ({ __typename?: 'CmsLink' } & {
          ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment }
        })
      | null
    supportLink?:
      | ({ __typename?: 'CmsLink' } & {
          ' $fragmentRefs'?: { ResolveHrefFragmentFragment: ResolveHrefFragmentFragment }
        })
      | null
  } | null
}

export type FooterQueryVariables = Exact<{ [key: string]: never }>

export type FooterQuery = {
  __typename?: 'Query'
  CmsFooter?:
    | ({ __typename?: 'CmsFooter' } & { ' $fragmentRefs'?: { FooterFragmentFragment: FooterFragmentFragment } })
    | null
}

export type CmsMediaFragmentFragment = {
  __typename?: 'CmsMedia'
  mimeType?: string | null
  filename?: string | null
  width?: number | null
  height?: number | null
  alt: string
  url?: string | null
  sizes?: {
    __typename?: 'CmsMedia_Sizes'
    card?: { __typename?: 'CmsMedia_Sizes_Card'; filename?: string | null; url?: string | null } | null
    portrait?: { __typename?: 'CmsMedia_Sizes_Portrait'; filename?: string | null; url?: string | null } | null
    square?: { __typename?: 'CmsMedia_Sizes_Square'; filename?: string | null; url?: string | null } | null
    feature?: { __typename?: 'CmsMedia_Sizes_Feature'; filename?: string | null; url?: string | null } | null
    squareThumbnail?: {
      __typename?: 'CmsMedia_Sizes_SquareThumbnail'
      filename?: string | null
      url?: string | null
    } | null
    banner?: { __typename?: 'CmsMedia_Sizes_Banner'; filename?: string | null; url?: string | null } | null
    largeHero?: { __typename?: 'CmsMedia_Sizes_LargeHero'; filename?: string | null; url?: string | null } | null
    smallAutoHeight?: {
      __typename?: 'CmsMedia_Sizes_SmallAutoHeight'
      filename?: string | null
      url?: string | null
    } | null
    largeAutoHeight?: {
      __typename?: 'CmsMedia_Sizes_LargeAutoHeight'
      filename?: string | null
      url?: string | null
    } | null
  } | null
} & { ' $fragmentName'?: 'CmsMediaFragmentFragment' }

export type CmsMetaFragmentFragment = {
  __typename?: 'CmsMeta'
  title?: string | null
  description?: string | null
  noIndex?: boolean | null
  jsonLD?: string | null
  image?:
    | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
    | null
} & { ' $fragmentName'?: 'CmsMetaFragmentFragment' }

export type CmsVideoFragmentFragment = {
  __typename?: 'CmsVideo'
  filename?: string | null
  width?: number | null
  height?: number | null
  url?: string | null
} & { ' $fragmentName'?: 'CmsVideoFragmentFragment' }

export type ResolveHrefFragmentFragment = {
  __typename?: 'CmsLink'
  type?: CmsLink_Type | null
  url?: string | null
  targetId?: string | null
  query?: Array<{ __typename?: 'CmsLink_Query'; key?: string | null; value?: string | null }> | null
  reference?: {
    __typename?: 'CmsLink_Reference_Relationship'
    relationTo?: CmsLink_Reference_RelationTo | null
    value?:
      | { __typename?: 'CmsArticle'; slug?: string | null }
      | { __typename?: 'CmsGuide'; slug?: string | null }
      | {
          __typename?: 'CmsMarketplacePage'
          slug?: string | null
          parent?: { __typename?: 'CmsMarketplacePage'; slug?: string | null } | null
        }
      | { __typename?: 'CmsNewsroomArticle'; slug?: string | null }
      | {
          __typename?: 'CmsPage'
          slug?: string | null
          parent?: { __typename?: 'CmsPage'; slug?: string | null } | null
        }
      | null
  } | null
  reusable?: {
    __typename?: 'CmsLink_Reusable_Relationship'
    relationTo?: CmsLink_Reusable_RelationTo | null
    value?: { __typename?: 'CmsLinks'; url: string } | null
  } | null
} & { ' $fragmentName'?: 'ResolveHrefFragmentFragment' }

export type ParentPageQueryVariables = Exact<{
  where?: InputMaybe<CmsPage_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ParentPageQuery = {
  __typename?: 'Query'
  CmsPages?: {
    __typename?: 'CmsPages'
    docs?: Array<{ __typename?: 'CmsPage'; id: number; title?: string | null } | null> | null
  } | null
}

export type ChildPageQueryVariables = Exact<{
  where?: InputMaybe<CmsPage_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ChildPageQuery = {
  __typename?: 'Query'
  CmsPages?: {
    __typename?: 'CmsPages'
    docs?: Array<{
      __typename?: 'CmsPage'
      id: number
      title?: string | null
      customFooter?:
        | ({ __typename?: 'CmsCustomFooter' } & {
            ' $fragmentRefs'?: { CmsCustomFooterFragmentFragment: CmsCustomFooterFragmentFragment }
          })
        | null
      customHeader?:
        | ({ __typename?: 'CmsCustomHeader' } & {
            ' $fragmentRefs'?: { CmsCustomHeaderFragmentFragment: CmsCustomHeaderFragmentFragment }
          })
        | null
      hero?: ({ __typename?: 'CmsHero' } & { ' $fragmentRefs'?: { HeroFragmentFragment: HeroFragmentFragment } }) | null
      content?:
        | ({ __typename?: 'CmsContentLayout' } & {
            ' $fragmentRefs'?: { BlocksWithExperimentFragmentFragment: BlocksWithExperimentFragmentFragment }
          })
        | null
      meta?:
        | ({ __typename?: 'CmsMeta' } & { ' $fragmentRefs'?: { CmsMetaFragmentFragment: CmsMetaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type SitemapPagesQueryVariables = Exact<{ [key: string]: never }>

export type SitemapPagesQuery = {
  __typename?: 'Query'
  CmsPages?: {
    __typename?: 'CmsPages'
    docs?: Array<{
      __typename?: 'CmsPage'
      slug?: string | null
      updatedAt?: string | null
      parent?: { __typename?: 'CmsPage'; slug?: string | null } | null
    } | null> | null
  } | null
}

export type StackerChildPageQueryVariables = Exact<{
  where?: InputMaybe<CmsStackerPage_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type StackerChildPageQuery = {
  __typename?: 'Query'
  CmsStackerPages?: {
    __typename?: 'CmsStackerPages'
    docs?: Array<{
      __typename?: 'CmsStackerPage'
      id: number
      title?: string | null
      affiliateCode?: string | null
      offerCategories?: Array<{
        __typename?: 'CmsStackerPage_OfferCategories'
        id?: string | null
        slug?: string | null
        name?: string | null
        category?: CmsStackerPage_OfferCategories_Category | null
        collection?: string | null
      }> | null
    } | null> | null
  } | null
}

export type AdvertiserDisclosureQueryVariables = Exact<{
  where?: InputMaybe<CmsLegal_Where>
}>

export type AdvertiserDisclosureQuery = {
  __typename?: 'Query'
  CmsLegals?: {
    __typename?: 'CmsLegals'
    docs?: Array<{ __typename?: 'CmsLegal'; richText?: any | null } | null> | null
  } | null
}

export type ArticleQueryVariables = Exact<{
  where?: InputMaybe<CmsArticle_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ArticleQuery = {
  __typename?: 'Query'
  CmsArticles?: {
    __typename?: 'CmsArticles'
    docs?: Array<{
      __typename?: 'CmsArticle'
      id: number
      title?: string | null
      excerpt?: string | null
      createdAt?: string | null
      publishedAt?: string | null
      updatedAt?: string | null
      resourceCategory?: CmsArticle_ResourceCategory | null
      wordCount?: number | null
      readTimeEstimate?: number | null
      richText?: any | null
      categories?: Array<{ __typename?: 'CmsCategories'; title: string }> | null
      tableOfContents?: Array<{
        __typename?: 'CmsArticle_TableOfContents'
        text?: string | null
        idAttribute?: string | null
      }> | null
      image?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
      authors?: Array<{
        __typename?: 'CmsAuthor'
        id: number
        slug?: string | null
        description?: string | null
        shortBio: string
        name: string
        media?:
          | ({ __typename?: 'CmsMedia' } & {
              ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
            })
          | null
        socials?:
          | ({ __typename?: 'CmsAuthor_Socials' } & {
              ' $fragmentRefs'?: { CmsAuthorSocialsFragmentFragment: CmsAuthorSocialsFragmentFragment }
            })
          | null
      }> | null
      customFooter?:
        | ({ __typename?: 'CmsCustomFooter' } & {
            ' $fragmentRefs'?: { CmsCustomFooterFragmentFragment: CmsCustomFooterFragmentFragment }
          })
        | null
      customHeader?:
        | ({ __typename?: 'CmsCustomHeader' } & {
            ' $fragmentRefs'?: { CmsCustomHeaderFragmentFragment: CmsCustomHeaderFragmentFragment }
          })
        | null
      content?:
        | ({ __typename?: 'CmsContentLayout' } & {
            ' $fragmentRefs'?: { BlocksWithExperimentFragmentFragment: BlocksWithExperimentFragmentFragment }
          })
        | null
      meta?:
        | ({ __typename?: 'CmsMeta' } & { ' $fragmentRefs'?: { CmsMetaFragmentFragment: CmsMetaFragmentFragment } })
        | null
      summary?: Array<{ __typename?: 'CmsArticle_Summary'; text?: string | null }> | null
      relatedArticles?: Array<{
        __typename?: 'CmsArticle'
        id: number
        slug?: string | null
        title?: string | null
        excerpt?: string | null
        resourceCategory?: CmsArticle_ResourceCategory | null
        readTimeEstimate?: number | null
        image?:
          | ({ __typename?: 'CmsMedia' } & {
              ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
            })
          | null
        meta?:
          | ({ __typename?: 'CmsMeta' } & { ' $fragmentRefs'?: { CmsMetaFragmentFragment: CmsMetaFragmentFragment } })
          | null
      }> | null
    } | null> | null
  } | null
}

export type SitemapArticlesQueryVariables = Exact<{ [key: string]: never }>

export type SitemapArticlesQuery = {
  __typename?: 'Query'
  CmsArticles?: {
    __typename?: 'CmsArticles'
    docs?: Array<{
      __typename?: 'CmsArticle'
      slug?: string | null
      updatedAt?: string | null
      resourceCategory?: CmsArticle_ResourceCategory | null
    } | null> | null
  } | null
}

export type EditorialNoteQueryVariables = Exact<{
  where?: InputMaybe<CmsLegal_Where>
}>

export type EditorialNoteQuery = {
  __typename?: 'Query'
  CmsLegals?: {
    __typename?: 'CmsLegals'
    docs?: Array<{ __typename?: 'CmsLegal'; richText?: any | null } | null> | null
  } | null
}

export type NavPrimeCalloutQueryVariables = Exact<{
  where?: InputMaybe<CmsCallout_Where>
}>

export type NavPrimeCalloutQuery = {
  __typename?: 'Query'
  CmsCallouts?: {
    __typename?: 'CmsCallouts'
    docs?: Array<{
      __typename?: 'CmsCallout'
      callout?: {
        __typename?: 'CmsCallout_Callout'
        iconName?: string | null
        heading?: string | null
        richText?: any | null
        emphasis?: CmsCallout_Callout_Emphasis | null
        intent?: CmsCallout_Callout_Intent | null
        links?: Array<{
          __typename?: 'CmsCallout_Callout_Links'
          link?:
            | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
            | null
        }> | null
      } | null
    } | null> | null
  } | null
}

export type ArticlesSearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input']
  searchPage?: InputMaybe<Scalars['Int']['input']>
}>

export type ArticlesSearchQuery = {
  __typename?: 'Query'
  CmsSearch?: {
    __typename?: 'CmsSearch'
    totalDocs?: number | null
    totalPages?: number | null
    docs?: Array<{
      __typename?: 'CmsSearchResult'
      doc: {
        __typename?: 'CmsSearchResult_Doc_Relationship'
        value?: {
          __typename?: 'CmsArticle'
          id: number
          title?: string | null
          excerpt?: string | null
          slug?: string | null
          readTimeEstimate?: number | null
          resourceCategory?: CmsArticle_ResourceCategory | null
          image?:
            | ({ __typename?: 'CmsMedia' } & {
                ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
              })
            | null
          authors?: Array<{ __typename?: 'CmsAuthor'; name: string; description?: string | null }> | null
        } | null
      }
    } | null> | null
  } | null
}

export type BlogSettingsQueryVariables = Exact<{ [key: string]: never }>

export type BlogSettingsQuery = {
  __typename?: 'Query'
  CmsSettings?: {
    __typename?: 'CmsSettings'
    blog?: {
      __typename?: 'CmsSettings_Blog'
      filterCategories?: Array<{ __typename?: 'CmsCategories'; id: number; title: string; slug: string }> | null
      featuredArticles?: Array<{
        __typename?: 'CmsArticle'
        slug?: string | null
        title?: string | null
        readTimeEstimate?: number | null
        resourceCategory?: CmsArticle_ResourceCategory | null
        image?:
          | ({ __typename?: 'CmsMedia' } & {
              ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
            })
          | null
        authors?: Array<{ __typename?: 'CmsAuthor'; name: string; description?: string | null }> | null
        categories?: Array<{ __typename?: 'CmsCategories'; title: string }> | null
      }> | null
      popularArticles?: Array<{
        __typename?: 'CmsArticle'
        slug?: string | null
        title?: string | null
        resourceCategory?: CmsArticle_ResourceCategory | null
        image?:
          | ({ __typename?: 'CmsMedia' } & {
              ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
            })
          | null
        authors?: Array<{ __typename?: 'CmsAuthor'; name: string }> | null
        categories?: Array<{ __typename?: 'CmsCategories'; title: string }> | null
      }> | null
    } | null
  } | null
}

export type ArticlesByCategoryQueryVariables = Exact<{
  where?: InputMaybe<CmsArticle_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}>

export type ArticlesByCategoryQuery = {
  __typename?: 'Query'
  CmsArticles?: {
    __typename?: 'CmsArticles'
    totalPages?: number | null
    docs?: Array<{
      __typename?: 'CmsArticle'
      title?: string | null
      slug?: string | null
      resourceCategory?: CmsArticle_ResourceCategory | null
      categories?: Array<{ __typename?: 'CmsCategories'; title: string }> | null
      image?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
      authors?: Array<{ __typename?: 'CmsAuthor'; name: string }> | null
    } | null> | null
  } | null
}

export type CmsAuthorSocialsFragmentFragment = {
  __typename?: 'CmsAuthor_Socials'
  x?: string | null
  facebook?: string | null
  linkedin?: string | null
  instagram?: string | null
} & { ' $fragmentName'?: 'CmsAuthorSocialsFragmentFragment' }

export type AuthorQueryVariables = Exact<{
  where?: InputMaybe<CmsAuthor_Where>
}>

export type AuthorQuery = {
  __typename?: 'Query'
  CmsAuthors?: {
    __typename?: 'CmsAuthors'
    docs?: Array<{
      __typename?: 'CmsAuthor'
      id: number
      slug?: string | null
      description?: string | null
      shortBio: string
      name: string
      socials?:
        | ({ __typename?: 'CmsAuthor_Socials' } & {
            ' $fragmentRefs'?: { CmsAuthorSocialsFragmentFragment: CmsAuthorSocialsFragmentFragment }
          })
        | null
      media?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type AuthorArticlesQueryVariables = Exact<{
  where?: InputMaybe<CmsArticle_Where>
}>

export type AuthorArticlesQuery = {
  __typename?: 'Query'
  CmsArticles?: {
    __typename?: 'CmsArticles'
    docs?: Array<{
      __typename?: 'CmsArticle'
      id: number
      title?: string | null
      slug?: string | null
      resourceCategory?: CmsArticle_ResourceCategory | null
      excerpt?: string | null
      image?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type SitemapAuthorsQueryVariables = Exact<{ [key: string]: never }>

export type SitemapAuthorsQuery = {
  __typename?: 'Query'
  CmsAuthors?: {
    __typename?: 'CmsAuthors'
    docs?: Array<{ __typename?: 'CmsAuthor'; slug?: string | null; updatedAt?: string | null } | null> | null
  } | null
}

export type FormQueryVariables = Exact<{
  id: Scalars['Int']['input']
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type FormQuery = {
  __typename?: 'Query'
  CmsForm?:
    | ({ __typename?: 'CmsForm'; title?: string | null } & {
        ' $fragmentRefs'?: { DynamicFormFragmentFragment: DynamicFormFragmentFragment }
      })
    | null
}

export type FormSubmissionMutationVariables = Exact<{
  form: Scalars['Int']['input']
  submissionData: Array<MutationCmsFormSubmission_SubmissionDataInput> | MutationCmsFormSubmission_SubmissionDataInput
}>

export type FormSubmissionMutation = {
  __typename?: 'Mutation'
  createCmsFormSubmission?: {
    __typename?: 'CmsFormSubmission'
    form: {
      __typename?: 'CmsForm'
      confirmationType?: CmsForm_ConfirmationType | null
      confirmationMessage?: any | null
      redirect?: {
        __typename?: 'CmsForm_Redirect'
        type?: CmsForm_Redirect_Type | null
        url?: string | null
        reference?: {
          __typename?: 'CmsForm_Redirect_Reference_Relationship'
          relationTo?: CmsForm_Redirect_Reference_RelationTo | null
          value?:
            | { __typename?: 'CmsArticle'; slug?: string | null }
            | { __typename?: 'CmsGuide'; slug?: string | null }
            | {
                __typename?: 'CmsMarketplacePage'
                slug?: string | null
                parent?: { __typename?: 'CmsMarketplacePage'; slug?: string | null } | null
              }
            | { __typename?: 'CmsNewsroomArticle'; slug?: string | null }
            | {
                __typename?: 'CmsPage'
                slug?: string | null
                parent?: { __typename?: 'CmsPage'; slug?: string | null } | null
              }
            | { __typename?: 'CmsStackerPage'; slug?: string | null }
            | null
        } | null
      } | null
    }
  } | null
}

export type GuideQueryVariables = Exact<{
  where?: InputMaybe<CmsGuide_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GuideQuery = {
  __typename?: 'Query'
  CmsGuides?: {
    __typename?: 'CmsGuides'
    docs?: Array<{
      __typename?: 'CmsGuide'
      id: number
      title?: string | null
      header?: any | null
      timeEstimate?: string | null
      intro?: any | null
      publishedAt?: string | null
      createdAt?: string | null
      authors?: Array<{ __typename?: 'CmsAuthor'; name: string }> | null
      media?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
      chapters?: Array<{
        __typename?: 'CmsGuide_Chapters'
        title?: any | null
        image?:
          | ({ __typename?: 'CmsMedia' } & {
              ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
            })
          | null
        link?:
          | ({ __typename?: 'CmsLink' } & { ' $fragmentRefs'?: { CmsLinkFragmentFragment: CmsLinkFragmentFragment } })
          | null
      }> | null
      meta?:
        | ({ __typename?: 'CmsMeta' } & { ' $fragmentRefs'?: { CmsMetaFragmentFragment: CmsMetaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type SitemapGuidesQueryVariables = Exact<{ [key: string]: never }>

export type SitemapGuidesQuery = {
  __typename?: 'Query'
  CmsGuides?: {
    __typename?: 'CmsGuides'
    docs?: Array<{ __typename?: 'CmsGuide'; slug?: string | null; updatedAt?: string | null } | null> | null
  } | null
}

export type MarketplaceParentPageQueryVariables = Exact<{
  where?: InputMaybe<CmsMarketplacePage_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type MarketplaceParentPageQuery = {
  __typename?: 'Query'
  CmsMarketplacePages?: {
    __typename?: 'CmsMarketplacePages'
    docs?: Array<{ __typename?: 'CmsMarketplacePage'; id: number } | null> | null
  } | null
}

export type MarketplaceChildPageQueryVariables = Exact<{
  where?: InputMaybe<CmsMarketplacePage_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type MarketplaceChildPageQuery = {
  __typename?: 'Query'
  CmsMarketplacePages?: {
    __typename?: 'CmsMarketplacePages'
    docs?: Array<{
      __typename?: 'CmsMarketplacePage'
      id: number
      title?: string | null
      offerCategory?: CmsMarketplacePage_OfferCategory | null
      customFooter?:
        | ({ __typename?: 'CmsCustomFooter' } & {
            ' $fragmentRefs'?: { CmsCustomFooterFragmentFragment: CmsCustomFooterFragmentFragment }
          })
        | null
      customHeader?:
        | ({ __typename?: 'CmsCustomHeader' } & {
            ' $fragmentRefs'?: { CmsCustomHeaderFragmentFragment: CmsCustomHeaderFragmentFragment }
          })
        | null
      hero?: ({ __typename?: 'CmsHero' } & { ' $fragmentRefs'?: { HeroFragmentFragment: HeroFragmentFragment } }) | null
      content?:
        | ({ __typename?: 'CmsContentLayout' } & {
            ' $fragmentRefs'?: { BlocksWithExperimentFragmentFragment: BlocksWithExperimentFragmentFragment }
          })
        | null
      meta?:
        | ({ __typename?: 'CmsMeta' } & { ' $fragmentRefs'?: { CmsMetaFragmentFragment: CmsMetaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type SitemapMarketplaceQueryVariables = Exact<{ [key: string]: never }>

export type SitemapMarketplaceQuery = {
  __typename?: 'Query'
  CmsMarketplacePages?: {
    __typename?: 'CmsMarketplacePages'
    docs?: Array<{
      __typename?: 'CmsMarketplacePage'
      slug?: string | null
      updatedAt?: string | null
      parent?: { __typename?: 'CmsMarketplacePage'; slug?: string | null } | null
    } | null> | null
  } | null
}

export type NewsroomArticleQueryVariables = Exact<{
  where?: InputMaybe<CmsNewsroomArticle_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type NewsroomArticleQuery = {
  __typename?: 'Query'
  CmsNewsroomArticles?: {
    __typename?: 'CmsNewsroomArticles'
    docs?: Array<{
      __typename?: 'CmsNewsroomArticle'
      id: number
      title?: string | null
      excerpt?: string | null
      createdAt?: string | null
      publishedAt?: string | null
      updatedAt?: string | null
      richText?: any | null
      image?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
      authors?: Array<{
        __typename?: 'CmsAuthor'
        id: number
        slug?: string | null
        description?: string | null
        shortBio: string
        name: string
        media?:
          | ({ __typename?: 'CmsMedia' } & {
              ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment }
            })
          | null
      }> | null
      customFooter?:
        | ({ __typename?: 'CmsCustomFooter' } & {
            ' $fragmentRefs'?: { CmsCustomFooterFragmentFragment: CmsCustomFooterFragmentFragment }
          })
        | null
      customHeader?:
        | ({ __typename?: 'CmsCustomHeader' } & {
            ' $fragmentRefs'?: { CmsCustomHeaderFragmentFragment: CmsCustomHeaderFragmentFragment }
          })
        | null
      content?:
        | ({ __typename?: 'CmsContentLayout' } & {
            ' $fragmentRefs'?: { BlocksWithExperimentFragmentFragment: BlocksWithExperimentFragmentFragment }
          })
        | null
      meta?:
        | ({ __typename?: 'CmsMeta' } & { ' $fragmentRefs'?: { CmsMetaFragmentFragment: CmsMetaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type SitemapNewsroomArticlesQueryVariables = Exact<{ [key: string]: never }>

export type SitemapNewsroomArticlesQuery = {
  __typename?: 'Query'
  CmsNewsroomArticles?: {
    __typename?: 'CmsNewsroomArticles'
    docs?: Array<{ __typename?: 'CmsNewsroomArticle'; slug?: string | null; updatedAt?: string | null } | null> | null
  } | null
}

export type NewsroomNavTeamInfoQueryVariables = Exact<{ [key: string]: never }>

export type NewsroomNavTeamInfoQuery = {
  __typename?: 'Query'
  CmsAuthors?: {
    __typename?: 'CmsAuthors'
    docs?: Array<{
      __typename?: 'CmsAuthor'
      id: number
      slug?: string | null
      description?: string | null
      shortBio: string
      name: string
      media?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type NewsroomSettingsQueryVariables = Exact<{ [key: string]: never }>

export type NewsroomSettingsQuery = {
  __typename?: 'Query'
  CmsSettings?: {
    __typename?: 'CmsSettings'
    newsroom?: {
      __typename?: 'CmsSettings_Newsroom'
      hero?: ({ __typename?: 'CmsHero' } & { ' $fragmentRefs'?: { HeroFragmentFragment: HeroFragmentFragment } }) | null
    } | null
  } | null
}

export type NewsroomArticlesListQueryVariables = Exact<{
  where?: InputMaybe<CmsNewsroomArticle_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type NewsroomArticlesListQuery = {
  __typename?: 'Query'
  CmsNewsroomArticles?: {
    __typename?: 'CmsNewsroomArticles'
    docs?: Array<{
      __typename?: 'CmsNewsroomArticle'
      title?: string | null
      slug?: string | null
      publishedAt?: string | null
      image?:
        | ({ __typename?: 'CmsMedia' } & { ' $fragmentRefs'?: { CmsMediaFragmentFragment: CmsMediaFragmentFragment } })
        | null
      authors?: Array<{ __typename?: 'CmsAuthor'; name: string }> | null
    } | null> | null
  } | null
}

export type LiteEmbeddedPageQueryVariables = Exact<{
  where?: InputMaybe<CmsLiteEmbeddedMarketplace_Where>
  draft?: InputMaybe<Scalars['Boolean']['input']>
}>

export type LiteEmbeddedPageQuery = {
  __typename?: 'Query'
  CmsLiteEmbeddedMarketplaces?: {
    __typename?: 'CmsLiteEmbeddedMarketplaces'
    docs?: Array<{
      __typename?: 'CmsLiteEmbeddedMarketplace'
      id: number
      title?: string | null
      logoHref?: string | null
      affiliateCode?: string | null
      logo?: { __typename?: 'CmsMedia'; url?: string | null; alt: string } | null
      offerCategories?: Array<{
        __typename?: 'CmsLiteEmbeddedMarketplace_OfferCategories'
        id?: string | null
        slug?: string | null
        name?: string | null
        category?: CmsLiteEmbeddedMarketplace_OfferCategories_Category | null
        collection?: string | null
      }> | null
      meta?:
        | ({ __typename?: 'CmsMeta' } & { ' $fragmentRefs'?: { CmsMetaFragmentFragment: CmsMetaFragmentFragment } })
        | null
    } | null> | null
  } | null
}

export type SitemapLiteEmbeddedPagesQueryVariables = Exact<{ [key: string]: never }>

export type SitemapLiteEmbeddedPagesQuery = {
  __typename?: 'Query'
  CmsLiteEmbeddedMarketplaces?: {
    __typename?: 'CmsLiteEmbeddedMarketplaces'
    docs?: Array<{
      __typename?: 'CmsLiteEmbeddedMarketplace'
      slug?: string | null
      updatedAt?: string | null
    } | null> | null
  } | null
}

export const CmsMediaFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsMediaFragmentFragment, unknown>
export const CmsLinkFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsLinkFragmentFragment, unknown>
export const CallToActionBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallToActionBlockFragmentFragment, unknown>
export const CmsSectionFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsSectionFragmentFragment, unknown>
export const CmsBlockSectionFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsBlockSectionFragmentFragment, unknown>
export const DevicePreviewFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'devicePreviewFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDevicePreview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'laptopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevicePreviewFragmentFragment, unknown>
export const ContentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentFragmentFragment, unknown>
export const CollectionArchiveCategoriesFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
  ],
} as unknown as DocumentNode<CollectionArchiveCategoriesFragmentFragment, unknown>
export const ArticleFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleFragmentFragment, unknown>
export const CollectionArchiveSelectedDocsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionArchiveSelectedDocsFragment, unknown>
export const CollectionArchivePopulatedDocsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollectionArchivePopulatedDocsFragment, unknown>
export const ArchiveFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'archiveFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populateBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'populatedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populatedDocsTotal' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchiveFragmentFragment, unknown>
export const QuoteFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'quoteFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsQuote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quoteStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'business' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quoteText' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuoteFragmentFragment, unknown>
export const CrossLinksFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'crossLinksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCrossLinks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crossLinksCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedDoc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'value' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CrossLinksFragmentFragment, unknown>
export const AccordionFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccordionFragmentFragment, unknown>
export const FeatureSectionFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tmplStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bgMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureSectionFragmentFragment, unknown>
export const CarouselFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'carouselFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCarousel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CarouselFragmentFragment, unknown>
export const BentoFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bentoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsBento' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bgMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BentoFragmentFragment, unknown>
export const PriceTierFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceTierFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPriceTier' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceMonthly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceQuarterly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceYearly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPopular' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popularText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'includes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tierName' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceTierFragmentFragment, unknown>
export const TextFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TextFragmentFragment, unknown>
export const EmailFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmailFragmentFragment, unknown>
export const CheckboxFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckboxFragmentFragment, unknown>
export const NumberFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NumberFragmentFragment, unknown>
export const MessageFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
  ],
} as unknown as DocumentNode<MessageFragmentFragment, unknown>
export const SelectFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectFragmentFragment, unknown>
export const TextAreaFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TextAreaFragmentFragment, unknown>
export const StateFormFieldFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StateFormFieldFragmentFragment, unknown>
export const CreditQualityFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreditQualityFragmentFragment, unknown>
export const TimeInBusinessFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimeInBusinessFragmentFragment, unknown>
export const DynamicFormFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DynamicFormFragmentFragment, unknown>
export const FormBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFormBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'form' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormBlockFragmentFragment, unknown>
export const CmsLinkWithMetaFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsLinkWithMetaFragmentFragment, unknown>
export const ResolveHrefFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResolveHrefFragmentFragment, unknown>
export const ResourcesFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resourcesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsResources' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardsGridType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkAppearance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourcesFragmentFragment, unknown>
export const FeatureGridFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureGridFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fillIcon' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureGridFragmentFragment, unknown>
export const CmsDisclaimerFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsDisclaimerFragmentFragment, unknown>
export const DisclaimersFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'disclaimersFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimers' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisclaimersFragmentFragment, unknown>
export const LegalBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'legalBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegalBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LegalBlockFragmentFragment, unknown>
export const CmsVideoFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsVideoFragmentFragment, unknown>
export const VideoBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoBlockFragmentFragment, unknown>
export const OfferBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OfferBlockFragmentFragment, unknown>
export const TableBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TableBlockFragmentFragment, unknown>
export const ImageBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageBlockFragmentFragment, unknown>
export const RichTextNestedBlocksFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RichTextNestedBlocksFragmentFragment, unknown>
export const RichTextSectionFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featuredImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextNestedBlocksFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RichTextSectionFragmentFragment, unknown>
export const DownloadBannerFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'downloadBannerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDownloadBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadBannerFragmentFragment, unknown>
export const CalloutBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCalloutBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CalloutBlockFragmentFragment, unknown>
export const ProsConsFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'prosConsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsProsConsBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pros' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cons' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProsConsFragmentFragment, unknown>
export const VideoEmbedBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoEmbedBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoEmbedBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'embedType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoEmbedBlockFragmentFragment, unknown>
export const RichTextBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'richTextContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableOfContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enableTOC' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RichTextBlockFragmentFragment, unknown>
export const AlertBannerBlockFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'alertBannerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAlertBannerBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlertBannerBlockFragmentFragment, unknown>
export const ExperimentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'experimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsExperiment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'devicePreviewFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDevicePreview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'laptopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'archiveFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populateBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'populatedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populatedDocsTotal' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'quoteFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsQuote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quoteStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'business' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quoteText' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'crossLinksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCrossLinks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crossLinksCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedDoc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'value' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tmplStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bgMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'carouselFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCarousel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bentoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsBento' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bgMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceTierFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPriceTier' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceMonthly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceQuarterly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceYearly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPopular' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popularText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'includes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tierName' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFormBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'form' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resourcesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsResources' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardsGridType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkAppearance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureGridFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fillIcon' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'disclaimersFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimers' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'legalBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegalBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featuredImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextNestedBlocksFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'downloadBannerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDownloadBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCalloutBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoEmbedBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoEmbedBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'embedType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'alertBannerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAlertBannerBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'richTextContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableOfContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enableTOC' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExperimentFragmentFragment, unknown>
export const BlocksWithExperimentFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'blocksWithExperimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContentLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'prosConsFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'experimentFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'devicePreviewFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDevicePreview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'laptopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'archiveFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populateBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'populatedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populatedDocsTotal' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'quoteFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsQuote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quoteStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'business' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quoteText' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'crossLinksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCrossLinks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crossLinksCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedDoc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'value' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tmplStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bgMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'carouselFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCarousel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bentoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsBento' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bgMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceTierFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPriceTier' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceMonthly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceQuarterly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceYearly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPopular' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popularText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'includes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tierName' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFormBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'form' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resourcesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsResources' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardsGridType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkAppearance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureGridFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fillIcon' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'disclaimersFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimers' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'legalBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegalBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featuredImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextNestedBlocksFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'downloadBannerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDownloadBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCalloutBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoEmbedBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoEmbedBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'embedType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'alertBannerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAlertBannerBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'richTextContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableOfContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enableTOC' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'prosConsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsProsConsBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pros' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cons' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'experimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsExperiment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlocksWithExperimentFragmentFragment, unknown>
export const FooterFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFooter' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerColumns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'columnTitle' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'link' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsLinks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'copyrightText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FooterFragmentFragment, unknown>
export const ListItemLinkFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'listItemLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconBefore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconAfter' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListItemLinkFragmentFragment, unknown>
export const HeaderNavbarFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'headerNavbarFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsHeader_Nav' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'link' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'listItemLinkFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'link' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'listItemLinkFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'listItemLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconBefore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconAfter' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeaderNavbarFragmentFragment, unknown>
export const HeroFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsHero' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richTextMax' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hzAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vertAlign' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerText' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeroFragmentFragment, unknown>
export const CmsCustomFooterFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomFooterFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomFooter' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsCustomFooterFragmentFragment, unknown>
export const CmsCustomHeaderFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomHeaderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerDisplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signupLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsCustomHeaderFragmentFragment, unknown>
export const CmsMetaFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMeta' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonLD' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsMetaFragmentFragment, unknown>
export const CmsAuthorSocialsFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsAuthorSocialsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAuthor_Socials' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CmsAuthorSocialsFragmentFragment, unknown>
export const PopulateRedirectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PopulateRedirects' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsRedirects' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1000' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'permanent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'to' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsPage' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parent' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsMarketplacePage' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parent' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsGuide' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsArticle' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsStackerPage' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsNewsroomArticle' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PopulateRedirectsQuery, PopulateRedirectsQueryVariables>
export const SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Settings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'logo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sameAs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsQuery, SettingsQueryVariables>
export const HeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Header' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nav' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'headerNavbarFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'loginLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'signupLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'listItemLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconBefore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconAfter' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'headerNavbarFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsHeader_Nav' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'link' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'listItemLinkFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'link' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'listItemLinkFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeaderQuery, HeaderQueryVariables>
export const FooterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Footer' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsFooter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'footerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFooter' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerColumns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkColumns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'columnTitle' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'link' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsLinks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'copyrightText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FooterQuery, FooterQueryVariables>
export const ParentPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ParentPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParentPageQuery, ParentPageQueryVariables>
export const ChildPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChildPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFooter' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomFooterFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customHeader' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomHeaderFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'heroFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'blocksWithExperimentFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMetaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'devicePreviewFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDevicePreview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'laptopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'archiveFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populateBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'populatedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populatedDocsTotal' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'quoteFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsQuote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quoteStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'business' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quoteText' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'crossLinksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCrossLinks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crossLinksCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedDoc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'value' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tmplStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bgMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'carouselFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCarousel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bentoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsBento' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bgMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceTierFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPriceTier' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceMonthly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceQuarterly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceYearly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPopular' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popularText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'includes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tierName' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFormBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'form' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resourcesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsResources' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardsGridType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkAppearance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureGridFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fillIcon' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'disclaimersFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimers' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'legalBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegalBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featuredImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextNestedBlocksFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'downloadBannerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDownloadBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCalloutBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'prosConsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsProsConsBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pros' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cons' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoEmbedBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoEmbedBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'embedType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'richTextContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableOfContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enableTOC' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'alertBannerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAlertBannerBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'experimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsExperiment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomFooterFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomFooter' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomHeaderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerDisplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signupLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsHero' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richTextMax' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hzAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vertAlign' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerText' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'blocksWithExperimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContentLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'prosConsFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'experimentFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMeta' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonLD' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChildPageQuery, ChildPageQueryVariables>
export const SitemapPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'EnumValue', value: 'published' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'not_equals' },
                            value: { kind: 'StringValue', value: 'home', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '0' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapPagesQuery, SitemapPagesQueryVariables>
export const StackerChildPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StackerChildPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStackerPage_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsStackerPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'offerCategories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'collection' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'affiliateCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StackerChildPageQuery, StackerChildPageQueryVariables>
export const AdvertiserDisclosureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdvertiserDisclosure' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal_where' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsLegals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdvertiserDisclosureQuery, AdvertiserDisclosureQueryVariables>
export const ArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Article' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excerpt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'wordCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tableOfContents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortBio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'socials' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsAuthorSocialsFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFooter' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomFooterFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customHeader' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomHeaderFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'blocksWithExperimentFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMetaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedArticles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'excerpt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMetaFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'devicePreviewFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDevicePreview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'laptopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'archiveFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populateBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'populatedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populatedDocsTotal' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'quoteFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsQuote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quoteStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'business' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quoteText' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'crossLinksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCrossLinks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crossLinksCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedDoc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'value' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tmplStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bgMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'carouselFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCarousel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bentoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsBento' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bgMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceTierFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPriceTier' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceMonthly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceQuarterly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceYearly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPopular' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popularText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'includes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tierName' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFormBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'form' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resourcesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsResources' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardsGridType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkAppearance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureGridFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fillIcon' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'disclaimersFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimers' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'legalBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegalBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featuredImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextNestedBlocksFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'downloadBannerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDownloadBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCalloutBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'prosConsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsProsConsBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pros' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cons' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoEmbedBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoEmbedBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'embedType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'richTextContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableOfContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enableTOC' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'alertBannerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAlertBannerBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'experimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsExperiment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsAuthorSocialsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAuthor_Socials' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomFooterFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomFooter' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomHeaderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerDisplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signupLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'blocksWithExperimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContentLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'prosConsFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'experimentFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMeta' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonLD' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleQuery, ArticleQueryVariables>
export const SitemapArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapArticles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'EnumValue', value: 'published' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '0' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapArticlesQuery, SitemapArticlesQueryVariables>
export const EditorialNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EditorialNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal_where' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsLegals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditorialNoteQuery, EditorialNoteQueryVariables>
export const NavPrimeCalloutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NavPrimeCallout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout_where' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsCallouts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NavPrimeCalloutQuery, NavPrimeCalloutQueryVariables>
export const ArticlesSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ArticlesSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsSearch' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '20' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doc' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'excerpt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalDocs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticlesSearchQuery, ArticlesSearchQueryVariables>
export const BlogSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BlogSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'blog' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filterCategories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredArticles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'authors' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'categories' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'popularArticles' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'authors' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'categories' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BlogSettingsQuery, BlogSettingsQueryVariables>
export const ArticlesByCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ArticlesByCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: '-publishedAt', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticlesByCategoryQuery, ArticlesByCategoryQueryVariables>
export const AuthorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Author' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAuthor_where' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsAuthors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortBio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'socials' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsAuthorSocialsFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'media' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsAuthorSocialsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAuthor_Socials' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthorQuery, AuthorQueryVariables>
export const AuthorArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AuthorArticles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle_where' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excerpt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthorArticlesQuery, AuthorArticlesQueryVariables>
export const SitemapAuthorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapAuthors' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsAuthors' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '0' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapAuthorsQuery, SitemapAuthorsQueryVariables>
export const FormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Form' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsForm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormQuery, FormQueryVariables>
export const FormSubmissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FormSubmission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'form' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'submissionData' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'mutationCmsFormSubmission_SubmissionDataInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCmsFormSubmission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'form' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'form' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissionData' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'submissionData' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'form' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmationMessage' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'redirect' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsPage' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parent' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsMarketplacePage' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'parent' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsGuide' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsArticle' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsNewsroomArticle' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'CmsStackerPage' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FormSubmissionMutation, FormSubmissionMutationVariables>
export const GuideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Guide' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsGuides' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'media' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeEstimate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intro' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chapters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'link' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMetaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMeta' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonLD' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GuideQuery, GuideQueryVariables>
export const SitemapGuidesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapGuides' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsGuides' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'EnumValue', value: 'published' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '0' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapGuidesQuery, SitemapGuidesQueryVariables>
export const MarketplaceParentPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketplaceParentPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsMarketplacePages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketplaceParentPageQuery, MarketplaceParentPageQueryVariables>
export const MarketplaceChildPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketplaceChildPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsMarketplacePages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offerCategory' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFooter' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomFooterFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customHeader' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomHeaderFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'heroFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'blocksWithExperimentFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMetaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'devicePreviewFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDevicePreview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'laptopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'archiveFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populateBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'populatedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populatedDocsTotal' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'quoteFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsQuote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quoteStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'business' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quoteText' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'crossLinksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCrossLinks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crossLinksCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedDoc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'value' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tmplStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bgMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'carouselFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCarousel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bentoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsBento' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bgMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceTierFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPriceTier' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceMonthly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceQuarterly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceYearly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPopular' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popularText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'includes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tierName' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFormBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'form' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resourcesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsResources' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardsGridType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkAppearance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureGridFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fillIcon' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'disclaimersFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimers' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'legalBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegalBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featuredImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextNestedBlocksFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'downloadBannerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDownloadBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCalloutBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'prosConsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsProsConsBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pros' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cons' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoEmbedBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoEmbedBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'embedType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'richTextContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableOfContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enableTOC' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'alertBannerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAlertBannerBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'experimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsExperiment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomFooterFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomFooter' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomHeaderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerDisplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signupLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsHero' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richTextMax' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hzAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vertAlign' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerText' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'blocksWithExperimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContentLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'prosConsFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'experimentFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMeta' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonLD' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarketplaceChildPageQuery, MarketplaceChildPageQueryVariables>
export const SitemapMarketplaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapMarketplace' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsMarketplacePages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'EnumValue', value: 'published' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '0' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapMarketplaceQuery, SitemapMarketplaceQueryVariables>
export const NewsroomArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewsroomArticle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsNewsroomArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excerpt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortBio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customFooter' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomFooterFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customHeader' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsCustomHeaderFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'blocksWithExperimentFragment' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMetaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsDisclaimerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimersArray' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'includeAsterick' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resolveHrefFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'callToActionBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCTA' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaBannerType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headingMax' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsBlockSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'element' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'elemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'className' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'devicePreviewFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDevicePreview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'laptopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnsMaxWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'columns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanLg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanMd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colSpanSm' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ctas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'link' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ctaAlign' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCategories' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readTimeEstimate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: '_status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_SelectedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive_PopulatedDocs_Relationship' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'value' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'articleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'archiveFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArchive' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populateBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourceCategory' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveCategoriesFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchiveSelectedDocs' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'populatedDocs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'collectionArchivePopulatedDocs' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'populatedDocsTotal' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'quoteFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsQuote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quoteStyle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                { kind: 'Field', name: { kind: 'Name', value: 'business' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quoteText' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'crossLinksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCrossLinks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crossLinksCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedDoc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'value' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'parent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'CmsMediaFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'accordionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAccordion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accordionItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainContent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'align' } },
          { kind: 'Field', name: { kind: 'Name', value: 'template' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tmplStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bgMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'carouselFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCarousel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bentoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsBento' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bgMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'media' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'priceTierFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPriceTier' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'tierName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tierDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceMonthly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceQuarterly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceYearly' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPopular' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'popularText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'includes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPricing' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tierName' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'emailFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsEmailFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'checkboxFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCheckboxFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'boolDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'numberFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNumberFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'numberDefaultValue' },
            name: { kind: 'Name', value: 'defaultValue' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'messageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMessageFormField' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'selectFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsSelectFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textAreaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTextAreaFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'stateFormFieldFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsStateFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'creditQualityFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCreditQualityFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'timeInBusinessFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTimeInBusinessFormField' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicFormFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsForm' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'emailFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'checkboxFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'numberFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'selectFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'textAreaFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'stateFormFieldFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'creditQualityFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'timeInBusinessFragment' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submitButtonLabel' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'formBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFormBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'form' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'dynamicFormFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'meta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'resourcesFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsResources' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardsGridType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkAppearance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkWithMetaFragment' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureGridFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsFeatureGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fillIcon' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'disclaimersFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDisclaimers' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'legalBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegalBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLegal' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'richText' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'offerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsOfferBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOffer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'offerId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'tableBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsTableBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'columns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'header' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cells' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cell' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsImageBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextNestedBlocksFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextNestedBlocks' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextSectionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextSection' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsBlockSectionFragment' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'header' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featuredImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextNestedBlocksFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'downloadBannerFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsDownloadBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'invertBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'calloutBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCalloutBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calloutReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCallout' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emphasis' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'link' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'prosConsFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsProsConsBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pros' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cons' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoEmbedBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideoEmbedBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'embedType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'richTextBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsRichTextBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'richTextContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tableOfContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'idAttribute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'richTextSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enableTOC' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'alertBannerBlockFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsAlertBannerBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intent' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'experimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsExperiment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomFooterFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomFooter' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsDisclaimerFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsCustomHeaderFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsCustomHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerDisplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signupLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'resolveHrefFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'blocksWithExperimentFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsContentLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'callToActionBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'devicePreviewFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'contentFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'archiveFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'quoteFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'crossLinksFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'accordionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'carouselFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bentoFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'priceTierFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'formBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'resourcesFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'featureGridFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'disclaimersFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'legalBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextSectionFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'offerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'tableBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'imageBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'downloadBannerFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'calloutBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'prosConsFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoEmbedBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'richTextBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'alertBannerBlockFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'experimentFragment' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMeta' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonLD' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsroomArticleQuery, NewsroomArticleQueryVariables>
export const SitemapNewsroomArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapNewsroomArticles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsNewsroomArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'EnumValue', value: 'published' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '0' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapNewsroomArticlesQuery, SitemapNewsroomArticlesQueryVariables>
export const NewsroomNavTeamInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewsroomNavTeamInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsAuthors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'StringValue', value: 'the-nav-team', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortBio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'media' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsroomNavTeamInfoQuery, NewsroomNavTeamInfoQueryVariables>
export const NewsroomSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewsroomSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'newsroom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hero' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'heroFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsVideoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsVideo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'cmsLinkFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLink' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTab' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'query' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsPage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsGuide' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMarketplacePage' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reusable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'relationTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLinks' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsHero' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'richTextMax' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopVideo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsVideoFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopFallback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hzAlign' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vertAlign' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'link' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'cmsLinkFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showReviews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclaimerText' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsroomSettingsQuery, NewsroomSettingsQueryVariables>
export const NewsroomArticlesListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewsroomArticlesList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsNewsroomArticle_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsNewsroomArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: '-publishedAt', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsroomArticlesListQuery, NewsroomArticlesListQueryVariables>
export const LiteEmbeddedPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LiteEmbeddedPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsLiteEmbeddedMarketplace_where' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsLiteEmbeddedMarketplaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoHref' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'offerCategories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'collection' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'affiliateCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMetaFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMediaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sizes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portrait' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'square' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'squareThumbnail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'banner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeHero' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smallAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'largeAutoHeight' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CmsMetaFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CmsMeta' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CmsMediaFragment' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jsonLD' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LiteEmbeddedPageQuery, LiteEmbeddedPageQueryVariables>
export const SitemapLiteEmbeddedPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapLiteEmbeddedPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'CmsLiteEmbeddedMarketplaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equals' },
                            value: { kind: 'EnumValue', value: 'published' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '0' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'docs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapLiteEmbeddedPagesQuery, SitemapLiteEmbeddedPagesQueryVariables>
